(function () {
  'use strict';

  angular.module('app.admin.modules',
    [
      // 3rd Party Dependencies
      'moment-picker',
      'ui.calendar',
      'ui.sortable',
      'xeditable',
      'ang-drag-drop'
    ]
  )
  .config(config);

    /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    $stateProvider
      .state('app.modules', {
        url      : '/modules',
        resolve  : {
          BoardList: function (msApi) {
            return msApi.resolve('modules.boardList@get');
          },
          acl: function($q, AclService, $location) {
            if(!AclService.can('modules')) {
              // Does not have permission
              return $q.reject('unauthorized');
            } else {
              $location.path('/modules/boards');
            }
          }
        },
        bodyClass: 'admin_modules'
      })

      // Home
      .state('app.modules.boards', {
        url  : '/boards',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/modules/views/boards/boards-view.html',
            controller : 'BoardsViewController as vm'
          }
        },
        resolve  : {
          acl: function($q, AclService) {
            if(!AclService.can('modules')) {
              // Does not have permission
              return $q.reject('unauthorized');
            }
          }
        }
      })

      // Board
      .state('app.modules.boards.board', {
        url    : '/:id/:uri',
        views  : {
          'content@app': {
            templateUrl: 'app/main/admin/modules/modules.html',
            controller : 'ModulesController as vm'
          },
          'modulesContent@app.modules.boards.board': {
            templateUrl: 'app/main/admin/modules/views/board/board-view.html',
            controller : 'BoardViewController as vm'
          }
        },
        resolve: {
          BoardData: function ($stateParams, BoardService) {
            return BoardService.getModuleAndPageData();
          },
          acl: function($q, AclService) {
            if(!AclService.can('modules')) {
              // Does not have permission
              return $q.reject('unauthorized');
            }
          }
        }
      }
      )
      // Add board
      .state('app.modules.boards.addBoard', {
        url    : '/add',
        views  : {
          'content@app': {
            templateUrl: 'app/main/admin/modules/modules.html',
            controller : 'ModulesController as vm'
          },
          'modulesContent@app.modules.boards.addBoard': {
            templateUrl: 'app/main/admin/modules/views/board/board-view.html',
            controller : 'BoardViewController as vm'
          }
        },
        resolve: {
          BoardData: function ($stateParams, BoardService) {
            return BoardService.addNewBoard();
          }
        }
      });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/admin/modules');

    // Api
    msApiProvider.register('modules.boardList', ['app/data/modules/board-list.json']);
    msApiProvider.register('modules.board', ['app/data/modules/boards/:id.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('admin.modules', {
      title : 'Page Access',
      icon  : 'icon-trello',
      state : 'app.modules.boards',
      weight: 39
    });
  }

})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('ScrumboardCalendarEventDialogController', ScrumboardCalendarEventDialogController);

    /** @ngInject */
  function ScrumboardCalendarEventDialogController($mdDialog, dueDate, BoardService, msUtils) {
    var vm = this;

        // Data
    vm.board = BoardService.data;
    vm.dueDate = dueDate;
    vm.newCard = {
      name  : '',
      listId: ''
    };
    vm.selectedCards = [];

    // Methods
    vm.exists = msUtils.exists;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.closeDialog = closeDialog;
    vm.addNewCard = addNewCard;
    vm.assignDueDate = assignDueDate;

    /**
     * Close Dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }
    /**
     * Add New Card
     */
    function addNewCard() {
      var newCardId = msUtils.guidGenerator();
      vm.board.cards.push({
        'id'               : newCardId,
        'name'             : vm.newCard.name,
        'description'      : '',
        'idAttachmentCover': '',
        'idMembers'        : [],
        'idLabels'         : [],
        'attachments'      : [],
        'subscribed'       : false,
        'checklists'       : [],
        'checkItems'       : 0,
        'checkItemsChecked': 0,
        'comments'         : [],
        'activities'       : [],
        'due'              : vm.dueDate
      });
      vm.board.lists.getById(vm.newCard.listId).idCards.push(newCardId);
      // Reset the newCard object
      vm.newCard = {
        name: '',
        listId: ''
      };
      closeDialog();
    }
    /**
     * Assign Due Date
     */
    function assignDueDate() {
      angular.forEach(vm.selectedCards, function (cardId) {
        vm.board.cards.getById(cardId).due = vm.dueDate;
      });
      vm.selectedCards = [];
      closeDialog();
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('LabelsMenuController', LabelsMenuController);

  /** @ngInject */
  function LabelsMenuController($document, $mdColorPalette, $mdDialog, fuseGenerator, msUtils, BoardService) {
    var vm = this;

    // Data
    vm.board = BoardService.data;
    vm.palettes = $mdColorPalette;
    vm.rgba = fuseGenerator.rgba;
    vm.hue = 500;
    vm.newLabelColor = 'red';
    vm.newLabelName = '';

    // Methods
    vm.addNewLabel = addNewLabel;
    vm.removeLabel = removeLabel;

    /**
     * Add New Label
     */
    function addNewLabel() {
      vm.board.labels.push({
        id   : msUtils.guidGenerator(),
        name : vm.newLabelName,
        color: vm.newLabelColor
      });
      vm.newLabelName = '';
    }

    /**
     * Remove label
     *
     * @param ev
     * @param labelId
     */
    function removeLabel(ev, labelId) {
      var confirm = $mdDialog.confirm({
        title              : 'Remove Label',
        parent             : $document.find('#modules'),
        textContent        : 'Are you sure want to remove label?',
        ariaLabel          : 'remove label',
        targetEvent        : ev,
        clickOutsideToClose: true,
        escapeToClose      : true,
        ok                 : 'Remove',
        cancel             : 'Cancel'
      });

      $mdDialog.show(confirm).then(function () {
        var arr = vm.board.labels;
        arr.splice(arr.indexOf(arr.getById(labelId)), 1);

        angular.forEach(vm.board.cards, function (card) {
          if (card.idLabels && card.idLabels.indexOf(labelId) > -1) {
            card.idLabels.splice(card.idLabels.indexOf(labelId), 1);
          }
        });
      }, function () {
        // Canceled
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('MembersMenuController', MembersMenuController);

  /** @ngInject */
  function MembersMenuController($document, $mdDialog, BoardService) {
    var vm = this;

    // Data
    vm.board = BoardService.data;
    vm.newMemberSearchInput = '';

    // Methods
    vm.addNewMember = addNewMember;
    vm.removeMember = removeMember;

    /**
     * Add New Member
     */
    function addNewMember() {
      // Add new member
    }

    /**
     * Remove member
     *
     * @param ev
     * @param memberId
     */
    function removeMember(ev, memberId) {
      var confirm = $mdDialog.confirm({
        title              : 'Remove Member',
        parent             : $document.find('#modules'),
        textContent        : 'Are you sure want to remove member?',
        ariaLabel          : 'remove member',
        targetEvent        : ev,
        clickOutsideToClose: true,
        escapeToClose      : true,
        ok                 : 'Remove',
        cancel             : 'Cancel'
      });

      $mdDialog.show(confirm).then(function () {
        var arr = vm.board.members;
        arr.splice(arr.indexOf(arr.getById(memberId)), 1);

        angular.forEach(vm.board.cards, function (card) {
          if (card.idMembers && card.idMembers.indexOf(memberId) > -1) {
            card.idMembers.splice(card.idMembers.indexOf(memberId), 1);
          }
        });
      }, function () {
        // Canceled
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('ColorMenuController', ColorMenuController);

  /** @ngInject */
  function ColorMenuController($mdColorPalette, BoardService) {
    var vm = this;

    // Data
    vm.board = BoardService.data;
    vm.palettes = $mdColorPalette;
  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.work-schedule-tasks.tasks.dialog', [])
  .controller('TaskDialogController', TaskDialogController);

  /** @ngInject */
  function TaskDialogController($scope,
                                $state,
                                $location,
                                $mdToast,
                                $mdDialog,
                                $document,
                                $translate,
                                dialogData,
                                TaskService,
                                LandService,
                                AnchorTypeDefinitionService,
                                msUtils) {
    var vm = this;
    var _ = window._;


    vm.allFields = false;
    vm.task = dialogData.task;

   /* if (vm.task.pre_water) {
      vm.selectedTaskAnchorType = 'pre_water';
    } else if (vm.task.time_anchor) {
      vm.selectedTaskAnchorType = 'time_anchor';
    } else if (vm.task.growing_start_date) {
      vm.selectedTaskAnchorType = 'growing_start_date';
    } else if (vm.task.harvest_date) {
      vm.selectedTaskAnchorType = 'harvest_date';
    } else if (vm.task.tillage_date) {
      vm.selectedTaskAnchorType = 'tillage_date';
    } else if (vm.task.irrigation_date) {
      vm.selectedTaskAnchorType = 'irrigation_date'
    } else {
      vm.selectedTaskAnchorType = 'normal';
    }*/

    vm.previousTask = _.cloneDeep(vm.task);
    vm.roles = dialogData.roles;
    vm.tasks = dialogData.tasks;
    vm.notifyGroups = dialogData.notifyGroups;
    vm.filterIds = dialogData.filterIds;
    vm.shownTasks = dialogData.shownTasks;
    vm.updateTaskModel = dialogData.updateTaskModel;
    vm.exists = msUtils.exists;
    vm.new_task = false;

    if (!vm.task.id) {
      vm.task = {ng: [], time_to_complete_mesured_by_acre: true, color: '#000000'};
      vm.title = 'New Task';
      vm.new_task = true;
    } else {
      vm.title = 'Edit Task';
    }

    vm.anchorDefinitions = [];

    AnchorTypeDefinitionService.get().then(function (t) {
      vm.anchorDefinitions = t.definitions;

    });

    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.addNewTask = addNewTask;
    vm.cancelDialog = cancelDialog;
    vm.editTask = editTask;

    vm.getPhases = function () {
      return vm.work_schedule_types.filter(function (p) {
        return p.name !== vm.work_schedule_type.name;
      }).map(function (p) {
        return p.name;
      });
    };


    vm.openColorPicker = function (ev, task) {
      $mdDialog.show({
        controller: 'PhaseColorPickerDialogController',
        controllerAs: 'vm',
        multiple: true,
        templateUrl: 'app/main/farm-admin/work-schedule-template/work-schedule-tasks/phase-type/dialog/color-picker-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            phase: task
          }
        }
      });
    };


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * Close dialog
     */
    function addNewTask() {
      TaskService.save(vm.task).then(function (_task) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Task(' + vm.task.name + ') are created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.filterIds.push(_task.id);
        vm.shownTasks.push(_task);
        vm.tasks.push(_task);
        $mdDialog.hide();
      });
    }


    /**
     * edit dialog
     */
    function editTask() {
      TaskService.update(vm.task).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Task (' + vm.task.name + ') has been saved.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        $mdDialog.hide();
      });
    }

    /**
     * Cancel dialog
     */
    function cancelDialog() {
      _.assign(vm.task, vm.previousTask);
      vm.closeDialog();
    }

    vm.getAnchorValue = function(anchor) {

      return anchor.id;

    };

    vm.checkSelectedTaskAnchorValue = function () {

      /*vm.task.pre_water = false;
      vm.task.growing_start_date = false;
      vm.task.harvest_date = false;
      vm.task.time_anchor = false;
      vm.task.tillage_date = false;
      vm.task.irrigation_date = false;


      switch (vm.selectedTaskAnchorType) {
        case 'pre_water':
          vm.task.pre_water = true;
          break;
        case 'time_anchor':
          vm.task.time_anchor = true;
          break;
        case 'harvest_date':
          vm.task.harvest_date = true;
          break;
        case 'growing_start_date':
          vm.task.growing_start_date = true;
          break;
        case 'tillage_date':
          vm.task.tillage_date = true;
          break;
        case 'irrigation_date':
          vm.task.irrigation_date = true;
          break;
      }*/

    };


  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.work-schedule-tasks.tasks.dialog.gantt', [])
  .controller('GanttTaskDialogController', GanttTaskDialogController);

  /** @ngInject */
  function GanttTaskDialogController($scope,
                                $state,
                                $location,
                                $mdToast,
                                $mdDialog,
                                $document,
                                $translate,
                                dialogData,
                                TaskService,
                                LandService,
                                ganttUtils,
                                PhaseService,
                                AnchorTypeDefinitionService,
                                msUtils) {
    var vm = this;
    var _ = window._;

    vm.tasks = [];

    TaskService.get().then(function (t) {
      vm.tasks = t;
    });
    vm.allFields = false;
    vm.task = dialogData.task;

   /* if (vm.task.pre_water) {
      vm.selectedTaskAnchorType = 'pre_water';
    } else if (vm.task.time_anchor) {
      vm.selectedTaskAnchorType = 'time_anchor';
    } else if (vm.task.growing_start_date) {
      vm.selectedTaskAnchorType = 'growing_start_date';
    } else if (vm.task.harvest_date) {
      vm.selectedTaskAnchorType = 'harvest_date';
    } else if (vm.task.tillage_date) {
      vm.selectedTaskAnchorType = 'tillage_date';
    } else if (vm.task.irrigation_date) {
      vm.selectedTaskAnchorType = 'irrigation_date'
    } else {
      vm.selectedTaskAnchorType = 'normal';
    }*/

    vm.previousTask = _.cloneDeep(vm.task);
    vm.roles = dialogData.roles;
    vm.tasks = dialogData.tasks;
    vm.notifyGroups = dialogData.notifyGroups;
    vm.filterIds = dialogData.filterIds;
    vm.shownTasks = dialogData.shownTasks;
    vm.block = dialogData.block;
    vm.updateTaskModel = dialogData.updateTaskModel;
    vm.exists = msUtils.exists;
    vm.new_task = false;
    vm.ganttBlockMode = dialogData.ganttBlockMode;

    vm.ganttData = dialogData.ganttData;

    vm.reload = dialogData.reload;

    if (vm.block) {
      vm.isGanttTaskDialog = true;
    }



    if (!vm.task.id) {
      vm.task = {ng: [], time_to_complete_mesured_by_acre: true, color: '#000000'};
      vm.title = 'New Task';
      vm.new_task = true;
    } else {
      vm.title = 'Edit Task';
    }

    vm.anchorDefinitions = [];

    AnchorTypeDefinitionService.get().then(function (t) {
      vm.anchorDefinitions = t.definitions;

    });

    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.addNewTask = addNewTask;
    vm.cancelDialog = cancelDialog;
    vm.editTask = editTask;

    vm.getPhases = function () {
      return vm.work_schedule_types.filter(function (p) {
        return p.name !== vm.work_schedule_type.name;
      }).map(function (p) {
        return p.name;
      });
    };


    vm.changeSelectedTask = function() {
      vm.task = vm.selectedTask;
    };

    vm.openColorPicker = function (ev, task) {
      $mdDialog.show({
        controller: 'PhaseColorPickerDialogController',
        controllerAs: 'vm',
        multiple: true,
        templateUrl: 'app/main/farm-admin/work-schedule-template/work-schedule-tasks/phase-type/dialog/color-picker-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            phase: task
          }
        }
      });
    };


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * Close dialog
     */
    function addNewTask() {
      TaskService.save(vm.task).then(function (_task) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Task(' + vm.task.name + ') are created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.filterIds.push(_task.id);
        vm.shownTasks.push(_task);
        vm.tasks.push(_task);
        $mdDialog.hide();
      });
    }


    /**
     * edit dialog
     */
    function editTask() {
      TaskService.update(vm.task).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Task (' + vm.task.name + ') has been saved.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        $mdDialog.hide();
      });
    }

    /**
     * Cancel dialog
     */
    function cancelDialog() {
      _.assign(vm.task, vm.previousTask);
      vm.closeDialog();
    }

    vm.getAnchorValue = function(anchor) {

      return anchor.id;

    };

    vm.checkSelectedTaskAnchorValue = function () {

      /*vm.task.pre_water = false;
      vm.task.growing_start_date = false;
      vm.task.harvest_date = false;
      vm.task.time_anchor = false;
      vm.task.tillage_date = false;
      vm.task.irrigation_date = false;


      switch (vm.selectedTaskAnchorType) {
        case 'pre_water':
          vm.task.pre_water = true;
          break;
        case 'time_anchor':
          vm.task.time_anchor = true;
          break;
        case 'harvest_date':
          vm.task.harvest_date = true;
          break;
        case 'growing_start_date':
          vm.task.growing_start_date = true;
          break;
        case 'tillage_date':
          vm.task.tillage_date = true;
          break;
        case 'irrigation_date':
          vm.task.irrigation_date = true;
          break;
      }*/

    };

    vm.addNewTaskGantt = function() {

      var gt = vm.task;

      /**
       * getMinutes
       * @param  {[type]} block [description]
       * @param  {[type]} task  [description]
       * @return {[type]}       [description]
       */
      function getMinutes(block, task) {
        if (task.time_to_complete_mesured_by_acre) {
          return task.estimated_minutes * block.acres_in_block;
        }
        return task.estimated_minutes2;
      }

      var _block = vm.ganttData.filter(function(d) {
        return d.id == vm.block.id;
      }).shift();

      _block.tasks.push({
        'id': ganttUtils.randomUuid(),
        'original_id': gt.id,
        'name': gt.name,
        'classes': [],
        'from': _.cloneDeep(moment(gt.date)),
        'to': _.cloneDeep(moment(gt.date)).add('m',getMinutes(vm.block,vm.task)),
        'color': gt.color,
        'daylight_only': gt.daylight_only,
        'task_color': gt.color,
        'time_anchor': gt.time_anchor,
        'pre_water': gt.pre_water,
        'growing_start_date': gt.growing_start_date,
        'tillage_date': gt.tillage_date,
        'irrigation_date': gt.irrigation_date,
        'harvest_date': gt.harvest_date,
        'equipment_color': gt.equipment_color,
        'labor_color': gt.labor_color,
        'foreman_color': gt.foreman_color,
        'labor_group': '',
        'labor_group_id': gt.labor_task_group_id,
        'equipment_id': gt.equipment_task_group_id,
        'equipment': '',
        'foreman': '',
        'foreman_id': gt.user_role_id,
        'anchor_id': gt.anchor_id,
        'task_name': gt.name,
        'phase_id': gt.phase_id,
        'phase_name': gt.phase_name,
        'phase_color': gt.phase_color
      });
      vm.closeDialog();

      vm.reload(vm.ganttData);

    };


  }
})();

(function () {
  'use strict';

  var $ = window.$;

  angular
    .module('app.farm-admin.users.users.dialogs', [])
    .controller('UserAddEditDialogController', UserAddEditDialogController)
    .directive('pwCheck', [function () {
      return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
          var firstPassword = '#' + attrs.pwCheck;
          elem.add(firstPassword).on('keyup', function () {
            scope.$apply(function () {
              var v = elem.val() === $(firstPassword).val();
              ctrl.$setValidity('pwmatch', v);
            });
          });
        }
      };
    }]);
  /** @ngInject */
  function UserAddEditDialogController($scope,
    $state,
    $rootScope,
    $location,
    Upload,
    $mdToast,
    $mdDialog,
    $translate,
    dialogData,
    UserService,
    CompanyService,
    msUtils,
    RoleService,
    _) {
    var vm = this;

    // Data
  //  $scope.event = window.event;
    vm.title = 'Edit User';
    vm.starredUsers = dialogData.starredUsers;
    vm.allRolesGroups = dialogData.allRolesGroups;
    vm.allNotifyGroups = dialogData.allNotifyGroups;
    vm.listType = dialogData.listType;
    vm.users = dialogData.users;
    vm.user = dialogData.user;
    $scope.event = dialogData.ev;
    if (!vm.user.starred) {
      vm.user.starred = false;
    }
    $scope.admin = dialogData.admin;
    vm.shownUsers = dialogData.shownUsers;
    vm.filterChange = dialogData.filterChange;
    vm.newUser = false;
    vm.allFields = false;
    vm.companies = [];
    vm.userOnline = UserService.getLocalUser();
    vm.userOnline.roles.forEach(function (currentItem) {
      if (currentItem.name === 'super_user') {
        vm.superRole = currentItem;
      }
    });
    if (!vm.user.id) {
      /* Just required fields here */
      vm.user = _.assign({
        //'id'         : msUtils.guidGenerator(),
        'active': false,
        'name': '',
        'login_name': '',
        'email_address': '',
        'cell_phone': '',
        'password': '',
        'password_confirm': '',
        'starred': false,
        'ng': [],
        'r': [],
        'online_status': 'Offline',
      }, vm.user);

      vm.title = 'New User';
      vm.newUser = true;
    }
    // Methods
    vm.addNewUser = addNewUser;
    vm.saveUser = saveUser;
    vm.starredUser = starredUser;
    vm.patchNotifyGroup = patchNotifyGroup;
    vm.patchRoleGroup = patchRoleGroup;
    vm.deleteUserConfirm = deleteUserConfirm;
    vm.isValidPassword = isValidPassword;
    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.queryCompany = queryCompany;
    vm.searchTextChange = searchTextChange;
    vm.selectedCompanyChange = selectedCompanyChange;
    vm.createFilterFor = createFilterFor;
    vm.addToUserUserRole = addToUserUserRole;
    vm.addToUserNotifyGroup = addToUserNotifyGroup;
    vm.openImgCropDialog = openImgCropDialog;
    vm.invalidImage = invalidImage;
    vm.checkTabKey = checkTabKey;
    vm.notifyGroups = [];
    vm.roles = [];
    vm.setMenuWidth = setMenuWidth;

    CompanyService.get().then(function (result) {
      vm.companies = result.companies;
      if (vm.user.company_id) {
        vm.user.company = vm.companies.filter(function (c) {
          return c.id == vm.user.company_id;
        }).shift();
        checkPhoneMask(vm.user.company);
      }
    });
    /**
     * checkTabKey
     */
    function checkTabKey(evt) {
      if (!_.isEmpty($scope.userForm.password_confirm.$error) && evt.keyCode === 9) {
        evt.preventDefault(evt);
      }
    }
    /**
     * invalidImage
     */
    function invalidImage($files) {
      vm.imageInvalid = $files.filter(function (file) {
        return file.type != 'image/gif' && file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/bmp' && file.type != 'image/jpg' && file.type != 'image/jpe' && file.type != 'image/tiff' && file.type != 'image/ico';
      }).length > 0;
    }
    /**
     * openImgCropDialog
     */
    function openImgCropDialog(evt, file) {
      if ($scope.userForm.file.$error.maxSize) {
        vm.imageInvalid = true;
      }
      if (!file) {
        vm.imageInvalid = true;
      }
      if (vm.imageInvalid) {
        vm.imageInvalid = false;
        return;
      }

      $mdDialog.show({
        controller: function DialogController($scope, $mdDialog) {
          /** @ngInject */
          $scope.vm = vm;
          $scope.crop_image = '';
          $scope.cancel = function () {
            delete vm.picFile;
            evt.stopPropagation();
            dialogData.addUserDialog(evt, vm.user, true);
            $mdDialog.cancel();
          };
          $scope.confirm = function () {
            // Convert it to a blob to upload
            var blob = b64toBlob($scope.crop_image, file);
            vm.user.image_url = $scope.crop_image;
            vm.user.image_name = '';
            vm.user.avatarUpdated = true;
            vm.user.file = blob;
            $mdDialog.cancel();
            evt.stopPropagation();
            dialogData.addUserDialog(evt, vm.user, true);
          };
        },
        templateUrl: 'app/main/farm-admin/users/users/dialogs/user/crop_dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        targetEvent: evt,
        fullscreen: true
      });
    }
    /**
     * queryCompany
     */
    function queryCompany(query) {
      var results = query ? _.filter(vm.companies, vm.createFilterFor(query))
        : vm.companies;
      return results;
    }
    /**
     * createFilterFor
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(state) {
        return (state.name.toLowerCase().indexOf(lowercaseQuery) === 0);
      };
    }
    /**
     * searchTextChange
     */
    function searchTextChange() {
    }
    /**
     * selectedCompanyChange
     */
    function selectedCompanyChange(c) {
      checkPhoneMask(c);
    }
    /**
     * checkPhoneMask
     */
    function checkPhoneMask(c) {
      if (!c) {
        vm.phoneMask = '';
        return;
      }
      if (c.country == 'United States') {
        vm.phoneMask = '999-999-9999';
      } else {
        vm.phoneMask = '';
      }
    }
    /**
     * Add new user
     */
    function addNewUser() {
      if (vm.isValidPassword()) {
        _.pick(vm.user, _.identity);
        var dataToPost = {
          active: vm.user.active.toString(),
          name: vm.user.name,
          company_id: vm.user.company.id,
          r: vm.user.r,
          ng: vm.user.ng,
          login_name: vm.user.login_name,
          email_address: vm.user.email_address,
          cell_phone: vm.user.cell_phone,
          password: vm.user.password,
          starred: vm.user.starred.toString(),
          online_status: vm.user.online_status
        };
        if (vm.user.r.length === 0) {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The user ' + vm.user.name + ' must have a role.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          return;
        }
        /**
         * Create new user
         */
        UserService.create(dataToPost).then(function (data) {
          vm.aux = {};
          vm.aux = data.user;
          if (vm.user.avatarUpdated) {
            Upload.upload({
              url: UserService.getUploadImgUrl(data.user.id),
              data: { id: data.user.id, upfile: vm.user.file }
            }, function () {
            }, function () {
            }).then(function () {
              $mdToast.show({
                template: '<md-toast class="md-toast success">The user ' + vm.user.name + ' has been created.</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });
              data.user.company = vm.companies.filter(function (c) {
                return c.id == data.user.company_id;
              }).shift();
              vm.aux.r, vm.aux.ng = [];
              vm.aux.r = vm.user.r;
              vm.aux.ng = vm.user.ng;
              if (vm.aux.ng) {
                vm.aux.ng.forEach(function (element) {
                  UserService.userNotifyGroupAddRelation(vm.aux.id, element).then(function () {
                  },
                  function () {
                    $mdToast.show({
                      template: '<md-toast class="md-toast error">The user ' + vm.aux.name + ' could not be related to role notify groups id:' + element + '.</md-toast>',
                      position: 'top right',
                      hideDelay: 4500
                    });
                  });
                });
              }
              if (vm.aux.r) {
                vm.aux.r.forEach(function (element) {
                  RoleService.userRoleAddRelation(vm.aux.id, element).then(function () {
                  },
                  function () {
                    $mdToast.show({
                      template: '<md-toast class="md-toast error">The user ' + vm.aux.name + ' could not be related to role group id:' + element + '.</md-toast>',
                      position: 'top right',
                      hideDelay: 4500
                    });
                  });
                });
              }
              vm.shownUsers.push(vm.aux);
              vm.users.push(vm.aux);
              vm.filterChange('all');
              closeDialog();
            });
          } else {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The user ' + vm.user.name + ' has been created.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            data.user.company = vm.companies.filter(function (c) {
              return c.id == data.user.company_id;
            }).shift();
            vm.aux.r, vm.aux.ng = [];
            vm.aux.r = vm.user.r;
            vm.aux.ng = vm.user.ng;
            if (vm.aux.ng) {
              vm.aux.ng.forEach(function (element) {
                UserService.userNotifyGroupAddRelation(vm.aux.id, element).then(function () {});
              });
            }
            if (vm.aux.r) {
              vm.aux.r.forEach(function (element) {
                RoleService.userRoleAddRelation(vm.aux.id, element).then(function () {
                },
                function () {
                  $mdToast.show({
                    template: '<md-toast class="md-toast error">The user ' + vm.aux.name + ' could not be related to role group id: ' + element + '.</md-toast>',
                    position: 'top right',
                    hideDelay: 4500
                  });
                });
              });
            }
            vm.shownUsers.push(vm.aux);
            vm.users.push(vm.aux);
            vm.filterChange('all');
            closeDialog();
          }

        },
          function (err) { //reject
            var error;
            if (err.status !== 500) {
              error = err.data.message;
            }
            $mdToast.show({
              template: '<md-toast class="md-toast error">The user ' + vm.user.name + ' could not be created. ' + ((error != undefined) ? error : '') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          });
      }
    }
    /**
     * Function to validate password
     * @return {Boolean} [description]
     */
    function isValidPassword() {
      if (vm.user.password === vm.user.password_confirm) {
        return true;
      } else {
        return false;
      }
    }
    /**
     * Save existent user (save on edit)
     */
    function checkIfIsMyUser(user) {
      return user.id == UserService.getLocalUser().id;
    }
    /**
     * Function to validate password
     * @return {Boolean} [description]
     */
    function saveUser() {
      vm.user.save = true;
      var dataToPost = {
        active: vm.user.active.toString(),
        name: vm.user.name,
        login_name: vm.user.login_name,
        email_address: vm.user.email_address,
        cell_phone: vm.user.cell_phone,
        office_phone: vm.user.office_phone,
        fax: vm.user.fax,
        company_id: vm.user.company.id,
        r: vm.user.r,
        ng: vm.user.ng,
        starred: vm.user.starred.toString(),
      };
      if (vm.user.r.length === 0) {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The user ' + vm.user.name + ' must have a role.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        return;
      }
      /**
       * If password is modified, add it to the object
       */
      if (vm.user.password !== undefined && vm.user.password.length > 0 && vm.isValidPassword()) {
        dataToPost.password = vm.user.password;
      }
      UserService.update(vm.user.id, dataToPost).then(function () {
        if (vm.user.avatarUpdated) {
          Upload.upload({
            url: UserService.getUploadImgUrl(vm.user.id),
            data: { id: vm.user.id, upfile: vm.user.file }
          }, function () {
          }, function () {
          }).then(function () {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The user ' + vm.user.name + ' has been updated.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            if (checkIfIsMyUser(vm.user)) {
              var localUser = UserService.getLocalUser();
              _.assign(localUser, vm.user, { company_id: vm.user.company.id });
              UserService.saveLocalUser(localUser);
              $rootScope.$broadcast('userChange', localUser);
              /**
               * Method that will updated user online in list by toolbar
               */
              $rootScope.$broadcast('updateUserOnlineToolbar',{});
            }
          });
        } else {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The user ' + vm.user.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          if (checkIfIsMyUser(vm.user)) {
            var localUser = UserService.getLocalUser();
            _.assign(localUser, vm.user, { company_id: vm.user.company.id });
            UserService.saveLocalUser(localUser);
            $rootScope.$broadcast('userChange', localUser);
            /**
             * Method that will updated user online in toolbar by list
             */
            $rootScope.$broadcast('updateUserOnlineToolbar',{});
          }
        }
      },
      function (err) { // Reject
        var error;
        if (err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">The user ' + vm.user.name + ' could not be updated. ' + ((error != undefined) ? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
      vm.roles.forEach(function (group) {
        RoleService.userRoleRemoveRelation(vm.user.id, group).then(function () {});
      });
      vm.notifyGroups.forEach(function (group) {
        UserService.userNotifyGroupRemoveRelation(vm.user.id, group).then(function () {});
      });
      $scope.aux = true;
      dataToPost.r.forEach(function (element) {
        RoleService.userRoleAddRelation(vm.user.id, element).then(function () {
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The User ' + vm.user.name + ' could not be relate to Business Roles id:' + element.name + '.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      });
      dataToPost.ng.forEach(function (element) {
        UserService.userNotifyGroupAddRelation(vm.user.id, element).then(function () {
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The User ' + vm.user.name + ' could not be relate to notify group ' + element.name + '.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      });
      closeDialog();
    //  $rootScope.$broadcast('updatedUser', {});
    }
    /**
     * Delete User Confirm Dialog
     */
    function deleteUserConfirm(ev) {
      vm.user.company_id = 1;
      var company_constraint;
      if (vm.user.company_id !== undefined && vm.user.company_id !== '') {
        company_constraint = true;
      }
      var confirm = $mdDialog.confirm()
        .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE'))
        .htmlContent('The user <b>' + vm.user.name + '</b>' + ' will be deleted. <br />' + ((company_constraint !== undefined) ? 'Also this user is related to a company, if you delete this user, the relation will be lost.' : ''))
        .ariaLabel('delete user')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        UserService.delete(vm.user.id).then(function () {
          vm.users.splice(vm.users.indexOf(vm.user), 1);
          vm.shownUsers.splice(vm.users.indexOf(vm.user), 1);
          $mdToast.show({
            template: '<md-toast class="md-toast success>The user ' + vm.user.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
          function () {
            $mdToast.show({
              template: '<md-toast class="md-toast error>The user ' + vm.user.name + ' could not be deleted.</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          });
      }, function () {
        // avoid unhandled rejection message.
      });
    }
    /**
     * Starred User
     */
    function starredUser(user) {
      if (user.starred === false) {
        user.starred = true;
      } else if (vm.user.starred === true) {
        user.starred = false;
      }
      if (checkIfIsMyUser(vm.user)) {
        var localUser = UserService.getLocalUser();
        _.assign(localUser, vm.user, { company_id: vm.user.company.id });
        UserService.saveLocalUser(localUser);
        $rootScope.$broadcast('userChange', localUser);
      }
    }
    /**
     * Patch User Role
     */
    function patchRoleGroup(user, group) {
      dialogData.patchRoleGroup(user, group);
    }
    /**
     * [patchUserGroup description]
     * @return {[type]} [description]
     */
    function patchNotifyGroup(user, group) {
      dialogData.patchNotifyGroup(user, group);
    }
    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }
    /**
     * Close dialog
     */
    function addToUserNotifyGroup(user, group) {
      if (!vm.exists(group.id, user.ng)) {
        user.ng.push(group.id);
      } else {
        _.remove(user.ng, function (elem) {
          vm.notifyGroups.push(group.id);
          return elem === group.id;
        });
      }
    }
    /**
     * Close dialog
     */
    function addToUserUserRole(user, group) {
      if (!vm.exists(group.id, user.r)) {
        user.r.push(group.id);
      } else {
        if (user.id === vm.userOnline.id && group.name === 'super_user') {
          $mdToast.show({
            template: '<md-toast class="md-toast warning">' + user.name + ' could not be role group ' + group.name + '.</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        } else {
          _.remove(user.r, function (elem) {
            vm.roles.push(group.id);
            return elem === group.id;
          });
        }
      }
    }

    /**
     * [setMenuWidth description]
     */
    function setMenuWidth() {
      var interval = setInterval(setWidth, 100);

      /**
       * [setWidth description]
       */
      function setWidth() {
        var menuEle = angular.element('.md-open-menu-container.md-active');
        menuEle.css({
          'width': '192px',
          'position': 'absolute',
          'left': '50%',
          'right': '50%'
        });

        if(!menuEle.length) {
          clearInterval(interval);
        }
      }
    }

    /**
     * Convert base64 image to blob
     * @param  {[type]} b64Data   [description]
     * @param  {[type]} file      [description]
     * @param  {[type]} sliceSize [description]
     * @return {[type]}           [description]
     */
    function b64toBlob(b64Data, file, sliceSize) {
      // Split the base64 string in data and contentType
      var block = b64Data.split(';');
      // Get the content type of the image
      var contentType = block[0].split(':')[1];

      // get the real base64 content of the file
      var realData = block[1].split(',')[1];

      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(realData);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      var blobUrl = URL.createObjectURL(blob);
      blob.$ngfBlobUrl = blobUrl;
      blob.$ngfName= file.$ngfName;

      return blob;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.users.users.notify-group.dialog', [])
    .controller('AddEditNotifyGroupDialogController', AddEditNotifyGroupDialogController);

  /** @ngInject */
  function AddEditNotifyGroupDialogController(
    $state,
    $location,
    $mdToast,
    $mdDialog,
    $translate,
    dialogData,
    UserService,
    msUtils
  ) {
    var vm               = this;
    vm.title             = 'Edit Notify Group for: ';
    vm.user              = dialogData.user;
    vm.newNotifyGroup    = false;

    if (!vm.notifyGroup) {
      /* Just required fields here */
      vm.notifyGroup = {
        'name'            : '',
        'login_name'      : '',
        'email_address'   : '',
        'cell_phone'      : '',
        'password'        : '',
        'password_confirm': ''
      };

      vm.title      = 'Add new Notify Group for: ';
      vm.newNotifyGroup    = true;
    }

    vm.user.avatar = 'assets/images/avatars/profile.jpg';

    // Methods
    vm.addNewNotifyGroup         = addNewNotifyGroup;
    vm.closeDialog               = closeDialog;
    vm.toggleInArray             = msUtils.toggleInArray;

    /**
     * Create new notify group.
     */
    function addNewNotifyGroup() {
      if (vm.notifyGroup.name === '') {
        return;
      }
      var newGroupData = {
        'notify_group': {
          'name': vm.notifyGroup.name
        }
      };
      /**
       * Call service to create a new notify-group associated to the user.
       */
      UserService.createUserNotifyGroup(vm.user.id, newGroupData).then(function() {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Notify Group ' + newGroupData.notify_group.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        $state.go($state.current, {}, {reload: true});
      },
      function() {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + vm.newGroupName + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
      closeDialog();
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.users.companies.dialogs', [])
  .controller('CompanyDialogController', CompanyDialogController);

  /** @ngInject */
  function CompanyDialogController($scope,
                                   $state,
                                   $mdToast,
                                   $mdDialog,
                                   $translate,
                                   $location,
                                   $stateParams,
                                   Upload,
                                   $rootScope,
                                   CompanyService,
                                   dialogData,
                                   msUtils,
                                   msApi) {
    var vm = this;
    var _ = window._;
    vm.stateInput = true;


    // Data
    vm.title = 'Edit Company';
    vm.starredCompanies = dialogData.starredCompanies;
    vm.allBusinessGroups = dialogData.groups;
    vm.companies = dialogData.companies;
    vm.company = dialogData.company;
    if (!vm.company.starred) {
      vm.company.starred = false;
    }
    $scope.admin = dialogData.admin;
    vm.newCompany = false;
    vm.allFields = false;
    vm.company_copy = dialogData.company_copy || _.cloneDeep(vm.company);
    vm.shownCompanies = dialogData.shownCompanies;
    vm.filterIds = dialogData.filterIds;
    vm.phoneMask='';
    $scope.admin = dialogData.admin;
    $scope.event = dialogData.ev;


    if (!vm.company.id) {
      vm.company = _.assign({
        //'id': msUtils.guidGenerator(),
        'name': '',
        'contact_person': '',
        //'avatar': 'assets/images/avatars/office.png',
        'email_address': '',
        'office_phone': '',
        'cell_phone': '',
        'fax': '',
        'address1': '',
        'address2': '',
        'city': '',
        'state': '',
        'zipcode': '',
        'country': '',
        'starred': false
      }, vm.company);
      vm.title = 'New Company';
      vm.newCompany = true;
      vm.company.tags = [];

    }

    // Methods
    vm.addNewCompany = addNewCompany;
    vm.saveCompany = saveCompany;
    vm.deleteCompanyConfirm = deleteCompanyConfirm;
    vm.closeDialog = closeDialog;
    vm.filterChange = dialogData.filterChange;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.init = init;
    vm.checkIfCountryUSA = checkIfCountryUSA;
    vm.patchCompanyGroup = patchCompanyGroup;
    vm.starredCompany = starredCompany;
    vm.searchTextChange = searchTextChange;
    vm.selectedCountryChange = selectedCountryChange;
    vm.queryCountry = queryCountry;
    vm.searchTextChangeState = searchTextChangeState;
    vm.selectedStateChange = selectedStateChange;
    vm.queryState = queryState;
    vm.createFilterFor = createFilterFor;
    vm.addToCompanyBusinessRoles = addToCompanyBusinessRoles;
    vm.openImgCropDialog = openImgCropDialog;
    vm.invalidImage = invalidImage;
    vm.radioShippingChange = radioShippingChange;
    vm.changeCity = changeCity;
    vm.changeAddress1 = changeAddress1;
    vm.changeAddress2 = changeAddress2;
    vm.changeZipcode = changeZipcode;
    vm.setMenuWidth = setMenuWidth;
    init();

    /**
     /**
     * invalidImage
     */
    function invalidImage($files) {
      vm.imageInvalid = $files.filter(function (file) {
        return file.type != 'image/gif' && file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/bmp' && file.type != 'image/jpg' && file.type != 'image/jpe' && file.type != 'image/tiff' && file.type != 'image/ico';
      }).length > 0;
    }

    /**
     /**
     * openImgCropDialog
     */
    function openImgCropDialog(evt, file) {

      if ($scope.companyForm.file.$error.maxSize) {
        vm.imageInvalid = true;
      }


      if (!file) {
        vm.imageInvalid = true;
      }

      if (vm.imageInvalid) {
        vm.imageInvalid = false;
        //delete vm.picFile;
        return;
      }

      $mdDialog.show({
        controller: function DialogController($scope, $mdDialog) {
          /** @ngInject */
          $scope.vm = vm;
          $scope.crop_image = '';
          $scope.cancel = function () {
            delete vm.picFile;
            dialogData.openCompanyDialog(evt, vm.company, true);
            $mdDialog.cancel();
          };
          $scope.confirm = function () {
            var blob = b64toBlob($scope.crop_image, file);
            vm.company.image_url = $scope.crop_image;
            vm.company.image_name = '';
            vm.company.avatarUpdated = true;
            vm.company.file = blob;
            $mdDialog.cancel();
            dialogData.openCompanyDialog(evt, vm.company, true);
          };
        },
        templateUrl: 'app/main/farm-admin/users/companies/dialogs/company/crop_dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        targetEvent: evt,
        fullscreen: true
      });


    }


    /**
     /**
     * queryCountry
     */
    function queryCountry(query) {
      var results = query ? _.map(_.filter(vm.countries, vm.createFilterFor(query)), function (elem) {
        return elem.name;
      }) : _.map(vm.countries, function (elem) {
        return elem.name;
      });

      return _.values(results);
    }

    /**
     /**
     * createFilterFor
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.name.toLowerCase().indexOf(lowercaseQuery) === 0);
      };

    }

    /**
     /**
     * searchTextChange
     */
    function searchTextChange() {

    }

    /**
     /**
     * selectedCountryChange
     */
    function selectedCountryChange(item) {
      if (item) {
        vm.checkIfCountryUSA(item.name, '');
      }
    }


    /**
     /**
     * queryState
     */
    function queryState(query) {
      var results = query ? _.map(_.filter(vm.states, vm.createFilterFor(query)), function (elem) {
        return elem.name;
      }) : _.map(vm.states, function (elem) {
        return elem.name;
      });

      return _.values(results);
    }


    /**
     /**
     * searchTextChangeState
     */
    function searchTextChangeState() {

    }

    /**
     /**
     * selectedStateChange
     */
    function selectedStateChange() {
      if (vm.sameShippingAddress) {
        vm.company.shipping_state = vm.company.state;
      }
    }


    /**
     /**
     * radioShippingChange
     */
    function radioShippingChange() {
      if (!vm.sameShippingAddress) {
        vm.company.shipping_address1 = '';
        vm.company.shipping_address2 = '';
        vm.company.shipping_city = '';
        vm.company.shipping_state = '';
        vm.company.shipping_zipcode = '';
      } else {
        vm.company.shipping_address1 = vm.company.address1;
        vm.company.shipping_address2 = vm.company.address2;
        vm.company.shipping_city = vm.company.city;
        vm.company.shipping_state = vm.company.state;
        vm.company.shipping_zipcode = vm.company.zipcode;
      }
    }

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function changeCity() {
      if (vm.sameShippingAddress) {
        vm.company.shipping_city = vm.company.city;
      }
    }

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function changeAddress1() {
      if (vm.sameShippingAddress) {
        vm.company.shipping_address1 = vm.company.address1;
      }
    }

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function changeAddress2() {
      if (vm.sameShippingAddress) {
        vm.company.shipping_address2 = vm.company.address2;
      }
    }

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function changeZipcode() {
      if (vm.sameShippingAddress) {
        vm.company.shipping_zipcode = vm.company.zipcode;
      }
    }

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      /**
       * Load countries
       */


      if (typeof (vm.company.country == 'undefined') || vm.company.country == null) {
        vm.company.country = 'United States';
        vm.checkIfCountryUSA(vm.company.country, '');
      }

      if (vm.newCompany) {
        vm.sameShippingAddress = true;
        vm.company.br = [];
      } else {
        if (['shipping_address1', 'shipping_address2', 'shipping_city', 'shipping_state', 'shipping_zipcode'].filter(function (elem) {
          return typeof(vm.company[elem]) != 'undefined' && vm.company[elem] != null;
        }).length > 0) {
          vm.sameShippingAddress = false;
        } else {
          vm.sameShippingAddress = true;
        }

      }


      msApi.request('countries@get',
      function (countriesInfo) {
        vm.countries = countriesInfo.countries;
      },
      function (res) {
        if (res.status === 401) {
          $location.url('/login');
        }
      }
      );
    }

    /**
     * Add new company
     */
    function addNewCompany() {
      var dataToPost = {
        name: vm.company.name,
        contact_person: vm.company.contact_person,
        email_address: vm.company.email_address,
        office_phone: vm.company.office_phone,
        cell_phone: vm.company.cell_phone,
        fax: vm.company.fax,
        address1: vm.company.address1,
        address2: vm.company.address2,
        city: vm.company.city,
        state: vm.states.filter(function (state) {
          return state.name == vm.company.state;
        }).shift().abbreviation,
        zipcode: vm.company.zipcode,
        shipping_address1: vm.company.shipping_address1 || vm.company.address1,
        shipping_address2: vm.company.shipping_address2 || vm.company.address2,
        shipping_city: vm.company.shipping_city || vm.company.city,
        shipping_state: vm.states.filter(function (state) {
          if(vm.company.shipping_state) {
            return state.name == vm.company.shipping_state;
          }
          else
          {
            return state.name == vm.company.state;
          }
        }).shift().abbreviation,
        shipping_zipcode: vm.company.shipping_zipcode || vm.company.zipcode,
        country: vm.company.country,
        br: vm.company.br,
        starred: vm.company.starred.toString()
      };
      CompanyService.create(dataToPost).then(function (data) {
        if (vm.company.avatarUpdated) {
          Upload.upload({
            url: CompanyService.getUploadImgUrl(data.company.id),
            data: {id: data.company.id, upfile: vm.company.file}
          }, function () {
          }, function () {
          }).then(function () {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The Company ' + vm.company.name + ' has been created.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            vm.aux = {};
            vm.aux = data.company;
            vm.aux.br = vm.company.br;
            if (vm.company.br) {
              vm.company.br.forEach(function (element) {
                CompanyService.companyBusinessRolesAddRelation(vm.aux.id, element).then(function () {
                },
                function () {
                  $mdToast.show({
                    template: '<md-toast class="md-toast error">The company ' + vm.aux.name + ' could not be relate to Business Roles id:' + element + '.</md-toast>',
                    position: 'top right',
                    hideDelay: 4500
                  });
                });
              });
            }
            vm.companies.push(vm.aux);
            vm.shownCompanies.push(vm.aux);
            closeDialog();
          });
        } else{
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Company ' + vm.company.name + ' has been created.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.aux = {};
          vm.aux = data.company;
          vm.aux.br = vm.company.br;
          if (vm.company.br) {
            vm.company.br.forEach(function (element) {
              CompanyService.companyBusinessRolesAddRelation(vm.aux.id, element).then(function () {
              },
              function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">The company ' + vm.aux.name + ' could not be relate to Business Roles id:' + element + '.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              });
            });
          }
          vm.companies.push(vm.aux);
          vm.shownCompanies.push(vm.aux);
          vm.filterChange('all');
          closeDialog();
        }
      },
      function (err) { //reject
        var error;
        if (err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">The Company ' + vm.company.name + ' could not be created. ' + ((error != undefined) ? error : '') + error + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * Save existent company (save on edit)
     */
    function saveCompany() {
      vm.company.save = true;
      var dataToPost = {
        name: vm.company.name,
        contact_person: vm.company.contact_person,
        email_address: vm.company.email_address,
        office_phone: vm.company.office_phone,
        cell_phone: vm.company.cell_phone,
        fax: vm.company.fax,
        address1: vm.company.address1,
        address2: vm.company.address2,
        br: vm.company.br,
        city: vm.company.city,
        state: vm.states.filter(function (state) {
          return state.name == vm.company.state;
        }).shift().abbreviation,
        zipcode: vm.company.zipcode,
        country: vm.company.country,
        shipping_address1: vm.company.shipping_address1 || vm.company.address1,
        shipping_address2: vm.company.shipping_address2 || vm.company.address2,
        shipping_state: vm.company.shipping_state || vm.company.state,
        shipping_city: vm.company.shipping_city || vm.company.city,
        shipping_zipcode: vm.company.shipping_zipcode || vm.company.zipcode,
        starred: vm.company.starred.toString()
      };

      if (dataToPost.shipping_state) {
        var fund = vm.states.filter(function (state) {
          return state.name == vm.company.shipping_state;
        }).shift();
        if (fund) {
          dataToPost.shipping_state = fund.abbreviation;
        }
      }
      CompanyService.update(vm.company.id, dataToPost).then(function (data) {
        if (vm.company.avatarUpdated) {
          Upload.upload({
            url: CompanyService.getUploadImgUrl(vm.company.id),
            data: {id: vm.company.id, upfile: vm.company.file}
          }, function () {
          }, function () {
          }).then(function () {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The company ' + vm.company.name + ' has been updated.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            closeDialog();
          });
        } else {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The company ' + vm.company.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          closeDialog();
        }
        vm.company.br.forEach(function (element) {
          CompanyService.companyBusinessRolesAddRelation(data.company.id, element).then(function () {
          },
          function () {
            $mdToast.show({
              template: '<md-toast class="md-toast error">The company ' + data.company.name + ' could not be relate to Business Roles id:' + element + '.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
          });
        });

      },
      function (err) { //reject
        var error;
        if (err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">The company ' + vm.company.name + ' could not be updated.' + ((error != undefined) ? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * Starred Company
     */
    function starredCompany(company) {
      if (company.starred === false) {
        company.starred = true;
      } else if (company.starred === true) {
        company.starred = false;
      }
    }

    /**
     * Delete Company Confirm Dialog
     */
    function deleteCompanyConfirm(ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('COMPANIES.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + vm.company.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete company')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        CompanyService.delete(vm.company.id).then(function () {
          vm.companies.splice(vm.companies.indexOf(vm.company), 1);
          vm.shownCompanies.splice(vm.shownCompanies.indexOf(vm.company), 1);
          $mdToast.show({
            template: '<md-toast class="md-toast success">The company ' + vm.company.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function (err) {
          var error;
          if (err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The company ' + vm.company.name + ' could not be deleted.' + ((error != undefined) ? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      }, function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Close dialog
     */
    function closeDialog(cancel) {
      if (cancel) {
        $rootScope.$broadcast('cancelCompany', {});
      }
      $mdDialog.hide();
    }

    /**
     * [checkIfCountryUSA description]
     * @return {[type]} [description]
     */
    function checkIfCountryUSA(country, selectedState) {
      if (country === 'United States') {
        vm.stateInput = false;
        vm.phoneMask = '999-999-9999';
        /* Load states */
        msApi.request('states@get',
        function (statesInfo) {
          vm.states = statesInfo.states;
          if (selectedState && selectedState !== '') {
            vm.company.state = selectedState;
          }
          if (vm.company.state) {
            var associatedState = vm.states.filter(function (state) {
              return state.abbreviation == vm.company.state;
            });
            if (associatedState.length > 0) {
              vm.company.state = associatedState.shift().name;
            }
          }
        },
        function (err) {
          console.error(err);
        });
      } else {
        vm.states = '';
        vm.company.state = '';
        vm.phoneMask = '';
        vm.stateInput = true;
      }
    }

    /**
     * [setMenuWidth description]
     */
    function setMenuWidth() {
      var interval = setInterval(setWidth, 100);

      /**
       * [setWidth description]
       */
      function setWidth() {
        var menuEle = angular.element('.md-open-menu-container.md-active');
        menuEle.css({
          'width': '192px',
          'position': 'absolute',
          'left': '50%',
          'right': '50%'
        });

        if(!menuEle.length) {
          clearInterval(interval);
        }
      }
    }

    /**
     * [patchCompanyGroup description]
     * @return {[type]} [description]
     */
    function patchCompanyGroup(company, group) {
      dialogData.patchCompanyGroup(company, group);
    }

    /**
     * Starred Company
     */
    function addToCompanyBusinessRoles(company, group) {
      if (!vm.exists(group.id, vm.company.br)) {
        vm.company.br.push(group.id);
      } else {
        _.remove(company.br, function (elem) {
          return elem === group.id;
        });
      }
      //closeDialog();
    }

    /**
     * Convert base64 image to blob
     * @param  {[type]} b64Data   [description]
     * @param  {[type]} file      [description]
     * @param  {[type]} sliceSize [description]
     * @return {[type]}           [description]
     */
    function b64toBlob(b64Data, file, sliceSize) {
      // Split the base64 string in data and contentType
      var block = b64Data.split(';');
      // Get the content type of the image
      var contentType = block[0].split(':')[1];
      // get the real base64 content of the file
      var realData = block[1].split(',')[1];

      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(realData);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      var blobUrl = URL.createObjectURL(blob);
      blob.$ngfBlobUrl = blobUrl;
      blob.$ngfName= file.$ngfName;

      return blob;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.subleases.dialogs-subleaseListBlocks', [])
    .controller('SubleaseListBlocksDialogCtrl', SubleaseListBlocksDialogCtrl);

  /** @ngInject */
  function SubleaseListBlocksDialogCtrl(
    $mdDialog,
    $mdToast,
    dialogData
  ) {
    var vm = this;

    // Data
    vm.sublease         = dialogData.sublease;

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.leases.dialogs-leaseListBlocks', [])
    .controller('LeaseListBlocksDialogController', LeaseListBlocksDialogController);

  /** @ngInject */
  function LeaseListBlocksDialogController(
    $mdDialog,
    $mdToast,
    dialogData
  ) {
    var vm = this;

    // Data
    vm.lease         = dialogData.lease;

  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.land.land.dialogs-location', [])
  .controller('LandDialogLocationController', LandDialogLocationController);

  /** @ngInject */
  function LandDialogLocationController($scope,
                                        $state,
                                        $location,
                                        $mdToast,
                                        $mdDialog,
                                        $translate,
                                        dialogData,
                                        LandService,
                                        msUtils
                                        ) {
    var vm = this;

    // Data
    vm.locations = dialogData.locations;
    vm.location = dialogData.location;
    $scope.dataAreaId = dialogData.dataAreaId;
    vm.newLocation = false;
    vm.allFields = false;


    if (!vm.location) {
      vm.location = {
        'area_id': $scope.dataAreaId,
        'name': '',
        'location_short_code': ''
      };
      vm.title = 'New Location';
      vm.newLocation = true;
      vm.location.tags = [];
    }

    // Methods
    vm.addNewLocation = addNewLocation;
    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;

    /**
     * Add new location
     */
    function addNewLocation() {
      var dataToPost = {
        area_id: vm.location.area_id,
        name: vm.location.name,
        location_short_code: vm.location.location_short_code
      };
      LandService.createLocation(dataToPost.area_id, dataToPost).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">Location ' + vm.location.name + ' has been created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        if (!data.ranches) {
          data.ranches = [];
        }
        vm.locations.push(data.location);
        closeDialog();

      },
      function (err) { //reject
        var error;
        if (err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">Location ' + vm.location.name + ' could not be created. ' + ((error != undefined) ? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.land.dialogs', [])
    .controller('LandDialogController', LandDialogController);

    /** @ngInject */
  function LandDialogController(
    $scope,
    $state,
    $location,
    $mdToast,
    $mdDialog,
    $translate,
    dialogData,
    LandService,
    msUtils
    ) {
    var vm = this;

    // Data
    vm.areas = dialogData.areas;
    vm.area = dialogData.area;
    vm.newArea = false;
    vm.allFields = false;

    if (!vm.area) {
      vm.area = {
        'name'          : '',
        'description'   : '',
      };
      vm.title       = 'New ' + dialogData.land_ref.area_reference_name;
      vm.newArea     = true;
      vm.area.tags   = [];
    }

    // Methods
    vm.addNewArea = addNewArea;
    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;

    /**
    * Add new area
    */
    function addNewArea() {
      var dataToPost = {
        name: vm.area.name,
      };
      LandService.createArea(dataToPost).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">Area '+ vm.area.name + ' has been created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        data.area.Locations=[];
        vm.areas.push(data.area);
        closeDialog();
      },
      function(err) { //reject
        var error;
        if(err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">Area '+ vm.area.name + ' could not be created. ' +  ((error != undefined)? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }
    /**
    * Close dialog
    */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.blocks.dialogs-block-bed-sizes', [])
    .controller('BlockBedSizesDialogController', BlockBedSizesDialogController);

  /** @ngInject */
  function BlockBedSizesDialogController(
    $mdDialog,
    $location,
    $mdToast,
    BlockBedSizeService,
    BedSizeService,
    dialogData
  ) {
    var vm = this;

    // Data
    vm.title               = 'Add Block Bed Size';
    vm.block               = dialogData.block;
    vm.bedSizes            = [];

    vm.block_bed_size = {
      block_id: vm.block.id,
      bed_count: null,
      bed_size: null
    };

    // Methods
    vm.addNewBlockBedSize  = addNewBlockBedSize;
    vm.getDataToPost       = getDataToPost;
    vm.closeDialog         = closeDialog;

    //////////

    BedSizeService.getAvailablesBedSizes(vm.block.id).then(function(bedSizesData) {
      vm.bedSizes = bedSizesData.bed_sizes;
    });

    /**
     * Add new block
     */
    function addNewBlockBedSize() {
      var dataToPost = getDataToPost();
      /**
       * Create new block
       */
      BlockBedSizeService.create(dataToPost).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The block bed size has been created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        BlockBedSizeService.getBlockBedSizes(vm.block.id).then(function(bedSizesData) {
          vm.block.block_bed_sizes = bedSizesData.block_bed_sizes;
          closeDialog();
        });

      },
      function() { //reject
        $mdToast.show({
          template: '<md-toast class="md-toast error">The block bed size could not be created. </md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }


    /**
     * Return data formated to post.
     * @return {[type]} [description]
     */
    function getDataToPost() {
      return {
        block_id: vm.block.id,
        bed_count: vm.block_bed_size.bed_count,
        bed_size_id: parseInt(vm.block_bed_size.bed_size_id),
        description: vm.block_bed_size.description
      };
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.seed.dialogs-variety', [])
    .controller('VarietyDialogController', VarietyDialogController);

  /** @ngInject */
  function VarietyDialogController(
    $state,
    $scope,
    $timeout,
    $mdToast,
    $mdSidenav,
    $mdDialog,
    $document,
    $translate,
    $location,
    $stateParams,
    dialogData,
    SeedService,
    CompanyService,
    msUtils
    )
    {
    var vm = this;
    // Data
    vm.varieties = dialogData.varieties;
    vm.variety = dialogData.variety;
    vm.redirectCompany = redirectCompany;
    $scope.dataSeedId = dialogData.dataSeedId;

    vm.newVariety = false;
    vm.allFields = false;

    if (!vm.variety) {
      vm.variety = {
        'seed_id': $scope.dataSeedId,
        'name': '',
        'description': '',
        'public_domain': ''
      };
      vm.newVariety = true;
      vm.titleVariety = 'New Variety';
      vm.variety.tags = [];
    }
    // Methods
    vm.addNewVariety = addNewVariety;
    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;

    //////////

    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      /* Get Seed companies */
      CompanyService.getCompanyByBusinessRole('seed company').then(function(companiesData) {
        vm.companies = companiesData.companies;
      },
      function(err) {
        console.error(err);
      });
    }
    /**
     * Redirect company page
     */
    function redirectCompany() {
      if (vm.companies) {
        closeDialog();
        $state.go($state.current, {}, {reload: true});/* Redirect to users and edit */
        $location.url('/companies/');
      } else {
        var user = {
          'company_id': msUtils.guidGenerator()
        };
        closeDialog();
        $state.go($state.current, {}, {reload: true});/* Redirect to users and edit */
        $location.url('/companies/' + user.company_id);
      }

    }
    /**
     * Add new variety
     */
    function addNewVariety() {
      var dataToPost = {
        seed_id: vm.variety.seed_id,
        name: vm.variety.name,
        description: vm.variety.description,
        public_domain: vm.variety.public_domain
      };

      SeedService.createVariety(dataToPost).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">Variety ' + vm.variety.name + ' has been created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });

        data.variety.seed_varieties_location = [];
        vm.varieties.push(data.variety);
        closeDialog();
      },
        function (err) { //reject
          var error;
          if (err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">Variety ' + vm.variety.name + ' could not be created. ' + ((error != undefined) ? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      closeDialog();
    }

    /**
    * Close dialog
    */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.seed.dialogs', [])
    .controller('SeedDialogController', SeedDialogController);

  /** @ngInject */
  function SeedDialogController(
    $state,
    $scope,
    $timeout,
    $mdToast,
    $mdSidenav,
    $mdDialog,
    $document,
    $translate,
    $location,
    $stateParams,
    dialogData,
    SeedService,
    msUtils
    )
    {
    var vm = this;
    // Data
    vm.seeds = dialogData.seeds;
    vm.seed = dialogData.seed;

    vm.newSeed = false;
    vm.allFields = false;

    if (!vm.seed) {
      vm.seed = {
        'name': '',
        'description': '',
      };
      vm.titleSeed = 'New Seed';
      vm.titleVariety = 'New Variety';
      vm.titleVarietyLocation = 'New Variety planting location';
      vm.newSeed = true;
      vm.seed.tags = [];
    }

    // Methods
    vm.addNewSeed = addNewSeed;
    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;

    /**
     * Add new seed
     */
    function addNewSeed() {
      var dataToPost = {
        name: vm.seed.name,
        description: vm.seed.description,
      };
      SeedService.create(dataToPost).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">Seed ' + dataToPost.name + ' has been created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        data.seed.SeedVarieties=[];
        vm.seeds.push(data.seed);
        closeDialog();
      },
        function (err) { //reject
          var error;
          if (err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">Seed ' + dataToPost.name + ' could not be created. ' + ((error != undefined) ? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      closeDialog();
    }

    /**
    * Close dialog
    */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.seed.dialogs-location', [])
    .controller('LocationDialogController', LocationDialogController);

  /** @ngInject */
  function LocationDialogController(
    $state,
    $scope,
    $timeout,
    $mdToast,
    $mdSidenav,
    $mdDialog,
    $document,
    $translate,
    $location,
    $stateParams,
    dialogData,
    SeedService,
    msUtils
    )
    {
    var vm = this;
    // Data
    vm.varietiesLocations = dialogData.varietiesLocations;
    vm.varietyLocation = dialogData.varietyLocation;
    $scope.dataVarietyId = dialogData.dataVarietyId;
    vm.locations = dialogData.locations;
    vm.redirectLand = redirectLand;
    vm.addNewLocation = false;
    vm.allFields = false;

    if (!vm.varietyLocation) {
      vm.varietyLocation = {
        'variety_id': $scope.dataVarietyId,
        'location_id': '',
        'begin_date': '',
        'end_date': ''
      };
      vm.titleVarietyLocation = 'New Variety Planting Location';
      vm.addNewLocation = true;
      vm.varietyLocation.tags = [];
    }

    // Methods
    vm.addNewLocation = addNewLocation;
    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.dateChanged = dateChanged;

    $scope.customDateFormat = {
      formatDate: function(date) {
        var m = moment(date);
        return m.isValid() ? m.format('MMMM Do') : '';
      }
    };

    /**
     * Redirect land page
     */
    function redirectLand() {
      closeDialog();
      $state.go($state.current, {}, {reload: true});/* Redirect to users and edit */
      $location.url('/land');
      $mdToast.show({
        template: '<md-toast class="md-toast warning">To add a location please click in next.</md-toast>',
        position: 'top right',
        hideDelay: 10000
      });
    }

    /**
     * Start or End dates changed
     * @param  {[type]} varLoc [description]
     * @return {[type]}
     */
    function dateChanged(varLoc) {
      var startDay = null;
      var endDay   = null;

      if (varLoc.begin_date) {
        startDay = new Date(varLoc.begin_date);
        varLoc.min_date = startDay;
        varLoc.begin_date = startDay;
      }
      if (varLoc.end_date) {
        endDay   = new Date(varLoc.end_date);
        varLoc.end_date = endDay;
      }
      if (startDay && endDay && endDay < startDay) {
        varLoc.end_date = startDay;
      }
    }

    /**
    * Add new variety planting location
    */
    function addNewLocation() {
      var dataToPost = {
        variety_id: vm.varietyLocation.variety_id,
        location_id: vm.varietyLocation.location_id,
        begin_date: vm.varietyLocation.begin_date,
        end_date: vm.varietyLocation.end_date,
      };

      SeedService.createVarietyPlantingLocation(dataToPost).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success>Planting Location has been created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.varietiesLocations.push(data.variety_planting_location);
        closeDialog();
      },
        function (err) { //reject
          var error;
          if (err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error>Planting Location could not be created. ' + ((error != undefined) ? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
    }

    /**
    * Close dialog
    */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function ()
{
  'use strict';

  angular
  .module('app.pages.work-schedule', [
      // 3rd Party Dependencies
    'gantt',
    'gantt.sortable',
    'gantt.movable',
    'gantt.drawtask',
    'gantt.tooltips',
    'gantt.bounds',
    'gantt.progress',
    'gantt.table',
    'gantt.tree',
    'gantt.groups',
    'gantt.dependencies',
    'gantt.overlap',
    'gantt.resizeSensor'
  ])
  .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
  {

    $stateProvider.state('app.pages_work_schedule', {
      url    : '/work-schedule',
      views  : {
        'content@app': {
          templateUrl: 'app/main/pages/work-schedule/work-schedule.html',
          controller : 'WorkScheduleCtrl as vm'
        }
      },
      bodyClass: 'work-schedule',
      resolve: {
        acl: function($q, AclService) {
          if(!AclService.can('work_schedule')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/work-schedule');

    // // Navigation
    msNavigationServiceProvider.saveItem('pages.work-schedule', {
      title : 'Work Schedule Manager',
      icon  : 'icon-timetable',
      state : 'app.pages_work_schedule',
      weight: 12
    });

    // Api
    msApiProvider.register('ganttChart.tasks', ['app/main/pages/work-schedule/json/tasks.json']);
    msApiProvider.register('ganttChart.timespans', ['app/main/pages/work-schedule/json/timespans.json']);


  }

})();

(function () {
  'use strict';

  angular.module('app.pages.work-schedule')
  .controller('GanttChartAddEditDialogController', GanttChartAddEditDialogController);

  /** @ngInject */
  function GanttChartAddEditDialogController($mdDialog, WorkTemplateService, dialogData, $document, SeasonsService, SeedService, AnchorTypeDefinitionService) {
    var vm = this;
    var _ = window._;
    vm.closeDialog = closeDialog;
    vm.save = save;
    vm.changeShowName = dialogData.changeShowName;
    vm.users = dialogData.users;
    vm.dates = [];

    vm.openColorPicker = function (ev, task) {
      $mdDialog.show({
        controller: 'PhaseColorPickerDialogController',
        controllerAs: 'vm',
        multiple: true,
        templateUrl: 'app/main/admin/work-schedule-template/phase-type/dialog/color-picker-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            phase: task
          }
        }
      });
    };

    /**
     * Generate closeDialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * Generate save
     */
    function save() {
      var index = _.findIndex(vm.ganttData, function (d) {
        return d.id == vm.block.id;
      });
      vm.saveEquipmentColors(vm.block);
      vm.saveForemanColors(vm.block);
      vm.saveLaborColors(vm.block);

      vm._block.dates = vm.block.dates;

      vm.changeWorkTemplate(vm.block);
      //vm.decideJoinTasks();
      _.assign(vm.ganttData[index], vm.block);
      vm.reload(vm.ganttData);
      $mdDialog.hide();
    }


    vm.workTemplates = [];
    vm._block = dialogData.block;
    vm.block = _.cloneDeep(dialogData.block);
    vm.ganttData = dialogData.data;
    vm.reload = dialogData.reload;
    vm.laborGroups = [];
    vm.rolesGroups = [];
    vm.labors = dialogData.labors;
    vm.equipments = dialogData.equipments;
    vm.foremans = dialogData.foremans;
    vm.changeWorkTemplate = dialogData.changeWorkTemplate;
    vm.decideJoinTasks = dialogData.decideJoinTasks;
    vm.seeds = [];
    vm.seasons = [];


    vm.getAnchorName = function (date) {
      return AnchorTypeDefinitionService.getAnchorName(date.anchor_id);
    };

    WorkTemplateService.get().then(function (data) {
      vm.workTemplates = data;
    });

    SeasonsService.getList().then(function (data) {
      vm.seasons = data.seasons;
    });

    SeedService.getAll().then(function (data) {
      vm.seeds = data.seeds;
    });

    vm.getSeedName = function () {
      if (!vm.block || !vm.block.work_template || vm.seeds.length === 0) {
        return '';
      }

      return vm.seeds.filter(function (s) {
        return s.id == vm.block.work_template.seed_id;
      }).shift().name;

    };

    vm.getSeasonName = function () {
      if (!vm.block || !vm.block.work_template || vm.seasons.length === 0) {
        return '';
      }

      return vm.seasons.filter(function (s) {
        return s.id == vm.block.work_template.season_id;
      }).shift().name;

    };

    vm.generateRolesGroups = function (block) {
      var rolesGroups = _.groupBy(block.tasks, function (t) {
        return t.foreman_id;
      });

      vm.rolesGroups = [];

      _.forEach(rolesGroups, function (role, key) {
        var foremans = vm.users.filter(function (user) {
          return _.findIndex(user.roles, function (r) {
            return r.id == key;
          }) != -1;
        });

        var _name = vm.foremans.filter(function (l) {
          return l.id == key;
        }).shift().name;

        if (foremans.length > 0) {
          vm.rolesGroups.push({
            name: _name,
            id: key,
            color: generateColor(),
            subgroups: foremans
          });
        }

      });


    };

    vm.getAnchorTask = function (anchor_id) {

      var allTasks = _.flatten(vm.block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));

      return allTasks.filter(function (t) {
        return t.anchor_id == anchor_id;
      }).shift();
    };

    /**
     * Generate generateColor
     */
    function generateColor() {

      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }

    vm.originalBlockWetDate = _.cloneDeep(moment(vm.block.scheduled_wet_date));
    vm.originalBlockGrowingDate = _.cloneDeep(moment(vm.block.scheduled_wet_date));
    vm.originalBlockTillageDate = _.cloneDeep(moment(vm.block.scheduled_wet_date));
    vm.originalBlockIrrigationDate = _.cloneDeep(moment(vm.block.scheduled_wet_date));


    vm.changePreWaterDays = function () {
      var days = vm.block.preWaterDays;
      vm.block.scheduled_pre_water_date = _.cloneDeep(moment(vm.originalBlockWetDate)).subtract(days, 'day');
    };


    vm.changeGrowingDays = function () {
      var days = vm.block.growingDays;
      vm.block.scheduled_growing_date = _.cloneDeep(moment(vm.originalBlockGrowingDate)).add(days, 'day');
    };

    vm.changeTillageDays = function () {
      var days = vm.block.tillageDays;
      vm.block.scheduled_tillage_date = _.cloneDeep(moment(vm.originalBlockTillageDate)).subtract(days, 'day');
    };

    vm.changeIrrigationDays = function () {
      var days = vm.block.irrigationDays;
      vm.block.scheduled_irrigation_date = _.cloneDeep(moment(vm.originalBlockIrrigationDate)).add(days, 'day');
    };

    vm.ahowDateFormatted = function (date) {
      if (date === null) {
        return moment(vm.block.scheduled_wet_date).format('MMMM Do YYYY, h:mm:ss a');
      }
      return moment(date).format('MMMM Do YYYY, h:mm:ss a');
    };

    vm.hasPreWaterTask = function () {

      var allTasks = _.flatten(vm.block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));

      return _.findIndex(allTasks, function (t) {
        return t.pre_water == true;
      }) !== -1;

    };

    //Returns all tasks of specific phase
    vm.getAllTasks = function () {
      return _.flatten(vm.block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));
    };

    //Checks if the phase has growing task
    vm.hasGrowingTask = function () {

      var allTasks = _.flatten(vm.block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));

      return _.findIndex(allTasks, function (t) {
        return t.growing_start_date == true;
      }) !== -1;

    };

    vm.hasTillageTask = function () {
      var allTasks = _.flatten(vm.block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));

      return _.findIndex(allTasks, function (t) {
        return t.tillage_date == true;
      }) !== -1;
    };

    vm.hasIrrigationTask = function () {
      var allTasks = _.flatten(vm.block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));

      return _.findIndex(allTasks, function (t) {
        return t.irrigation_date == true;
      }) !== -1;
    };


    vm.generateLaborGroups = function (block) {

      var laborGroups = _.groupBy(block.tasks, function (t) {
        return t.labor_group_id;
      });

      vm.laborGroups = [];

      _.forEach(laborGroups, function (labor, key) {


        var _name = vm.labors.filter(function (l) {
          return l.id == key;
        }).shift().name;

        var labors = [{id: 1, name: _name + ' 1'}, {id: 2, name: _name + ' 2'}, {id: 3, name: _name + ' 3'}];


        vm.laborGroups.push({
          name: _name,
          id: key,
          color: generateColor(),
          subgroups: labors
        });

      });

      vm.generateEquipmentGroups(block);

    };


    vm.generateEquipmentGroups = function (block) {

      var equipmentGroups = _.groupBy(block.tasks, function (t) {
        return t.equipment_id;
      });

      vm.equipmentGroups = [];

      _.forEach(equipmentGroups, function (equipment, key) {


        var _name = vm.equipments.filter(function (l) {
          return l.id == key;
        }).shift().name;

        var equipments = [{id: 1, name: _name + ' Team 1'}, {id: 2, name: _name + ' Team 2'}, {
          id: 3,
          name: _name + ' Team 3'
        }];


        vm.equipmentGroups.push({
          name: _name,
          id: key,
          color: generateColor(),
          subgroups: equipments
        });

      });

    };

    vm.saveEquipmentColors = function (block) {
      if (vm.equipmentGroups) {
        vm.equipmentGroups.forEach(function (e) {
          vm.saveTaskColor(e.id, 'equipment_id', 'equipment_color', e.color, block);
        });
      }
    };

    vm.saveLaborColors = function (block) {
      if (vm.laborGroups) {
        vm.laborGroups.forEach(function (e) {
          vm.saveTaskColor(e.id, 'labor_group_id', 'labor_color', e.color, block);
        });
      }
    };

    vm.saveForemanColors = function (block) {
      if (vm.rolesGroups) {
        vm.rolesGroups.forEach(function (e) {
          vm.saveTaskColor(e.id, 'foreman_id', 'foreman_color', e.color, block);
        });
      }
    };


    vm.saveTaskColor = function (id, attr, colorAttr, color, block) {

      var tasks = block.tasks.filter(function (task) {
        return task[attr] == id;
      });

      tasks.forEach(function (t) {
        t[colorAttr] = color;
      });

    };

    vm.generateDates = function () {

      vm.dates = [];
      vm.block.dates.forEach(function (date) {
        var anchor = AnchorTypeDefinitionService.getAnchor(date.anchor_id);
        if (anchor.display) {
          var type = 'picker';
          if (anchor.preAnchor) {
            type = 'before';
          } else if (anchor.postDate) {
            type = 'after';
          }
          vm.dates.push({date: date, anchor: anchor, type: type});
        }
      });


    };

    //Checks if can configure repeats from specific phase
    vm.canConfigureRepeats = function (phase) {

      var valid = false;

      phase.tasks.forEach(function (task) {
        var anchor = AnchorTypeDefinitionService.getAnchor(task.anchor_id);

        if (anchor) {
          if ((anchor.preAnchor || anchor.postDate) && anchor.repeats) {
            valid = true;
          }
        }

      });

      return valid;

    };

    //Returns formated date
    vm.formatDate = function (date) {
      return moment(date).format('MM-DD-YYYY');
    };

    vm.addDays = function (date, mult) {

      var wet_date = _.cloneDeep(vm.block.scheduled_wet_date);
      wet_date = _.cloneDeep(moment(wet_date)).add(parseInt(date.model) * mult, 'day');
      date.date = wet_date;

    };


  }
})();

(function () {
  'use strict';

  angular
    .module('app.pages.planting-schedule.dialog', [])
    .controller('PlantingScheduleInformationDialogController', PlantingScheduleInformationDialogController);

  /** @ngInject */
  function PlantingScheduleInformationDialogController(
    $mdDialog,
    $location,
    $mdToast,
    dialogData,
    PlantingSchedulePlantingInformationService
  ) {
    var vm = this;

    // Data
    vm.newPlantingScheduleInformation = [];
    vm.parent_id = dialogData.parent_id;
    vm.plantingInformationList = dialogData.plantingInformationList;

    var user = sessionStorage.getItem('user');
    vm.user = JSON.parse(user);

    // Methods
    vm.init = init;
    vm.closeDialog = closeDialog;
    vm.addPlantingScheduleInformation = addPlantingScheduleInformation;

    //////////

    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {

    }


    /**
     * Create Planting Schedule Information
     */
    function addPlantingScheduleInformation() {
      vm.newPlantingScheduleInformation.parent_id = vm.parent_id;
      vm.newPlantingScheduleInformation.wet_date = moment(vm.newPlantingScheduleInformation.wet_date).format('ddd, MMM D');
      PlantingSchedulePlantingInformationService.save(vm.newPlantingScheduleInformation).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The planting information has been created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.plantingInformationList.push(vm.newPlantingScheduleInformation);
        closeDialog();
      },
        function (err) { //reject
          var error;
          if (err.status && err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The planting information could not be created. ' + ((error !== undefined) ? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        }
      );

    }


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.grower-schedule.dialogs-show-errors', [])
    .controller('ShowErrorsDialogController', ShowErrorsDialogController);

  /** @ngInject */
  function ShowErrorsDialogController(
    $mdDialog,
    dialogData,
    moment,
    GeneralFunctionsService
  ) {
    var vm = this;

    // Data
    vm.gs                               = dialogData.gs;
    vm.farm                             = dialogData.farm;
    vm.double_crop_bed_preparation_days = 0;
    vm.aux_seed_varieties_location      = [];

    // Methods
    vm.init                             = init;
    vm.closeDialog                      = closeDialog;
    vm.formatDate                       = formatDate;
    vm.formatDateForVariety             = formatDateForVariety;

    //////////
    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      if (vm.farm && vm.farm.double_crop_bed_preparation_days) {
        vm.double_crop_bed_preparation_days = vm.farm.double_crop_bed_preparation_days;
      }
      if (vm.gs && vm.gs.wet_date_variety_error) {
        var filteredVarieties = GeneralFunctionsService.filterVarietyDatesByLocation(vm.gs.variety, vm.gs.location_id);
        vm.aux_seed_varieties_location = filteredVarieties;
      }
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * [formatDate description]
     * @param  {[type]} date [description]
     * @return {[type]}
     */
    function formatDate(date) {
      return moment(date).format('MMM D, YYYY');
    }

    /**
     * [formatDate description]
     * @param  {[type]} date [description]
     * @return {[type]}
     */
    function formatDateForVariety(date) {
      return moment(date).format('MMM D');
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.grower-schedule.dialogs-planting-report', [])
    .controller('PlantingReportDialogController', PlantingReportDialogController);

  /** @ngInject */
  function PlantingReportDialogController(
    $mdDialog,
    $location,
    $mdToast,
    $filter,
    dialogData,
    UserService,
    moment
  ) {
    var vm = this;

    // Data
    vm.title              = (dialogData.title) ? dialogData.title : 'Planting Report Information';
    vm.planting_report    = {};
    vm.growerSchedules    = dialogData.growerSchedules;
    vm.gs                 = dialogData.gs;
    vm.pca_users          = [];
    vm.allSeasons         = dialogData.seasons;
    vm.showAllFields      = dialogData.showAllFields;

    // Methods
    vm.init               = init;
    vm.save               = save;
    vm.closeDialog        = closeDialog;

    //////////
    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      UserService.getList({role: 'pca'}).then(
        function (usersData) {
          vm.pca_users = usersData.users;
        },
        function (err) {
          console.error(err);
        }
      );
      // load block data
      if (vm.gs) {
        (vm.gs.bed_size)         ? vm.planting_report.bed_size = vm.gs.bed_size : null;
        (vm.gs.block_bed_count)  ? vm.planting_report.block_bed_count = vm.gs.block_bed_count : null;
        (vm.gs.plant_lines)      ? vm.planting_report.plant_lines = vm.gs.plant_lines : null;
        (vm.gs.pca_id)           ? vm.planting_report.pca_id = vm.gs.pca_id : null;

        if (vm.gs.scheduled_wet_date) {
          // Check Week Ending
          var next_saturday = moment(vm.gs.scheduled_wet_date).day('Saturday').hours(0);
          if (next_saturday) {
            vm.planting_report.week_ending = $filter('date')(next_saturday._d, 'mediumDate');
          }
          // Check Season
          angular.forEach(vm.allSeasons, function(season) {
            var season_start = new Date(season.start_day);
            var season_end = new Date(season.end_day);
            var wet_date = new Date(vm.gs.scheduled_wet_date);
            if (wet_date >= season_start && wet_date <= season_end) {
              vm.planting_report.season = season.name;
            }
          });
        }

      }
    }

    /**
     * [addBeds description]
     */
    function save() {
      vm.gs.bed_size = vm.planting_report.bed_size;
      vm.gs.plant_lines = vm.planting_report.plant_lines;
      vm.gs.pca_id = vm.planting_report.pca_id;
      if (vm.planting_report.block_bed_count) {
        vm.gs.block_bed_count = vm.planting_report.block_bed_count;
        vm.gs.acresPerBed = vm.gs.acres_in_block / vm.gs.block_bed_count;
        vm.gs.max_beds = vm.gs.acres_in_block / vm.gs.acresPerBed;
      }
      closeDialog();
    }
    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.contracts.dialogs-variety', [])
    .controller('ContractVarietyDialogController', ContractVarietyDialogController);

  /** @ngInject */
  function ContractVarietyDialogController(
    $mdDialog,
    $location,
    $mdToast,
    dialogData,
    $scope,
    SeedService,
    ContractScheduleVarietiesService,
    ContractService,
    GeneralFunctionsService,
    moment,
    _
  ) {
    var vm = this;
    // Data
    vm.title                      = (dialogData && dialogData.variety) ? 'Edit Variety Wet Date' : 'Add Variety Wet Date';
    // varieties wet dates
    vm.varieties_wet_dates        = (dialogData && dialogData.varieties_wet_dates) ? dialogData.varieties_wet_dates : [];
    // varieties from seed_id
    vm.varieties                  = [];
    vm.min_original_harvest_date  = null;
    vm.contract_schedule_variety  = (dialogData && dialogData.variety) ? dialogData.variety : '';

    vm.contract                   = (dialogData && dialogData.contract) ? dialogData.contract : '';
    vm.seed_id                    = (dialogData && dialogData.seed_id) ? dialogData.seed_id : null;
    vm.seed_name                  = (dialogData && dialogData.seed_name) ? dialogData.seed_name : '';
    vm.contract_schedule_id       = (dialogData && dialogData.contract_schedule_id) ? dialogData.contract_schedule_id : '';

    /**
     * Options for ng-model-options
     */
    vm.ngOptions = {
      updateOn: 'default',
      debounce: {
        default: 500
      }
    };

    $scope.aux = vm.contract_schedule_variety.acres;
    if (!vm.contract_schedule_variety) {
      vm.contract_schedule_variety  = {
        contract_schedule_id    : vm.contract_schedule_id,
        variety_id              : null,
        original_wet_date       : null,
        original_harvest_date   : null,
        original_growing_days   : null,
        acres                   : null
      };
    } else {
      if (vm.contract_schedule_variety.original_wet_date) {
        vm.min_original_harvest_date = new Date(vm.contract_schedule_variety.original_wet_date);
      }
    }
    // Methods
    vm.init                       = init;
    vm.saveVariety                = saveVariety;
    vm.closeDialog                = closeDialog;
    vm.setMinDate                 = setMinDate;
    vm.calculateGrowingDays       = calculateGrowingDays;
    vm.redirectToSeed             = redirectToSeed;

    var user = sessionStorage.getItem('user');
    vm.user = JSON.parse(user);

    $scope.customDateFormat = {
      formatDate: function(date) {
        var m = moment(date);
        return m.isValid() ? m.format('ll') : '';
      }
    };

    //////////

    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      if (vm.seed_id) {
        SeedService.getVarieties(vm.seed_id).then(function(varietiesData) {
          vm.varieties = varietiesData.varieties;
        },
        function(err) {
          console.error(err);
        });
      }
    }

    /**
     * Go to Seed page. It's called if there are no Varieties to show
     * @return {[type]} [description]
     */
    function redirectToSeed() {
      closeDialog();
      var data = [];
      data = {
        contract_id: vm.contract.id,
        contract_schedule_id: vm.contract_schedule_id,
        seed_id: vm.seed_id,
        seed_name: vm.seed_name
      };
      ContractScheduleVarietiesService.saveData(data);

      $location.url('/seed');
    }

    /**
     * [setMinDate description]
     */
    function setMinDate(field) {
      if (vm.contract_schedule_variety[field + '_wet_date']) {
        vm['min_' + field + '_harvest_date'] = vm.contract_schedule_variety[field + '_wet_date'];
        if (vm.contract_schedule_variety[field + '_harvest_date'] &&
          vm['min_' + field + '_harvest_date'] > new Date(vm.contract_schedule_variety[field + '_harvest_date'])) {
          vm.contract_schedule_variety[field + '_harvest_date'] = vm['min_' + field + '_harvest_date'].toISOString();
        }
      }
    }

    /**
     * Create or Update variety
     */
    function saveVariety() {
      if (vm.contract_schedule_variety.id) {
        ContractScheduleVarietiesService.update(vm.contract_schedule_variety.id, vm.contract_schedule_variety).then(
          function(response) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The variety wet date has been updated.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            var pos = _.findIndex(vm.varieties_wet_dates, {'id': response.contract_schedule_variety.id});
            if (response.contract_schedule_variety !== undefined &&  pos > -1) {
              // save old acres to check if they has changed, then call to update acres on contract and contract_schedule
              var old_acres = _.cloneDeep(vm.varieties_wet_dates[pos].acres);
              vm.varieties_wet_dates[pos] = response.contract_schedule_variety;
              if (old_acres !== response.contract_schedule_variety.acres) {
                setTimeout(function() {
                  updateLocalContractData();
                });
              }
              closeDialog();
            }
          },
          function(err) { //reject
            var error;
            if(err.status && err.status !== 500) {
              error = err.data.message;
            }
            $mdToast.show({
              template: '<md-toast class="md-toast error">The variety wet date could not be updated. ' + ((error !== undefined)? error : '') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          }
        );
      } else {
        ContractScheduleVarietiesService.create(vm.contract_schedule_variety).then(
          function(response) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The variety wet date has been created.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            response.contract_schedule_variety.growerScheduleData = null;
            vm.varieties_wet_dates.push(response.contract_schedule_variety);
            setTimeout(function() {
              updateLocalContractData();
              closeDialog();
            });
          },
          function(err) { //reject
            var error;
            if(err.status && err.status !== 500) {
              error = err.data.message;
            }
            $mdToast.show({
              template: '<md-toast class="md-toast error">The variety wet date could not be created. ' + ((error !== undefined)? error : '') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          }
        );
      }
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      setTimeout(function() {
        $mdDialog.hide();
      }, 1000);
    }

    /**
     * Update acres from Contract and Contract Schedule
     * @return {[type]}
     */
    function updateLocalContractData() {
      ContractService.get(vm.contract.id, {'exclude_related': 'contract_payment_schedule,company'}).then(
        function(response) {
          vm.contract.acres = response.contract.acres;
          var local_idx     = _.findIndex(vm.contract.contract_schedule, {id: dialogData.contract_schedule_id});
          var api_idx       = _.findIndex(response.contract.contract_schedule, {id: dialogData.contract_schedule_id});
          if (local_idx > -1 && api_idx > -1) {
            vm.contract.contract_schedule[local_idx].acres = response.contract.contract_schedule[api_idx].acres;
            if (response.contract && response.contract.total_amount_per_acre) {
              vm.contract.total_amount_per_acre = response.contract.total_amount_per_acre;
            }
            if (response.contract && response.contract.total_incentive_amount_per_acre) {
              vm.contract.total_incentive_amount_per_acre = response.contract.total_incentive_amount_per_acre;
            }
          }
        },
        function(err) {
          console.error(err);
        }
      );
    }

    /**
     * Calculate Estimated Wet Date, Estimated Harvest Date and Growing Days
     *
     * Requirement:
     * - Growing day should be between Estimated wet date and Estimated harvest date
     * - If those dates are set and Growing day change the harvest date should be calculated
     * - If harvest date and growing days are set estimated wet date should be calculated
     * - If estimated wet date and estimated harvest date are set, growing days should be calculated.
     *
     * @param  {[type]} field [description]
     * @return {[type]}
     */
    function calculateGrowingDays(field) {
      //Refresh ng-model-options after calculating
      if (field === 'growing_days') {
        var options = angular.extend(vm.ngOptions, {
          updateOn: 'default',
          debounce: {
            default: 0
          }
        });
        $scope.varietyForm.original_growing_days.$overrideModelOptions(options);
      }
      var res = GeneralFunctionsService.calculateGrowingDays(
        field,
        vm.contract_schedule_variety.original_wet_date,
        vm.contract_schedule_variety.original_harvest_date,
        vm.contract_schedule_variety.original_growing_days
      );
      if (res) {
        vm.contract_schedule_variety.original_wet_date      = res.wet_date;
        vm.contract_schedule_variety.original_harvest_date  = res.harvest_date;
        vm.contract_schedule_variety.original_growing_days  = res.growing_days;
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.contracts.dialogs-grower-dates', [])
    .controller('GrowerDatesDialogController', GrowerDatesDialogController);

  /** @ngInject */
  function GrowerDatesDialogController(dialogData, $mdDialog) {
    var vm = this;
    // Data
    var auxTitle    = (dialogData && dialogData.varietyName) ? dialogData.varietyName : '';
    vm.title        = 'Grower Schedule Dates ' + auxTitle;
    vm.growerDates      = (dialogData && dialogData.growerData) ? dialogData.growerData :  {};

  //  vm.growerDates= [];
  //  vm.growerDates.push(vm.growerData)

    // Methods
    vm.closeDialog  = closeDialog;
    //////////
    init();

    /**
     * Init function
     */
    function init() {

    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.contracts.dialogs-crop', [])
    .controller('CropDialogController', CropDialogController);

  /** @ngInject */
  function CropDialogController(
    $mdDialog,
    $location,
    $mdToast,
    dialogData,
    SeedService,
    AreaService,
    AreaFiscalYearService,
    ContractScheduleService,
    ContractService,
    _
  ) {
    var vm = this;

    // Data
    vm.title               = (dialogData && dialogData.crop) ? 'Edit Contracted Crop' : 'Add Contracted Crop';
    vm.locations           = [];
    vm.seeds               = [];
    vm.crops               = (dialogData && dialogData.crops) ? dialogData.crops : [];
    vm.crop                = (dialogData && dialogData.crop) ? dialogData.crop : '';

    // crop that is binded on table, if user clicks 'save', update it
    vm.original_crop       = (dialogData && dialogData.original_crop) ? dialogData.original_crop : '';
    vm.contract            = (dialogData && dialogData.contract) ? dialogData.contract : '';
    if (!vm.crop) {
      vm.crop = {
        contract_id         : (dialogData && dialogData.contract && dialogData.contract.id) ? dialogData.contract.id : '',
        location_id         : null,
        seed_id             : null,
        acres               : null,
        amount_per_acre     : null,
        incentive_amount_per_acre  : null,
        description         : ''
      };
    }
    var user              = sessionStorage.getItem('user');
    vm.user               = JSON.parse(user);

    // Methods
    vm.init               = init;
    vm.saveCrop           = saveCrop;
    vm.closeDialog        = closeDialog;

    //////////

    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      /* Get Area Id to filter Locations */
      if (vm.user && vm.user.default_global_area_fiscal_year_id) {
        AreaFiscalYearService.getAreaFiscalYear(vm.user.default_global_area_fiscal_year_id).then(function(areaFiscalYear) {
          var area_id = areaFiscalYear.area_fiscal_year.area_id;
          /* Get Area Locations */
          AreaService.getAreaLocations(area_id).then(function(locationsData) {
            vm.locations = locationsData.locations;
          },
          function(err) {
            console.error(err);
          });
        },
        function(err) {
          console.error(err);
        });
      }
      /* Get Seeds */
      SeedService.getAll().then(function(seedsData) {
        vm.seeds = seedsData.seeds;
      },
      function(err) {
        console.error(err);
      });
    }

    /**
     * Create or Update Crop
     */
    function saveCrop() {
      if (vm.crop.id) {
        // Edit Crop
        // Remove contract_schedule_varieties to make the request data smaller
        var dataToPut = angular.copy(vm.crop);
        if (dataToPut.contract_schedule_varieties) {
          delete dataToPut.contract_schedule_varieties;
        }
        ContractScheduleService.update(vm.crop.id, dataToPut).then(
          function(response) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The scheduled crop has been updated.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            var pos = _.findIndex(vm.crops, {'id': response.contract_schedule.id});
            if (response.contract_schedule !== undefined &&  pos > -1) {
              // avoid number as string error on form
              var aux = angular.copy(response.contract_schedule);
              vm.crops[pos] = aux;
              updateLocalContractData();
            }
            closeDialog();
          },
          function(err) { //reject
            var error;
            if(err.status && err.status !== 500) {
              error = err.data.message;
            }
            $mdToast.show({
              template: '<md-toast class="md-toast error">The scheduled crop could not be updated. ' + ((error !== undefined)? error : '') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          }
        );
      } else {
        // New Crop
        ContractScheduleService.create(vm.crop).then(
          function(response) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The scheduled crop has been created.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            vm.crops.push(response.contract_schedule);
            updateLocalContractData();
            closeDialog();
          },
          function(err) { //reject
            var error;
            if(err.status && err.status !== 500) {
              error = err.data.message;
            }
            $mdToast.show({
              template: '<md-toast class="md-toast error">The scheduled crop could not be created. ' + ((error !== undefined)? error : '') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          }
        );
      }
    }

    /**
     * Update amount and incentive amount from Contract
     * @return {[type]}
     */
    function updateLocalContractData() {
      ContractService.get(vm.contract.id, {'exclude_related': 'contract_payment_schedule,company'}).then(
        function(response) {
          if (response.contract && response.contract.total_amount_per_acre) {
            vm.contract.total_amount_per_acre = response.contract.total_amount_per_acre;
          }
          if (response.contract && response.contract.total_incentive_amount_per_acre) {
            vm.contract.total_incentive_amount_per_acre = response.contract.total_incentive_amount_per_acre;
          }
        },
        function(err) {
          console.error(err);
        }
      );
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.contracts.dialogs-contract', [])
    .controller('ContractDialogController', ContractDialogController);

  /** @ngInject */
  function ContractDialogController(
    $mdDialog,
    $location,
    $mdToast,
    dialogData,
    ContractService
  ) {
    var vm = this;

    // Data
    vm.payment_finance_terms = [];
    vm.shippers           = dialogData.shippers;
    vm.title              = 'New Contract';
    vm.contracts          = (dialogData.contracts) ? dialogData.contracts : [];
    vm.shownContracts     = (dialogData.shownContracts) ? dialogData.shownContracts : [];
    vm.starredContracts   = (dialogData.starredContracts) ? dialogData.starredContracts : [];
    vm.filterIds          = dialogData.filterIds;
    var user              = sessionStorage.getItem('user');
    vm.user               = JSON.parse(user);
    vm.contract = {
      area_fiscal_year_id : (vm.user && vm.user.default_global_area_fiscal_year_id) ? vm.user.default_global_area_fiscal_year_id: '',
      company_id          : '',
      number              : '',
      signature_date      : '',
      start_date          : '',
      end_date            : '',
      acres               : '',
      amount_per_acre     : '',
      payment_finance_terms : '',
      starred             : false,
      amount     : '',
      description         : '',
      incentive_amount    : ''
    };

    // Methods
    vm.init               = init;
    vm.addNewContract     = addNewContract;
    vm.closeDialog        = closeDialog;
    vm.toggleStarred      = toggleStarred;

    //////////

    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      // Get Payment Terms
      ContractService.getPaymentTerms().then(function(paymentTerms) {
        vm.payment_finance_terms = paymentTerms.payment_finance_terms;
      },
      function(err) {
        console.error(err);
      });
    }

    /**
     * Toggle Contract Starred
     */
    function toggleStarred() {
      vm.contract.starred = !vm.contract.starred;
    }

    /**
     * Add new contract
     */
    function addNewContract() {
      ContractService.create(vm.contract).then(
        function(data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The contract '+ vm.contract.number + ' has been created.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.contracts.push(data.contract);
          vm.shownContracts.push(data.contract);
          (data.contract.starred) ? vm.starredContracts.push(data.contract.id) : '';

          if(vm.filterIds.length) {
            vm.filterIds.push(data.contract.id);
          }
          closeDialog();
        },
        function(err) { //reject
          var error;
          if(err.status && err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The contract '+ vm.contract.number + ' could not be created. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        }
      );
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.pages.auth.login.dialogs', [])
    .controller('BackgroundController', BackgroundController);
    /** @ngInject */
  function BackgroundController($scope,
    $window,
    $state,
    $rootScope,
    $location,
    Upload,
    $mdToast,
    $mdDialog,
    $translate,
    dialogData,
    BackgroundService
    ) {

    var vm = this;

    //Data
    vm.background = dialogData.background;
    vm.changeBackground = dialogData.changeBackground;
    vm.backgroundAux = dialogData.backgroundAux;
    vm.saveBackground = saveBackground;
    vm.closeBackground = closeBackground;
    vm.openBackDialog = openBackDialog;
    vm.validateSizeImage = validateSizeImage;
    vm.invalidImage = invalidImage;
    vm.closeDialog = closeDialog;
    vm.sizeImg = {
      width: 1920,
      height: 1080
    };
    $scope.invalidFiles;
    //Functions

    /**
     * Save background
     */
    function saveBackground() {
      vm.background.save = true;
      var dataToPost = {
        upfile: vm.background.file
      };
      BackgroundService.uploadFile(dataToPost).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">Background has been saved</md-toast>',
          position: 'top right',
          hideDelay: 3000
        });
        $mdDialog.cancel();
        vm.closeDialog();
      },
      function (err) {
        vm.background.save = false;
        var error;
        if (err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">Background could not be loaded. ' + ((error) ? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 3000
        });
      });
    }
    /**
     * Close blackground without Save
     */
    function closeBackground() {
      vm.closeDialog();
    }
    /**
     * Invalid image
     */
    function invalidImage($files) {
      vm.imageInvalid = $files.filter(function (file) {
        return file.type != 'image/gif' && file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/bmp' && file.type != 'image/jpg' && file.type != 'image/jpe' && file.type != 'image/tiff' && file.type != 'image/ico';
      }).length > 0;
    }
    /**
     * Listen errors
     */
    $scope.$watch('invalidFiles', function() {
      if ($scope.invalidFiles) {
        vm.validateSizeImage();
      }
    });
    /**
     * Validate image
     * @param {*} file
     */
    function validateSizeImage() {
      if ($scope.invalidFiles.$error === 'minWidth' || $scope.invalidFiles.$error === 'minHeight') {
        $mdToast.show({
          template: '<md-toast class="md-toast error">Invalid size. Please, select a image greater than 1920x1080px</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      } else {
        $mdToast.show({
          template: '<md-toast class="md-toast error">Invalid image. Max file size 10MB</md-toast>',
          position: 'top right',
          hideDelay: 3000
        });
      }
    }
    /**
     * Open background crop dialog
     */
    function openBackDialog(ev, file) {
      if (!file) {
        vm.imageInvalid = true;
      }
      if (vm.imageInvalid) {
        vm.imageInvalid = false;
        return;
      }
      var reader = new FileReader();
      reader.readAsDataURL(file);
      vm.background.loaded = false;
      reader.onloadend = function () {
        vm.background.image_url = reader.result;
        vm.background.file = file;
        vm.background.loaded = true;
      };
    }
    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.work-template.dialog', [])
  .controller('WorkTemplateDialogController', WorkTemplateDialogController);

  /** @ngInject */
  function WorkTemplateDialogController($scope,
                                 $state,
                                 $location,
                                 $mdToast,
                                 $mdDialog,
                                 $translate,
                                 dialogData,
                                 WorkScheduleType,
                                 WorkTemplateService,
                                 LandService,
                                 msUtils) {
    var vm = this;
    var _ = window._;

    // Data
    vm.new_work_schedule_type = false;
    vm.allFields = false;
    vm.work_template = dialogData.work_template;
    vm.previousWT = _.cloneDeep(vm.work_template);
    vm.seasons = dialogData.seasons;
    vm.seeds = dialogData.seeds;
    vm.phase_types = dialogData.phase_types;
    vm.load = dialogData.load;
    vm.shownWorkTemplates = dialogData.shownWorkTemplates;
    vm.filterIds = dialogData.filterIds ;
    vm.workTemplates = dialogData.workTemplates;

    if (!vm.work_template.id) {
      vm.title = 'New Work Template';
      vm.new_work_template = true;
    }else{
      vm.title = 'Edit Work Template';
    }

    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.addNewWorkTemplate = addNewWorkTemplate;
    vm.editWT = editWT;
    vm.cancelDialog = cancelDialog;
    vm.openColorPicker = dialogData.openColorPicker;

    vm.getPhases = function () {
      return vm.work_schedule_types.filter(function (p) {
        return p.name !== vm.work_schedule_type.name;
      }).map(function (p) {
        return p.name;
      });
    };

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * Close dialog
     */
    function addNewWorkTemplate() {
      WorkTemplateService.save(vm.work_template).then(function (work_temaplate) {

        vm.shownWorkTemplates.push(work_temaplate);
        vm.filterIds.push(work_temaplate.id);
        vm.workTemplates.push(work_temaplate);

        $mdToast.show({
          template: '<md-toast class="md-toast success">The Work Template (' + vm.work_template.name + ') are created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        $mdDialog.hide();
      });
    }


    /**
     * edit dialog
     */
    function editWT() {
      WorkTemplateService.update(vm.work_template).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Task (' + vm.work_template.name + ') has been saved.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        $mdDialog.hide();
      });
    }

    /**
     * Cancel dialog
     */
    function cancelDialog() {
      _.assign(vm.work_template,vm.previousWT);
      vm.closeDialog();
    }


  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.clone-work-template.dialog', [])
  .controller('CloneWorkTemplateDialogController', CloneWorkTemplateDialogController);

  /** @ngInject */
  function CloneWorkTemplateDialogController($scope,
                                             $state,
                                             $location,
                                             $mdToast,
                                             $mdDialog,
                                             $document,
                                             $translate,
                                             dialogData,
                                             TaskService,
                                             WorkTemplateService,
                                             LandService,
                                             msUtils) {
    var vm = this;
    var _ = window._;


    vm.allFields = false;
    vm.work_template = dialogData.workTemplate;
    vm.work_templates = dialogData.workTemplates;
    vm.shownWorkTemplates = dialogData.shownWorkTemplates;
    vm.filterIds = dialogData.filterIds;
    vm.new_work_template = _.cloneDeep(vm.work_template);
    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;

    vm.cancelDialog = cancelDialog;
    vm.editTask = editTask;
    vm.clone = clone;

    vm.getPhases = function () {
      return vm.work_schedule_types.filter(function (p) {
        return p.name !== vm.work_schedule_type.name;
      }).map(function (p) {
        return p.name;
      });
    };


    vm.openColorPicker = function (ev, task) {
      $mdDialog.show({
        controller: 'PhaseColorPickerDialogController',
        controllerAs: 'vm',
        multiple: true,
        templateUrl: 'app/main/farm-admin/work-schedule-template/phase-type/dialog/color-picker-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            phase: task
          }
        }
      });
    };

    vm.getWorkTemplates = function () {
      return vm.work_templates.map(function (wt) {
        return wt.name;
      });
    };


    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }


    /**
     * Close dialog
     */
    function clone() {
      WorkTemplateService.save(vm.new_work_template).then(function (work_temaplate) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Work Template(' + vm.new_work_template.name + ') are created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.shownWorkTemplates.push(work_temaplate);
        vm.filterIds.push(work_temaplate.id);
        vm.work_templates.push(work_temaplate);
        $mdDialog.hide();

      });
    }


    /**
     * edit dialog
     */
    function editTask() {
      TaskService.update(vm.task).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Task (' + vm.task.name + ') has been saved.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        $mdDialog.hide();
      });
    }

    /**
     * Cancel dialog
     */
    function cancelDialog() {
      _.assign(vm.task, vm.previousTask);
      vm.closeDialog();
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.work-schedule-template.work-schedule-tasks.timeline-placeholders', [
      'xeditable'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.timeline-placeholders', {
      url      : '/timeline-placeholders',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/work-schedule-template/work-schedule-tasks/timeline-placeholders/timeline-placeholders.html',
          controller : 'TimelinePlaceholdersCtrl as vm'
        }
      },
      resolve  : {
        RolesData: function(apiResolver) {
          /**
           * if user is not super user - User Role "Super User" not loading
           */
          var user = JSON.parse(sessionStorage.getItem('user'));
          var admin = user.roles.findIndex(function (i)  { return i.name.toLowerCase() === 'super_user'; }) >= 0;
          if (admin === false) {
            return apiResolver.resolve('roles@get', { except: 10});
          } else {
            return apiResolver.resolve('roles@get');
          }
        },
        NotifyGroupsData: function(apiResolver) {
          return apiResolver.resolve('notify_groups@get');
        }
      },
      bodyClass: 'anchorTypeDefinition'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/work-schedule-template/work-schedule-tasks/timeline-placeholders');

    //Api
    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.work-schedule-template.work-schedule-tasks.timeline-placeholders', {
      title: 'Timeline Placeholders',
      icon : 'icon-format-list-bulleted',
      state: 'app.timeline-placeholders',
      weight: 26
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.work-schedule-tasks.timeline-placeholders')
  .controller('TimelinePlaceholdersCtrl', TimelinePlaceholdersCtrl);

  /** @ngInject */
  function TimelinePlaceholdersCtrl($q,
                                    $state,
                                    $scope,
                                    $timeout,
                                    $mdToast,
                                    $mdSidenav,
                                    $mdDialog,
                                    $document,
                                    $translate,
                                    $location,
                                    RolesData,
                                    NotifyGroupsData,
                                    RoleService,
                                    TaskService,
                                    CompanyService,
                                    UserService,
                                    AnchorTypeDefinitionService,
                                    NotifyGroupService,
                                    msUtils) {
    var vm = this;
    var _ = window._;

    vm.anchorDefinitions = [];
    vm.allRolesGroups = [];
    vm.allNotifyGroups = [];
    vm.selectedTasks = [];
    vm.starredTasks = [];
    vm.filterIds = [];
    vm.listType = 'all';
    vm.listOrder = 'name';
    vm.listOrderAsc = false;
    $scope.finishUpdate = true;
    vm.offset = 0;
    vm.shownTasks = [];
    vm.maxListLength = 20;

    $scope.loadingData = true;

    /**
     * Users role from API
     */
    if (RolesData && RolesData.roles) {
      vm.allRolesGroups = RolesData.roles.filter(function (ng) {
        return ng.name.toLowerCase().indexOf('foreman') != -1;
      });
    }
    /**
     * Users notify group from API
     */
    if (NotifyGroupsData && NotifyGroupsData.notify_groups) {
      //vm.allNotifyGroups = NotifyGroupsData.notify_groups;
      vm.allNotifyGroups = [
        {name: 'Tractor', id: 1},
        {name: 'Sprinkler', id: 2},
        {name: 'Irrigation', id: 3},
        {name: 'Planter', id: 4},
        {name: 'Harvest', id: 5}
      ];
    }


    vm.load = load;
    vm.filterChange = filterChange;
    vm.deleteUserConfirm = deleteUserConfirm;
    vm.deleteUser = deleteUser;
    vm.deleteSelectedTasks = deleteSelectedTasks;
    vm.toggleSelectTask = toggleSelectTask;
    vm.openTaskDialog = openTaskDialog;
    vm.deselectUsers = deselectUsers;
    vm.selectAllUsers = selectAllUsers;
    vm.deleteUser = deleteUser;
    vm.addNewNotifyGroup = addNewNotifyGroup;
    vm.addNewRoleGroup = addNewRoleGroup;
    vm.editNotifyGroup = editNotifyGroup;
    vm.editRoleGroup = editRoleGroup;
    vm.editGroup = editGroup;
    vm.deleteGroup = deleteGroup;
    vm.deleteNotifyGroup = deleteNotifyGroup;
    vm.deleteRoleGroup = deleteRoleGroup;
    vm.toggleSidenav = toggleSidenav;
    vm.patchStarred = patchStarred;
    vm.patchActive = patchActive;
    vm.patchNotifyGroup = patchNotifyGroup;
    vm.patchRoleGroup = patchRoleGroup;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.loadMore = loadMore;
    vm.getForemanName = getForemanName;
    vm.getFilteredRoles = getFilteredRoles;
    vm.addNewAnchorDefinition = addNewAnchorDefinition;
    vm.save = save;

    /* Call to funciton load as first thing */
    load();

    vm.changeWetDate = function (anchor) {

      if (anchor.wetDate) {
        vm.disableOtherAttrs(anchor, ['harvestDate', 'assignAnchorDate', 'preAnchor', 'postDate', 'repeats', 'display'], ['wetDate']);
      }

    };


    vm.changeHarvestDate = function (anchor) {

      if (anchor.harvestDate) {
        vm.disableOtherAttrs(anchor, ['wetDate', 'assignAnchorDate', 'preAnchor', 'postDate', 'repeats', 'display'], ['harvestDate']);
      }

    };


    vm.invalidForm = function () {
      var invalid = false;
      vm.anchorDefinitions.forEach(function (anchor) {
        if (vm.checkAttrAndOther(anchor, 'wetDate', ['harvestDate', 'assignAnchorDate', 'preAnchor', 'postDate', 'repeats', 'display']) || vm.checkAttrAndOther(anchor, 'harvestDate', ['wetDate', 'assignAnchorDate', 'preAnchor', 'postDate', 'repeats', 'display']) || vm.checkAttrAndOther(anchor, 'assignAnchorDate', ['wetDate', 'harvestDate', 'preAnchor', 'postDate', 'repeats']) || (anchor.assignAnchorDate && !anchor.display) || (anchor.preAnchor && !anchor.display) || (anchor.postAnchor && !anchor.display) || (anchor.preAnchor && anchor.postAnchor)) {
          invalid = true;
        }
      });


      return invalid || !$scope.anchorForm.$valid;
    };

    vm.checkAttrAndOther = function (anchor, attr, others) {
      var invalid = false;
      others.forEach(function (o) {
        if (anchor[o] && anchor[attr]) {
          invalid = true;
        }
      });

      return invalid;
    };


    vm.getWetDateAnchor = function () {
      return vm.anchorDefinitions.filter(function (a) {
        return a.wetDate;
      });
    };


    vm.getHarvestDateAnchor = function () {
      return vm.anchorDefinitions.filter(function (a) {
        return a.harvestDate;
      });
    };


    vm.getHarvestDateAnchor = function () {
      return vm.anchorDefinitions.filter(function (a) {
        return a.harvestDate;
      });
    };


    vm.disableOtherAttrs = function (anchor, attrs, except) {
      attrs.forEach(function (attr) {
        if (_.findIndex(except, attr) === -1) {
          anchor[attr] = false;
        }
      });
    };

    /**
     * [load description]
     * @return {[type]} [description]
     */
    function load() {
      $scope.loadingData = true;

      AnchorTypeDefinitionService.get().then(function (t) {
        vm.anchorDefinitions = t.definitions;

        vm.anchorDefinitions.forEach(function (anchor) {
          if (anchor.wetDate) {
            anchor.typeSelection = 'wetDate';
          } else if (anchor.harvestDate) {
            anchor.typeSelection = 'harvestDate';
          } else if (anchor.assignAnchorDate) {
            anchor.typeSelection = 'assignAnchorDate';
          } else if (anchor.preAnchor) {
            anchor.typeSelection = 'preAnchor';
          } else if (anchor.postDate) {
            anchor.typeSelection = 'postDate';
          } else {
            anchor.typeSelection = 'normal';
          }
        });

      });

      TaskService.getTasksWithOffset(vm.offset, vm.maxListLength).then(function (tasks) {
        vm.shownTasks = tasks;
        vm.shownTasks.forEach(function (task) {
          vm.filterIds.push(task.id);
          task.ng = [task.notify_group_id];
        });
        $scope.loadingData = false;
      });
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function getFilteredRoles() {
      return vm.allRolesGroups.filter(function (r) {

        return _.findIndex(vm.tasks, function (t) {
          return t.user_role_id == r.id;
        }) != -1;

      });
    }

    vm.checkRepeats = function (anchor) {
      if (!anchor.preAnchor && !anchor.postDate) {
        anchor.repeats = false;
      }
    };

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function save() {

      vm.anchorDefinitions.forEach(function (anchor) {
        anchor[anchor.typeSelection] = true;
        if (anchor.wetDate || anchor.harvestDate) {
          anchor.display = false;
        } else {
          anchor.display = true;
        }
      });


      AnchorTypeDefinitionService.update().then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Anchor definition has been updated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function loadMore() {
      vm.offset += vm.maxListLength;
      TaskService.getTasksWithOffset(vm.offset, vm.maxListLength).then(function (tasks) {
        if (tasks.length > 0) {
          vm.shownTasks = vm.shownTasks.concat(tasks);
          tasks.forEach(function (task) {
            vm.filterIds.push(task.id);
          });
        }
        else
          return;
      });
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function getForemanName(task) {
      var array = vm.allRolesGroups.filter(function (r) {
        return r.id == task.user_role_id;
      });

      if (array.length == 0) {
        return '';
      }

      return array.shift().name;
    }

    /**
     * Change Users List Filter
     * @param type
     */
    function openTaskDialog(ev, task) {


      $mdDialog.show({
        controller: 'TaskDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/work-schedule-template/work-schedule-tasks/task/dialog/task-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          dialogData: {
            task: task,
            tasks: vm.tasks,
            roles: vm.allRolesGroups,
            notifyGroups: vm.allNotifyGroups,
            filterIds: vm.filterIds,
            shownTasks: vm.shownTasks,
            updateTaskModel: updateTaskModel
          }
        }
      });
    }


    /**
     * Change Users List Filter
     * @param type
     */
    function filterChange(type, group_type) {
      $scope.groupType = group_type;
      vm.listType = type;
      if (type === 'all') {
        vm.filterIds = vm.shownTasks.map(function (w) {
          return w.id;
        });
      }
      else if (type === 'starred') {
        vm.filterIds = [];
        vm.filterIds = vm.starredTasks;
      }
      else if (angular.isObject(type) && group_type) {
        vm.filterIds = vm.tasks.filter(function (t) {
          return t.notify_group_id == type.id;
        }).map(function (t) {
          return t.id;
        });
      }
      else if (angular.isObject(type)) {
        vm.filterIds = vm.tasks.filter(function (t) {
          return t.user_role_id == type.id;
        }).map(function (t) {
          return t.id;
        });
      }
      vm.selectedTasks = [];
    }


    /**
     * Delete Contact Confirm Dialog
     */
    function deleteUserConfirm(user, ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + user.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete user')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteUser(user);
        vm.selectedContacts = [];
      }, function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Delete Contact
     */
    function deleteUser(user) {
      vm.users.splice(vm.users.indexOf(user), 1);
    }

    /**
     * Delete Selected Users
     */
    function deleteSelectedTasks(ev) {
      ev.preventDefault();
      var confirm = $mdDialog.confirm()
      .title($translate.instant('TASK.ARE_YOU_SURE_TO_DELETE_BULK'))
      .htmlContent('<b>' + vm.selectedTasks.length + ' selected</b>' + ' will be deleted.')
      .ariaLabel('delete tasks')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var arrIds = [];
        vm.selectedTasks.forEach(function (task) {
          arrIds.push(task.id);
        });
        TaskService.bulkDelete(arrIds).then(function () {

          arrIds.forEach(function (_id) {
            _.remove(vm.tasks, {
              id: _id
            });
          });

          vm.selectedTasks = [];
          $mdToast.show({
            template: '<md-toast class="md-toast success">The tasks were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The tasks could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }


    /**
     * Toggle selected status of the user
     *
     * @param user
     * @param event
     */
    function toggleSelectTask(task, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedTasks.indexOf(task) > -1) {
        vm.selectedTasks.splice(vm.selectedTasks.indexOf(task), 1);
      } else {
        vm.selectedTasks.push(task);
      }
    }

    /**
     * Deselect users
     */
    function deselectUsers() {
      vm.selectedTasks = [];
    }

    /**
     * Select all users
     */
    function selectAllUsers() {
      vm.selectedTasks = $scope.filteredUsers;
    }

    /**
     * Create a new notify-group associated to the user.
     */
    function addNewNotifyGroup() {
      if (vm.newGroupName2 === '') {
        return;
      }
      var newGroupData = {
        'name': vm.newGroupName2
      };
      /**
       * Call service to create a new notify-group associated to the user.
       */
      NotifyGroupService.create(newGroupData).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Notify Group ' + newGroupData.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.allNotifyGroups.push(data.notify_group);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + vm.newGroupName + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Create a new role-gropu associated to the user
     */
    function addNewRoleGroup() {
      if (vm.newGroupName === '') {
        return;
      }
      var newGroupData = {
        'name': vm.newGroupName,
        'work_schedule_role_yesno': 'false'
      };
      /**
       * Call service to create a new notify-group associated to the user.
       */
      RoleService.create(newGroupData).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Role Group ' + newGroupData.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.allRolesGroups.push(data.role);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + vm.newGroupName + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Edit group
     */
    function editGroup(ev, group) {
      vm.allNotifyGroups.forEach(function (notify_groups) {
        if (group.name === notify_groups.name) {
          editNotifyGroup(ev, group);
        }
      });
      vm.allRolesGroups.forEach(function (roles) {
        if (group.name === roles.name) {
          editRoleGroup(ev, group);
        }
      });
    }

    /**
     * Edit a notify group.
     *
     * @return {[type]} [description]
     */
    function editNotifyGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_EDIT_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be updated.')
      .ariaLabel('update group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to update a notify-group.
         */
        NotifyGroupService.update(group.id, group).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Handle cancel
      });
    }

    /**
     * Edit a role group.
     *
     * @return {[type]} [description]
     */
    function editRoleGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_EDIT_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be updated.')
      .ariaLabel('update group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to update a role.
         */
        RoleService.update(group.id, group).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Role Group ' + group.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Handle cancel
      });
    }

    /**
     * Delete Group
     */
    function deleteGroup(ev, group) {
      vm.allNotifyGroups.forEach(function (notify_groups) {
        if (group.name === notify_groups.name) {
          deleteNotifyGroup(ev, group);
        }
      });
      vm.allRolesGroups.forEach(function (roles) {
        if (group.name === roles.name) {
          deleteRoleGroup(ev, group);
        }
      });
    }

    /**
     * Delete Notify Group
     */
    function deleteNotifyGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to create a new notify-group associated to the user.
         */
        NotifyGroupService.delete(group.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.allNotifyGroups.splice(vm.allNotifyGroups.indexOf(group), 1);
        },
        function (err) {
          if (err.status === 409) {
            var confirm2 = $mdDialog.confirm()
            .title($translate.instant('USERS.ARE_YOU_SURE_WANT_TO_REMOVE_GROUP_RELATION'))
            .htmlContent('<h3>The group <b>' + group.name + '</b> cannot be deleted because there are other users related to it.\
              <br />Do you want to remove group relation from your user account?</h3> <b>' + group.name + '</b>' + ' relation will be removed from the user: <b>' + vm.user.name + '</b>')
            .ariaLabel('delete group relation')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm2).then(function () {
              UserService.removeUserNotifyGroupRelation(vm.user.id, group.id).then(function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' relation with user ' + vm.user.name + ' has been removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
                $state.go($state.current, {}, {reload: true});
              },
              function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">The group ' + group.name + ' relation could not be removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              });
            });
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Avoid unhandled call
      });
    }


    vm.checkAnchorType = function($event,anchor) {
      ['harvestDate', 'assignAnchorDate', 'preAnchor', 'postDate','wetDate','normal'].forEach(function(attr) {
        anchor[attr] = false;
      });

      anchor[anchor.typeSelection] = true;

    };

    vm.delete = function (ev, def) {

      var confirm = $mdDialog.confirm()
      .title($translate.instant('PHASE.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent($translate.instant('PHASE.CONFIRM_CONTENT'))
      .ariaLabel('delete anchor type type')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return AnchorTypeDefinitionService.delete(def);
      }).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Anchor type definition has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });

    };

    /**
     * Delete Role Group
     */
    function deleteRoleGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to create a new notify-group associated to the user.
         */
        RoleService.delete(group.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Role ' + group.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.allRolesGroups.splice(vm.allRolesGroups.indexOf(group), 1);
        },
        function (err) {
          if (err.status === 409) {
            var confirm2 = $mdDialog.confirm()
            .title($translate.instant('USERS.ARE_YOU_SURE_WANT_TO_REMOVE_GROUP_RELATION'))
            .htmlContent('<h3>The group <b>' + group.name + '</b> cannot be deleted because there are other users related to it.\
              <br />Do you want to remove group relation from your user account?</h3> <b>' + group.name + '</b>' + ' relation will be removed from the user: <b>' + vm.user.name + '</b>')
            .ariaLabel('delete group relation')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm2).then(function () {
              UserService.removeUserRoleRelation(vm.user.id, group.id).then(function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast success">The Role ' + group.name + ' relation with user ' + vm.user.name + ' has been removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
                $state.go($state.current, {}, {reload: true});
              },
              function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">The group ' + group.name + ' relation could not be removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              });
            });
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Avoid unhandled call
      });
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Function to patch starred user.
     *
     * @return {[type]} [description]
     */
    function patchStarred(task) {
      var starred = false;
      if (vm.starredTasks.indexOf(task.id) !== -1) {
        starred = true;
      }
      task.starred = starred;
      TaskService.update(task.id, {starred: starred.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The task ' + task.name + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The task ' + task.name + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Function to patch active user.
     *
     * @return {[type]} [description]
     */
    function patchActive(user) {
      UserService.patch(user.id, {active: user.active.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The user ' + user.name + ((user.active === true) ? ' has been activated.' : ' has been deactivated.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast error">The user ' + user.name + ' could not be activated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });

      });
    }

    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function patchNotifyGroup(task, group) {
      TaskService.update().then(function () {
        updateTaskModel(task, group);
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The task ' + task.name + 'has been updated </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }


    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function updateTaskModel(task, group) {
      if (vm.exists(group.id, task.ng)) {
        task.ng.splice(task.ng.indexOf(group.id), 1);
      } else {
        task.ng.push(group.id);
      }
    }


    /**
     * Patch User Role
     */
    function patchRoleGroup(task, group) {
      TaskService.update().then(function () {
        task.user_role_id = group.id;
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The task ' + task.name + 'has been updated </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }


    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function addNewAnchorDefinition() {
      vm.anchorDefinitions.push(
        {
          name: '',
          shortCode: '',
          wetDate: false,
          id: vm.anchorDefinitions.length + 10,
          harvestDate: false,
          assignAnchorDate: false,
          preAnchor: false,
          postDate: false,
          repeats: false,
          display: false
        }
      );
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.work-schedule-template.work-schedule-tasks.tasks', [
      'xeditable'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.tasks', {
      url      : '/tasks',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/work-schedule-template/work-schedule-tasks/task/task.html',
          controller : 'TaskCtrl as vm'
        }
      },
      resolve  : {
        RolesData: function(apiResolver) {
          /**
           * if user is not super user - User Role "Super User" not loading
           */
          var user = JSON.parse(sessionStorage.getItem('user'));
          var admin = user.roles.findIndex(function (i)  { return i.name.toLowerCase() === 'super_user'; }) >= 0;
          if (admin === false) {
            return apiResolver.resolve('roles@get', { except: 10});
          } else {
            return apiResolver.resolve('roles@get');
          }
        },
        NotifyGroupsData: function(apiResolver) {
          return apiResolver.resolve('notify_groups@get');
        }
      },
      bodyClass: 'tasks'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/work-schedule-template/work-schedule-tasks/task');

    //Api
    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.work-schedule-template.work-schedule-tasks.tasks', {
      title: 'Tasks',
      icon : 'icon-clipboard-check',
      state: 'app.tasks',
      weight: 26
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.work-schedule-tasks.tasks')
  .controller('TaskCtrl', TaskCtrl);

  /** @ngInject */
  function TaskCtrl($q,
                    $state,
                    $scope,
                    $timeout,
                    $mdToast,
                    $mdSidenav,
                    $mdDialog,
                    $document,
                    $translate,
                    $location,
                    RolesData,
                    NotifyGroupsData,
                    RoleService,
                    TaskService,
                    CompanyService,
                    UserService,
                    NotifyGroupService,
                    msUtils) {
    var vm = this;
    var _ = window._;

    vm.tasks = [];
    vm.allRolesGroups = [];
    vm.allNotifyGroups = [];
    vm.selectedTasks = [];
    vm.starredTasks = [];
    vm.filterIds = [];
    vm.listType = 'all';
    vm.listOrder = 'name';
    vm.listOrderAsc = false;
    $scope.finishUpdate = true;
    vm.offset = 0;
    vm.shownTasks = [];
    vm.maxListLength = 20;

    /**
     * Users role from API
     */
    if (RolesData && RolesData.roles) {
      vm.allRolesGroups = RolesData.roles.filter(function (ng) {
        return ng.name.toLowerCase().indexOf('foreman') != -1;
      });
    }
    /**
     * Users notify group from API
     */
    if (NotifyGroupsData && NotifyGroupsData.notify_groups) {
      //vm.allNotifyGroups = NotifyGroupsData.notify_groups;
      vm.allNotifyGroups = [
        {name: 'Tractor', id: 1},
        {name: 'Sprinkler', id: 2},
        {name: 'Irrigation', id: 3},
        {name: 'Planter', id: 4},
        {name: 'Harvest', id: 5}
      ];
    }


    vm.load = load;
    vm.filterChange = filterChange;
    vm.deleteUserConfirm = deleteUserConfirm;
    vm.deleteUser = deleteUser;
    vm.deleteSelectedTasks = deleteSelectedTasks;
    vm.toggleSelectTask = toggleSelectTask;
    vm.openTaskDialog = openTaskDialog;
    vm.deselectUsers = deselectUsers;
    vm.selectAllUsers = selectAllUsers;
    vm.deleteUser = deleteUser;
    vm.addNewNotifyGroup = addNewNotifyGroup;
    vm.addNewRoleGroup = addNewRoleGroup;
    vm.editNotifyGroup = editNotifyGroup;
    vm.editRoleGroup = editRoleGroup;
    vm.editGroup = editGroup;
    vm.deleteGroup = deleteGroup;
    vm.deleteNotifyGroup = deleteNotifyGroup;
    vm.deleteRoleGroup = deleteRoleGroup;
    vm.toggleSidenav = toggleSidenav;
    vm.patchStarred = patchStarred;
    vm.patchActive = patchActive;
    vm.patchNotifyGroup = patchNotifyGroup;
    vm.patchRoleGroup = patchRoleGroup;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.loadMore = loadMore;
    vm.getForemanName = getForemanName;
    vm.getFilteredRoles = getFilteredRoles;

    /* Call to funciton load as first thing */
    load();

    /**
     * [load description]
     * @return {[type]} [description]
     */
    function load() {
      $scope.loadingData = true;

      TaskService.get().then(function (t) {
        vm.tasks = t;
      });

      TaskService.getTasksWithOffset(vm.offset, vm.maxListLength).then(function (tasks) {
        vm.shownTasks = tasks;
        vm.shownTasks.forEach(function (task) {
          vm.filterIds.push(task.id);
          task.ng = [task.notify_group_id];
        });
        $scope.loadingData = false;
      });
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function getFilteredRoles() {
      return vm.allRolesGroups.filter(function (r) {

        return _.findIndex(vm.tasks, function (t) {
          return t.user_role_id == r.id;
        }) != -1;

      });
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function loadMore() {
      vm.offset += vm.maxListLength;
      TaskService.getTasksWithOffset(vm.offset, vm.maxListLength).then(function (tasks) {
        if (tasks.length > 0) {
          vm.shownTasks = vm.shownTasks.concat(tasks);
          tasks.forEach(function (task) {
            vm.filterIds.push(task.id);
          });
        }
        else
          return;
      });
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function getForemanName(task) {
      var array = vm.allRolesGroups.filter(function (r) {
        return r.id == task.user_role_id;
      });

      if (array.length == 0) {
        return '';
      }

      return array.shift().name;
    }

    /**
     * Change Users List Filter
     * @param type
     */
    function openTaskDialog(ev, task) {


      $mdDialog.show({
        controller: 'TaskDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/work-schedule-template/work-schedule-tasks/task/dialog/task-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          dialogData: {
            task: task,
            tasks: vm.tasks,
            roles: vm.allRolesGroups,
            notifyGroups: vm.allNotifyGroups,
            filterIds: vm.filterIds,
            shownTasks: vm.shownTasks,
            updateTaskModel: updateTaskModel
          }
        }
      });
    }


    /**
     * Change Users List Filter
     * @param type
     */
    function filterChange(type, group_type) {
      $scope.groupType = group_type;
      vm.listType = type;
      if (type === 'all') {
        vm.filterIds = vm.shownTasks.map(function (w) {
          return w.id;
        });
      }
      else if (type === 'starred') {
        vm.filterIds = [];
        vm.filterIds = vm.starredTasks;
      }
      else if (angular.isObject(type) && group_type) {
        vm.filterIds = vm.tasks.filter(function (t) {
          return t.notify_group_id == type.id;
        }).map(function (t) {
          return t.id;
        });
      }
      else if (angular.isObject(type)) {
        vm.filterIds = vm.tasks.filter(function (t) {
          return t.user_role_id == type.id;
        }).map(function (t) {
          return t.id;
        });
      }
      vm.selectedTasks = [];
    }


    /**
     * Delete Contact Confirm Dialog
     */
    function deleteUserConfirm(user, ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + user.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete user')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteUser(user);
        vm.selectedContacts = [];
      }, function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Delete Contact
     */
    function deleteUser(user) {
      vm.users.splice(vm.users.indexOf(user), 1);
    }

    /**
     * Delete Selected Users
     */
    function deleteSelectedTasks(ev) {
      ev.preventDefault();
      var confirm = $mdDialog.confirm()
      .title($translate.instant('TASK.ARE_YOU_SURE_TO_DELETE_BULK'))
      .htmlContent('<b>' + vm.selectedTasks.length + ' selected</b>' + ' will be deleted.')
      .ariaLabel('delete tasks')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var arrIds = [];
        vm.selectedTasks.forEach(function (task) {
          arrIds.push(task.id);
        });
        TaskService.bulkDelete(arrIds).then(function () {

          arrIds.forEach(function (_id) {
            _.remove(vm.tasks, {
              id: _id
            });
          });

          vm.selectedTasks = [];
          $mdToast.show({
            template: '<md-toast class="md-toast success">The tasks were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The tasks could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }


    /**
     * Toggle selected status of the user
     *
     * @param user
     * @param event
     */
    function toggleSelectTask(task, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedTasks.indexOf(task) > -1) {
        vm.selectedTasks.splice(vm.selectedTasks.indexOf(task), 1);
      } else {
        vm.selectedTasks.push(task);
      }
    }

    /**
     * Deselect users
     */
    function deselectUsers() {
      vm.selectedTasks = [];
    }

    /**
     * Select all users
     */
    function selectAllUsers() {
      vm.selectedTasks = $scope.filteredUsers;
    }

    /**
     * Create a new notify-group associated to the user.
     */
    function addNewNotifyGroup() {
      if (vm.newGroupName2 === '') {
        return;
      }
      var newGroupData = {
        'name': vm.newGroupName2
      };
      /**
       * Call service to create a new notify-group associated to the user.
       */
      NotifyGroupService.create(newGroupData).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Notify Group ' + newGroupData.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.allNotifyGroups.push(data.notify_group);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + vm.newGroupName + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Create a new role-gropu associated to the user
     */
    function addNewRoleGroup() {
      if (vm.newGroupName === '') {
        return;
      }
      var newGroupData = {
        'name': vm.newGroupName,
        'work_schedule_role_yesno': 'false'
      };
      /**
       * Call service to create a new notify-group associated to the user.
       */
      RoleService.create(newGroupData).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Role Group ' + newGroupData.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.allRolesGroups.push(data.role);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + vm.newGroupName + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Edit group
     */
    function editGroup(ev, group) {
      vm.allNotifyGroups.forEach(function (notify_groups) {
        if (group.name === notify_groups.name) {
          editNotifyGroup(ev, group);
        }
      });
      vm.allRolesGroups.forEach(function (roles) {
        if (group.name === roles.name) {
          editRoleGroup(ev, group);
        }
      });
    }

    /**
     * Edit a notify group.
     *
     * @return {[type]} [description]
     */
    function editNotifyGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_EDIT_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be updated.')
      .ariaLabel('update group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to update a notify-group.
         */
        NotifyGroupService.update(group.id, group).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Handle cancel
      });
    }

    /**
     * Edit a role group.
     *
     * @return {[type]} [description]
     */
    function editRoleGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_EDIT_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be updated.')
      .ariaLabel('update group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to update a role.
         */
        RoleService.update(group.id, group).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Role Group ' + group.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Handle cancel
      });
    }

    /**
     * Delete Group
     */
    function deleteGroup(ev, group) {
      vm.allNotifyGroups.forEach(function (notify_groups) {
        if (group.name === notify_groups.name) {
          deleteNotifyGroup(ev, group);
        }
      });
      vm.allRolesGroups.forEach(function (roles) {
        if (group.name === roles.name) {
          deleteRoleGroup(ev, group);
        }
      });
    }

    /**
     * Delete Notify Group
     */
    function deleteNotifyGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to create a new notify-group associated to the user.
         */
        NotifyGroupService.delete(group.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.allNotifyGroups.splice(vm.allNotifyGroups.indexOf(group), 1);
        },
        function (err) {
          if (err.status === 409) {
            var confirm2 = $mdDialog.confirm()
            .title($translate.instant('USERS.ARE_YOU_SURE_WANT_TO_REMOVE_GROUP_RELATION'))
            .htmlContent('<h3>The group <b>' + group.name + '</b> cannot be deleted because there are other users related to it.\
              <br />Do you want to remove group relation from your user account?</h3> <b>' + group.name + '</b>' + ' relation will be removed from the user: <b>' + vm.user.name + '</b>')
            .ariaLabel('delete group relation')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm2).then(function () {
              UserService.removeUserNotifyGroupRelation(vm.user.id, group.id).then(function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' relation with user ' + vm.user.name + ' has been removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
                $state.go($state.current, {}, {reload: true});
              },
              function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">The group ' + group.name + ' relation could not be removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              });
            });
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Avoid unhandled call
      });
    }

    /**
     * Delete Role Group
     */
    function deleteRoleGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to create a new notify-group associated to the user.
         */
        RoleService.delete(group.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Role ' + group.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.allRolesGroups.splice(vm.allRolesGroups.indexOf(group), 1);
        },
        function (err) {
          if (err.status === 409) {
            var confirm2 = $mdDialog.confirm()
            .title($translate.instant('USERS.ARE_YOU_SURE_WANT_TO_REMOVE_GROUP_RELATION'))
            .htmlContent('<h3>The group <b>' + group.name + '</b> cannot be deleted because there are other users related to it.\
              <br />Do you want to remove group relation from your user account?</h3> <b>' + group.name + '</b>' + ' relation will be removed from the user: <b>' + vm.user.name + '</b>')
            .ariaLabel('delete group relation')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm2).then(function () {
              UserService.removeUserRoleRelation(vm.user.id, group.id).then(function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast success">The Role ' + group.name + ' relation with user ' + vm.user.name + ' has been removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
                $state.go($state.current, {}, {reload: true});
              },
              function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">The group ' + group.name + ' relation could not be removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              });
            });
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Avoid unhandled call
      });
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Function to patch starred user.
     *
     * @return {[type]} [description]
     */
    function patchStarred(task) {
      var starred = false;
      if (vm.starredTasks.indexOf(task.id) !== -1) {
        starred = true;
      }
      task.starred = starred;
      TaskService.update(task.id, {starred: starred.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The task ' + task.name + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The task ' + task.name + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Function to patch active user.
     *
     * @return {[type]} [description]
     */
    function patchActive(user) {
      UserService.patch(user.id, {active: user.active.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The user ' + user.name + ((user.active === true) ? ' has been activated.' : ' has been deactivated.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast error">The user ' + user.name + ' could not be activated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });

      });
    }

    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function patchNotifyGroup(task, group) {
      TaskService.update().then(function () {
        updateTaskModel(task, group);
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The task ' + task.name + 'has been updated </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }


    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function updateTaskModel(task, group) {
      if (vm.exists(group.id, task.ng)) {
        task.ng.splice(task.ng.indexOf(group.id), 1);
      } else {
        task.ng.push(group.id);
      }
    }


    /**
     * Patch User Role
     */
    function patchRoleGroup(task, group) {
      TaskService.update().then(function () {
        task.user_role_id = group.id;
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The task ' + task.name + 'has been updated </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.phase-types.dialog', [])
  .controller('PhaseDialogController', PhaseDialogController);

  /** @ngInject */
  function PhaseDialogController($scope,
                                 $state,
                                 $location,
                                 $mdToast,
                                 $mdDialog,
                                 $translate,
                                 dialogData,
                                 WorkScheduleType,
                                 LandService,
                                 msUtils) {
    var vm = this;

    // Data
    vm.work_schedule_types = dialogData.work_schedule_types;
    vm.work_schedule_type = dialogData.work_schedule_type;
    vm.new_work_schedule_type = false;
    vm.allFields = false;

    if (!vm.work_schedule_type) {
      vm.work_schedule_type = {
        'name': '',
        'description': '',
      };
      vm.title = 'New Phase';
      vm.new_work_schedule_type = true;
    }

    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.addNewWorkScheduleType = addNewWorkScheduleType;

    vm.getPhases = function () {
      return vm.work_schedule_types.filter(function (p) {
        return p.name !== vm.work_schedule_type.name;
      }).map(function (p) {
        return p.name;
      });
    };

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * Close dialog
     */
    function addNewWorkScheduleType() {
      WorkScheduleType.save(vm.work_schedule_type).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Phase Type (' + vm.work_schedule_type.name + ') are created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        $mdDialog.hide();
      });
    }


  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.phase-name.dialog', [])
  .controller('PhaseNameDialogController', PhaseNameDialogController);

  /** @ngInject */
  function PhaseNameDialogController($scope,
                                     $state,
                                     $location,
                                     $mdToast,
                                     $mdDialog,
                                     $translate,
                                     dialogData,
                                     PhaseService,
                                     LandService,
                                     msUtils) {
    var vm = this;

    // Data
    vm.phases = dialogData.phases;
    vm.phase = dialogData.phase;
    vm.new_phase = false;
    vm.allFields = false;

    vm.getPhases = function (phase) {
      return vm.phases.filter(function (p) {
        return p.name !== phase.name;
      }).map(function (p) {
        return p.name;
      });
    };

    if (!vm.phase) {
      vm.phase = {
        'name': '',
        'description': '',
        'work_schedule_type_id': dialogData.work_type_id,
        'color': PhaseService.generateColor()
      };
      vm.title = 'New Phase';
      vm.new_phase = true;
    }

    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.addNewPhase = addNewPhase;
    vm.openColorPicker = dialogData.openColorPicker;

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }


    /**
     * Close dialog
     */
    function addNewPhase() {
      PhaseService.save(vm.phase).then(function () {
        vm.phases.push(vm.phase);
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Phase Name (' + vm.phase.name + ') are created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        $mdDialog.hide();
      });
    }




  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.phase-name.color-picker-dialog', [])
  .controller('PhaseColorPickerDialogController', PhaseColorPickerDialogController);

  /** @ngInject */
  function PhaseColorPickerDialogController($mdDialog,
                                            dialogData) {
    var vm = this;

    vm.phase = dialogData.phase;
    vm.previousColor = vm.phase.color;

    vm.saveDialog = function () {
      $mdDialog.hide();
    };


    vm.cancel = function () {
      vm.phase.color = vm.previousColor;
      $mdDialog.hide();
    };

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.subleases', ['infinite-scroll', 'ms-resize'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_subleases', {
      url      : '/subleases',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/subleases/subleases.html',
          controller : 'SubleasesCtrl as vm'
        }
      },
      bodyClass: 'subleases',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('subleases')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_subleases_edit', {
      url      : '/subleases/edit/:id/:tab',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/subleases/tabs/tabs.html',
          controller : 'SubleasesTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('subleases')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_subleases_add', {
      url      : '/subleases/add',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/subleases/tabs/tabs.html',
          controller : 'SubleasesTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('subleases')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation Subleases
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/land/subleases');
    // Translation Subleases edit
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/land/subleases/tabs');

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.land.subleases', {
      title : 'Subleases',
      icon  : 'icon-satellite',
      state : 'app.farm-admin_subleases',
      weight: 31
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.subleases')
    .controller('SubleasesTabsCtrl', SubleasesTabsCtrl);

  /** @ngInject */
  function SubleasesTabsCtrl(
    $q,
    $location,
    $filter,
    $mdToast,
    SubleaseService,
    SubleasePaymentScheduleService,
    AreaFiscalYearService,
    CompanyService,
    $stateParams,
    api,
    $rootScope,
    $state
  ) {
    var vm                  = this;
    vm.paymentTerms         = [];
    vm.service              = SubleaseService;
    vm.paymentService       = SubleasePaymentScheduleService;
    vm.isLease              = false;
    vm.entity               = 'sublease';
    vm.informationForm              = {};
    vm.informationForm.$pristine    = true;
    vm.informationForm.$invalid     = true;
    vm.paymentsForm = {};
    vm.paymentsForm.$pristine     = true;
    vm.paymentsForm.$invalid      = true;
    vm.paymentsUpdated          = [];
    vm.paymentUpdated             = false;
    vm.error                      = undefined;
    vm.area_id                    = null;

    var user = sessionStorage.getItem('user');
    if(user) {
      vm.user = JSON.parse(user);
      var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;
      AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function(areaFiscalYearData) {
        vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
      });
    }

    $rootScope.$on('informationForm', function(event, data) {
      vm.informationForm = data;
    });

    $rootScope.$on('paymentsForm', function(event, data, paymentsUpdated) {
      vm.paymentsUpdated = paymentsUpdated;
      vm.paymentsForm = data;
    });


    // Methods
    vm.init                  = init;
    vm.tabsSave              = tabsSave;
    vm.parseObject           = parseObject;
    vm.backListing           = backListing;
    vm.convertAmountToNumber = convertAmountToNumber;
    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      /* Get Sublease */
      if ($stateParams.id) {
        api.subleases.get({ id: $stateParams.id }, function(SubleaseData) {
          if(SubleaseData && SubleaseData.sublease) {
            if(SubleaseData && SubleaseData.sublease && SubleaseData.sublease.amount_per_acre) {
              SubleaseData.sublease.amount_per_acre = convertAmountToNumber(SubleaseData.sublease.amount_per_acre);
            }
            vm.sublease = SubleaseData.sublease;
            vm.sublease.newSublease = false;
          }
        },
        function(err) {
          console.error(err);
        });
      }
      else{
        vm.sublease = {
          sublease_number: '',
          tenant_company_id: '',
          signature_date: '',
          start_date: '',
          end_date: '',
          acres: 0,
          amount_per_acre: '',
          payment_terms: '',
          starred: '',
          description:  '',
          newSublease: true
        };
      }

      vm.selectedTab = $state.params.tab;
    }
    /**
     * Go to subleases page
     * @return {[type]} [description]
     */
    function backListing () {
      $location.url('/subleases');
    }
    /**
     * Function to save each tab information.
     * @return {[type]} [description]
     */
    function tabsSave() {
      if (vm.sublease.id) {
        var promises  = [];
        vm.paymentsUpdated.forEach(function(payment) {
          promises.push(
            SubleasePaymentScheduleService.update(payment.id, payment).then(function() {
            }).catch(function(error) {
              vm.error=error.data.message;
            })
          );
        });

        Promise.all(promises).then(function() {
          if(vm.error === undefined) {
            SubleaseService.update(vm.sublease.id, vm.parseObject(vm.sublease)).then(function(data) {
              $mdToast.show({
                template: '<md-toast class="md-toast success">All sublease information has been updated successfully.</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });
              vm.sublease=data.sublease;
            },
            function (err)  {
              var error;
              if(err.status !== 500) {
                error = err.data.message;
              }
              $mdToast.show({
                template: '<md-toast class="md-toast error">The sublease information could not be updated.' + ((error !== undefined)? error : '') + '</md-toast>',
                position: 'top right',
                hideDelay: 6000
              });
            });
          }
          else {
            $mdToast.show({
              template: '<md-toast class="md-toast error">Payment Schedules could not be updated. </md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          }
        });
      } else {
        /**
        * Create new sublease
        */
        SubleaseService.create(vm.parseObject(vm.sublease)).then(function (data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The sublease '+ data.sublease.sublease_number + ' has been created.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          $location.url('/subleases/edit/' + data.sublease.id + '/' + 0);
         /* if(vm.filterIds.length>0) {
            vm.filterIds.push(data.lease.id);
          }*/
        },
        function(err) { //reject
          var error;
          if(err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The sublease could not be created. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      }
    }
    /**
     * Function to parse object if needed.
     * @param  {[type]} sublease [description]
     * @return {[type]}       [description]
     */
    function parseObject(sublease) {
      var signature_date_temp = new Date(sublease.signature_date).setHours(9);
      sublease.signature_date = new Date(signature_date_temp).toISOString();
      var start_date_temp = new Date(sublease.start_date).setHours(9);
      sublease.start_date = new Date(start_date_temp).toISOString();
      var end_date_temp = new Date(sublease.end_date).setHours(9);
      sublease.end_date = new Date(end_date_temp).toISOString();
      if (vm.sublease.id) {
        return {
          sublease_number: sublease.sublease_number,
          tenant_company_id: sublease.tenant_company_id,
          signature_date: sublease.signature_date,
          start_date: sublease.start_date,
          end_date: sublease.end_date,
          amount_per_acre: sublease.amount_per_acre,
          payment_terms: sublease.payment_terms,
          description: sublease.description,
          starred: sublease.starred,
          id: sublease.id,
          area_id: vm.area_id
        };
      } else {
        return {
          sublease_number: sublease.sublease_number,
          tenant_company_id: sublease.tenant_company_id,
          signature_date: sublease.signature_date,
          start_date: sublease.start_date,
          end_date: sublease.end_date,
          amount_per_acre: sublease.amount_per_acre,
          payment_terms: sublease.payment_terms,
          description: sublease.description,
          starred: sublease.starred,
          area_id: vm.area_id
        };
      }
    }
    /**
     * Convert amount money to number
     * @param  {[type]} amount [description]
     * @return {[type]}        [description]
     */
    function convertAmountToNumber(amount) {
      var amount_number = amount.replace('$', '');
      amount_number = amount_number.replace(',', '');
      return parseFloat(amount_number);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.ranches', [
      'datatables',
      // 3rd Party Dependencies
      'uiGmapgoogle-maps',
      'ms-infinite-scroll',
      'ms-resize'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider, uiGmapGoogleMapApiProvider) {
    // Google Map
    uiGmapGoogleMapApiProvider.configure({
      key: 'AIzaSyAcFNeZxPpnL7cYXbCjuGUEBgQk4495ttE'
    });

    // State
    $stateProvider.state('app.farm-admin_ranches', {
      url      : '/ranches',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/ranches/ranches.html',
          controller : 'RanchesCtrl as vm'
        }
      },
      bodyClass: 'ranches',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('ranches')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_ranches_from_page', {
      url      : '/ranches/from_page/:location_id/:page_name/:entity_id',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/ranches/ranches.html',
          controller : 'RanchesCtrl as vm'
        }
      },
      bodyClass: 'ranches',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('ranches')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_ranches_edit', {
      url      : '/ranches/edit/:id',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/ranches/tabs/tabs.html',
          controller : 'RanchesTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('ranches')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_ranches_add', {
      url      : '/ranches/add',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/ranches/tabs/tabs.html',
          controller : 'RanchesTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('ranches')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_ranches_add_filtered', {
      url      : '/ranches/add/location_id/:location_id',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/ranches/tabs/tabs.html',
          controller : 'RanchesTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('ranches')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/land/ranches');
    // Translation edit
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/land/ranches/tabs');

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.land.ranches', {
      title : 'Ranches',
      icon  : 'icon-view-dashboard',
      state : 'app.farm-admin_ranches',
      weight: 28
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.ranches')
    .controller('RanchesTabsCtrl', RanchesTabsCtrl);

  /** @ngInject */
  function RanchesTabsCtrl(
    $q,
    $location,
    $filter,
    $mdToast,
    $state,
    RanchService,
    uiGmapGoogleMapApi,
    uiGmapIsReady,
    $stateParams,
    api,
    AreaFiscalYearService,
    AreaService,
    msApi,
    _
  ) {
    var vm                  = this;
    var google              = null;

    vm.ranch              = [];
    vm.locations          = [];
    vm.simpleMarkerMap    = {};
    vm.map                = {};
    vm.entity             = 'ranch';
    vm.water_districts    = [];
    vm.saveDisabled       = true;
    vm.location_name      = null;
    vm.location_id        = parseInt($state.params.location_id) || null;
    vm.states             = [];
    vm.informationForm    = {};

    // Methods
    vm.init                 = init;
    vm.tabsSave             = tabsSave;
    vm.backListing          = backListing;
    vm.parseObject          = parseObject;
    vm.updateName           = updateName;
    vm.goToLand             = goToLand;
    vm.setShortCode         = setShortCode;
    vm.setRanchName         = setRanchName;
    vm.searchTextChangeState = searchTextChangeState;
    vm.selectedStateChange  = selectedStateChange;
    vm.queryState           = queryState;
    vm.createFilterFor      = createFilterFor;
    vm.addRanch             = addRanch;
    vm.setStarred           = setStarred;
    vm.setActive            = setActive;

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init () {
      var user = sessionStorage.getItem('user');
      if(user) {
        vm.user = JSON.parse(user);
        var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;
        AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function(areaFiscalYearData) {
          var area_id = areaFiscalYearData.area_fiscal_year.area_id;
          AreaService.getAreaLocations(area_id).then(function(locationsData) {
            vm.locations = locationsData.locations;
            if(vm.location_id) {
              vm.ranch.section_name = '';
              vm.ranch.location_short_code = '';
              vm.ranch.location_id = vm.location_id;
              vm.locations.forEach(function(location) {
                if(location.id === vm.location_id) {
                  vm.ranch.location_short_code = location.location_short_code;
                }
              });
              setRanchName();
            }
          },
          function(err) {
            console.error(err);
          });
         //Uncomment following line when there are records of water districts with area set
          //api.water_districts.get({area_id: $stateParams.area_id}, function(WaterDistricts) {
          api.water_districts.get({}, function(WaterDistricts) {
            if(WaterDistricts && WaterDistricts.water_districts) {
              vm.water_districts = WaterDistricts.water_districts;
            }
          });

        },
        function(err) {
          console.error(err);
        });
      }

      if ($stateParams.id) {
        api.ranches.get({ id: $stateParams.id }, function(RanchData) {
          if(RanchData && RanchData.ranch) {
            vm.ranch = RanchData.ranch;

            api.locations.get({ id: vm.ranch.location_id }, function(LocationData) {
              if(LocationData && LocationData.location) {
                vm.location_name = LocationData.location.name;
              }
            });
            //cast for input number
            vm.ranch.latitude = vm.ranch.latitude ? Number(vm.ranch.latitude) : 32.680996;
            vm.ranch.longitude = vm.ranch.longitude ? Number(vm.ranch.longitude) : -114.631348;
            if(!vm.ranch.zoom) {
              vm.ranch.zoom = 9;
            }
          }
        });
      } else {
        vm.ranch.location_short_code = '';
        vm.ranch.section_name = '';
      }

      msApi.request('states@get',
        function (statesInfo) {
          vm.states = statesInfo.states;
        },
        function (err) {
          console.error(err);
        });

      // TODO: add necessary data for initialize
      setTimeout(function() {
        initMap();}, 1000);

    }

    /**
     * Go to ranches page
     * @return {[type]} [description]
     */
    function backListing () {
      $location.url('/ranches');
    }
    /**
     * Function to save each tab information.
     * @return {[type]} [description]
     */
    function tabsSave () {
      if (!vm.ranch.starred) {
        vm.ranch.starred = false;
      }
      if (!vm.ranch.active) {
        vm.ranch.active = false;
      }
      if((!vm.ranch.zoom && !vm.ranch.latitude && !vm.ranch.longitude)
        || (vm.ranch.zoom && vm.ranch.latitude && vm.ranch.longitude)) {
        if (vm.ranch.id) {
          RanchService.update(vm.ranch.id, parseObject(vm.ranch)).then(function (data) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The ranch '+ vm.ranch.name + ' has been updated.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });

            vm.ranch = data.ranch;
            initMap();
          },
        function() { // Reject
          $mdToast.show({
            template: '<md-toast class="md-toast error">The ranch '+ vm.ranch.name + ' could not be updated.</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
        }
        else {
          /**
           * Create new ranch
           */
          RanchService.create(parseObject(vm.ranch)).then(function (data) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The ranch '+ data.ranch.name + ' has been created.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            vm.ranch = data.ranch;
            initMap();
            $location.url('/ranches/edit/' + data.ranch.id);
          },
          function(err) { //reject
            var error;
            if(err.status !== 500) {
              if(err.data.info) {
                error = err.data.info.name;
              }
              else {
                error = err.data.message;
              }
            }
            $mdToast.show({
              template: '<md-toast class="md-toast error">The ranch could not be created, ' + ((error !== undefined)? error : '') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          });
        }
      }
      else {
        $mdToast.show({
          template: '<md-toast class="md-toast error">All Geolocation fields must be completed',
          position: 'top right',
          hideDelay: 6000
        });
      }
    }


    /**
     * Google Map settings and marker
     * @return void
     */
    function initMap () {
      uiGmapIsReady.promise(1).then(function(instances) {
        instances.forEach(function(inst) {
          vm.map = inst.map;
        });
      });
      /* http://angular-ui.github.io/angular-google-maps/#!/api/google-map
       * https://developers.google.com/maps/documentation/javascript/reference#MapOptions
       */
      uiGmapGoogleMapApi.then(function () {

        vm.simpleMarkerMap = {
          center: {
            latitude : vm.ranch.latitude ||  38.959409,
            longitude:  vm.ranch.longitude ||  -94.482422
          },
          options: {
            maxZoom: 18,
            minZoom: 3,
            mapTypeId: 'hybrid'
          },
          zoom: vm.ranch.zoom || 9,
          dragging: true,
          marker: {
            id     : 0,
            coords : {
              latitude : vm.ranch.latitude || 38.959409,
              longitude:  vm.ranch.longitude ||  -94.482422
            },

            icon: 'assets/angular-material-assets/img/icons/ic_place_24px.svg'
          },


          events: {
            click: function(map, ranchEvent, originalEvent) {
              //update or leave the same
              vm.ranch.latitude   = (originalEvent[0] && originalEvent[0].latLng.lat()) ? Number(originalEvent[0].latLng.lat()) : Number(vm.ranch.latitude);
              vm.ranch.longitude  = (originalEvent[0] && originalEvent[0].latLng.lng()) ? Number(originalEvent[0].latLng.lng()) : Number(vm.ranch.longitude);
              vm.ranch.zoom       = vm.map.getZoom() ? vm.map.getZoom() : vm.ranch.zoom;
              vm.saveDisabled = false;

              //update map point
              vm.simpleMarkerMap.marker.coords = {
                latitude : vm.ranch.latitude,
                longitude: vm.ranch.longitude
              };

              if(google && google.maps) {
                vm.map.setCenter(new google.maps.LatLng(vm.ranch.latitude,vm.ranch.longitude));
              }
            },
            zoom_changed: function() {
              vm.ranch.zoom       = vm.map.getZoom() ? vm.map.getZoom() : vm.ranch.zoom;
              vm.saveDisabled = false;
            },

          }
        };
        google.maps.event.addListener(vm.map, 'zoom_changed', function () {
          if (vm.map.getZoom() > 18) vm.map.setZoom(18);
        });

        //vm.map.setCenter(new google.maps.LatLng(vm.ranch.latitude,vm.ranch.longitude));
        if (vm.ranch.latitude!==undefined && vm.ranch.longitude!==undefined
          && vm.ranch.latitude!=='' && vm.ranch.longitude!=='') {
           //Check geolocation and create marker
          vm.simpleMarkerMap.marker = {
            id     : 0,
            coords : {
              latitude : Number(vm.ranch.latitude),
              longitude: Number(vm.ranch.longitude)
            },

          };
          vm.simpleMarkerMap.center = {
            latitude : Number(vm.ranch.latitude),
            longitude: Number(vm.ranch.longitude)
          };

          vm.simpleMarkerMap.zoom = vm.ranch.zoom || 9;
        }


      });

    }

    /**
     * Function to parse object if needed.
     * @param  {Object} ranch
     * @return {Object} ranch structure
     */
    function parseObject (ranch) {
      if(vm.ranch.id) {
        return {
          id                    : ranch.id,
          active                : ranch.active?ranch.active.toString():'false',
          starred               : ranch.starred?ranch.starred.toString():'false',
          name                  : ranch.name,
          section_name          : ranch.section_name,
          location_short_code   : ranch.location_short_code,
          location_id           : ranch.location_id,
          latitude              : ranch.latitude,
          longitude             : ranch.longitude,
          zoom                  : ranch.zoom,
          address1              : ranch.address1,
          city                  : ranch.city,
          state                 : ranch.state,
          zipcode               : ranch.zipcode,
          township              : ranch.township,
          range                 : ranch.range,
          water_district_id     : ranch.water_district_id
        };
      }
      else {
        return {
          active                : ranch.active?ranch.active.toString():'false',
          starred               : ranch.starred?ranch.starred.toString():'false',
          name                  : ranch.name,
          section_name          : ranch.section_name,
          location_short_code   : ranch.location_short_code,
          location_id           : ranch.location_id,
          latitude              : ranch.latitude,
          longitude             : ranch.longitude,
          zoom                  : ranch.zoom,
          address1              : ranch.address1,
          city                  : ranch.city,
          state                 : ranch.state,
          zipcode               : ranch.zipcode,
          township              : ranch.township,
          range                 : ranch.range,
          water_district_id     : ranch.water_district_id
        };
      }
    }

    /**
     * Update ranch name
     * @return {[type]} [description]
     */
    function updateName() {
      vm.ranch.name = vm.ranch.location_short_code + vm.ranch.section_name;
    }

    /**
     * Go to Locations page
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    function goToLand() {
      $location.url('/land');
    }

        /**
     * Set short code
     * @param {[type]} shortCode [description]
     */
    function setShortCode(shortCode) {
      vm.ranch.location_short_code = shortCode;
    }

    /**
     * [setRanchName description]
     */
    function setRanchName() {
      vm.ranch.name = vm.ranch.location_short_code + vm.ranch.section_name;
    }

        /**
     /**
     * queryState
     */
    function queryState(query) {
      var results = query ? _.map(_.filter(vm.states, vm.createFilterFor(query)), function (elem) {
        return elem.name;
      }) : _.map(vm.states, function (elem) {
        return elem.name;
      });

      return _.values(results);
    }

        /**
     /**
     * createFilterFor
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.name.toLowerCase().indexOf(lowercaseQuery) === 0);
      };

    }

        /**
     /**
     * searchTextChangeState
     */
    function searchTextChangeState(text) {
      vm.ranch.state = text;
    }

    /**
     /**
     * selectedStateChange
     */
    function selectedStateChange() {
    }

    /**
     * Load add page for given ranch
     * @param  {[type]} ev    [description]
     * @return {[type]}       [description]
     */
    function addRanch() {
      $location.url('/ranches/add/location_id/' + vm.ranch.location_id);
    }

    /**
     * [setStarred description]
     */
    function setStarred() {
      vm.informationForm.$pristine = false;
      vm.ranch.starred = !vm.ranch.starred;
    }


    /**
     * [setActive description]
     */
    function setActive() {
      vm.informationForm.$pristine = false;
      vm.ranch.active = !vm.ranch.active;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.leases', ['ms-infinite-scroll', 'ms-resize'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_leases', {
      url      : '/leases',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/leases/leases.html',
          controller : 'LeasesCtrl as vm'
        }
      },
      bodyClass: 'leases',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('leases')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_leases_edit', {
      url      : '/leases/edit/:id/:tab',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/leases/tabs/tabs.html',
          controller : 'LeasesTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('leases')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_leases_add', {
      url      : '/leases/add',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/leases/tabs/tabs.html',
          controller : 'LeasesTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('leases')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation Leases
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/land/leases');
    // Translation Leases edit
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/land/leases/tabs');

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.land.leases', {
      title : 'Leases',
      icon  : 'icon-satellite',
      state : 'app.farm-admin_leases',
      weight: 30
    });
  }

})();

(function() {
  'use strict';

  angular
  .module('app.farm-admin.land.leases')
  .controller('LeasesTabsCtrl', LeasesTabsCtrl);

  /** @ngInject */
  function LeasesTabsCtrl(
    $q,
    $location,
    $filter,
    $mdToast,
    LeaseService,
    LeasePaymentScheduleService,
    AreaFiscalYearService,
    CompanyService,
    $stateParams,
    $state,
    msUtils,
    api,
    $rootScope
    ) {
    var vm                  = this;
    vm.entity               = 'lease';
    vm.lease_service        = LeaseService;
    vm.paymentTerms         = [];
    vm.fileUpload           = {title:'', description:''};
    vm.service              = LeaseService;
    vm.paymentService       = LeasePaymentScheduleService;
    vm.isLease              = true;
    vm.selectedTab          = null;
    vm.informationForm = {};
    vm.informationForm.$pristine  = true;
    vm.informationForm.$invalid   = true;
    vm.paymentsForm = {};
    vm.paymentsForm.$pristine     = true;
    vm.paymentsForm.$invalid      = true;
    vm.paymentsUpdated          = [];
    vm.paymentUpdated             = false;
    vm.error                      = undefined;
    vm.area_id                    = null;

    var user = sessionStorage.getItem('user');
    if(user) {
      vm.user = JSON.parse(user);
      var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;
      AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function(areaFiscalYearData) {
        vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
      });
    }

    $rootScope.$on('informationForm', function(event, data) {
      vm.informationForm = data;
    });

    $rootScope.$on('paymentsForm', function(event, data, paymentsUpdated) {
      vm.paymentsUpdated = paymentsUpdated;
      vm.paymentsForm = data;
    });

    /* Get Leases */
    if ($stateParams.id) {
      api.leases.get({ id: $stateParams.id }, function(LeaseData) {
        if(LeaseData && LeaseData.lease) {
          if(LeaseData && LeaseData.lease && LeaseData.lease.amount_per_acre) {
            LeaseData.lease.amount_per_acre = msUtils.parseMoneyAsNumber(LeaseData.lease.amount_per_acre);
          }
          vm.lease = LeaseData.lease;
          vm.newLease = false;
        }
      },
      function(err) {
        console.error(err);
      });
    }
    else{
      vm.lease = {
        lease_number: '',
        landlord_company_id: '',
        signature_date: '',
        start_date: '',
        end_date: '',
        acres: 0,
        amount_per_acre: null,
        payment_terms: '',
        starred: '',
        land_owner_company_id: '',
        description:  '',
        newLease: true
      };
    }

    // Methods
    vm.init                 = init;
    vm.tabsSave             = tabsSave;
    vm.parseObject          = parseObject;
    vm.backListing          = backListing;
    vm.convertAmountToNumber = convertAmountToNumber;


    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {


      /* Get land owner companies */
      CompanyService.getCompanyByBusinessRole('land owner').then(function(companiesData) {
        vm.landOwnerCompanies = companiesData.companies;
      },
      function(err) {
        console.error(err);
      });

      /* Get landlord companies */
      CompanyService.getCompanyByBusinessRole('landlord').then(function(companiesData) {
        vm.landlordCompanies = companiesData.companies;
      },
      function(err) {
        console.error(err);
      });

      /* Get Payment Terms */
      LeaseService.getPaymentTerms().then(function(paymentTermsData) {
        vm.paymentTerms = paymentTermsData.payment_terms;
      },
      function(err) {
        console.error(err);
      });

      vm.selectedTab = $state.params.tab;

    }
    /**
     * Go to leases page
     * @return {[type]} [description]
     */
    function backListing () {
      $location.url('/leases');
    }
    /**
     * Function to save each tab information.
     * @return {[type]} [description]
     */
    function tabsSave() {
      if (vm.lease.id) {
        var promises  = [];
        vm.paymentsUpdated.forEach(function(payment) {
          promises.push(
            LeasePaymentScheduleService.update(payment.id, payment).then(function() {
            }).catch(function(error) {
              vm.error=error.data.message;
            })
          );
        });

        Promise.all(promises).then(function() {
          if(vm.error === undefined) {
            LeaseService.update(vm.lease.id, vm.parseObject(vm.lease)).then(function(data) {
              $mdToast.show({
                template: '<md-toast class="md-toast success">All lease information has been updated successfully.</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });
              vm.lease=data.lease;
            },
            function (err)  {
              var error;
              if(err.status !== 500) {
                error = err.data.message;
              }
              $mdToast.show({
                template: '<md-toast class="md-toast error">The lease information could not be updated.' + ((error !== undefined)? error : '') + '</md-toast>',
                position: 'top right',
                hideDelay: 6000
              });
            });
          }
          else {
            $mdToast.show({
              template: '<md-toast class="md-toast error">Payment Schedules could not be updated. </md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          }
        });
      } else {
         /**
         * Create new lease
         */
        LeaseService.create(vm.parseObject(vm.lease)).then(function (data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The lease '+ data.lease.lease_number + ' has been created.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          $location.url('/leases/edit/' + data.lease.id + '/' + 0);
        },
        function(err) { //reject
          var error;
          if(err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The lease could not be created. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      }
    }


    /**
     * Function to parse object if needed.
     * @param  {[type]} lease [description]
     * @return {[type]}       [description]
     */
    function parseObject(lease) {
      var signature_date_temp = new Date(lease.signature_date).setHours(9);
      lease.signature_date = new Date(signature_date_temp).toISOString();
      var start_date_temp = new Date(lease.start_date).setHours(9);
      lease.start_date = new Date(start_date_temp).toISOString();
      var end_date_temp = new Date(lease.end_date).setHours(9);
      lease.end_date = new Date(end_date_temp).toISOString();
      if (vm.lease.id) {
        return {
          lease_number: lease.lease_number,
          landlord_company_id: lease.landlord_company_id,
          signature_date: lease.signature_date,
          start_date: lease.start_date,
          end_date: lease.end_date,
          amount_per_acre: lease.amount_per_acre,
          payment_terms: lease.payment_terms,
          description: lease.description,
          starred: lease.starred,
          land_owner_company_id: lease.land_owner_company_id,
          id: lease.id,
          area_id: vm.area_id
        };
      } else {
        return {
          lease_number: lease.lease_number,
          landlord_company_id: lease.landlord_company_id,
          signature_date: lease.signature_date,
          start_date: lease.start_date,
          end_date: lease.end_date,
          amount_per_acre: lease.amount_per_acre,
          payment_terms: lease.payment_terms,
          description: lease.description,
          starred: lease.starred,
          land_owner_company_id: lease.land_owner_company_id,
          newLease: false,
          area_id: vm.area_id
        };
      }
    }

    /**
     * Convert amount money to number
     * @param  {[type]} amount [description]
     * @return {[type]}        [description]
     */
    function convertAmountToNumber(amount) {
      var amount_number = amount.replace('$', '');
      amount_number = amount_number.replace(',', '');
      return parseFloat(amount_number);
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.blocks', ['uiGmapgoogle-maps', 'ms-resize', 'dynamicNumber'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_blocks', {
      url      : '/blocks',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/blocks/blocks.html',
          controller : 'BlocksCtrl as vm'
        }
      },
      bodyClass: 'blocks',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('blocks')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_blocks_from_page', {
      url      : '/blocks/from_page/:location_id/:ranch_id/:page_name/:entity_id',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/blocks/blocks.html',
          controller : 'BlocksCtrl as vm'
        }
      },
      bodyClass: 'blocks',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('blocks')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_blocks_edit', {
      url      : '/blocks/edit/:id',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/blocks/tabs/tabs.html',
          controller : 'BlocksTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('blocks')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_blocks_add', {
      url      : '/blocks/add',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/blocks/tabs/tabs.html',
          controller : 'BlocksTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('blocks')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.farm-admin_blocks_add_filtered', {
      url      : '/blocks/add/location/:location_id/ranch/:ranch_id',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/blocks/tabs/tabs.html',
          controller : 'BlocksTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('blocks')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation Blocks
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/land/blocks');
    // Translation Blocks edit
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/land/blocks/tabs');

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.land.blocks', {
      title : 'Blocks',
      icon  : 'icon-view-dashboard',
      state : 'app.farm-admin_blocks',
      weight: 29
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.blocks')
    .controller('BlocksTabsCtrl', BlocksTabsCtrl);

  /** @ngInject */
  function BlocksTabsCtrl(
    $scope,
    $q,
    $location,
    $filter,
    $mdToast,
    BlockService,
    BlockBedDirectionsService,
    RanchService,
    AreaFiscalYearService,
    LocationService,
    AreaService,
    CompanyService,
    BlockBedSizeService,
    $mdDialog,
    $document,
    uiGmapGoogleMapApi,
    uiGmapIsReady,
    $translate,
    $stateParams,
    api
  ) {
    var google              = null;
    var vm                  = this;
    vm.newBlock             = true;
    vm.simpleMarkerMap      = {};
    vm.block                = [];
    vm.ranches              = [];
    vm.ranch_name           = '';
    vm.location_id          = null;
    vm.location_name        = '';
    vm.entity               = 'block';
    $scope.loadingBedsData = true;

    vm.paymentTerms         = [];
    vm.fileUpload           = {title:'', description:''};
    vm.informationForm      = {};
    vm.saveDisabled         = true;
    vm.savedBedSizes        = true;
    vm.bedSizes             = [];


    vm.filterData = BlockService.getFilterData();
    if(vm.filterData.location_id) {
      vm.location_id = vm.filterData.location_id;
            /* Get Block Location */
      LocationService.getLocation(vm.location_id).then(function(locationData) {
        vm.location = locationData.location;
      },
      function(err) {
        console.error(err);
      });

      loadRanches(vm.location_id);
      if(vm.filterData.ranch_id) {
        vm.block.ranch_id = vm.filterData.ranch_id;
        /* Get Block Ranch */
        RanchService.get(vm.block.ranch_id).then(function(ranchData) {
          vm.ranch_name = ranchData.ranch.name;
          generateBlockName(vm.ranch_name);
        },
        function(err) {
          console.error(err);
        });
      }
    }


    /* Get Blocks from API */
    if($stateParams.id) {
      api.blocks.get({ id: parseInt($stateParams.id) }, function(BlockData) {
        vm.block = BlockData.block;
        if(vm.block) {
          vm.newBlock = false;
          vm.savedBedSizes = false;
          vm.block.latitude = vm.block.latitude ? Number(vm.block.latitude) : 32.680996;
          vm.block.longitude = vm.block.longitude ? Number(vm.block.longitude) : -114.631348;

          if(!vm.block.zoom) {
            vm.block.zoom = 11;
          }


          /* Get Block Location */
          LocationService.getLocation(vm.block.ranch.location_id).then(function(locationData) {
            vm.location = locationData.location;
          },
          function(err) {
            console.error(err);
          });

          /* Get Block Ranch */
          RanchService.get(vm.block.ranch.id).then(function(ranchData) {
            vm.ranch_name = ranchData.ranch.name;
          },
          function(err) {
            console.error(err);
          });

          /* Get Block Bed Sizes */
          BlockBedSizeService.getBlockBedSizes(vm.block.id).then(function(bedSizesData) {
            vm.block.block_bed_sizes = bedSizesData.block_bed_sizes;
            $scope.loadingBedsData = false;
          },
          function(err) {
            console.error(err);
          });
        }
      },
      function(err) {
        console.error(err);
      });
    }


    // Methods
    vm.init                       = init;
    vm.initMap                    = initMap;
    vm.tabsSave                   = tabsSave;
    vm.parseObject                = parseObject;
    vm.addBlockBedSizeDialog      = addBlockBedSizeDialog;
    vm.deleteBlockBedSizeConfirm  = deleteBlockBedSizeConfirm;
    vm.deleteBlockBedSize         = deleteBlockBedSize;
    vm.saveBlockBedSizesConfirm   = saveBlockBedSizesConfirm;
    vm.saveBlockBedSizes          = saveBlockBedSizes;
    vm.backListing                = backListing;
    vm.generateBlockName          = generateBlockName;
    vm.setStarred                 = setStarred;
    vm.setRanch                   = setRanch;
    vm.loadRanches                = loadRanches;
    vm.goToRanches                = goToRanches;
    vm.addBlock                   = addBlock;
    vm.setNonUniform              = setNonUniform;
    vm.setActive                  = setActive;

    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      var user = sessionStorage.getItem('user');
      vm.user = JSON.parse(user);
      var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;
      api.companies.get({business_role: 'land owner'}, function(LandOwnerCompaniesData) {
        vm.landOwnerCompanies = LandOwnerCompaniesData.companies;
      },
      function(err) {
        console.error(err);
      });

      AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function(areaFiscalYearData) {
        var area_id = areaFiscalYearData.area_fiscal_year.area_id;
        AreaService.getAreaLocations(area_id).then(function(locationsData) {
          vm.locations = locationsData.locations;
        },
        function(err) {
          console.error(err);
        });

      },
      function(err) {
        console.error(err);
      });

      setTimeout(function() {
        initMap();}, 1000);

      /* Get Soil types */
      api.soil_types.get(function(soilTypesData) {
        vm.soilTypes = soilTypesData.soil_types;
      });

      /* Get Block Bed Directions */
      BlockBedDirectionsService.get().then(function(bedDirectionsData) {
        vm.blockBedDirections = bedDirectionsData.block_bed_directions;
      },
      function(err) {
        console.error(err);
      });

      $scope.loadingData = true;
      api.bed_sizes.get(function(BedSizesData) {
        vm.bedSizes = BedSizesData.bed_sizes;
        $scope.loadingData = false;
      });
    }


    /**
     * Google Map settings and marker
     * @return void
     */
    function initMap () {
      uiGmapIsReady.promise(1).then(function(instances) {
        instances.forEach(function(inst) {
          vm.map = inst.map;
        });
      });
      /* http://angular-ui.github.io/angular-google-maps/#!/api/google-map
       * https://developers.google.com/maps/documentation/javascript/reference#MapOptions
       */
      uiGmapGoogleMapApi.then(function () {

        vm.simpleMarkerMap = {
          center: {
            latitude : vm.block.latitude || 32.680996,
            longitude:  vm.block.longitude ||  -114.631348
          },
          options: {
            maxZoom: 18,
            minZoom: 3,
            mapTypeId: 'hybrid'
          },
          zoom: vm.block.zoom || 11,
          dragging: true,
          marker: {
            id     : 0,
            coords : {
              latitude : vm.block.latitude || 32.680996,
              longitude:  vm.block.longitude || -114.631348
            },

            icon: 'assets/angular-material-assets/img/icons/ic_place_24px.svg'
          },


          events: {
            click: function(map, blockEvent, originalEvent) {
              //update or leave the same
              vm.block.latitude   = (originalEvent[0] && originalEvent[0].latLng.lat()) ? Number(originalEvent[0].latLng.lat()) : Number(vm.block.latitude);
              vm.block.longitude  = (originalEvent[0] && originalEvent[0].latLng.lng()) ? Number(originalEvent[0].latLng.lng()) : Number(vm.block.longitude);
              vm.block.zoom       = vm.map.getZoom() ? vm.map.getZoom() : vm.block.zoom;
              vm.saveDisabled = false;

              //update map point
              vm.simpleMarkerMap.marker.coords = {
                latitude : vm.block.latitude,
                longitude: vm.block.longitude
              };

              if(google && google.maps) {
                vm.map.setCenter(new google.maps.LatLng(vm.block.latitude,vm.block.longitude));
              }
            },
            zoom_changed: function() {
              vm.block.zoom       = vm.map.getZoom() ? vm.map.getZoom() : vm.block.zoom;
              vm.saveDisabled = false;
            },

          }
        };
        google.maps.event.addListener(vm.map, 'zoom_changed', function () {
          if (vm.map.getZoom() > 18) vm.map.setZoom(18);
        });

        //vm.map.setCenter(new google.maps.LatLng(vm.block.latitude,vm.block.longitude));
        if (vm.block.latitude!==undefined && vm.block.longitude!==undefined
          && vm.block.latitude!=='' && vm.block.longitude!=='') {
           //Check geolocation and create marker
          vm.simpleMarkerMap.marker = {
            id     : 0,
            coords : {
              latitude : Number(vm.block.latitude),
              longitude: Number(vm.block.longitude)
            },

          };
          vm.simpleMarkerMap.center = {
            latitude : Number(vm.block.latitude),
            longitude: Number(vm.block.longitude)
          };

          vm.simpleMarkerMap.zoom = vm.block.zoom || 9;
        }


      });

    }

    /**
     * Go to blocks page
     * @return {[type]} [description]
     */
    function backListing () {
      $location.url('/blocks');
    }
    /**
     * Function to save each tab information.
     * @return {[type]} [description]
     */
    function tabsSave() {
      if (!vm.block.starred) {
        vm.block.starred = false;
      }
      if (!vm.block.active) {
        vm.block.active = false;
      }
      if (!vm.block.nonuniform_block_size) {
        vm.block.nonuniform_block_size = false;
      }
      if(!vm.newBlock) {
        saveBlockBedSizes();
      }
      if(vm.savedBedSizes) {
        var dataToPost = {
          ranch_id              : vm.block.ranch_id,
          code                  : vm.block.code,
          name                  : vm.block.name,
          acres                 : vm.block.acres,
          company_id            : vm.block.company_id,
          soil_type_id          : vm.block.soil_type_id,
          active                : vm.block.active,
          bed_direction_id      : vm.block.bed_direction_id,
          description           : vm.block.description,
          starred               : vm.block.starred,
          latitude              : vm.block.latitude,
          longitude             : vm.block.longitude,
          zoom                  : vm.block.zoom,
          nonuniform_block_size : vm.block.nonuniform_block_size
        };

        if((!vm.block.zoom && !vm.block.latitude && !vm.block.longitude)
          || (vm.block.zoom &&  vm.block.latitude && vm.block.longitude)) {
          if (vm.block.id) {
            BlockService.update(vm.block.id, vm.parseObject(dataToPost)).then(function(data) {
              $mdToast.show({
                template: '<md-toast class="md-toast success">All block information has been updated successfully.</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });


              BlockBedSizeService.getBlockBedSizes(vm.block.id).then(function(bedSizesData) {
                data.block.block_bed_sizes = bedSizesData.block_bed_sizes;
              },
              function(err) {
                console.error(err);
              });
              vm.block = data.block;
              initMap();
            },
          function() { // Reject
            $mdToast.show({
              template: '<md-toast class="md-toast error">The block '+ vm.block.name + ' could not be updated.</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          });
          }
          else {
          /**
           * Create new block
           */
            BlockService.create(dataToPost).then(function (data) {
              $mdToast.show({
                template: '<md-toast class="md-toast success">The block '+ data.block.name + ' has been created.</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });
              vm.block = data.block;
              initMap();
              $scope.newBlock = false;
              $location.url('/blocks/edit/' + data.block.id);
            },
            function(err) { //reject
              var error;
              if(err.status !== 500) {
                error = err.data.message;
              }
              $mdToast.show({
                template: '<md-toast class="md-toast error">' + ((error !== undefined)? error : 'The block could not be created ') + '</md-toast>',
                position: 'top right',
                hideDelay: 6000
              });
            });
          }
        }
        else{
          $mdToast.show({
            template: '<md-toast class="md-toast error">All Geolocation fields must be completed',
            position: 'top right',
            hideDelay: 6000
          });
        }
      }
    }
    /**
     * Function to parse object if needed.
     * @param  {[type]} block [description]
     * @return {[type]}       [description]
     */
    function parseObject(block) {
      if (vm.block.id) {
        return {
          id: block.id,
          ranch_id: block.ranch_id,
          code: block.code,
          name: block.name,
          acres: block.acres,
          company_id: block.company_id,
          soil_type_id: block.soil_type_id,
          active: block.active,
          bed_direction_id: block.bed_direction_id,
          description: block.description,
          starred: block.starred,
          latitude: block.latitude,
          longitude: block.longitude,
          zoom: block.zoom,
          nonuniform_block_size: block.nonuniform_block_size
        };
      }
    }


        /**
     * Function to handle the behavior of add/edit an user.
     */
    function addBlockBedSizeDialog(ev) {
      $mdDialog.show({
        controller         : 'BlockBedSizesDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/farm-admin/land/blocks/dialogs/block-bed-sizes/block-bed-sizes-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            block              : vm.block,
            dialogType         : 'add'
          }
        }
      });

    }


        /**
     * Delete block bed size confirm
     */
    function deleteBlockBedSizeConfirm(block_bed_size,ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('BLOCK_TABS.SECTION_INFO.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('Block bed size <b>#' + block_bed_size.id  + ' </b>' + ' will be deleted.')
      .ariaLabel('delete bed_size')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteBlockBedSize(block_bed_size);
      }, function () {

      });
    }

    /**
     * Delete block bed size
     * @param  {[type]} payment [description]
     * @return {[type]}         [description]
     */
    function deleteBlockBedSize(block_bed_size) {
      BlockBedSizeService.delete(block_bed_size.id).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The block bed size with ID '+ block_bed_size.id + ' has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.block.block_bed_sizes.splice(vm.block.block_bed_sizes.indexOf(block_bed_size), 1);
      },
      function(err) { //reject
        var error;
        if(err.status && err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">The block bed size with ID '+ block_bed_size.id + 'could not be deleted. ' + ((error !== undefined)? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

        /**
     * Save Block bed sizes Confirm Dialog
     */
    function saveBlockBedSizesConfirm(ev) {

      var confirm = $mdDialog.confirm()
        .title($translate.instant('TABS.SECTION_INFO.ARE_YOU_SURE_TO_SAVE'))
        .htmlContent('Block bed sizes will be saved.')
        .ariaLabel('save bed sizes')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        saveBlockBedSizes();
      }, function () {

        // avoid unhandled rejection message.
      });
    }
    /**
    * Save existent seed (save on edit)
    */
    function saveBlockBedSizes() {
      vm.block.block_bed_sizes.forEach(function(block_bed_size) {
        if(!block_bed_size.description) {
          block_bed_size.description = '';
        }
        BlockBedSizeService.update(block_bed_size.id, block_bed_size).then(function () {

        },
          function () { //reject
            $mdToast.show({
              template: '<md-toast class="error">Block bed size with ID ' + block_bed_size.id + ' could not be updated.</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          });
      });
      vm.savedBedSizes = true;
    }


    /**
     * [setStarred description]
     */
    function setStarred() {
      vm.informationForm.$pristine = false;
      vm.block.starred = !vm.block.starred;
    }

    /**
     * [setNonUniform description]
     */
    function setNonUniform() {
      vm.informationForm.$pristine = false;
      vm.block.nonuniform_block_size = !vm.block.nonuniform_block_size;

    }

    /**
     * [setActive description]
     */
    function setActive() {
      vm.informationForm.$pristine = false;
      vm.block.active = !vm.block.active;
    }

       /**
     * Load Ranches
     * @param  {[type]} location_id [description]
     * @return {[type]}             [description]
     */
    function loadRanches(location_id, location_name) {
      RanchService.getRanchesByLocation(location_id).then(function(ranchesData) {
        vm.ranches=ranchesData.ranches;
      });
      vm.location_id = location_id;
      vm.location_name = location_name;
    }

    /**
     * [generateBlockName description]
     * @return {[type]} [description]
     */
    function generateBlockName(ranchName) {
      if(ranchName) {
        vm.ranch_name = ranchName;
        if(vm.block.code) {
          if(vm.block.code.indexOf(' ') === 0) {
            vm.block.name= vm.ranch_name+vm.block.code;
          }
          else {
            vm.block.name= vm.ranch_name+'-'+ vm.block.code;
          }
        }
        else {
          vm.block.name= vm.ranch_name;
        }
      }
      else if(vm.block.code) {
        vm.block.name = vm.block.code;
      }

    }

    /**
     * [setRanch description]
     * @param {[type]} ranchId [description]
     */
    function setRanch(ranchId) {
      vm.block.ranch_id=parseInt(ranchId);
    }

    /**
     * Go to ranches page
     * @return {[type]} [description]
     */
    function goToRanches() {
      var data = [];
      data = {
        location_id: vm.location_id,
        location_name: vm.location_name,
        from_page: 'add_block'
      };
      BlockService.saveFilterData(data);
      $location.url('/ranches');
    }

      /**
     * [addBlock description]
     * @param  {[type]} ev    [description]
     * @param  {[type]} block [description]
     * @return {[type]}       [description]
     */
    function addBlock() {
      $location.url('/blocks/add/location/' + vm.location.id + '/ranch/' + vm.block.ranch_id);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.directives.fileUpload.dialogs', [])
    .controller('DocumentCategoryDialogController', DocumentCategoryDialogController);

  /** @ngInject */
  function DocumentCategoryDialogController(
    $mdDialog,
    $mdToast,
    dialogData,
    DocumentService
  ) {
    var vm = this;

    // Data
    vm.title                = 'New Document';
    vm.document_name        = '';
    vm.document_category_id = dialogData.document_category_id || null;
    vm.document_categories  = dialogData.document_categories || [];

    // Methods
    vm.addNewDocument       = addNewDocument;
    vm.closeDialog          = closeDialog;

    //////////

    /**
     * Add new document
     */
    function addNewDocument() {
      var data = {
        'name': vm.document_name,
        'document_category_id': vm.document_category_id
      };
      DocumentService.createDocType(data).then(
        function (res) {
          res.document.files = [];
          vm.document_categories.push(res.document);
          $mdToast.show({
            template: '<md-toast class="md-toast success">The document ' + vm.document_name + ' has been created.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          closeDialog();
        },
        function (err) {
          var message = 'The document could not be created.';
          if (err && err.data && err.data.message) {
            message = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">' + message + '</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        }
      );
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('CalendarViewController', CalendarViewController);

  /** @ngInject */
  function CalendarViewController($scope, $document, $mdDialog, $mdSidenav, BoardService, DialogService) {
    var vm = this;

    // Data
    vm.board = BoardService.data;
    vm.eventSources = [];

    vm.calendarUiConfig = {
      calendar: {
        editable                 : true,
        eventLimit               : true,
        header                   : '',
        handleWindowResize       : false,
        aspectRatio              : 1,
        dayNames                 : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
        dayNamesShort            : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
        timezone                 : 'local',
        eventDurationEditable    : false,
        defaultTimedEventDuration: '01:00:00',
        viewRender               : function (view) {
          vm.calendarView = view;
          vm.calendar = vm.calendarView.calendar;
          vm.currentMonthShort = vm.calendar.getDate().format('MMM');
        },
        columnFormat             : {
          month: 'ddd',
          week : 'ddd D',
          day  : 'ddd D'
        },
        eventClick               : function eventDetail(calendarEvent, ev) {
          vm.openCardDialog(ev, calendarEvent.idCard);
        },
        eventDrop                : function (event) {
          vm.board.cards.getById(event.idCard).due = moment.utc(event.start).format('x');
        },
        selectable               : true,
        selectHelper             : true,
        dayClick                 : function (date, ev) {
          var offset = moment().utcOffset();
          var corrDate = '';
          if (offset < 0) {
            corrDate = moment.utc(date).subtract(offset, 'm').format('x');
          }  else {
            corrDate = moment.utc(date).add(offset, 'm').format('x');
          }
          eventDialog(corrDate, ev);
        }
      }
    };

    // Methods
    vm.next = next;
    vm.prev = prev;
    vm.goToDate = goToDate;
    vm.openCardDialog = DialogService.openCardDialog;
    vm.toggleSidenav = toggleSidenav;

    init();

    /**
     * Initialize
     */
    function init() {
      vm.cards = getScheduledCards();
      vm.eventSources[0] = vm.cards;
    }

    /**
     * Get scheduled cards and prepare
     * them to show on the calendar
     *
     * @returns {Array}
     */
    function getScheduledCards() {
      var cards = [];

      angular.forEach(vm.board.cards, function (card) {
        if (card.due) {
          cards.push({
            idCard         : card.id,
            title          : card.name,
            start          : moment.utc(card.due, 'x'),
            due            : card.due,
            backgroundColor: getEventBgColor(card.due)
          });
        }
      });
      return cards;
    }

    /**
     * Get background color
     *
     * @param cardDue
     * @returns {*}
     */
    function getEventBgColor(cardDue) {
      if (moment() > moment(cardDue, 'x')) {
        return '#F44336';
      }
      return '#4CAF50';
    }

    /**
     * Watch board changes
     */
    $scope.$watch('vm.board', function (current, old) {
      if (angular.equals(current, old)) {
        return;
      }
      init();
    }, true);

    /**
     * Go to Date
     *
     * @param date
     */
    function goToDate(date) {
      vm.calendarView.calendar.gotoDate(date);
      $mdSidenav('scheduled-tasks-sidenav').close();
    }

    /**
     * Go to next on current view (week, month etc.)
     */
    function next() {
      vm.calendarView.calendar.next();
    }

    /**
     * Go to previous on current view (week, month etc.)
     */
    function prev() {
      vm.calendarView.calendar.prev();
    }

    /**
     * Event Dialog
     */
    function eventDialog(date, ev) {
      $mdDialog.show({
        templateUrl        : 'app/main/admin/modules/views/calendar/dialogs/event/event-dialog.html',
        controller         : 'ScrumboardCalendarEventDialogController',
        controllerAs       : 'vm',
        parent             : $document.find('#modules'),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dueDate: date
        }
      });
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('BoardsViewController', BoardsViewController);

    /** @ngInject */
  function BoardsViewController(BoardList) {
    var vm = this;

    // Data
    vm.boardList = BoardList.data;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('BoardViewController', BoardViewController);

  /** @ngInject */
  function BoardViewController(
    $state,
    $document,
    $window,
    $timeout,
    $mdDialog,
    $mdToast,
    msUtils,
    BoardList,
    BoardService,
    CardFilters,
    ModuleService,
    DialogService,
    _
  ) {
    var vm = this;

    // Data
    vm.currentView = 'board';
    vm.board = {
      'lists'  : BoardService.modules,
      'cards'  : BoardService.pages,
      'members': BoardService.roles
    };
    vm.boardList = BoardList.data;
    vm.cardFilters = CardFilters;
    vm.card = {};
    vm.cardOptions = {};
    vm.newListName = '';
    vm.sortableListOptions = {
      axis       : 'x',
      delay      : 75,
      distance   : 7,
      items      : '> .list-wrapper',
      handle     : '.list-header',
      placeholder: 'list-wrapper list-sortable-placeholder',
      tolerance  : 'pointer',
      start      : function (ev, ui) {
        var width = ui.item[0].children[0].clientWidth;
        var height = ui.item[0].children[0].clientHeight;
        ui.placeholder.css({
          'min-width': width + 'px',
          'width'    : width + 'px',
          'height'   : height + 'px'
        });
      },
      update      : function(ev, ui) {
        var oldIndex = ui.item.sortable.index;
        var newIndex = ui.item.sortable.dropindex;
        var moduleId = ui.item[0].classList[1].match(/\d+/)[0];
        ModuleService.patchSort(moduleId, { newSortPos: newIndex + 1, oldSortPos: oldIndex + 1}).then(function(data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">' + data.message + '</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.board.lists[oldIndex].sort = oldIndex + 1;
          vm.board.lists[newIndex].sort = newIndex + 1;
          $state.go($state.current, {}, {reload: true});
        }, function(err) {
          if(err && err.data && err.data.message) {
            $mdToast.show({
              template: '<md-toast class="md-toast error">' + err.data.message + '</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
          }
        });
      }
    };
    vm.sortableCardOptions = {
      appendTo            : 'body',
      connectWith         : '.list-cards',
      delay               : 75,
      distance            : 7,
      forceHelperSize     : true,
      forcePlaceholderSize: true,
      handle              : msUtils.isMobile() ? '.list-card-sort-handle' : false,
      helper              : function (event, el) {
        return el.clone().addClass('list-card-sort-helper');
      },
      placeholder         : 'list-card card-sortable-placeholder',
      tolerance           : 'pointer',
      scroll              : true,
      sort                : function (event, ui) {
        var listContentEl = ui.placeholder.closest('.list-content');
        var boardContentEl = ui.placeholder.closest('#board');
        if (listContentEl) {
          var listContentElHeight = listContentEl[0].clientHeight,
            listContentElScrollHeight = listContentEl[0].scrollHeight;
          if (listContentElHeight !== listContentElScrollHeight) {
            var itemTop = ui.position.top,
              itemBottom = itemTop + ui.item.height(),
              listTop = listContentEl.offset().top,
              listBottom = listTop + listContentElHeight;

            if (itemTop < listTop + 25) {
              listContentEl.scrollTop(listContentEl.scrollTop() - 25);
            }
            if (itemBottom > listBottom - 25) {
              listContentEl.scrollTop(listContentEl.scrollTop() + 25);
            }
          }
        }

        if (boardContentEl) {
          var boardContentElWidth = boardContentEl[0].clientWidth;
          var boardContentElScrollWidth = boardContentEl[0].scrollWidth;
          if (boardContentElWidth !== boardContentElScrollWidth) {
            var itemLeft = ui.position.left,
              itemRight = itemLeft + ui.item.width(),
              boardLeft = boardContentEl.offset().left,
              boardRight = boardLeft + boardContentElWidth;
            if (itemLeft < boardLeft + 25) {
              boardContentEl.scrollLeft(boardContentEl.scrollLeft() - 25);
            }
            if (itemRight > boardRight) {
              boardContentEl.scrollLeft(boardContentEl.scrollLeft() + 25);
            }
          }
        }
      }
    };

    // Methods
    vm.openCardDialog     = DialogService.openCardDialog;
    vm.addNewList         = addNewList;
    vm.updateListName     = updateListName;
    vm.removeList         = removeList;
    vm.removeCard         = removeCard;
    vm.removeMember       = removeMember;
    vm.addMemberToList    = addMemberToList;
    vm.cardFilter         = cardFilter;
    vm.isOverdue          = isOverdue;
    vm.getClassQtyMembers = getClassQtyMembers;
    vm.exists             = msUtils.exists;

    init();
    /**
     * Initialize
     */
    function init() {
      $timeout(function () {
        // IE list-content max-height hack
        if (angular.element('html').hasClass('explorer')) {
          // Calculate the height for the first time
          calculateListContentHeight();
          // Attach calculateListContentHeight function to window resize
          $window.onresize = function () {
            calculateListContentHeight();
          };
        }
      }, 0);
    }

    /**
     * IE ONLY
     * Calculate the list-content height
     * IE ONLY
     */
    function calculateListContentHeight() {
      var boardEl = angular.element('#board');
      var boardElHeight = boardEl.height();

      boardEl.find('.list-wrapper').each(function (index, el) {
        // Get the required heights for calculations
        var listWrapperEl = angular.element(el),
          listHeaderElHeight = listWrapperEl.find('.list-header').height(),
          listFooterElHeight = listWrapperEl.find('.list-footer').height();

        // Calculate the max height
        var maxHeight = boardElHeight - listHeaderElHeight - listFooterElHeight;

        // Add the max height
        listWrapperEl.find('.list-content').css({'max-height': maxHeight});
      });
    }

    /**
     * Add new list (module)
     */
    function addNewList() {
      if (vm.newListName === '') {
        return;
      }
      var module = {
        name   : vm.newListName,
        sort   : vm.board.lists.length + 1
      };
      ModuleService.create(module).then(function(data) {
        vm.board.lists.push(data.module);
        $mdToast.show({
          template: '<md-toast class="md-toast success">'+ data.message +'.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function(err) {
        if(err && err.data && err.data.message) {
          $mdToast.show({
            template: '<md-toast class="md-toast error">'+ err.data.message +'.</md-toast>',
            position: 'top right',
            hideDelay: 8500
          });
        }
      });

      vm.newListName = '';
    }

    /**
     * [updateListName description]
     * @param  {[type]} listName [description]
     * @return {[type]}          [description]
     */
    function updateListName(list) {
      ModuleService.patch(list.id, {name: list.name}).then(function(data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">'+ data.message +'.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      }, function(err) {
        if(err && err.data && err.data.message) {
          $mdToast.show({
            template: '<md-toast class="md-toast error">'+ err.data.message +'.</md-toast>',
            position: 'top right',
            hideDelay: 8500
          });
        }
      });
    }

    /**
     * Remove list (module)
     *
     * @param ev
     * @param list
     */
    function removeList(ev, list) {
      var confirm = $mdDialog.confirm({
        title              : 'Remove Module',
        parent             : $document.find('#modules'),
        textContent        : 'Are you sure want to remove this module?',
        ariaLabel          : 'remove module',
        targetEvent        : ev,
        clickOutsideToClose: true,
        escapeToClose      : true,
        ok                 : 'Remove',
        cancel             : 'Cancel'
      });
      $mdDialog.show(confirm).then(function () {
        ModuleService.delete(list.id).then(function(data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">'+ data.message +'.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.board.lists.splice(vm.board.lists.indexOf(list), 1);
        },
        function(err) {
          if(err && err.data && err.data.message) {
            $mdToast.show({
              template: '<md-toast class="md-toast warning">'+ err.data.message +'.</md-toast>',
              position: 'top right',
              hideDelay: 9000
            });
          }
        });
      }, function () {
        // Canceled
      });

    }

    /**
     * Remove card (page)
     *
     * @param ev
     * @param list
     */
    function removeCard(ev, index, list, card) {
      var confirm = $mdDialog.confirm({
        title              : 'Remove Page',
        parent             : $document.find('#modules'),
        textContent        : 'Are you sure want to remove page?',
        ariaLabel          : 'remove page',
        targetEvent        : ev,
        clickOutsideToClose: true,
        escapeToClose      : true,
        ok                 : 'Remove',
        cancel             : 'Cancel'
      });
      $mdDialog.show(confirm).then(function () {
        ModuleService.moduleRemovePageRelation(list.id, card.id).then(function(data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">'+ data.message +'.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          _.pull(vm.board.lists[index].idCards, card.id);
        });
      }, function () {
        // Canceled
      });
    }

    /**
     * Remove member (role)
     *
     * @param ev
     * @param list
     */
    function removeMember(ev, index, list, memberId) {
      var confirm = $mdDialog.confirm({
        title              : 'Remove Role',
        parent             : $document.find('#modules'),
        textContent        : 'Are you sure want to remove this role?',
        ariaLabel          : 'remove role',
        targetEvent        : ev,
        clickOutsideToClose: true,
        escapeToClose      : true,
        ok                 : 'Remove',
        cancel             : 'Cancel'
      });
      $mdDialog.show(confirm).then(function () {
        ModuleService.moduleRemoveRoleRelation(list.id, memberId).then(function(data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">'+ data.message +'.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          _.pull(vm.board.lists[index].idMembers, memberId);
        });
      }, function () {
        // Canceled
      });
    }
    /**
     * Function to add a member(role) relation to list (module)
     * [addMemberToList description]
     */
    function addMemberToList(index, list, member) {
      ModuleService.moduleAddRoleRelation(list.id, member.id).then(function(data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">'+ data.message +'.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        if(!list.hasOwnProperty('idMembers')) {
          vm.board.lists[index].idMembers = [member.id];
        } else {
          vm.board.lists[index].idMembers.push(member.id);
        }
      },
      function (err) {
        if(err && err.data && err.data.message) {
          $mdToast.show({
            template: '<md-toast class="md-toast warning">'+ err.data.message +'.</md-toast>',
            position: 'top right',
            hideDelay: 8500
          });
        }
      });
    }

    /**
     * Card filter
     *
     * @param cardId
     * @returns {*}
     */
    function cardFilter(cardId) {
      var card = vm.board.cards.getById(cardId);
      try {
        if (angular.lowercase(card.name).indexOf(angular.lowercase(vm.cardFilters.name)) < 0) {
          throw false;
        }
        angular.forEach(vm.cardFilters.labels, function (label) {
          if (!msUtils.exists(label, card.idLabels)) {
            throw false;
          }
        });
        angular.forEach(vm.cardFilters.members, function (member) {
          if (!msUtils.exists(member, card.idMembers)) {
            throw false;
          }
        });
      } catch (err) {
        return err;
      }
      return true;
    }

    /**
     * Is the card overdue?
     *
     * @param cardDate
     * @returns {boolean}
     */
    function isOverdue(cardDate) {
      return moment() > moment(cardDate, 'x');
    }

    /**
     * [getClassQtyMembers description]
     * @param  {[type]} memberQty [description]
     * @return {[type]}           [description]
     */
    function getClassQtyMembers(memberQty) {
      if(memberQty === 4) {
        return { 'avatar-qty-greater-than-4': true };
      } else if (memberQty === 5) {
        return { 'avatar-qty-greater-than-5': true };
      } else if(memberQty >= 6) {
        return { 'avatar-qty-greater-than-6': true };
      }
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('SettingsSidenavController', SettingsSidenavController);

  /** @ngInject */
  function SettingsSidenavController($mdColorPalette, BoardService) {
    var vm = this;

    // Data
    vm.board = BoardService.data;
    vm.palettes = $mdColorPalette;
    vm.selectedMenu = 'Settings';
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('FiltersSidenavController', FiltersSidenavController);

  /** @ngInject */
  function FiltersSidenavController(msUtils, BoardService, CardFilters) {
    var vm = this;

    // Data
    vm.board = BoardService.data;
    vm.cardFilters = CardFilters;
    vm.labels = vm.board.labels;
    vm.members = vm.board.members;
    vm.selectedMenu = 'Settings';

    // Methods
    vm.exists = msUtils.exists;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.clearFilters = CardFilters.clear;
    vm.filteringIsOn = CardFilters.isOn;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('msSbAddCardController', msSbAddCardController)
    .directive('msSbAddCard', msSbAddCardDirective);

    /** @ngInject */
  function msSbAddCardController(
    $q,
    $scope,
    $mdDialog,
    $mdToast,
    $document,
    $timeout,
    BoardService,
    ModuleService,
    PageService
  ) {
    var vm = this;

    vm.newCardName = '';
    vm.listId = $scope.msListId;

    vm.board = {'lists': BoardService.modules, 'cards': BoardService.pages };
    vm.cards = vm.board.cards;
    vm.list = vm.board.lists.getById(vm.listId);
    /** autocomplete **/
    vm.simulateQuery = false;
    vm.isDisabled    = false;

    // list of `state` value/display objects
    vm.querySearch   = querySearch;
    /** autocomplete end **/
    // Methods
    vm.addNewCard = addNewCard;
    vm.createFilterFor = createFilterFor;
    vm.additionalOption = '';

    /**
    * Search for pages
    * remote dataservice call.
    */
    function querySearch(query) {
      vm.additionalOption = 'Also you can <a ng-click="vm.addNewCard($event, vm.searchText)">create a new one!</a>';
      return query ? vm.cards.filter(createFilterFor(query)) : vm.cards;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(card) {
        return (card && card.hasOwnProperty('name') && card.name.indexOf(lowercaseQuery) === 0);
      };
    }

    /**
     * Add New Card
     */
    function addNewCard(ev, card) {
      // Refresh service
      if (card && card.hasOwnProperty('name')) { // Add existent card.
        if(!vm.list.hasOwnProperty('idCards')) {
          vm.list.idCards = [card.id];
        } else {
          vm.list.idCards.push(card.id);
        }
        ModuleService.moduleAddPageRelation(vm.listId, card.id).then(function(data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">'+ data.message +'.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      } else { // Create a new one.
        $document.find('.md-scroll-mask').remove();
        var confirm = $mdDialog.confirm({
          title              : 'Add a new page',
          parent             : $document.find('#modules'),
          textContent        : 'Are you sure want to add a new page? the new page will not be visible until you create proper menu section.',
          ariaLabel          : 'add page',
          targetEvent        : ev,
          clickOutsideToClose: true,
          escapeToClose      : true,
          ok                 : 'Add',
          cancel             : 'Cancel'
        });
        $mdDialog.show(confirm).then(function () {
          var page = {
            name               : card,
            documents_on_page  : false,
            page_module        : [vm.list],
            is_admin           : false,
            section            : 'admin'
          };
          PageService.create(page).then(function(data) {
            // sort cards asc
            vm.cards.sort(function(a, b) { return (a.id > b.id) ? 1 : ((b.id > a.id) ? -1 : 0); });
            // add new card.
            vm.cards.push(data.page);
            vm.list.idCards.push(data.page.id);
            ModuleService.moduleAddPageRelation(vm.listId, data.page.id).then(function(rData) {
              $mdToast.show({
                template: '<md-toast class="md-toast success">'+ rData.message +'.</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });
              $timeout(function () {
                $scope.scrollListContentBottom();
              });
            }, function(err) {
              console.error(err);
            });
          },
          function(err) {
            console.error(err);
          });
        }, function () {
          // Canceled
        });
      }
      vm.searchText = '';
    }
  }

  /** @ngInject */
  function msSbAddCardDirective($document, $window, $timeout) {
    return {
      restrict   : 'E',
      controller : 'msSbAddCardController as vm',
      templateUrl: 'app/main/admin/modules/directives/ms-sb-add-card/ms-sb-add-card.html',
      scope      : {
        msListId: '='
      },
      link: function (scope, iElement) {
        scope.formActive = false;
        scope.toggleForm = toggleForm;
        scope.scrollListContentBottom = scrollListContentBottom;

        var buttonEl = iElement.find('.ms-sb-add-card-button'),
          formEl = iElement.find('.ms-sb-add-card-form'),
          listCards = iElement.parent().prev().find('.list-cards');

        /**
         * Click Event
         */
        buttonEl.on('click', toggleForm);

        /**
         * Toggle Form
         */
        function toggleForm() {
          scope.$evalAsync(function () {
            scope.formActive = !scope.formActive;

            if (scope.formActive) {
              $timeout(function () {
                formEl.find('input').focus();
                scrollListContentBottom();
              });
              $document.on('click', outSideClick);
            } else {
              PerfectScrollbar.update(listCards[0]);
              $document.off('click', outSideClick);
            }

            $timeout(function () {
              // IE list-content max-height hack
              if (angular.element('html').hasClass('explorer')) {
                angular.element($window).trigger('resize');
              }
            });
          });
        }

        /**
         * Scroll List to the Bottom
         */
        function scrollListContentBottom() {
          listCards[0].scrollTop = listCards[0].scrollHeight;
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        var outSideClick = function (event) {
          var isChild = formEl.has(event.target).length > 0;
          var isSelf = formEl[0] === event.target;
          var isInside = isChild || isSelf;
          if (!isInside) {
            toggleForm();
          }
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
   .module('app.admin.modules')
   .controller('ScrumboardCardDialogController', ScrumboardCardDialogController);
   /** @ngInject */
  function ScrumboardCardDialogController(
   $q,
   $filter,
   $document,
   $mdDialog,
   $mdToast,
   fuseTheming,
   fuseGenerator,
   msUtils,
   BoardService,
   cardId,
   removeCardFnc,
   ModuleService,
   PageService,
   PageSettingService,
   PageActionService
  ) {
    var vm                      = this;
    // Data
    vm.sections                 = [];
    vm.actions                  = [];
    vm.newPermissionColor       = 'red';
    // Methods
    vm.palettes                 = fuseTheming.getRegisteredPalettes();
    vm.rgba                     = fuseGenerator.rgba;
    vm.toggleInArray            = msUtils.toggleInArray;
    vm.exists                   = msUtils.exists;
    vm.closeDialog              = closeDialog;
    vm.getCardList              = getCardList;
    vm.removeCard               = removeCard;
    /* Attachment */
    vm.toggleCoverImage         = toggleCoverImage;
    vm.removeAttachment         = removeAttachment;
    /* Permissions */
    vm.permissionQuerySearch    = permissionQuerySearch;
    vm.filterPermission         = filterPermission;
    vm.addNewPermission         = addNewPermission;
    vm.removePermission         = removePermission;
    /* Roles */
    vm.roleQuerySearch          = roleQuerySearch;
    vm.filterRole               = filterRole;
    /* Action */
    vm.updateCheckedCount       = updateCheckedCount;
    vm.addCheckItem             = addCheckItem;
    vm.removeAction             = removeAction;
    vm.removeActionItem         = removeActionItem;
    vm.createAction             = createAction;
    /* Comment */
    vm.addNewComment            = addNewComment;
    vm.updateCard               = updateCard;
    vm.getSelectedIndex         = getSelectedIndex;
    vm.loadEntities             = loadEntities;
    vm.test             = test;

    init();
    
    function test() {
      console.log(vm.actions);
    }
    /**
     * Initialization function
     * @return {[type]} [description]
     */
    function init() {
      /**
       * Get all modules, pages and sections to load in the view.
       */
      $q.all([
        ModuleService.getList().then(),
        PageService.getList().then(),
        PageService.getSectionsList().then()
      ]).then(function(res) {
        vm.board = {
          lists: res[0].modules,
          cards: res[1].pages
        };
        if(res && res[2]) {
          vm.sections = res[2].sections;
        }
        vm.board.lists.forEach(function(module, i) {
          var pageIds = [];
          module.pages.forEach(function(page) {
            pageIds.push(page.id);
          });
          vm.board.lists[i].idCards = pageIds;
        });
        vm.card = vm.board.cards.getById(cardId);
        /**
         * Get all roles for the current card (page).
         */
        $q.all([
          PageSettingService.getAllPrivilegesOrRolesByPage(['user_role_id', cardId]).then(),
          PageSettingService.getAllPrivilegesOrRolesByPage(['privilege_id', cardId]).then(),
          PageSettingService.getAllPageActionsByEntity(['page_id', cardId]).then()
        ]).then(function(res) {
          if(vm.board && vm.board.hasOwnProperty('cards') && vm.board.cards.length > 0) {
            vm.loadEntities(res[0], 'roles', 'user_role');
            vm.loadEntities(res[1], 'permissions', 'privilege');
            vm.loadEntities(res[2], 'actions', 'page_action', true);
          }
        },
        function(err) {
          console.error(err);
        });
      },
      function(err) {
        console.error(err);
      });
    }
    
    /**
     * Function loadEntities to load permissions, roles and page actions
     * from API dynamically, for now is used to load:
     *
     *  - Permissions
     *  - Roles
     *  - Page Actions
     * 
     * @return {[type]} [description]
     */
    function loadEntities(aApiData, entityAppName, apiName, isCard) {
      // Initialize vars
      vm[entityAppName] = [];
      vm.board.cards[cardId]['id' + $filter('capitalize')(entityAppName)] = [];
      if(aApiData && aApiData.hasOwnProperty(apiName)) {
        if(aApiData[apiName].length > 1) {
          aApiData[apiName].forEach(function(data) {
            // Push entity object(id, name) into array entity.
            vm[entityAppName].push({id: data[apiName].id, name: data[apiName].name, checked: true});
            // Push ids into entity array.
            vm.board.cards[cardId]['id' + $filter('capitalize')(entityAppName)].push(data[apiName].id);
            // Assign entity array to board entity array.
            if(isCard) {
              vm.card[entityAppName] = {
                'actions': {
                  'name': 'Page Actions',
                  'checkItems': vm[entityAppName]
                }
              };
            } else {
              vm.board[entityAppName] = vm[entityAppName];
            }
          });
        }
      }
    }
    /**
     * Get selected section index
     * @return {[type]} [description]
     */
    function getSelectedIndex(cardSection) {
      vm.sections.forEach(function(section, i) {
        if(cardSection === section) {
          return i;
        }
      });
    }
    /**
     * Function to save card (page)
     * 
     * @return {[type]} [description]
     */
    function updateCard() {
      if(vm.card.section === 'admin') {
        vm.card.is_admin = true;
      } else {
        vm.card.is_admin = false;
      }
      PageService.patch(vm.card.id, {
        documents_on_page: vm.card.documents_on_page, 
        is_admin: vm.card.is_admin, 
        section: vm.card.section
      }).then(function(data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">'+ data.message +'.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },function(err) {
        if(err && err.data && err.data.message) {
          $mdToast.show({
            template: '<md-toast class="md-toast error">'+ err.data.message +'.</md-toast>',
            position: 'top right',
            hideDelay: 8500
          });
        }
      });
    }
   /**
    * Close Dialog
    */
    function closeDialog() {
      $mdDialog.hide();
    }
   /**
    * Get Card List
    */
    function getCardList() {
      if(vm.board && vm.board.hasOwnProperty('lists')) {
        var response;
        for (var i = 0, len = vm.board.lists.length; i < len; i++) {
          if (vm.board.lists[i].idCards.indexOf(vm.card.id) > -1) {
            response = vm.board.lists[i];
            break;
          }
        }
        return response;
      }
    }
   /**
    * Remove card
    *
    * @param ev
    */
    function removeCard(ev) {
      removeCardFnc(ev, getCardList(), vm.card);
    }
   /**
    * Toggle cover image
    *
    * @param attachmentId
    */
    function toggleCoverImage(attachmentId) {
      if (attachmentId === vm.card.idAttachmentCover) {
        vm.card.idAttachmentCover = null;
      } else {
        vm.card.idAttachmentCover = attachmentId;
      }
    }
   /**
    * Remove attachment
    *
    * @param item
    */
    function removeAttachment(item) {
      if (vm.card.idAttachmentCover === item.id) {
        vm.card.idAttachmentCover = '';
      }
      vm.card.attachments.splice(vm.card.attachments.indexOf(item), 1);
    }
   /**
    * Add permission chips
    *
    * @param query
    * @returns {filterFn}
    */
    function permissionQuerySearch(query) {
      return query ? vm.permissions.filter(createFilterFor(query)) : [];
    }
   /**
    * Permission filter
    *
    * @param permission
    * @returns {boolean}
    */
    function filterPermission(permission) {
      if (!vm.permissionSearchText || vm.permissionSearchText === '') {
        return true;
      }
      return angular.lowercase(permission.name).indexOf(angular.lowercase(vm.permissionSearchText)) >= 0;
    }
   /**
    * Add new permission
    */
    function addNewPermission() {
      vm.board.permissions.push({
        id   : msUtils.guidGenerator(),
        name : vm.newPermissionName,
        color: vm.newPermissionColor
      });
      vm.newPermissionName = '';
    }
   /**
    * Remove permission
    */
    function removePermission() {
      var arr = vm.board.permissions;
      arr.splice(arr.indexOf(arr.getById(vm.editPermissionId)), 1);
      angular.forEach(vm.board.cards, function (card) {
        if (card.idPermissions && card.idPermissions.indexOf(vm.editPermissionId) > -1) {
          card.idPermissions.splice(card.idPermissions.indexOf(vm.editPermissionId), 1);
        }
      });
      vm.newPermissionName = '';
    }
   /**
    * Add role chips
    *
    * @param query
    * @returns {Array}
    */
    function roleQuerySearch(query) {
      return query ? vm.roles.filter(createFilterFor(query)) : [];
    }
   /**
    * Role filter
    *
    * @param role
    * @returns {boolean}
    */
    function filterRole(role) {
      if (!vm.roleSearchText || vm.roleSearchText === '') {
        return true;
      }
      return angular.lowercase(role.name).indexOf(angular.lowercase(vm.roleSearchText)) >= 0;
    }
   /**
    * Update check list stats
    * @param list
    */
    function updateCheckedCount(list) {
      var checkItems = list.checkItems;
      var checkedItems = 0;
      var allCheckedItems = 0;
      var allCheckItems = 0;
      angular.forEach(checkItems, function (checkItem) {
        if (checkItem.checked) {
          checkedItems++;
        }
      });
      list.checkItemsChecked = checkedItems;
      angular.forEach(vm.card.actions, function (item) {
        allCheckItems += item.checkItems.length;
        allCheckedItems += item.checkItemsChecked;
      });
      vm.card.checkItems = allCheckItems;
      vm.card.checkItemsChecked = allCheckedItems;
    }
   /**
    * Add action item
    *
    * @param text
    * @param action
    */
    function addCheckItem(text, action) {
      if (!text || text === '') {
        return;
      }
      var newCheckItem = {
        'name'   : text,
        'checked': false
      };
      action.checkItems.push(newCheckItem);
      updateCheckedCount(action);
    }
   /**
    * Remove action from page (this will remove action association with page.)
    *
    * @param item
    */
    function removeAction(item) {
      vm.card.actions.splice(vm.card.actions.indexOf(item), 1);
      angular.forEach(vm.card.actions, function (list) {
        updateCheckedCount(list);
      });
    }
   /**
    * Remove action Item
    *
    * @param item
    */
    function removeActionItem(ev, item, list) {
      var confirm = $mdDialog.confirm({
        title              : 'Remove page action',
        parent             : $document.find('#modules'),
        textContent        : 'Are you sure want to remove this page action?',
        ariaLabel          : 'remove page action',
        targetEvent        : ev,
        clickOutsideToClose: true,
        escapeToClose      : true,
        ok                 : 'Remove',
        cancel             : 'Cancel'
      });
      $mdDialog.show(confirm).then(function () {
        PageActionService.delete(item.id).then(function() {
          list.splice(list.indexOf(item), 1);
          angular.forEach(vm.card.actions, function (list) {
            updateCheckedCount(list);
          });
        }, function(err) {
          console.log(err);
        });
      }, function(err) {
        console.log(err);
      });
    }
   /**
    * Create action
    */
    function createAction() {
      vm.card.actions.push({
        id               : msUtils.guidGenerator(),
        name             : vm.newActionTitle,
        checkItemsChecked: 0,
        checkItems       : []
      });
      vm.newActionTitle = '';
    }
   /**
    * Add new comment
    *
    * @param newCommentText
    */
    function addNewComment(newCommentText) {
      var newComment = {
        idRole: '36027j1930450d8bf7b10158',
        message : newCommentText,
        time    : 'now'
      };
      vm.card.comments.unshift(newComment);
    }
   /**
    * Filter for chips
    *
    * @param query
    * @returns {filterFn}
    */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(item) {
        return angular.lowercase(item.name).indexOf(lowercaseQuery) >= 0;
      };
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.reports.resource-requirements-report', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.pages_resource-requirements-report', {
      url      : '/resource-requirements-report',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/reports/resource-requirements-report/resource-requirements-report.html',
          controller : 'ResourceRequirementsReportCtrl as vm'
        }
      },
      bodyClass: 'reports',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('resource_requirements_report')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/reports/resource-requirements-report');


    // // Navigation
    msNavigationServiceProvider.saveItem('pages.reports.resource-requirements-report', {
      title : 'Resource Requirements',
      icon  : 'icon-chart-areaspline',
      state : 'app.pages_resource-requirements-report',
      weight: 17
    });
  }

})();

(function() {
  'use strict';

  angular
  .module('app.pages.reports.resource-requirements-report')
  .controller('ResourceRequirementsReportCtrl', ResourceRequirementsReportCtrl);


  /** @ngInject */
  function ResourceRequirementsReportCtrl(
    $scope,
    AreaFiscalYearService,
    AreaService,
    SeasonsService,
    $filter,
    api,
    _,
    ContractScheduleVarietiesService
  ) {

    // Data
    var vm = this;
    vm.active_filters              = [];
    vm.listType                    = 'all';
    vm.locations                   = [];
    vm.filterIds                   = [];
    vm.allSeasons                  = [];
    vm.allWeekEnding               = [];
    vm.shownContractSchedules      = [];
    vm.contractSchedules           = [];
    vm.loadListFiltered            = false;
    vm.seasons                     = [];
    vm.shippers                    = [];
    vm.shipper                     = [];
    vm.isFarmOwner                 = true;
    vm.filterTitle                 = '';
    vm.shipper_id                  = null;
    vm.shipper_name                = '';
    vm.location_id                 = null;
    vm.location_name               = '';
    vm.season_id                   = null;
    vm.season_name                 = '';
    vm.week_ending_id              = null;
    vm.week_ending_name            = '';
    vm.offset                      = 0;
    vm.limit                       = 100;
    vm.orderedContractSchedules    = [];
    vm.seasonsTotals               = [];
    vm.annualTotal                 = 0;
    vm.area_id                     = null;
    vm.areaFiscalYear_id           = null;
    vm.fiscal_year                 = null;
    vm.byWetDate                   = true;
    vm.startYear                   = null;
    vm.endYear                     = null;


    // Methods
    vm.filterChange                = filterChange;
    vm.toggleWeekEndingTotals      = toggleWeekEndingTotals;

    //////////
    init ();

    /**
    * [init description]
    * @return {[type]} [description]
    */
    function init() {
      $scope.loadingData = true;

      var user = sessionStorage.getItem('user');
      vm.user = JSON.parse(user);

      vm.areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;

      AreaFiscalYearService.getAreaFiscalYear(vm.areaFiscalYear_id).then(function(areaFiscalYearData) {
        // calculate week endings of Fiscal Year
        if (areaFiscalYearData && areaFiscalYearData.area_fiscal_year && areaFiscalYearData.area_fiscal_year.fiscal_year) {
          vm.fiscal_year = areaFiscalYearData.area_fiscal_year.fiscal_year;
          vm.startYear = new Date (vm.fiscal_year.begin_date);
          vm.startYear = vm.startYear.getFullYear();
          vm.endYear = new Date (vm.fiscal_year.end_date);
          vm.endYear = vm.endYear.getFullYear();
          calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
        }
        vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
        AreaService.getAreaLocations(vm.area_id).then(function(locationsData) {
          vm.locations = locationsData.locations;
        },
        function(err) {
          console.error(err);
        });

        /* Get all shippers */
        ContractScheduleVarietiesService.getAllAssociatedShippers().then(function(ShippersData) {
          vm.shippers = ShippersData.shippers;
        });

        /* Get all seasons */
        SeasonsService.getList().then(function(seasonsData) {
          vm.seasons = seasonsData.seasons;

          api.users.get({id:vm.user.id}, function(userData) {
            var flagRole = false;


            api.farms.get({id: 1}, function (farmData) {
              var farmCompanyId = farmData.farm.farm_company_id;
              if(userData.user.company_id === farmCompanyId) {
                flagRole = true;
              }

              if(flagRole) {
                getAllContractScheduleVarieties(vm.area_id);
              }
              else {
                vm.isFarmOwner = false;
                vm.shipper_id = userData.user.company_id;
                getAllContractScheduleVarieties(vm.area_id);
              }
            });      

          });

        },
        function(err) {
          console.error(err);
        });

      },
      function(err) {
        console.error(err);
      });



    }

    /**
    * [filterChange description]
    * @param  {[type]} type [description]
    * @param  {[type]} id   [description]
    * @param  {[type]} name [description]
    * @return {[type]}      [description]
    */
    function filterChange(type, id, name) {
      vm.loadListFiltered = true;
      $scope.loadingData=true;
      vm.listType = type;

      if (type === 'all') {
        if(vm.isFarmOwner) {
          vm.shipper_name = '';
          vm.shipper_id = null;
        }
        vm.location_name = '';
        vm.location_id = null;
        vm.season_name = '';
        vm.season_id = null;
        vm.week_ending_name = '';
        vm.week_ending_id = null;
        vm.filterIds = [];
        vm.filterTitle     = '';
        calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
      }

      else {
        if (type === 'shipper') {
          vm.shipper_name = name;
          vm.shipper_id = id;
        }

        else if (type === 'location') {
          vm.location_name = name;
          vm.location_id = id;
        }

        else if (type === 'season') {
          vm.season_name = name;
          vm.season_id = id;
          filterWeekEndings(vm.season_id);
        }
        else if (type === 'week_ending') {
          vm.week_ending_name = name;
          vm.week_ending_id = id;
        }

        if(vm.filterTitle !== '') {
          vm.filterTitle = vm.filterTitle + ' - ' + name;
        }
        else {
          vm.filterTitle = name;
        }
      }
      vm.filterIds = [];
      vm.contractSchedules = [];
      getAllContractScheduleVarieties(vm.area_id);

      vm.loadListFiltered = false;
      //  $scope.loadingData = false;

    }

    /**
    * [populateFields description]
    * @return {[type]} [description]
    */
    function getAllContractScheduleVarieties(area_id) {
      $scope.loadingData = true;
      vm.loadListFiltered = true;
      ContractScheduleVarietiesService.getAllForReports(vm.offset, vm.limit,area_id, vm.byWetDate, vm.fiscal_year.begin_date,vm.fiscal_year.end_date, vm.shipper_id, vm.location_id, vm.season_id, vm.week_ending_id).then(function(ContractSchedulesData) {
        if(ContractSchedulesData && ContractSchedulesData.contract_schedule_varieties) {
          vm.contractSchedules = ContractSchedulesData.contract_schedule_varieties;
          vm.filterIds = ContractSchedulesData.filter_ids;
          vm.seasonsTotals = ContractSchedulesData.seasons_totals;
          vm.annualTotal = ContractSchedulesData.annual_total;
        }
        vm.loadListFiltered = false;
        $scope.loadingData = false;

      });



    }

    /**
    * [filterWeekEndings description]
    * @param  {[type]} seasonId [description]
    * @return {[type]}          [description]
    */
    function filterWeekEndings(seasonId) {
      var idx = _.findIndex(vm.seasons, {'id': seasonId});
      var period_start = vm.seasons[idx].start_day;
      var period_end = vm.seasons[idx].end_day;
      calculateWeekEndings(period_start, period_end);
    }

    /**
    * [calculateWeekEndings description]
    * @return {[type]}
    */
    function calculateWeekEndings(period_start, period_end) {
      var endings = [];
      var end = moment(period_end);
      var next_saturday = moment(period_start).day('Saturday').startOf('day')._d;
      while (next_saturday < end) {
        var obj = {
          id: next_saturday,
          name: $filter('date')(next_saturday)
        };
        endings.push(obj);
        next_saturday = moment(next_saturday.toISOString()).add(7, 'days')._d;
      }
      vm.allWeekEnding = endings;
    }



    /**
    * [toggleWeekEndingTotals description]
    * @return {[type]} [description]
    */
    function toggleWeekEndingTotals() {
      vm.byWetDate = !vm.byWetDate;
      vm.fitlerIds = [];
      vm.contractSchedules = [];
      getAllContractScheduleVarieties(vm.area_id);

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.reports.planting-schedule-report', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.pages_planting-schedule-report', {
      url      : '/planting-schedule-report',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/reports/planting-schedule-report/planting-schedule-report.html',
          controller : 'PlantingScheduleReportCtrl as vm'
        }
      },
      bodyClass: 'reports',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('planting_schedule_report')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/reports/planting-schedule-report');


    // // Navigation
    msNavigationServiceProvider.saveItem('pages.reports.planting-schedule-report', {
      title : 'Planting Schedule',
      icon  : 'icon-chart-areaspline',
      state : 'app.pages_planting-schedule-report',
      weight: 15
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.reports.planting-schedule-report')
    .controller('PlantingScheduleReportCtrl', PlantingScheduleReportCtrl);


  /** @ngInject */
  function PlantingScheduleReportCtrl(
    $scope,
    AreaFiscalYearService,
    AreaService,
    SeasonsService,
    $filter,
    api,
    _,
  //  PlantingService,
    RanchService,
    BlockService
  ) {

    // Data
    var vm = this;
    vm.active_filters              = [];
    vm.listType                    = 'all';
    vm.locations                   = [];
    vm.filterIds                   = [];
    vm.allSeasons                  = [];
    vm.allWeekEnding               = [];
    vm.shownPlantingSchedules      = [];
    vm.plantingSchedules           = [];
    vm.loadListFiltered            = false;
    vm.seasons                     = [];
    vm.shippers                    = [];
    vm.pcaCompanies                = [];
    vm.shipper                     = [];
    vm.isFarmOwner                 = true;
    vm.filterTitle                 = '';
    vm.shipper_id                  = null;
    vm.shipper_name                = '';
    vm.pca_id                      = null;
    vm.pca_name                    = '';
    vm.location_id                 = null;
    vm.location_name               = '';
    vm.ranch_id                    = null;
    vm.ranch_name                  = '';
    vm.block_id                    = null;
    vm.block_name                  = '';
    vm.season_id                   = null;
    vm.season_name                 = '';
    vm.week_ending_id              = null;
    vm.week_ending_name            = '';
    vm.offset                      = 0;
    vm.limit                       = 100;
    vm.orderedPlantingSchedules      = [];
    vm.seasonsTotals               = [];
    vm.annualTotal                 = 0;
    vm.area_id                     = null;
    vm.areaFiscalYear_id           = null;
    vm.ranches                     = [];
    vm.blocks                      = [];
    vm.foremans                    = [];
    vm.isShipper                   = false;
    vm.isPca                       = false;
    vm.fiscal_year                 = null;
    vm.byWetDate                   = true;
    vm.startYear                   = null;
    vm.endYear                     = null;

    // Methods
    vm.filterChange                = filterChange;
    vm.toggleWeekEndingTotals      = toggleWeekEndingTotals;

    //////////
    init ();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
    //  $scope.loadingData = true;

      var user = sessionStorage.getItem('user');
      vm.user = JSON.parse(user);

      vm.areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;

      AreaFiscalYearService.getAreaFiscalYear(vm.areaFiscalYear_id).then(function(areaFiscalYearData) {
        // calculate week endings of Fiscal Year
        if (areaFiscalYearData && areaFiscalYearData.area_fiscal_year && areaFiscalYearData.area_fiscal_year.fiscal_year) {
          vm.fiscal_year = areaFiscalYearData.area_fiscal_year.fiscal_year;
          vm.fiscal_year = areaFiscalYearData.area_fiscal_year.fiscal_year;
          vm.startYear = new Date (vm.fiscal_year.begin_date);
          vm.startYear = vm.startYear.getFullYear();
          vm.endYear = new Date (vm.fiscal_year.end_date);
          vm.endYear = vm.endYear.getFullYear();
          calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
        }
        vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
        AreaService.getAreaLocations(vm.area_id).then(function(locationsData) {
          vm.locations = locationsData.locations;
        },
        function(err) {
          console.error(err);
        });

        /* Get all seasons */
        SeasonsService.getList().then(function(seasonsData) {
          vm.seasons = seasonsData.seasons;

        },
        function(err) {
          console.error(err);
        });

        var flagRole = false;
        api.companies.get({id:vm.user.company_id}, function(companyData) {
          angular.forEach(companyData.company.business_roles, function(businessRole) {
            if(businessRole.name === 'Farm Owner')   flagRole = true;
            else {
              if (businessRole.name === 'shipper') {
                vm.isShipper = true;
              }
            }
          });

          if(!flagRole) {
            vm.isFarmOwner = false;
            if(vm.isShipper) {
              vm.shipper_id = vm.user.company_id;
            }
          }
          getAllPlantingSchedules(vm.area_id);
        });

      },
      function(err) {
        console.error(err);
      });



    }

    /**
     * [filterChange description]
     * @param  {[type]} type [description]
     * @param  {[type]} id   [description]
     * @param  {[type]} name [description]
     * @return {[type]}      [description]
     */
    function filterChange(type, id, name) {
      vm.loadListFiltered = true;
    //  $scope.loadingData=true;
      vm.listType = type;

      if (type === 'all') {
        if(vm.isFarmOwner) {
          vm.shipper_name = '';
          vm.shipper_id = null;
          vm.pca_name = '';
          vm.pca_id = null;
        }
        vm.location_name = '';
        vm.location_id = null;
        vm.ranch_name = '';
        vm.ranch_id = null;
        vm.block_name = '';
        vm.block_id = null;
        vm.season_name = '';
        vm.season_id = null;
        vm.week_ending_name = '';
        vm.week_ending_id = null;
        vm.filterIds = [];
        vm.filterTitle     = '';
        calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
      }

      else {
        if (type === 'shipper') {
          vm.shipper_name = name;
          vm.shipper_id = id;
        }

        else if (type === 'foreman') {
          vm.foreman_name = name;
          vm.foreman_id = id;
        }

        else if (type === 'location') {
          vm.location_name = name;
          vm.location_id = id;
          RanchService.getRanchesByLocation(id).then(function(ranchesData) {
            vm.ranches=ranchesData.ranches;
          });
        }

        else if (type === 'ranch') {
          vm.ranch_name = name;
          vm.ranch_id = id;
          BlockService.getBlocksOfRanch(id).then(function(blocksData) {
            vm.blocks = blocksData.blocks;
          });
        }

        else if (type === 'block') {
          vm.block_name = name;
          vm.block_id = id;
        }

        else if (type === 'season') {
          vm.season_name = name;
          vm.season_id = id;
          filterWeekEndings(vm.season_id);
        }
        else if (type === 'week_ending') {
          vm.week_ending_name = name;
          vm.week_ending_id = id;
        }

        if(vm.filterTitle !== '') {
          vm.filterTitle = vm.filterTitle + ' - ' + name;
        }
        else {
          vm.filterTitle = name;
        }
      }
      vm.filterIds = [];
      vm.plantingSchedules = [];
      AreaFiscalYearService.getAreaFiscalYear(vm.areaFiscalYear_id).then(function(areaFiscalYearData) {
        var area_id = areaFiscalYearData.area_fiscal_year.area_id;
        getAllPlantingSchedules(area_id);
      });


      vm.loadListFiltered = false;
    //  $scope.loadingData = false;

    }

    /**
     * [getAllPlantingSchedules description]
     * @param  {[type]} area_id [description]
     * @return {[type]}         [description]
     */
    function getAllPlantingSchedules(/*area_id*/) {
      $scope.loadingData = true;
      vm.loadListFiltered = true;
    //  var promises = [];
  //    promises.push(
    /*  PlantingScheduleService.getAllForReports(area_id,vm.offset, vm.limit, vm.shipper_id, vm.location_id, vm.season_id, vm.week_ending_id).then(function(ContractSchedulesData) {
        if(PlantingSchedulesData && PlantingSchedulesData.planting_schedule) {
          vm.plantingSchedules = PlantingSchedulesData.planting_schedule;
        }*/
      var planting_block1 = {block: {id:3, name: 'SFsection01-BC01', ranch_name: 'SFsection01', location_name: 'Santa Fe', beds_number: 5, bed_direction: 'N-W', lines_per_bed: 100}};
      vm.plantingSchedules.push({id: 1, planting_block: planting_block1, shipper: {id: 2, name: 'Shipper Company'}, owner: {id: 2, name: 'Owner Company'},
        foreman: {id:5, name: 'Foreman'},  actual_wet_date: '2017-10-25', acres: 500, seed: {id: 1, name: 'seed test'}, variety: {id:1, name: 'variety test'},
        seed_spacing: 5 });

      var planting_block2 = {block: {id:9, name: 'PNsection01-bc05', ranch_name: 'PNsection01', location_name: 'Parana', beds_number: 20, bed_direction: 'S-W', lines_per_bed: 50}};
      vm.plantingSchedules.push({id: 2, planting_block: planting_block2, shipper: {id: 2, name: 'Shipper Company'},  owner: {id: 2, name: 'Owner Company'},
        foreman: {id:4, name: 'Foreman test'}, actual_wet_date: '2017-11-25', acres: 1000, seed: {id: 2, name: 'seed A'}, variety: {id:1, name: 'variety A'},
        seed_spacing: 2 });

      vm.plantingSchedules.forEach(function(plantingSchedule) {
        vm.filterIds.push(plantingSchedule.id);
        plantingSchedule.season = [];
        vm.seasons.forEach(function(season) {
          if(plantingSchedule.actual_wet_date>= season.start_day && plantingSchedule.actual_wet_date<=season.end_day) {
            plantingSchedule.season.id = season.id;
            plantingSchedule.season.name = season.name;
          }
        });


        var idx = _.find(vm.shippers, {'id': plantingSchedule.shipper.id});
        if (!idx) {
          vm.shippers.push({id: plantingSchedule.shipper.id, name:plantingSchedule.shipper.name});
        }
        vm.shippers = _.orderBy(vm.shippers, ['name']);

        idx = _.find(vm.foremans, {'id': plantingSchedule.foreman.id});
        if (!idx) {
          vm.foremans.push({id: plantingSchedule.foreman.id, name:plantingSchedule.foreman.name});
        }
        vm.foremans = _.orderBy(vm.foremans, ['name']);

      });

    //  })
  //  );
  //    Promise.all(promises).then(function() {
      groupPlantingScheduleReports();
      calculateTotals();
      vm.loadListFiltered = false;
      $scope.loadingData = false;
    //  });
    }

    /**
     * [filterWeekEndings description]
     * @param  {[type]} seasonId [description]
     * @return {[type]}          [description]
     */
    function filterWeekEndings(seasonId) {
      var idx = _.findIndex(vm.seasons, {'id': seasonId});
      var period_start = vm.seasons[idx].start_day;
      var period_end = vm.seasons[idx].end_day;
      calculateWeekEndings(period_start, period_end);
    }

    /**
     * [calculateWeekEndings description]
     * @return {[type]}
     */
    function calculateWeekEndings(period_start, period_end) {
      var endings = [];
      var end = moment(period_end);
      var next_saturday = moment(period_start).day('Saturday').startOf('day')._d;
      while (next_saturday < end) {
        var obj = {
          id: next_saturday,
          name: $filter('date')(next_saturday)
        };
        endings.push(obj);
        next_saturday = moment(next_saturday.toISOString()).add(7, 'days')._d;
      }
      vm.allWeekEnding = endings;
    }

    /**
     * [groupPlantingScheduleReports description]
     * @return {[type]} [description]
     */
    function groupPlantingScheduleReports() {
      var count = 0;
      var next_saturday = null;
      var lastIndex = 0, minIndex = 0, totalAcres=0;
      var insertedPlantingFlag = false;
      var planting_schedules = [];
      vm.allWeekEnding.forEach(function (weekEnding) {
        vm.orderedPlantingSchedules[count] = [];
        vm.orderedPlantingSchedules[count].planting_schedules = [];
        for (var i = minIndex; i < vm.plantingSchedules.length; i++) {
          next_saturday = moment(vm.plantingSchedules[i].actual_wet_date).day('Saturday').startOf('day').format('YYYY-MM-DD');
          if(next_saturday === moment(weekEnding.id).startOf('day').format('YYYY-MM-DD')) {
            planting_schedules.push(vm.plantingSchedules[i]);

            //vm.orderedPlantingSchedules[count].push(vm.plantingSchedules[i]);
            insertedPlantingFlag = true;
            lastIndex = i;
            totalAcres = totalAcres + vm.plantingSchedules[i].acres;

          }
        }

        vm.orderedPlantingSchedules[count].planting_schedules=planting_schedules;
        vm.orderedPlantingSchedules[count].week_ending=weekEnding.id;
        vm.orderedPlantingSchedules[count].total_acres=parseInt(totalAcres);
        totalAcres=0;
        planting_schedules=[];
        if(insertedPlantingFlag) {
          minIndex = lastIndex + 1;
          insertedPlantingFlag = false;
        }
        count++;
      });

    }

    /**
     * [calculateTotals description]
     * @return {[type]} [description]
     */
    function calculateTotals() {
      vm.annualTotal = 0;
      vm.seasonsTotals=[];
      vm.plantingSchedules.forEach(function(plantingSchedule) {
        if(plantingSchedule.season.id) {
          var idx = _.findIndex(vm.seasonsTotals, {'id': plantingSchedule.season.id});
          if(idx < 0) {
            vm.seasonsTotals.push({id: plantingSchedule.season.id, name:plantingSchedule.season.name, total: parseInt(plantingSchedule.acres)});
          }
          else {
            var acresSum = vm.seasonsTotals[idx].total;

            vm.seasonsTotals[idx].total = acresSum + parseInt(plantingSchedule.acres);
          }
        }
      });

      vm.seasonsTotals.forEach(function(seasonTotal) {
        vm.annualTotal += seasonTotal.total;
      });
    }

    /**
     * [toggleWeekEndingTotals description]
     * @return {[type]} [description]
     */
    function toggleWeekEndingTotals() {
      vm.byWetDate = !vm.byWetDate;
      groupPlantingScheduleReports(vm.byWetDate);
      calculateTotals();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.reports.grower-schedule-report', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.pages_grower-schedule-report', {
      url      : '/grower-schedule-report',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/reports/grower-schedule-report/grower-schedule-report.html',
          controller : 'GrowerScheduleReportCtrl as vm'
        }
      },
      bodyClass: 'reports',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('grower_schedule_report')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/reports/grower-schedule-report');


    // // Navigation
    msNavigationServiceProvider.saveItem('pages.reports.grower-schedule-report', {
      title : 'Master Schedule',
      icon  : 'icon-chart-areaspline',
      state : 'app.pages_grower-schedule-report',
      weight: 14
    });
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.reports.grower-schedule-report')
    .controller('GrowerScheduleReportCtrl', GrowerScheduleReportCtrl);


  /** @ngInject */
  function GrowerScheduleReportCtrl(
    $scope,
    AreaFiscalYearService,
    AreaService,
    SeasonsService,
    $filter,
    api,
    _,
    GrowerScheduleService,
    RanchService,
    BlockService,
    FiscalYearSeasonsService
  ) {

    // Data
    var vm = this;
    vm.active_filters              = [];
    vm.listType                    = 'all';
    vm.locations                   = [];
    vm.filterIds                   = [];
    vm.allSeasons                  = [];
    vm.allWeekEnding               = [];
    vm.shownGrowerSchedules      = [];
    vm.growerSchedules           = [];
    vm.loadListFiltered            = false;
    vm.seasons                     = [];
    vm.shippers                    = [];
    vm.pcaUsers                    = [];
    vm.shipper                     = [];
    vm.isFarmOwner                 = true;
    vm.filterTitle                 = '';
    vm.shipper_id                  = null;
    vm.shipper_name                = '';
    vm.pca_id                      = null;
    vm.pca_name                    = '';
    vm.block_id                    = null;
    vm.block_name                  = '';
    vm.ranch_id                    = null;
    vm.ranch_name                  = '';
    vm.location_id                 = null;
    vm.location_name               = '';
    vm.season_id                   = null;
    vm.season_name                 = '';
    vm.week_ending_id              = null;
    vm.week_ending_name            = '';
    vm.offset                      = 0;
    vm.limit                       = 100;
    vm.orderedGrowerSchedules    = [];
    vm.seasonsTotals               = [];
    vm.annualTotal                 = 0;
    vm.area_id                     = null;
    vm.areaFiscalYear_id           = null;
    vm.fiscal_year                 = null;
    vm.byWetDate                   = true;
    vm.startYear                   = null;
    vm.endYear                     = null;
    vm.ranches                     = [];
    vm.blocks                      = [];
    vm.fiscalYearId                = null;


    // Methods
    vm.filterChange                = filterChange;
    vm.toggleWeekEndingTotals      = toggleWeekEndingTotals;

    //////////
    init ();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      $scope.loadingData = true;

      var user = sessionStorage.getItem('user');
      vm.user = JSON.parse(user);

      vm.areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;

      AreaFiscalYearService.getAreaFiscalYear(vm.areaFiscalYear_id).then(function(areaFiscalYearData) {
        // calculate week endings of Fiscal Year
        if (areaFiscalYearData && areaFiscalYearData.area_fiscal_year && areaFiscalYearData.area_fiscal_year.fiscal_year) {
          vm.fiscal_year = areaFiscalYearData.area_fiscal_year.fiscal_year;
          vm.fiscalYearId = vm.fiscal_year.id;
          vm.startYear = new Date (vm.fiscal_year.begin_date);
          vm.startYear = vm.startYear.getFullYear();
          vm.endYear = new Date (vm.fiscal_year.end_date);
          vm.endYear = vm.endYear.getFullYear();
          calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
        }
        vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
        AreaService.getAreaLocations(vm.area_id).then(function(locationsData) {
          vm.locations = locationsData.locations;
        },
        function(err) {
          console.error(err);
        });

        /* Get all shippers */
        GrowerScheduleService.getAllAssociatedShippers().then(function(ShippersData) {
          vm.shippers = ShippersData.shippers;
        });

        /* Get all PCAs */
        GrowerScheduleService.getAllAssociatedPcaUsers().then(function(PcaUsersData) {
          vm.pcaUsers = PcaUsersData.pcaUsers;
        });

        /* Get all seasons */
        SeasonsService.getList().then(function(seasonsData) {
          vm.seasons = seasonsData.seasons;
        },
        function(err) {
          console.error(err);
        });

        var flagRole = false;
        api.companies.get({id:vm.user.company_id}, function(companyData) {
          angular.forEach(companyData.company.business_roles, function(businessRole) {
            if(businessRole.name === 'Farm Owner')   flagRole = true;
          });

          if(!flagRole) {
            vm.isFarmOwner = false;
            vm.shipper_id = vm.user.company_id;
          }

          getAllGrowerSchedules(vm.fiscalYearId);
        });

      },
      function(err) {
        console.error(err);
      });



    }

    /**
     * [filterChange description]
     * @param  {[type]} type [description]
     * @param  {[type]} id   [description]
     * @param  {[type]} name [description]
     * @return {[type]}      [description]
     */
    function filterChange(type, id, name) {
      vm.loadListFiltered = true;
      $scope.loadingData=true;
      vm.listType = type;

      if (type === 'all') {
        if(vm.isFarmOwner) {
          vm.shipper_name = '';
          vm.shipper_id = null;
          vm.pca_name = '';
          vm.pca_id = null;
        }
        vm.location_name = '';
        vm.location_id = null;
        vm.ranch_name = '';
        vm.ranch_id = null;
        vm.block_name = '';
        vm.block_id = null;
        vm.season_name = '';
        vm.season_id = null;
        vm.week_ending_name = '';
        vm.week_ending_id = null;
        vm.filterIds = [];
        vm.filterTitle     = '';
        calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
      }

      else {
        if (type === 'shipper') {
          vm.shipper_name = name;
          vm.shipper_id = id;
        }

        else if (type === 'pca') {
          vm.pca_name = name;
          vm.pca_id = id;
        }

        else if (type === 'location') {
          vm.location_name = name;
          vm.location_id = id;
          RanchService.getRanchesByLocation(vm.location_id).then(function(ranchesData) {
            vm.ranches=ranchesData.ranches;
          });
        }

        else if (type === 'ranch') {
          vm.ranch_name = name;
          vm.ranch_id = id;
          BlockService.getBlocksOfRanch(vm.ranch_id).then(function(blocksData) {
            vm.blocks = blocksData.blocks;
          });
        }

        else if (type === 'block') {
          vm.block_name = name;
          vm.block_id = id;
        }
        else if (type === 'season') {
          vm.season_name = name;
          vm.season_id = id;
          filterWeekEndings(vm.season_id);
        }
        else if (type === 'week_ending') {
          vm.week_ending_name = name;
          vm.week_ending_id = id;
        }

        if(vm.filterTitle !== '') {
          vm.filterTitle = vm.filterTitle + ' - ' + name;
        }
        else {
          vm.filterTitle = name;
        }
      }
      vm.filterIds = [];
      vm.growerSchedules = [];
      getAllGrowerSchedules(vm.fiscalYearId);

      vm.loadListFiltered = false;
    //  $scope.loadingData = false;

    }

    /**
    * [populateFields description]
    * @return {[type]} [description]
    */
    function getAllGrowerSchedules(fiscalYearId) {
      $scope.loadingData = true;
      vm.loadListFiltered = true;
      var data = {
        offset: vm.offset,
        limit: vm.limit,
        for_reports: true,
        fiscal_year_id: fiscalYearId,
        by_wet_date: vm.byWetDate,
        period_start: vm.fiscal_year.begin_date,
        period_end: vm.fiscal_year.end_date,
        company_id: vm.shipper_id,
        pca_user_id: vm.pca_id,
        block_id: vm.block_id,
        ranch_id: vm.ranch_id,
        location_id: vm.location_id,
        season_id: vm.season_id,
        week_ending: vm.week_ending_id
      };
      GrowerScheduleService.getAllForReports(data).then(function(GrowerSchedulesData) {
        if(GrowerSchedulesData && GrowerSchedulesData.grower_schedules) {
          vm.growerSchedules = GrowerSchedulesData.grower_schedules;
          vm.filterIds = GrowerSchedulesData.filter_ids;
          vm.seasonsTotals = GrowerSchedulesData.seasons_totals;
          vm.annualTotal = GrowerSchedulesData.annual_total;
        }

      });

      vm.loadListFiltered = false;
      $scope.loadingData = false;

    }

    /**
     * [filterWeekEndings description]
     * @param  {[type]} seasonId [description]
     * @return {[type]}          [description]
     */
    function filterWeekEndings(seasonId) {
      FiscalYearSeasonsService.getByFiscalYearSeason(vm.fiscalYearId, seasonId).then(function(fiscalYearSeasonData) {
        var period_start = fiscalYearSeasonData.fiscal_year_seasons[0].start_date;
        var period_end = fiscalYearSeasonData.fiscal_year_seasons[0].end_date;
        calculateWeekEndings(period_start, period_end);
      });
    }

    /**
     * [calculateWeekEndings description]
     * @return {[type]}
     */
    function calculateWeekEndings(period_start, period_end) {
      var endings = [];
      var end = moment(period_end);
      var next_saturday = moment(period_start).day('Saturday').startOf('day')._d;
      while (next_saturday < end) {
        var obj = {
          id: next_saturday,
          name: $filter('date')(next_saturday)
        };
        endings.push(obj);
        next_saturday = moment(next_saturday.toISOString()).add(7, 'days')._d;
      }
      vm.allWeekEnding = endings;
    }



    /**
     * [toggleWeekEndingTotals description]
     * @return {[type]} [description]
     */
    function toggleWeekEndingTotals() {
      vm.byWetDate = !vm.byWetDate;
      vm.fitlerIds = [];
      vm.growerSchedules = [];
      getAllGrowerSchedules(vm.fiscalYearId);

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.reports.contract-schedule-report', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.pages_contract-schedule-report', {
      url      : '/contract-schedule-report',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/reports/contract-schedule-report/contract-schedule-report.html',
          controller : 'ContractScheduleReportCtrl as vm'
        }
      },
      bodyClass: 'reports',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('contract_schedule_report')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/reports/contract-schedule-report');


    // // Navigation
    msNavigationServiceProvider.saveItem('pages.reports.contract-schedule-report', {
      title : 'Contract Schedule',
      icon  : 'icon-chart-areaspline',
      state : 'app.pages_contract-schedule-report',
      weight: 16
    });
  }

})();

(function() {
  'use strict';

  angular
  .module('app.pages.reports.contract-schedule-report')
  .controller('ContractScheduleReportCtrl', ContractScheduleReportCtrl);


  /** @ngInject */
  function ContractScheduleReportCtrl(
    $scope,
    AreaFiscalYearService,
    AreaService,
    SeasonsService,
    $filter,
    api,
    _,
    ContractScheduleVarietiesService,
    FiscalYearSeasonsService
  ) {

    // Data
    var vm = this;
    vm.active_filters              = [];
    vm.listType                    = 'all';
    vm.locations                   = [];
    vm.filterIds                   = [];
    vm.allSeasons                  = [];
    vm.allWeekEnding               = [];
    vm.shownContractSchedules      = [];
    vm.contractSchedules           = [];
    vm.loadListFiltered            = false;
    vm.seasons                     = [];
    vm.shippers                    = [];
    vm.shipper                     = [];
    vm.isFarmOwner                 = true;
    vm.filterTitle                 = '';
    vm.shipper_id                  = null;
    vm.shipper_name                = '';
    vm.location_id                 = null;
    vm.location_name               = '';
    vm.season_id                   = null;
    vm.season_name                 = '';
    vm.week_ending_id              = null;
    vm.week_ending_name            = '';
    vm.offset                      = 0;
    vm.limit                       = 100;
    vm.orderedContractSchedules    = [];
    vm.seasonsTotals               = [];
    vm.annualTotal                 = 0;
    vm.area_id                     = null;
    vm.areaFiscalYear_id           = null;
    vm.fiscal_year                 = null;
    vm.byWetDate                   = true;
    vm.startYear                   = null;
    vm.endYear                     = null;
    vm.fiscalYearId                = null;


    // Methods
    vm.filterChange                = filterChange;
    vm.toggleWeekEndingTotals      = toggleWeekEndingTotals;

    //////////
    init ();

    /**
    * [init description]
    * @return {[type]} [description]
    */
    function init() {
      $scope.loadingData = true;

      var user = sessionStorage.getItem('user');
      vm.user = JSON.parse(user);

      vm.areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;

      AreaFiscalYearService.getAreaFiscalYear(vm.areaFiscalYear_id).then(function(areaFiscalYearData) {
        // calculate week endings of Fiscal Year
        if (areaFiscalYearData && areaFiscalYearData.area_fiscal_year && areaFiscalYearData.area_fiscal_year.fiscal_year) {
          vm.fiscal_year = areaFiscalYearData.area_fiscal_year.fiscal_year;
          vm.fiscalYearId = vm.fiscal_year.id;
          vm.startYear = new Date (vm.fiscal_year.begin_date);
          vm.startYear = vm.startYear.getFullYear();
          vm.endYear = new Date (vm.fiscal_year.end_date);
          vm.endYear = vm.endYear.getFullYear();
          calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
        }
        vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
        AreaService.getAreaLocations(vm.area_id).then(function(locationsData) {
          vm.locations = locationsData.locations;
        },
        function(err) {
          console.error(err);
        });

        /* Get all shippers */
        ContractScheduleVarietiesService.getAllAssociatedShippers().then(function(ShippersData) {
          vm.shippers = ShippersData.shippers;
        });

        /* Get all seasons */
        SeasonsService.getList().then(function(seasonsData) {
          vm.seasons = seasonsData.seasons;
        },
        function(err) {
          console.error(err);
        });


        var flagRole = false;
        api.companies.get({id:vm.user.company_id}, function(companyData) {
          angular.forEach(companyData.company.business_roles, function(businessRole) {
            if(businessRole.name === 'Farm Owner')   flagRole = true;
          });

          if(!flagRole) {
            vm.isFarmOwner = false;
            vm.shipper_id = vm.user.company_id;
          }
          getAllContractScheduleVarieties(vm.area_id, vm.fiscalYearId);
        });


      },
      function(err) {
        console.error(err);
      });



    }

    /**
    * [filterChange description]
    * @param  {[type]} type [description]
    * @param  {[type]} id   [description]
    * @param  {[type]} name [description]
    * @return {[type]}      [description]
    */
    function filterChange(type, id, name) {
      vm.loadListFiltered = true;
      $scope.loadingData=true;
      vm.listType = type;

      if (type === 'all') {
        if(vm.isFarmOwner) {
          vm.shipper_name = '';
          vm.shipper_id = null;
        }
        vm.location_name = '';
        vm.location_id = null;
        vm.season_name = '';
        vm.season_id = null;
        vm.week_ending_name = '';
        vm.week_ending_id = null;
        vm.filterIds = [];
        vm.filterTitle     = '';
        calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
      }

      else {
        if (type === 'shipper') {
          vm.shipper_name = name;
          vm.shipper_id = id;
        }

        else if (type === 'location') {
          vm.location_name = name;
          vm.location_id = id;
        }

        else if (type === 'season') {
          vm.season_name = name;
          vm.season_id = id;
          filterWeekEndings(vm.season_id);
        }
        else if (type === 'week_ending') {
          vm.week_ending_name = name;
          vm.week_ending_id = id;
        }

        if(vm.filterTitle !== '') {
          vm.filterTitle = vm.filterTitle + ' - ' + name;
        }
        else {
          vm.filterTitle = name;
        }
      }
      vm.filterIds = [];
      vm.contractSchedules = [];
      getAllContractScheduleVarieties(vm.area_id, vm.fiscalYearId);

      vm.loadListFiltered = false;
      //  $scope.loadingData = false;

    }

    /**
    * [populateFields description]
    * @return {[type]} [description]
    */
    function getAllContractScheduleVarieties(area_id, fiscal_year_id) {
      $scope.loadingData = true;
      vm.loadListFiltered = true;
      var data = {
        for_reports: true,
        offset: vm.offset,
        limit: vm.limit,
        area_id: area_id,
        fiscal_year_id: fiscal_year_id,
        by_wet_date: vm.byWetDate,
        period_start: vm.fiscal_year.begin_date,
        period_end: vm.fiscal_year.end_date,
        company_id: vm.shipper_id,
        location_id: vm.location_id,
        season_id: vm.season_id,
        week_ending: vm.week_ending_id
      };
      ContractScheduleVarietiesService.getAllForReports(data).then(function(ContractSchedulesData) {
        if(ContractSchedulesData && ContractSchedulesData.contract_schedule_varieties) {
          vm.contractSchedules = ContractSchedulesData.contract_schedule_varieties;
          vm.filterIds = ContractSchedulesData.filter_ids;
          vm.seasonsTotals = ContractSchedulesData.seasons_totals;
          vm.annualTotal = ContractSchedulesData.annual_total;
        }
        vm.loadListFiltered = false;
        $scope.loadingData = false;

      });



    }

    /**
    * [filterWeekEndings description]
    * @param  {[type]} seasonId [description]
    * @return {[type]}          [description]
    */
    function filterWeekEndings(seasonId) {
      var data = {
        fiscal_year_id: vm.fiscalYearId,
        season_id: seasonId
      };
      FiscalYearSeasonsService.getByFiscalYearSeason(data).then(function(fiscalYearSeasonData) {
        var period_start = fiscalYearSeasonData.fiscal_year_seasons[0].start_date;
        var period_end = fiscalYearSeasonData.fiscal_year_seasons[0].end_date;
        calculateWeekEndings(period_start, period_end);
      });
    }

    /**
    * [calculateWeekEndings description]
    * @return {[type]}
    */
    function calculateWeekEndings(period_start, period_end) {
      var endings = [];
      var end = moment(period_end);
      var next_saturday = moment(period_start).day('Saturday').startOf('day')._d;
      while (next_saturday < end) {
        var obj = {
          id: next_saturday,
          name: $filter('date')(next_saturday)
        };
        endings.push(obj);
        next_saturday = moment(next_saturday.toISOString()).add(7, 'days')._d;
      }
      vm.allWeekEnding = endings;
    }



    /**
    * [toggleWeekEndingTotals description]
    * @return {[type]} [description]
    */
    function toggleWeekEndingTotals() {
      vm.byWetDate = !vm.byWetDate;
      vm.fitlerIds = [];
      vm.contractSchedules = [];
      getAllContractScheduleVarieties(vm.area_id, vm.fiscalYearId);

    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.planting-schedule', ['ms-infinite-scroll', 'dynamicNumber', 'ms-resize'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.pages_planting-schedule', {
      url      : '/planting-schedule',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/planting-schedule/planting-schedule.html',
          controller : 'PlantingScheduleCtrl as vm'
        }
      },
      bodyClass: 'planting-schedule',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('planting_schedule')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.pages_planting-schedule_edit', {
      url      : '/planting-schedule/edit/:id',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/planting-schedule/tabs/tabs.html',
          controller : 'PlantingScheduleTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('planting_schedule')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.pages_planting-schedule_add', {
      url      : '/planting-schedule/add',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/planting-schedule/tabs/tabs.html',
          controller : 'PlantingScheduleTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('planting_schedule')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/planting-schedule');

    // Navigation
    msNavigationServiceProvider.saveItem('pages.planting-schedule', {
      title : 'Planting Schedule',
      icon  : 'icon-leaf',
      state : 'app.pages_planting-schedule',
      weight: 11
    });

  }

})();

(function () {
  'use strict';

  angular
    .module('app.pages.planting-schedule')
    .controller('PlantingScheduleTabsCtrl', PlantingScheduleTabsCtrl);

  /** @ngInject */
  function PlantingScheduleTabsCtrl(
    $q,
    $location,
    $filter,
    $mdToast,
    PlantingScheduleService,
    PlantingScheduleBlockInformationService,
    PlantingSchedulePlantingInformationService,
    $mdDialog,
    $document,
    $translate,
    $state,
    $stateParams,
    msUtils,
    api,
    $scope
  ) {
    $scope.event = window.event;

    var vm = this;

    vm.newPlantingSchedule = {};
    vm.blockInformation = [];
    vm.blockNumber = null;
    vm.plantingInformation = [];
    vm.newBlock = false;


    var user = sessionStorage.getItem('user');
    vm.user = JSON.parse(user);

    // Methods
    vm.init = init;
    vm.addPlantingSchedule = addPlantingSchedule;
    vm.addPlantingScheduleBlockInformation = addPlantingScheduleBlockInformation;
    vm.clearInformation = clearInformation;
    vm.showDialogPlantingScheduleInformation = showDialogPlantingScheduleInformation;

    vm.backListing = backListing;

    vm.error = undefined;

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      $scope.loadingData = true;
      if ($stateParams.id) {
        vm.newBlock = false;
        var user = sessionStorage.getItem('user');
        if (user) {
          vm.user = JSON.parse(user);

          PlantingScheduleBlockInformationService.get().then(function (BlockInformation) {
            vm.blockInformation = BlockInformation[$stateParams.id];

            PlantingSchedulePlantingInformationService.get().then(function (PlantingInformation) {
              PlantingInformation.forEach(function (info) {
                if (info.parent_id == $stateParams.id) {
                  vm.plantingInformation.push(info);
                }
              });

              PlantingScheduleService.get().then(function (PlantingSchedule) {
                PlantingSchedule.forEach(function (schedule) {
                  if (schedule.id == $stateParams.id) {
                    vm.blockNumber = schedule.block;
                  }
                });
              });

            });

            $scope.loadingData = false;
          },
            function (err) {
              console.error(err);
            });



        }
      }
      else {
        vm.newPlantingSchedule = {};
        vm.newBlock = true;
      }
    }

    /**
     * [addPlantingSchedule description]
     */
    function addPlantingSchedule() {
      PlantingScheduleService.save(vm.newPlantingSchedule).then(function (PlantingSchedule) {
        $location.url('/planting-schedule/edit/' + PlantingSchedule.id);
      });
    }

    /**
     * [addPlantingScheduleBlockInformation description]
     */
    function addPlantingScheduleBlockInformation() {
      PlantingScheduleBlockInformationService.save(vm.blockInformation).then(function () {
        $location.url('/planting-schedule/edit/' + $stateParams.id);
      });
    }

    /*** PLANTING SCHEDULE INFORMATION TAB ***/

     /**
      * Function to handle the behavior of add planting schedule information.
      * @param  {[type]} ev [description]
      * @return {[type]}    [description]
      */
    function showDialogPlantingScheduleInformation(ev) {

      $mdDialog.show({
        controller: 'PlantingScheduleInformationDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pages/planting-schedule/dialogs/planting-schedule-information/planting-schedule-information-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            parent_id: $stateParams.id,
            plantingInformationList: vm.plantingInformation
          }
        }
      });
    }

    /**
     * [clearInformation description]
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    function clearInformation(id) {
      vm.plantingInformation.forEach(function (info) {
        if (info.id == id) {
          info.acres = null;
          info.bed_count = null;
          info.bed_size = null;
          info.seed_spacing = null;
          info.number_of_lines = null;
          info.planting_date = null;
        }
      });
    }

    /**
     * Go to planting shedule page
     * @return {[type]} [description]
     */
    function backListing() {
      $location.url('/planting-schedule');
    }


  }
})();

(function () {
  'use strict';

  angular
    .module('app.pages.error-401', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.pages_errors_error-401', {
      url      : '/error-401',
      views    : {
        'main@'                             : {
          templateUrl: 'app/core/layouts/content-only.html',
          controller : 'MainController as vm'
        },
        'content@app.pages_errors_error-401': {
          templateUrl: 'app/main/pages/errors/401/error-401.html',
          controller : 'Error401Controller as vm'
        }
      },
      bodyClass: 'error-401'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/errors/401');
  }
})();
(function () {
  'use strict';

  angular
    .module('app.pages.error-401')
    .controller('Error401Controller', Error401Controller);

  /** @ngInject */
  function Error401Controller() {}
})();
(function() {
  'use strict';

  angular
    .module('app.pages.contracts', ['ms-infinite-scroll', 'dynamicNumber', 'ms-resize', 'ms-limit-to'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.pages_contracts', {
      url      : '/contracts',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/contracts/contracts.html',
          controller : 'ContractsCtrl as vm'
        }
      },
      bodyClass: 'contracts',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('contracts')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }

    }).state('app.pages_contracts_edit', {
      url      : '/contracts/edit/:id/:tab',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/contracts/tabs/tabs.html',
          controller : 'ContractsTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('contracts')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    }).state('app.pages_contracts_add', {
      url      : '/contracts/add',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/contracts/tabs/tabs.html',
          controller : 'ContractsTabsCtrl as vm'
        }
      },
      bodyClass: 'tabs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('contracts')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/contracts');

    // Navigation
    msNavigationServiceProvider.saveItem('pages.contracts', {
      title : 'Shipper Contracts',
      icon  : 'icon-file-document-box',
      state : 'app.pages_contracts',
      weight: 9
    });

  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.contracts')
    .controller('ContractsTabsCtrl', ContractsTabsCtrl);

  /** @ngInject */
  function ContractsTabsCtrl(
    $q,
    $location,
    $filter,
    $mdToast,
    ContractService,
    CompanyService,
    ContractScheduleService,
    ContractPaymentScheduleService,
    ContractScheduleVarietiesService,
    $mdDialog,
    $document,
    $translate,
    $state,
    $stateParams,
    msUtils,
    api,
    $scope,
    $rootScope,
    _,
    AreaFiscalYearService,
    GrowerScheduleService
  ) {
    $scope.event = window.event;

    var vm                  = this;
    vm.service              = ContractPaymentScheduleService;
    vm.entity               = 'contract';
    vm.selectedTab = null;
    vm.payment_finance_terms= [];
    vm.shippers             = [];
    vm.contract             = {};
    vm.crops                = [];
    vm.varieties            = [];
    vm.selected_crop        = null;
    vm.selected_crop_id     = null;
    vm.min_signature_date   = null;
    vm.min_start_date       = null;
    vm.savedData            = [];
    var user                = sessionStorage.getItem('user');
    vm.user                 = JSON.parse(user);
    vm.currentDay           = new Date ();
    vm.paymentsForm = {};
    vm.paymentsForm.$pristine     = true;
    vm.paymentsForm.$invalid      = true;



    /* Crops */
    vm.variety_title        = '';
    vm.growerScheduleData   = null;
    vm.cropIdsUpdated       = [];
    vm.cropsUpdated         = [];
    vm.isCropUpdated        = false;
    vm.cropsForm = {};
    vm.cropsForm.$pristine     = true;
    vm.cropsForm.$invalid      = true;

    // Methods
    vm.init                 = init;
    vm.tabsSave             = tabsSave;
    vm.saveCrops            = saveCrops;
    vm.addCropDialog        = addCropDialog;
    vm.addVarietyDialog     = addVarietyDialog;
    vm.viewGrowerDatesDialog= viewGrowerDatesDialog;
    vm.deleteVariety        = deleteVariety;
    vm.deleteCrop           = deleteCrop;
    vm.showVarieties        = showVarieties;
    vm.backListing          = backListing;
    vm.setMinDate           = setMinDate;
    vm.broadcast            = broadcast;
    vm.setStarred           = setStarred;
    $scope.customDateFormat = {
      formatDate: function(date) {
        var m = moment(date);
        return m.isValid() ? m.format('ll') : '';
      }
    };


    vm.paymentsUpdated            = [];
    vm.paymentUpdated             = false;
    vm.error                      = undefined;

    $rootScope.$on('paymentsForm', function(event, data, paymentsUpdated) {
      vm.paymentsUpdated = paymentsUpdated;
      vm.paymentsForm = data;
    });

    $rootScope.$on('cropsForm', function(event, cropsUpdated) {
      vm.cropsUpdated = cropsUpdated;
    });




    vm.cropsForm = {};
    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {

      $scope.loadingData = true;
      $scope.loadingDataCrop = true;

      if ($stateParams.id) {
        var user = sessionStorage.getItem('user');
        if(user) {
          vm.user = JSON.parse(user);
          var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;

          AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function() {
            ContractService.get($stateParams.id).then(function(ContractData) {
              if(ContractData && ContractData.contract && ContractData.contract.additional_incentive_total_amount) {
                ContractData.contract.additional_incentive_total_amount = msUtils.parseMoneyAsNumber(ContractData.contract.additional_incentive_total_amount);
              }
              vm.contract               = ContractData.contract;
              if (vm.contract.signature_date) {
                vm.min_signature_date   = new Date(vm.contract.signature_date);
                vm.min_start_date       = new Date(vm.contract.signature_date);
              }
              if (vm.contract.start_date) {
                vm.min_start_date       = new Date(vm.contract.start_date);
              }
              if (vm.contract.contract_schedule) {
                vm.contract_schedule    = _.orderBy(vm.contract.contract_schedule, ['id']);
                vm.crops                = vm.contract.contract_schedule;
              }

              vm.savedData = ContractScheduleVarietiesService.getData();

              if (vm.savedData.contract_schedule_id) {
                vm.selectedTab = 1;
                vm.selected_crop_id = vm.savedData.contract_schedule_id;
                var index     = _.findIndex(vm.crops, {id: vm.selected_crop_id});
                if(index >= 0) {
                  var crop = vm.crops[index];
                  vm.showVarieties(crop);
                }
                ContractScheduleVarietiesService.saveData([]);
              }
              $scope.loadingData = false;
              $scope.loadingDataCrop = false;
            },
            function(err) {
              console.error(err);
            });
          });
        }

      } else {
        vm.contract.signature_date = new Date();
        vm.contract.start_date = new Date();
        vm.contract.end_date = new Date();
      }

      // format Incentive Amount (money) as number

      // Get Shippers
      CompanyService.getCompanyByBusinessRole('shipper').then(function(companiesData) {
        vm.shippers = companiesData.companies;
      },
      function(err) {
        console.error(err);
      });

      // Get Payment Terms
      ContractService.getPaymentTerms().then(function(paymentTerms) {
        vm.payment_finance_terms = paymentTerms.payment_finance_terms;
      },
      function(err) {
        console.error(err);
      });

    }

	/**
     * [setMinDate description]
     */
    function setMinDate(field) {
      if (vm.contract[field + '_date']) {
        vm['min_' + field + '_date'] = vm.contract[field + '_date'];
        if (field == 'signature') {
          vm['min_start_date'] = vm.contract[field + '_date'];
          if (vm['min_' + field + '_date'] > new Date(vm.contract['start_date'])) {
            vm.contract['start_date'] = vm['min_' + field + '_date'].toISOString();
            if (vm['min_start_date'] > new Date(vm.contract['end_date'])) {
              vm.contract['end_date'] = vm['min_start_date'].toISOString();
            }
          }
        }
        if (field == 'start') {
          if (vm['min_' + field + '_date'] > new Date(vm.contract['end_date'])) {
            vm.contract['end_date'] = vm['min_' + field + '_date'].toISOString();
          }
        }

      }
    }

    /**
     * Go to contracts page
     * @return {[type]} [description]
     */
    function backListing () {
      $location.url('/contracts');
    }

    /*** INFORMATION TAB ***/

    /**
     * Function to save each tab information.
     * @return {[type]} [description]
     */
    function tabsSave() {
      var dataToPut = angular.copy(vm.contract);
      if (dataToPut.contract_payment_schedule) {
        delete dataToPut.contract_payment_schedule;
      }
      if (dataToPut.contract_schedule) {
        delete dataToPut.contract_schedule;
      }
      if(vm.contract.id) {
        var promises  = [];
        vm.paymentsUpdated.forEach(function(payment) {
          promises.push(
            ContractPaymentScheduleService.update(payment.id, payment).then(function() {
            }).catch(function(error) {
              vm.errorPayment=error.data.message;
            })
          );
        });

        vm.cropsUpdated.forEach(function(crop) {
          crop.acres = parseFloat(crop.acres);
          crop.amount_per_acre = parseFloat(crop.amount_per_acre);
          crop.incentive_amount_per_acre = parseFloat(crop.incentive_amount_per_acre);
          promises.push(
            ContractScheduleService.update(crop.id, crop).then(
              function() {
              }).catch(function(error) {
                vm.errorCrop=error.data.message;
              })
          );
        });

        Promise.all(promises).then(function() {
          if(vm.errorPayment === undefined && vm.errorCrop === undefined) {
            ContractService.update(vm.contract.id, dataToPut).then(function () {
              $mdToast.show({
                template: '<md-toast class="md-toast success">The contract '+ vm.contract.number + ' has been updated.</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });
            },
            function() { // Reject
              $mdToast.show({
                template: '<md-toast class="md-toast error">The contract '+ vm.contract.name + ' could not be updated.</md-toast>',
                position: 'top right',
                hideDelay: 6000
              });
            });
          }
          else {
            if(vm.errorPayment !== undefined) {
              $mdToast.show({
                template: '<md-toast class="md-toast error">Payment Schedules could not be updated. </md-toast>',
                position: 'top right',
                hideDelay: 6000
              });
            }
            else {
              $mdToast.show({
                template: '<md-toast class="md-toast error">Crops could not be updated. </md-toast>',
                position: 'top right',
                hideDelay: 6000
              });
            }
          }
        });
      } else {
        vm.contract = {
          area_fiscal_year_id : (vm.user && vm.user.default_global_area_fiscal_year_id) ? vm.user.default_global_area_fiscal_year_id: '',
          company_id          : vm.contract.company_id,
          number              : vm.contract.number,
          signature_date      : vm.contract.signature_date,
          start_date          : vm.contract.start_date,
          end_date            : vm.contract.end_date,
          payment_finance_terms : vm.contract.payment_finance_terms,
          starred             : vm.contract.starred,
          description         : vm.contract.description || '',
          incentive_amount    : vm.contract.incentive_amount
        };
        ContractService.create(vm.contract).then(
        function(data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The contract '+ vm.contract.number + ' has been created.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          //vm.contract = data.contract;
          $location.url('/contracts/edit/' + data.contract.id + '/' + 0);
        },
        function(err) { //reject
          var error;
          if(err.status && err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The contract '+ vm.contract.number + ' could not be created. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        }
      );
      }
    }
    /*** CROPS TAB ***/

    /**
     * Function to handle the behavior of add crop.
     */
    function addCropDialog(ev, crop) {
      var aux_crop = {};
      if (crop) {
        aux_crop = angular.copy(crop);
        aux_crop.acres = parseFloat(aux_crop.acres);
        aux_crop.amount_per_acre = msUtils.parseMoneyAsNumber(aux_crop.amount_per_acre);
        aux_crop.incentive_amount_per_acre = msUtils.parseMoneyAsNumber(aux_crop.incentive_amount_per_acre);
      }
      $mdDialog.show({
        controller         : 'CropDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/pages/contracts/dialogs/crop/crop-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: false,
        locals             : {
          dialogData: {
            crops          : vm.crops,
            crop           : (crop) ? aux_crop : '',
            selected_crop  : vm.selected_crop,
            contract       : vm.contract
          }
        }
      })
      .finally(function() {
        vm.showVarieties(crop, true);
      });
    }

    /**
     * Show contract_schedule_varieties from selected contract_schedule
     * @param  {[type]} crop      [selected crop]
     * @param  {[type]} titleOnly [update only the title of variety wet date table, without refresh items]
     * @return {[type]}
     */
    function showVarieties(crop, titleOnly) {
      if (event) {
        event.stopPropagation();
      }
      vm.variety_title = {
        'seed'    : crop.seed.name,
        'acres'   : crop.acres
      };
      vm.selected_crop = crop;
      if (!titleOnly) {
        if (crop.hasOwnProperty('contract_schedule_varieties')) {
          vm.varieties = crop.contract_schedule_varieties;
          vm.varieties.forEach(function(variety) {
            GrowerScheduleService.getVarietyWetDates(variety.id).then(function(growerData) {
              if(growerData && growerData.grower_schedules) {
                variety.growerScheduleData = growerData.grower_schedules;
              }
            });
          });
        } else {
          vm.varieties = [];
        }
      }
    }

    /**
     * Function to save Crops
     * @return {[type]} [description]
     */
    function saveCrops() {
    }

    /**
     * [deleteCrop description]
     * @param  {[type]} ev      [description]
     * @param  {[type]} variety [description]
     * @return {[type]}
     */
    function deleteCrop(ev, crop) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('CONTRACTS.CROPS.ARE_YOU_SURE_TO_DELETE'))
        .htmlContent('The crop will be deleted.')
        .ariaLabel('delete crop')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        ContractScheduleService.delete(crop.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The crop were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          var pos = _.findIndex(vm.crops, {'id': crop.id});
          if (crop.id !== undefined &&  pos > -1) {
            vm.crops.splice(pos, 1);
            updateLocalContractData();
          }
        },
        function (err) {
          var error = 'The crop could not be deleted.';
          if (err.data && err.data.message) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">' + error + '</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Function to handle the behavior of add variety
     */
    function addVarietyDialog(ev, variety) {
      if (vm.selected_crop) {
        // search crop again to check if has changed its data
        vm.selected_crop = _.find(vm.crops, {id: vm.selected_crop.id});
        var aux_variety = {};
        if (variety) {
          aux_variety = angular.copy(variety);
          aux_variety.acres = parseFloat(aux_variety.acres);
          aux_variety.acres_scheduled = parseFloat(aux_variety.acres_scheduled);
        }
        $mdDialog.show({
          controller         : 'ContractVarietyDialogController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/pages/contracts/dialogs/variety/variety-dialog.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: false,
          locals             : {
            dialogData: {
              contract_schedule_id  : vm.selected_crop.id,
              seed_id               : vm.selected_crop.seed_id,
              seed_name             : vm.selected_crop.seed.name,
              varieties_wet_dates   : vm.varieties,
              variety               : (variety) ? aux_variety : '',
              contract              : vm.contract
            }
          }
        })
        .finally(function() {
          vm.showVarieties(vm.selected_crop, true);
        });
      } else {
        $mdToast.show({
          template: '<md-toast class="md-toast error">Please, first select a contracted crop.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      }
    }

    /**
     * Function to handle the behavior of view Grower Dates
     */
    function viewGrowerDatesDialog(ev, variety) {
      if(!variety.growerScheduleData) {
        var confirm = $mdDialog.confirm()
         .htmlContent('Seed / Variety not yet scheduled within Grower Schedule')
         .ariaLabel('Variety not scheduled')
         .targetEvent(ev)
         .ok('OK');

        $mdDialog.show(confirm).then(function () {
        }, function () {

        });
      }
      else {
        $mdDialog.show({
          controller         : 'GrowerDatesDialogController',
          controllerAs       : 'vm',
          templateUrl        : 'app/main/pages/contracts/dialogs/grower-dates/grower-dates-dialog.html',
          parent             : angular.element($document.body),
          targetEvent        : ev,
          clickOutsideToClose: true,
          locals             : {
            dialogData: {
              growerData  : variety.growerScheduleData,
              varietyName : variety.variety.name
            }
          }
        });
      }
    }

    /**
     * [deleteVariety description]
     * @param  {[type]} ev      [description]
     * @param  {[type]} variety [description]
     * @return {[type]}
     */
    function deleteVariety(ev, variety) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('CONTRACTS.VARIETIES.ARE_YOU_SURE_TO_DELETE'))
        .htmlContent('The variety wet date will be deleted.')
        .ariaLabel('delete variety wet date')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        ContractScheduleVarietiesService.delete(variety.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The variety wet date were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          var pos = _.findIndex(vm.varieties, {'id': variety.id});
          if (variety.id !== undefined &&  pos > -1) {
            vm.varieties.splice(pos, 1);
            updateLocalContractData(true);
          }
        },
        function (err) {
          var error = 'The variety wet date could not be deleted.';
          if (err.data && err.data.message) {
            error = err.data.message;
          }

          $mdToast.show({
            template: '<md-toast class="md-toast error">' + error + '</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Update acres, total_amount_per_acre & total_incentive_amount_per_acre from contract information
     * @param  {[type]} variety_deleted [If true, also update selected contract_schedule information]
     * @return {[type]}
     */
    function updateLocalContractData(variety_deleted) {
      ContractService.get(vm.contract.id, {'exclude_related': 'contract_payment_schedule,company'}).then(
        function(response) {
          vm.contract.acres = response.contract.acres;
          vm.contract.total_amount_per_acre = response.contract.total_amount_per_acre;
          vm.contract.total_incentive_amount_per_acre = response.contract.total_incentive_amount_per_acre;
          // if variety was deleted, also update the contract schedule acres
          if (variety_deleted) {
            var local_idx     = _.findIndex(vm.contract.contract_schedule, {id: vm.selected_crop.id});
            var api_idx       = _.findIndex(response.contract.contract_schedule, {id: vm.selected_crop.id});
            if (local_idx > -1 && api_idx > -1) {
              vm.contract.contract_schedule[local_idx].acres = response.contract.contract_schedule[api_idx].acres;
              vm.selected_crop.acres = vm.contract.contract_schedule[local_idx].acres;
              vm.showVarieties(vm.selected_crop, true);
            }
          }
        },
        function(err) {
          console.error(err);
        }
      );
    }

      /**
   * [broadcast description]
   * @return {[type]} [description]
   */
    function broadcast(crop) {
      if(vm.cropIdsUpdated.indexOf(crop.id)<0) {
        vm.cropIdsUpdated.push(crop.id);
        vm.cropsUpdated.push(crop);
        vm.isCropUpdated = true;
      }
      $rootScope.$broadcast('cropsForm', vm.cropsUpdated);
    }

    /**
     * [setStarred description]
     */
    function setStarred() {
      vm.informationForm.$pristine = false;
      vm.contract.starred = !vm.contract.starred;
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.pages.auth.register', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {
    // State
    $stateProvider.state('app.pages_auth_register', {
      url      : '/register',
      views    : {
        'main@'                          : {
          templateUrl: 'app/core/layouts/content-only.html',
          controller : 'MainController as vm'
        },
        'content@app.pages_auth_register': {
          templateUrl: 'app/main/pages/auth/register/register.html',
          controller : 'RegisterController as vm'
        }
      },
      bodyClass: 'register'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

    // Navigation
    msNavigationServiceProvider.saveItem('pages.auth.register', {
      title : 'Register',
      state : 'app.pages_auth_register',
      weight: 3
    });
  }
})();
(function () {
  'use strict';

  angular
    .module('app.pages.auth.register')
    .controller('RegisterController', RegisterController);

  /** @ngInject */
  function RegisterController()
  {
    // Data

    // Methods

    //////////
  }
})();
(function() {
  'use strict';

  angular
    .module('app.pages.auth.login', [
      'ngFileUpload',
      'uiCropper',
      'ui.mask',
      'ms-load-image'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.pages_auth_login', {
      url      : '/login',
      views    : {
        'main@'                  : {
          templateUrl: 'app/core/layouts/content-only.html',
          controller : 'MainController as vm'
        },
        'content@app.pages_auth_login': {
          templateUrl: 'app/main/pages/auth/login/login.html',
          controller : 'LoginController as vm'
        }
      },
      bodyClass: 'login'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/auth/login');
  }

})();

(function() {
  'use strict';

  angular
    .module('app.pages.auth.login')
    .controller('LoginController', LoginController);

    /** @ngInject */
  function LoginController(
    $cookies,
    $scope,
    $rootScope,
    $q,
    $state,
    $timeout,
    $document,
    $mdSidenav,
    $mdDialog,
    $translate,
    $location,
    $mdToast,
    UserService,
    AuthService,
    AUTH_EVENTS,
    OAUTH_CLIENT_DEV,
    FarmService,
    fuseTheming,
    BackgroundService,
    _,
    Upload,
    $window
  ) {
    var vm = this;

    // Data
    $scope.event = window.event;
    vm.form = {
      email:'',
      password:''
    };
    $scope.remember = false;
    vm.rememberMe = rememberMe;
    vm.setTheme = setTheme;
    vm.changeBackground = changeBackground;
    vm.closeDialog = closeDialog;
    vm.background = {};
    BackgroundService.getFile().then(function (img) {
      if (img) {
        vm.background.image_url = BackgroundService.getUploadImgUrl();
      }
    }, function (err) {
      if (err) {
        vm.background.image_url = 'assets/images/backgrounds/march.jpg';
      }
    });
    if (sessionStorage.getItem('user')) {
      vm.user = UserService.getLocalUser();
      UserService.getUser(vm.user.id).then(function(userData) {
        if (userData.user.roles) {
          vm.roles = userData.user.roles;
          $scope.changeBack = vm.roles.findIndex(function (i) {
            return i.name.toLowerCase() === 'super user';
          }) >= 0;
        }
      });
    }
    /**
     * Function to perform login
     * @return {[type]} [description]
     */
    vm.login = function () {
      var credentials = {
        username: vm.form.email,
        password: vm.form.password,
        grant_type: OAUTH_CLIENT_DEV.grant_type,
        client_id: OAUTH_CLIENT_DEV.client_id,
        client_secret: OAUTH_CLIENT_DEV.client_secret
      };
      AuthService.login(credentials).then(function (user) {
        // Get ACL config
        AuthService.setACLConfig().then(function() {
          AuthService.addRoles().then(function(data) {
            $rootScope.$broadcast(AUTH_EVENTS.loginSuccess);
            vm.setCurrentUser(user);
            $mdToast.show({
              template: '<md-toast class="md-toast success">'+ $translate.instant('LOGIN.WELCOME') + user.name + '</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            vm.setTheme();
            if($rootScope.referrerUrl && $rootScope.referrerUrl.indexOf('error') === -1) {
              if($rootScope.referrerUrl.indexOf('login') === -1) {
                $location.url($rootScope.referrerUrl);
              }
              $rootScope.referrerUrl = null;
            } else {
              if(data.aclServiceData) {
                // Check if abilities exists
                if(data.aclServiceData.hasOwnProperty('abilities')) {
                  var abilities = data.aclServiceData.abilities;
                  // Check if it has property roles and if the current user role is on it.
                  if(data.aclServiceData.hasOwnProperty('roles') && abilities[user.roles[0].name]) {
                    // Return the first page that that user has access and redirect to it.
                    $window.location.assign('/' + abilities[user.roles[0].name][0].replace(/_/g, '-'));
                  }
                } else {
                  $mdToast.show({
                    template: '<md-toast class="md-toast error">' + $translate.instant('LOGIN.ERRORS.THERE_ARE_NO_PAGES_AVAILABLES') + '</md-toast>',
                    position: 'top right',
                    hideDelay: 9500
                  });
                }
              }
            }
          });
        }, function (err) {
          console.error(err);
        });
        if ($scope.remember) {
          vm.rememberMe(user);
        }
      },
      function() {
        $rootScope.$broadcast(AUTH_EVENTS.loginFailed);
        $mdToast.show({
          template: '<md-toast class="md-toast error">' + $translate.instant('LOGIN.ERRORS.ERROR_ON_LOGIN') + '</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    };
    /**
     * Remember users
     */
    function rememberMe(user) {
      localStorage.setItem('user', JSON.stringify(user));
    }
    /**
     * Function to set credentials of the user in client.
     */
    vm.setCurrentUser = function (user) {
      UserService.saveLocalUser(user);
    };
    /**
    * Set theme
    */
    function setTheme() {
      FarmService.getFarm(1).then(function(FarmData) {
        vm.themeName = FarmData.farm.color_palette;
        vm.layoutStyle = FarmData.farm.layout_type;
        fuseTheming.setActiveTheme(vm.themeName);

        // Update the cookie
        vm.cookiesLast = $cookies.get('layoutStyle');
        if (vm.cookiesLast !== vm.layoutStyle) {
          $cookies.put('layoutStyle', vm.layoutStyle);
          location.reload();
        }
      },
      function(err) {
        console.error(err);
      });
    }
    /**
     * Change Background
     */
    function changeBackground(ev, back) {
      if (!back.backgroundUpdated) {
        vm.backClone = _.cloneDeep(back);
      }
      $mdDialog.show({
        controller: 'BackgroundController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pages/auth/login/dialogs/background_dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            background: back,
            backgroundAux: vm.background,
            changeBackground: vm.changeBackground,
            dialogType: 'add',
          }
        }
      })
      .finally(function() {
        if (!vm.background.save) {
          _.assign(vm.background, vm.backClone);
        }
        vm.background.save = null;
      });
    }
    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.cancel();
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.pages.auth.forgot-password', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider)
  {
    // State
    $stateProvider.state('app.pages_auth_forgot-password', {
      url      : '/forgot-password',
      views    : {
        'main@'                                 : {
          templateUrl: 'app/core/layouts/content-only.html',
          controller : 'MainController as vm'
        },
        'content@app.pages_auth_forgot-password': {
          templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
          controller : 'ForgotPasswordController as vm'
        }
      },
      bodyClass: 'forgot-password'
    });
    $stateProvider.state('app.pages_auth_forgot-password_set-password', {
      url      : '/set-password/:hash',
      views    : {
        'main@'                                 : {
          templateUrl: 'app/core/layouts/content-only.html',
          controller : 'MainController as vm'
        },
        'content@app.pages_auth_forgot-password_set-password': {
          templateUrl: 'app/main/pages/auth/forgot-password/set-password.html',
          controller : 'ForgotPasswordController as vm'
        }
      },
      bodyClass: 'set-password'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');

  }
})();
(function () {
  'use strict';

  angular
    .module('app.pages.auth.forgot-password')
    .controller('ForgotPasswordController', ForgotPasswordController);

  /** @ngInject */
  function ForgotPasswordController(
    $state,
    $translate,
    $location,
    $stateParams,
    $mdToast,
    UserService,
    $window
  )
  {
    // Data
    var vm      = this;
    vm.form = {
      email: '',
      password: '',
      password_confirm: ''
    };
    // Methods
    vm.init            = init;
    vm.requestPassword = requestPassword;
    vm.setNewPassword  = setNewPassword;
    vm.isValidPassword = isValidPassword;

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      if($location.url().indexOf('/set-password') !== -1) { // Avoid not desired redirect.
        // check set new password hash
        UserService.checkSetPasswordHash($location.search().hash).then(function() {
          // Can access to the page.
        },
        function() {
          // Return to forgot-password
          $mdToast.show({
            template: '<md-toast>' + $translate.instant('NEW_PASSWORD.ERRORS.HASH_EXPIRED') + '</md-toast>',
            position: 'top right',
            hideDelay: 10000
          });
          $location.url('/forgot-password');
        });
      }
    }

    /**
     * Function to request new password
     *
     * @return {void}
     */
    function requestPassword() {
      if(vm.form.email !== '') {
        var dataToPost = {
          email: vm.form.email,
          redirect_url: $location.protocol() + '://'+ $location.host() +':'+  $location.port()  + '/set-password'
        };
        UserService.requestPassword(vm.form.email, dataToPost).then(function() {
          $mdToast.show({
            template: '<md-toast class="md-toast success">' + $translate.instant('FORGOT_PASSWORD.SUCCESS') + '</md-toast>',
            position: 'top right',
            hideDelay: 10000
          });
          $location.url('/login');
        },
        function(err) {
          if(err.status === 409) { //Conflict
            $mdToast.show({
              template: '<md-toast>' + $translate.instant('FORGOT_PASSWORD.ERROR_NOT_FOUND') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          } else {
            $mdToast.show({
              template: '<md-toast class="md-toast error">' + $translate.instant('FORGOT_PASSWORD.ERROR') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          }
        });
      }
    }
    /**
     * [setNewPassword description]
     */
    function setNewPassword() {
      if(vm.isValidPassword()) {
        var dataToPost = {
          token: $location.search().hash,
          password: vm.form.password
        };
        if($location.search().hash) {
          UserService.setNewPassword(dataToPost).then(function() {
            $mdToast.show({
              template: '<md-toast class="md-toast success">' + $translate.instant('NEW_PASSWORD.PASSWORD_SET_SUCCESS') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
            $location.url('/login');
            $window.location.reload();
          },
          function(err) {
            if(err.status === 409) { // User already has used that hash, return to forgot-password.
              $mdToast.show({
                template: '<md-toast>' + $translate.instant('NEW_PASSWORD.ERRORS.HASH_EXPIRED') + '</md-toast>',
                position: 'top right',
                hideDelay: 6000
              });
              $location.url('/forgot-password');
            } else {
              $mdToast.show({
                template: '<md-toast class="md-toast error">' + $translate.instant('NEW_PASSWORD.ERRORS.ERROR_PASSWORD_COULD_NOT_SET') + '</md-toast>',
                position: 'top right',
                hideDelay: 6000
              });
            }
          });
        }
      } else {
        $mdToast.show({
          template: '<md-toast class="md-toast error">' + $translate.instant('NEW_PASSWORD.ERRORS.PASSWORD_MUST_MATCH_ONLY') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      }
    }

    /**
     * Function to validate password
     * @return {Boolean} [description]
     */
    function isValidPassword() {
      if (vm.form
          && vm.form.password
          && vm.form.password_confirm
          && vm.form.password !== ''
          && vm.form.password_confirm !== ''
          && vm.form.password === vm.form.password_confirm) {
        return true;
      } else {
        return false;
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.work-schedule-template.work-template-2', [
      'xeditable',
      'dndLists'
    ])
    .config(config);


  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider.state('app.work-schedule-template.work-template-2', {
      url      : '/edit',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/work-schedule-template/work-template-2/work-template-2.html',
          controller : 'WorkTemplate2Ctrl as vm',
          params: {
            workTemplate:{}
          }
        }
      },
      resolve  : {
        RolesData: function(apiResolver) {
          /**
           * if user is not super user - User Role "Super User" not loading
           */
          var user = JSON.parse(sessionStorage.getItem('user'));
          var admin = user.roles.findIndex(function (i)  { return i.name.toLowerCase() === 'super_user'; }) >= 0;
          if (admin === false) {
            return apiResolver.resolve('roles@get', { except: 10});
          } else {
            return apiResolver.resolve('roles@get');
          }
        },
        NotifyGroupsData: function(apiResolver) {
          return apiResolver.resolve('notify_groups@get');
        }
      },
      bodyClass: 'task'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/work-schedule-template/work-template-2');


  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.work-template-2')
  .controller('WorkTemplate2Ctrl', WorkTemplate2Ctrl);

  /** @ngInject */
  function WorkTemplate2Ctrl($state,
                             $scope,
                             $window,
                             $mdToast,
                             $mdDialog,
                             $document,
                             api,
                             ganttUtils,
                             TaskService,
                             SeasonsService,
                             PhaseService,
                             SeedService,
                             WorkScheduleType,
                             AnchorTypeDefinitionService,
                             msUtils,
                             WorkTemplateService) {
    var vm = this;
    var _ = window._;

    vm.$window = $window;
    vm.phaseType = [];
    vm.seeds = [];
    vm.workTemplate = _.cloneDeep(WorkTemplateService.selectedWorkTemplate);
    vm.seasons = [];
    vm.tasks = [];
    vm.phases = [];
    vm.allRolesGroups = [];
    vm.taskSelected = {};
    vm.currentFilter = null;
    vm.anchorTask = null;
    vm.exists = msUtils.exists;

    $scope.loadingData = true;


    vm.allNotifyGroups = [
      {name: 'Tractor', id: 1},
      {name: 'Sprinkler', id: 2},
      {name: 'Irrigation', id: 3},
      {name: 'Planter', id: 4},
      {name: 'Harvest', id: 5}
    ];

    vm.laborGroups = [{name: 'Fertilizer', id: 1}];
    vm.equipmentGroups = [{name: 'Fertilizer', id: 1}];
    vm.anchorDefinitions = [];

    AnchorTypeDefinitionService.get().then(function (t) {
      vm.anchorDefinitions = t.definitions;
    });

    vm.getAnchorShortCode = function (id) {
      return AnchorTypeDefinitionService.getAnchorShortCode(id);
    };

    api.roles.get({}, function (RolesData) {
      vm.allRolesGroups = RolesData.roles.filter(function (ng) {
        return ng.name.toLowerCase().indexOf('foreman') != -1;
      });
    },
    function (err) {
      console.error(err);
    });

    PhaseService.get().then(function (data) {
      vm.phases = _.cloneDeep(data);

      if (!vm.workTemplate.phases) {
        vm.workTemplate.phases = data.filter(function (d) {
          return d.work_schedule_type_id == vm.workTemplate.phase_type_id;
        });
      }

      vm.workTemplate.phases.forEach(function (p) {
        p.isExpanded = false;
      });

      $scope.loadingData = false;
    });

    WorkScheduleType.get().then(function (data) {
      vm.phaseType = data;
    });

    SeedService.getAll().then(function (data) {
      vm.seeds = data.seeds;


    });

    SeasonsService.getList().then(function (data) {
      vm.seasons = data.seasons;


    });
    TaskService.get().then(function (data) {
      data.forEach(function (d) {
        d.ng = [d.notify_group_id];
      });
      vm.tasks = data;
    });

    vm.checkIfTaskIsAdded = function (index, item, external, type, phase) {

      /* if (!item.inList) {
       if (vm.hasAnchorTask(phase)) {
       $mdToast.show({
       template: '<md-toast class="md-toast error">You Cannot add more than one time anchor task.</md-toast>',
       position: 'top right',
       hideDelay: 4500
       });

       return false;
       }
       }*/

      index = _.findIndex(phase.tasks, function (t) {
        return t.id == item.id;
      });

      if (index == -1) {
        return item;
      } else if (item.inList) {
        return item;
      }
      else {
        return false;
      }
    };

    vm.save = function () {

      WorkTemplateService.update(vm.workTemplate).then(function () {
        _.assign(WorkTemplateService.selectedWorkTemplate, vm.workTemplate);
        $mdToast.show({
          template: '<md-toast class="md-toast success">The work template has been saved.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        //$state.go('app.work_schedule');
      });

    };

    vm.showTaskNotifyGroupName = function (task) {
      var arr = vm.allNotifyGroups.filter(function (n) {
        return n.id == task.notify_group_id;
      });
      if (arr.length == 0) {
        return '';
      } else {
        return arr.shift().name;
      }
    };

    vm.showTaskNotifyGroupName = function (task) {
      var arr = vm.allNotifyGroups.filter(function (n) {
        return n.id == task.notify_group_id;
      });
      if (arr.length == 0) {
        return '-';
      } else {
        return arr.shift().name;
      }
    };

    vm.showTaskEquipmentGroupName = function (task) {
      var arr = vm.equipmentGroups.filter(function (n) {
        return n.id == task.equipment_task_group_id;
      });
      if (arr.length == 0) {
        return '-';
      } else {
        return arr.shift().name;
      }
    };

    vm.showTaskLaborGroupName = function (task) {
      var arr = vm.laborGroups.filter(function (n) {
        return n.id == task.labor_task_group_id;
      });
      if (arr.length == 0) {
        return '-';
      } else {
        return arr.shift().name;
      }
    };

    vm.insertOnLast = function (index, item, external, type, phase) {

      if (vm.checkIfTaskIsAdded(index, item, external, type, phase)) {
        vm.setInserted(index, item, external, type, phase);
        phase.tasks.push(item);
      }


    };

    vm.setInserted = function (index, item, external, type, phase) {
      item.inList = true;
      item.id = ganttUtils.randomUuid();
      phase.showTasks = true;
      if (vm.anchorTask == null) {
        vm.anchorTask = item;
      }

      vm.accordion.expand(index);
    };

    vm.getFilteredTasks = function () {

      if (vm.currentFilter == null) {
        return vm.tasks;
      } else {
        return vm.tasks.filter(function (t) {
          return t.user_role_id == vm.currentFilter;
        });
      }


    };

    vm.hasAnchorTask = function () {

      var allTasks = _.flatten(vm.getFilteredPhases().map(function (phase) {
        return phase.tasks;
      }));

      var anchors = allTasks.filter(function (task) {
        return task.time_anchor == true;
      });

      return anchors.length > 0;
    };

    vm.hasAnyTask = function () {
      var allTasks = _.flatten(vm.getFilteredPhases().map(function (phase) {
        return phase.tasks;
      }));
      return allTasks.length > 0;
    };

    vm.validFirstPhase = function () {
      return true;

      /*
       var first_phase = _.first(vm.getFilteredPhases());
       if (!first_phase) {
       return false;
       }
       return _.intersectionBy(vm.getAnchorTasks(), first_phase.tasks, 'id').length == 0 && _.intersectionBy(vm.getPreWaters(), first_phase.tasks, 'id').length == 0 && _.intersectionBy(vm.getGrowingStartDate(), first_phase.tasks, 'id').length == 0 && _.intersectionBy(vm.getHarvestDate(), first_phase.tasks, 'id').length == 0;
       */
    };

    vm.getAnchorTasks = function () {

      var allTasks = _.flatten(vm.getFilteredPhases().map(function (phase) {
        return phase.tasks;
      }));

      var wetDateId = vm.anchorDefinitions.filter(function (a) {
        return a.wetDate == true;
      }).shift();
      if (wetDateId) {
        wetDateId = wetDateId.id;
      } else {
        wetDateId = null;
      }

      var harvestDateId = vm.anchorDefinitions.filter(function (a) {
        return a.harvestDate == true;
      }).shift();
      if (harvestDateId) {
        harvestDateId = harvestDateId.id;
      } else {
        harvestDateId = null;
      }

      var assignAnchorId = vm.anchorDefinitions.filter(function (a) {
        return a.assignAnchorDate == true;
      }).shift();
      if (assignAnchorId) {
        assignAnchorId = assignAnchorId.id;
      } else {
        assignAnchorId = null;
      }

      var anchors = allTasks.filter(function (task) {
        return task.anchor_id == assignAnchorId || task.anchor_id == wetDateId;
      });
      return anchors;
    };

    vm.getPreWaters = function () {

      var allTasks = _.flatten(vm.getFilteredPhases().map(function (phase) {
        return phase.tasks;
      }));

      var prewaters = allTasks.filter(function (task) {
        return task.pre_water == true;
      });
      return prewaters;
    };

    vm.getGrowingStartDate = function () {

      var allTasks = _.flatten(vm.getFilteredPhases().map(function (phase) {
        return phase.tasks;
      }));

      var growings = allTasks.filter(function (task) {
        return task.growing_start_date == true;
      });
      return growings;
    };


    vm.getHarvestDate = function () {

      var allTasks = _.flatten(vm.getFilteredPhases().map(function (phase) {
        return phase.tasks;
      }));

      var harvests = allTasks.filter(function (task) {
        return task.harvest_date == true;
      });
      return harvests;
    };

    vm.invalidPhases = function () {
      return vm.getAnchorTasks().length > 1;
      /*
       var arr = vm.getFilteredPhases();
       if (!arr) {
       return true;
       }

       return !vm.validFirstPhase() || vm.getAnchorTasks().length != 1 || vm.getPreWaters().length != 1
       || vm.getHarvestDate().length != 1 || vm.getGrowingStartDate().length != 1
       || vm.getFilteredPhases().length < 5 || !vm.isBefore(vm.getPreWaters(), vm.getAnchorTasks())
       || !vm.isBefore(vm.getAnchorTasks(), vm.getGrowingStartDate()) || !vm.isBefore(vm.getGrowingStartDate(), vm.getHarvestDate());
       */
    };

    vm.openTaskDialog = function (ev, task) {


      $mdDialog.show({
        controller: 'TaskDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/work-schedule-template/work-schedule-tasks/task/dialog/task-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          dialogData: {
            task: task,
            tasks: vm.tasks,
            roles: vm.allRolesGroups,
            notifyGroups: vm.allNotifyGroups,
            filterIds: [],
            shownTasks: [],
            updateTaskModel: updateTaskModel
          }
        }
      });


    };

    vm.openColorPicker = function (ev, phase, saveFn) {
      ev.stopPropagation();
      $mdDialog.show({
        controller: 'PhaseColorPickerDialogController',
        controllerAs: 'vm',
        multiple: true,
        templateUrl: 'app/main/farm-admin/work-schedule-template/phase-type/dialog/color-picker-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            phase: phase,
            saveFn: saveFn
          }
        }
      });
    };

    vm.isBefore = function (tasks, tasks2) {

      var task = _.first(tasks);
      var task2 = _.first(tasks2);

      var phases = vm.getFilteredPhases();

      var phaseIndex1 = -1;
      var phaseIndex2 = -1;

      _.forEach(phases, function (phase, index) {

        if (task) {
          if (_.findIndex(phase.tasks, function (t) {
            return t.id == task.id;
          }) != -1) {
            phaseIndex1 = index;
          }
        }

        if (task2) {
          if (_.findIndex(phase.tasks, function (t) {
            return t.id == task2.id;
          }) != -1) {
            phaseIndex2 = index;
          }
        }


      });


      return phaseIndex1 < phaseIndex2;

    };

    vm.phaseExpand = function (index, id, value) {

      vm.getFilteredPhases()[index].isExpanded = value;

    };

    vm.filterChange = function (id) {
      vm.currentFilter = id;
    };

    vm.getFilteredPhases = function () {
      /* if (!vm.workTemplate.phase_type_id) {
       return vm.phases;
       }

       return vm.phases.filter(function (p) {
       return p.work_schedule_type_id == vm.workTemplate.phase_type_id;
       });
       */

      if (!vm.workTemplate.phases) {
        return [];
      }

      return vm.workTemplate.phases;

    };

    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function updateTaskModel(task, group) {
      if (vm.exists(group.id, task.ng)) {
        task.ng.splice(task.ng.indexOf(group.id), 1);
      } else {
        task.ng.push(group.id);
      }
    }


    vm.checkIfIsAnchorTaskAndRemove = function (task) {
      if (vm.anchorTask.id == task.id) {
        vm.anchorTask = null;
      }
    };


  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.work-schedule-template.work-template', [
      'xeditable'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.work-schedule-template', {
      url      : '/work-template',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/work-schedule-template/work-template/work-template.html',
          controller : 'WorkTemplateCtrl as vm'
        }
      },
      resolve  : {
        RolesData: function(apiResolver) {
          /**
           * if user is not super user - User Role "Super User" not loading
           */
          var user = JSON.parse(sessionStorage.getItem('user'));
          var admin = user.roles.findIndex(function (i)  { return i.name.toLowerCase() === 'super_user'; }) >= 0;
          if (admin === false) {
            return apiResolver.resolve('roles@get', { except: 10});
          } else {
            return apiResolver.resolve('roles@get');
          }
        },
        NotifyGroupsData: function(apiResolver) {
          return apiResolver.resolve('notify_groups@get');
        }
      },
      bodyClass: 'work-template'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/work-schedule-template/work-template');

    //Api
    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.work-schedule-template.work-template', {
      title: 'Work Schedule Templates',
      icon : '',
      state: 'app.work-schedule-template',
      weight: 27
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.work-template')
  .controller('WorkTemplateCtrl', WorkTemplateCtrl);

  /** @ngInject */
  function WorkTemplateCtrl($q,
                            $state,
                            $scope,
                            $timeout,
                            $mdToast,
                            $mdSidenav,
                            $mdDialog,
                            $document,
                            $translate,
                            $location,
                            RolesData,
                            NotifyGroupsData,
                            RoleService,
                            SeasonsService,
                            SeedService,
                            TaskService,
                            WorkTemplateService,
                            CompanyService,
                            UserService,
                            WorkScheduleType,
                            NotifyGroupService,
                            msUtils) {
    var vm = this;
    var _ = window._;

    // Data
    /* Get user Info */
    var user = UserService.getLocalUser();
    vm.roles = user.roles;
    $scope.idUserOnline = user.id;
    $scope.admin = vm.roles.findIndex(function (i) {
      return i.name.toLowerCase() === 'super_user';
    }) >= 0;


    vm.workTemplates = [];
    vm.allRolesGroups = [];
    vm.allNotifyGroups = [];
    vm.selectedWT = [];
    vm.starredWT = [];
    vm.filterIds = [];
    vm.listType = 'all';
    vm.listOrder = 'name';
    vm.listOrderAsc = false;
    vm.newGroupName = '';
    $scope.finishUpdate = true;
    $scope.deleteSuperUserRole = false;
    vm.offset = 0;
    vm.shownWorkTemplates = [];
    vm.maxListLength = 20;
    vm.seeds = [];
    vm.seasons = [];
    vm.phaseTypes = [];

    SeasonsService.getList().then(function (seasons) {
      vm.seasons = seasons.seasons;
    });

    SeedService.getAll().then(function (seeds) {
      vm.seeds = seeds.seeds;
    });

    WorkTemplateService.get().then(function (works) {
      vm.workTemplates = works;
    });

    WorkScheduleType.get().then(function (phasesTypes) {
      vm.phaseTypes = phasesTypes;
    });


    /**
     * Users role from API
     */
    if (RolesData && RolesData.roles) {
      vm.allRolesGroups = RolesData.roles.filter(function (ng) {
        return ng.name.toLowerCase().indexOf('foreman') != -1;
      });
    }
    /**
     * Users notify group from API
     */
    if (NotifyGroupsData && NotifyGroupsData.notify_groups) {
      //vm.allNotifyGroups = NotifyGroupsData.notify_groups;
      vm.allNotifyGroups = [
        {name: 'Tractor', id: 1},
        {name: 'Sprinkler', id: 2},
        {name: 'Irrigation', id: 3},
        {name: 'Planter', id: 4},
        {name: 'Harvest', id: 5}
      ];
    }


    vm.load = load;
    vm.filterChange = filterChange;
    vm.deleteUserConfirm = deleteUserConfirm;
    vm.deleteUser = deleteUser;
    vm.deleteSelectedWT = deleteSelectedWT;
    vm.toggleSelectWT = toggleSelectWT;
    vm.openWTDialog = openWTDialog;
    vm.showSeasonName = showSeasonName;
    vm.showSeedName = showSeedName;
    vm.showPhaseTypeName = showPhaseTypeName;
    vm.deselectUsers = deselectUsers;
    vm.selectAllUsers = selectAllUsers;
    vm.deleteUser = deleteUser;
    vm.addNewNotifyGroup = addNewNotifyGroup;
    vm.addNewRoleGroup = addNewRoleGroup;
    vm.editNotifyGroup = editNotifyGroup;
    vm.editRoleGroup = editRoleGroup;
    vm.editGroup = editGroup;
    vm.deleteGroup = deleteGroup;
    vm.deleteNotifyGroup = deleteNotifyGroup;
    vm.deleteRoleGroup = deleteRoleGroup;
    vm.toggleSidenav = toggleSidenav;
    vm.patchStarred = patchStarred;
    vm.patchActive = patchActive;
    vm.patchSeason = patchSeason;
    vm.patchSeed = patchSeed;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.loadMore = loadMore;
    $scope.loadingData = true;
    vm.goWTpage = goWTpage;
    vm.openCloneWorkTemplateDialog = openCloneWorkTemplateDialog;
    vm.load = load;


    /**
     * Change Users List Filter
     * @param type
     */
    function openCloneWorkTemplateDialog(ev, wt) {


      $mdDialog.show({
        controller: 'CloneWorkTemplateDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/work-schedule-template/work-template/dialog/clone-task-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          dialogData: {
            workTemplate: wt,
            workTemplates: vm.workTemplates,
            filterIds: vm.filterIds,
            shownWorkTemplates: vm.shownWorkTemplates
          }
        }
      });
    }


    /* Call to funciton load as first thing */
    load();

    /**
     * [load description]
     * @return {[type]} [description]
     */
    function load() {

      vm.offset = 0;
      vm.filterIds = [];
      vm.workTemplates = [];
      vm.shownWorkTemplates = [];
      $scope.loadingData = true;

      WorkTemplateService.get().then(function (wt) {
        vm.workTemplates = wt;
      });

      WorkTemplateService.getWorkTemplatesWithOffset(vm.offset, vm.maxListLength).then(function (works) {
        vm.shownWorkTemplates = works;
        vm.shownWorkTemplates.forEach(function (work) {
          vm.filterIds.push(work.id);
          initSeasonsSeeds(work);
        });
        $scope.loadingData = false;
      });
    }

    /**
     * [load description]
     * @return {[type]} [description]
     */
    function goWTpage(workTemplate) {
      WorkTemplateService.selectedWorkTemplate = workTemplate;
      $state.go('app.work-schedule-template.work-template-2');
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function loadMore() {
      vm.offset += vm.maxListLength;
      WorkTemplateService.getWorkTemplatesWithOffset(vm.offset, vm.maxListLength).then(function (works) {
        if (works.length > 0) {
          vm.shownWorkTemplates = vm.shownWorkTemplates.concat(works);
          works.forEach(function (work) {
            vm.filterIds.push(work.id);
            initSeasonsSeeds(work);
          });
        }
        else
          return;
      });
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function showSeasonName(wt) {
      var arr = vm.seasons.filter(function (s) {
        return s.id == wt.season_id;
      });
      if (arr.length == 0) {
        return '';
      }
      return arr.shift().name;
    }


    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function showSeedName(wt) {
      var arr = vm.seeds.filter(function (s) {
        return s.id == wt.seed_id;
      });
      if (arr.length == 0) {
        return '';
      }
      return arr.shift().name;
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function showPhaseTypeName(wt) {
      var arr = vm.phaseTypes.filter(function (s) {
        return s.id == wt.phase_type_id;
      });

      if (arr.length == 0) {
        return '';
      }
      return arr.shift().name;
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function openWTDialog(ev, work_template) {


      $mdDialog.show({
        controller: 'WorkTemplateDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/work-schedule-template/work-template/dialog/task-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          dialogData: {
            work_template: work_template,
            work_templates: vm.workTemplates,
            seeds: vm.seeds,
            seasons: vm.seasons,
            phase_types: vm.phaseTypes,
            load: vm.load,
            openColorPicker:vm.openColorPicker,
            workTemplates: vm.workTemplates,
            shownWorkTemplates: vm.shownWorkTemplates,
            filterIds: vm.filterIds
          }
        }
      });
    }

    /**
     * Change Users List Filter
     * @param type
     */
    function filterChange(type, group_type) {
      $scope.groupType = group_type;
      vm.listType = type;
      if (type === 'all') {
        vm.filterIds = vm.workTemplates.map(function (w) {
          return w.id;
        });
      }
      else if (type === 'starred') {
        vm.filterIds = [];
        vm.filterIds = vm.starredWT;
      }
      else if (angular.isObject(type) && group_type) {
        vm.filterIds = vm.workTemplates.filter(function (t) {
          return t.season_id == type.id;
        }).map(function (t) {
          return t.id;
        });
      }
      else if (angular.isObject(type)) {
        vm.filterIds = vm.workTemplates.filter(function (t) {
          return t.seed_id == type.id;
        }).map(function (t) {
          return t.id;
        });
      }
      vm.selectedWT = [];
    }


    /**
     * Delete Contact Confirm Dialog
     */
    function deleteUserConfirm(user, ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + user.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete user')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteUser(user);
        vm.selectedContacts = [];
      }, function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Delete Contact
     */
    function deleteUser(user) {
      vm.users.splice(vm.users.indexOf(user), 1);
    }

    /**
     * Delete Selected Users
     */
    function deleteSelectedWT(ev) {
      ev.preventDefault();
      var confirm = $mdDialog.confirm()
      .title($translate.instant('TASK.ARE_YOU_SURE_TO_DELETE_BULK'))
      .htmlContent('<b>' + vm.selectedWT.length + ' selected</b>' + ' will be deleted.')
      .ariaLabel('delete tasks')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var arrIds = [];
        vm.selectedWT.forEach(function (task) {
          arrIds.push(task.id);
        });
        WorkTemplateService.bulkDelete(arrIds).then(function () {

          arrIds.forEach(function (_id) {
            _.remove(vm.workTemplates, {
              id: _id
            });
          });

          vm.selectedTasks = [];
          $mdToast.show({
            template: '<md-toast class="md-toast success">The work templates were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The work templates could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }


    /**
     * Toggle selected status of the work template
     *
     * @param work template
     * @param event
     */
    function toggleSelectWT(wt, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedWT.indexOf(wt) > -1) {
        vm.selectedWT.splice(vm.selectedWT.indexOf(wt), 1);
      } else {
        vm.selectedWT.push(wt);
      }
    }

    /**
     * Deselect users
     */
    function deselectUsers() {
      vm.selectedWT = [];
    }

    /**
     * Select all users
     */
    function selectAllUsers() {
      vm.selectedWT = $scope.filteredUsers;
    }

    /**
     * Create a new notify-group associated to the user.
     */
    function addNewNotifyGroup() {
      if (vm.newGroupName2 === '') {
        return;
      }
      var newGroupData = {
        'name': vm.newGroupName2
      };
      /**
       * Call service to create a new notify-group associated to the user.
       */
      NotifyGroupService.create(newGroupData).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Notify Group ' + newGroupData.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.allNotifyGroups.push(data.notify_group);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + vm.newGroupName + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }


    /**
     * Create a new role-gropu associated to the user
     */
    function initSeasonsSeeds(wt) {
      wt.seasons = [wt.season_id];
      wt.seeds = [wt.seed_id];
    }

    /**
     * Create a new role-gropu associated to the user
     */
    function addNewRoleGroup() {
      if (vm.newGroupName === '') {
        return;
      }
      var newGroupData = {
        'name': vm.newGroupName,
        'work_schedule_role_yesno': 'false'
      };
      /**
       * Call service to create a new notify-group associated to the user.
       */
      RoleService.create(newGroupData).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Role Group ' + newGroupData.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.allRolesGroups.push(data.role);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + vm.newGroupName + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Edit group
     */
    function editGroup(ev, group) {
      vm.allNotifyGroups.forEach(function (notify_groups) {
        if (group.name === notify_groups.name) {
          editNotifyGroup(ev, group);
        }
      });
      vm.allRolesGroups.forEach(function (roles) {
        if (group.name === roles.name) {
          editRoleGroup(ev, group);
        }
      });
    }

    /**
     * Edit a notify group.
     *
     * @return {[type]} [description]
     */
    function editNotifyGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_EDIT_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be updated.')
      .ariaLabel('update group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to update a notify-group.
         */
        NotifyGroupService.update(group.id, group).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Handle cancel
      });
    }

    /**
     * Edit a role group.
     *
     * @return {[type]} [description]
     */
    function editRoleGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_EDIT_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be updated.')
      .ariaLabel('update group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to update a role.
         */
        RoleService.update(group.id, group).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Role Group ' + group.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Handle cancel
      });
    }

    /**
     * Delete Group
     */
    function deleteGroup(ev, group) {
      vm.allNotifyGroups.forEach(function (notify_groups) {
        if (group.name === notify_groups.name) {
          deleteNotifyGroup(ev, group);
        }
      });
      vm.allRolesGroups.forEach(function (roles) {
        if (group.name === roles.name) {
          deleteRoleGroup(ev, group);
        }
      });
    }

    /**
     * Delete Notify Group
     */
    function deleteNotifyGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to create a new notify-group associated to the user.
         */
        NotifyGroupService.delete(group.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.allNotifyGroups.splice(vm.allNotifyGroups.indexOf(group), 1);
        },
        function (err) {
          if (err.status === 409) {
            var confirm2 = $mdDialog.confirm()
            .title($translate.instant('USERS.ARE_YOU_SURE_WANT_TO_REMOVE_GROUP_RELATION'))
            .htmlContent('<h3>The group <b>' + group.name + '</b> cannot be deleted because there are other users related to it.\
              <br />Do you want to remove group relation from your user account?</h3> <b>' + group.name + '</b>' + ' relation will be removed from the user: <b>' + vm.user.name + '</b>')
            .ariaLabel('delete group relation')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm2).then(function () {
              UserService.removeUserNotifyGroupRelation(vm.user.id, group.id).then(function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' relation with user ' + vm.user.name + ' has been removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
                $state.go($state.current, {}, {reload: true});
              },
              function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">The group ' + group.name + ' relation could not be removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              });
            });
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Avoid unhandled call
      });
    }

    /**
     * Delete Role Group
     */
    function deleteRoleGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to create a new notify-group associated to the user.
         */
        RoleService.delete(group.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Role ' + group.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.allRolesGroups.splice(vm.allRolesGroups.indexOf(group), 1);
        },
        function (err) {
          if (err.status === 409) {
            var confirm2 = $mdDialog.confirm()
            .title($translate.instant('USERS.ARE_YOU_SURE_WANT_TO_REMOVE_GROUP_RELATION'))
            .htmlContent('<h3>The group <b>' + group.name + '</b> cannot be deleted because there are other users related to it.\
              <br />Do you want to remove group relation from your user account?</h3> <b>' + group.name + '</b>' + ' relation will be removed from the user: <b>' + vm.user.name + '</b>')
            .ariaLabel('delete group relation')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm2).then(function () {
              UserService.removeUserRoleRelation(vm.user.id, group.id).then(function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast success">The Role ' + group.name + ' relation with user ' + vm.user.name + ' has been removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
                $state.go($state.current, {}, {reload: true});
              },
              function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">The group ' + group.name + ' relation could not be removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              });
            });
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Avoid unhandled call
      });
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Function to patch starred user.
     *
     * @return {[type]} [description]
     */
    function patchStarred(wt) {
      var starred = false;
      if (vm.starredWT.indexOf(wt.id) !== -1) {
        starred = true;
      }
      wt.starred = starred;
      WorkTemplateService.update(wt.id, {starred: starred.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The work template ' + wt.name + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The work template ' + wt.name + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Function to patch active user.
     *
     * @return {[type]} [description]
     */
    function patchActive(user) {
      UserService.patch(user.id, {active: user.active.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The work template ' + user.name + ((user.active === true) ? ' has been activated.' : ' has been deactivated.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast error">The work template ' + user.name + ' could not be activated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });

      });
    }

    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function patchSeed(wt, group) {

      WorkTemplateService.update().then(function () {
        wt.seed_id = group.id;
        wt.seeds = [group.id];
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The work template ' + wt.name + 'has been updated </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });

    }

    /**
     * Patch User Role
     */
    function patchSeason(wt, group) {
      WorkTemplateService.update().then(function () {
        wt.season_id = group.id;
        wt.seasons = [group.id];
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The work template ' + wt.name + 'has been updated </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }


    vm.openColorPicker = function (ev, task) {
      $mdDialog.show({
        controller: 'PhaseColorPickerDialogController',
        controllerAs: 'vm',
        multiple: true,
        templateUrl: 'app/main/farm-admin/work-schedule-template/phase-type/dialog/color-picker-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            phase: task
          }
        }
      });
    };


  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.work-schedule-template.phase-types', [
      'xeditable','mdColorPicker','color.picker'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.phase_types', {
      url      : '/phase-types',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/work-schedule-template/phase-type/phase-type.html',
          controller : 'PhaseTypeCtrl as vm'
        }
      },
      bodyClass: 'farm-admin'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/work-schedule-template/phase-type');

    //Api
    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.work-schedule-template.phase-types', {
      title: 'Work Schedule Phases',
      icon : '',
      state: 'app.phase_types',
      weight: 22
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.work-schedule-template.phase-types')
  .controller('PhaseTypeCtrl', PhaseTypeCtrl);

  /** @ngInject */
  function PhaseTypeCtrl($scope, $mdToast, $mdDialog, $document, StepperService, $interval, WorkScheduleType, PhaseService, $translate) {

    var vm = this;
    var _ = window._;
    vm.loading = true;
    vm.work_schedule_types = [];
    vm.phasesByType = [];
    vm.openForm = openForm;

    loadWorkSchedule();

    vm.step1 = {};
    vm.step2 = {};
    vm.phaseNameForm = {};

    vm.checkStep1FormValid = function () {
      return this.step1.$invalid;
    };

    vm.getPhases = function (phase) {
      return vm.phasesByType.filter(function (p) {
        return p.name !== phase.name;
      }).map(function (p) {
        return p.name;
      });
    };

    vm.getWorkTypes = function (phase) {
      return vm.work_schedule_types.filter(function (p) {
        return p.name !== phase.name;
      }).map(function (p) {
        return p.name;
      });
    };

    vm.saveColor = function () {
      $mdDialog.close();
    };

    vm.showDialogStep1 = function (ev) {
      $mdDialog.show({
        controller: 'PhaseDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/work-schedule-template/phase-type/dialog/phase-type-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            dialogType: 'add',
            work_schedule_types: vm.work_schedule_types
          }
        }
      });
    };

    vm.saveWorkType = function () {
      WorkScheduleType.update().then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Phase/s Type/s has been updated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    };

    vm.savePhase = function () {
      PhaseService.update().then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Phase/s Name/s has been updated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    };


    vm.showDialogStep2 = function (ev) {
      $mdDialog.show({
        controller: 'PhaseNameDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/work-schedule-template/phase-type/dialog/phase-name-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            dialogType: 'add',
            phases: vm.phasesByType,
            work_type_id: vm.phaseSelectedId,
            openColorPicker: vm.openColorPicker
          }
        }
      });
    };


    $scope.stepCurrent = 1;

    /**
     * currentStep
     */
    function currentStep() {
      $scope.stepCurrent = StepperService.getStepNumber();
    }

    /**
     * Interval - Upload banner and save with next
     */

    $scope.$watch('stepCurrent', function (newVal) {
      vm.loading = true;
      if (newVal == 2) {
        loadPhases();
      }
      if (newVal == 1) {
        loadWorkSchedule();
      }
    });

    /**
     * Change in step
     */
    function openForm() {
      currentStep();
    }

    /**
     * loadWorkSchedule
     */
    function loadWorkSchedule() {
      return WorkScheduleType.get().then(function (types) {
        vm.loading = false;
        vm.work_schedule_types = types;
      });
    }


    /**
     * loadPhases
     */
    function loadPhases() {
      PhaseService.getByType(vm.phaseSelectedId).then(function (phases) {
        vm.phasesByType = phases;
        vm.loading = false;
      });
    }

    vm.openColorPicker = function (ev, phase, saveFn) {
      $mdDialog.show({
        controller: 'PhaseColorPickerDialogController',
        controllerAs: 'vm',
        multiple: true,
        templateUrl: 'app/main/farm-admin/work-schedule-template/phase-type/dialog/color-picker-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            phase: phase,
            saveFn: saveFn
          }
        }
      });
    };

    vm.deleteWorkScheduleType = function (ev, phase) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('PHASE.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent($translate.instant('PHASE.CONFIRM_CONTENT'))
      .ariaLabel('delete phase type')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return WorkScheduleType.delete(phase);
      }).then(function () {
        if (phase.id == vm.phaseSelectedId) {
          vm.phaseSelectedId = null;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Phase Type has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    };


    vm.deletePhase = function (ev, phase) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('PHASE.ARE_YOU_SURE_TO_DELETE_PHASE_NAME'))
      .htmlContent($translate.instant('PHASE.CONFIRM_CONTENT_PHASE_NAME'))
      .ariaLabel('delete phase name')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        return PhaseService.delete(phase);
      }).then(function () {

        _.remove(vm.phasesByType, {
          id: phase.id
        });

        $mdToast.show({
          template: '<md-toast class="md-toast success">The Phase Name has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    };
  }


})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.users.users', [
      // 3rd Party Dependencies
      'xeditable',
      'ngFileUpload',
      'uiCropper',
      'ms-infinite-scroll',
      'ms-resize',
      'ui.mask',
      'ms-load-image',
      'ms-pw-check'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_users', {
      url      : '/users',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/users/users/users.html',
          controller : 'UsersCtrl as vm'
        }
      },
      bodyClass: 'users',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('users')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/users/users');

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.users.users', {
      title : 'Users',
      icon  : 'icon-account-multiple',
      state : 'app.farm-admin_users',
      weight: 23
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.users.users')
  .controller('UsersCtrl', UsersCtrl);

  /** @ngInject */
  function UsersCtrl($q,
    $state,
    $scope,
    $window,
    $timeout,
    $mdToast,
    $mdSidenav,
    $mdDialog,
    $document,
    $translate,
    $location,
    $rootScope,
    RoleService,
    CompanyService,
    UserService,
    NotifyGroupService,
    msUtils,
    api
    ) {
    var vm = this;
    var _ = window._;
    // Data
    /* Get user Info */
    var user = UserService.getLocalUser();
    vm.roles = user.roles;
    $scope.event = window.event;
    $scope.idUserOnline = user.id;
    $scope.admin = vm.roles.findIndex(function (i) {
      return i.name.toLowerCase() === 'super_user';
    }) >= 0;

    // Set default avatar
    if (user !== undefined && user !== null) {
      //user.image_url = 'assets/images/avatars/profile.jpg';
      vm.user = user;
    }
    if (vm.userOnline !== undefined && vm.userOnline !== null) {
      //vm.userOnline.avatar = 'assets/images/avatars/profile.jpg';
      vm.user = vm.userOnline;
      vm.user.notify_groups = [];
    }
    $scope.loadingData = true;
    vm.users = [];
    vm.allRolesGroups = [];
    vm.allNotifyGroups = [];
    vm.selectedUsers = [];
    vm.starredUsers = [];
    vm.filterIds = [];
    vm.listType = 'all';
    vm.listOrder = 'name';
    vm.listOrderAsc = false;
    vm.newGroupName = '';
    $scope.finishUpdate = true;
    $scope.deleteSuperUserRole = false;
    vm.offset = 20;
    vm.maxListLength = 20;
    //Users data from API.
    api.users.get({}, function (UsersData) {
      vm.users = UsersData.users;
      /**
       * Add starred for validation
       */
      if (vm.users) {
        vm.users.forEach(function (user) {
          if (user.starred === true) {
            vm.starredUsers.push(user.id);
          }
        });
      }
      /**
       * Add notify groups for validation
       */
      vm.users.forEach(function (user) {
        user.ng = [];
        if (user.notify_groups) {
          user.notify_groups.forEach(function (ng) {
            user.ng.push(ng.id);
          });
        }
      });
      /**
       * Add roles for validation
       */
      vm.users.forEach(function (user) {
        user.r = [];
        user.roles.forEach(function (r) {
          user.r.push(r.id);
        });
      });
    });

    /**
     * Users role from API
     * If user is not super_user - User Role "Super User" not loading
     *
     */
    user = JSON.parse(sessionStorage.getItem('user'));
    var admin = user.roles.findIndex(function (i) {
      return i.name.toLowerCase() === 'super_user';
    }) >= 0;
    var condition = {};
    if (admin === false) {
      condition = {except: 10};
    }
    api.roles.get(condition, function (RolesData) {
      vm.allRolesGroups = RolesData.roles;
    }, function () {
      //console.log(err);
    });
    /**
     * Users notify group from API
     */
    api.notify_groups.get({}, function (NotifyGroupsData) {
      vm.allNotifyGroups = NotifyGroupsData.notify_groups;
    },
    function (err) {
      console.error(err);
    });

    loadUserOnline();

    /**
     *Get user Info
     */
    function loadUserOnline() {
      var user = JSON.parse(sessionStorage.getItem('user'));
      vm.userOnline = user;
      vm.roles = user.roles;
      $scope.idUserOnline = user.id;
      vm.users.forEach(function (user) {
        var superUserOnline = vm.roles.findIndex(function (i) {
          return i.id === 10;
        }) >= 0;
        var superUser = user.roles.findIndex(function (i) {
          return i.id === 10;
        }) >= 0;
        if (user.id === $scope.idUserOnline && superUserOnline === superUser) {
          $scope.admin = true;
        }
      });
    }
    // Methods
    vm.load = load;
    vm.addUserDialog = addUserDialog;
    vm.filterChange = filterChange;
    vm.deleteUserConfirm = deleteUserConfirm;
    vm.deleteUser = deleteUser;
    vm.deleteSelectedUsers = deleteSelectedUsers;
    vm.toggleSelectUser = toggleSelectUser;
    vm.deselectUsers = deselectUsers;
    vm.selectAllUsers = selectAllUsers;
    vm.deleteUser = deleteUser;
    vm.addNewNotifyGroup = addNewNotifyGroup;
    vm.addNewRoleGroup = addNewRoleGroup;
    vm.editNotifyGroup = editNotifyGroup;
    vm.editRoleGroup = editRoleGroup;
    vm.editGroup = editGroup;
    vm.deleteGroup = deleteGroup;
    vm.deleteNotifyGroup = deleteNotifyGroup;
    vm.deleteRoleGroup = deleteRoleGroup;
    vm.toggleSidenav = toggleSidenav;
    vm.patchStarred = patchStarred;
    vm.patchActive = patchActive;
    vm.patchNotifyGroup = patchNotifyGroup;
    vm.patchRoleGroup = patchRoleGroup;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.loadMore = loadMore;
    vm.loaded = loaded;
    vm.setHighlight = setHighlight;

    $scope.$on('userChange', function (event, user) {
      var index = _.findIndex(vm.users, function (o) {
        return o.id === user.id;
      });
      _.assign(vm.users[index], user);
    });
    /**
    * Loaded photo
    * @param {*} user
    */
    function loaded(user) {
      user.photo = true;
    }
    /* Call to funciton load as first thing */
    CompanyService.get().then(function (result) {
      vm.companies = result.companies;
      load();
    });
    /**
     * [load description]
     * @return {[type]} [description]
     */
    function load(reloadNGroups) {
      var user = UserService.getLocalUser();
      if (user) {
        UserService.getUserNotifyGroups(user.id).then(function (data) {
          if (data) {
            vm.user.notify_groups = data.notify_groups;
          }
        },
        function (err) {
          console.error(err);
        });
      }
      UserService.getUsersWithOffset(0, vm.maxListLength).then(function (usersData) {
        vm.shownUsers = usersData.users;
        vm.shownUsers.forEach(function (user) {
          if (vm.myUserUpdate) {
            if (user.id === vm.myUserUpdate.id) {
              user.image_url = vm.myUserUpdate.image_url;
            }
          }
          user.r = [];
          user.ng = [];
          user.roles.forEach(function (r) {
            user.r.push(r.id);
          });
          if (user.notify_groups) {
            user.notify_groups.forEach(function (ng) {
              user.ng.push(ng.id);
            });
          }
          vm.filterIds.push(user.id);
          user.company = vm.companies.filter(function (c) {
            return c.id == user.company_id;
          }).shift();
          user.ng = [];
          if (user.notify_groups) {
            user.notify_groups.forEach(function (ng) {
              user.ng.push(ng.id);
            });
          }
          user.r = [];
          user.roles.forEach(function (r) {
            user.r.push(r.id);
          });
          $timeout(function() {
            user.photo = true;
          }, 2000);
        });
        $scope.loadingData = false;

        // If reload notify groups object is defined
        if(reloadNGroups) {
          vm.filterChange(reloadNGroups.group, reloadNGroups.type);
        }
      });
    }
    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function loadMore() {
      if (vm.shownUsers.length === vm.users.length) {
        return;
      }
      else {
        UserService.getUsersWithOffset(vm.offset, vm.maxListLength).then(function (usersData) {
          if (usersData.users.length > 0) {
            vm.shownUsers = vm.shownUsers.concat(usersData.users);
            usersData.users.forEach(function (user) {
              vm.filterIds.push(user.id);
              user.company = vm.companies.filter(function (c) {
                return c.id == user.company_id;
              }).shift();
              user.ng = [];
              if (user.notify_groups) {
                user.notify_groups.forEach(function (ng) {
                  user.ng.push(ng.id);
                });
              }
              user.r = [];
              user.roles.forEach(function (r) {
                user.r.push(r.id);
              });

            });
          }
          else
            return;
        });
        vm.offset += vm.maxListLength;
      }
    }
    /**
     * Method that will updated user online in list by toolbar
     */
    $scope.$on('updateUserOnlineUserController', function() {
      vm.myUserUpdate = UserService.getLocalUser();
      vm.users.forEach(function (user) {
        if (user.id === vm.myUserUpdate.id) {
          user = vm.myUserUpdate;
        }
      });
      load();
    });
    /**
     * [addUserDialog description]
     */
    function addUserDialog(ev, user, avoidClone) {
      if (!avoidClone) {
        vm.userClone = _.cloneDeep(user);
        vm.adminClone = _.cloneDeep($scope.admin);
        vm.selectedUser = user;
      }
      $mdDialog.show({
        controller: 'UserAddEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/users/users/dialogs/user/add-edit-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            users: vm.users,
            shownUsers: vm.shownUsers,
            filterChange: vm.filterChange,
            listType: vm.listType,
            starredUsers: vm.starredUsers,
            allNotifyGroups: vm.allNotifyGroups,
            allRolesGroups: vm.allRolesGroups,
            patchNotifyGroup: vm.patchNotifyGroup,
            patchRoleGroup: vm.patchRoleGroup,
            addUserDialog: vm.addUserDialog,
            admin: vm.adminClone,
            user: vm.userClone,
            dialogType: 'add',
            ev: ev
          }
        }
      })
      .finally(function() {
        if (vm.userClone.save) {
          vm.userClone.save = null;
          _.assign(vm.selectedUser, vm.userClone);
          vm.selectedUser.image_url = vm.userClone.image_url;
        }
      });
    }
    /**
     * Change Users List Filter
     * @param type
     */
    function filterChange(type, group_type) {
      $scope.groupType = group_type;
      vm.listType = type;
      vm.shownUsers.forEach(function (user) {
        user.photo = undefined;
        $timeout(function() {
          user.photo = true;
        }, 800);
      });
      if (type === 'all') {
        vm.filterIds = null;
      }
      else if (type === 'starred') {
        vm.filterIds = [];
        vm.filterIds = vm.starredUsers;
      }
      else if (angular.isObject(type) && group_type) {
        /* Get all user ids that match the notify group or role */
        var arrIds = [];
        vm.shownUsers.forEach(function (user) {
          // Filter by notify_groups or roles.
          if (group_type && user[group_type] && user[group_type].length > 0) {
            user[group_type].forEach(function (gt) {
              if (gt.id === type.id) {
                arrIds.push(user.id);
              }
            });
          }
        });
        vm.filterIds = arrIds;
      }
      vm.selectedUsers = [];
    }

    /**
     * Delete Contact Confirm Dialog
     */
    function deleteUserConfirm(user, ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + user.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete user')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteUser(user);
        vm.selectedContacts = [];
      }, function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Delete Contact
     */
    function deleteUser(user) {
      vm.users.splice(vm.users.indexOf(user), 1);
      vm.shownUsers.splice(vm.shownUsers.indexOf(user), 1);
    }

    /**
     * Delete Selected Users
     */
    function deleteSelectedUsers(ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_BULK'))
      .htmlContent('<b>' + vm.selectedUsers.length + ' selected</b>' + ' will be deleted.')
      .ariaLabel('delete users')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var arrIds = [];
        vm.selectedUsers.forEach(function (user) {
          arrIds.push(user.id);
        });
        UserService.bulkDelete(arrIds).then(function () {
          vm.selectedUsers.forEach(function (user) {
            vm.users.splice(vm.users.indexOf(user), 1);
            vm.shownUsers.splice(vm.shownUsers.indexOf(user), 1);
          });
          vm.selectedUsers = [];
          $mdToast.show({
            template: '<md-toast class="md-toast success">The users were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The users could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }
    /**
     * Toggle selected status of the user
     *
     * @param user
     * @param event
     */
    function toggleSelectUser(user) {
      if (event) {
        event.stopPropagation();
      }
      if (vm.selectedUsers.indexOf(user) > -1) {
        vm.selectedUsers.splice(vm.selectedUsers.indexOf(user), 1);
      } else {
        vm.selectedUsers.push(user);
      }
    }
    /**
     * Deselect users
     */
    function deselectUsers() {
      vm.selectedUsers = [];
    }
    /**
     * Select all users
     */
    function selectAllUsers() {
      vm.selectedUsers = $scope.filteredUsers;
    }

    /**
     * Create a new notify-group associated to the user.
     */
    function addNewNotifyGroup() {
      if (vm.newGroupName2 === '') {
        return;
      }
      var newGroupData = {
        'name': vm.newGroupName2
      };
      // Reset value
      vm.newGroupName2 = null;
      /**
       * Call service to create a new notify-group associated to the user.
       */
      NotifyGroupService.create(newGroupData).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Notify Group ' + newGroupData.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.allNotifyGroups.push(data.notify_group);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + vm.newGroupName + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }
    /**
     * Create a new role-gropu associated to the user
     */
    function addNewRoleGroup() {
      if (vm.newGroupName === '') {
        return;
      }
      var newGroupData = {
        'name': vm.newGroupName,
        'work_schedule_role_yesno': 'false'
      };
      // Reset value
      vm.newGroupName = null;
      /**
       * Call service to create a new notify-group associated to the user.
       */
      RoleService.create(newGroupData).then(function (data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">Ther role ' + newGroupData.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.allRolesGroups.push(data.role);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The role ' + newGroupData.name + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }
    /**
     * Edit group
     */
    function editGroup(ev, group) {
      vm.allNotifyGroups.forEach(function (notify_groups) {
        if (group.name === notify_groups.name) {
          editNotifyGroup(ev, group);
        }
      });
      vm.allRolesGroups.forEach(function (roles) {
        if (group.name === roles.name) {
          editRoleGroup(ev, group);
        }
      });
    }
    /**
     * Edit a notify group.
     *
     * @return {[type]} [description]
     */
    function editNotifyGroup(ev, group) {
      /**
       * Call service to update a notify-group.
       */
      NotifyGroupService.update(group.id, group).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' has been updated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function (err) {
        var error;
        if(err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + group.name + ' could not been updated.'+ ((error !== undefined)? error : '') +'</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }
    /**
     * Edit a role group.
     *
     * @return {[type]} [description]
     */
    function editRoleGroup(ev, group) {
      /**
       * Call service to update a role.
       */
      RoleService.update(group.id, group).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Role Group ' + group.name + ' has been updated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The group ' + group.name + ' could not been updated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }
    /**
     * Delete Group
     */
    function deleteGroup(ev, group) {
      vm.allNotifyGroups.forEach(function (notify_groups) {
        if (group.name === notify_groups.name) {
          deleteNotifyGroup(ev, group);
        }
      });
      vm.allRolesGroups.forEach(function (roles) {
        if (group.name === roles.name) {
          deleteRoleGroup(ev, group);
        }
      });
    }
    /**
     * Delete Notify Group
     */
    function deleteNotifyGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');
      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to create a new notify-group associated to the user.
         */
        NotifyGroupService.delete(group.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.allNotifyGroups.splice(vm.allNotifyGroups.indexOf(group), 1);
          vm.filterChange('all');
        },
        function (err) {
          var isGroupRelated = false;
          if (err.status === 409) {
            UserService.getUserNotifyGroups(vm.user.id).then(function(ngData) {
              ngData.notify_groups.forEach(function(notifyGroup) {
                if(group.id === notifyGroup.id) {
                  isGroupRelated = true;
                }
              });
              if(isGroupRelated) {
                var confirm2 = $mdDialog.confirm()
                .title($translate.instant('USERS.ARE_YOU_SURE_WANT_TO_REMOVE_GROUP_RELATION'))
                .htmlContent('<h3>The group <b>' + group.name + '</b> cannot be deleted because there are other users related to it.\
                  <br />Do you want to remove group relation from your user account?</h3> <b>' + group.name + '</b>' + ' relation will be removed from the user: <b>' + vm.user.name + '</b>')
                .ariaLabel('delete group relation')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');
                $mdDialog.show(confirm2).then(function () {
                  UserService.removeUserNotifyGroupRelation(vm.user.id, group.id).then(function () {
                    $mdToast.show({
                      template: '<md-toast class="md-toast success">The Notify Group ' + group.name + ' relation with user ' + vm.user.name + ' has been removed.</md-toast>',
                      position: 'top right',
                      hideDelay: 4500
                    });
                    // Reload users without reload the page.
                    var reloadNGroups = {group: group, type: 'notify_groups'};
                    vm.load(reloadNGroups);
                  },
                  function () {
                    $mdToast.show({
                      template: '<md-toast class="md-toast error">The group ' + group.name + ' relation could not be removed.</md-toast>',
                      position: 'top right',
                      hideDelay: 4500
                    });
                  });
                });
              } else {
                if (!isGroupRelated) {
                  $mdToast.show({
                    template: '<md-toast class="md-toast error">' + err.data.message + '.</md-toast>',
                    position: 'top right',
                    hideDelay: 6500
                  });
                }
              }
            });
          } else {
            if (err.status === 400 && !isGroupRelated) {
              $mdToast.show({
                template: '<md-toast class="md-toast error">' + err.data.message + '.</md-toast>',
                position: 'top right',
                hideDelay: 6500
              });
            }
          }
        });
      },
      function () {
        // Avoid unhandled call
      });
    }
    /**
     * Delete Role Group
     */
    function deleteRoleGroup(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');
      $mdDialog.show(confirm).then(function () {
        /**
         * Call service to create a new notify-group associated to the user.
         */
        RoleService.delete(group.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Role ' + group.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.allRolesGroups.splice(vm.allRolesGroups.indexOf(group), 1);
          vm.filterChange('all');
        },
        function (err) {
          if (err.status === 409) {
            var confirm2 = $mdDialog.confirm()
            .title($translate.instant('USERS.ARE_YOU_SURE_WANT_TO_REMOVE_GROUP_RELATION'))
            .htmlContent('<h3>The group <b>' + group.name + '</b> cannot be deleted because there are other users related to it.\
              <br />Do you want to remove group relation from your user account?</h3> <b>' + group.name + '</b>' + ' relation will be removed from the user: <b>' + vm.user.name + '</b>')
            .ariaLabel('delete group relation')
            .targetEvent(ev)
            .ok('OK')
            .cancel('CANCEL');

            $mdDialog.show(confirm2).then(function () {
              UserService.removeUserRoleRelation(vm.user.id, group.id).then(function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast success">The Role ' + group.name + ' relation with user ' + vm.user.name + ' has been removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
                $state.go($state.current, {}, {reload: true});
              },
              function () {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">The group ' + group.name + ' relation could not be removed.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              });
            });
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The group ' + group.name + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // Avoid unhandled call
      });
    }
    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
    /**
     * Function to patch starred user.
     *
     * @return {[type]} [description]
     */
    function patchStarred(user) {
      event.stopPropagation();

      var starred = false;
      if (vm.starredUsers.indexOf(user.id) !== -1) {
        starred = true;
      }
      UserService.patch(user.id, {starred: starred.toString()}).then(function () {
        var localUser = UserService.getLocalUser();
        user.starred = !user.starred;
        localUser.starred = user.starred;
        UserService.saveLocalUser(localUser);

        $mdToast.show({
          template: '<md-toast class="md-toast success">The user ' + user.name + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The user ' + user.name + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }
    /**
     * Function to patch active user.
     *
     * @return {[type]} [description]
     */
    function patchActive(user) {
      event.stopPropagation();
      UserService.patch(user.id, {active: user.active.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The user ' + user.name + ((user.active === true) ? ' has been activated.' : ' has been deactivated.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast error">The user ' + user.name + ' could not be activated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }
    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function patchNotifyGroup(user, group) {
      $scope.finishUpdate = false;
      var fncCall = 'userNotifyGroupAddRelation';
      var msg = 'related to';
      if (user.ng.indexOf(group.id) !== -1) {
        fncCall = 'userNotifyGroupRemoveRelation';
        msg = 'removed from';
      }
      /* timeout needed because toggleInArray should be executed first */
      $timeout(function () {
        UserService[fncCall](user.id, group.id).then(function () {
          // Update without refresh.
          if (fncCall === 'userNotifyGroupAddRelation') {
            user.ng.push(group.id);
            user.notify_groups.push(group);
          } else {
            user.ng.splice(user.ng.indexOf(group.id), 1);
            user.notify_groups.forEach(function (ngroup) {
              if (ngroup.id === group.id) {
                user.notify_groups.splice(_.findIndex(user.notify_groups, function (o) {
                  return o.id == group.id;
                }), 1);
              }
            });
          }
          $mdToast.show({
            template: '<md-toast class="md-toast success">The user ' + user.name + ' has been ' + msg + ' notify group ' + group.name + '.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.shownUsers.forEach(function (element) {
            if (element.id === user.id) {
              element.ng = user.ng;
            }
          });
          if (vm.listType === 'all') {
            vm.filterChange(vm.listType);
          } else {
            vm.filterChange(group, 'notify_groups');
          }
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The user ' + user.name + ' could not be ' + msg + ' notify group ' + group.name + '.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        }),
        vm.shownUsers.forEach(function (user) {
          user.ng = [];
          if (user.notify_groups) {
            user.notify_groups.forEach(function (ng) {
              user.ng.push(ng.id);
            });
          }
        });
        $scope.finishUpdate = true;
      });
    }
    /**
     * Patch User Role
     */
    function patchRoleGroup(user, group) {
      $scope.finishUpdate = false;
      if (user.id === $scope.idUserOnline && group.name === 'super_user') {
        $mdToast.show({
          template: '<md-toast class="md-toast warning">' + user.name + ' could not be role group ' + group.name + '.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      } else {
        $scope.finishUpdate = false;
        var fncCall = 'userRoleAddRelation';
        var msg = 'related to';
        if (user.r.indexOf(group.id) !== -1) {
          if (user.r.length === 1) {
            $mdToast.show({
              template: '<md-toast class="md-toast error">The user ' + user.name + ' must have a role.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            return;
          } else {
            fncCall = 'userRoleRemoveRelation';
            msg = 'removed from';
          }
        }
        /* timeout needed because toggleInArray should be executed first */
        $timeout(function () {
          RoleService[fncCall](user.id, group.id).then(function () {
            // Update without refresh.
            if (fncCall === 'userRoleAddRelation') {
              user.r.push(group.id);
              user.roles.push(group);
            } else {
              user.r.splice(user.r.indexOf(group.id), 1);
              user.roles.forEach(function (rgroup) {
                if (rgroup.id === group.id) {
                  // user.roles.splice(user.roles.indexOf(group), 1);
                  user.roles.splice(_.findIndex(user.roles, function (o) {
                    return o.id == group.id;
                  }), 1);
                }
              });
            }
            $mdToast.show({
              template: '<md-toast class="md-toast success">The user ' + user.name + ' has been ' + msg + ' role group ' + group.name + '.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            vm.shownUsers.forEach(function (element) {
              if (element.id === user.id) {
                element.r = user.r;
              }
            });
            if (vm.listType === 'all') {
              vm.filterChange(vm.listType);
            } else {
              vm.filterChange(group, 'roles');
            }
          },
          function () {
            $mdToast.show({
              template: '<md-toast class="md-toast error">The user ' + user.name + ' could not be ' + msg + ' role group ' + group.name + '.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
          }),
          vm.shownUsers.forEach(function (user) {
            user.r = [];
            user.roles.forEach(function (r) {
              user.r.push(r.id);
            });
          });
          $scope.finishUpdate = true;
        });
      }
    }

    /**
     * [setHighlight description]
     * @param {[type]} id [description]
     */
    function setHighlight(id) {
      var eleId ='#user-row-' + id;
      var ele = angular.element(eleId).css('background-color', 'whitesmoke');

      var interval = setInterval(releaseHighlight, 100);

      /**
       * [releaseHighlight description]
       * @return {[type]} [description]
       */
      function releaseHighlight() {
        var menuEle = angular.element('.md-open-menu-container.md-active');
        menuEle.css({
          'width': '256px',
          'position': 'absolute',
          'left':' auto',
          'right': '10px'
        });

        if(!menuEle.length) {
          ele.css('background-color', 'white');
          clearInterval(interval);
        }
      }
    }

    $scope.$on('updatedUser', function () {
      $state.reload();
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.farm-admin.users.farm-owner', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.farm-admin_farm-owner', {
        url: '/farm-owner',
        views: {
          'content@app': {
            templateUrl: 'app/main/farm-admin/users/farm-owner/farm-owner.html',
            controller: 'CompanyCtrl as vm'
          }
        },
        bodyClass: 'farm-owner',
        resolve  : {
          acl: function($q, AclService) {
            if(!AclService.can('farm_owner')) {
              // Does not have permission
              return $q.reject('unauthorized');
            }
          }
        }
      });

    // Translation for companies
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/users/farm-owner');

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.users.farm-owner', {
      title: 'Farm Owner',
      icon : 'icon-emoticon-cool',
      state: 'app.farm-admin_farm-owner',
      weight: 21
    });

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.users.farm-owner')
    .controller('CompanyCtrl', CompanyCtrl);

  /**
   * Admin company farm owner controller
   *
   * @param {[type]} $scope         [description]
   * @param {[type]} $translate     [description]
   * @param {[type]} $location      [description]
   * @param {[type]} $http          [description]
   * @param {[type]} $mdToast       [description]
   * @param {[type]} CompanyService [description]
   * @param {[type]} msUtils        [description]
   * @param {[type]} msApi          [description]
   */
  function CompanyCtrl(
    $q,
    $scope,
    $translate,
    $location,
    $http,
    $mdToast,
    CompanyService,
    msUtils,
    msApi,
    msNavigationService,
    AclService
  ) {

    var vm                    = this;
    var toastInstance         = {};
    $scope.title              = 'Company';
    vm.stateInput             = true;
    vm.form                   = {
      company: {
        name: '',
        contact_person: '',
        email_address: '',
        office_phone: '',
        cell_phone: '',
        fax: '',
        address1: '',
        address2: '',
        state: '',
        country: '',
        zipcode: ''
      }
    };
    // Navigation
    msNavigationService.deleteItem('farm_definition');

    msApi.request('countries@get',
      function(countriesInfo) {
        vm.countries = countriesInfo.countries;
      },
      function(res) {
        if(res.status === 401) {
          $location.url('/login');
        }
      }
    );
    // Methods
    $scope.hideToast      = hideToast;
    vm.saveCompany        = saveCompany;
    vm.checkIfCountryUSA  = checkIfCountryUSA;
    vm.toggleInArray      = msUtils.toggleInArray;

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      if(!AclService.can('farm_definition')) {
        // Does not have permission
        return $q.reject('unauthorized');
      }
      // Load data | get company of farm owner id #1.
      CompanyService.getCompany(1).then(function(response) {
        vm.company = response.company;
        vm.checkIfCountryUSA(vm.company.country, vm.company.state);
      },
      function() {
        // Handle error.
      });
    }

    /**
     * Add new company
     */
    function saveCompany() {
      var dataToPost = {
        name: vm.company.name,
        contact_person: vm.company.contact_person,
        email_address: vm.company.email_address,
        office_phone: vm.company.office_phone,
        cell_phone: vm.company.cell_phone,
        fax: vm.company.fax,
        address1: vm.company.address1,
        address2: vm.company.address2,
        city: vm.company.city,
        state: vm.company.state,
        country: vm.company.country,
        zipcode: vm.company.zipcode
      };
      /**
       * Create new user
       */
      CompanyService.update(1, dataToPost).then(function () {
        $mdToast.show({
          template: '<md-toast>The company '+ vm.company.name + ' has been updated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function(err) { //reject
        var error;
        if(err.status !== 500) {
          error = err.data.message;
        }
        toastInstance = $mdToast.show({
          template: '<md-toast>\
              The company '+ vm.company.name + ' could not be updated. ' + ((error !== undefined)? error : '') +
              '<md-button ng-click="hideToast()">X</md-button></md-toast>',
          position: 'top right',
          hideDelay: false,
          controller: 'CompanyCtrl',
        });
      });
    }
    /**
     * [checkIfCountryUSA description]
     * @return {[type]} [description]
     */
    function checkIfCountryUSA(country, selectedState) {
      if(country === 'United States') {
        vm.stateInput = false;
        /* Load states */
        msApi.request('states@get',
          function(statesInfo) {
            vm.states = statesInfo.states;
            if(selectedState && selectedState !== '') {
              vm.company.state = selectedState;
            }
          },
          function(err) {
            console.error(err);
          });
      } else {
        vm.states = '';
        vm.company.state = '';
        vm.stateInput = true;
      }
    }
    /**
     * [hideToast description]
     * @return {[type]} [description]
     * // TODO: MOVE THIS TO A TOAST CONTROLLER
     */
    function hideToast() {
      $mdToast.hide(toastInstance);
    }
  }

})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.users.companies', [
      // 3rd Party Dependencies
      'xeditable',
      'ngFileUpload',
      'uiCropper',
      'ms-infinite-scroll',
      'vAccordion',
      'ngAnimate',
      'ms-resize',
      'ui.mask',
      'ms-load-image'
    ])
    .config(config);

    /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_companies', {
      url      : '/companies/:id',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/users/companies/companies.html',
          controller : 'CompaniesCtrl as vm'
        }
      },
      bodyClass: 'companies',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('companies')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/users/companies');

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.users.companies', {
      title : 'Companies',
      icon  : 'icon-office',
      state : 'app.farm-admin_companies',
      weight: 22
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.users.companies')
  .controller('CompaniesCtrl', CompaniesCtrl);

  /** @ngInject */
  function CompaniesCtrl($state,
                         $scope,
                         $mdToast,
                         $mdDialog,
                         $timeout,
                         $mdSidenav,
                         $document,
                         $translate,
                         $location,
                         $stateParams,
                         UserService,
                         CompanyService,
                         BusinessRoleService,
                         msUtils,
                         msApi,
                         $http,
                         api) {

    var vm = this;
    var _ = window._;
    var bgAvatarColor = '';
    $scope.event = window.event;
    // Data
    /* Get user Info */
    //var user = UserService.getLocalUser();

    loadUserOnline();

    /**
     *
     * Get user Info
     */
    function loadUserOnline() {
      $scope.loadingData = true;
      var user = JSON.parse(sessionStorage.getItem('user'));
      vm.roles = user.roles;
      UserService.getUser(user.id).then(function (data) {
        vm.userOnline = data.user;
        var superUserOnline = vm.roles.findIndex(function (i) {
          return i.id === 10;
        }) >= 0;
        var superUser = vm.userOnline.roles.findIndex(function (i) {
          return i.id === 10;
        }) >= 0;
        if (superUserOnline === superUser) {
          $scope.admin = true;
        }
      });
    }

    vm.allBusinessGroups = [];
    vm.selectedCompanies = [];
    vm.starredCompanies = [];
    vm.filterIds = [];
    vm.listType = 'all';
    vm.listOrder = 'name';
    vm.listOrderAsc = false;
    vm.newGroupName = '';
    vm.offset = 10;
    vm.maxListLength = 10;
    vm.companies = [];

    // Company data from API.
    api.companies.get({}, function (CompaniesData) {
      vm.companies = CompaniesData.companies;
      /**
       * Set Company Starred
       */
      if (vm.companies) {
        angular.forEach(vm.companies, function (company) {
          if (company.starred === true) {
            vm.starredCompanies.push(company.id);
          }
        });
      }
      $scope.loadingData = false;
    },
    function (err) {
      console.error(err);
    });
    /**
     * Load business roles
     */
    api.business_roles.get({}, function (BusinessRoleData) {
      vm.allBusinessGroups = BusinessRoleData.business_roles;
    },
    function (err) {
      console.error(err);
    });
    // Methods
    vm.init = init;
    vm.openCompanyDialog = openCompanyDialog;
    vm.filterChange = filterChange;
    vm.deleteCompanyConfirm = deleteCompanyConfirm;
    vm.deleteCompany = deleteCompany;
    vm.deleteSelectedCompanies = deleteSelectedCompanies;
    vm.toggleSelectCompany = toggleSelectCompany;
    vm.deselectCompanies = deselectCompanies;
    vm.selectAllCompanies = selectAllCompanies;
    vm.deleteCompany = deleteCompany;
    vm.addNewGroup = addNewGroup;
    vm.deleteGroup = deleteGroup;

    vm.editGroup = editGroup;
    vm.editGroupForm = editGroupForm;
    vm.toggleSidenav = toggleSidenav;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;

    vm.checkIfCountryUSA = checkIfCountryUSA;
    vm.closeDialog = closeDialog;
    vm.patchStarred = patchStarred;
    vm.patchCompanyGroup = patchCompanyGroup;

    vm.loadMore = loadMore;
    vm.loaded = loaded;
    vm.setHighlight = setHighlight;
//////////

    init();

    /**
     * Initialization function.
     *
     * @return {[type]} [description]
     */
    function init() {
      /* add Business Roles for validation */
      vm.companies.forEach(function (company) {
        company.br = [];
        company.business_roles.forEach(function (br) {
          company.br.push(br.id);
        });
      });
      /* Get url params */
      if ($stateParams.id) {
        /* Search for company */
        vm.companies.forEach(function (company) {
          /* Company match */
          if (parseInt(company.id) === parseInt($stateParams.id)) {
            /* Open modal */
            vm.openCompanyDialog('', company);
          }
        });
      }

      CompanyService.getCompaniesWithOffset(0, vm.maxListLength).then(function (companiesData) {

        companiesData.companies.forEach(function (company) {
          company.br = [];
          company.business_roles.forEach(function (br) {
            company.br.push(br.id);
          });
        });

        vm.shownCompanies = companiesData.companies;
        vm.shownCompanies.forEach(function (company) {
          vm.filterIds.push(company.id);
        });
      });
    }

    /**
     * Loaded photo
     * @param {*} company
     */
    function loaded(company) {
      company.photo = true;
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function loadMore() {
      if (vm.shownCompanies.length === vm.companies.length) {
        return;
      }
      else {
        CompanyService.getCompaniesWithOffset(vm.offset, vm.maxListLength).then(function (companiesData) {
          if (companiesData.companies.length > 0) {

            companiesData.companies.forEach(function (company) {
              company.br = [];
              company.business_roles.forEach(function (br) {
                company.br.push(br.id);
              });
            });

            vm.shownCompanies = vm.shownCompanies.concat(companiesData.companies);
            companiesData.companies.forEach(function (company) {
              vm.filterIds.push(company.id);
            });
          }
          else
            return;
        });
        vm.offset += vm.maxListLength;
      }

    }

    /**
     * Open new company dialog
     *
     * @param ev
     * @param company
     */
    function openCompanyDialog(ev, company, avoidClone) {

      if (!avoidClone) {
        vm.companyClone = _.cloneDeep(company);
        vm.selectedCompany = company;
      }

      $mdDialog.show({
        controller: 'CompanyDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/users/companies/dialogs/company/company-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            companies: vm.companies,
            shownCompanies: vm.shownCompanies,
            filterChange: vm.filterChange,
            filterIds: vm.filterIds,
            company: vm.companyClone,
            starredCompanies: vm.starredCompanies,
            dialogType: 'add',
            groups: vm.allBusinessGroups,
            patchCompanyGroup: vm.patchCompanyGroup,
            openCompanyDialog: vm.openCompanyDialog,
            admin: $scope.admin,
            ev: ev
          }
        }
      })
      .finally(function () {
        if (vm.companyClone.save) {
          vm.companyClone.save = null;
          _.assign(vm.selectedCompany, vm.companyClone);
          vm.selectedCompany.image_url = vm.companyClone.image_url;
        }
      });

      setTimeout(function () {
        var bgAvatarEle = angular.element('.md-accent-bg.md-tall');

        if (avoidClone) {
          bgAvatarEle.css('background-color', bgAvatarColor);
        } else {
          bgAvatarColor = bgAvatarEle.css('background-color');
        }
      }, 500);

    }

    /**
     * Function Chance
     * @param {*} type
     */
    function filterChange(type) {
      vm.listType = type;
      vm.shownCompanies.forEach(function (company) {
        company.photo = undefined;
        $timeout(function () {
          company.photo = true;
        }, 800);
      });
      if (type === 'all') {
        vm.filterIds = [];
        angular.forEach(vm.shownCompanies, function (company) {
          vm.filterIds.push(company.id);
        });
      }
      else if (type === 'starred') {
        vm.filterIds = [];
        vm.filterIds = vm.starredCompanies;
      }
      else if (angular.isObject(type)) {
        // Get all companies ids that match
        var arraIds = [];
        vm.shownCompanies.forEach(function (company) {
          if (company.business_roles.length > 0) {
            company.business_roles.forEach(function (gt) {
              if (gt.id === type.id) {
                arraIds.push(company.id);
              }
            });
          }
        });
        vm.filterIds = arraIds;
      }
      vm.selectedCompanies = [];
    }

    /**
     * Delete Company Confirm Dialog
     */
    function deleteCompanyConfirm(company, ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('COMPANIES.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + company.name + ' </b>' + ' will be deleted.')
      .ariaLabel('delete company')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteCompany(company);
        vm.selectedCompanies = [];
      }, function () {

      });
    }

    /**
     * Delete Company
     */
    function deleteCompany(company) {
      CompanyService.delete(company.id).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The company ' + company.name + ' has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.companies.splice(vm.companies.indexOf(company), 1);
        vm.shownCompanies.splice(vm.shownCompanies.indexOf(company), 1);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The company ' + company.name + ' could not be deleted.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * Delete Selected Companies
     */
    function deleteSelectedCompanies(ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('COMPANIES.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + vm.selectedCompanies.length + ' selected</b>' + ' will be deleted.')
      .ariaLabel('delete companies')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var arrIds = [];
        vm.selectedCompanies.forEach(function (company) {
          arrIds.push(company.id);
        });
        CompanyService.bulkDelete(arrIds)
        .then(function () {
          vm.selectedCompanies.forEach(function (company) {
            vm.companies.splice(vm.companies.indexOf(company), 1);
            vm.shownCompanies.splice(vm.shownCompanies.indexOf(company), 1);
          });
          vm.selectedCompanies = [];
          $mdToast.show({
            template: '<md-toast class="md-toast success">The companies were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });

        },
        function (err) {
          var companiesNotDelete;
          if (err !== 500) {
            companiesNotDelete = err.data.companies_not_deleted.map(function (c) {
              return c.name;
            });
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">' + '(' + companiesNotDelete.toString() + ') ' + err.data.message + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      },
      function () {

      });
    }

    /**
     * Toggle selected status of the company
     *
     * @param company
     * @param event
     */
    function toggleSelectCompany(company, event) {

      if (event) {
        event.stopPropagation();
      }
      if (vm.selectedCompanies.indexOf(company) > -1) {
        vm.selectedCompanies.splice(vm.selectedCompanies.indexOf(company), 1);
      } else {
        vm.selectedCompanies.push(company);
      }

    }

    /**
     * Deselect companies
     */
    function deselectCompanies() {
      vm.selectedCompanies = [];
    }

    /**
     * Sselect all companies
     */
    function selectAllCompanies() {
      vm.selectedCompanies = $scope.filteredCompanies;
    }

    /**
     *
     */
    function addNewGroup() {
      if (vm.newGroupName === '') {
        return;
      }

      var newGroup = {
        'name': vm.newGroupName,

      };
      BusinessRoleService.create(newGroup).then(function (data) {
        $mdToast.show({
          //template: '<md-toast>The Businnes Roke Group ' + newGroupData.notify_group.name + ' has been created and associated to user: ' + vm.user.name + '.</md-toast>',
          template: '<md-toast class="md-toast success">The Businnes Role group ' + vm.newGroupName + ' has been created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.allBusinessGroups.push(data.business_roles);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The Business Role group ' + vm.newGroupName + ' could not be created.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Edit a Business Role group.
     *
     * @return {[type]} [description]
     */
    function editGroupForm(ev, group) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('COMPANIES.ARE_YOU_SURE_TO_EDIT_GROUP'))
      .htmlContent('<b>' + group.name + '</b>' + ' will be updated.')
      .ariaLabel('update group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        BusinessRoleService.update(group.id, group).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Business Role Group: ' + group.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          $state.go($state.current, {}, {reload: true});
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The Business Role Group: ' + group.name + ' could not been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {

      });
    }

    /**
     * Delete Group
     */
    function deleteGroup(ev) {
      var group = vm.listType;


      var confirm = $mdDialog.confirm()
      .title('Are you sure want to delete the group?')
      .htmlContent('The Business Role Group <b>' + group.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete group')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        BusinessRoleService.delete(group.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The Business Role Group ' + group.name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () { //reject
          $mdToast.show({
            template: '<md-toast class="md-toast error">The Business Role Group ' + group.name + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
        vm.allBusinessGroups.splice(vm.allBusinessGroups.indexOf(group), 1);
        filterChange('all');
      });

    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * Update Business Role Group
     */
    function editGroup() {
      var dataToPost = {
        id: vm.listType.id,
        name: vm.listType.name
      };

      BusinessRoleService.update(dataToPost.id, dataToPost).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Business Role Group ' + dataToPost.name + ' has been updated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () { //reject
        $mdToast.show({
          template: '<md-toast class="md-toast error">The Business Role Group ' + dataToPost.name + ' could not be updated.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });

    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * [checkIfCountryUSA description]
     * @return {[type]} [description]
     */
    function checkIfCountryUSA(country, selectedState) {
      if (country === 'United States') {
        vm.stateInput = false;
        /* Load states */
        $http.get().then(function (statesInfo) {
          vm.states = statesInfo.data.states;
          if (selectedState && selectedState !== '') {
            vm.company.state = selectedState;
          }
        },
        function (err) {
          console.error(err);
        });
      } else {
        vm.states = '';
        vm.company.state = '';
        vm.stateInput = true;
      }
    }

    /**
     * Function to patch starred company.
     *
     * @return {[type]} [description]
     */
    function patchStarred(company) {
      event.stopPropagation();

      var starred = false;
      if (vm.starredCompanies.indexOf(company.id) !== -1) {
        starred = true;
      }
      CompanyService.patch(company.id, {starred: starred.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The company ' + company.name + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        company.starred = !company.starred;
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The company ' + company.name + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
     * Function to assign a business role to company.
     *
     * @return {[type]} [description]
     */
    function patchCompanyGroup(company, group) {

      if (group.loading) {
        return;
      }

      $scope.finishUpdate = false;
      var fncCall = 'companyBusinessRolesAddRelation';
      var msg = 'related to';
      if (company.br.indexOf(group.id) != -1) {
        fncCall = 'companyBusinessRolesRemoveRelation';
        msg = 'removed from';
      }
      group.loading = true;
      /* timeout needed because toggleInArray should be executed first */
      $timeout(function () {
        CompanyService[fncCall](company.id, group.id).then(function () {
          // Update without refresh.
          if (fncCall === 'companyBusinessRolesAddRelation') {
            company.br.push(group.id);
            company.business_roles.push(group);
          } else {
            company.br.splice(company.br.indexOf(group.id), 1);
            company.business_roles.forEach(function (bgroup) {
              if (bgroup.id === group.id) {
                company.business_roles.splice(_.findIndex(company.business_roles, function (o) {
                  return o.id == group.id;
                }), 1);
              }
            });
          }
          group.loading = false;
          $mdToast.show({
            template: '<md-toast class="md-toast success">The company ' + company.name + ' has been ' + msg + ' Business Roles ' + group.name + '.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.shownCompanies.forEach(function (element) {
            if (element.id === company.id) {
              element.br = company.br;
            }
          });
          if (vm.listType === 'all') {
            vm.filterChange(vm.listType);
          } else {
            vm.filterChange(group);
          }
        },
        function (err) {
          var error;
          if (err.status !== 500) {
            error = err.data.message;
          }
          group.loading = false;
          $mdToast.show({
            template: '<md-toast class="md-toast error">The company ' + company.name + ' could not be ' + msg + ' Business Roles ' + group.name + '. ' + ((error != undefined) ? error : '') + '.</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        }),
        vm.shownCompanies.forEach(function (company) {
          company.br = [];
          company.business_roles.forEach(function (br) {
            company.br.push(br.id);
          });
        });
        $scope.finishUpdate = true;
      });
    }

    /**
     * Open new company dialog
     *
     * @param ev
     * @param company
     */
    function setHighlight(id) {
      var eleId = '#company-row-' + id;
      var ele = angular.element(eleId).css('background-color', 'whitesmoke');

      var interval = setInterval(releaseHighlight, 100);

      /**
       * Open new company dialog
       *
       * @param ev
       * @param company
       */
      function releaseHighlight() {
        var menuEle = angular.element('.md-open-menu-container.md-active');
        menuEle.css({
          'width': '256px',
          'position': 'absolute',
          'left': ' auto',
          'right': '10px'
        });

        if (!menuEle.length) {
          ele.css('background-color', '');
          clearInterval(interval);
        }
      }
    }

    $scope.$on('updatedCompany', function () {
      $state.reload();
    });
  }
})();

(function() {
  'use strict';

  angular
  .module('app.farm-admin.land.subleases')
  .controller('SubleasesCtrl', SubleasesCtrl);

  /** @ngInject */
  function SubleasesCtrl(
    $mdSidenav,
    $location,
    $mdToast,
    $mdDialog,
    $document,
    $translate,
    moment,
    SubleaseService,
    RanchService,
    BlockService,
    msUtils,
    AreaFiscalYearService,
    AreaService,
    $scope,
    api,
    _,
    $timeout
  ) {
    var vm                         = this;
    vm.listType                    = [];
    vm.filterIds                   = [];
    vm.filterLocationsIds          = [];
    vm.filterRanchesIds            = [];
    vm.filterCompaniesIds          = [];
    vm.filterStateIds              = [];
    vm.listType.name               = 'all';
    // Data
    vm.starredSubleases            = [];
    vm.subleases                   = [];
    vm.locations                   = [];
    vm.location_id                 = undefined;
    vm.ranches                     = [];
    vm.ranch_id                    = undefined;
    vm.blocks                      = [];
    vm.block_id                    = undefined;
    vm.tenantCompanies             = [];
    vm.tenant_id                   = undefined;
    vm.selectedSubleases           = [];
    vm.location_name               = '';
    vm.ranch_name                  = '';
    vm.offset                      = 10;
    vm.maxListLength               = 10;
    vm.get_subleases               = true;
    vm.filterTitle                 = '';
    vm.allFilterIds                = [];
    $scope.event                   = window.event;
    vm.filteredStarred             = false;
    vm.filteredState               = false;
    vm.loadListFiltered            = false;
    vm.area_id                     = null;


    // Methods
    vm.filterChange                = filterChange;
    vm.addSubleaseDialog           = addSubleaseDialog;
    vm.addSublease                 = addSublease;
    vm.editSublease                = editSublease;
    vm.patchStarred                = patchStarred;
    vm.getStateFilteredIds         = getStateFilteredIds;
    vm.getStarredFilteredIds       = getStarredFilteredIds;
    vm.toggleInArray               = msUtils.toggleInArray;
    vm.exists                      = msUtils.exists;
    vm.getLocationFilteredIds      = getLocationFilteredIds;
    vm.getRanchFilteredIds         = getRanchFilteredIds;
    vm.getBlockFilteredIds         = getBlockFilteredIds;
    vm.getTenantFilteredIds        = getTenantFilteredIds;
    vm.deleteSubleaseConfirm       = deleteSubleaseConfirm;
    vm.deleteSublease              = deleteSublease;
    vm.toggleSelectSublease        = toggleSelectSublease;
    vm.deselectSubleases           = deselectSubleases;
    vm.selectAllSubleases          = selectAllSubleases;
    vm.deleteSublease              = deleteSublease;
    vm.viewBlocksDialog            = viewBlocksDialog;
    vm.loadMore                    = loadMore;
    vm.goToBlockTab                = goToBlockTab;
    vm.toggleSidenav               = toggleSidenav;
    vm.checkTitleInclude           = checkTitleInclude;
    vm.capitalizeString            =  capitalizeString;

    vm.filterData = SubleaseService.getFilterData();
    if(vm.filterData.location_id) {
      vm.location_id = vm.filterData.location_id;
      vm.location_name = vm.filterData.location_name;
      if(vm.filterData.ranch_id) {
        vm.ranch_id = vm.filterData.ranch_id;
        vm.ranch_name = vm.filterData.ranch_name;
        if(vm.filterData.block_id) {
          vm.block_id = vm.filterData.block_id;
          vm.block_name = vm.filterData.block_name;
        }
      }
      SubleaseService.saveFilterData([]);
    }

    init();

    /**
    * [init description]
    * @return {[type]} [description]
    */
    function init() {
      $scope.loadingData = true;
      var user = sessionStorage.getItem('user');
      if(user) {
        vm.user = JSON.parse(user);
        var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;

        AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function(areaFiscalYearData) {
          vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
          AreaService.getAreaLocations(vm.area_id).then(function(locationsData) {
            vm.locations = locationsData.locations;
          },
          function(err) {
            console.error(err);
          });

          /* Get Subleases */
          api.subleases.get({ sublease: true, area_id: vm.area_id }, function(SubleasesData) {
            vm.subleases = SubleasesData.subleases;
            $scope.loadingData = false;

            if(vm.subleases) {
              angular.forEach(vm.subleases, function(sublease) {
                /**
                * Set Lease Starred
                */
                if(sublease.starred === true) {
                  vm.starredSubleases.push(sublease.id);
                }

                if (sublease.tenant_company_id) {
                  var idx = _.find(vm.tenantCompanies, {'id': sublease.tenant_company_id});
                  if (!idx) {
                    vm.tenantCompanies.push({id: sublease.tenant_company_id, name:sublease.tenant_company.name});
                  }
                }
              });

            }

          },
          function(err) {
            console.error(err);
          });

          var data = {
            offset: 0,
            limit: vm.maxListLength,
            area_id: vm.area_id
          };
          SubleaseService.getSubleasesWithOffset(data).then(function(subleasesData) {
            vm.shownSubleases=subleasesData.subleases;
            if(!vm.filterData.location_id) {
              vm.shownSubleases.forEach(function(sublease) {
                vm.filterIds.push(sublease.id);
              });
            }
          });

        },
        function(err) {
          console.error(err);
        });
      }


    }

    /**
    * [loadMore description]
    * @return {[type]} [description]
    */
    function loadMore() {
      if(vm.shownSubleases.length === vm.subleases.length) {
        return;
      }
      else{
        var data = {
          offset: vm.offset,
          limit: vm.maxListLength,
          area_id: vm.area_id
        };
        SubleaseService.getSubleasesWithOffset(data).then(function(subleasesData) {
          if(subleasesData.subleases.length>0) {
            vm.shownSubleases=vm.shownSubleases.concat(subleasesData.subleases);
            if(!vm.filterData.location_id) {
              subleasesData.leases.forEach(function(sublease) {
                vm.filterIds.push(sublease.id);
              });
            }
          }
          else
          return;
        });
        vm.offset += vm.maxListLength;
      }
    }

    /**
    * Change Users List Filter
    * @param type
    */
    function filterChange(type, id,name,fromBack) {
      var milisecondsTimeout = 0;
      if(fromBack) {
        milisecondsTimeout = 500;
        $scope.loadingData = true;
      }
      $timeout(function () {
        vm.loadListFiltered = true;
        vm.listType = { name: type };

        if (type === 'all') {
          vm.location_id = undefined;
          vm.location_name = '';
          vm.filterTitle = '';
          vm.ranches     = [];
          vm.ranch_id    = undefined;
          vm.ranch_name  = '';
          vm.blocks      = [];
          vm.block_id    = undefined;
          vm.tenant      = [] ;
          vm.tenant_id   = undefined;
          vm.tenant_name = '';
          vm.filterIds   = [];
          vm.filterLocationsIds          = [];
          vm.filterRanchesIds            = [];
          vm.companiesFilterIds          = [];
          vm.filterStateIds              = [] ;
          vm.filteredStarred = false;
          vm.filteredState = false;
          angular.forEach(vm.subleases, function(lease) {
            vm.filterIds.push(lease.id);
          });
        }

        else if (type === 'active' || type === 'expired' || type === 'expiring'  || type === 'future') {
          var stateCapitalize = vm.capitalizeString(type);
          vm.stringTitleInclude = checkTitleInclude();
          if (!vm.stringTitleInclude) {
            if(vm.filterTitle !== '') {
              vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
            }
            else {
              vm.filterTitle = stateCapitalize;
            }
          }
          else {
            vm.filterTitle = vm.filterTitle.replace(vm.stringTitleInclude,stateCapitalize);
            vm.listType.name = stateCapitalize;
          }

          getStateFilteredIds(type);
        }

        /* TYPE STARRED */
        else if (type === 'starred') {
          vm.stringTitleInclude = checkTitleInclude();
          if (!vm.stringTitleInclude) {
            if(vm.filterTitle !== '') {
              vm.filterTitle = vm.filterTitle + ' - Starred';
            }
            else {
              vm.filterTitle = 'Starred';
            }
          }
          else {
            vm.filterTitle = vm.filterTitle.replace(vm.stringTitleInclude,'Starred');
            vm.listType.name = 'Starred';
          }

          getStarredFilteredIds();
        }
        /* TYPE LOCATION */
        else if(type === 'location') {

          vm.starredBlocks = [];
          vm.ranches     = [];
          vm.ranch_id    = undefined;
          vm.ranch_name  = '';
          vm.blocks      = [];
          vm.block_id    = undefined;
          vm.location_name = name;
          vm.filterTitle = name;

          if(vm.landlord_name) {
            vm.filterTitle = vm.landlord_name + ' - ' + vm.location_name;
          }
          else {
            vm.filterTitle = vm.location_name;
          }
          getLocationFilteredIds(id);

          /**
          * Set Subleases Starred
          */
          if(vm.subleases) {
            angular.forEach(vm.subleases, function(sublease) {
              if(sublease.starred === true) {
                vm.starredSubleases.push(sublease.id);
              }
            });
          }

        }
        /* TYPE RANCH */
        else if(type === 'ranch') {
          vm.filterTitle = vm.location_name + ' - ' + name;
          vm.blocks      = [];
          vm.block_id    = null;
          vm.ranch_name = name;
          vm.ranch_id = id;
          getRanchFilteredIds(id);
        }
        /* TYPE BLOCK */
        else if(type === 'block') {
          vm.filterTitle = vm.location_name + ' - ' + vm.ranch_name + ' - ' + name;
          vm.block_name = name;
          vm.block_id = id;
          getBlockFilteredIds(id);
        }
        /* TYPE TENANT */
        else if(type === 'tenant') {
          if(name === vm.tenant_name) {
            vm.filteredStarred = false;
            vm.filteredState = false;
          }
          vm.tenant_name = name;
          vm.tenant_id = id;
          vm.filterTitle = '';
          if(vm.location_id && vm.ranch_id) {
            vm.filterTitle = vm.location_name + ' - ' + vm.ranch_name + ' - ' + vm.tenant_name;
          }
          else if(vm.location_id) {
            vm.filterTitle = vm.location_name + ' - ' + vm.tenant_name;
          }
          else {
            vm.filterTitle = vm.tenant_name;
          }
          getTenantFilteredIds(id);
        }
        vm.loadListFiltered = false;
        $scope.loadingData = false;
      },milisecondsTimeout);
    }


    /**
    * Toggle sidenav
    *
    * @param sidenavId
    */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }



    /**
    * Function to handle the behavior of add/edit an user.
    */
    function addSubleaseDialog(ev, sublease) {
      $mdDialog.show({
        controller         : 'SubleaseDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/farm-admin/land/subleases/dialogs/sublease/sublease-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            subleases      : vm.subleases,
            shownSubleases : vm.shownSubleases,
            filterIds      : vm.filterIds,
            sublease       : sublease,
            dialogType     : 'add'
          }
        }
      });
    }

    /**
    * [getStateFilteredIds description]
    * @return {[type]} [description]
    */
    function getStateFilteredIds(state) {
      vm.filteredStarred = false;
      vm.filteredState = state;
      vm.filterIds=[];
      vm.filterStateIds = [];
      SubleaseService.getStateFilteredSubleases(state).then(function(subleasesData) {
        vm.stateFilteredSubleases = subleasesData.subleases;
        if(vm.tenant_id && !vm.location_id) {
          vm.stateFilteredSubleases.forEach(function(sublease) {
            if(vm.filterCompaniesIds.indexOf(sublease.id)>=0) {
              vm.filterIds.push(sublease.id);
              vm.filterStateIds.push(sublease.id);
            }
          });
        }
        else {
          if (vm.location_id) {
            vm.stateFilteredSubleases.forEach(function(sublease) {
              if(vm.allFilterIds.indexOf(sublease.id)>=0) {
                vm.filterIds.push(sublease.id);
                vm.filterStateIds.push(sublease.id);
              }
            });
          }
          else {
            vm.stateFilteredSubleases.forEach(function(sublease) {
              vm.filterIds.push(sublease.id);
              vm.filterStateIds.push(sublease.id);
            });
          }
        }
      },
      function(err) {
        console.error(err);
      });
    }
    /**
    * [addSublease description]
    * @param  {[type]} ev    [description]
    * @param  {[type]}  [description]
    * @return {[type]}       [description]
    */
    function addSublease() {
      var data = [];
      if(vm.location_id) {
        data = {
          location_id: vm.location_id,
          location_name: vm.location_name,
          ranch_id: vm.ranch_id ? parseInt(vm.ranch_id) : null,
          ranch_name: vm.ranch_name ? vm.ranch_name : null,
          block_id: vm.block_id ? parseInt(vm.block_id) : null,
          block_name: vm.block_name ? vm.block_name : null,
        };
      }
      SubleaseService.saveFilterData(data);
      $location.url('/subleases/add');
    }
    /**
    * [editSublease description]
    * @param  {[type]} ev    [description]
    * @param  {[type]} sublease [description]
    * @return {[type]}       [description]
    */
    function editSublease(ev, sublease) {
      var data = [];
      if(vm.location_id) {
        data = {
          location_id: vm.location_id,
          location_name: vm.location_name,
          ranch_id: vm.ranch_id ? parseInt(vm.ranch_id) : null,
          ranch_name: vm.ranch_name ? vm.ranch_name : null,
          block_id: vm.block_id ? parseInt(vm.block_id) : null,
          block_name: vm.block_name ? vm.block_name : null,
        };
      }
      SubleaseService.saveFilterData(data);
      $location.url('/subleases/edit/' + sublease.id + '/' + 0);
    }

    /**
    * Function to patch starred sublease.
    *
    * @return {[type]} [description]
    */
    function patchStarred(sublease) {
      event.stopPropagation();
      var starred = true;
      if(vm.starredSubleases.indexOf(sublease.id) !== -1) {
        starred = false;
      }
      SubleaseService.patch(sublease.id, {starred: starred}).then(function() {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The sublease ' + sublease.sublease_number + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function() {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The sublease ' + sublease.sublease_number + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

    /**
    * Function to filter lease by location of its blocks
    * @param  {[type]} location_id [location id]
    * @return {[type]}             [description]
    */
    function getLocationFilteredIds(location_id) {
      vm.location_id=location_id;
      vm.filterIds = [];
      vm.filterLocationsIds=[];
      if(!vm.tenant_id) {
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && sublease.starred) {
                    vm.filterIds.push(sublease.id);
                    vm.filterLocationsIds.push(sublease.id);
                    vm.allFilterIds.push(sublease.id);
                  }
                });
              });
            }
          });
        }
        if(vm.filteredState) {
          var stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && vm.filterStateIds.indexOf(sublease.id)>=0) {
                    vm.filterIds.push(sublease.id);
                    vm.filterLocationsIds.push(sublease.id);
                    vm.allFilterIds.push(sublease.id);
                  }
                });
              });
            }
          });
        }
        else if(!vm.filteredStarred && !vm.filteredState) {
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id) {
                    vm.filterIds.push(sublease.id);
                    vm.filterLocationsIds.push(sublease.id);
                    vm.allFilterIds.push(sublease.id);
                  }
                });
              });
            }
          });
        }
      }
      else {
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && sublease.tenant_company_id === vm.tenant_id && sublease.starred) {
                    vm.filterIds.push(sublease.id);
                    vm.filterLocationsIds.push(sublease.id);
                    vm.allFilterIds.push(sublease.id);
                  }
                });
              });

            }
          });
        }
        if(vm.filteredState) {
          stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && sublease.tenant_company_id === vm.tenant_id && vm.filterStateIds.indexOf(sublease.id)>=0) {
                    vm.filterIds.push(sublease.id);
                    vm.filterLocationsIds.push(sublease.id);
                    vm.allFilterIds.push(sublease.id);
                  }
                });
              });

            }
          });
        }
        else if(!vm.filteredStarred && !vm.filteredState) {
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && sublease.tenant_company_id === vm.tenant_id) {
                    vm.filterIds.push(sublease.id);
                    vm.filterLocationsIds.push(sublease.id);
                    vm.allFilterIds.push(sublease.id);
                  }
                });
              });
            }
          });
        }
      }
      RanchService.getRanchesByLocation(location_id).then(function(ranchesData) {
        vm.ranches=ranchesData.ranches;
      });
    }

    /**
    * Function to filter sublease by ranch of its blocks
    * @param  {[type]} ranch_id [description]
    * @return {[type]}          [description]
    */
    function getRanchFilteredIds(ranch_id) {
      vm.filterIds = [];
      vm.allFilterIds = [];
      vm.filterRanchesIds = [];
      if(!vm.tenant_id) {
        /* IF STARRED SELECTED */
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && sublease.starred) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                  vm.filterRanchesIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          var stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && vm.filterStateIds.indexOf(sublease.id)>=0) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                  vm.filterRanchesIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                  vm.filterRanchesIds.push(sublease.id);
                }
              });
            }
          });
        }
      }
      else {
        /* IF STARRED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && sublease.tenant_company_id === parseInt(vm.tenant_id) && vm.filterLocationsIds.indexOf(sublease.id)>=0 && sublease.starred) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                  vm.filterRanchesIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && sublease.tenant_company_id === parseInt(vm.tenant_id) && vm.filterLocationsIds.indexOf(sublease.id)>=0 && vm.filterStateIds.indexOf(sublease.id)>=0) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                  vm.filterRanchesIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && sublease.tenant_company_id === parseInt(vm.tenant_id) && vm.filterLocationsIds.indexOf(sublease.id)>=0) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                  vm.filterRanchesIds.push(sublease.id);
                }
              });
            }
          });
        }
      }

      var lease_status = 'subleased';
      BlockService.getBlocksOfRanch(ranch_id, lease_status).then(function(blocksData) {
        vm.blocks = blocksData.blocks;
      },
      function(err) {
        console.error(err);
      });
    }



    /**
    * Function to filter sublease by ranch for its blocks
    * @param  {[type]} block_id [description]
    * @return {[type]}          [description]
    */
    function getBlockFilteredIds(block_id) {
      vm.filterIds = [];
      vm.allFilterIds = [];
      if(!vm.tenant_id) {
        /* IF SUBLEASED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Subleased';
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.id === block_id && sublease.subleased) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF STARRED SELECTED */
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.id === block_id && sublease.starred) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          var stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.id === block_id && vm.filterStateIds.indexOf(sublease.id)>=0) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.id === block_id) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                }
              });
            }
          });
        }
      }
      else {
        /* IF SUBLEASED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Subleased';
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.id === block_id && sublease.tenant_company_id === parseInt(vm.tenant_id) && vm.filterRanchesIds.indexOf(sublease.id)>=0 && sublease.subleased) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF STARRED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.id === block_id && sublease.tenant_company_id === parseInt(vm.tenant_id) && vm.filterRanchesIds.indexOf(sublease.id)>=0 && sublease.starred) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.id === block_id && sublease.tenant_company_id === parseInt(vm.tenant_id) && vm.filterRanchesIds.indexOf(sublease.id)>=0 && vm.filterStateIds.indexOf(sublease.id)>=0) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                }
              });
            }
          });
        }
        /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.subleases.forEach(function(sublease) {
            if(sublease.blocks !== []) {
              sublease.blocks.forEach(function(block) {
                if(block.id === block_id && sublease.tenant_company_id === parseInt(vm.tenant_id) && vm.filterRanchesIds.indexOf(sublease.id)>=0) {
                  vm.filterIds.push(sublease.id);
                  vm.allFilterIds.push(sublease.id);
                }
              });
            }
          });
        }
      }
    }

    /**
    * [getTenantFilteredIds description]
    * @param  {[type]} company_id [description]
    * @return {[type]}            [description]
    */
    function getTenantFilteredIds(company_id) {
      vm.filterIds = [];
      vm.allFilterIdsTemp  = vm.allFilterIds;
      vm.allFilterIds = [];
      /* IF LOCATION SELECTED */
      if(vm.location_id) {
        /* IF BLOCK SELECTED */
        if(vm.block_id) {
          /* IF STARRED SELECTED */
          if(vm.filteredStarred) {
            vm.filterTitle = vm.filterTitle + ' - Starred';
            vm.subleases.forEach(function(sublease) {
              if(sublease.blocks !== []) {
                sublease.blocks.forEach(function(block) {
                  if(sublease.tenant_company_id === company_id && block.id === parseInt(vm.block_id) && sublease.starred && vm.allFilterIdsTemp.indexOf(sublease.id)>=0) {
                    vm.filterIds.push(sublease.id);
                    vm.filterCompaniesIds.push(sublease.id);
                  }
                });
              }
            });
          }
          /* IF SOME STATE FILTER SELECTED */
          if(vm.filteredState) {
            var stateCapitalize = vm.capitalizeString(vm.filteredState);
            vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
            vm.subleases.forEach(function(sublease) {
              if(sublease.blocks !== []) {
                sublease.blocks.forEach(function(block) {
                  if(sublease.tenant_company_id === company_id && block.id === parseInt(vm.block_id) && vm.filterStateIds.indexOf(sublease.id)>=0 && vm.allFilterIdsTemp.indexOf(sublease.id)>=0) {
                    vm.filterIds.push(sublease.id);
                    vm.filterCompaniesIds.push(sublease.id);
                  }
                });
              }
            });
          }
          /* IF ANY 'FILTER BY' SELECTED */
          else if(!vm.filteredStarred && !vm.filteredState) {
            vm.subleases.forEach(function(sublease) {
              if(sublease.blocks !== []) {
                sublease.blocks.forEach(function(block) {
                  if(sublease.tenant_company_id === company_id && block.id === parseInt(vm.block_id)  && vm.allFilterIdsTemp.indexOf(sublease.id)>=0) {
                    vm.filterIds.push(sublease.id);
                    vm.filterCompaniesIds.push(sublease.id);
                  }
                });
              }
            });
          }
        }
        /* IF NO BLOCK SELECTED BUT RANCH SELECTED*/
        else if (vm.ranch_id) {
          /* IF STARRED SELECTED */
          if(vm.filteredStarred) {
            vm.filterTitle = vm.filterTitle + ' - Starred';
            vm.subleases.forEach(function(sublease) {
              if(sublease.blocks !== []) {
                sublease.blocks.forEach(function(block) {
                  if(sublease.tenant_company_id === company_id && block.ranch_id === parseInt(vm.ranch_id) && sublease.starred && vm.allFilterIdsTemp.indexOf(sublease.id)>=0) {
                    vm.filterIds.push(sublease.id);
                    vm.filterCompaniesIds.push(sublease.id);
                  }
                });
              }
            });
          }
          /* IF SOME STATE FILTER SELECTED */
          if(vm.filteredState) {
            stateCapitalize = vm.capitalizeString(vm.filteredState);
            vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
            vm.subleases.forEach(function(sublease) {
              if(sublease.blocks !== []) {
                sublease.blocks.forEach(function(block) {
                  if(sublease.tenant_company_id === company_id && block.ranch_id === parseInt(vm.ranch_id) && vm.filterStateIds.indexOf(sublease.id)>=0 && vm.allFilterIdsTemp.indexOf(sublease.id)>=0) {
                    vm.filterIds.push(sublease.id);
                    vm.filterCompaniesIds.push(sublease.id);
                  }
                });
              }
            });
          }
          /* IF ANY 'FILTER BY' SELECTED */
          else if(!vm.filteredStarred && !vm.filteredState) {
            vm.subleases.forEach(function(sublease) {
              if(sublease.blocks !== []) {
                sublease.blocks.forEach(function(block) {
                  if(sublease.tenant_company_id === company_id && block.ranch_id === parseInt(vm.ranch_id)  && vm.allFilterIdsTemp.indexOf(sublease.id)>=0) {
                    vm.filterIds.push(sublease.id);
                    vm.filterCompaniesIds.push(sublease.id);
                  }
                });
              }
            });
          }
        }
        /* IF NO RANCH SELECTED BUT LOCATION SELECTED*/
        else{
          /* IF STARRED SELECTED */
          if(vm.filteredStarred) {
            vm.filterTitle = vm.filterTitle + ' - Starred';
            vm.subleases.forEach(function(sublease) {
              if(sublease.blocks !== []) {
                sublease.blocks.forEach(function(block) {
                  RanchService.get(block.ranch_id).then(function(ranchData) {
                    if(ranchData.ranch.location_id === vm.location_id && sublease.tenant_company_id === company_id && sublease.starred && vm.filterLocationsIds.indexOf(sublease.id)>=0) {
                      vm.filterIds.push(sublease.id);
                      vm.filterCompaniesIds.push(sublease.id);
                    }
                  });
                });
              }
            });
          }
          /* IF SOME STATE FILTER SELECTED */
          if(vm.filteredState) {
            stateCapitalize = vm.capitalizeString(vm.filteredState);
            vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
            vm.subleases.forEach(function(sublease) {
              if(sublease.blocks !== []) {
                sublease.blocks.forEach(function(block) {
                  RanchService.get(block.ranch_id).then(function(ranchData) {
                    if(ranchData.ranch.location_id === vm.location_id && sublease.tenant_company_id === company_id && vm.filterStateIds.indexOf(sublease.id)>=0 && vm.filterLocationsIds.indexOf(sublease.id)>=0) {
                      vm.filterIds.push(sublease.id);
                      vm.filterCompaniesIds.push(sublease.id);
                    }
                  });
                });
              }
            });
          }
          /* IF ANY 'FILTER BY' SELECTED */
          else if(!vm.filteredStarred && !vm.filteredState) {
            vm.subleases.forEach(function(sublease) {
              if(sublease.blocks !== []) {
                sublease.blocks.forEach(function(block) {
                  RanchService.get(block.ranch_id).then(function(ranchData) {
                    if(ranchData.ranch.location_id === vm.location_id && sublease.tenant_company_id === company_id && vm.filterLocationsIds.indexOf(sublease.id)>=0) {
                      vm.filterIds.push(sublease.id);
                      vm.filterCompaniesIds.push(sublease.id);
                    }
                  });
                });
              }
            });
          }
        }
      }
      /* IF NO LOCATION SELECTED */
      else{
        /* IF STARRED SELECTED */
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.subleases.forEach(function(sublease) {
            if(sublease.tenant_company_id === company_id  && sublease.starred) {
              vm.filterIds.push(sublease.id);
              vm.filterCompaniesIds.push(sublease.id);
            }
          });
        }
        /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.subleases.forEach(function(sublease) {
            if(sublease.tenant_company_id === company_id && vm.filterStateIds.indexOf(sublease.id)>=0) {
              vm.filterIds.push(sublease.id);
              vm.filterCompaniesIds.push(sublease.id);
            }
          });
        }
        /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredStarred && !vm.filteredState) {
          vm.subleases.forEach(function(sublease) {
            if(sublease.tenant_company_id === company_id) {
              vm.filterIds.push(sublease.id);
              vm.filterCompaniesIds.push(sublease.id);
            }
          });
        }
      }
    }

    /**
    * Delete sublease Confirm Dialog
    */
    function deleteSubleaseConfirm(ev,sublease) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('SUBLEASES.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('Sublease '+ '<b>' + sublease.lease_number  + ' </b>' + ' will be deleted.')
      .ariaLabel('delete sublease')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteSublease(sublease);
        vm.selectedSubleases = [];
      }, function () {

      });
    }

    /**
    * Delete sublease
    */
    function deleteSublease(sublease) {
      SubleaseService.delete(sublease.id).then(function() {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The sublease '+ sublease.lease_number + ' has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.subleases.splice(vm.subleases.indexOf(sublease), 1);
        vm.shownSubleases.splice(vm.shownSubleases.indexOf(sublease), 1);
      },
      function() {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The sublease '+ sublease.lease_number + ' could not be deleted.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }


    /**
    * Toggle selected status of the sublease
    *
    * @param sublease
    * @param event
    */
    function toggleSelectSublease(sublease) {
      event.stopPropagation();
      if (vm.selectedSubleases.indexOf(sublease) > -1) {
        vm.selectedSubleases.splice(vm.selectedSubleases.indexOf(sublease), 1);
      } else {
        vm.selectedSubleases.push(sublease);
      }
    }

    /**
    * Deselect subleases
    */
    function deselectSubleases() {
      vm.selectedSubleases = [];
    }
    /**
    * Sselect all subleases
    */
    function selectAllSubleases() {
      vm.selectedSubleases = $scope.filteredSubleases;
    }

    /**
    * Function to handle the behavior of list blocks.
    */
    function viewBlocksDialog(ev, sublease) {
      $mdDialog.show({
        controller         : 'SubleaseListBlocksDialogCtrl',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/farm-admin/land/subleases/dialogs/sublease-list-blocks/sublease-list-blocks-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            sublease       : sublease,
            dialogType     : 'add'
          }
        }
      });
    }

    /**
    * [goToBlockTab description]
    * @param  {[type]} ev    [description]
    * @param  {[type]} lease [description]
    * @return {[type]}       [description]
    */
    function goToBlockTab(ev, lease) {
      $location.url('/subleases/edit/' + lease.id + '/' + 2);
    }

    /**
    * [getStarredFilteredIds description]
    * @return {[type]} [description]
    */
    /**
    * [getStarredFilteredIds description]
    * @return {[type]} [description]
    */
    function getStarredFilteredIds() {
      vm.filteredStarred = true;
      vm.filteredState = false;
      vm.filterIds=[];
      if(vm.tenant_id && !vm.location_id) {
        vm.starredSubleases.forEach(function(id) {
          if(vm.filterCompaniesIds.indexOf(id)>=0) {
            vm.filterIds.push(id);
          }
        });
      }
      else {
        if (vm.location_id) {
          vm.starredSubleases.forEach(function(id) {
            if(vm.allFilterIds.indexOf(id)>=0) {
              vm.filterIds.push(id);
            }
          });
        } else {
          vm.starredSubleases.forEach(function(id) {
            vm.filterIds.push(id);
          });
        }
      }
    }

    /**
    * [checkTitleInclude description]
    * @param  {[type]} string [description]
    * @return {[type]}        [description]
    */
    function checkTitleInclude() {
      if (vm.filterTitle.includes('Starred')) {
        return 'Starred';
      }
      else if (vm.filterTitle.includes('Active')) {
        return 'Active';
      }
      else if (vm.filterTitle.includes('Expiring')) {
        return 'Expiring';
      }
      else if (vm.filterTitle.includes('Expired')) {
        return 'Expired';
      }
      else if (vm.filterTitle.includes('Future')) {
        return 'Future';
      }
      else if (vm.filterTitle !== '')
        return '';
    }

    /**
    * [capitalizeString description]
    * @param  {[type]} string [description]
    * @return {[type]}        [description]
    */
    function capitalizeString(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.ranches')
    .controller('RanchesCtrl', RanchesCtrl);

  /** @ngInject */
  function RanchesCtrl(
    $state,
    $scope,
    $timeout,
    $mdToast,
    $mdSidenav,
    $mdDialog,
    $document,
    $translate,
    $location,
    RanchService,
    AreaFiscalYearService,
    AreaService,
    BlockService,
    LeaseService,
    msUtils
  ) {
    var vm                  = this;
    // Filter
    vm.listType             = [];
    vm.listType.name        = 'all';
    vm.filterIds            = [];
    vm.listOrder            = 'name';
    vm.listOrderAsc         = false;
    vm.filterChange         = filterChange;
    vm.search               = '';
    vm.ranches              = [];
    vm.locations            = [];
    //layout
    vm.selectedRanches      = [];
    vm.location_id          = parseInt($state.params.location_id) || null;
    vm.from_page_name       = $state.params.page_name || null;
    vm.from_entity_id       = parseInt($state.params.entity_id) || null;
    vm.offset               = 20;
    vm.maxListLength        = 20;
    vm.starredRanches       = [];
    vm.area_id              = null;
    vm.fromLeaseBlocks      = null;
    vm.filterTitle          = '';
    vm.filteredStarred      = false;
    vm.filteredActive       = false;
    vm.loadListFiltered     = false;
    vm.filterData                  = [];

    // Methods
    vm.selectAllRanches         = selectAllRanches;
    vm.deselectRanches          = deselectRanches;
    vm.toggleSidenav            = toggleSidenav;
    vm.toggleSelectRanch        = toggleSelectRanch;
    vm.addRanchDialog           = addRanchDialog;
    vm.addRanch                 = addRanch;
    vm.toggleInArray            = msUtils.toggleInArray;
    vm.exists                   = msUtils.exists;
    vm.deleteSelectedRanches    = deleteSelectedRanches;
    vm.editRanch                = editRanch;
    vm.patchStarred             = patchStarred;
    vm.patchActive              = patchActive;
    vm.deleteRanchConfirm       = deleteRanchConfirm;
    vm.getLocationFilteredIds   = getLocationFilteredIds;
    vm.getStarredFilteredIds    = getStarredFilteredIds;
    vm.getActiveFilteredIds     = getActiveFilteredIds;
    vm.loadMore                 = loadMore;
    vm.viewBlocks               = viewBlocks;
    vm.backToLeaseBlocksPage    = backToLeaseBlocksPage;
    vm.backToSubleaseBlocksPage = backToSubleaseBlocksPage;
    vm.backToBlocksPage         = backToBlocksPage;
    vm.checkTitleInclude        = checkTitleInclude;

    vm.filterData = RanchService.getFilterData();
    if(vm.filterData.location_id) {
      vm.location_id = vm.filterData.location_id;
      vm.location_name = vm.filterData.location_name;
      RanchService.saveFilterData([]);
    }
    else{
      vm.filterData = BlockService.getFilterData();
      if(vm.filterData.location_id) {
        vm.location_id = vm.filterData.location_id;
        vm.location_name = vm.filterData.location_name;
        if(vm.filterData.from_page && vm.filterData.from_page === 'add_block') {
          vm.from_page_name = 'add_block';
        }
      }
      else {
        vm.filterData = LeaseService.getLeaseBlockData();
        if(vm.filterData.location_id) {
          vm.location_id = vm.filterData.location_id;
          vm.location_name = vm.filterData.location_name;
          vm.lease_id = vm.filterData.lease_id;
          vm.isLease = vm.filterData.isLease;
          if(vm.filterData.from_page && vm.filterData.from_page === 'lease_blocks') {
            vm.from_page_name = 'lease_blocks';
          }
        }
      }
    }

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      $scope.loadingData = true;
      var user = sessionStorage.getItem('user');
      if(user) {
        vm.user = JSON.parse(user);
        var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;

        AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function(areaFiscalYearData) {
          vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
          AreaService.getAreaLocations(vm.area_id).then(function(locationsData) {
            vm.locations = locationsData.locations;
          },
          function(err) {
            console.error(err);
          });

          RanchService.getAreaRanches(vm.area_id).then(function(ranchesData) {
            vm.ranches = ranchesData.ranches;
            if(vm.ranches) {
              if(vm.from_page_name && vm.location_id) {

                vm.listType = null;
                vm.locations.forEach(function(location) {
                  if(location.id===vm.location_id)
                    vm.location_name = location.name;
                });
                $timeout(function () { filterChange('location',vm.location_id,vm.location_name); }, 100);
              }
              angular.forEach(vm.ranches, function(ranch) {
                if(ranch.starred === true) {
                  vm.starredRanches.push(ranch.id);
                }
              });

              $scope.loadingData = false;
            }
          },
          function(err) {
            console.error(err);
          });



          RanchService.getRanchesWithOffset(0,vm.maxListLength,vm.area_id).then(function(ranchesData) {
            vm.shownRanches=ranchesData.ranches;
          //  $scope.filteredRanches = vm.shownRanches;
            if(!vm.from_page_name) {
              vm.shownRanches.forEach(function(ranch) {
                vm.filterIds.push(ranch.id);
              });
            }
          });
        },

        function(err) {
          console.error(err);
        });
      }


    }


     /**
      * [loadMore description]
      * @param  {[type]} area_id [description]
      * @return {[type]}         [description]
      */
    function loadMore(area_id) {
      if(vm.shownRanches.length === vm.ranches.length) {
        return;
      }
      else{
        RanchService.getRanchesWithOffset(vm.offset,vm.maxListLength,area_id).then(function(ranchesData) {
          if(ranchesData.ranches.length>0) {
            vm.shownRanches=vm.shownRanches.concat(ranchesData.ranches);
         // $scope.filteredRanches = vm.shownRanches;
            if(!vm.from_page_name) {
              ranchesData.ranches.forEach(function(ranch) {
                vm.filterIds.push(ranch.id);
              });
            }
          }
          else
            return;
        });
        vm.offset += vm.maxListLength;
      }
    }


    /**
     * Change Ranches List Filter
     * @param type
     */
    function filterChange(type, id, name, fromBack) {
      var milisecondsTimeout = 0;
      if(fromBack) {
        milisecondsTimeout = fromBack;
      }
      $timeout(function () {
        vm.loadListFiltered = true;
        vm.listType = { name: type };

        if (type === 'all') {
          vm.location_name = '';
          vm.location_id = undefined;
          vm.filterIds = [];
          vm.filterTitle     = '';
          vm.filteredActive = false;
          vm.filteredStarred = false;
          angular.forEach(vm.ranches, function(ranch) {
            vm.filterIds.push(ranch.id);
          });
        }
        else if (type === 'starred') {
          if (!checkTitleInclude('Starred')) {
            if(vm.filterTitle.includes('Active')) {
              vm.filterTitle = vm.filterTitle.replace('Active','Starred');
            }
            else {
              vm.filterTitle = vm.filterTitle + ' - Starred';
            }
          }
          else {
            vm.listType.name = 'Starred';
          }

          getStarredFilteredIds();
        }
        else if (type === 'active') {
          if (!checkTitleInclude('Active')) {
            if(vm.filterTitle.includes('Starred')) {
              vm.filterTitle = vm.filterTitle.replace('Starred','Active');
            }
            else {
              vm.filterTitle = vm.filterTitle + ' - Active';
            }
          }
          else {
            vm.listType.name = 'Active';
          }

          getActiveFilteredIds();
        }
        else if (type === 'location') {
          if(vm.location_name === name) {
            vm.filteredStarred = false;
          }
          vm.starredBlocks = [];
          vm.location_name = name;
          vm.filterTitle = vm.location_name;
          getLocationFilteredIds(id);

                       /**
           * Set Ranches Starred
           */
          if(vm.ranches) {
            angular.forEach(vm.ranches, function(ranch) {
              if(ranch.starred === true) {
                vm.starredRanches.push(ranch.id);
              }
            });
          }

        }
        vm.loadListFiltered = false;
        vm.selectedRanches = [];
      },milisecondsTimeout);
    }

    /**
     * Toggle selected status of the ranch
     *
     * @param ranch
     * @param event
     */
    function toggleSelectRanch(ranch, event) {
      if (event) {
        event.stopPropagation();
      }

      if (vm.selectedRanches.indexOf(ranch) > -1) {
        vm.selectedRanches.splice(vm.selectedRanches.indexOf(ranch), 1);
      } else {
        vm.selectedRanches.push(ranch);
      }
    }
    /**
     * Load add page for given ranch
     * @param  {[type]} ev    [description]
     * @return {[type]}       [description]
     */
    function addRanch() {
      var data = [];
      if(vm.location_id) {
        data = {
          location_id: vm.location_id,
          location_name: vm.location_name,
        };
      }
      RanchService.saveFilterData(data);
      if(vm.location_id) {
        $location.url('/ranches/add/location_id/' + vm.location_id);
      }
      else {
        $location.url('/ranches/add');
      }
    }
    /**
     * Load edit page for given ranch
     * @param  {[type]} ev    [description]
     * @param  {[type]} ranch [description]
     * @return {[type]}       [description]
     */
    function editRanch(ev, ranch) {
      var data = [];
      if(vm.location_id) {
        data = {
          location_id: vm.location_id,
          location_name: vm.location_name,
        };
      }
      RanchService.saveFilterData(data);
      $location.url('/ranches/edit/' + ranch.id);

    }

    /**
     * Deselect ranches
     */
    function deselectRanches() {
      vm.selectedRanches = [];
    }
    /**
     * Sselect all ranches
     */
    function selectAllRanches() {
      vm.selectedRanches = $scope.filteredRanches;
    }
    /**
     * Delete Contact Confirm Dialog
     */
    function deleteRanchConfirm(ranch, ev) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('RANCHES.ARE_YOU_SURE_TO_DELETE'))
        .htmlContent('<b>' + ranch.name + '</b>' + ' will be deleted.')
        .ariaLabel('delete ranch')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteRanch(ranch);
        vm.selectedContacts = [];
      }, function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Delete Contact
     */
    function deleteRanch(ranch) {
      vm.ranches.splice(vm.ranches.indexOf(ranch), 1);
      vm.shownRanches.splice(vm.shownRanches.indexOf(ranch), 1);
    }

    /**
     * Delete Selected Ranches
     */
    function deleteSelectedRanches(ev) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('USERS.ARE_YOU_SURE_TO_DELETE_BULK'))
        .htmlContent('<b>' + vm.selectedRanches.length + ' selected</b>' + ' will be deleted.')
        .ariaLabel('delete ranches')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var arrIds = [];
        vm.selectedRanches.forEach(function (ranch) {
          arrIds.push(ranch.id);
        });
        RanchService.bulkDelete(arrIds).then(function () {
          vm.selectedRanches.forEach(function (ranch) {
            vm.ranches.splice(vm.ranches.indexOf(ranch), 1);
            vm.shownRanches.splice(vm.shownRanches.indexOf(ranch), 1);
          });
          vm.selectedRanches = [];

          $mdToast.show({
            template: '<md-toast>The ranches were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast>The ranches could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });

      },
      function () {
        // avoid unhandled rejection message.
      });
    }
    /**
     * Function to patch starred ranch.
     *
     * @return {[type]} [description]
     */
    function patchStarred(ranch) {
      var starred = false;
      if(vm.starredRanches.indexOf(ranch.id) !== -1) {
        starred = true;
      }
      RanchService.patch(ranch.id, {starred: starred.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The ranch ' + ranch.name + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function() {
        $mdToast.show({
          template: '<md-toast  class="md-toast error">The ranch ' + ranch.name + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });

      });
    }

    /**
     * Function to patch active ranch.
     *
     * @return {[type]} [description]
     */
    function patchActive(ranch) {
      RanchService.patch(ranch.id, {active: ranch.active.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The ranch ' + ranch.name + ((ranch.active === true) ? ' has been activated.' : ' has been deactivated.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.ranches.forEach(function(ranchOrig) {
          if(ranch.id === ranchOrig.id) {
            ranchOrig.active = ranch.active;
          }
        });
      },
      function() {
        $mdToast.show({
          template: '<md-toast  class="md-toast error">The ranch ' + ranch.name + ' could not be activated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });

      });
    }
    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }
    /**
     * Function to handle the behavior of add/edit an ranch.
     */
    function addRanchDialog(ev, ranch) {
      $mdDialog.show({
        controller         : 'RanchAddEditDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/farm-admin/land/ranches/dialogs/ranch/add-edit-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            ranches: vm.ranches,
            shownRanches: vm.shownRanches,
            ranch: ranch,
            locations: vm.locations,
            filterIds: vm.filterIds,
            location_id : vm.location_id,
            dialogType: 'add'
          }
        }
      });
/*function filterAfterAdd(){
         getLocationFilteredIds(vm.location_id);
      }      */

    }

    /**
     * [getLocationFilteredIds description]
     * @param  {[type]} location_id [description]
     * @return {[type]}             [description]
     */
    function getLocationFilteredIds(location_id) {
      vm.filterIds = [];
      vm.location_id = location_id;
      if(vm.filteredStarred) {
        vm.filterTitle = vm.filterTitle + ' - Active';
        vm.ranches.forEach(function(ranch) {
          if(ranch.location_id === location_id && ranch.starred) {
            vm.filterIds.push(ranch.id);

          }
        });
      }
      else {
        vm.ranches.forEach(function(ranch) {
          if(ranch.location_id === location_id) {
            vm.filterIds.push(ranch.id);
          }
        });
      }
    }

            /**
     * [getStarredFilteredIds description]
     * @return {[type]} [description]
     */
    function getStarredFilteredIds() {
      vm.filteredStarred  = true;
      vm.filteredActive = false;
      vm.filterIdsTemp=vm.filterIds;
      vm.filterIds=[];
      if (vm.location_id) {
        vm.starredRanches.forEach(function(id) {
          if(vm.filterIdsTemp.indexOf(id)>=0) {
            vm.filterIds.push(id);
          }
        });
      } else {
        vm.starredRanches.forEach(function(id) {
          vm.filterIds.push(id);
        });
      }
    }


        /**
     * [getStarredFilteredIds description]
     * @return {[type]} [description]
     */
    function getActiveFilteredIds() {
      vm.filteredActive = true;
      vm.filteredStarred = false;
      vm.filterIdsTemp=vm.filterIds;
      vm.filterIds=[];
      if (vm.location_id) {
        vm.ranches.forEach(function (ranch) {
          if(ranch && ranch.active && vm.filterIdsTemp.indexOf(ranch.id)>=0) {
            vm.filterIds.push(ranch.id);
          }
        });
      }
      else{
        vm.ranches.forEach(function (ranch) {
          if(ranch && ranch.active) {
            vm.filterIds.push(ranch.id);
          }
        });
      }
    }


    /**
     * [viewBlocks description]
     * @param  {[type]} location_id [description]
     * @param  {[type]} ranch_id    [description]
     * @return {[type]}             [description]
     */
    function viewBlocks(location_id, location_name, ranch_id, ranch_name) {
      var from_filter = false;
      if(vm.location_id) {
        from_filter = true;
      }
      var data = [];
      data = {
        location_id: location_id,
        location_name: location_name,
        ranch_id: ranch_id,
        ranch_name: ranch_name,
        from_filter: from_filter
      };
      RanchService.saveFilterData(data);
      $location.url('/blocks');
    }

    /**
     * [backToLeaseBlocksPage description]
     * @return {[type]} [description]
     */
    function backToLeaseBlocksPage () {
      if(vm.isLease) {
        $location.url('/leases/edit/'+ vm.lease_id + '/' + 2);
      }
      else {
        $location.url('/subleases/edit/'+ vm.lease_id + '/' + 2);
      }
    }

     /**
     * [backToSubleaseBlocksPage description]
     * @return {[type]} [description]
     */
    function backToSubleaseBlocksPage () {
      $location.url('/subleases/edit/'+ vm.sublease_id + '/' + 2);
    }

        /**
     * [checkTitleInclude description]
     * @param  {[type]} string [description]
     * @return {[type]}        [description]
     */
    function checkTitleInclude(string) {
      if (vm.filterTitle === '' || vm.filterTitle.includes(string)) {
        return true;
      }
      else
        return false;
    }

        /**
     * [backToBlocksPage description]
     * @return {[type]} [description]
     */
    function backToBlocksPage () {
      $location.url('/blocks/add');
    }


  }
})();

(function() {
  'use strict';

  angular
  .module('app.farm-admin.land.leases')
  .controller('LeasesCtrl', LeasesCtrl);

  /** @ngInject */
  function LeasesCtrl(
    $mdSidenav,
    $location,
    $mdToast,
    $mdDialog,
    $document,
    $translate,
    moment,
    LeaseService,
    RanchService,
    BlockService,
    msUtils,
    AreaFiscalYearService,
    AreaService,
    $stateParams,
    $scope,
    api,
    $timeout,
    _
    ) {
    var vm                         = this;
    vm.listType                    = [];
    vm.filterIds                   = [];
    vm.filterLocationsIds          = [];
    vm.filterRanchesIds            = [];
    vm.filterCompaniesIds          = [];
    vm.filterStateIds              = [];
    vm.listType.name               = 'all';
    // Data
    vm.starredLeases               = [];
    vm.locations                   = [];
    vm.location_id                 = null;
    vm.ranches                     = [];
    vm.ranch_id                    = null;
    vm.blocks                      = [];
    vm.block_id                    = null;
    vm.landlordCompanies             = [];
    vm.landlord_id                   = null;
    vm.selectedLeases              = [];
    vm.location_name               = '';
    vm.ranch_name                  = '';
    vm.block_name                  = '';
    vm.offset                      = 20;
    vm.maxListLength               = 20;
    vm.get_subleases               = false;
    vm.informationForm             = {};
    vm.originalBlocks              = [];
    vm.filterTitle                 = '';
    vm.allFilterIds                = [];
    vm.filteredStarred             = false;
    vm.filteredState               = false;
    vm.filteredSubleased           = false;
    vm.loadListFiltered            = false;
    vm.filterData                  = [];
    vm.area_id                     = null;


    // Methods
    vm.filterChange                = filterChange;
    vm.addLeaseDialog              = addLeaseDialog;
    vm.addLease                    = addLease;
    vm.editLease                   = editLease;
    vm.patchStarred                = patchStarred;
    vm.getStateFilteredIds         = getStateFilteredIds;
    vm.getStarredFilteredIds       = getStarredFilteredIds;
    vm.getSubleasedFilteredIds     = getSubleasedFilteredIds;
    vm.toggleInArray               = msUtils.toggleInArray;
    vm.exists                      = msUtils.exists;
    vm.getLocationFilteredIds      = getLocationFilteredIds;
    vm.getRanchFilteredIds         = getRanchFilteredIds;
    vm.getBlockFilteredIds         = getBlockFilteredIds;
    vm.getLandlordFilteredIds        = getLandlordFilteredIds;
    vm.deleteLeaseConfirm          = deleteLeaseConfirm;
    vm.deleteLease                 = deleteLease;
    vm.toggleSelectLease           = toggleSelectLease;
    vm.deselectLeases              = deselectLeases;
    vm.selectAllLeases             = selectAllLeases;
    vm.deleteLease                 = deleteLease;
    vm.viewBlocksDialog            = viewBlocksDialog;
    vm.loadMore                    = loadMore;
    vm.goToBlockTab                = goToBlockTab;
    vm.toggleSidenav               = toggleSidenav;
    vm.checkTitleInclude           = checkTitleInclude;
    vm.capitalizeString            =  capitalizeString;

    vm.filterData = LeaseService.getFilterData();
    if(vm.filterData.location_id) {
      vm.location_id = vm.filterData.location_id;
      vm.location_name = vm.filterData.location_name;
      if(vm.filterData.ranch_id) {
        vm.ranch_id = vm.filterData.ranch_id;
        vm.ranch_name = vm.filterData.ranch_name;
        if(vm.filterData.block_id) {
          vm.block_id = vm.filterData.block_id;
          vm.block_name = vm.filterData.block_name;
        }
      }
      LeaseService.saveFilterData([]);
    }


    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      $scope.loadingData = true;
      var user = sessionStorage.getItem('user');
      vm.user = JSON.parse(user);
      var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;

      AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function(areaFiscalYearData) {
        vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
        AreaService.getAreaLocations(vm.area_id).then(function(locationsData) {
          vm.locations = locationsData.locations;
        },
        function(err) {
          console.error(err);
        });

        /* Get Leases */
        api.leases.get({area_id: vm.area_id}, function(LeasesData) {
          vm.leases = LeasesData.leases;
          $scope.loadingData = false;

          /**
           * Set Lease Starred
           */

          if(vm.leases) {
            angular.forEach(vm.leases, function(lease) {
              if(lease.starred === true) {
                vm.starredLeases.push(lease.id);
              }

              lease.is_subleased = false;
              if(lease.blocks.length>0) {
                lease.blocks.forEach(function(block) {
                  api.blocks.get({ id: block.id }, function(BlockData) {
                    if(BlockData.sublease_dates.length) {
                      lease.is_subleased = true;
                    }
                  });
                });
              }

              if (lease.landlord_company_id) {
                var idx = _.find(vm.landlordCompanies, {'id': lease.landlord_company_id});
                if (!idx) {
                  vm.landlordCompanies.push({id: lease.landlord_company_id, name:lease.landlord_company.name});
                }
              }
            });
          }
        },
        function(err) {
          console.error(err);
        });

        var data = {
          offset: 0,
          limit: vm.maxListLength,
          area_id: vm.area_id
        };
        LeaseService.getLeasesWithOffset(data).then(function(leasesData) {
          vm.shownLeases=leasesData.leases;
          vm.shownLeases.forEach(function(lease) {
            if(!vm.filterData.location_id) {
              vm.filterIds.push(lease.id);
            }
            lease.is_subleased = false;
            if(lease.blocks.length>0) {
              lease.blocks.forEach(function(block) {
                api.blocks.get({ id: block.id }, function(BlockData) {
                  if(BlockData.sublease_dates.length) {
                    lease.is_subleased = true;
                  }
                });
              });
            }

          });
        });

      },
      function(err) {
        console.error(err);
      });




    }

     /**
      * [loadMore description]
      * @return {[type]} [description]
      */
    function loadMore() {
      if(vm.shownLeases.length === vm.leases.length) {
        return;
      }
      else{
        var data = {
          offset: vm.offset,
          limit: vm.maxListLength,
          area_id: vm.area_id
        };
        LeaseService.getLeasesWithOffset(data).then(function(leasesData) {
          if(leasesData.leases.length>0) {
            leasesData.leases.forEach(function(lease) {
              if(!vm.filterData.location_id) {
                vm.filterIds.push(lease.id);
              }
              lease.is_subleased = false;
              if(lease.blocks.length>0) {
                lease.blocks.forEach(function(block) {
                  api.blocks.get({ id: block.id }, function(BlockData) {
                    if(BlockData.block.is_subleased) {
                      lease.is_subleased = true;
                    }
                  });
                });
              }
            });
            vm.shownLeases=vm.shownLeases.concat(leasesData.leases);
            leasesData.leases.forEach(function(lease) {
              vm.filterIds.push(lease.id);
            });
          }
          else
            return;
        });
        vm.offset += vm.maxListLength;
      }
    }

    /**
     * Change Leases List Filter
     * @param type
     */
    function filterChange(type,id,name,fromBack) {
      var milisecondsTimeout = 0;
      if(fromBack) {
        milisecondsTimeout = 500;
        $scope.loadingData = true;
      }
      $timeout(function () {
        vm.loadListFiltered = true;
        vm.listType = { name: type };

        if (type === 'all') {
          vm.location_id = null;
          vm.location_name = null;
          vm.filterTitle = '';
          vm.ranches     = [];
          vm.ranch_id    = undefined;
          vm.ranch_name  = '';
          vm.blocks      = [];
          vm.block_id    = undefined;
          vm.landlord      = [] ;
          vm.landlord_id   = undefined;
          vm.landlord_name = '';
          vm.filterIds   = [];
          vm.filterLocationsIds          = [];
          vm.filterRanchesIds            = [];
          vm.filterCompaniesIds          = [];
          vm.filterStateIds              = [] ;
          vm.filteredStarred = false;
          vm.filteredState = false;
          vm.filteredSubleased = false;
          vm.filterData = {};
          angular.forEach(vm.leases, function(lease) {
            vm.filterIds.push(lease.id);
          });
        }
        else if (type === 'active' || type === 'expired' || type === 'expiring' || type === 'future') {
          var stateCapitalize = vm.capitalizeString(type);
          vm.stringTitleInclude = checkTitleInclude();
          if (!vm.stringTitleInclude) {
            if(vm.filterTitle !== '') {
              vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
            }
            else {
              vm.filterTitle = stateCapitalize;
            }
          }
          else {
            vm.filterTitle = vm.filterTitle.replace(vm.stringTitleInclude,stateCapitalize);
            vm.listType.name = stateCapitalize;
          }

          getStateFilteredIds(type);
        }
        /* TYPE STARRED */
        else if (type === 'starred') {
          vm.stringTitleInclude = checkTitleInclude();
          if (!vm.stringTitleInclude) {
            if(vm.filterTitle !== '') {
              vm.filterTitle = vm.filterTitle + ' - Starred';
            }
            else {
              vm.filterTitle = 'Starred';
            }
          }
          else {
            vm.filterTitle = vm.filterTitle.replace(vm.stringTitleInclude,'Starred');
            vm.listType.name = 'Starred';
          }

          getStarredFilteredIds();
        }
        /* TYPE SUBLEASED */
        else if (type === 'subleased') {
          vm.stringTitleInclude = checkTitleInclude();
          if (!vm.stringTitleInclude) {
            if(vm.filterTitle !== '') {
              vm.filterTitle = vm.filterTitle + ' - Subleased';
            }
            else {
              vm.filterTitle = 'Subleased';
            }

          }
          else {
            vm.filterTitle = vm.filterTitle.replace(vm.stringTitleInclude,'Subleased');
            vm.listType.name = 'Subleased';
          }

          getSubleasedFilteredIds();
        }
        /* TYPE LOCATION */
        else if(type === 'location') {

          vm.starredBlocks = [];
          vm.ranches     = [];
          vm.ranch_id    = undefined;
          vm.ranch_name  = '';
          vm.blocks      = [];
          vm.block_id    = undefined;
          vm.location_name = name;
          vm.filterTitle = name;

          if(vm.landlord_name) {
            vm.filterTitle = vm.landlord_name + ' - ' + vm.location_name;
          }
          else {
            vm.filterTitle = vm.location_name;
          }
          getLocationFilteredIds(id);

           /**
           * Set Leases Starred
           */
          if(vm.leases) {
            angular.forEach(vm.leases, function(lease) {
              if(lease.starred === true) {
                vm.starredLeases.push(lease.id);
              }
            });
          }

        }
        /* TYPE RANCH */
        else if(type === 'ranch') {
          vm.filterTitle = vm.location_name + ' - ' + name;
          vm.blocks      = [];
          vm.block_id    = null;
          vm.ranch_name = name;
          vm.ranch_id = id;
          getRanchFilteredIds(id);
        }
        /* TYPE BLOCK */
        else if(type === 'block') {
          vm.filterTitle = vm.location_name + ' - ' + vm.ranch_name + ' - ' + name;
          vm.block_name = name;
          vm.block_id = id;
          getBlockFilteredIds(id);
        }
        /* TYPE LANDLORD */
        else if(type === 'landlord') {
          if(name === vm.landlord_name) {
            vm.filteredSubleased = false;
            vm.filteredStarred = false;
            vm.filteredState = false;
          }
          vm.landlord_name = name;
          vm.landlord_id = id;
          vm.filterTitle = '';
          if(vm.location_id && vm.ranch_id) {
            vm.filterTitle = vm.location_name + ' - ' + vm.ranch_name + ' - ' + vm.landlord_name;
          }
          else if(vm.location_id) {
            vm.filterTitle = vm.location_name + ' - ' + vm.landlord_name;
          }
          else {
            vm.filterTitle = vm.landlord_name;
          }
          getLandlordFilteredIds(id);
        }
        vm.loadListFiltered = false;
        $scope.loadingData = false;
      },milisecondsTimeout);
    }


    /**
      * Toggle sidenav
      *
      * @param sidenavId
      */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }



    /**
     * Function to handle the behavior of add/edit an user.
     */
    function addLeaseDialog(ev, lease) {
      $mdDialog.show({
        controller         : 'LeaseDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/farm-admin/leases/dialogs/lease/lease-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            leases          : vm.leases,
            shownLeases     : vm.shownLeases,
            filterIds       : vm.filterIds,
            lease           : lease,
            dialogType     : 'add'
          }
        }
      });
    }

    /**
     * [getStateFilteredIds description]
     * @return {[type]} [description]
     */
    function getStateFilteredIds(state) {
      vm.filteredStarred = false;
      vm.filteredState = state;
      vm.filteredSubleased = false;
      vm.filterIds=[];
      vm.filterStateIds = [];
      LeaseService.getStateFilteredLeases(state).then(function(leasesData) {
        vm.stateFilteredLeases = leasesData.leases;
        if(vm.landlord_id && !vm.location_id) {
          vm.stateFilteredLeases.forEach(function(lease) {
            if(vm.filterCompaniesIds.indexOf(lease.id)>=0) {
              vm.filterIds.push(lease.id);
              vm.filterStateIds.push(lease.id);
            }
          });
        }
        else {
          if (vm.location_id) {
            vm.stateFilteredLeases.forEach(function(lease) {
              if(vm.allFilterIds.indexOf(lease.id)>=0) {
                vm.filterIds.push(lease.id);
                vm.filterStateIds.push(lease.id);
              }
            });
          }
          else {
            vm.stateFilteredLeases.forEach(function(lease) {
              vm.filterIds.push(lease.id);
              vm.filterStateIds.push(lease.id);
            });
          }
        }
      },
      function(err) {
        console.error(err);
      });
    }
    /**
     * [addLease description]
     * @param  {[type]} ev    [description]
     * @return {[type]}       [description]
     */
    function addLease() {
      var data = [];
      if(vm.location_id) {
        data = {
          location_id: vm.location_id,
          location_name: vm.location_name,
          ranch_id: vm.ranch_id ? parseInt(vm.ranch_id) : null,
          ranch_name: vm.ranch_name ? vm.ranch_name : null,
          block_id: vm.block_id ? parseInt(vm.block_id) : null,
          block_name: vm.block_name ? vm.block_name : null,
        };
      }
      LeaseService.saveFilterData(data);
      $location.url('/leases/add');
    }
    /**
     * [editLease description]
     * @param  {[type]} ev    [description]
     * @param  {[type]} lease [description]
     * @return {[type]}       [description]
     */
    function editLease(ev, lease) {
      var data = [];
      if(vm.location_id) {
        data = {
          location_id: vm.location_id,
          location_name: vm.location_name,
          ranch_id: vm.ranch_id ? parseInt(vm.ranch_id) : null,
          ranch_name: vm.ranch_name ? vm.ranch_name : null,
          block_id: vm.block_id ? parseInt(vm.block_id) : null,
          block_name: vm.block_name ? vm.block_name : null,
        };
      }
      LeaseService.saveFilterData(data);
      $location.url('/leases/edit/' + lease.id + '/' + 0);
    }

    /**
     * Function to patch starred lease.
     *
     * @return {[type]} [description]
     */
    function patchStarred(lease) {
      event.stopPropagation();

      var starred = true;
      if(vm.starredLeases.indexOf(lease.id) !== -1) {
        starred = false;
      }
      LeaseService.patch(lease.id, {starred: starred}).then(function() {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The lease ' + lease.lease_number + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function() {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The lease ' + lease.lease_number + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

 /**
  * Function to filter lease by location of its blocks
  * @param  {[type]} location_id [location id]
  * @return {[type]}             [description]
  */
    function getLocationFilteredIds(location_id) {
      vm.location_id=location_id;
      vm.filterIds = [];
      vm.filterLocationsIds=[];
      if(!vm.landlord_id) {
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Subleased';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && lease.is_subleased) {
                    vm.filterIds.push(lease.id);
                    vm.filterLocationsIds.push(lease.id);
                    vm.allFilterIds.push(lease.id);
                  }
                });
              });
            }
          });
        }
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && lease.starred) {
                    vm.filterIds.push(lease.id);
                    vm.filterLocationsIds.push(lease.id);
                    vm.allFilterIds.push(lease.id);
                  }
                });
              });
            }
          });
        }
        if(vm.filteredState) {
          var stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && vm.filterStateIds.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterLocationsIds.push(lease.id);
                    vm.allFilterIds.push(lease.id);
                  }
                });
              });
            }
          });
        }
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id) {
                    vm.filterIds.push(lease.id);
                    vm.filterLocationsIds.push(lease.id);
                    vm.allFilterIds.push(lease.id);
                  }
                });
              });
            }
          });
        }
      }
      else {
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Subleased';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && lease.landlord_company_id === vm.landlord_id && lease.is_subleased) {
                    vm.filterIds.push(lease.id);
                    vm.filterLocationsIds.push(lease.id);
                    vm.allFilterIds.push(lease.id);
                  }
                });
              });
            }
          });
        }
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && lease.landlord_company_id === vm.landlord_id && lease.starred) {
                    vm.filterIds.push(lease.id);
                    vm.filterLocationsIds.push(lease.id);
                    vm.allFilterIds.push(lease.id);
                  }
                });
              });

            }
          });
        }
        if(vm.filteredState) {
          stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && lease.landlord_company_id === vm.landlord_id && vm.filterStateIds.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterLocationsIds.push(lease.id);
                    vm.allFilterIds.push(lease.id);
                  }
                });
              });

            }
          });
        }

        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                RanchService.get(block.ranch_id).then(function(ranchData) {
                  if(ranchData.ranch.location_id === location_id && lease.landlord_company_id === vm.landlord_id) {
                    vm.filterIds.push(lease.id);
                    vm.filterLocationsIds.push(lease.id);
                    vm.allFilterIds.push(lease.id);
                  }
                });
              });
            }
          });
        }
      }
      RanchService.getRanchesByLocation(location_id).then(function(ranchesData) {
        vm.ranches=ranchesData.ranches;
      });
    }

    /**
     * Function to filter lease by ranch of its blocks
     * @param  {[type]} ranch_id [description]
     * @return {[type]}          [description]
     */
    function getRanchFilteredIds(ranch_id) {
      vm.filterIds = [];
      vm.allFilterIds = [];
      vm.filterRanchesIds = [];
      if(!vm.landlord_id) {
        /* IF SUBLEASED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Subleased';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && lease.subleased) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                  vm.filterRanchesIds.push(lease.id);
                }
              });
            }
          });
        }
        /* IF STARRED SELECTED */
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && lease.starred) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                  vm.filterRanchesIds.push(lease.id);
                }
              });
            }
          });
        }
       /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          var stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && vm.filterStateIds.indexOf(lease.id)>=0) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                  vm.filterRanchesIds.push(lease.id);
                }
              });
            }
          });
        }
        /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                  vm.filterRanchesIds.push(lease.id);
                }
              });
            }
          });
        }
      }
      else {
         /* IF SUBLEASED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Subleased';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && lease.landlord_company_id === parseInt(vm.landlord_id) && vm.filterLocationsIds.indexOf(lease.id)>=0 && lease.subleased) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                  vm.filterRanchesIds.push(lease.id);
                }
              });
            }
          });
        }
        /* IF STARRED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && lease.landlord_company_id === parseInt(vm.landlord_id) && vm.filterLocationsIds.indexOf(lease.id)>=0 && lease.starred) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                  vm.filterRanchesIds.push(lease.id);
                }
              });
            }
          });
        }
        /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && lease.landlord_company_id === parseInt(vm.landlord_id) && vm.filterLocationsIds.indexOf(lease.id)>=0 && vm.filterStateIds.indexOf(lease.id)>=0) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                  vm.filterRanchesIds.push(lease.id);
                }
              });
            }
          });
        }
          /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.ranch_id === ranch_id && lease.landlord_company_id === parseInt(vm.landlord_id) && vm.filterLocationsIds.indexOf(lease.id)>=0) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                  vm.filterRanchesIds.push(lease.id);
                }
              });
            }
          });
        }
      }

      var lease_status = 'leased';
      BlockService.getBlocksOfRanch(ranch_id, lease_status).then(function(blocksData) {
        vm.blocks = blocksData.blocks;
      },
      function(err) {
        console.error(err);
      });
    }



/**
 * Function to filter lease by ranch for its blocks
 * @param  {[type]} block_id [description]
 * @return {[type]}          [description]
 */
    function getBlockFilteredIds(block_id) {
      vm.filterIds = [];
      vm.allFilterIds = [];
      if(!vm.landlord_id) {
        /* IF SUBLEASED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Subleased';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.id === block_id && lease.subleased) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                }
              });
            }
          });
        }
        /* IF STARRED SELECTED */
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.id === block_id && lease.starred) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                }
              });
            }
          });
        }
       /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          var stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.id === block_id && vm.filterStateIds.indexOf(lease.id)>=0) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                }
              });
            }
          });
        }
        /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.id === block_id) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                }
              });
            }
          });
        }
      }
      else {
        /* IF SUBLEASED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Subleased';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.id === block_id && lease.landlord_company_id === parseInt(vm.landlord_id) && vm.filterRanchesIds.indexOf(lease.id)>=0 && lease.subleased) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                }
              });
            }
          });
        }
        /* IF STARRED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.id === block_id && lease.landlord_company_id === parseInt(vm.landlord_id) && vm.filterRanchesIds.indexOf(lease.id)>=0 && lease.starred) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                }
              });
            }
          });
        }
        /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.id === block_id && lease.landlord_company_id === parseInt(vm.landlord_id) && vm.filterRanchesIds.indexOf(lease.id)>=0 && vm.filterStateIds.indexOf(lease.id)>=0) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                }
              });
            }
          });
        }
        /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.leases.forEach(function(lease) {
            if(lease.blocks !== []) {
              lease.blocks.forEach(function(block) {
                if(block.id === block_id && lease.landlord_company_id === parseInt(vm.landlord_id) && vm.filterRanchesIds.indexOf(lease.id)>=0) {
                  vm.filterIds.push(lease.id);
                  vm.allFilterIds.push(lease.id);
                }
              });
            }
          });
        }
      }
    }

    /**
     * [getLandlordFilteredIds description]
     * @param  {[type]} company_id [description]
     * @return {[type]}            [description]
     */
    function getLandlordFilteredIds(company_id) {
      vm.filterIds = [];
      vm.allFilterIdsTemp  = vm.allFilterIds;
      vm.allFilterIds = [];
      /* IF LOCATION SELECTED */
      if(vm.location_id) {
      /* IF BLOCK SELECTED */
        if(vm.block_id) {
          /* IF SUBLEASED SELECTED */
          if(vm.filteredSubleased) {
            vm.filterTitle = vm.filterTitle + ' - Subleased';
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  if(lease.landlord_company_id === company_id && block.id === parseInt(vm.block_id) && lease.subleased && vm.allFilterIdsTemp.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterCompaniesIds.push(lease.id);
                  }
                });
              }
            });
          }
          /* IF STARRED SELECTED */
          if(vm.filteredStarred) {
            vm.filterTitle = vm.filterTitle + ' - Starred';
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  if(lease.landlord_company_id === company_id && block.id === parseInt(vm.block_id) && lease.starred && vm.allFilterIdsTemp.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterCompaniesIds.push(lease.id);
                  }
                });
              }
            });
          }
          /* IF SOME STATE FILTER SELECTED */
          if(vm.filteredState) {
            var stateCapitalize = vm.capitalizeString(vm.filteredState);
            vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  if(lease.landlord_company_id === company_id && block.id === parseInt(vm.block_id) && vm.filterStateIds.indexOf(lease.id)>=0 && vm.allFilterIdsTemp.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterCompaniesIds.push(lease.id);
                  }
                });
              }
            });
          }
          /* IF ANY 'FILTER BY' SELECTED */
          else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  if(lease.landlord_company_id === company_id && block.id === parseInt(vm.block_id)  && vm.allFilterIdsTemp.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterCompaniesIds.push(lease.id);
                  }
                });
              }
            });
          }
        }
        /* IF RANCH SELECTED BUT NO BLOCK SELECTED */
        else if (vm.ranch_id) {
          /* IF SUBLEASED SELECTED */
          if(vm.filteredSubleased) {
            vm.filterTitle = vm.filterTitle + ' - Subleased';
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  if(lease.landlord_company_id === company_id && block.ranch_id === parseInt(vm.ranch_id) && lease.subleased && vm.allFilterIdsTemp.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterCompaniesIds.push(lease.id);
                  }
                });
              }
            });
          }
          /* IF STARRED SELECTED */
          if(vm.filteredStarred) {
            vm.filterTitle = vm.filterTitle + ' - Starred';
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  if(lease.landlord_company_id === company_id && block.ranch_id === parseInt(vm.ranch_id) && lease.starred && vm.allFilterIdsTemp.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterCompaniesIds.push(lease.id);
                  }
                });
              }
            });
          }
          /* IF SOME STATE FILTER SELECTED */
          if(vm.filteredState) {
            stateCapitalize = vm.capitalizeString(vm.filteredState);
            vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  if(lease.landlord_company_id === company_id && block.ranch_id === parseInt(vm.ranch_id) && vm.filterStateIds.indexOf(lease.id)>=0 && vm.allFilterIdsTemp.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterCompaniesIds.push(lease.id);
                  }
                });
              }
            });
          }
          /* IF ANY 'FILTER BY' SELECTED */
          else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  if(lease.landlord_company_id === company_id && block.ranch_id === parseInt(vm.ranch_id)  && vm.allFilterIdsTemp.indexOf(lease.id)>=0) {
                    vm.filterIds.push(lease.id);
                    vm.filterCompaniesIds.push(lease.id);
                  }
                });
              }
            });
          }
        }
        else{
          /* IF SUBLEASED SELECTED */
          if(vm.filteredSubleased) {
            vm.filterTitle = vm.filterTitle + ' - Subleased';
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  RanchService.get(block.ranch_id).then(function(ranchData) {
                    if(ranchData.ranch.location_id === vm.location_id && lease.landlord_company_id === company_id && lease.subleased && vm.filterLocationsIds.indexOf(lease.id)>=0) {
                      vm.filterIds.push(lease.id);
                      vm.filterCompaniesIds.push(lease.id);
                    }
                  });
                });
              }
            });
          }
          /* IF STARRED SELECTED */
          if(vm.filteredStarred) {
            vm.filterTitle = vm.filterTitle + ' - Starred';
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  RanchService.get(block.ranch_id).then(function(ranchData) {
                    if(ranchData.ranch.location_id === vm.location_id && lease.landlord_company_id === company_id && lease.starred && vm.filterLocationsIds.indexOf(lease.id)>=0) {
                      vm.filterIds.push(lease.id);
                      vm.filterCompaniesIds.push(lease.id);
                    }
                  });
                });
              }
            });
          }
          /* IF SOME STATE FILTER SELECTED */
          if(vm.filteredState) {
            stateCapitalize = vm.capitalizeString(vm.filteredState);
            vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  RanchService.get(block.ranch_id).then(function(ranchData) {
                    if(ranchData.ranch.location_id === vm.location_id && lease.landlord_company_id === company_id && vm.filterStateIds.indexOf(lease.id)>=0 && vm.filterLocationsIds.indexOf(lease.id)>=0) {
                      vm.filterIds.push(lease.id);
                      vm.filterCompaniesIds.push(lease.id);
                    }
                  });
                });
              }
            });
          }
          /* IF ANY 'FILTER BY' SELECTED */
          else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
            vm.leases.forEach(function(lease) {
              if(lease.blocks !== []) {
                lease.blocks.forEach(function(block) {
                  RanchService.get(block.ranch_id).then(function(ranchData) {
                    if(ranchData.ranch.location_id === vm.location_id && lease.landlord_company_id === company_id && vm.filterLocationsIds.indexOf(lease.id)>=0) {
                      vm.filterIds.push(lease.id);
                      vm.filterCompaniesIds.push(lease.id);
                    }
                  });
                });
              }
            });
          }
        }
      }
      /* IF NO LOCATION SELECTED */
      else{
        /* IF SUBLEASED SELECTED */
        if(vm.filteredSubleased) {
          vm.filterTitle = vm.filterTitle + ' - Subleased';
          vm.leases.forEach(function(lease) {
            if(lease.landlord_company_id === company_id && lease.subleased) {
              vm.filterIds.push(lease.id);
              vm.filterCompaniesIds.push(lease.id);
            }
          });
        }
        /* IF STARRED SELECTED */
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.leases.forEach(function(lease) {
            if(lease.landlord_company_id === company_id  && lease.starred) {
              vm.filterIds.push(lease.id);
              vm.filterCompaniesIds.push(lease.id);
            }
          });
        }
        /* IF SOME STATE FILTER SELECTED */
        if(vm.filteredState) {
          stateCapitalize = vm.capitalizeString(vm.filteredState);
          vm.filterTitle = vm.filterTitle + ' - ' + stateCapitalize;
          vm.leases.forEach(function(lease) {
            if(lease.landlord_company_id === company_id && vm.filterStateIds.indexOf(lease.id)>=0) {
              vm.filterIds.push(lease.id);
              vm.filterCompaniesIds.push(lease.id);
            }
          });
        }
        /* IF ANY 'FILTER BY' SELECTED */
        else if(!vm.filteredSubleased && !vm.filteredStarred && !vm.filteredState) {
          vm.leases.forEach(function(lease) {
            if(lease.landlord_company_id === company_id) {
              vm.filterIds.push(lease.id);
              vm.filterCompaniesIds.push(lease.id);
            }
          });
        }
      }
    }




 /**
    * Delete Lease Confirm Dialog
    */
    function deleteLeaseConfirm(ev,lease) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('LEASES.ARE_YOU_SURE_TO_DELETE'))
        .htmlContent('Lease '+ '<b>' + lease.lease_number  + ' </b>' + ' will be deleted.')
        .ariaLabel('delete lease')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteLease(lease);
        vm.selectedLeases = [];
      }, function () {

      });
    }

    /**
    * Delete Lease
    */
    function deleteLease(lease) {
      LeaseService.delete(lease.id).then(function() {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The lease '+ lease.lease_number + ' has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.leases.splice(vm.leases.indexOf(lease), 1);
        vm.shownLeases.splice(vm.shownLeases.indexOf(lease), 1);
      },
      function() {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The lease '+ lease.lease_number + ' could not be deleted.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }


    /**
    * Toggle selected status of the lease
    *
    * @param lease
    * @param event
    */
    function toggleSelectLease(lease) {
      event.stopPropagation();

      if (vm.selectedLeases.indexOf(lease) > -1) {
        vm.selectedLeases.splice(vm.selectedLeases.indexOf(lease), 1);
      } else {
        vm.selectedLeases.push(lease);
      }
    }

   /**
    * Deselect leases
    */
    function deselectLeases() {
      vm.selectedLeases = [];
    }
   /**
    * Sselect all leases
    */
    function selectAllLeases() {
      vm.selectedLeases = $scope.filteredLeases;
    }
    /**
     * Function to handle the behavior of list blocks.
     */
    function viewBlocksDialog(ev, lease) {
      $mdDialog.show({
        controller         : 'LeaseListBlocksDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/farm-admin/land/leases/dialogs/lease-list-blocks/lease-list-blocks-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            lease          : lease,
            dialogType     : 'add'
          }
        }
      });
    }

    /**
     * [goToBlockTab description]
     * @param  {[type]} ev    [description]
     * @param  {[type]} lease [description]
     * @return {[type]}       [description]
     */
    function goToBlockTab(ev, lease) {
      $location.url('/leases/edit/' + lease.id + '/' + 2);
    }

    /**
     * [getStarredFilteredIds description]
     * @return {[type]} [description]
     */
    function getStarredFilteredIds() {
      vm.filteredStarred = true;
      vm.filteredState = false;
      vm.filteredSubleased = false;
      vm.filterIds=[];
      if(vm.landlord_id && !vm.location_id) {
        vm.starredLeases.forEach(function(id) {
          if(vm.filterCompaniesIds.indexOf(id)>=0) {
            vm.filterIds.push(id);
          }
        });
      }
      else {
        if (vm.location_id) {
          vm.starredLeases.forEach(function(id) {
            if(vm.allFilterIds.indexOf(id)>=0) {
              vm.filterIds.push(id);
            }
          });
        } else {
          vm.starredLeases.forEach(function(id) {
            vm.filterIds.push(id);
          });
        }
      }
    }


    /**
     * [getSubleasedFilteredIds description]
     * @return {[type]} [description]
     */
    function getSubleasedFilteredIds() {
      vm.filteredStarred = false;
      vm.filteredState = false;
      vm.filteredSubleased = true;
      vm.filterIds=[];
      if(vm.landlord_id && !vm.location_id) {
        vm.leases.forEach(function(lease) {
          if(lease.is_subleased && vm.filterCompaniesIds.indexOf(lease.id)>=0) {
            vm.filterIds.push(lease.id);
          }
        });
      }
      else {
        if (vm.location_id) {
          vm.leases.forEach(function(lease) {
            if(lease.is_subleased && vm.allFilterIds.indexOf(lease.id)>=0) {
              vm.filterIds.push(lease.id);
            }
          });
        }
        else{
          vm.leases.forEach(function(lease) {
            if(lease.is_subleased) {
              vm.filterIds.push(lease.id);
            }
          });
        }
      }
    }

        /**
     * [checkTitleInclude description]
     * @param  {[type]} string [description]
     * @return {[type]}        [description]
     */
    function checkTitleInclude() {
      if (vm.filterTitle.includes('Starred')) {
        return 'Starred';
      }
      else if (vm.filterTitle.includes('Subleased')) {
        return 'Subleased';
      }
      else if (vm.filterTitle.includes('Active')) {
        return 'Active';
      }
      else if (vm.filterTitle.includes('Expiring')) {
        return 'Expiring';
      }
      else if (vm.filterTitle.includes('Expired')) {
        return 'Expired';
      }
      else if (vm.filterTitle.includes('Future')) {
        return 'Future';
      }
      else if (vm.filterTitle !== '')
        return '';
    }

    /**
     * [capitalizeString description]
     * @param  {[type]} string [description]
     * @return {[type]}        [description]
     */
    function capitalizeString(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.land-definition', [
      'xeditable',
      'ms-resize'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_land-definition', {
      url      : '/land',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/land/land/land.html',
          controller : 'LandCtrl as vm'
        }
      },
      resolve : {
        acl: function($q, AclService) {
          if(!AclService.can('land_definition')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        },
        AreaData: function(apiResolver) {
          return apiResolver.resolve('areas@get');
        }
      },
      bodyClass: 'farm-admin',
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/land/land');

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.land.land-definition', {
      title: 'Areas',
      icon : 'icon-picture',
      state: 'app.farm-admin_land-definition',
      weight: 27
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.land-definition')
    .controller('LandCtrl', LandCtrl);

  /** @ngInject */
  function LandCtrl(
    $state,
    $scope,
    $timeout,
    $mdToast,
    $mdSidenav,
    $mdDialog,
    $document,
    $translate,
    $location,
    $stateParams,
    LandService,
    FarmService,
    StepperService,
    AreaFiscalYearService,
    msUtils,
    RanchService,
    LocationService,
    _,
    api
  ) {

    var vm = this;
    //Data
    $scope.areaName = '';
    $scope.locationName = '';
    $scope.dataAreaId = '';
    $scope.dataLocationId = '';
    $scope.stepCurrent = 1;
    $scope.loadingData = true;
    //Area data from API.
    api.areas.get({}, function(AreaData) {
      if (AreaData && AreaData.areas) {
        vm.areas = AreaData.areas;
        $scope.loadingData = false;
      }
    });

    vm.areaChanged = false;
    vm.error = undefined;
    vm.errorOnRanch = undefined;
    vm.updatedLocations = [];
    vm.landForm = [];
    vm.showSuccessMessage = false;
    //// Methods

    //Load
    vm.init = init;
    vm.load = load;
    vm.currentStep = currentStep;

    //Dialogs
    vm.openAreaDialog = openAreaDialog;
    vm.openLocationDialog = openLocationDialog;

    //ID
    vm.areaId = areaId;
    vm.locationId = locationId;

    //Add
    vm.openAreaDialog = openAreaDialog;
    vm.openLocationDialog = openLocationDialog;


    //Delete
    vm.deleteAreaConfirm = deleteAreaConfirm;
    vm.deleteArea = deleteArea;
    vm.deleteLocationConfirm = deleteLocationConfirm;
    vm.deleteLocation = deleteLocation;

    //Save
    vm.saveAreaConfirm = saveAreaConfirm;
    vm.saveArea = saveArea;
    vm.saveLocationConfirm = saveLocationConfirm;
    vm.saveLocation = saveLocation;
    vm.saveForm = saveForm;

    vm.exists = msUtils.exists;
    vm.openForm = openForm;

    vm.changedAreas = changedAreas;


    //RadioButton
    vm.radio = {
      groupArea: false,
      groupLocation: false,
    };
    /**
     * Load default area User Online
     */
    var user = sessionStorage.getItem('user');
    vm.user = JSON.parse(user);
    area();
    /**
     * Load Area
     */
    function area() {
      AreaFiscalYearService.getAreaFiscalYear(vm.user.default_global_area_fiscal_year_id).then(function(data) {
        vm.areaFiscalYearId = data.area_fiscal_year.area_id;
        load(vm.areaFiscalYearId);
        $scope.dataAreaId = vm.areaFiscalYearId;
        $scope.areaName = data.area_fiscal_year.area.name;
      },
      function (err) {
        console.error(err);
      });
    }
    /**
     * Current Step
     */
    function currentStep() {
      var nextStep = StepperService.getStepNumber();
      if($scope.stepCurrent !== nextStep) {
        vm.groupLocation = null;

        if($scope.stepCurrent === 1 && nextStep === 2 && vm.areaChanged) {
          saveArea();
        }
      }

      $scope.stepCurrent = nextStep;
    }
    /**
     * Change in step
     */
    function openForm() {
      currentStep();

    }
    init();
    /**
     * Load land referances name
     */
    function init() {
      FarmService.getFarm(1).then(function(FarmLandRefData) {
        vm.land_ref = FarmLandRefData.farm;
      },
      function(err) {
        console.error(err);
      });
    }
    /**
     * Checked area
     */
    function areaId(id, name) {
      $scope.loadingDataLocation = true;
      load(id);
      $scope.dataAreaId = id;
      $scope.areaName = name;
    }
    /**
     * Checked Variety
     */
    function locationId(id, name, sc) {
      $scope.dataLocationId = id;
      $scope.locationName = name;
      $scope.locationShortCode = sc;
    }
    /**
     * Load locations
     */
    function load(id) {
      LandService.getLocations(id).then(function (data) {
        vm.locations = data.locations;
        $scope.loadingDataLocation = false;
      },
        function (err) {
          console.error(err);
        });
    }

    /**
     * Open new area dialog
     *  @param ev
     *  @param area
     */
    function openAreaDialog(ev, area) {
      $mdDialog.show({
        controller         : 'LandDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/farm-admin/land/land/dialogs/land/land-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            land_ref : vm.land_ref,
            areas: vm.areas,
            area: area,
            dialogType: 'add'
          }
        }
      });
    }
    /**
     * Open new Location dialog
     *  @param ev
     *  @param location
     */
    function openLocationDialog(ev, location) {
      $mdDialog.show({
        controller: 'LandDialogLocationController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/land/land/dialogs/location/land-dialog-location.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            land_ref : vm.land_ref,
            locations: vm.locations,
            location: location,
            dataAreaId: $scope.dataAreaId,
            dialogType: 'add'
          }
        }
      });
    }

    /**
    * Delete Area Area Confirm Dialog
    */
    function deleteAreaConfirm(area, ev) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure want to delete the Area Name?')
        .htmlContent('<b>' + area.name +'</b>' + ' will be deleted.')
        .ariaLabel('delete area Name')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function ()
      {
        deleteArea(area);
      }, function ()
      {

      });
    }
    /**
    * Delete Area
    */
    function deleteArea(area) {
      LandService.deleteArea(area.id).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Area Name: ' + area.name + ' has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.areas.splice(vm.areas.indexOf(area), 1);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The Area Name: ' + area.name + ' could not be deleted.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }
    /**
    * Delete Location Confirm Dialog
    */
    function deleteLocationConfirm(location, ev) {
      var confirm = $mdDialog.confirm()
        .title('Are you sure want to delete the Location Name?')
        .htmlContent('<b>' + location.name +'</b>' + ' will be deleted.')
        .ariaLabel('delete Location Name')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteLocation(location);

      }, function ()
          {

      });
    }
    /**
    * Delete Location
    */
    function deleteLocation(location) {
      LandService.deleteLocation(location.id).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The Area Name: ' + location.name + 'has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });

        vm.locations.splice(vm.locations.indexOf(location), 1);
        var idx = _.findIndex(vm.areas, {'id': location.area_id});
        vm.areas[idx].Locations.splice(vm.locations.indexOf(location), 1);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The Area Name: ' + location.name + ' could not be deleted.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * Save Area Confirm Dialog
     */
    function saveAreaConfirm(ev) {

      var confirm = $mdDialog.confirm()
        .title($translate.instant('LANDS.ARE_YOU_SURE_TO_SAVE'))
        .htmlContent('Areas will be saved.')
        .ariaLabel('save ' + vm.land_ref.area_reference_name)
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        saveArea();
      }, function () {

        // avoid unhandled rejection message.
      });
    }
    /**
    * Save existent area (save on edit)
    */
    function saveArea() {
      vm.areas.forEach(function(area) {
        LandService.update(area.id, area).then(function () {
        },
          function () { //reject
            $mdToast.show({
              template: '<md-toast class="md-toast error">Area ' + area.name + ' could not be updated.</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          });
      }, this);
      $mdToast.show({
        template: '<md-toast class="md-toast success">Areas has been updated.</md-toast>',
        position: 'top right',
        hideDelay: 1000
      });
    }
    /**
    * Save Location Confirm Dialog
    */
    function saveLocationConfirm(ev) {

      var confirm = $mdDialog.confirm()
        .title($translate.instant('LANDS.ARE_YOU_SURE_TO_SAVE'))
        .htmlContent('Locations will be saved.')
        .ariaLabel('save ' + vm.land_ref.location_reference_name)
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        saveLocation();
      }, function () {

        // avoid unhandled rejection message.
      });
    }
    /**
    * Save existent location (save on edit)
    */
    function saveLocation() {
      vm.error = undefined;
      vm.showSuccessMessage = false;
      var promises = [];
      vm.locations.forEach(function(location) {
        promises.push(
          LocationService.update(location.id, location).then(function () {
          }).catch (function(error)  {
            vm.error=error.data.message;
            var parameter = '';
            if(!location.name) {
              parameter = 'location name';
            }
            if(!location.location_short_code) {
              parameter = 'short code';
            }
            var message;
            if(parameter !== '') {
              message = 'There is an error in the '+ parameter + ' field.';
            }
            else {
              message = vm.error ? vm.error.replace(/_/g, ' ') : '';
            }
            $mdToast.show({
              template: '<md-toast class="md-toast error">Location ' + location.name + ' could not be updated.'+ ((message !== undefined)? message : '') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });

          })
          );
      });

      Promise.all(promises).then(function() {
        if(vm.error === undefined) {
          var count = 0;
          vm.locations.forEach(function(location) {
            if(location.updatedCode) {
              count++;
              updateAssociatedRanches(location.id,location.location_short_code);
            }
          });

          if(count===0) {
            vm.showSuccessMessage=true;
            $mdToast.show({
              template: '<md-toast class="md-toast success">Locations were updated successfully.</md-toast>',
              position: 'top right',
              hideDelay: 1000
            });
          }
        }
      });

    }




    /**
     * [updateAssociatedRanches description]
     * @param  {[type]} locationId        [description]
     * @param  {[type]} locationShortCode [description]
     * @return {[type]}                   [description]
     */
    function updateAssociatedRanches(locationId,locationShortCode) {
      var promises = [];
      RanchService.getRanchesByLocation(locationId).then(function(ranchesData) {
        ranchesData.ranches.forEach(function(ranch) {
          ranch.location_short_code = locationShortCode;
          ranch.name = locationShortCode + ranch.section_name;
          promises.push(
            RanchService.update(ranch.id,ranch).then(function() {
            }).catch (function(error) {
              vm.error=error.data.message;
              var detail = error.data.info.name ? error.data.info.name : '';
              $mdToast.show({
                template: '<md-toast class="md-toast error">Ranch ' + ranch.name + ' could not be updated.' + ((vm.errorOnRanch !== undefined)? vm.errorOnRanch : '' + detail) + '</md-toast>',
                position: 'top right',
                hideDelay: 6000
              });
            })
          );
        });

        Promise.all(promises).then(function() {
          if(vm.error === undefined && !vm.showSuccessMessage) {
            vm.showSuccessMessage=true;
            $mdToast.show({
              template: '<md-toast class="md-toast success">Locations were updated successfully.</md-toast>',
              position: 'top right',
              hideDelay: 1000
            });
          }
        });
      });
    }


        /**
     * Save Form
     */
    function saveForm(ev) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('LANDS.ARE_YOU_SURE_TO_SAVE_ALL'))
        .htmlContent('All changes will be saved.')
        .ariaLabel('save all')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        saveArea();
        saveLocation();
      }, function () {

        // avoid unhandled rejection message.
      });
    }

    /**
     * [changedAreaName description]
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    function changedAreas() {
      vm.areaChanged = true;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.land.blocks')
    .controller('BlocksCtrl', BlocksCtrl);

  /** @ngInject */
  function BlocksCtrl(
    $mdSidenav,
    $location,
    $mdToast,
    $mdDialog,
    $document,
    moment,
    BlockService,
    RanchService,
    AreaService,
    LeaseService,
    AreaFiscalYearService,
    msUtils,
    $translate,
    $state,
    $stateParams,
    $scope,
    api,
    $timeout
  ) {
    var vm                         = this;
    vm.listType                    = [];
    vm.listType.name               = 'all';
    vm.listType.state = '';
    vm.filterIds                   = [];
    // Data
    vm.starredBlocks               = [];
    vm.user                        = [];
    vm.area_id                     = null;
    vm.ranches                     = [];
    vm.ranch_id                    = parseInt($state.params.ranch_id) || null;
    vm.locations                   = [];
    vm.location_id                 = parseInt($state.params.location_id) || null;
    vm.from_page_name              = $state.params.page_name || null;
    vm.from_entity_id              = parseInt($state.params.entity_id) || null;
    vm.landOwnerCompanies          = [];
    vm.location_name               = '';
    vm.blocks                      = [];
    vm.shownBlocks                 = [];
    vm.offset                      = 20;
    vm.maxListLength               = 20;
    vm.filterLocationsIds          = [];
    vm.allFilterIds                = [];
    vm.companiesFilterIds          = [];
    vm.filterTitle                 = '';
    vm.fromRanch                   = false;
    vm.fromLeaseBlocks             = false;
    vm.area_id                     = null;
    vm.filteredActive              = false;
    vm.filteredStarred             = false;
    vm.loadListFiltered            = false;
    vm.allLandOwnerCompanies       = [];
    vm.landOwnerCompanies          = [];
    vm.blocksCompaniesIds          = [];
    vm.filterData                  = [];
    var today = new Date().setUTCHours(0,0,0,0);
    today = new Date (today).toISOString();

    // Methods
    vm.filterChange                = filterChange;
    vm.addBlock                    = addBlock;
    vm.editBlock                   = editBlock;
    vm.patchStarred                = patchStarred;
    vm.getStarredFilteredIds       = getStarredFilteredIds;
    vm.getActiveFilteredIds        = getActiveFilteredIds;
    vm.getLocationFilteredIds      = getLocationFilteredIds;
    vm.getRanchFilteredIds         = getRanchFilteredIds;
    vm.getLandOwnerFilteredIds     = getLandOwnerFilteredIds;
    vm.toggleInArray               = msUtils.toggleInArray;
    vm.exists                      = msUtils.exists;
    vm.getLocationFilteredIds      = getLocationFilteredIds;
    vm.patchActive                 = patchActive;
    vm.deleteBlockConfirm          = deleteBlockConfirm;
    vm.deleteBlock                 = deleteBlock;
    vm.loadMore                    = loadMore;
    vm.toggleSidenav               = toggleSidenav;
    vm.backToRanchPage             = backToRanchPage;
    vm.backToLeaseBlocksPage       = backToLeaseBlocksPage;
    vm.checkTitleInclude           = checkTitleInclude;
    vm.goToRanchesPage             = goToRanchesPage;
    vm.goToLandPage                = goToLandPage;

    vm.filterData = BlockService.getFilterData();
    if(vm.filterData.location_id) {
      vm.location_id = vm.filterData.location_id;
      vm.location_name = vm.filterData.location_name;
      if(vm.filterData.ranch_id) {
        vm.ranch_id = vm.filterData.ranch_id;
        vm.ranch_name = vm.filterData.ranch_name;
      }
      BlockService.saveFilterData([]);
    }
    else{
      vm.filterData = RanchService.getFilterData();
      if(vm.filterData.location_id) {
        vm.from_page_name = 'ranches';
        vm.location_id = vm.filterData.location_id;
        vm.location_name = vm.filterData.location_name;
        if(vm.filterData.ranch_id) {
          vm.ranch_id = vm.filterData.ranch_id;
          vm.ranch_name = vm.filterData.ranch_name;
        }
        RanchService.saveFilterData([]);
      }
      else {
        vm.filterData = LeaseService.getLeaseBlockData();
        if(vm.filterData.location_id) {
          vm.location_id = vm.filterData.location_id;
          vm.location_name = vm.filterData.location_name;
          vm.ranch_id = vm.filterData.ranch_id;
          vm.ranch_name = vm.filterData.ranch_name;
          vm.lease_id = vm.filterData.lease_id;
          vm.isLease = vm.filterData.isLease;
          if(vm.filterData.from_page && vm.filterData.from_page === 'lease_blocks') {
            vm.from_page_name = 'lease_blocks';
            vm.fromLeaseBlocks = true;
          }
          LeaseService.saveLeaseBlockData([]);
        }
      }
    }


    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      $scope.loadingData = true;
      var user = sessionStorage.getItem('user');
      vm.user = JSON.parse(user);
      var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;

      AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function(areaFiscalYearData) {
        vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
        AreaService.getAreaLocations(vm.area_id).then(function(locationsData) {
          vm.locations = locationsData.locations;

          BlockService.getAreaBlocks(vm.area_id).then(function(blocksData) {
            vm.blocks = blocksData.blocks;

            if(vm.blocks) {
              if(vm.from_page_name && vm.location_id) {
                if(vm.from_page_name === 'ranches') {
                  vm.fromRanch = true;
                }
                vm.listType = null;

              }



              angular.forEach(vm.blocks, function(block) {
                vm.blocksCompaniesIds.push(block.company_id);
                if(block.starred === true) {
                  vm.starredBlocks.push(block.id);
                }


                block.lease_end_date=null;
                if(block.lease_dates.length) {
                  angular.forEach(block.lease_dates, function(leaseDate) {
                    if (today>=leaseDate.lease_start_date && today<=leaseDate.lease_end_date) {
                      block.lease_end_date=leaseDate.lease_end_date;
                    }
                  });
                }


                block.subleased=false;
                if(block.sublease_dates.length) {
                  angular.forEach(block.sublease_dates, function(subleaseDate) {
                    if (today>=subleaseDate.sublease_start_date && today<=subleaseDate.sublease_end_date) {
                      block.subleased=true;
                    }
                  });
                }
              });

              api.companies.get({business_role: 'land owner'}, function(LandOwnerCompaniesData) {
                vm.allLandOwnerCompanies = LandOwnerCompaniesData.companies;
                angular.forEach(vm.allLandOwnerCompanies,function(company) {
                  if(vm.blocksCompaniesIds.indexOf(company.id)>=0) {
                    vm.landOwnerCompanies.push(company);
                  }
                });
              },
              function(err) {
                console.error(err);
              });

              $scope.loadingData = false;


            }
          },
          function(err) {
            console.error(err);
          });


          BlockService.getBlocksWithOffset(0,vm.maxListLength,vm.area_id).then(function(blocksData) {
            vm.shownBlocks=blocksData.blocks;
            if(!vm.from_page_name && !vm.filterData.location_id) {
              vm.shownBlocks.forEach(function(block) {
                vm.filterIds.push(block.id);

                block.lease_end_date=null;
                if(block.lease_dates.length) {
                  angular.forEach(block.lease_dates, function(leaseDate) {
                    if (today>=leaseDate.lease_start_date && today<=leaseDate.lease_end_date) {
                      block.lease_end_date=leaseDate.lease_end_date;
                    }
                  });
                }


                block.subleased=false;
                if(block.sublease_dates.length) {
                  angular.forEach(block.sublease_dates, function(subleaseDate) {
                    if (today>=subleaseDate.sublease_start_date && today<=subleaseDate.sublease_end_date) {
                      block.subleased=true;
                    }
                  });
                }
              });
            }
          });
        },
        function(err) {
          console.error(err);
        });

      },
      function(err) {
        console.error(err);
      });
    }



            /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function loadMore(area_id) {
      if(vm.shownBlocks.length === vm.blocks.length) {
        return;
      }
      else{
        BlockService.getBlocksWithOffset(vm.offset,vm.maxListLength,area_id).then(function(blocksData) {
          if(blocksData.blocks.length>0) {

            if(!vm.from_page_name && !vm.filterData.location_id) {
              blocksData.blocks.forEach(function(block) {
                vm.filterIds.push(block.id);

                block.lease_end_date=null;
                if(block.lease_dates.length) {
                  angular.forEach(block.lease_dates, function(leaseDate) {
                    if (today>=leaseDate.lease_start_date && today<=leaseDate.lease_end_date) {
                      block.lease_end_date=leaseDate.lease_end_date;
                    }
                  });
                }


                block.subleased=false;
                if(block.sublease_dates.length) {
                  angular.forEach(block.sublease_dates, function(subleaseDate) {
                    if (today>=subleaseDate.sublease_start_date && today<=subleaseDate.sublease_end_date) {
                      block.subleased=true;
                    }
                  });
                }
              });
            }
            vm.shownBlocks=vm.shownBlocks.concat(blocksData.blocks);
          }
          else
            return;
        });
        vm.offset += vm.maxListLength;
      }
    }

    /**
     * Change Blocks List Filter
     * @param type
     */
    function filterChange(type,id,name,fromBack) {
      var milisecondsTimeout = 0;
      if(fromBack) {
        milisecondsTimeout = fromBack;
      }
      $timeout(function () {
        vm.loadListFiltered = true;
        vm.listType = { name: type };

        if (type === 'all') {
          vm.location_name = '';
          vm.ranch_name = '';
          vm.landOwner_name = '';
          vm.filterTitle     = '';
          vm.location_id     = undefined;
          vm.ranches         = [];
          vm.ranch_id        = undefined;
          vm.landOwner       = [] ;
          vm.landOwner_id    = undefined;
          vm.filteredActive  = false;
          vm.filteredStarred = false;
          vm.filterIds       = [];
          vm.filterLocationsIds          = [];
          vm.filterRanchesIds            = [];
          vm.companiesFilterIds          = [];
          vm.filterData = {};
          angular.forEach(vm.blocks, function(block) {
            vm.filterIds.push(block.id);
          });
        }

        //Filter by starred
        else if (type === 'starred') {
          if (!checkTitleInclude('Starred')) {
            if(vm.filterTitle.includes('Active')) {
              vm.filterTitle = vm.filterTitle.replace('Active','Starred');
            }
            else {
              vm.filterTitle = vm.filterTitle + ' - Starred';
            }
          }
          else {
            vm.listType.name = 'Starred';
          }
          getStarredFilteredIds();
        }

        //Fitler by active
        else if (type === 'active') {
          if (!checkTitleInclude('Active')) {
            if(vm.filterTitle.includes('Starred')) {
              vm.filterTitle = vm.filterTitle.replace('Starred','Active');
            }
            else {
              vm.filterTitle = vm.filterTitle + ' - Active';
            }
          }
          else {
            vm.listType.name = 'Active';
          }
          getActiveFilteredIds();
        }

        //Filter by location
        else if(type === 'location') {
          vm.starredBlocks = [];
          vm.location_name = name;
          vm.ranch_id = undefined;
          vm.ranch_name = '';
          if(vm.landOwner_name) {
            vm.filterTitle = vm.landOwner_name + ' - ' + vm.location_name;
          }
          else {
            vm.filterTitle = vm.location_name;
          }
          getLocationFilteredIds(id);
               /**
           * Set Block Starred
           */
          if(vm.blocks) {
            angular.forEach(vm.blocks, function(block) {
              if(block.starred === true) {
                vm.starredBlocks.push(block.id);
              }
            });
          }
        }
        else if(type === 'ranch') {
          vm.filterTitle = vm.location_name + ' - ' + name;
          vm.ranch_id = id;
          vm.ranch_name = name;
          getRanchFilteredIds(id);
        }
        else if(type === 'landOwner') {
          if(name === vm.landOwner_name) {
            vm.filteredActive = false;
            vm.filteredStarred = false;
          }
          vm.landOwner_name = name;
          vm.landOwner_id = id;
          vm.filterTitle = '';
          if(vm.location_id &&vm.ranch_id) {
            vm.filterTitle = vm.location_name + ' - ' + vm.ranch_name + ' - ' + vm.landOwner_name;
          }
          else if(vm.location_id) {
            vm.filterTitle = vm.location_name + ' - ' + vm.landOwner_name;
          }
          else {
            vm.filterTitle = vm.landOwner_name;
          }
          getLandOwnerFilteredIds(id);
        }
        vm.loadListFiltered = false;
      },milisecondsTimeout);
    }


    /**
      * Toggle sidenav
      *
      * @param sidenavId
      */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }


	/**
     * [addBlock description]
     * @param  {[type]} ev    [description]
     * @param  {[type]} block [description]
     * @return {[type]}       [description]
     */
    function addBlock() {
      if(vm.location_id) {
        var data = [];
        data = {
          location_id: vm.location_id,
          location_name: vm.location_name,
          ranch_id: vm.ranch_id ? parseInt(vm.ranch_id) : null,
          ranch_name: vm.ranch_name ? vm.ranch_name : null,
        };

        BlockService.saveFilterData(data);
        $location.url('/blocks/add');
      }
      else {
        $location.url('/blocks/add');
      }
    }
    /**
     * [editBlock description]
     * @param  {[type]} ev    [description]
     * @param  {[type]} block [description]
     * @return {[type]}       [description]
     */
    function editBlock(ev, block) {
      var data = [];
      if(vm.location_id) {
        data = {
          location_id: vm.location_id,
          location_name: vm.location_name,
          ranch_id: vm.ranch_id ? parseInt(vm.ranch_id) : null,
          ranch_name: vm.ranch_name ? vm.ranch_name : null,
        };
      }
      BlockService.saveFilterData(data);
      $location.url('/blocks/edit/' + block.id);
    }

    /**
     * Function to patch starred block.
     *
     * @return {[type]} [description]
     */
    function patchStarred(block) {
      event.stopPropagation();
      var starred = false;
      if(vm.starredBlocks.indexOf(block.id) !== -1) {
        starred = true;
      }
      BlockService.patch(block.id, {starred: starred.toString()}).then(function() {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The block ' + block.name + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.starredBlocks.push(block.id);
      },
      function() {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The block ' + block.name + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }

 /**
  * Function to filter block by location
  * @param  {[type]} location_id [location id]
  * @return {[type]}             [description]
  */
    function getLocationFilteredIds(location_id) {
      vm.location_id=location_id;
      vm.filterIds = [];
      vm.filterLocationsIds=[];
      if(!vm.landOwner_id) {
        if(vm.filteredActive) {
          vm.filterTitle = vm.filterTitle + ' - Active';
          vm.blocks.forEach(function(block) {
            RanchService.get(block.ranch_id).then(function(ranchData) {
              if(ranchData.ranch.location_id === location_id && block.active) {
                vm.filterIds.push(block.id);
                vm.filterLocationsIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          });
        }
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.blocks.forEach(function(block) {
            RanchService.get(block.ranch_id).then(function(ranchData) {
              if(ranchData.ranch.location_id === location_id && block.starred) {
                vm.filterIds.push(block.id);
                vm.filterLocationsIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          });
        }
        else if(!vm.filteredActive && !vm.filteredStarred) {
          vm.blocks.forEach(function(block) {
            RanchService.get(block.ranch_id).then(function(ranchData) {
              if(ranchData.ranch.location_id === location_id) {
                vm.filterIds.push(block.id);
                vm.filterLocationsIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          });
        }
      }
      else {
        if(vm.filteredActive) {
          vm.filterTitle = vm.filterTitle + ' - Active';
          vm.blocks.forEach(function(block) {
            RanchService.get(block.ranch_id).then(function(ranchData) {
              if(ranchData.ranch.location_id === location_id && block.company_id === vm.landOwner_id && block.active) {
                vm.filterIds.push(block.id);
                vm.filterLocationsIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          });
        }
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.blocks.forEach(function(block) {
            RanchService.get(block.ranch_id).then(function(ranchData) {
              if(ranchData.ranch.location_id === location_id && block.company_id === vm.landOwner_id && block.starred) {
                vm.filterIds.push(block.id);
                vm.filterLocationsIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          });
        }
        else if(!vm.filteredActive && !vm.filteredStarred) {
          vm.blocks.forEach(function(block) {
            RanchService.get(block.ranch_id).then(function(ranchData) {
              if(ranchData.ranch.location_id === location_id && block.company_id === vm.landOwner_id) {
                vm.filterIds.push(block.id);
                vm.filterLocationsIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          });
        }

      }
      RanchService.getRanchesByLocation(location_id).then(function(ranchesData) {
        vm.ranches=ranchesData.ranches;
        if(vm.from_page_name) {
          vm.ranches.forEach(function(ranch) {
            if(ranch.id===vm.ranch_id) {
              vm.ranch_name = ' - ' + ranch.name;
              vm.filterTitle = vm.filterTitle + vm.ranch_name;
            }
          });
        }
      });
    }

    /**
     * Function to filter blocks by ranch
     * @param  {[type]} ranch_id [description]
     * @return {[type]}          [description]
     */
    function getRanchFilteredIds(ranch_id) {
      vm.filterIds = [];
      vm.allFilterIds = [];
      if(!vm.landOwner_id) {
        if(vm.filteredActive) {
          vm.filterTitle = vm.filterTitle + ' - Active';
          vm.blocks.forEach(function(block) {
            if(block.ranch_id === ranch_id  && block.active) {
              vm.filterIds.push(block.id);
              vm.allFilterIds.push(block.id);
            }
          });
        }
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.blocks.forEach(function(block) {
            if(block.ranch_id === ranch_id  && block.starred) {
              vm.filterIds.push(block.id);
              vm.allFilterIds.push(block.id);
            }
          });
        }
        else if(!vm.filteredActive && !vm.filteredStarred) {
          vm.blocks.forEach(function(block) {
            if(block.ranch_id === ranch_id) {
              vm.filterIds.push(block.id);
              vm.allFilterIds.push(block.id);
            }
          });
        }
      }
      else{
        if(vm.filteredActive) {
          vm.filterTitle = vm.filterTitle + ' - Active';
          vm.blocks.forEach(function(block) {
            if(block.ranch_id === ranch_id && block.company_id === parseInt(vm.landOwner_id) && block.active) {
              vm.filterIds.push(block.id);
              vm.allFilterIds.push(block.id);
            }
          });
        }
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.blocks.forEach(function(block) {
            if(block.ranch_id === ranch_id && block.company_id === parseInt(vm.landOwner_id) && block.starred) {
              vm.filterIds.push(block.id);
              vm.allFilterIds.push(block.id);
            }
          });
        }
        else if(!vm.filteredActive && !vm.filteredStarred) {
          vm.blocks.forEach(function(block) {
            if(block.ranch_id === ranch_id && block.company_id === parseInt(vm.landOwner_id)) {
              vm.filterIds.push(block.id);
              vm.allFilterIds.push(block.id);
            }
          });
        }
      }
    }

    /**
     * [getLandOwnerFilteredIds description]
     * @param  {[type]} company_id [description]
     * @return {[type]}            [description]
     */
    function getLandOwnerFilteredIds(company_id) {
      vm.filterIds = [];
      vm.allFilterIdsTemp  = vm.allFilterIds;
      vm.allFilterIds = [];
      if(vm.location_id) {
        if(vm.ranch_id) {
          if(vm.filteredActive) {
            vm.filterTitle = vm.filterTitle + ' - Active';
            vm.blocks.forEach(function(block) {
              if(block.company_id === company_id && block.ranch_id === parseInt(vm.ranch_id) && block.active && vm.filterLocationsIds.indexOf(block.id)>=0) {
                vm.filterIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          }
          if(vm.filteredStarred) {
            vm.filterTitle = vm.filterTitle + ' - Starred';
            vm.blocks.forEach(function(block) {
              if(block.company_id === company_id && block.ranch_id === parseInt(vm.ranch_id) && block.starred && vm.filterLocationsIds.indexOf(block.id)>=0) {
                vm.filterIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          }
          else if(!vm.filteredActive && !vm.filteredStarred) {
            vm.blocks.forEach(function(block) {
              if(block.company_id === company_id && block.ranch_id === parseInt(vm.ranch_id)  && vm.filterLocationsIds.indexOf(block.id)>=0) {
                vm.filterIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          }
        }
        else{
          if(vm.filteredActive) {
            if(!vm.filterTitle.includes('Active')) {
              vm.filterTitle = vm.filterTitle + ' - Active';
            }
            vm.blocks.forEach(function(block) {
              if(block.company_id === company_id && block.active && vm.filterLocationsIds.indexOf(block.id)>=0) {
                vm.filterIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          }
          if(vm.filteredStarred) {
            if(!vm.filterTitle.includes('Starred')) {
              vm.filterTitle = vm.filterTitle + ' - Starred';
            }
            vm.blocks.forEach(function(block) {
              if(block.company_id === company_id && block.starred && vm.filterLocationsIds.indexOf(block.id)>=0) {
                vm.filterIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          }
          else if(!vm.filteredActive && !vm.filteredStarred) {
            vm.blocks.forEach(function(block) {
              if(block.company_id === company_id  && vm.filterLocationsIds.indexOf(block.id)>=0) {
                vm.filterIds.push(block.id);
                vm.allFilterIds.push(block.id);
              }
            });
          }
        }
      }
      else {
        if(vm.filteredActive) {
          vm.filterTitle = vm.filterTitle + ' - Active';
          vm.blocks.forEach(function(block) {
            if(block.company_id === company_id && block.active) {
              vm.filterIds.push(block.id);
              vm.companiesFilterIds.push(block.id);
            }
          });
        }
        if(vm.filteredStarred) {
          vm.filterTitle = vm.filterTitle + ' - Starred';
          vm.blocks.forEach(function(block) {
            if(block.company_id === company_id && block.starred && vm.filterIds.indexOf(block.id<0)) {
              vm.filterIds.push(block.id);
              vm.companiesFilterIds.push(block.id);
            }
          });
        }
        else if(!vm.filteredActive && !vm.filteredStarred) {
          vm.blocks.forEach(function(block) {
            if(block.company_id === company_id) {
              vm.filterIds.push(block.id);
              vm.companiesFilterIds.push(block.id);
            }
          });
        }
      }

    }

        /**
     * Function to patch active block.
     *
     * @return {[type]} [description]
     */
    function patchActive(block) {
      event.stopPropagation();
      BlockService.patch(block.id, {active: block.active.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast  class="md-toast success">The block ' + block.name + ((block.active === true) ? ' has been activated.' : ' has been deactivated.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.blocks.forEach(function(blockOrig) {
          if(block.id === blockOrig.id) {
            blockOrig.active = block.active;
          }
        });
      },
      function() {
        $mdToast.show({
          template: '<md-toast  class="md-toast error">The block ' + block.name + ' could not be activated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });

      });
    }

    /**
     * Delete block confirm
     */
    function deleteBlockConfirm(block,ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('BLOCKS.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('Block <b>#' + block.name  + ' </b>' + ' will be deleted.')
      .ariaLabel('delete bed_size')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteBlock(block);
      }, function () {

      });
    }

    /**
     * Delete block
     * @param  {[type]} payment [description]
     * @return {[type]}         [description]
     */
    function deleteBlock(block) {
      BlockService.delete(block.id).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The block '+ block.name + ' has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.blocks.splice(vm.blocks.indexOf(block), 1);
        vm.shownBlocks.splice(vm.shownBlocks.indexOf(block), 1);
      },
      function(err) { //reject
        var error;
        if(err.status && err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">The block  '+ block.NAME + 'could not be deleted. ' + ((error !== undefined)? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * [getStarredFilteredIds description]
     * @return {[type]} [description]
     */
    function getStarredFilteredIds() {
      vm.filteredStarred = true;
      vm.filteredActive = false;
      vm.filterIds=[];
      if(vm.landOwner_id && !vm.location_id) {
        vm.starredBlocks.forEach(function(id) {
          if(vm.companiesFilterIds.indexOf(id)>=0) {
            vm.filterIds.push(id);
          }
        });
      }
      else {
        if (vm.location_id) {
          vm.starredBlocks.forEach(function(id) {
            if(vm.allFilterIds.indexOf(id)>=0) {
              vm.filterIds.push(id);
            }
          });
        } else {
          vm.starredBlocks.forEach(function(id) {
            vm.filterIds.push(id);
          });
        }
      }
    }

    /**
     * [getStarredFilteredIds description]
     * @return {[type]} [description]
     */
    function getActiveFilteredIds() {
      vm.filteredActive = true;
      vm.filteredStarred = false;
      vm.filterIds=[];
      if(vm.landOwner_id && !vm.location_id) {
        vm.blocks.forEach(function(block) {
          if(block.active && vm.companiesFilterIds.indexOf(block.id)>=0) {
            vm.filterIds.push(block.id);
          }
        });
      }
      else {
        if (vm.location_id) {
          vm.blocks.forEach(function(block) {
            if(block.active && vm.allFilterIds.indexOf(block.id)>=0) {
              vm.filterIds.push(block.id);
            }
          });
        }
        else{
          vm.blocks.forEach(function(block) {
            if(block.active) {
              vm.filterIds.push(block.id);
            }
          });
        }
      }
    }

    /**
     * [backToRanchPage description]
     * @return {[type]} [description]
     */
    function backToRanchPage () {
      $location.url('/ranches');
    }

    /**
     * [backToLeaseBlocksPage description]
     * @return {[type]} [description]
     */
    function backToLeaseBlocksPage () {
      if(vm.isLease) {
        $location.url('/leases/edit/'+ vm.lease_id + '/' + 2);
      }
      else {
        $location.url('/subleases/edit/'+ vm.lease_id + '/' + 2);
      }
    }

    /**
     * [goToRanchesPage description]
     * @return {[type]} [description]
     */
    function goToRanchesPage() {
      $location.url('/ranches/from_page/'+ vm.location_id + '/blocks/' + null);
    }

        /**
     * Go to Locations page
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    function goToLandPage() {
      $location.url('/land');
    }

    /**
     * [checkTitleInclude description]
     * @param  {[type]} string [description]
     * @return {[type]}        [description]
     */
    function checkTitleInclude(string) {
      if (vm.filterTitle === '' || vm.filterTitle.includes(string)) {
        return true;
      }
      else
        return false;
    }


  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.water', [
      'xeditable'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_water', {
      url      : '/water',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/farm-resources/water/water.html',
          controller : 'WaterCtrl as vm'
        }
      },
      bodyClass: 'water',
      resolve: {
        acl: function($q, AclService) {
          if(!AclService.can('water')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/farm-resources/water');

    //Api
    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.farm-resources.water', {
      title: 'Water Districts',
      icon : 'icon-water',
      state: 'app.farm-admin_water',
      weight: 29
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.water')
    .controller('WaterCtrl', WaterCtrl);

  /** @ngInject */
  function WaterCtrl() {
    // Data

    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.seed', [
      'xeditable',
      'ms-resize',
      'ui.utils.masks'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_seed', {
      url      : '/seed',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/farm-resources/seed/seed.html',
          controller : 'SeedCtrl as vm'
        },
        resolve  : {
          acl: function($q, AclService) {
            if(!AclService.can('cronjobs')) {
              // Does not have permission
              return $q.reject('unauthorized');
            }
          }
        }
      },
      bodyClass: 'seed',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('seed')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/farm-resources/seed');

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.farm-resources.seed', {
      title: 'Seed Definition',
      icon : 'icon-barley',
      state: 'app.farm-admin_seed',
      weight: 24
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin.farm-resources.seed')
  .controller('SeedCtrl', SeedCtrl);

  /** @ngInject */
  function SeedCtrl($state,
                    $scope,
                    $timeout,
                    $mdToast,
                    $mdSidenav,
                    $mdDialog,
                    $document,
                    $translate,
                    $location,
                    $stateParams,
                    SeedService,
                    StepperService,
                    FarmService,
                    CompanyService,
                    AreaFiscalYearService,
                    ContractScheduleVarietiesService,
                    GrowerScheduleService,
                    msUtils,
                    api,
                    _,
                    moment) {

    var vm = this;
    // Data
    $scope.seedName = '';
    $scope.varietyName = '';
    $scope.companyName = '';
    $scope.dataSeedId = '';
    $scope.dataVarietyId = '';
    $scope.stepCurrent = 1;
    vm.fromContracts = false;
    vm.contractData = [];
    vm.fromGrowerSchedule = false;
    vm.growerScheduleData = {};
    $scope.customDateFormat = {
      formatDate: function (date) {
        var m = moment(date);
        return m.isValid() ? m.format('MMMM Do') : '';
      }
    };

    vm.min_date = new Date(new Date().getFullYear(), 0, 1);
    vm.max_date = new Date(new Date().getFullYear(), 11, 31);


    //Methods
    vm.load = load;
    vm.loadLocation = loadLocation;

    vm.seedId = seedId;
    vm.varietyId = varietyId;

    vm.deleteSeed = deleteSeed;
    vm.deleteSeedConfirm = deleteSeedConfirm;
    vm.deleteVariety = deleteVariety;
    vm.deleteVarietyConfirm = deleteVarietyConfirm;
    vm.deleteVarietyPlantingLocationConfirm = deleteVarietyPlantingLocationConfirm;
    vm.deleteVarietyPlantingLocation = deleteVarietyPlantingLocation;

    vm.saveSeedConfirm = saveSeedConfirm;
    vm.saveSeed = saveSeed;
    vm.saveVarietyConfirm = saveVarietyConfirm;
    vm.saveVariety = saveVariety;
    vm.saveVarietyPlantingLocationConfirm = saveVarietyPlantingLocationConfirm;
    vm.saveVarietyPlantingLocation = saveVarietyPlantingLocation;
    vm.saveForm = saveForm;

    vm.openSeedDialog = openSeedDialog;
    vm.openVarietyDialog = openVarietyDialog;
    vm.openVarietyPlantingLocationDialog = openVarietyPlantingLocationDialog;

    vm.exists = msUtils.exists;
    vm.openForm = openForm;
    vm.currentStep = currentStep;
    vm.seedDateChanged = seedDateChanged;

    vm.redirectCompany = redirectCompany;
    vm.redirectLand = redirectLand;
    $scope.loadingData = true;

    vm.backToContractCropPage = backToContractCropPage;
    vm.backToGrowerSchedule = backToGrowerSchedule;
    /**
     * Radio group
     */
    vm.radio = {
      groupSeed: true,
      groupVariety: true,
      groupVarietyLocation: false,
    };
    /**
     * Load default area User Online
     */
    var user = sessionStorage.getItem('user');
    vm.user = JSON.parse(user);
    area();

    /**
     * Load Area
     */
    function area() {
      AreaFiscalYearService.getAreaFiscalYear(vm.user.default_global_area_fiscal_year_id).then(function (data) {
        vm.areaFiscalYearId = data.area_fiscal_year.area_id;
        locations(vm.areaFiscalYearId);
      },
      function (err) {
        console.error(err);
      });
    }

    //Seed data from API.
    api.seeds.get({}, function (SeedData) {
      vm.seeds = SeedData.seeds;
      $scope.loadingData = false;
    },
    function (err) {
      console.error(err);
    });

    /**
     * Load locations filter by area id
     */
    function locations(area) {
      SeedService.getLocations(area).then(function (data) {
        vm.locations = data.locations;
      },
      function (err) {
        console.error(err);
      });
    }

    farms();

    /**
     * Load land referances name
     */
    function farms() {
      FarmService.getFarm(1).then(function (FarmLandRefData) {
        vm.land_ref = FarmLandRefData.farm;
      },
      function (err) {
        console.error(err);
      });
    }


    /**
     * Current Step
     */
    function currentStep() {
      if ($scope.stepCurrent !== StepperService.getStepNumber()) {
        //    vm.groupSeed = null;
        //    vm.groupVariety = null;
      }
      $scope.stepCurrent = StepperService.getStepNumber();
    }

    /**
     * Change in step
     */
    function openForm() {
      currentStep();
    }

    /**
     * Load seeds company
     */
    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      /* Get Seed companies */
      CompanyService.getCompanyByBusinessRole('seed company').then(function (companiesData) {
        vm.companies = companiesData.companies;
      },
      function (err) {
        console.error(err);
      });

      vm.contractData = ContractScheduleVarietiesService.getData();
      if (vm.contractData.seed_id) {
        var seed_id = vm.contractData.seed_id;
        var seed_name = vm.contractData.seed_name;
        ContractScheduleVarietiesService.saveData([]);
        vm.fromContracts = true;
        vm.groupSeed = seed_id;
        seedId(seed_id,seed_name);
      }

      vm.growerScheduleData = GrowerScheduleService.getData();
      if (!_.isEmpty(vm.growerScheduleData)) {
        vm.fromGrowerSchedule = true;
        GrowerScheduleService.saveData({});
      }

    }

    /**
     * Checked Seed
     * @param {*} id
     * @param {*} name
     */
    function seedId(id, name) {
      $scope.loadingDataVarieties = true;
      load(id);
      $scope.dataSeedId = id;
      $scope.seedName = name;
    }

    /**
     * Checked Variety
     * @param {*} id
     * @param {*} name
     */
    function varietyId(id, name, companyId) {
      $scope.dataVarietyId = id;
      $scope.varietyName = name;
      $scope.loadingDataLocation = true;
      loadLocation(id);
      vm.companies.forEach(function (company) {
        if (company.id === companyId) {
          $scope.companyName = company.name;
        }
      });
    }

    /*Call to function load varieties */
    /**
     * [load description]
     * @return {[type]} [description]
     */
    function load(id) {
      SeedService.getVarieties(id).then(function (data) {
        vm.varieties = data.varieties;
        $scope.loadingDataVarieties = false;
      },
      function (err) {
        console.error(err);
      });
    }

    /*Call to function load as first thing */
    /**
     * [load description]
     * @return {[type]} [description]
     */
    function loadLocation(id) {
      SeedService.getVarietiesLocation(id, vm.areaFiscalYearId).then(function (data) {
        vm.varietiesLocations = data.variety_planting_location;
        // set min_date on each row of vm.varietiesLocations
        angular.forEach(vm.varietiesLocations, function(varLoc) {
          seedDateChanged(varLoc, true);
        });
        $scope.loadingDataLocation = false;
      },
      function (err) {
        console.error(err);
      });
    }

    /**
     * Redirect company page
     */
    function redirectCompany() {
      $state.go($state.current, {}, {reload: true});
      /* Redirect to users and edit */
      $location.url('/companies/');
    }

    /**
     * Redirect land page
     */
    function redirectLand() {
      $state.go($state.current, {}, {reload: true});
      /* Redirect to users and edit */
      $location.url('/land');
      $mdToast.show({
        template: '<md-toast class="md-toast warning">To add a location please click in next.</md-toast>',
        position: 'top right',
        hideDelay: 10000
      });
    }

    /**
     * [seedDateChanged description]
     * @param  {[type]} seed [description]
     * @return {[type]}
     */
    function seedDateChanged(seed, avoidValidation) {
      var startDay = null;
      var endDay   = null;

      if (seed.begin_date) {
        startDay = new Date(seed.begin_date);
        seed.min_date = startDay;
        seed.begin_date = startDay;
      }
      if (seed.end_date) {
        endDay   = new Date(seed.end_date);
        seed.end_date = endDay;
      }
      if (!avoidValidation && startDay && endDay && endDay < startDay) {
        seed.end_date = startDay;
      }
    }

    /**
     * Open new seed dialog
     *  @param ev
     *  @param seed
     */
    function openSeedDialog(ev, seed) {
      $mdDialog.show({
        controller: 'SeedDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/farm-resources/seed/dialogs/seed/seed-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            seeds: vm.seeds,
            seed: seed,
            dialogType: 'add'
          }
        }
      });
    }

    /**
     * Open new variety dialog
     *  @param ev
     *  @param variety
     */
    function openVarietyDialog(ev, variety) {
      $mdDialog.show({
        controller: 'VarietyDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/farm-resources/seed/dialogs/variety/variety-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            varieties: vm.varieties,
            variety: variety,
            dataSeedId: $scope.dataSeedId,
            companies: vm.companies,
            dialogType: 'add'
          }
        }
      });
    }

    /**
     * Open new variety planting location dialog
     *  @param ev
     *  @param varietyLocation
     */
    function openVarietyPlantingLocationDialog(ev, varietyLocation) {
      $mdDialog.show({
        controller: 'LocationDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/farm-resources/seed/dialogs/location/location-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            varietiesLocations: vm.varietiesLocations,
            varietyLocation: varietyLocation,
            dataVarietyId: $scope.dataVarietyId,
            locations: vm.locations,
            dialogType: 'add'
          }
        }
      });
    }

    /**
     * Delete Seed Confirm Dialog
     */
    function deleteSeedConfirm(seed, ev) {

      var confirm = $mdDialog.confirm()
      .title($translate.instant('SEEDS.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + seed.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete seed')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        deleteSeed(seed);
        vm.selectedSeed = [];
      }, function () {

        // avoid unhandled rejection message.
      });
    }

    /**
     * Delete Seed
     */
    function deleteSeed(seed) {
      SeedService.delete(seed.id).then(function () {
        $mdToast.show({
          templante: '<md-toast class="md-toast success">Seed ' + seed.name + 'has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.seeds.splice(vm.seeds.indexOf(seed), 1);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">Seed ' + seed.name + ' could not be deleted.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * Delete Variety Confirm Dialog
     */
    function deleteVarietyConfirm(variety, ev) {

      var confirm = $mdDialog.confirm()
      .title($translate.instant('SEEDS.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + variety.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete seed')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        deleteVariety(variety);
      }, function () {

        // avoid unhandled rejection message.
      });
    }

    /**
     * Delete Variety
     */
    function deleteVariety(variety) {
      SeedService.deleteVariety(variety.id).then(function () {
        $mdToast.show({
          templante: '<md-toast class="md-toast success">Variety ' + variety.name + 'has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.varieties.splice(vm.varieties.indexOf(variety), 1);
        var idx = _.findIndex(vm.seeds, {'id': variety.seed_id});
        vm.seeds[idx].seed_varieties.splice(vm.varieties.indexOf(variety), 1);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">Variety ' + variety.name + ' could not be deleted.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * Delete Variety Planting Location Confirm Dialog
     */
    function deleteVarietyPlantingLocationConfirm(varietyPlantingLocation, ev) {

      var confirm = $mdDialog.confirm()
      .title($translate.instant('SEEDS.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('Location planting will be deleted.')
      .ariaLabel('delete seed')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        deleteVarietyPlantingLocation(varietyPlantingLocation);
      }, function () {

        // avoid unhandled rejection message.
      });
    }

    /**
     * Delete Variety Planting Location
     */
    function deleteVarietyPlantingLocation(varietyPlantingLocation) {
      SeedService.deleteVarietyPlantingLocation(varietyPlantingLocation.id).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">Variety Planting Location has been deleted.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.varietiesLocations.splice(vm.varietiesLocations.indexOf(varietyPlantingLocation), 1);
        var idx = _.findIndex(vm.varieties, {'id': varietyPlantingLocation.variety_id});
        vm.varieties[idx].seed_varieties_location.splice(vm.varietiesLocations.indexOf(varietyPlantingLocation), 1);
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">Variety Planting Location could not be deleted.</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * Save Seed Confirm Dialog
     */
    function saveSeedConfirm(ev) {

      var confirm = $mdDialog.confirm()
      .title($translate.instant('SEEDS.ARE_YOU_SURE_TO_SAVE'))
      .htmlContent('Seeds will be saved.')
      .ariaLabel('save seed')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        saveSeed();
      }, function () {

        // avoid unhandled rejection message.
      });
    }

    /**
     * Save existent seed (save on edit)
     */
    function saveSeed() {
      vm.seeds.forEach(function (seed) {
        SeedService.update(seed.id, seed).then(function () {
        },
        function () { //reject
          $mdToast.show({
            template: '<md-toast class="md-toast error">Seeds could not be updated.</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      });
      $mdToast.show({
        template: '<md-toast class="md-toast success">Seeds has been updated.</md-toast>',
        position: 'top right',
        hideDelay: 1000
      });
    }

    /**
     * Save variety Confirm Dialog
     */
    function saveVarietyConfirm(ev) {

      var confirm = $mdDialog.confirm()
      .title($translate.instant('SEEDS.ARE_YOU_SURE_TO_SAVE_VARIETY'))
      .htmlContent('Varieties will be saved.')
      .ariaLabel('save varieties')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        saveVariety();
      }, function () {

        // avoid unhandled rejection message.
      });
    }

    /**
     * Save existent variety (save on edit)
     */
    function saveVariety() {
      vm.varieties.forEach(function (variety) {
        SeedService.updateVariety(variety.id, variety).then(function () {
        },
        function () { //reject
          $mdToast.show({
            template: '<md-toast class="md-toast error">Variety ' + variety.name + ' could not be updated.</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      }, this);
      $mdToast.show({
        template: '<md-toast class="md-toast success">Varieties has been updated.</md-toast>',
        position: 'top right',
        hideDelay: 1000
      });
    }

    /**
     * Save variety planting location Confirm Dialog
     */
    function saveVarietyPlantingLocationConfirm(ev) {

      var confirm = $mdDialog.confirm()
      .title($translate.instant('SEEDS.ARE_YOU_SURE_TO_SAVE_VARIETY_PLANTING'))
      .htmlContent('Variety planting locations will be saved.')
      .ariaLabel('save variety planting locations')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {

        saveVarietyPlantingLocation();
      }, function () {

        // avoid unhandled rejection message.
      });
    }

    /**
     * Save existent variety planting location (save on edit)
     */
    function saveVarietyPlantingLocation() {
      vm.varietiesLocations.forEach(function (location) {
        SeedService.updateVarietyPlantingLocation(location.id, location).then(function () {
        },
        function () { //reject
          $mdToast.show({
            template: '<md-toast class="md-toast error">Variety ' + location.name + ' could not be updated.</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      }, this);
      $mdToast.show({
        template: '<md-toast class="md-toast success">Variety planting location has been updated.</md-toast>',
        position: 'top right',
        hideDelay: 1000
      });
    }

    /**
     * Save Form
     */
    function saveForm(ev) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('SEEDS.ARE_YOU_SURE_TO_SAVE_ALL'))
      .htmlContent('All changes will be saved.')
      .ariaLabel('save all')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        saveSeed();
        saveVariety();
        saveVarietyPlantingLocation();
      }, function () {

        // avoid unhandled rejection message.
      });
    }

    /**
     * [backToContractCropPage description]
     * @return {[type]} [description]
     */
    function backToContractCropPage() {
      ContractScheduleVarietiesService.saveData(vm.contractData);
      $location.url('/contracts/edit/' + vm.contractData.contract_id + '/' + 1);
    }

    /**
     * [backToGrowerSchedule description]
     * @return {[type]} [description]
     */
    function backToGrowerSchedule() {
      ContractScheduleVarietiesService.saveData(vm.contractData);
      $location.url('/grower-schedule');
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.pesticide-definition', [
      'xeditable'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_pesticide-definition', {
      url      : '/pesticide-definition',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/farm-resources/pesticide-definition/pesticide-definition.html',
          controller : 'PesticideCtrl as vm'
        }
      },

      bodyClass: 'pesticide-definition',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('pesticide_definition')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/farm-resources/pesticide-definition');

    //Api

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.farm-resources.pesticide-definition', {
      title: 'Pesticide Definition',
      icon : 'icon-engine',
      state: 'app.farm-admin_pesticide-definition',
      weight: 28
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.pesticide-definition')
    .controller('PesticideCtrl', PesticideCtrl);

  /** @ngInject */
  function PesticideCtrl() {
    // Data

    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.labor', [
      'xeditable'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_labor', {
      url      : '/labor',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/farm-resources/labor/labor.html',
          controller : 'LaborCtrl as vm'
        }
      },

      bodyClass: 'labor',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('labor')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/farm-resources/labor');

    //Api

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.farm-resources.labor', {
      title: 'Labor Definition',
      icon : 'icon-nature-people',
      state: 'app.farm-admin_labor',
      weight: 26
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.labor')
    .controller('LaborCtrl', LaborCtrl);

  /** @ngInject */
  function LaborCtrl() {
    // Data

    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.fertilizer-definition', [
      'xeditable'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_fertilizer-definition', {
      url      : '/fertilizer-definition',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/farm-resources/fertilizer-definition/fertilizer-definition.html',
          controller : 'FertilizerCtrl as vm'
        }
      },

      bodyClass: 'fertilizer-definition',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('fertilizer_definition')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/farm-resources/fertilizer-definition');

    //Api

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.farm-resources.fertilizer-definition', {
      title: 'Fertilizer Definition',
      icon : 'icon-engine',
      state: 'app.farm-admin_fertilizer-definition',
      weight: 27
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.fertilizer-definition')
    .controller('FertilizerCtrl', FertilizerCtrl);

  /** @ngInject */
  function FertilizerCtrl() {
    // Data

    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.equipment', [
      'xeditable'
    ])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.farm-admin_equipment', {
      url      : '/equipment',
      views    : {
        'content@app': {
          templateUrl: 'app/main/farm-admin/farm-resources/equipment/equipment.html',
          controller : 'EquipmentCtrl as vm'
        }
      },

      bodyClass: 'equipment',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('equipment')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/farm-admin/farm-resources/equipment');

    //Api

    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin.farm-resources.equipment', {
      title: 'Equipment Definition',
      icon : 'icon-engine',
      state: 'app.farm-admin_equipment',
      weight: 25
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.farm-admin.farm-resources.equipment')
    .controller('EquipmentCtrl', EquipmentCtrl);

  /** @ngInject */
  function EquipmentCtrl() {
    // Data

    // Methods

    //////////
  }
})();

(function() {
  'use strict';

  angular
    .module('app.directives.msPaymentSchedule.dialogs', [])
    .controller('PaymentScheduleDialogController', PaymentScheduleDialogController);

  /** @ngInject */
  function PaymentScheduleDialogController(
    $mdDialog,
    dialogData,
    $location,
    $mdToast,
    $scope,
    msUtils
  ) {
    var vm = this;

    // Data
    vm.title                  = 'Edit Scheduled Payment';
    vm.newPaymentSchedule     = false;
    vm.related_id             = dialogData.related_id;
    vm.paymentSchedule        = dialogData.payment;
    vm.payments               = dialogData.payments || [];
    vm.service                = dialogData.service;
    vm.entity                 = dialogData.entity;

    if (!vm.paymentSchedule) {
      vm.paymentSchedule      = {
        payment_due_date          : null,
        amount                    : null,
        payment_made              : false,
        description               : '',
        // extra fields for contract
        due_date                  : null,
        contract_incentive_amount : null,
        amount_paid               : null,
        date_paid                 : null

      };
      vm.title                = 'New Scheduled Payment';
      vm.newPaymentSchedule   = true;
    }
    vm.paymentSchedule[vm.entity + '_id'] = vm.related_id;
    vm.auxPaymentSchedule     = angular.copy(vm.paymentSchedule);

    // Methods
    vm.addNewPaymentSchedule  = addNewPaymentSchedule;
    vm.savePaymentSchedule    = savePaymentSchedule;
    vm.closeDialog            = closeDialog;
    vm.toggleInArray          = msUtils.toggleInArray;
    vm.exists                 = msUtils.exists;

    /**
     * Function to get Entity payments after create/update
     * @return {[type]}
     */
    function getPayments() {
      if (vm.service.hasOwnProperty('getAll')) {
        vm.service.getAll({
          'order_by'  : (vm.entity === 'contract') ? 'due_date' : 'payment_due_date',
          'search_by' : [vm.entity + '_id'],
          'search'    : vm.related_id
        }).then(function (payments) {
          vm.payments.splice(0, vm.payments.length);
          var aux = payments[vm.entity + '_payment_schedules'];
          for (var i = 0; i < aux.length; i++) {
            aux[i].changed = false; // virtual field
            aux[i].pos = i + 1;
            (aux[i].amount) ? aux[i].amount = msUtils.parseMoneyAsNumber(aux[i].amount) : null;
            (aux[i].amount_paid) ? aux[i].amount_paid = msUtils.parseMoneyAsNumber(aux[i].amount_paid) : null;
            (aux[i].contract_incentive_amount) ? aux[i].contract_incentive_amount = msUtils.parseMoneyAsNumber(aux[i].contract_incentive_amount) : null;
            vm.payments.push(aux[i]);
          }
          closeDialog();
        },
        function(err) {
          var error;
          if(err.status && err.status !== 500) {
            error = err.data.message;
          }
          console.error('Payments could not be loaded. ' + ((error !== undefined) ? error : ''));
          closeDialog();
        });
      } else {
        console.error('"getAll" function is not defined on service');
        closeDialog();
      }
    }

    /**
     * Add new payment schedule
     */
    function addNewPaymentSchedule() {
      if (vm.service.hasOwnProperty('create')) {
        vm.service.create(vm.auxPaymentSchedule).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The scheduled payment has been created.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          getPayments();
        },
        function(err) { //reject
          var error;
          if(err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The scheduled payment could not be created. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
          closeDialog();
        });
      } else {
        closeDialog();
        console.error('"create" function is not defined on service');
      }
    }

    /**
     * Save existent payment schedule (save on edit)
     */
    function savePaymentSchedule() {
      if (vm.service.hasOwnProperty('update')) {
        vm.service.update(vm.auxPaymentSchedule.id, vm.auxPaymentSchedule).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The scheduled payment #' + vm.auxPaymentSchedule.pos + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          getPayments();
        },
        function() { //reject
          $mdToast.show({
            template: '<md-toast class="md-toast error">The scheduled payment #' + vm.auxPaymentSchedule.pos + ' could not be updated.</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
          closeDialog();
        });
      } else {
        closeDialog();
        console.error('"update" function is not defined on service');
      }
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }
  }
})();

(function() {
  'use strict';

  angular
  .module('app.directives.msLeaseBlock.dialogs',[])
  .controller('LeaseBlockDialogController', LeaseBlockDialogController);

  /** @ngInject */
  function LeaseBlockDialogController(
    $mdDialog,
    dialogData,
    $location,
    $mdToast,
    $scope,
    LeaseService,
    RanchService,
    AreaFiscalYearService,
    AreaService,
    BlockService,
    msUtils,
    api
    //LeaseBlockService
    ) {
    var vm = this;

    // Data
    vm.title          = 'Edit Lease Block';

    vm.newBlock       = false;
    vm.lease          = dialogData.lease;
    vm.block          = dialogData.block;
    vm.blockId        = dialogData.blockId;
    vm.service        = dialogData.service;
    vm.isLease        = dialogData.isLease;
    vm.locations      = [];
    vm.ranches        = [];
    vm.blocks         = [];
    vm.block_type     = 'not_leased';
    vm.oldBlock       = [];
    vm.alreadyAssigned = false;
    vm.owner_id        = 1;
    vm.area_id         = null;
    vm.blocksForEdit   = [];
    vm.requiredFields  = true;
    vm.userCompanyId   = null;

    if(!vm.isLease) {
      vm.title          = 'Edit Sublease Block';
      vm.block_type     = 'not_subleased';
    }

    if (!vm.block) {
      var lease_block={
        description: ''
      };
      var sublease_block={
        description: ''
      };
      vm.block = {
        lease_id: vm.lease.id,
        description:  '',
        location_id: null,
      };


      if(!vm.isLease) {
        vm.title          = 'New Sublease Block';
        vm.block.sublease_block = sublease_block;
      }
      else {
        vm.title      = 'New Lease Block';
        vm.block.lease_block = lease_block;
      }
      vm.newBlock   = true;

    }
    else{
      vm.block.id = vm.blockId;

      vm.block.location_id    = null;
      vm.oldBlock={
        id: vm.blockId,
        acres: vm.block.acres,
        active: vm.block.active,
        bed_direction_id: vm.block.bed_direction_id,
        code: vm.block.code,
        company_id: vm.block.company_id,
        description: vm.description,
        latitude: vm.block.latitude,
       // lease_block_description: vm.block.lease_block.description,
        location_id: vm.block.location_id,
        longitude: vm.block.longitude,
        name: vm.block.name,
        ranch_id: vm.block.ranch_id,
        ranch_name: vm.block.ranch_name,
        soil_type: vm.block.soil_type
      };
      if(vm.isLease) {
        vm.oldBlock.lease_block_description= vm.block.lease_block.description;
      }
      else {
        vm.oldBlock.lease_block_description= vm.block.sublease_block.description;
      }
      vm.blocksForEdit.push(vm.block);
      vm.requiredFields= false;
    }

    // Methods
    vm.assignNewBlock     = assignNewBlock;
    vm.saveLeaseBlock     = saveLeaseBlock;
    vm.getDataToPost      = getDataToPost;
    vm.closeDialog        = closeDialog;
    vm.toggleInArray      = msUtils.toggleInArray;
    vm.exists             = msUtils.exists;
    vm.getRanchBlocks     = getRanchBlocks;
    vm.getLocationRanches = getLocationRanches;
    vm.goToLand           = goToLand;
    vm.goToRanches        = goToRanches;
    vm.goToBlocks         = goToBlocks;
    vm.goToLease          = goToLease;
    vm.updateLeaseAcres   = updateLeaseAcres;


    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
       /* Get locations */
      var user = sessionStorage.getItem('user');
      if(user) {
        vm.user = JSON.parse(user);
        api.users.get({id: vm.user.id}, function(userData) {
          vm.userCompanyId = userData.user.company_id;
        });
        var areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;
        AreaFiscalYearService.getAreaFiscalYear(areaFiscalYear_id).then(function(areaFiscalYearData) {
          vm.area_id = areaFiscalYearData.area_fiscal_year.area_id;
          AreaService.getAreaLocations(vm.area_id).then(function(locationsData) {
            vm.locations = locationsData.locations;
          },
          function(err) {
            console.error(err);
          });
          if(vm.block.ranch_id) {
            RanchService.get(vm.block.ranch_id).then(function(ranchData) {
              vm.block.location_id=ranchData.ranch.location_id;
              vm.oldBlock.location_id=ranchData.ranch.location_id;
              getLocationRanches(vm.block.location_id);
              getRanchBlocks(vm.area_id,vm.block.ranch_id,vm.block_type);
            });
          }
        },
        function(err) {
          console.error(err);
        });


      }

    }

    /**
     * [getRanchBlocks description]
     * @param  {[type]} id   [description]
     * @param  {[type]} type [description]
     * @return {[type]}      [description]
     */
    function getRanchBlocks(area_id,ranch_id,reload) {
      vm.blocks = [];
      if(!vm.isLease) {
        BlockService.getBlocksForSublease (area_id, ranch_id, vm.lease.start_date, vm.lease.end_date, vm.userCompanyId).then(function(blocksData) {
          vm.blocks = blocksData.blocks;
          vm.blocksForEdit.concat(blocksData.blocks);
          if(reload) {
            vm.block.id = undefined;
          }
        },
        function(err) {
          console.error(err);
        });
      }
      else {
        BlockService.getBlocksForLease(area_id, ranch_id, vm.lease.start_date, vm.lease.end_date, vm.userCompanyId).then(function(blocksData) {
          vm.blocks = blocksData.blocks;
          vm.blocks.forEach(function(block) {
            vm.blocksForEdit.push(block);
          });
          if(reload) {
            vm.block.id = undefined;
          }
        },
        function(err) {
          console.error(err);
        });
      }
    }



    /**
     * Assign new block
     */
    function assignNewBlock() {
      if(vm.blockId) {
        vm.lease.blocks.forEach(function(block) {
          if(block.id === parseInt(vm.blockId)) {
            vm.alreadyAssigned=true;
          }
        });
      }

      if(!vm.alreadyAssigned) {
        var description = '';
        if(vm.isLease) {
          description = vm.block.lease_block.description;
        }
        else {
          description = vm.block.sublease_block.description;
        }
        var additionalData =
          {
            description: description,
            location_id: vm.block.location_id
          };
        vm.service.assignBlock(vm.lease.id,vm.blockId,additionalData).then(function (data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The block has been assigned.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });

          if(vm.isLease) {
            data.leased_block.lease_block = additionalData;
            vm.lease.blocks.push(data.leased_block);
          }
          else {
            data.subleased_block.sublease_block = additionalData;
            vm.lease.blocks.push(data.subleased_block);
          }

          var newBlockArray = [];
          newBlockArray=vm.lease.blocks;
          vm.lease.blocks = newBlockArray;
          updateLeaseAcres();
          closeDialog();
        },
        function(err) { //reject
          var error;
          if(err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      }
      else{
        $mdToast.show({
          template: '<md-toast class="md-toast error"> The block is already assigned to the lease </md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      }
    }

    /**
     * Save existent block (save on edit)
     */
    function saveLeaseBlock() {
      if(vm.oldBlock.id !== vm.blockId) {
        //unassign old block and asssign new block
        assignNewBlock();
        if(!vm.alreadyAssigned) {
          vm.service.unassignBlock(vm.lease.id,vm.oldBlock.id).then(function () {
            vm.lease.blocks.splice(vm.lease.blocks.indexOf(vm.block), 1);
            updateLeaseAcres();
            closeDialog();
          },

          function() { //reject
            $mdToast.show({
              template: '<md-toast class="md-toast error">The block could not be unassigned. </md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
            return;
          });
        }
      }
      else{
        var description = '';
        var id = null;
        if(vm.isLease) {
          id = vm.block.lease_block.id;
          description = vm.block.lease_block.description;
        }
        else {
          id = vm.block.sublease_block.id;
          description = vm.block.sublease_block.description;
        }
        if(vm.oldBlock.lease_block_description !== description) {
          //Edit lease_block description
          var data =
            {
              description: description
            };
          vm.service.patchAssociatedBlock(id,data).then(function () {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The block has been updated.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            vm.lease.blocks.forEach(function(block) {
              if(block.id === vm.block.id) {
                if(vm.isLease) {
                  block.lease_block.description = data.description;
                }
                else {
                  block.sublease_block.description = data.description;
                }
                return;
              }
            });
            closeDialog();
          },
          function() { //reject
            $mdToast.show({
              template: '<md-toast class="md-toast error">The block could not be updated. </md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
            return;
          });
          closeDialog();
        }
      }
    }

    /**
     * Return data formated to post.
     * @return {[type]} [description]
     */
    function getDataToPost() {
      return {
        lease_id: vm.block.lease_id,
        description:  vm.block.description,
        location_id: vm.block.location_id
      };
    }

    /**
     * Close dialog
    */
    function closeDialog() {
      vm.block = vm.oldBlock;
      dialogData.block = vm.oldBlock;
      $mdDialog.hide();
    }

    /**
     * Get ranches of location
     * @param {[type]} id [description]
     */
    function getLocationRanches(id, reload) {
      RanchService.getRanchesByLocation(id).then(function(ranchesData) {
        vm.ranches = ranchesData.ranches;
        if(reload) {
          vm.block.ranch_id = undefined;
          vm.block.id = undefined;
        }
      },
      function(err) {
        console.error(err);
      });
    }

        /**
     * Go to Locations page
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    function goToLand() {
      $location.url('/land');
    }

    /**
     * Go to ranches page
     * @return {[type]} [description]
     */
    function goToRanches() {
      vm.location_name = null;
      api.locations.get({id: parseInt(vm.block.location_id)}, function(locationsData) {
        if(locationsData.location) {
          vm.location_name = locationsData.location.name;
        }
        var data = [];
        data = {
          location_id: parseInt(vm.block.location_id),
          location_name: vm.location_name,
          from_page: 'lease_blocks',
          lease_id: vm.lease.id,
          isLease: vm.isLease
        };

        LeaseService.saveLeaseBlockData(data);

        $location.url('/ranches');
        closeDialog();
      });


    }


    /**
     * [goToBlocks description]
     * @return {[type]}             [description]
     */
    function goToBlocks() {
      vm.location_name = null;
      vm.ranch_name = null;
      api.locations.get({id: parseInt(vm.block.location_id)}, function(locationsData) {
        if(locationsData.location) {
          vm.location_name = locationsData.location.name;
        }
        api.ranches.get({id: parseInt(vm.block.ranch_id)}, function(ranchesData) {
          if(ranchesData.ranch) {
            vm.ranch_name = ranchesData.ranch.name;
          }
          var data = [];
          data = {
            location_id: parseInt(vm.block.location_id),
            location_name: vm.location_name,
            ranch_id: parseInt(vm.block.ranch_id),
            ranch_name: vm.ranch_name,
            from_page: 'lease_blocks',
            lease_id: vm.lease.id,
            isLease: vm.isLease
          };

          LeaseService.saveLeaseBlockData(data);

          $location.url('/blocks');
          closeDialog();
        });
      });

    }

    /**
     * [goToLease description]
     * @param  {[type]} lease_id [description]
     * @return {[type]}          [description]
     */
    function goToLease(lease_id) {
      $location.url('/leases/edit/' + lease_id + '/' + 2);
      closeDialog();
    }

      /**
   * [updateLeaseAcres description]
   * @return {[type]} [description]
   */
    function updateLeaseAcres() {
      var acresAmount = 0;
      vm.lease.blocks.forEach(function(block) {
        acresAmount += block.acres;
      });
      vm.lease.acres=acresAmount;
      var data = {
        acres: acresAmount
      };
      vm.service.patch(vm.lease.id,data).then(function() {},
      function(err) {
        console.error(err);
      });
    }

  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .factory('CardFilters', CardFiltersService);

  /** @ngInject */
  function CardFiltersService() {
    var service = {
      name   : '',
      labels : [],
      members: [],
      clear  : clear,
      isOn   : isOn
    };
    /**
     * Clear
     */
    function clear() {
      service.name = '';
      service.labels = [];
      service.members = [];
    }
    /**
     * Is on
     *
     * @returns {boolean}
     */
    function isOn() {
      return (service.name === '' && service.labels.length === 0 && service.members.length === 0) ? false : true;
    }
    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .factory('DialogService', DialogService);

  /** @ngInject */
  function DialogService($mdDialog, $document) {
    var service = {
      openCardDialog: openCardDialog
    };

    /**
     * Open card dialog
     *
     * @param ev
     * @param cardId
     */
    function openCardDialog(ev, cardId, removeCardFnc) {
      $mdDialog.show({
        templateUrl        : 'app/main/admin/modules/dialogs/card/card-dialog.html',
        controller         : 'ScrumboardCardDialogController',
        controllerAs       : 'vm',
        parent             : $document.find('#modules'),
        targetEvent        : ev,
        clickOutsideToClose: true,
        escapeToClose      : true,
        locals             : {
          cardId: cardId,
          removeCardFnc: removeCardFnc
        }
      });
    }
    return service;
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .factory('BoardService', BoardService);

    /** @ngInject */
  function BoardService($q, msApi, ModuleService, PageService, RoleService) {
    var service = {
      data        : {},
      modules     : {},
      pages       : {},
      roles       : {},
      addNewBoard : addNewBoard,
      getBoardData: getBoardData,
      getModuleAndPageData: getModuleAndPageData
    };

    /**
     * Get board data from the server
     *
     * @param boardId
     * @returns {*}
     */
    function getBoardData(boardId) {
      // Create a new deferred object
      var deferred = $q.defer();

      msApi.request('modules.board@get', {id: boardId},
        // SUCCESS
        function (response) {
          // Attach the data
          service.data = response.data;
          // Resolve the promise
          deferred.resolve(response);
        },
        // ERROR
        function (response) {
          // Reject the promise
          deferred.reject(response);
        }
      );
      return deferred.promise;
    }
    /**
     * [getModuleData description]
     * @return {[type]} [description]
     */
    function getModuleAndPageData() {
      // Create a new deferred object
      var deferred = $q.defer();
      $q.all([
        ModuleService.getList().then(),
        PageService.getList().then(),
        RoleService.getList().then()
      ]).then(function(response) {
        // Attach the data
        response[0].modules.forEach(function(module, i) {
          // Get Pages ids and add map/relation to moudle.
          var pageIds = [];
          var roleIds = [];
          module.pages.forEach(function(page) {
            pageIds.push(page.id);
          });
          response[0].modules[i].idCards = pageIds;
          // Get roles and map with each module.
          module.module_access.forEach(function(role) {
            roleIds.push(role.user_role_id);
          });
          response[0].modules[i].idMembers = roleIds;
        });
        service.modules = response[0].modules;
        service.pages = response[1].pages;
        service.roles = response[2].roles;
        // Resolve the promise
        deferred.resolve(response);
      },
      // ERROR
      function (response) {
        // Reject the promise
        deferred.reject(response);
      });
      return deferred.promise;
    }

    /**
     * Create an empty board object and set it.
     *
     * For the demonstration purposes, we are creating the
     * empty object in the javascript which you wouldn't do
     * it in real life. Rather, you would make an API call
     * to your server to generate an empty object that fills
     * some of the areas for you like an ID, labels, members
     * or the default board settings.
     *
     * Then you would grab the response that comes from
     * the API call and attach it to the service.data object.
     */
    function addNewBoard() {
      // Create a new deferred object
      var deferred = $q.defer();

      // Here you would make an API call to your server...
      _generateEmptyScrumboardObject().then(
        // SUCCESS
        function (response) {
          // Attach the data
          service.data = response.data;
          // Resolve the response
          deferred.resolve(response);
        },
        // ERROR
        function (response) {
          // Reject the response
          deferred.reject(response);
        }
      );
      return deferred.promise;
    }

    /**
     * Dummy function for generating an empty
     * modules object for demonstration
     * purposes
     *
     * @private
     * returns {$promise}
     */
    function _generateEmptyScrumboardObject() {
      // Create a new deferred object
      var deferred = $q.defer();
      // Fake id generator
      var id = parseInt(new Date().valueOf(), 16);
      // Prepare an empty modules object
      var emptyObject = {
        data: {
          name    : 'Untitled Board',
          uri     : 'untitled-board',
          id      : id,
          settings: {
            color          : '',
            subscribed     : false,
            cardCoverImages: true
          },
          lists   : [],
          cards   : [],
          members : [
            {
              id    : '56027c1930450d8bf7b10758',
              name  : 'Alice Freeman',
              avatar: 'assets/images/avatars/alice.jpg'
            },
            {
              id    : '26027s1930450d8bf7b10828',
              name  : 'Danielle Obrien',
              avatar: 'assets/images/avatars/danielle.jpg'
            },
            {
              id    : '76027g1930450d8bf7b10958',
              name  : 'James Lewis',
              avatar: 'assets/images/avatars/james.jpg'
            },
            {
              id    : '36027j1930450d8bf7b10158',
              name  : 'Vincent Munoz',
              avatar: 'assets/images/avatars/vincent.jpg'
            }
          ],
          labels  : [
            {
              id   : '26022e4129ad3a5sc28b36cd',
              name : 'High Priority',
              color: 'red'
            },
            {
              id   : '56027e4119ad3a5dc28b36cd',
              name : 'Design',
              color: 'orange'
            },
            {
              id   : '5640635e19ad3a5dc21416b2',
              name : 'App',
              color: 'blue'
            },
            {
              id   : '6540635g19ad3s5dc31412b2',
              name : 'Feature',
              color: 'green'
            }
          ]
        }
      };
      // Resolve the promise
      deferred.resolve(emptyObject);
      return deferred.promise;
    }
    return service;
  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin.growing-seasons-definition.dialogs', [])
    .controller('GrowingYearDialogController', GrowingYearDialogController);

  /** @ngInject */
  function GrowingYearDialogController(
    $mdDialog,
    $location,
    $mdToast,
    dialogData,
    FiscalYearService,
    SeasonsService,
    $scope,
    api,
    _
  ) {
    var vm = this;

    // Data
    vm.payment_finance_terms = [];
    vm.title              = (dialogData.growingYear) ? 'Edit Growing Year '+ dialogData.growingYear.name  : 'New Growing Year';
    vm.growingYear        = (dialogData.growingYear) ? dialogData.growingYear : {};
    vm.growingYears       = (dialogData.growingYears) ? dialogData.growingYears : [];
    vm.season2MinDate     = '';
    vm.season3MinDate     = '';
    vm.season4MinDate     = '';
    vm.seasonMaxDate      = '';


    // Methods
    vm.init               = init;
    vm.saveGrowingYear     = saveGrowingYear;
    vm.closeDialog         = closeDialog;
    vm.calculateMinMaxDates  = calculateMinMaxDates;

    $scope.customDateFormat = {
      formatDate: function(date) {
        var m = moment(date);
        return m.isValid() ? m.format('ll') : '';
      }
    };

    //////////

    init();
    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      if(!vm.growingYear.id) {
        vm.growingYear.fiscal_year_seasons = [];
        vm.growingYear.display_on_home_page = false;
        api.seasons.get(function(SeasonsData) {
          vm.seasons  = SeasonsData.seasons;
          var idx = 0;
          angular.forEach(vm.seasons, function(season) {
            vm.growingYear.fiscal_year_seasons[idx] = {};
            vm.growingYear.fiscal_year_seasons[idx].season_id = season.id;
            idx++;
          });
        });


      }
    }

    /**
     * [calculateMinMaxtDates description]
     * @param  {[type]} seasonStartDate [description]
     * @param  {[type]} seasonNumber    [description]
     * @return {[type]}                 [description]
     */
    function calculateMinMaxDates(seasonStartDate, seasonNumber) {
      switch (seasonNumber) {
      case 1:
        vm.season2MinDate = new Date(moment(seasonStartDate).add(1,'days'));
        vm.seasonMaxDate = new Date(moment(seasonStartDate).add(365,'days'));
        vm.growingYear.begin_date = seasonStartDate;
        vm.growingYear.fiscal_year_seasons[3].end_date = vm.seasonMaxDate;
        vm.growingYear.end_date = vm.seasonMaxDate;
        break;
      case 2:
        vm.growingYear.fiscal_year_seasons[0].end_date = new Date(moment(seasonStartDate).subtract(1,'days'));
        vm.season3MinDate = new Date(moment(seasonStartDate).add(1,'days'));
        break;
      case 3:
        vm.growingYear.fiscal_year_seasons[1].end_date = new Date(moment(seasonStartDate).subtract(1,'days'));
        vm.season4MinDate = new Date(moment(seasonStartDate).add(1,'days'));
        break;
      case 4:
        vm.growingYear.fiscal_year_seasons[2].end_date = new Date(moment(seasonStartDate).subtract(1,'days'));
        break;
      }
    }

    /**
     * [saveGrowingYear description]
     * @return {[type]} [description]
     */
    function saveGrowingYear() {
      if(vm.growingYear.id) {
        FiscalYearService.update(vm.growingYear.id, vm.growingYear).then(
          function(data) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The growing year '+ vm.growingYear.name + ' has been updated.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            var pos = _.findIndex(vm.growingYears, {'id': data.fiscal_year.id});
            if (data.fiscal_year !== undefined &&  pos > -1) {
              // avoid number as string error on form
              var aux = angular.copy(data.fiscal_year);
              vm.growingYears[pos] = aux;
            }
            closeDialog();
          },
          function(err) { //reject
            var error;
            if(err.status && err.status !== 500) {
              error = err.data.message;
            }
            $mdToast.show({
              template: '<md-toast class="md-toast error">The  growing year '+ vm.growingYear.name + ' could not be updated. ' + ((error !== undefined)? error : '') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          }
        );
      }
      else {
        FiscalYearService.create(vm.growingYear).then(
          function(data) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The growing year '+ vm.growingYear.name + ' has been created.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            vm.growingYears.push(data.fiscal_year);
            closeDialog();
          },
          function(err) { //reject
            var error;
            if(err.status && err.status !== 500) {
              error = err.data.message;
            }
            $mdToast.show({
              template: '<md-toast class="md-toast error">The  growing year '+ vm.growingYear.name + ' could not be created. ' + ((error !== undefined)? error : '') + '</md-toast>',
              position: 'top right',
              hideDelay: 6000
            });
          }
        );
      }

    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.toolbar.dialogs-profile', [])
    .controller('EditProfileDialogController', EditProfileDialogController)
    .directive('pwCheck', [function () {
      return {
        require: 'ngModel',
        link: function (scope, elem, attrs, ctrl) {
          var firstPassword = '#' + attrs.pwCheck;
          elem.add(firstPassword).on('keyup', function () {
            scope.$apply(function () {
              var v = elem.val() === $(firstPassword).val();
              ctrl.$setValidity('pwmatch', v);
            });
          });
        }
      };
    }]);

  /** @ngInject */
  function EditProfileDialogController(
    $scope,
    $state,
    $rootScope,
    $location,
    Upload,
    $mdToast,
    $mdDialog,
    $translate,
    dialogData,
    UserService,
    CompanyService,
    msUtils,
    RoleService,
    _) {
    var vm = this;

    // Data
    $scope.event = dialogData.ev;
    vm.title = 'Edit my profile';
    vm.allRolesGroups = dialogData.allRolesGroups;
    vm.allNotifyGroups = dialogData.allNotifyGroups;
    vm.user = dialogData.user;
    if (!vm.user.starred) {
      vm.user.starred = false;
    }
    $scope.admin = dialogData.admin;
    vm.companies = [];
    vm.userOnline = UserService.getLocalUser();
    vm.userOnline.roles.forEach(function (currentItem) {
      if (currentItem.name === 'super_user') {
        vm.superRole = currentItem;
      }
    });

    // Methods
    vm.saveUser = saveUser;
    vm.starredUser = starredUser;
    vm.patchNotifyGroup = patchNotifyGroup;
    vm.patchRoleGroup = patchRoleGroup;
    vm.isValidPassword = isValidPassword;
    vm.closeDialog = closeDialog;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.queryCompany = queryCompany;
    vm.searchTextChange = searchTextChange;
    vm.selectedCompanyChange = selectedCompanyChange;
    vm.createFilterFor = createFilterFor;
    vm.addToUserUserRole = addToUserUserRole;
    vm.addToUserNotifyGroup = addToUserNotifyGroup;
    vm.openImgCropDialog = openImgCropDialog;
    vm.invalidImage = invalidImage;
    vm.checkTabKey = checkTabKey;
    vm.notifyGroups = [];
    vm.roles = [];
    CompanyService.get().then(function (result) {
      vm.companies = result.companies;
      if (vm.user.company_id) {
        vm.user.company = vm.companies.filter(function (c) {
          return c.id == vm.user.company_id;
        }).shift();
        checkPhoneMask(vm.user.company);
      }
    });
    /**
     * checkTabKey
     */
    function checkTabKey(evt) {
      if (!_.isEmpty($scope.userForm.password_confirm.$error) && evt.keyCode === 9) {
        evt.preventDefault(evt);
      }
    }
    /**
     * invalidImage
     */
    function invalidImage($files) {
      vm.imageInvalid = $files.filter(function (file) {
        return file.type != 'image/gif' && file.type != 'image/jpeg' && file.type != 'image/png' && file.type != 'image/bmp' && file.type != 'image/jpg' && file.type != 'image/jpe' && file.type != 'image/tiff' && file.type != 'image/ico';
      }).length > 0;
    }
    /**
     * openImgCropDialog
     */
    function openImgCropDialog(evt, file) {
      if ($scope.userForm.file.$error.maxSize) {
        vm.imageInvalid = true;
      }
      if (!file) {
        vm.imageInvalid = true;
      }
      if (vm.imageInvalid) {
        vm.imageInvalid = false;
        return;
      }
      $mdDialog.show({
        controller: function DialogController($scope, $mdDialog) {
          /** @ngInject */
          $scope.vm = vm;
          $scope.crop_image = '';
          $scope.cancel = function () {
            delete vm.picFile;
            dialogData.addUserDialog(evt, vm.user, true);
            $mdDialog.cancel();
          };
          $scope.confirm = function () {
            // Convert it to a blob to upload
            var blob = b64toBlob($scope.crop_image, file);
            vm.user.image_url = $scope.crop_image;
            vm.user.image_name = '';
            vm.user.avatarUpdated = true;
            vm.user.file = blob;
            $mdDialog.cancel();
            evt.stopPropagation();
            dialogData.addUserDialog(evt, vm.user, true);

          };
        },
        templateUrl: 'app/main/admin/users/dialogs/user/crop_dialog.html',
        parent: angular.element(document.body),
        clickOutsideToClose: false,
        targetEvent: evt,
        fullscreen: true
      });
    }
    /**
     * queryCompany
     */
    function queryCompany(query) {
      var results = query ? _.filter(vm.companies, vm.createFilterFor(query))
        : vm.companies;
      return results;
    }
    /**
     * createFilterFor
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);
      return function filterFn(state) {
        return (state.name.toLowerCase().indexOf(lowercaseQuery) === 0);
      };
    }
    /**
     * searchTextChange
     */
    function searchTextChange() {
    }
    /**
     * selectedCompanyChange
     */
    function selectedCompanyChange(c) {
      checkPhoneMask(c);
    }
    /**
     * checkPhoneMask
     */
    function checkPhoneMask(c) {
      if (!c) {
        vm.phoneMask = '';
        return;
      }
      if (c.country == 'United States') {
        vm.phoneMask = '999-999-9999';
      } else {
        vm.phoneMask = '';
      }
    }
    /**
     * Function to validate password
     * @return {Boolean} [description]
     */
    function isValidPassword() {
      if (vm.user.password === vm.user.password_confirm) {
        return true;
      } else {
        return false;
      }
    }
    /**
     * Save existent user (save on edit)
     */
    function checkIfIsMyUser(user) {
      return user.id == UserService.getLocalUser().id;
    }
    /**
     * Function to validate password
     * @return {Boolean} [description]
     */
    function saveUser() {
      vm.user.save = true;
      var dataToPost = {
        active: vm.user.active.toString(),
        name: vm.user.name,
        login_name: vm.user.login_name,
        email_address: vm.user.email_address,
        cell_phone: vm.user.cell_phone,
        office_phone: vm.user.office_phone,
        fax: vm.user.fax,
        company_id: vm.user.company.id,
        r: vm.user.r,
        ng: vm.user.ng,
        starred: vm.user.starred.toString(),
      };
      if (vm.user.r.length === 0) {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The user ' + vm.user.name + ' must have a role.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        return;
      }
      /**
       * If password is modified, add it to the object
       */
      if (vm.user.password !== undefined && vm.user.password.length > 0 && vm.isValidPassword()) {
        dataToPost.password = vm.user.password;
      }
      UserService.update(vm.user.id, dataToPost).then(function () {
        if (vm.user.avatarUpdated) {
          Upload.upload({
            url: UserService.getUploadImgUrl(vm.user.id),
            data: { id: vm.user.id, upfile: vm.user.file }
          }, function () {
          }, function () {
          }).then(function () {
            $mdToast.show({
              template: '<md-toast class="md-toast success">The user ' + vm.user.name + ' has been updated.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });

            if (checkIfIsMyUser(vm.user)) {
              var localUser = UserService.getLocalUser();
              _.assign(localUser, vm.user, { company_id: vm.user.company.id });
              UserService.saveLocalUser(localUser);
              $rootScope.$broadcast('userChange', localUser);
              /**
               * Method that will updated user online in list by toolbar
               */
              $rootScope.$broadcast('updateUserOnlineUserController',{});
            }
          });
        } else {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The user ' + vm.user.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          if (checkIfIsMyUser(vm.user)) {
            var localUser = UserService.getLocalUser();
            _.assign(localUser, vm.user, { company_id: vm.user.company.id });
            UserService.saveLocalUser(localUser);
            $rootScope.$broadcast('userChange', localUser);
            /**
             * Method that will updated user online in list by toolbar
             */
            $rootScope.$broadcast('updateUserOnlineUserController',{});
          }
        }
      },
      function (err) { // Reject
        var error;
        if (err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">The user ' + vm.user.name + ' could not be updated. ' + ((error != undefined) ? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
      vm.roles.forEach(function (group) {
        RoleService.userRoleRemoveRelation(vm.user.id, group).then(function () {});
      });
      vm.notifyGroups.forEach(function (group) {
        UserService.userNotifyGroupRemoveRelation(vm.user.id, group).then(function () {});
      });
      $scope.aux = true;
      dataToPost.r.forEach(function (element) {
        RoleService.userRoleAddRelation(vm.user.id, element).then(function () {
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The User ' + vm.user.name + ' could not be relate to Business Roles id:' + element.name + '.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      });
      dataToPost.ng.forEach(function (element) {
        UserService.userNotifyGroupAddRelation(vm.user.id, element).then(function () {
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The User ' + vm.user.name + ' could not be relate to notify group ' + element.name + '.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      });
      closeDialog();
    }
    /**
     * Starred User
     */
    function starredUser(user) {
      if (user.starred === false) {
        user.starred = true;
      } else if (vm.user.starred === true) {
        user.starred = false;
      }
      if (checkIfIsMyUser(vm.user)) {
        var localUser = UserService.getLocalUser();
        _.assign(localUser, vm.user, { company_id: vm.user.company.id });
        UserService.saveLocalUser(localUser);
        $rootScope.$broadcast('userChange', localUser);
      }
    }


    /**
     * Patch User Role
     */
    function patchRoleGroup(user, group) {
      dialogData.patchRoleGroup(user, group);
    }
    /**
     * [patchUserGroup description]
     * @return {[type]} [description]
     */
    function patchNotifyGroup(user, group) {
      dialogData.patchNotifyGroup(user, group);
    }
    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }
    /**
     * Add user to notify group
     */
    function addToUserNotifyGroup(user, group) {
      if (!vm.exists(group.id, user.ng)) {
        user.ng.push(group.id);
      } else {
        _.remove(user.ng, function (elem) {
          vm.notifyGroups.push(group.id);
          return elem === group.id;
        });
      }
    }
    /**
     * Add user to role
     */
    function addToUserUserRole(user, group) {
      if (!vm.exists(group.id, user.r)) {
        user.r.push(group.id);
      } else {
        if (user.id === vm.userOnline.id && group.name === 'super_user') {
          $mdToast.show({
            template: '<md-toast class="md-toast warning">' + user.name + ' could not be role group ' + group.name + '.</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        } else {
          _.remove(user.r, function (elem) {
            vm.roles.push(group.id);
            return elem === group.id;
          });
        }
      }
    }

    /**
     * Convert base64 image to blob
     * @param  {[type]} b64Data   [description]
     * @param  {[type]} file      [description]
     * @param  {[type]} sliceSize [description]
     * @return {[type]}           [description]
     */
    function b64toBlob(b64Data, file, sliceSize) {
      // Split the base64 string in data and contentType
      var block = b64Data.split(';');
      // Get the content type of the image
      var contentType = block[0].split(':')[1];

      // get the real base64 content of the file
      var realData = block[1].split(',')[1];

      contentType = contentType || '';
      sliceSize = sliceSize || 512;

      var byteCharacters = atob(realData);
      var byteArrays = [];

      for (var offset = 0; offset < byteCharacters.length; offset += sliceSize) {
        var slice = byteCharacters.slice(offset, offset + sliceSize);

        var byteNumbers = new Array(slice.length);
        for (var i = 0; i < slice.length; i++) {
          byteNumbers[i] = slice.charCodeAt(i);
        }

        var byteArray = new Uint8Array(byteNumbers);

        byteArrays.push(byteArray);
      }

      var blob = new Blob(byteArrays, {type: contentType});
      var blobUrl = URL.createObjectURL(blob);
      blob.$ngfBlobUrl = blobUrl;
      blob.$ngfName= file.$ngfName;

      return blob;
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('app.toolbar.dialogs', [])
    .controller('AreaFiscalYearDialogController', AreaFiscalYearDialogController);

  /** @ngInject */
  function AreaFiscalYearDialogController(
    $state,
    $location,
    $mdToast,
    $mdDialog,
    $timeout,
    $translate,
    AreaService,
    UserService,
    FiscalYearService,
    areaFiscalYear,
    areas,
    fiscalYears,
    parentInit,
    msUtils
  ) {
    var vm = this;
    var toastInstance     = {};

    // Data
    vm.title              = 'Set the Area and Growing Year';
    vm.allFields          = false;
    vm.isValidYear        = true;
    vm.areaFiscalYear     = areaFiscalYear;
    vm.areas              = areas;
    vm.fiscalYears        = fiscalYears;

    // Methods
    vm.parentInit         = parentInit;
    vm.init               = init;
    vm.validateYear       = validateYear;
    vm.saveAreaFiscalYear = saveAreaFiscalYear;
    vm.closeDialog        = closeDialog;
    vm.toggleInArray      = msUtils.toggleInArray;
    vm.hideToast          = hideToast;
    vm.exists             = msUtils.exists;
    vm.getSelected        = getSelected;

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      //TODO: set selected area.
    }

    /**
     * Save area fiscal year
     */
    function saveAreaFiscalYear() {
      // TODO: CHANGE THIS TO SAVE DATA IN PROPER ENTITIES.
      if(vm.area.id && vm.fy.id) {
        vm.areas.forEach(function(area, k) {
          if(parseInt(area.id) === parseInt(vm.area.id)) {
            vm.areaFiscalYear.area = {id: vm.area.id, name: vm.areas[k].name};
          }
        });
        vm.fiscalYears.forEach(function(fy, k) {
          if(parseInt(fy.id) === parseInt(vm.fy.id)) {
            vm.areaFiscalYear.fiscal_year = {id: vm.fy.id, begin_date: vm.fiscalYears[k].begin_date, end_date: vm.fiscalYears[k].end_date};
          }
        });
        var dataToPost = {
          area_id: vm.areaFiscalYear.area.id,
          fiscal_year_id: vm.areaFiscalYear.fiscal_year.id
        };
        /* Set global area & fiscal year */
        UserService.setGlobalAreaFiscalYear(dataToPost).then(function(data) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">' + data.message + '.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          // Change from note ~359793
          $state.reload();
          var user = UserService.getLocalUser();
          if(data.user) {
            user.default_global_area_fiscal_year_id = data.user.default_global_area_fiscal_year_id;
            UserService.saveLocalUser(user);
            vm.parentInit();
          }
        },
        function() {
          toastInstance = $mdToast.show({
            template: '<md-toast class="md-toast error">\
              The global settings could not be saved, please try again later. ' +
              '<md-button ng-click="vm.hideToast()">X</md-button></md-toast>',
            position: 'top right',
            hideDelay: false,
            controller: 'AreaFiscalYearDialogController',
          });
        });
      }
      closeDialog();
    }
    /**
     * [validateYear description]
     * @return {[type]} [description]
     */
    function validateYear() {
      /**
       * Validate year
       */
      if(/^\d{4}$/.test(vm.areaFiscalYear.fiscal_year.begin_date) !== true
         || vm.areaFiscalYear.fiscal_year.begin_date < moment().year()
      ) {
        vm.isValidYear = false;
      } else {
        vm.isValidYear = true;
        vm.areaFiscalYear.fiscal_year.end_date = moment(vm.areaFiscalYear.fiscal_year.begin_date + '-01-01').add(1, 'year').year();
      }
      return vm.isValidYear;
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * [hideToast description]
     * @return {[type]} [description]
     * // TODO: MOVE THIS TO A TOAST CONTROLLER
     */
    function hideToast() {
      $mdToast.hide(toastInstance);
    }

    /**
     * [getSelected description]
     * @return {[type]} [description]
     */
    function getSelected(area, fy) {
      if(vm.areaFiscalYear.area && vm.areaFiscalYear.area.id === '') {
        if(area && area.id === 1) {
          return 'selected';
        }
      }
      if(vm.areaFiscalYear.fiscal_year && vm.areaFiscalYear.fiscal_year.id === '') {
        if(fy && fy.id === 1) {
          return 'selected';
        }
      }
      if(area && vm.areaFiscalYear.area && vm.areaFiscalYear.area.id === area.id) {
        return 'selected';
      }
      if(fy && vm.areaFiscalYear.fiscal_year && vm.areaFiscalYear.fiscal_year.id === fy.id) {
        return 'selected';
      }
      return;
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

    }
})();

(function ()
{
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('ChatTabController', ChatTabController);

  /** @ngInject */
  function ChatTabController(
    $rootScope,
    $q,
    $state,
    $timeout,
    $mdDialog,
    $document,
    $mdSidenav,
    $translate,
    $mdToast,    
    UserService,
    msApi
  )
  {
    var vm = this;

    // Data
    vm.contacts = [];
    vm.users = [];
    vm.chat = {};
    vm.chatActive = false;
    vm.replyMessage = '';

    init();

    /**
     * Get Users
     */
    function init() {
      UserService.getList().then(function (data) {
        vm.users = data.users;
      },
      function (err) {
        console.error(err);    
      });
    }
    // Methods
    vm.toggleChat = toggleChat;
    vm.reply = reply;

    //////////

    function toggleChat(contact) {
      vm.chatActive = !vm.chatActive;

      if ( vm.chatActive ) {
        vm.replyMessage = '';
        vm.chat.contact = contact;
        scrollToBottomOfChat(0);
      }
    }

    function reply() {
      if ( vm.replyMessage === '' ) {
        return;
      }

      if ( !vm.chat.contact.dialog ) {
        vm.chat.contact.dialog = [];
      }

      vm.chat.contact.dialog.push({
        who    : 'user',
        message: vm.replyMessage,
        time   : 'Just now'
      });

      vm.replyMessage = '';

      scrollToBottomOfChat(400);
    }

    function scrollToBottomOfChat(speed) {
      var chatDialog = angular.element('#chat-dialog');

      $timeout(function () {
        chatDialog.animate({
          scrollTop: chatDialog[0].scrollHeight
        }, speed);
      }, 0);
    }
  }
})();
(function() {
  'use strict';

  angular
    .module('app.services', []);
})();
(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('WorkScheduleType', function ($http, $sessionStorage, $q, _) {
    //var API = {url: $sessionStorage.apiUrl};
    /* Use entity var without trailing slash */
    //var entity = '/workScheduleType';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    //var entityES = '/workScheduleType/';
    var workScheduleType = {};
    var workScheduleTypes = [
      {name: 'Name 1', id: 1},
      {name: 'Name 2', id: 2},
      {name: 'Name 3', id: 3}
    ];

    workScheduleType.get = function () {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve(workScheduleTypes);
      }, 2500);

      return deferred.promise;
    };

    workScheduleType.save = function (phase) {
      //var self = this;
      var deferred = $q.defer();

      setTimeout(function () {
        phase.id = workScheduleTypes.length + 1;
        workScheduleTypes.push(phase);
        deferred.resolve();
      }, 500);

      return deferred.promise;
    };

    workScheduleType.update = function () {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve();
      }, 2000);

      return deferred.promise;
    };

    workScheduleType.delete = function (phase) {
      //var self = this;
      var deferred = $q.defer();

      setTimeout(function () {
        _.remove(workScheduleTypes, {
          id: phase.id
        });
        deferred.resolve();
      }, 500);

      return deferred.promise;
    };

    return workScheduleType;
  });
})();
(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('WorkTemplateService', function ($http, $q) {
    /* Use entity var without trailing slash */
    //var entity = '/phase';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    //var entityES = '/phase/';
    var workTemplateService = {};
    var work_templates = [
      {name: 'Work Template 1', id: 1, active: true, season_id: 1, seed_id: 1, phase_type_id: 1,color:'#000'},
      {name: 'Work Template 2', id: 2, active: true, season_id: 1, seed_id: 1, phase_type_id: 1,color:'#2F1'},
      {name: 'Work Template 3', id: 3, active: false, season_id: 1, seed_id: 1, phase_type_id: 1,color:'#F22'},
      {name: 'Work Template 4', id: 4, active: false, season_id: 1, seed_id: 1, phase_type_id: 1,color:'#22F'}
    ];

    var _ = window._;

    workTemplateService.selectedWorkTemplate = {};


    workTemplateService.get = function () {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve(work_templates);
      }, 2000);

      return deferred.promise;
    };

    workTemplateService.getWorkTemplatesWithOffset = function (offset, limit) {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve(_.take(_.drop(work_templates, offset), limit));
      }, 2000);

      return deferred.promise;

    };

    workTemplateService.save = function (phase) {
      //var self = this;
      var deferred = $q.defer();

      setTimeout(function () {
        phase.id = work_templates.length + 1;
        work_templates.push(phase);
        deferred.resolve(phase);
      }, 500);

      return deferred.promise;
    };


    workTemplateService.update = function (wk) {
      var deferred = $q.defer();

      setTimeout(function () {
        var index = _.findIndex(work_templates, function (w) {
          return w.id == wk.id;
        });

        _.assign(work_templates[index], wk);

        deferred.resolve();
      }, 2000);

      return deferred.promise;
    };

    workTemplateService.bulkDelete = function (_tasks) {
      var deferred = $q.defer();


      setTimeout(function () {
        _tasks.forEach(function (_id) {
          _.remove(work_templates, {
            id: _id
          });
        });

        deferred.resolve(work_templates);
      }, 500);

      return deferred.promise;
    };

    workTemplateService.setSelected = function (wk) {
      workTemplateService.selectedWorkTemplate = wk;
    };


    workTemplateService.delete = function (phase) {
      var deferred = $q.defer();

      setTimeout(function () {
        _.remove(work_templates, {
          id: phase.id
        });
        deferred.resolve(work_templates);
      }, 500);

      return deferred.promise;
    };

    return workTemplateService;
  });
})();
(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('UserService', function ($http, API) {
    // var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity = '/users';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES = '/users/';
    var userNotifyGroup = '/notify_groups';
    var userNotifyGroupES = '/notify_groups/';
    var userNotifyGroupCreate = '/notify_groups/create';
    var requestPassword = '/password_reset_request';
    var checkPasswordResetHash = '/check_password_reset_hash';
    var setNewPassword = '/password_reset';
    var areaFiscalYear = '/set_global_area_fiscal_year';
    var localUser = JSON.parse(sessionStorage.getItem('user')) || null;
    var userService = {};


    userService.saveLocalUser = function (user) {
      // Normalize roles before store.
      var roleNewCase = '';
      user.roles.forEach(function(role, i) {
        roleNewCase = role.name.replace(/ /g, '_');
        user.roles[i].name = roleNewCase.toLowerCase();
      });
      sessionStorage.setItem('user', JSON.stringify(user));
      localUser = user;
    };

    userService.getLocalUser = function () {
      if(!localUser) {
        localUser = JSON.parse(localStorage.getItem('user'));
      }
      return localUser;
    };

    /**
     * Get all users
     */
    userService.getList = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
      .get(API.url + entity, {params: params})
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };
    /**
     * Ger user by id
     */
    userService.getUser = function (id) {
      return $http
      .get(API.url + entityES + id)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };
    /**
     * Function to create a new user.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    userService.create = function (data) {
      return $http
      .post(API.url + entity + '/create', data)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };
    /**
     * Function to update an user.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    userService.update = function (id, data) {
      return $http
      .put(API.url + entityES + id, data)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };
    /**
     * Function to patch an user.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    userService.patch = function (id, field) {
      return $http
      .patch(API.url + entityES + id, field)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };
    /**
     * Function to delete an user.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    userService.delete = function (id) {
      return $http
      .delete(API.url + entityES + id)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };
    /**
     * Function to delete multile users.
     * @param  {[type]} id
     * @return {[type]}
     *
     * TODO: add query string to bulk delete.
     */
    userService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
      .delete(API.url + entity + '/bulk?ids=' + ids)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };
    /**
     * Create new notify group and associate to user.
     *
     * @param  {[type]} user_id [description]
     * @return {[type]}         [description]
     */
    userService.createUserNotifyGroup = function (userId, data) {
      return $http
      .post(API.url + entityES + userId + userNotifyGroupCreate, data)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };

    /**
     * Assign a notify group to an user.
     *
     * @param  {[type]} user_id [description]
     * @return {[type]}         [description]
     */
    userService.userNotifyGroupAddRelation = function (userId, ngId) {
      return $http
      .put(API.url + entityES + userId + userNotifyGroupES + ngId)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };

    /**
     * Remove a notify group from an user.
     *
     * @param  {[type]} user_id [description]
     * @return {[type]}         [description]
     */
    userService.userNotifyGroupRemoveRelation = function (userId, ngId) {
      return $http
      .delete(API.url + entityES + userId + userNotifyGroupES + ngId)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };
    /**
     * [getNotifyGroups description]
     * @param  {[type]} userId [description]
     * @return {[type]}        [description]
     */
    userService.getUserNotifyGroups = function (userId) {
      return $http
      .get(API.url + entityES + userId + userNotifyGroup)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };

    /**
     * Function request new password.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    userService.requestPassword = function (email, data) {
      return $http
      .post(API.url + entityES + email + requestPassword, data)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };

    /**
     * Function request new password.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    userService.setNewPassword = function (data) {
      return $http
      .post(API.url + entity + setNewPassword, data)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };

    /**
     * [checkSetPasswordHash description]
     * @return {[type]} [description]
     */
    userService.checkSetPasswordHash = function (hash) {
      return $http
      .get(API.url + entityES + hash + checkPasswordResetHash)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };

    /**
     * Function to set global area fiscal year.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    userService.setGlobalAreaFiscalYear = function (data) {
      return $http
      .post(API.url + entity + areaFiscalYear, data)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };

    userService.getUploadImgUrl = function (userId) {
      return API.url + entityES + userId + '/add_image';
    };

    /**
     * [getUsersWithOffset description]
     * @param  {[type]} offset  [description]
     * @param  {[type]} limit   [description]
     * @return {[type]}         [description]
     */
    userService.getUsersWithOffset = function (offset, limit) {
      return $http
      .get(API.url + entity + '?limit=' + limit + '&offset=' + offset + '&area_id=' + '&order_by=id')
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * Remvove notify group relation with user.
     *
     * @param  {[type]} user_id [description]
     * @return {[type]}         [description]
     */
    userService.removeUserNotifyGroupRelation = function (userId, notifyGroupId) {
      return $http
      .delete(API.url + entityES + userId + userNotifyGroupES + notifyGroupId)
      .then(function (res) {
        if(res) {
          return res.data;
        }
      });
    };

    /**
     * Get user notify groups.
     *
     * @param  {[type]} userId [description]
     * @return {[type]}        [description]
     */
    userService.getUserNotifyGroups = function (userId) {
      return $http
      .get(API.url + entityES + userId + userNotifyGroup)
      .then(function (res) {
        if(res) {
          return res.data;
        }
      });
    };

    return userService;
  });
})();

(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('TaskService', function ($http, $sessionStorage, $q) {
    //var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    //var entity = '/task';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    //var entityES = '/task/';
    var taskService = {};
    var tasks = [
      {
        name: 'Task 1',
        user_role_id: 4,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 4, growing_start_date: false, harvest_date: false,tillage_date:false,irrigation_date:false,
        id: 1,
        work_schedule_type_id: 1,
        notify_at_start: true,
        notify_at_end: true,
        time_to_complete_mesured_by_acre: false,
        auto_start: false,
        daylight_only: true,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 0, estimated_minutes2: 10
      },
      {
        name: 'Task 2',
        user_role_id: 4,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, pre_water: false, growing_start_date: false, harvest_date: false,anchor_id: 3,irrigation_date:false,
        id: 2,
        work_schedule_type_id: 1,
        notify_at_start: false,
        notify_at_end: false,
        time_to_complete_mesured_by_acre: true,
        auto_start: false,
        daylight_only: true,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 5, estimated_minutes2: 0
      },
      {
        name: 'Task 3',
        user_role_id: 4,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 1,
        id: 3,
        work_schedule_type_id: 1,
        notify_at_start: false,
        notify_at_end: true,
        time_to_complete_mesured_by_acre: false,
        auto_start: false,
        daylight_only: false,
        time_anchor: true,
        color: generateColor(), estimated_minutes: 0, estimated_minutes2: 20
      },
      {
        name: 'Task 4',
        user_role_id: 6,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, pre_water: false, anchor_id: 5, harvest_date: false,tillage_date:false,irrigation_date:false,
        id: 4,
        work_schedule_type_id: 1,
        notify_at_start: true,
        notify_at_end: false,
        time_to_complete_mesured_by_acre: true,
        auto_start: true,
        daylight_only: false,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 10, estimated_minutes2: 0
      },
      {
        name: 'Task 5',
        user_role_id: 6,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, pre_water: false, growing_start_date: false, harvest_date: false,tillage_date:false,anchor_id: 6,
        id: 5,
        work_schedule_type_id: 1,
        notify_at_start: false,
        notify_at_end: true,
        time_to_complete_mesured_by_acre: false,
        auto_start: false,
        daylight_only: false,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 0, estimated_minutes2: 30
      },
      {
        name: 'Task 6',
        user_role_id: 5,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, pre_water: false, growing_start_date: false, anchor_id: 2,
        id: 6,
        work_schedule_type_id: 1,
        notify_at_start: false,
        notify_at_end: false,
        time_to_complete_mesured_by_acre: true,
        auto_start: false,
        daylight_only: false,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 2, estimated_minutes2: 0
      },
      {
        name: 'Task 7',
        user_role_id: 5,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 7,
        id: 7,
        work_schedule_type_id: 1,
        notify_at_start: true,
        notify_at_end: true,
        time_to_complete_mesured_by_acre: false,
        auto_start: true,
        daylight_only: true,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 0, estimated_minutes2: 50
      },
      {
        name: 'Task 11',
        user_role_id: 4,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 7,
        id: 11,
        work_schedule_type_id: 1,
        notify_at_start: true,
        notify_at_end: true,
        time_to_complete_mesured_by_acre: false,
        auto_start: false,
        daylight_only: true,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 0, estimated_minutes2: 40
      },
      {
        name: 'Task 21',
        user_role_id: 3,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 7,
        id: 21,
        work_schedule_type_id: 1,
        notify_at_start: false,
        notify_at_end: false,
        time_to_complete_mesured_by_acre: true,
        auto_start: false,
        daylight_only: true,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 3, estimated_minutes2: 0
      },
      {
        name: 'Task 31',
        user_role_id: 3,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 7,
        id: 31,
        work_schedule_type_id: 1,
        notify_at_start: false,
        notify_at_end: true,
        time_to_complete_mesured_by_acre: false,
        auto_start: false,
        daylight_only: false,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 0, estimated_minutes2: 60
      },
      {
        name: 'Task 41',
        user_role_id: 7,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 7,
        id: 41,
        work_schedule_type_id: 1,
        notify_at_start: true,
        notify_at_end: false,
        time_to_complete_mesured_by_acre: true,
        auto_start: true,
        daylight_only: false,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 4, estimated_minutes2: 0
      },
      {
        name: 'Task 51',
        user_role_id: 7,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 7,
        id: 51,
        work_schedule_type_id: 1,
        notify_at_start: false,
        notify_at_end: true,
        time_to_complete_mesured_by_acre: false,
        auto_start: false,
        daylight_only: false,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 0, estimated_minutes2: 120
      },
      {
        name: 'Task 61',
        user_role_id: 7,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 7,
        id: 61,
        work_schedule_type_id: 1,
        notify_at_start: false,
        notify_at_end: false,
        time_to_complete_mesured_by_acre: true,
        auto_start: false,
        daylight_only: false,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 6, estimated_minutes2: 0
      },
      {
        name: 'Task 71',
        user_role_id: 4,
        notify_group_id: 1,
        labor_task_group_id: 1,
        equipment_task_group_id: 1, anchor_id: 7,
        id: 71,
        work_schedule_type_id: 1,
        notify_at_start: true,
        notify_at_end: true,
        time_to_complete_mesured_by_acre: false,
        auto_start: true,
        daylight_only: true,
        time_anchor: false,
        color: generateColor(), estimated_minutes: 0, estimated_minutes2: 80
      },
    ];


    /**
     * Function to delete an company.
     * @param  {[generateColor]}
     */
    function generateColor() {

      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }

    var _ = window._;


    taskService.get = function () {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve(tasks);
      }, 2000);

      return deferred.promise;
    };

    taskService.getTasksWithOffset = function (offset, limit) {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve(_.take(_.drop(tasks, offset), limit));
      }, 2000);

      return deferred.promise;

    };

    taskService.save = function (task) {
      //var self = this;
      var deferred = $q.defer();

      setTimeout(function () {
        task.id = tasks.length + 1;
        tasks.push(task);
        deferred.resolve(task);
      }, 500);

      return deferred.promise;
    };


    taskService.update = function () {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve();
      }, 2000);

      return deferred.promise;
    };


    taskService.getByType = function (typeId) {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve(tasks.filter(function (p) {
          return p.work_schedule_type_id == typeId;
        }));
      }, 2000);

      return deferred.promise;
    };

    taskService.delete = function (task) {
      var deferred = $q.defer();

      setTimeout(function () {
        _.remove(tasks, {
          id: task.id
        });
        deferred.resolve(task);
      }, 500);

      return deferred.promise;
    };

    taskService.bulkDelete = function (_tasks) {
      var deferred = $q.defer();


      setTimeout(function () {
        _tasks.forEach(function (_id) {
          _.remove(tasks, {
            id: _id
          });
        });

        deferred.resolve(tasks);
      }, 500);

      return deferred.promise;
    };

    return taskService;
  });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('SubleasePaymentScheduleService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity                  = '/sublease_payment_schedules';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES                = '/sublease_payment_schedules/';

      var subleasePaymentScheduleService = {};
      /**
       * Function to create a new sublease payment schedule.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      subleasePaymentScheduleService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update an sublease payment schedule.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      subleasePaymentScheduleService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to patch an sublease payment schedule.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      subleasePaymentScheduleService.patch = function (id, field) {
        return $http
          .patch(API.url + entityES + id, field)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete an sublease payment schedule.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      subleasePaymentScheduleService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete multile subleases.
       * @param  {[type]} id
       * @return {[type]}
       *
       * TODO: add query string to bulk delete.
       */
      subleasePaymentScheduleService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to get all sublease payment schedule.
       * @param  {[type]} parameters [description]
       * @return {[type]}
       */
      subleasePaymentScheduleService.getAll = function (parameters) {
        var params = {};
        if (parameters) {
          params = parameters;
        }
        return $http
          .get(API.url + entity, {params: params})
          .then(function (res) {
            return res.data;
          });
      };

      return subleasePaymentScheduleService;
    });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('SubleaseService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/subleases';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/subleases/';
    var paymentTerms            = '/all/payment_terms';
    var subleaseDocuments          = '/sublease_documents';
    var blocksES                  = '/blocks/';
    var savedFilterData         = {};

    var subleaseService = {};
    /**
      * Function to create a new sublease.
      * @param  {[type]} data [description]
      * @return {[type]}      [description]
    */
    subleaseService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
      * Function to update an sublease.
      * @param  {[type]} id [description]
      * @return {[type]}    [description]
    */
    subleaseService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
      * Function to patch an sublease.
      * @param  {[type]} id [description]
      * @return {[type]}    [description]
    */
    subleaseService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          return res.data;
        });
    };
    /**
      * Function to delete an sublease.
      * @param  {[type]} id [description]
      * @return {[type]}    [description]
    */
    subleaseService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };
    /**
      * Function to delete multile subleases.
      * @param  {[type]} id
      * @return {[type]}
      *
      * TODO: add query string to bulk delete.
    */
    subleaseService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
        .delete(API.url + entity + '/bulk?ids=' + ids)
        .then(function (res) {
          return res.data;
        });
    };

    /**
      * Function to get payment terms.
      * @param  {[type]} data [description]
      * @return {[type]}      [description]
    */
    subleaseService.getPaymentTerms = function () {
      return $http
        .get(API.url + entity + paymentTerms)
        .then(function (res) {
          return res.data;
        });
    };

    /**
      * Function to get sublease documents.
      * @param  {[type]} data [description]
      * @return {[type]}      [description]
    */
    subleaseService.getDocuments = function (id) {
      return $http
        .get(API.url + entityES + id + subleaseDocuments + '?limit=' + 999999)
        .then(function (res) {
          return res.data;
        });
    };

          /**
     * Function to get payment terms.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    subleaseService.getAllActiveSubleases = function () {
      return $http
        .get(API.url + entity  + '?state=active' + '&limit=' + 999999)
        .then(function (res) {
          return res.data;
        });
    };

          /**
     * Function to assign block to sublease
     * [assignBlock description]
     * @param  {[type]} subleaseId [description]
     * @param  {[type]} blockId [description]
     * @return {[type]}         [description]
     */
    subleaseService.assignBlock = function (subleaseId, blockId, data) {
      return $http
         .put(API.url + entityES + subleaseId + blocksES + blockId, data)
         .then(function (res) {
           return res.data;
         });
    };

    /**
     * Function to unassign block to sublease
     * @param  {[type]} subleaseId [description]
     * @param  {[type]} blockId [description]
     * @return {[type]}         [description]
     */
    subleaseService.unassignBlock = function (subleaseId, blockId) {
      return $http
         .delete(API.url + entityES + subleaseId + blocksES + blockId)
         .then(function (res) {
           return res.data;
         });
    };

    /**
     * get sublease blocks
     * @param  {[type]} id   [description]
     * @param  {[type]} type [description]
     * @return {[type]}      [description]
     */
    subleaseService.getBlocks = function (id,type) {
      return $http
        .get(API.url + entityES + id + '/blocks/' + type)
        .then(function (res) {
          return res.data;
        });
    };

              /**
     * Function to get all subleases
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    subleaseService.getAllSubleases = function () {
      return $http
        .get(API.url + entity)
        .then(function (res) {
          return res.data;
        });
    };


    /**
     * Function to get subleases filtered by state
     * @param  {[type]} state    [description]
     * @param  {[type]} area     [description]
     * @return {[type]}          [description]
     */
    subleaseService.getStateFilteredSubleases = function (state) {
      return $http
        .get(API.url + entity  + '?state=' + state + '&limit=' + 999999)
        .then(function (res) {
          return res.data;
        });
    };

/**
 * [description]
 * @param  {[type]} parameters [description]
 * @return {[type]}            [description]
 */
    subleaseService.getSubleasesWithOffset = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity,  {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * [patch description]
     * @param  {[type]} id    [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     */
    subleaseService.patchAssociatedBlock = function (id, data) {
      return $http
        .patch(API.url + entityES + 'sublease_block/' + id, data)
        .then(function (res) {
          return res.data;
        });
    };

        /**
     * [saveFilterData description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    subleaseService.saveFilterData = function (data) {
      savedFilterData = data;
    };

    /**
     * [getFilterData description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    subleaseService.getFilterData = function () {
      return savedFilterData;
    };



    return subleaseService;
  });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('SubblockLocationService', function (_) {
    // var API = { url: $sessionStorage.apiUrl };
    // /* Use entity var without trailing slash */
    // var entity                  = '/subblock_locations';
    // /* Use entityES var with trailing slash (ES = Entity Slash) */
    // var entityES                = '/subblock_locations/';

    var subblockLocationService = {};

    /**
     * Function to get all subblock locations
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    subblockLocationService.getList = function () {
      var subblock_locations = [
        {
          'id': 1,
          'block_bed_direction_id': 1,
          'name': 'All',
          'number_of_locations_in_bed': 1,
          'location_order_number': 1
        },
        {
          'id': 2,
          'block_bed_direction_id': 1,
          'name': 'W',
          'number_of_locations_in_bed': 2,
          'location_order_number': 1
        },
        {
          'id': 3,
          'block_bed_direction_id': 1,
          'name': 'E',
          'number_of_locations_in_bed': 2,
          'location_order_number': 2
        },
        {
          'id': 4,
          'block_bed_direction_id': 1,
          'name': 'W',
          'number_of_locations_in_bed': 3,
          'location_order_number': 1
        },
        {
          'id': 5,
          'block_bed_direction_id': 1,
          'name': 'M',
          'number_of_locations_in_bed': 3,
          'location_order_number': 2
        },
        {
          'id': 6,
          'block_bed_direction_id': 1,
          'name': 'E',
          'number_of_locations_in_bed': 3,
          'location_order_number': 3
        },
        {
          'id': 7,
          'block_bed_direction_id': 1,
          'name': 'W',
          'number_of_locations_in_bed': 4,
          'location_order_number': 1
        },
        {
          'id': 8,
          'block_bed_direction_id': 1,
          'name': 'WW',
          'number_of_locations_in_bed': 4,
          'location_order_number': 2
        },
        {
          'id': 9,
          'block_bed_direction_id': 1,
          'name': 'EE',
          'number_of_locations_in_bed': 4,
          'location_order_number': 3
        },
        {
          'id': 10,
          'block_bed_direction_id': 1,
          'name': 'E',
          'number_of_locations_in_bed': 4,
          'location_order_number': 4
        },
        {
          'id': 11,
          'block_bed_direction_id': 1,
          'name': 'W',
          'number_of_locations_in_bed': 5,
          'location_order_number': 1
        },
        {
          'id': 12,
          'block_bed_direction_id': 1,
          'name': 'WW',
          'number_of_locations_in_bed': 5,
          'location_order_number': 2
        },
        {
          'id': 13,
          'block_bed_direction_id': 1,
          'name': 'M',
          'number_of_locations_in_bed': 5,
          'location_order_number': 3
        },
        {
          'id': 14,
          'block_bed_direction_id': 1,
          'name': 'EE',
          'number_of_locations_in_bed': 5,
          'location_order_number': 4
        },
        {
          'id': 15,
          'block_bed_direction_id': 1,
          'name': 'E',
          'number_of_locations_in_bed': 5,
          'location_order_number': 5
        },
        {
          'id': 16,
          'block_bed_direction_id': 1,
          'name': 'W',
          'number_of_locations_in_bed': 6,
          'location_order_number': 1
        },
        {
          'id': 17,
          'block_bed_direction_id': 1,
          'name': 'WW',
          'number_of_locations_in_bed': 6,
          'location_order_number': 2
        },
        {
          'id': 18,
          'block_bed_direction_id': 1,
          'name': 'WWW',
          'number_of_locations_in_bed': 6,
          'location_order_number': 3
        },
        {
          'id': 19,
          'block_bed_direction_id': 1,
          'name': 'EEE',
          'number_of_locations_in_bed': 6,
          'location_order_number': 4
        },
        {
          'id': 20,
          'block_bed_direction_id': 1,
          'name': 'EE',
          'number_of_locations_in_bed': 6,
          'location_order_number': 5
        },
        {
          'id': 21,
          'block_bed_direction_id': 1,
          'name': 'E',
          'number_of_locations_in_bed': 6,
          'location_order_number': 6
        },
        {
          'id': 22,
          'block_bed_direction_id': 1,
          'name': 'W',
          'number_of_locations_in_bed': 7,
          'location_order_number': 1
        },
        {
          'id': 23,
          'block_bed_direction_id': 1,
          'name': 'WW',
          'number_of_locations_in_bed': 7,
          'location_order_number': 2
        },
        {
          'id': 24,
          'block_bed_direction_id': 1,
          'name': 'WWW',
          'number_of_locations_in_bed': 7,
          'location_order_number': 3
        },
        {
          'id': 25,
          'block_bed_direction_id': 1,
          'name': 'M',
          'number_of_locations_in_bed': 7,
          'location_order_number': 4
        },
        {
          'id': 26,
          'block_bed_direction_id': 1,
          'name': 'EEE',
          'number_of_locations_in_bed': 7,
          'location_order_number': 5
        },
        {
          'id': 27,
          'block_bed_direction_id': 1,
          'name': 'EE',
          'number_of_locations_in_bed': 7,
          'location_order_number': 6
        },
        {
          'id': 28,
          'block_bed_direction_id': 1,
          'name': 'E',
          'number_of_locations_in_bed': 7,
          'location_order_number': 7
        },
        {
          'id': 29,
          'block_bed_direction_id': 1,
          'name': 'W',
          'number_of_locations_in_bed': 8,
          'location_order_number': 1
        },
        {
          'id': 30,
          'block_bed_direction_id': 1,
          'name': 'WW',
          'number_of_locations_in_bed': 8,
          'location_order_number': 2
        },
        {
          'id': 31,
          'block_bed_direction_id': 1,
          'name': 'WWW',
          'number_of_locations_in_bed': 8,
          'location_order_number': 3
        },
        {
          'id': 32,
          'block_bed_direction_id': 1,
          'name': 'WWWW',
          'number_of_locations_in_bed': 8,
          'location_order_number': 4
        },
        {
          'id': 33,
          'block_bed_direction_id': 1,
          'name': 'EEEE',
          'number_of_locations_in_bed': 8,
          'location_order_number': 5
        },
        {
          'id': 34,
          'block_bed_direction_id': 1,
          'name': 'EEE',
          'number_of_locations_in_bed': 8,
          'location_order_number': 6
        },
        {
          'id': 35,
          'block_bed_direction_id': 1,
          'name': 'EE',
          'number_of_locations_in_bed': 8,
          'location_order_number': 7
        },
        {
          'id': 36,
          'block_bed_direction_id': 1,
          'name': 'E',
          'number_of_locations_in_bed': 8,
          'location_order_number': 8
        },
        {
          'id': 37,
          'block_bed_direction_id': 2,
          'name': 'All',
          'number_of_locations_in_bed': 1,
          'location_order_number': 1
        },
        {
          'id': 38,
          'block_bed_direction_id': 2,
          'name': 'N',
          'number_of_locations_in_bed': 2,
          'location_order_number': 1
        },
        {
          'id': 39,
          'block_bed_direction_id': 2,
          'name': 'S',
          'number_of_locations_in_bed': 2,
          'location_order_number': 2
        },
        {
          'id': 40,
          'block_bed_direction_id': 2,
          'name': 'N',
          'number_of_locations_in_bed': 3,
          'location_order_number': 1
        },
        {
          'id': 41,
          'block_bed_direction_id': 2,
          'name': 'M',
          'number_of_locations_in_bed': 3,
          'location_order_number': 2
        },
        {
          'id': 42,
          'block_bed_direction_id': 2,
          'name': 'S',
          'number_of_locations_in_bed': 3,
          'location_order_number': 3
        },
        {
          'id': 43,
          'block_bed_direction_id': 2,
          'name': 'N',
          'number_of_locations_in_bed': 4,
          'location_order_number': 1
        },
        {
          'id': 44,
          'block_bed_direction_id': 2,
          'name': 'NN',
          'number_of_locations_in_bed': 4,
          'location_order_number': 2
        },
        {
          'id': 45,
          'block_bed_direction_id': 2,
          'name': 'SS',
          'number_of_locations_in_bed': 4,
          'location_order_number': 3
        },
        {
          'id': 46,
          'block_bed_direction_id': 2,
          'name': 'S',
          'number_of_locations_in_bed': 4,
          'location_order_number': 4
        },
        {
          'id': 47,
          'block_bed_direction_id': 2,
          'name': 'N',
          'number_of_locations_in_bed': 5,
          'location_order_number': 1
        },
        {
          'id': 48,
          'block_bed_direction_id': 2,
          'name': 'NN',
          'number_of_locations_in_bed': 5,
          'location_order_number': 2
        },
        {
          'id': 49,
          'block_bed_direction_id': 2,
          'name': 'M',
          'number_of_locations_in_bed': 5,
          'location_order_number': 3
        },
        {
          'id': 50,
          'block_bed_direction_id': 2,
          'name': 'SS',
          'number_of_locations_in_bed': 5,
          'location_order_number': 4
        },
        {
          'id': 51,
          'block_bed_direction_id': 2,
          'name': 'S',
          'number_of_locations_in_bed': 5,
          'location_order_number': 5
        },
        {
          'id': 52,
          'block_bed_direction_id': 2,
          'name': 'N',
          'number_of_locations_in_bed': 6,
          'location_order_number': 1
        },
        {
          'id': 53,
          'block_bed_direction_id': 2,
          'name': 'NN',
          'number_of_locations_in_bed': 6,
          'location_order_number': 2
        },
        {
          'id': 54,
          'block_bed_direction_id': 2,
          'name': 'NNN',
          'number_of_locations_in_bed': 6,
          'location_order_number': 3
        },
        {
          'id': 55,
          'block_bed_direction_id': 2,
          'name': 'SSS',
          'number_of_locations_in_bed': 6,
          'location_order_number': 4
        },
        {
          'id': 56,
          'block_bed_direction_id': 2,
          'name': 'SS',
          'number_of_locations_in_bed': 6,
          'location_order_number': 5
        },
        {
          'id': 57,
          'block_bed_direction_id': 2,
          'name': 'S',
          'number_of_locations_in_bed': 6,
          'location_order_number': 6
        },
        {
          'id': 58,
          'block_bed_direction_id': 2,
          'name': 'N',
          'number_of_locations_in_bed': 7,
          'location_order_number': 1
        },
        {
          'id': 59,
          'block_bed_direction_id': 2,
          'name': 'NN',
          'number_of_locations_in_bed': 7,
          'location_order_number': 2
        },
        {
          'id': 60,
          'block_bed_direction_id': 2,
          'name': 'NNN',
          'number_of_locations_in_bed': 7,
          'location_order_number': 3
        },
        {
          'id': 61,
          'block_bed_direction_id': 2,
          'name': 'M',
          'number_of_locations_in_bed': 7,
          'location_order_number': 4
        },
        {
          'id': 62,
          'block_bed_direction_id': 2,
          'name': 'SSS',
          'number_of_locations_in_bed': 7,
          'location_order_number': 5
        },
        {
          'id': 63,
          'block_bed_direction_id': 2,
          'name': 'SS',
          'number_of_locations_in_bed': 7,
          'location_order_number': 6
        },
        {
          'id': 64,
          'block_bed_direction_id': 2,
          'name': 'S',
          'number_of_locations_in_bed': 7,
          'location_order_number': 7
        },
        {
          'id': 65,
          'block_bed_direction_id': 2,
          'name': 'N',
          'number_of_locations_in_bed': 8,
          'location_order_number': 1
        },
        {
          'id': 66,
          'block_bed_direction_id': 2,
          'name': 'NN',
          'number_of_locations_in_bed': 8,
          'location_order_number': 2
        },
        {
          'id': 67,
          'block_bed_direction_id': 2,
          'name': 'NNN',
          'number_of_locations_in_bed': 8,
          'location_order_number': 3
        },
        {
          'id': 68,
          'block_bed_direction_id': 2,
          'name': 'NNNN',
          'number_of_locations_in_bed': 8,
          'location_order_number': 4
        },
        {
          'id': 69,
          'block_bed_direction_id': 2,
          'name': 'SSSS',
          'number_of_locations_in_bed': 8,
          'location_order_number': 5
        },
        {
          'id': 70,
          'block_bed_direction_id': 2,
          'name': 'SSS',
          'number_of_locations_in_bed': 8,
          'location_order_number': 6
        },
        {
          'id': 71,
          'block_bed_direction_id': 2,
          'name': 'SS',
          'number_of_locations_in_bed': 8,
          'location_order_number': 7
        },
        {
          'id': 72,
          'block_bed_direction_id': 2,
          'name': 'S',
          'number_of_locations_in_bed': 8,
          'location_order_number': 8
        }
      ];
      return subblock_locations;
    };

    subblockLocationService.getByNumberOfLocations = function (block_bed_direction_id, number_of_locations_in_bed) {
      // if (number_of_locations_in_bed === location_order_number) {
      //   number_of_locations_in_bed++;
      //   location_order_number = 1;
      // } else {
      //   location_order_number++;
      // }
      var subblock_locations = subblockLocationService.getList();
      var response = _.filter(subblock_locations, {
        block_bed_direction_id: block_bed_direction_id,
        number_of_locations_in_bed: number_of_locations_in_bed
      });
      response = _.sortBy(response, ['location_order_number']);
      return response;
    };

    return subblockLocationService;
  });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('StepperService', function () {
      return {
        stepNumber: '',
        disable: false,
        getStepNumber: function() {
          return this.stepNumber;
        },
        setStepNumber: function(step) {
          this.stepNumber = step;
        }
      };

    });
})();
(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('SeedService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      var entity = '/seeds';
      var entityES = '/seeds/';
      var seedVarieties = '/varieties';
      var seedVarietiesES = '/varieties/';
      var varietiesLocationsES = '/variety-planting-locations/';
      var areaES = '/areas/';
      var locations = '/locations';
      var seedService = {};
      /**
       * Function to get all seeds.
       * @return {[type]}      [description]
       */
      seedService.getAll = function () {
        return $http
          .get(API.url + entity)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to create a new seed.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      seedService.create = function (data) {
        return $http
          .post(API.url + entity + '/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to create a new variety.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      seedService.createVariety = function (data) {
        return $http
          .post(API.url + seedVarieties + '/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to create a new variety planting location.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      seedService.createVarietyPlantingLocation = function (data) {
        return $http
          .post(API.url + seedVarieties + varietiesLocationsES + 'create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update an seed.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      seedService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update an variety.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      seedService.updateVariety = function (id, data) {
        return $http
          .put(API.url + seedVarietiesES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update an variety planting location.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      seedService.updateVarietyPlantingLocation = function (id, data) {
        return $http
          .put(API.url + seedVarieties + varietiesLocationsES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
      //  * Function to get varieties seed.
      //  * @param  {[type]} id [description]
      //  * @return {[type]}    [description]
      //  */
      seedService.getVarieties = function (id) {
        return $http
          .get(API.url + entityES + id + seedVarieties)
          .then(function (res) {
            return res.data;
          });
      };
      /**
      //  * Function to get varieties location seed.
      //  * @param  {[type]} id [description]
      //  * @return {[type]}    [description]
      //  */
      seedService.getVarietiesLocation = function (id, area) {
        return $http
          .get(API.url + seedVarietiesES + id + varietiesLocationsES + area)
          .then(function (res) {
            return res.data;
          });
      };
      /**
      //  * Function to get location seed.
      //  * @param  {[type]} id [description]
      //  * @return {[type]}    [description]
      //  */
      seedService.getLocations = function (id) {
        return $http
          .get(API.url + areaES + id + locations)
          .then(function (res) {
            return res.data;
          });
      };
      /**
      * Function to delete an seed.
      * @param  {[type]} id [description]
      * @return {[type]}    [description]
      */
      seedService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to delete an variety.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      seedService.deleteVariety = function (id) {
        return $http
          .delete(API.url + seedVarietiesES + id)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to delete an variety planting location.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      seedService.deleteVarietyPlantingLocation = function (id) {
        return $http
          .delete(API.url + seedVarieties + varietiesLocationsES + id)
          .then(function (res) {
            return res.data;
          });
      };

      return seedService;
    });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('SeasonsService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity          = '/seasons';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES        = '/seasons/';
      var seasonsService    = {};

      /**
       * Function to create a new seasons
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      seasonsService.getList = function () {
        return $http
          .get(API.url + entity)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to create a new seasons
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      seasonsService.getFiscalYear = function (id) {
        return $http
          .get(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to create a new seasons
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      seasonsService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update a seasons
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      seasonsService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete a seasons
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
      seasonsService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete multile seasons.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       *
       * TODO: add query string to bulk delete.
       */ 
      seasonsService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            return res.data;
          });
      };
      return seasonsService;
    });
})();
(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('RoleService', function ($http, API) {
      // var API = { url: $sessionStorage.apiUrl };
      var entity = '/roles';
      var entityES = '/roles/';
      var entityUsersES = '/users/';
      var roleService = {};

      /**
       * Get all roles
       */
      roleService.getList = function (parameters) {
        var params = {};
        if (parameters) {
          params = parameters;
        }
        return $http
        .get(API.url + entity, {params: params})
        .then(function (res) {
          if (res) {
            return res.data;
          }
        });
      };
      /**
       * Function to create a new Businees Role Group
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      roleService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update a Businees Role Group
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      roleService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete a Businees Role Group
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      roleService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete multile Businees Role Group.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       *
       * TODO: add query string to bulk delete.
       */
      roleService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            return res.data;
          });
      };
            /**
       * Assign a notify group to an user.
       *
       * @param  {[type]} user_id [description]
       * @return {[type]}         [description]
       */
      roleService.userRoleAddRelation = function (userId, rId) {
        return $http
          .put(API.url + entityES + rId + entityUsersES + userId)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };

      /**
       * Remove a role group from an user.
       *
       * @param  {[type]} user_id [description]
       * @return {[type]}         [description]
       */
      roleService.userRoleRemoveRelation = function (userId, rId) {
        return $http
          .delete(API.url + entityES + rId + entityUsersES + userId)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      /**
       * Remvove notify group relation with user.
       *
       * @param  {[type]} user_id [description]
       * @return {[type]}         [description]
       */
      roleService.removeUserRoleRelation = function (userId, rId) {
        return $http
          .delete(API.url + entityES + rId + entityUsersES + userId)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      return roleService;
    });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('RanchService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    var entity = '/ranches',
      entityES = '/ranches/',
      ranchDocument = '/documents',
      ranchDocumentES = '/documents/',
      savedFilterData         = {},
      ranchService = {};
      /**
       * Function to create a new ranch.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
    ranchService.create = function (data) {
      return $http
        .post(API.url + entity + '/create', data)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to update an ranch.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    ranchService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to patch an ranch.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    ranchService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          return res.data;
        });
    };
      /**
      * Function to delete an seed.
      * @param  {[type]} id [description]
      * @return {[type]}    [description]
      */
    ranchService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };
    /**
    //  * Function to get varieties ranch.
    //  * @param  {[type]} id [description]
    //  * @return {[type]}    [description]
    //  */
    ranchService.getDocument = function (id) {
      return $http
        .get(API.url + entityES + id + ranchDocument)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to delete multile users.
     * @param  {[type]} id
     * @return {[type]}
     *
     * TODO: add query string to bulk delete.
     */
    ranchService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
        .delete(API.url + entityES + '/bulk?ids=' + ids)
        .then(function (res) {
          return res.data;
        });
    };
    /**
      * Function to delete an ranch.
      * @param  {[type]} id [description]
      * @return {[type]}    [description]
    */
    ranchService.deleteDocument = function (id) {
      return $http
        .delete(API.url + ranchDocumentES + id)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Get ranch information
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
    */
    ranchService.get = function (id) {
      return $http
        .get(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };

    /**
      * Get ranch blocks
      * @param  {[type]} id   [description]
      * @param  {[type]} type [description]
      * @return {[type]}      [description]
    */
    ranchService.getRanchBlocks = function (id, type, parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entityES + id + '/blocks/' + type, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Get ranchs of location
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    ranchService.getRanchesByLocation = function (id, parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity +  '/location/' + id, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * [getAreaBlocks description]
     * @param  {[type]} area_id [description]
     * @return {[type]}         [description]
     */
    ranchService.getAreaRanches = function (area_id) {
      return $http
        .get(API.url + entity  + '?area_id=' + area_id + '&limit=' + 999999)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * [getRanchesWithOffset description]
     * @param  {[type]} offset  [description]
     * @param  {[type]} limit   [description]
     * @param  {[type]} area_id [description]
     * @return {[type]}         [description]
     */
    ranchService.getRanchesWithOffset = function (offset, limit, area_id) {
      return $http
        .get(API.url + entity  + '?offset=' + offset + '&limit=' + limit + '&area_id=' + area_id + '&order_by=id')
        .then(function (res) {
          return res.data;
        });
    };

        /**
     * [saveFilterData description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    ranchService.saveFilterData =function (data) {
      savedFilterData = data;
    };

    /**
     * [getFilterData description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    ranchService.getFilterData =function () {
      return savedFilterData;
    };

    return ranchService;
  });
})();

(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('PlantingSchedulePlantingInformationService', function ($http, $q) {
      /* Use entity var without trailing slash */
      //var entity = '/phase';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      //var entityES = '/phase/';
      var PlantingSchedulePlantingInformationService = {};
      var work_templates = [
        {
          id: 0, location: 'loc 1', shipper: 'Dole', wet_date: moment('2019-12-19').format('ddd, MMM D'), seed: 'Iceberg Lettuce', variety: 'HHA', acres: 35.6,
          bed_count: 100, bed_size: 'bed size 1', seed_spacing: 'seed spacing 2', number_of_lines: 10, planting_date: moment('2017-12-19').format('ddd, MMM D'),
          parent_id: 0
        },
        {
          id: 1, location: 'loc 1', shipper: 'Dole', wet_date: moment('2019-12-19').format('ddd, MMM D'), seed: 'Iceberg Lettuce', variety: 'HHA', acres: 35.6,
          bed_count: 100, bed_size: 'bed size 1', seed_spacing: 'seed spacing 1', number_of_lines: 10, planting_date: moment('2019-12-19').format('ddd, MMM D'),
          parent_id: 0
        },
        {
          id: 2, location: 'loc 1', shipper: 'Dole', wet_date: moment('2019-12-19').format('ddd, MMM D'), seed: 'Iceberg Lettuce', variety: 'HHA', acres: 35.6,
          bed_count: 100, bed_size: 'bed size 1', seed_spacing: 'seed spacing 3', number_of_lines: 10, planting_date: moment('2019-12-19').format('ddd, MMM D'),
          parent_id: 0
        },
        {
          id: 3, location: 'loc 1', shipper: 'Dole', wet_date: moment('2019-12-19').format('ddd, MMM D'), seed: 'Iceberg Lettuce', variety: 'HHA', acres: 35.6,
          bed_count: 100, bed_size: 'bed size 1', seed_spacing: 'seed spacing 1', number_of_lines: 10, planting_date: moment('2019-12-19').format('ddd, MMM D'),
          parent_id: 1
        },
        {
          id: 4, location: 'loc 1', shipper: 'Dole', wet_date: moment('2019-12-19').format('ddd, MMM D'), seed: 'Iceberg Lettuce', variety: 'HHA', acres: 35.6,
          bed_count: 100, bed_size: 'bed size 1', seed_spacing: 'seed spacing 2', number_of_lines: 10, planting_date: moment('2019-12-19').format('ddd, MMM D'),
          parent_id: 2
        },
        {
          id: 5, location: 'loc 1', shipper: 'Dole', wet_date: moment('2019-12-19').format('ddd, MMM D'), seed: 'Iceberg Lettuce', variety: 'HHA', acres: 35.6,
          bed_count: 100, bed_size: 'bed size 1', seed_spacing: 'seed spacing 3', number_of_lines: 10, planting_date: moment('2019-12-19').format('ddd, MMM D'),
          parent_id: 3
        },

      ];

      var _ = window._;

      PlantingSchedulePlantingInformationService.selectedWorkTemplate = {};

      /**
       * Get planting schedule planting information.
       * @return {[type]}      [description]
      */
      PlantingSchedulePlantingInformationService.get = function () {
        var deferred = $q.defer();

        setTimeout(function () {
          deferred.resolve(work_templates);
        }, 2000);

        return deferred.promise;
      };

      /**
       * Get planting schedule planting information with offset.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
      */
      PlantingSchedulePlantingInformationService.getPlantingSchedulePlantingInformationWithOffset = function (offset, limit) {
        var deferred = $q.defer();

        setTimeout(function () {
          deferred.resolve(_.take(_.drop(work_templates, offset), limit));
        }, 2000);

        return deferred.promise;

      };

      /**
       * Function to save a planting schedule planting information.
       * @param  {[type]} phase [description]
       * @return {[type]}       [description]
      */
      PlantingSchedulePlantingInformationService.save = function (phase) {
        //var self = this;
        var deferred = $q.defer();

        setTimeout(function () {
          phase.id = work_templates.length + 1;
          work_templates.push(phase);
          deferred.resolve(phase);
        }, 500);

        return deferred.promise;
      };

      /**
       * Function to update a planting schedule planting information.
       * @param  {[type]} wk  [description]
       * @return {[type]}     [description]
      */
      PlantingSchedulePlantingInformationService.update = function (wk) {
        var deferred = $q.defer();

        setTimeout(function () {
          var index = _.findIndex(work_templates, function (w) {
            return w.id == wk.id;
          });

          _.assign(work_templates[index], wk);

          deferred.resolve();
        }, 2000);

        return deferred.promise;
      };

      /**
       * Function to delete multiple planting schedule planting information.
       * @param  {[type]} _tasks [description]
       * @return {[type]}        [description]
      */
      PlantingSchedulePlantingInformationService.bulkDelete = function (_tasks) {
        var deferred = $q.defer();


        setTimeout(function () {
          _tasks.forEach(function (_id) {
            _.remove(work_templates, {
              id: _id
            });
          });

          deferred.resolve(work_templates);
        }, 500);

        return deferred.promise;
      };

      PlantingSchedulePlantingInformationService.setSelected = function (wk) {
        PlantingSchedulePlantingInformationService.selectedWorkTemplate = wk;
      };


      /**
       * Function to delete a planting schedule planting information.
       * @param  {[type]} phase [description]
       * @return {[type]}       [description]
      */
      PlantingSchedulePlantingInformationService.delete = function (phase) {
        var deferred = $q.defer();

        setTimeout(function () {
          _.remove(work_templates, {
            id: phase.id
          });
          deferred.resolve(work_templates);
        }, 500);

        return deferred.promise;
      };

      return PlantingSchedulePlantingInformationService;
    });
})();
(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('PlantingScheduleBlockInformationService', function ($http, $q) {
      /* Use entity var without trailing slash */
      //var entity = '/phase';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      //var entityES = '/phase/';
      var PlantingScheduleBlockInformationService = {};
      var work_templates = [
        {
          id: 0, block_bed_count: 100, bed_size: 'Multiple', bed_direction: 'N-S', block_confirmed_by: 'John Thompson', bed_notes: 'notes example',
          planting_block_confirmed_by: 'John Thompson', planting_block_confirmed_date: moment('2016-12-19').format('ddd, MMM D'), planting_notes: 'planting notes example 123',
          farm_block_confirmed_by: 'John Thompson', farm_block_confirmed_date: moment('2017-12-14').format('ddd, MMM D'), farm_notes: 'farm notes example',
          parent_id: 0
        },
        {
          id: 1, block_bed_count: 100, bed_size: 'Multiple', bed_direction: 'N-S', block_confirmed_by: 'John Thompson', bed_notes: 'notes example',
          planting_block_confirmed_by: 'name3', planting_block_confirmed_date: moment('2016-12-19').format('ddd, MMM D'), planting_notes: 'planting notes example',
          farm_block_confirmed_by: 'John Thompson', farm_block_confirmed_date: moment('2017-12-19').format('ddd, MMM D'), farm_notes: 'farm notes example',
          parent_id: 1
        },
        {
          id: 2, block_bed_count: 100, bed_size: 'Multiple', bed_direction: 'N-S', block_confirmed_by: 'John Thompson', bed_notes: 'notes example',
          planting_block_confirmed_by: 'name3', planting_block_confirmed_date: moment('2016-12-19').format('ddd, MMM D'), planting_notes: 'planting notes example',
          farm_block_confirmed_by: 'name2', farm_block_confirmed_date: moment('2017-12-19').format('ddd, MMM D'), farm_notes: 'farm notes example',
          parent_id: 2
        },
        {
          id: 3, block_bed_count: 100, bed_size: 'Multiple', bed_direction: 'N-S', block_confirmed_by: 'John Thompson', bed_notes: 'notes example',
          planting_block_confirmed_by: 'name2', planting_block_confirmed_date: moment('2016-12-19').format('ddd, MMM D'), planting_notes: 'planting notes example',
          farm_block_confirmed_by: 'name3', farm_block_confirmed_date: moment('2017-12-19').format('ddd, MMM D'), farm_notes: 'farm notes example',
          parent_id: 3
        },

      ];

      var _ = window._;

      PlantingScheduleBlockInformationService.selectedWorkTemplate = {};

      /**
       * Get planting schedule block information.
       * @return {[type]}      [description]
      */
      PlantingScheduleBlockInformationService.get = function () {
        var deferred = $q.defer();

        setTimeout(function () {
          deferred.resolve(work_templates);
        }, 2000);

        return deferred.promise;
      };

      /**
       * Get planting schedule block information with offset.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
      */
      PlantingScheduleBlockInformationService.getPlantingScheduleBlockInformationWithOffset = function (offset, limit) {
        var deferred = $q.defer();

        setTimeout(function () {
          deferred.resolve(_.take(_.drop(work_templates, offset), limit));
        }, 2000);

        return deferred.promise;

      };

      /**
       * Function to save a planting schedule block information.
       * @param  {[type]} phase [description]
       * @return {[type]}       [description]
      */
      PlantingScheduleBlockInformationService.save = function (phase) {
        //var self = this;
        var deferred = $q.defer();

        setTimeout(function () {
          phase.id = work_templates.length + 1;
          work_templates.push(phase);
          deferred.resolve(phase);
        }, 500);

        return deferred.promise;
      };

      /**
       * Function to update a planting schedule block information.
       * @param  {[type]} wk  [description]
       * @return {[type]}     [description]
      */
      PlantingScheduleBlockInformationService.update = function (wk) {
        var deferred = $q.defer();

        setTimeout(function () {
          var index = _.findIndex(work_templates, function (w) {
            return w.id == wk.id;
          });

          _.assign(work_templates[index], wk);

          deferred.resolve();
        }, 2000);

        return deferred.promise;
      };

      /**
       * Function to delete multiple planting schedule block information.
       * @param  {[type]} _tasks [description]
       * @return {[type]}        [description]
      */
      PlantingScheduleBlockInformationService.bulkDelete = function (_tasks) {
        var deferred = $q.defer();


        setTimeout(function () {
          _tasks.forEach(function (_id) {
            _.remove(work_templates, {
              id: _id
            });
          });

          deferred.resolve(work_templates);
        }, 500);

        return deferred.promise;
      };

      PlantingScheduleBlockInformationService.setSelected = function (wk) {
        PlantingScheduleBlockInformationService.selectedWorkTemplate = wk;
      };


      /**
       * Function to delete a planting schedule block information.
       * @param  {[type]} phase [description]
       * @return {[type]}       [description]
      */
      PlantingScheduleBlockInformationService.delete = function (phase) {
        var deferred = $q.defer();

        setTimeout(function () {
          _.remove(work_templates, {
            id: phase.id
          });
          deferred.resolve(work_templates);
        }, 500);

        return deferred.promise;
      };

      return PlantingScheduleBlockInformationService;
    });
})();
(function () {
  'use strict';

  angular
    .module('app.services')
    .factory('PlantingScheduleService', function ($http, $q) {
      /* Use entity var without trailing slash */
      //var entity = '/phase';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      //var entityES = '/phase/';
      var plantingScheduleService = {};
      var work_templates = [
        {
          id: 0, shipper: 'Dole', wet_date: moment('2017-02-02').format('ddd, MMM D'), block: 'R12A', seed: 'Iceberg Lettuce', variety: 'HHA',
          acres: 105, planting_date: moment('2017-03-31').format('ddd, MMM D'), bed_count: 100,
          bed_status: 'Not Shaped', planting_status: 'Planted - Pending', starred: true,
        },
        {
          id: 1, shipper: 'DoleB', wet_date: moment('2017-02-02').format('ddd, MMM D'), block: 'R10B', seed: 'Iceberg Lettuce', variety: 'HHA',
          acres: 13, planting_date: moment('2017-03-31').format('ddd, MMM D'), bed_count: 100,
          bed_status: 'Not Shaped', planting_status: 'Planted - Grower Approved', starred: true,
        },
        {
          id: 2, shipper: 'DoleC', wet_date: moment('2017-02-02').format('ddd, MMM D'), block: 'R16C', seed: 'Iceberg Lettuce', variety: 'HHC',
          acres: 64, planting_date: moment('2017-03-31').format('ddd, MMM D'), bed_count: 100,
          bed_status: 'Shaped - Approved', planting_status: 'Planted - Pending', starred: false,
        },
        {
          id: 3, shipper: 'DoleD', wet_date: moment('2017-02-02').format('ddd, MMM D'), block: 'R13D', seed: 'Iceberg Lettuce', variety: 'HHD',
          acres: 133, planting_date: moment('2017-03-31').format('ddd, MMM D'), bed_count: 100,
          bed_status: 'Not Shaped', planting_status: 'Planted - Pending', starred: false,
        },
      ];

      var _ = window._;

      plantingScheduleService.selectedWorkTemplate = {};

      /**
       * Get planting schedules.
       * @return {[type]}      [description]
      */
      plantingScheduleService.get = function () {
        var deferred = $q.defer();

        setTimeout(function () {
          deferred.resolve(work_templates);
        }, 2000);

        return deferred.promise;
      };

      /**
       * Get planting schedules with offset
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
      */
      plantingScheduleService.getPlantingScheduleWithOffset = function (offset, limit) {
        var deferred = $q.defer();

        setTimeout(function () {
          deferred.resolve(_.take(_.drop(work_templates, offset), limit));
        }, 2000);

        return deferred.promise;

      };

      /**
       * Function to save a planting schedule
       * @param  {[type]} phase [description]
       * @return {[type]}       [description]
      */
      plantingScheduleService.save = function (phase) {
        //var self = this;
        var deferred = $q.defer();

        setTimeout(function () {
          phase.id = work_templates.length + 1;
          work_templates.push(phase);
          deferred.resolve(phase);
        }, 500);

        return deferred.promise;
      };

      /**
       * Function to update a planting schedule.
       * @param  {[type]} wk  [description]
       * @return {[type]}     [description]
      */
      plantingScheduleService.update = function (wk) {
        var deferred = $q.defer();

        setTimeout(function () {
          var index = _.findIndex(work_templates, function (w) {
            return w.id == wk.id;
          });

          _.assign(work_templates[index], wk);

          deferred.resolve();
        }, 2000);

        return deferred.promise;
      };

      /**
       * Function to delete multiple planting schedules.
       * @param  {[type]} _tasks [description]
       * @return {[type]}        [description]
      */
      plantingScheduleService.bulkDelete = function (_tasks) {
        var deferred = $q.defer();


        setTimeout(function () {
          _tasks.forEach(function (_id) {
            _.remove(work_templates, {
              id: _id
            });
          });

          deferred.resolve(work_templates);
        }, 500);

        return deferred.promise;
      };

      plantingScheduleService.setSelected = function (wk) {
        plantingScheduleService.selectedWorkTemplate = wk;
      };


      /**
       * Function to delete a planting schedule.
       * @param  {[type]} phase [description]
       * @return {[type]}       [description]
      */
      plantingScheduleService.delete = function (phase) {
        var deferred = $q.defer();

        setTimeout(function () {
          _.remove(work_templates, {
            id: phase.id
          });
          deferred.resolve(work_templates);
        }, 500);

        return deferred.promise;
      };

      return plantingScheduleService;
    });
})();
(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('PhaseService', function ($http, $sessionStorage, $q) {
    //var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    //var entity = '/phase';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    //var entityES = '/phase/';
    var phaseService = {};
    var phases = [
      {name: 'Phase 1', id: 1, work_schedule_type_id: 1, color: generateColor(),tasks:[]},
      {name: 'Phase 2', id: 2, work_schedule_type_id: 1, color: generateColor(),tasks:[]},
      {name: 'Phase 3', id: 3, work_schedule_type_id: 1, color: generateColor(),tasks:[]},
      {name: 'Phase 4', id: 4, work_schedule_type_id: 2, color: generateColor(),tasks:[]},
      {name: 'Phase 5', id: 5, work_schedule_type_id: 2, color: generateColor(),tasks:[]},
      {name: 'Phase 6', id: 6, work_schedule_type_id: 1, color: generateColor(),tasks:[]},
      {name: 'Phase 7', id: 7, work_schedule_type_id: 1, color: generateColor(),tasks:[]},
      {name: 'Phase 8', id: 8, work_schedule_type_id: 3, color: generateColor(),tasks:[]}
    ];


    phases.forEach(function (p) {
      p.tasks = [];
    });

    var _ = window._;

    /**
     * Function to delete an company.
     * @param  {[generateColor]}
     */
    function generateColor() {

      var letters = '0123456789ABCDEF';
      var color = '#';
      for (var i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)];
      }
      return color;
    }

    phaseService.generateColor = generateColor;

    phaseService.get = function () {
      var deferred = $q.defer();

      phases.forEach(function (p) {
        p.tasks = [];
      });

      setTimeout(function () {
        deferred.resolve(phases);
      }, 2000);

      return deferred.promise;
    };

    phaseService.save = function (phase) {
      //var self = this;
      var deferred = $q.defer();

      setTimeout(function () {
        phase.id = phases.length + 1;
        phases.push(phase);
        deferred.resolve();
      }, 500);

      return deferred.promise;
    };


    phaseService.update = function () {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve();
      }, 2000);

      return deferred.promise;
    };


    phaseService.getByType = function (typeId) {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve(phases.filter(function (p) {
          return p.work_schedule_type_id == typeId;
        }));
      }, 2000);

      return deferred.promise;
    };

    phaseService.delete = function (phase) {
      var deferred = $q.defer();

      setTimeout(function () {
        _.remove(phases, {
          id: phase.id
        });
        deferred.resolve(phase);
      }, 500);

      return deferred.promise;
    };

    return phaseService;
  });
})();
(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('PageSettingService', function ($http, API) {
    // var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                           = '/page_settings';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                         = '/page_settings/';
    var getAllPageActionsByEntity        = '/page_settings/get_all_page_actions_by_entity';
    var getAllPrivilegesOrRolesByPage    = '/page_settings/get_all_privileges_or_roles_by_page';

    var pageSettingService = {};
      /**
       * Function to create a new page.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
    pageSettingService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to update an page.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    pageSettingService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to patch an page.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    pageSettingService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to delete an page.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    pageSettingService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to get all the pages_settings
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    pageSettingService.getList = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to get all page actions from a given entity (user_role, privilege or page.)
     *
     * Possible parameters:
     *   - entity: The entity (user_role, privilege or page)
     *   - id: The id of the given entity to be searched.
     *   
     *   ! arrParams will take just the values, you should pass as follows:
     *     - Example: ['user_role_id', 1] !! Note !! that the id id the entity id you're passing.
     * 
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    pageSettingService.getAllPageActionsByEntity = function (arrParams) {
      var formattedParams = '/' + arrParams.join('/');
      return $http
        .get(API.url + getAllPageActionsByEntity + formattedParams)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to get all the privileges or roles from a given page.
     *
     * Possible parameters:
     *   - entity: The entity (user_role or privilege)
     *   - page_id: The page_id to be searched.
     *
     *   ! arrParams will take just the values, you should pass as follows:
     *     - Example: ['user_role_id', 1]
     * 
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    pageSettingService.getAllPrivilegesOrRolesByPage = function (arrParams) {
      var formattedParams = '/' + arrParams.join('/');
      return $http
        .get(API.url + getAllPrivilegesOrRolesByPage + formattedParams)
        .then(function (res) {
          return res.data;
        });
    };

    return pageSettingService;
  });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('PageActionService', function ($http, API) {
    // var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                           = '/page_actions';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                         = '/page_actions/';

    var pageActionService = {};
      /**
       * Function to create a new page.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
    pageActionService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to update an page.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    pageActionService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to patch an page.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    pageActionService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to delete an page.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    pageActionService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to get all the pages_actions
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    pageActionService.getList = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    return pageActionService;
  });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('PageService', function ($http, API) {
    // var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/pages';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/pages/';
    var sectionsPath            = '/pages/sections';

    var pageService = {};
      /**
       * Function to create a new page.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
    pageService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to update an page.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    pageService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to patch an page.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    pageService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to delete an page.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    pageService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to delete multile pages.
       * @param  {[type]} id
       * @return {[type]}
       *
       * TODO: add query string to bulk delete.
       */
    pageService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
        .delete(API.url + entity + '/bulk?ids=' + ids)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to get all the pages
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    pageService.getList = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to get all the sections
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    pageService.getSectionsList = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + sectionsPath, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    return pageService;
  });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('NotifyGroupService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity            = '/notify_groups';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES          = '/notify_groups/';
      var notifyGroupService  = {};


      /**
       * Get all roles
       */
      notifyGroupService.getList = function (parameters) {
        var params = {};
        if (parameters) {
          params = parameters;
        }
        return $http
        .get(API.url + entity, {params: params})
        .then(function (res) {
          if (res) {
            return res.data;
          }
        });
      };
      /**
       * Function to create a new notify-group.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      notifyGroupService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      /**
       * Function to update an notify-group.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      notifyGroupService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      /**
       * Function to delete an notify-group.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
      notifyGroupService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      /**
       * Function to delete multile notify-groups.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       *
       * TODO: add query string to bulk delete.
       */ 
      notifyGroupService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      return notifyGroupService;
    });
})();
(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('ModuleService', function ($http, API) {
    // var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/modules';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/modules/';

    var moduleService = {};

    /**
     * Function to get module.
     *
     * @return {[type]}      [description]
     */
    moduleService.getModule = function (id) {
      return $http
      .get(API.url + entityES + id)
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * Function to get module by sort.
     *
     * @return {[type]}      [description]
     */
    moduleService.getModuleBySort = function (sort) {
      return $http
      .get(API.url + entityES + '/get_by_sort/' + sort)
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * Function to create a new module.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    moduleService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to update an module.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    moduleService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to patch an module.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    moduleService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to patch an module.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    moduleService.patchSort = function (id, fields) {
      return $http
        .patch(API.url + entityES + id + '/sort', fields)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to delete an module.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    moduleService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };
      /**
       * Function to delete multile modules.
       * @param  {[type]} id
       * @return {[type]}
       *
       * TODO: add query string to bulk delete.
       */
    moduleService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
        .delete(API.url + entity + '/bulk?ids=' + ids)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to get all the modules
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    moduleService.getList = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity, {params: params})
        .then(function (res) {
          if(res && res.hasOwnProperty('data')) {
            return res.data;
          }
        });
    };

   /**
    * Add page relation to module.
    *
    * @param {Number} module_id / The module id to search
    * @param {Number} page_id   / The page id to search.
    * @return {Object} / Object with information of the status of the operation.
    */
    moduleService.moduleAddPageRelation = function (moduleId, pageId) {
      return $http
      .put(API.url + entityES + moduleId + '/add_page/' + pageId)
      .then(function (res) {
        if(res) {
          return res.data;
        }
      });
    };

   /**
    * Remove page relation from module.
    *
    * @param {Number} module_id / The module id to search
    * @param {Number} page_id   / The page id to search.
    * @return {Object} / Object with information of the status of the operation.
    */
    moduleService.moduleRemovePageRelation = function (moduleId, pageId) {
      return $http
      .delete(API.url + entityES + moduleId + '/remove_page/' + pageId)
      .then(function (res) {
        if(res) {
          return res.data;
        }
      });
    };

    /**
     * Add role relation to module.
     *
     * @param {Number} module_id / The module id to search
     * @param {Number} role_id   / The role id to search.
     * @return {Object} / Object with information of the status of the operation.
     */
    moduleService.moduleAddRoleRelation = function (moduleId, roleId) {
      return $http
       .put(API.url + '/module_access/' + moduleId + '/add_role/' + roleId)
       .then(function (res) {
         if(res) {
           return res.data;
         }
       });
    };

    /**
     * Remove role relation from module.
     *
     * @param {Number} module_id / The module id to search
     * @param {Number} role_id   / The role id to search.
     * @return {Object} / Object with information of the status of the operation.
     */
    moduleService.moduleRemoveRoleRelation = function (moduleId, roleId) {
      return $http
       .delete(API.url + '/module_access/' + moduleId + '/remove_role/' + roleId)
       .then(function (res) {
         if(res) {
           return res.data;
         }
       });
    };

    return moduleService;
  });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('LocationService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/locations';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/locations/';

    var locationService = {};
    /**
     * Function to get all locations.
     * @return {[type]}      [description]
     */
    locationService.getAll = function () {
      return $http
      .get(API.url + entity)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to create a new location.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    locationService.create = function (data) {
      return $http
      .post(API.url + entity +'/create', data)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to update a location.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    locationService.update = function (id, data) {
      return $http
      .put(API.url + entityES + id, data)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to patch a location.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    locationService.patch = function (id, field) {
      return $http
      .patch(API.url + entityES + id, field)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to delete a location.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    locationService.delete = function (id) {
      return $http
      .delete(API.url + entityES + id)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to delete multiple locations.
     * @param  {[type]} id
     * @return {[type]}
     *
     * TODO: add query string to bulk delete.
     */
    locationService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
      .delete(API.url + entity + '/bulk?ids=' + ids)
      .then(function (res) {
        return res.data;
      });
    };

        /**
     * Function to get location.
     * @return {[type]}      [description]
     */
    locationService.getLocation = function (id) {
      return $http
      .get(API.url + entityES + id)
      .then(function (res) {
        return res.data;
      });
    };


    return locationService;
  });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('LeasePaymentScheduleService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity                  = '/lease_payment_schedules';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES                = '/lease_payment_schedules/';

      var leasePaymentScheduleService = {};
      /**
       * Function to create a new lease payment schedule.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      leasePaymentScheduleService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update an lease payment schedule.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      leasePaymentScheduleService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to patch an lease payment schedule.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      leasePaymentScheduleService.patch = function (id, data) {
        return $http
          .patch(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete an lease payment schedule.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      leasePaymentScheduleService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete multile leases.
       * @param  {[type]} id
       * @return {[type]}
       *
       * TODO: add query string to bulk delete.
       */
      leasePaymentScheduleService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to get all lease payment schedule.
       * @param  {[type]} parameters [description]
       * @return {[type]}
       */
      leasePaymentScheduleService.getAll = function (parameters) {
        var params = {};
        if (parameters) {
          params = parameters;
        }
        return $http
          .get(API.url + entity, {params: params})
          .then(function (res) {
            return res.data;
          });
      };

      return leasePaymentScheduleService;
    });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('LeaseService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/leases';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/leases/';
    var paymentTerms            = '/all/payment_terms';
    var leaseDocuments          = '/lease_documents';
    var blocksES                  = '/blocks/';
    var savedFilterData         = {};
    var savedLeaseBlockData     = {};
    var leaseService = {};


    /**
      * Function to create a new lease.
      * @param  {[type]} data [description]
      * @return {[type]}      [description]
    */
    leaseService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
      * Function to update an lease.
      * @param  {[type]} id [description]
      * @return {[type]}    [description]
    */
    leaseService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
      * Function to patch an lease.
      * @param  {[type]} id [description]
      * @return {[type]}    [description]
    */
    leaseService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          return res.data;
        });
    };
    /**
      * Function to delete an lease.
      * @param  {[type]} id [description]
      * @return {[type]}    [description]
    */
    leaseService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };
    /**
      * Function to delete multile leases.
      * @param  {[type]} id
      * @return {[type]}
      *
      * TODO: add query string to bulk delete.
    */
    leaseService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
        .delete(API.url + entity + '/bulk?ids=' + ids)
        .then(function (res) {
          return res.data;
        });
    };

    /**
      * Function to get payment terms.
      * @param  {[type]} data [description]
      * @return {[type]}      [description]
    */
    leaseService.getPaymentTerms = function () {
      return $http
        .get(API.url + entity + paymentTerms)
        .then(function (res) {
          return res.data;
        });
    };

    /**
      * Function to get lease documents.
      * @param  {[type]} data [description]
      * @return {[type]}      [description]
    */
    leaseService.getDocuments = function (id) {
      return $http
        .get(API.url + entityES + id + leaseDocuments + '?limit=' + 999999)
        .then(function (res) {
          return res.data;
        });
    };

          /**
     * Function to get payment terms.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    leaseService.getAllActiveLeases = function () {
      return $http
        .get(API.url + entity  + '?state=active' + '&sublease=' + false + '&limit=' + 999999)
        .then(function (res) {
          return res.data;
        });
    };

          /**
     * Function to assign block to lease
     * [assignBlock description]
     * @param  {[type]} leaseId [description]
     * @param  {[type]} blockId [description]
     * @return {[type]}         [description]
     */
    leaseService.assignBlock = function (leaseId, blockId, data) {
      return $http
         .put(API.url + entityES + leaseId + blocksES + blockId, data)
         .then(function (res) {
           return res.data;
         });
    };

    /**
     * Function to unassign block to lease
     * @param  {[type]} leaseId [description]
     * @param  {[type]} blockId [description]
     * @return {[type]}         [description]
     */
    leaseService.unassignBlock = function (leaseId, blockId) {
      return $http
         .delete(API.url + entityES + leaseId + blocksES + blockId)
         .then(function (res) {
           return res.data;
         });
    };

    /**
     * get lease blocks
     * @param  {[type]} id   [description]
     * @param  {[type]} type [description]
     * @return {[type]}      [description]
     */
    leaseService.getBlocks = function (id,type) {
      return $http
        .get(API.url + entityES + id + '/blocks/' + type)
        .then(function (res) {
          return res.data;
        });
    };

              /**
     * Function to get all leases
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    leaseService.getAllLeases = function () {
      return $http
        .get(API.url + entity)
        .then(function (res) {
          return res.data;
        });
    };


    /**
     * Function to get leases filtered by state
     * @param  {[type]} state    [description]
     * @param  {[type]} area     [description]
     * @return {[type]}          [description]
     */
    leaseService.getStateFilteredLeases = function (state) {
      return $http
        .get(API.url + entity + '?state=' + state + '&limit=' + 999999)
        .then(function (res) {
          return res.data;
        });
    };

/**
 * [description]
 * @param  {[type]} parameters [description]
 * @return {[type]}            [description]
 */
    leaseService.getLeasesWithOffset = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity,  {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * [patch description]
     * @param  {[type]} id    [description]
     * @param  {[type]} data  [description]
     * @return {[type]}       [description]
     */
    leaseService.patchAssociatedBlock = function (id, data) {
      return $http
        .patch(API.url + entityES + 'lease_block/' + id, data)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * [saveFilterData description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    leaseService.saveFilterData =function (data) {
      savedFilterData = data;
    };

    /**
     * [getFilterData description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    leaseService.getFilterData =function () {
      return savedFilterData;
    };

        /**
     * [saveLeaseBlockData description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    leaseService.saveLeaseBlockData =function (data) {
      savedLeaseBlockData = data;
    };

    /**
     * [getLeaseBlockData description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    leaseService.getLeaseBlockData =function () {
      return savedLeaseBlockData;
    };


    return leaseService;
  });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('LandService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      var entity = '/areas';
      var entityES = '/areas/';
      var entityLocation = '/location';
      var entityLocationES = '/location/';
      var entityLocations = '/locations';
      var entityRanchES = '/ranch/';
      var entityRanch = '/ranch';
      var entityRanches = '/ranches';
      var landService = {};

      /**
       *  Function to get location area 
       */
      landService.getLocations = function (id) {
        return $http
          .get(API.url + entityES + id + entityLocations)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       *  Function to get section area 
       */
      landService.getSections = function (id) {
        return $http
          .get(API.url + entityES + id + entityRanches)
          .then(function (res) {
            return res.data;
          });
      };  
      /**
       * Function to create a new area.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      landService.createArea = function (data) {
        return $http
          .post(API.url + entity + '/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to create a new location.
       * @param  {[type]} areaId [description]
       * @return {[type]}      [description]
       */
      landService.createLocation = function (id, data) {
        return $http
          .post(API.url + entityES + id + entityLocation, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to create a new location.
       * @param  {[type]} areaId [description]
       * @return {[type]}      [description]
       */
      landService.createSection = function (id, data) {
        return $http
          .post(API.url + entityES + id + entityRanch + '/create', data)
          .then(function (res) {
            return res.data;
          });
      };       
      /**
       * Function to update an area.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      landService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update an location.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      landService.updateLocation = function (id, data) {
        return $http
          .put(API.url + entity + entityLocationES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update an section.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      landService.updateSection = function (id, data) {
        return $http
          .put(API.url + entity + entityRanchES + id, data)
          .then(function (res) {
            return res.data;
          });
      };      
      /**
       * Function to delete an area.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
      landService.deleteArea = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete an location.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
      landService.deleteLocation = function (id) {
        return $http
          .delete(API.url + entity + entityLocationES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete an section
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
      landService.deleteSection = function (id) {
        return $http
          .delete(API.url + entity + entityRanchES + id)
          .then(function (res) {
            return res.data;
          });
      };
      return landService;
    });
})();
(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('GrowerService', function () {
    //var API = {url: $sessionStorage.apiUrl};
    /* Use entity var without trailing slash */
    //var entity = '/workScheduleType';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    //var entityES = '/workScheduleType/';
    var growerService = {};

    growerService.getGrowerSchedules = function () {
      return [
        {
          id: 1,
          block_name: 'R12A',
          bed_size: 5,
          block_bed_count: 2,
          acres_in_block: 100,
          company_id: 1,
          seed_name: '',
          scheduled_irrigation_date: null,
          scheduled_tillage_date: null,
          scheduled_pre_water_date: null,
          scheduled_growing_date: null,
          scheduled_wet_date: moment('2017-09-22 12:00'),
          original_harvest_date: moment('2017-12-22 12:00'),
          last_harvest_date: moment('2017-09-20 12:00')._d,
          location_id: 2,
          variety_name: '',
          scheduled_acres: 0,
          beds: 0,
          growing_days: 0,
          plant_lines: 5,
          pca_id: null,
          hasSubBlock: false,
          isSubBlock: false,
          subBlockOf: 1,
          block_bed_direction_id: 1,
          block_number_of_locations_in_bed: 1, // aux value: number of subblocks and locations
          grower_schedule_sublocation: {
            'id': 1,
            'block_bed_direction_id': 1,
            'name': 'All',
            'number_of_locations_in_bed': 1,
            'location_order_number': 1
          }
        },
        {
          id: 2,
          block_name: 'R12B',
          bed_size: null,
          acres_in_block: 25.4,
          company_id: 1,
          seed_name: '',
          scheduled_irrigation_date: null,
          scheduled_tillage_date: null,
          scheduled_pre_water_date: null,
          scheduled_growing_date: null,
          scheduled_wet_date: moment('2017-09-22 12:00'),
          original_harvest_date: moment('2017-12-22 12:00'),
          last_harvest_date: moment('2017-09-20 12:00')._d,
          location_id: 3,
          variety_name: '',
          scheduled_acres: 0,
          beds: 0,
          growing_days: 0,
          plant_lines: null,
          pca_id: null,
          hasSubBlock: false,
          isSubBlock: false,
          subBlockOf: 2,
          block_bed_direction_id: 2,
          block_number_of_locations_in_bed: 1, // aux value: number of subblocks and locations
          grower_schedule_sublocation: {
            'id': 37,
            'block_bed_direction_id': 2,
            'name': 'All',
            'number_of_locations_in_bed': 1,
            'location_order_number': 1
          }
        }
      ];


    };

    return growerService;
  });
})();

(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('GrowerScheduleService', function ($http, $sessionStorage)  {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/grower_schedules';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/grower_schedules/';
    var saveMultiple            = '/save_multiple_grower';

    var growerScheduleService = {};
    var savedData             = {};

    /**
     * Function to create a new Grower Schedule.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    growerScheduleService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to bulk create/update Grower Schedules.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    growerScheduleService.saveMultiple = function (data, parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .post(API.url + entity + saveMultiple, data, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to delete a Grower Schedule.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    growerScheduleService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * [description]
     * @param  {[type]} contract_schedule_variety_id [description]
     * @return {[type]}                              [description]
     */
    growerScheduleService.getVarietyWetDates = function(contract_schedule_variety_id) {
      return $http
      .get(API.url + entity + '/grower_variety/' + contract_schedule_variety_id)
      .then(function (res) {
        return res.data;
      });
    };


    /**
     * Get all grower schedules for reports
     * @param  {[type]} offset           [description]
     * @param  {[type]} limit            [description]
     * @param  {[type]} fiscalYearId     [description]
     * @param  {[type]} byWetDate        [description]
     * @param  {[type]} periodStart      [description]
     * @param  {[type]} periodEnd        [description]
     * @param  {[type]} shipperCompanyId [description]
     * @param  {[type]} pcaUserId        [description]
     * @param  {[type]} blockId          [description]
     * @param  {[type]} ranchId          [description]
     * @param  {[type]} locationId       [description]
     * @param  {[type]} seasonId         [description]
     * @param  {[type]} weekEnding       [description]
     * @return {[type]}                  [description]
     */
    growerScheduleService.getAllForReports = function (offset, limit, fiscalYearId, byWetDate, periodStart, periodEnd, shipperCompanyId, pcaUserId, blockId, ranchId, locationId, seasonId, weekEnding) {
      return $http
        .get(API.url + entityES + '?fiscal_year_id=' + fiscalYearId + '&limit=' + limit + '&offset=' + offset + '&for_reports=true' + '&by_wet_date=' + byWetDate + '&period_start=' + periodStart
                     + '&period_end=' + periodEnd + '&shipper_company_id=' + shipperCompanyId +  '&pca_user_id=' + pcaUserId +  '&block_id=' + blockId +  '&ranch_id=' + ranchId
                     + '&location_id=' + locationId + '&season_id=' + seasonId + '&week_ending=' + weekEnding)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * [description]
     * @return {[type]} [description]
     */
    growerScheduleService.getAllAssociatedShippers = function () {
      return $http
      .get(API.url + entity + '/all/associated_shippers')
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * [description]
     * @return {[type]} [description]
     */
    growerScheduleService.getAllAssociatedPcaUsers = function () {
      return $http
      .get(API.url + entity + '/all/associated_pcaUsers')
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * [description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    growerScheduleService.saveData =function (data) {
      savedData = data;
    };

   /**
    * [description]
    * @return {[type]} [description]
    */
    growerScheduleService.getData =function () {
      return savedData;
    };

    return growerScheduleService;
  });
})();

(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('GrowerBlockService', function ($http, $sessionStorage)  {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/grower_blocks';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/grower_blocks/';
    var saveChilds              = 'save_childs';

    var growerBlockService = {};

    /**
     * [description]
     * @return {[type]}
     */
    growerBlockService.getAll = function(parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
      .get(API.url + entity, {params: params})
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * Function to create a new Grower Block.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    growerBlockService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to delete a Grower Block.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    growerBlockService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to bulk save Grower Blocks.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    growerBlockService.saveChilds = function () {
      return $http
        .delete(API.url + entityES + saveChilds)
        .then(function (res) {
          return res.data;
        });
    };

    return growerBlockService;
  });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('GeneralFunctionsService', function (moment, _) {
    var service = {
      calculateGrowingDays        : calculateGrowingDays,
      dateIsBetween               : dateIsBetween,
      filterVarietiesByWetDate    : filterVarietiesByWetDate,
      filterVarietyDatesByLocation: filterVarietyDatesByLocation
    };

    return service;

    //////////

    /**
     * Calculate Wet Date, Harvest Date and Growing Days
     *
     * Requirement:
     * - Growing day should be between Wet Date and Harvest Date
     * - If those dates are set and Growing day change the harvest date should be calculated
     * - If harvest date and growing days are set wet date should be calculated
     * - If wet date and harvest date are set, growing days should be calculated.
     *
     * @param  {[type]} changedField [one of 'wet_date', 'harvest_date' or 'growing_days']
     * @param  {[type]} wet_date [Wet Date value]
     * @param  {[type]} harvest_date [Harvest Date value]
     * @param  {[type]} growing_days [Growing Days value]
     * @return {[type]}
     */
    function calculateGrowingDays(changedField, wet_date, harvest_date, growing_days) {
      var wet = null;
      var harvest = null;
      var growing = null;
      // if wet_date has changed, check if one of other fields exists to calculate the last one
      if (changedField === 'wet_date' && wet_date) {
        wet = moment(wet_date);
        // check harvest_date
        if (harvest_date) {
          // when wet_date is selected and it's greater than harvest_date it is assigned to it
          // but in ISOString format instead normal JS date
          if (typeof harvest_date === 'object') {
            harvest = moment(harvest_date);
          } else {
            harvest = moment(harvest_date);
          }
          growing_days = harvest.diff(wet, 'days');
        // check growing_days
        } else if (growing_days !== undefined && growing_days !== null) {
          growing = Math.floor(growing_days);
          harvest_date = wet.add(growing, 'days')._d;
        }
      // growing_days has changed
      } else if (changedField === 'growing_days' && growing_days !== undefined && growing_days !== null) {
        // check wet_date
        if (wet_date) {
          wet = moment(wet_date);
          growing = Math.floor(growing_days);
          harvest_date = wet.add(growing, 'days')._d;
        // check harvest_date
        } else if (harvest_date) {
          harvest = moment(harvest_date);
          growing = Math.floor(growing_days);
          wet_date = harvest.subtract(growing, 'days')._d;
        }
      // harvest_date has changed
      } else if (changedField === 'harvest_date' && harvest_date) {
        // check wet_date
        if (wet_date) {
          wet = moment(wet_date);
          harvest = moment(harvest_date);
          growing_days = harvest.diff(wet, 'days');
        // check growing_days
        } else if (growing_days !== undefined && growing_days !== null) {
          growing = Math.floor(growing_days);
          harvest = moment(harvest_date);
          wet_date = harvest.subtract(growing, 'days')._d;
        }
      }
      // growing_days can be 0, so I only need to check that is different from 'undefined'
      var aux_growing_days = (growing_days !== undefined) ? growing_days : null;
      return {
        'wet_date'     : wet_date || null,
        'harvest_date' : harvest_date || null,
        'growing_days' : aux_growing_days
      };
    }

    /**
     * Check if date is between dates range (inclusive), without consider the years of all of them
     * @param  {[type]} startDate   [description]
     * @param  {[type]} endDate     [description]
     * @param  {[type]} dateToCheck [description]
     * @return {[type]}
     */
    function dateIsBetween(startDate, endDate, dateToCheck) {
      var current_year = moment().year();
      // set all dates on current year, this way all years are valid
      var start = moment(startDate).year(current_year).hours(0);
      var end   = moment(endDate).year(current_year).hours(0);
      var date  = moment(dateToCheck).year(current_year).hours(0);

      if (start > end) {
        start.subtract(1, 'years');
      }

      var valid = false;
      // dateToCheck has been changed to current_year, check if fits on current start-end period
      // if not, since start-date could be changed to one year less, subtract 1 year to dateToCheck and check if not fits
      if (date.isBetween(start, end, null, [])) {
        valid = true;
      } else {
        date.subtract(1, 'years');
        if (date.isBetween(start, end, null, [])) {
          valid = true;
        }
      }

      if (valid) {
        return true;
      } else {
        return false;
      }
    }

    /**
     * Filter given Varieties by Scheduled Wet Date & Location
     * @return {[type]}
     */
    function filterVarietiesByWetDate(wet_date, varieties, location_id) {
      var filteredVarieties = [];
      if (wet_date) {
        angular.forEach(varieties, function(variety) {
          if (variety && variety.hasOwnProperty('seed_varieties_location') && variety.seed_varieties_location.length) {
            angular.forEach(variety.seed_varieties_location, function (varietyLocation) {
              if (varietyLocation && varietyLocation.location_id === location_id) {
                var res = dateIsBetween(varietyLocation.begin_date, varietyLocation.end_date, wet_date);
                if (res) {
                  var obj = _.find(filteredVarieties, {id: variety.id});
                  if (!obj) {
                    filteredVarieties.push(variety);
                  }
                }
              }
            });
          }
        });
      }
      return filteredVarieties;
    }

    /**
     * Filter given Varieties by Location
     * @param  {[type]} variety     [description]
     * @param  {[type]} location_id [description]
     * @return {[type]}
     */
    function filterVarietyDatesByLocation(variety, location_id) {
      var filteredVarieties = [];
      if (variety && variety.hasOwnProperty('seed_varieties_location') && variety.seed_varieties_location.length) {
        angular.forEach(variety.seed_varieties_location, function (varietyLocation) {
          if (varietyLocation && varietyLocation.location_id === location_id) {
            var obj = _.find(filteredVarieties, {id: varietyLocation.id});
            if (!obj) {
              filteredVarieties.push(varietyLocation);
            }
          }
        });
      }
      return filteredVarieties;
    }

  });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('FiscalYearSeasonsService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity          = '/fiscal_year_seasons';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES        = '/fiscal_year_seasons/';
      var fiscalYearSeasonsService = {};

      /**
       * Function to get all fiscal-year-season.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      fiscalYearSeasonsService.getList = function () {
        return $http
          .get(API.url + entity)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to get a fiscal-year-season
       * @param  {[type]} parameters [description]
       * @return {[type]}            [description]
       */
      fiscalYearSeasonsService.getByFiscalYearSeason = function (parameters) {
        var params = {};
        if (parameters) {
          params = parameters;
        }
        return $http
          .get(API.url + entity, {params: params})
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to create a new fiscal-year-season.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      fiscalYearSeasonsService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update a fiscal-year-season.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      fiscalYearSeasonsService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete a fiscal-year-season.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      fiscalYearSeasonsService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete multile fiscal-year-seasons.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       *
       * TODO: add query string to bulk delete.
       */
      fiscalYearSeasonsService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            return res.data;
          });
      };
      return fiscalYearSeasonsService;
    });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('FiscalYearService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity          = '/fiscal_years';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES        = '/fiscal_years/';
      var fiscalYearService = {};

      /**
       * Function to create a new fiscal-year.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      fiscalYearService.getList = function () {
        return $http
          .get(API.url + entity)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to create a new fiscal-year.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      fiscalYearService.getFiscalYear = function (id) {
        return $http
          .get(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to create a new fiscal-year.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      fiscalYearService.create = function (data) {
        console.log(data);
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update a fiscal-year.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      fiscalYearService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete a fiscal-year.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      fiscalYearService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete multile fiscal-years.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       *
       * TODO: add query string to bulk delete.
       */
      fiscalYearService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            return res.data;
          });
      };
      return fiscalYearService;
    });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('FarmService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity        = '/farms';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES      = '/farms/';
      var farmService     = {};

      /**
       * Function to get farm by id.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      farmService.getFarm = function (id) {
        return $http
          .get(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to get farms list.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      farmService.getList = function () {
        return $http
          .get(API.url + entity)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to update a farm.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      farmService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      
      return farmService;
    });
})();
(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('DocumentCategoryService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/document_categories';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/document_categories/';

    var documentCategoryService = {};
    /**
     * Function to create a new document category.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    documentCategoryService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to update an document category.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    documentCategoryService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to patch an document category.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    documentCategoryService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to delete an document category.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    documentCategoryService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to get all the document categories
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    documentCategoryService.getAll = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    return documentCategoryService;
  });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('DocumentService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/documents';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/documents/';
    var upload_file             = '/upload_file';
    var delete_file             = '/delete_file/';
    var set_as_primary          = '/set_as_primary/';
    var document_types          = '/document_types/';
    var download_file           = '/download_file/';
    var patch_document          = '/patch/';

    var documentService = {};

    /**
     * Function to delete a document (tab)
     * @param  {[type]} file_entity [description]
     * @param  {[type]} id          [description]
     * @return {[type]}
     */
    documentService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };

    /**
    * Function to delete a file
    * @param  {[type]} file_entity [description]
    * @param  {[type]} id          [description]
    * @return {[type]}
    */
    documentService.deleteFile = function (file_entity, id) {
      return $http
        .delete(API.url + entity + delete_file + file_entity + '/' + id)
        .then(function (res) {
          return res.data;
        });
    };


    /**
     * Function to get all the documents
     * @param  {[type]} parameters [description]
     * @return {[type]}
     */
    documentService.getAll = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to upload documents
     * @param  {[type]} data [description]
     * @return {[type]}
     */
    documentService.uploadFile = function (data) {
      var formData = new FormData();
      angular.forEach(data, function (value, key) {
        formData.append(key, value);
      });

      return $http
        .post(
          API.url + entity + upload_file,
          formData,
        {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        }
        )
        .then(function (res) {
          return res;
        });
    };

    /**
     * Function to set a document as primary
     * @param  {[type]} file_entity [description]
     * @param  {[type]} id          [description]
     * @return {[type]}
     */
    documentService.setAsPrimary = function (file_entity, id) {
      return $http
        .get(API.url + entity + set_as_primary + file_entity + '/' + id)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to create a document type
     * @param  {[type]} file_entity [description]
     * @param  {[type]} id          [description]
     * @return {[type]}
     */
    documentService.createDocType = function (data) {
      return $http
        .post(API.url + entity + document_types + 'create', data)
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * Function to download a file
     * @param  {[type]} file_url [description]
     * @return {[type]}
     */
    documentService.getFile = function (file_entity, id) {
      return $http
        .get(API.url + entity + download_file + file_entity + '/' + id, {responseType: 'blob'})
        .then(function (res) {
          return res;
        });
    };

    /**
     * Function to patch a document field
     * @param  {[type]} file_entity [description]
     * @param  {[type]} id          [description]
     * @return {[type]}
     */
    documentService.patch = function (file_entity, id, data) {
      return $http
        .patch(API.url + entity + patch_document + file_entity + '/' + id, data)
        .then(function (res) {
          return res.data;
        });
    };

    return documentService;
  });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('CronjobService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity          = '/cronjobs';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES        = '/cronjobs/';
      var cronjobService       = {};

      /**
       * Function to create a new cronjob.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      cronjobService.getList = function () {
        return $http
          .get(API.url + entity + '?limit=' + 999999)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to get cronjob.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      cronjobService.getCronjob = function (id) {
        return $http
          .get(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to create a new cronjob.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      cronjobService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update a cronjob.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      cronjobService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete a cronjob.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
      cronjobService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to force cronjob.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
      cronjobService.forceCronjob = function (name) {
        return $http
          .get(API.url + entityES + '/force/' + name)
          .then(function (res) {
            return res.data;
          });
      };

      return cronjobService;
    });
})();
(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('ContractScheduleVarietiesService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/contract_schedule_varieties';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/contract_schedule_varieties/';
    var saveChilds              = '/save_childs';

    var contractScheduleVarietiesService = {};
    var savedData         = {};

    /**
     * Function to get all Contract Schedule Varieties
     * @return {[type]}
     */
    contractScheduleVarietiesService.getAll = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
      .get(API.url + entity, {params: params})
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * Function to create a new contract schedule.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    contractScheduleVarietiesService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to update a contract schedule.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    contractScheduleVarietiesService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to patch a schedule.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    contractScheduleVarietiesService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to delete a contract schedule.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    contractScheduleVarietiesService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to delete multiple contract schedules.
     * @param  {[type]} id
     * @return {[type]}
     *
     * TODO: add query string to bulk delete.
     */
    contractScheduleVarietiesService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
        .delete(API.url + entity + '/bulk?ids=' + ids)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to bulk create/update contract schedule varieties.
     * Used on Grower Schedule section to create/update Contracts subrows (childs)
     * @param  {[type]} data [array of contract schedule varieties]
     * @return {[type]}      [description]
     */
    contractScheduleVarietiesService.saveChilds = function (data) {
      return $http
        .post(API.url + entity + saveChilds, data)
        .then(function (res) {
          return res.data;
        });
    };


    /**
     * Get all contract schedules varieties for reports
     * @param  {[type]} parameters [description]
     * @return {[type]}            [description]
     */
    contractScheduleVarietiesService.getAllForReports = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
        .get(API.url + entity, {params: params})
        .then(function (res) {
          return res.data;
        });
    };

    /**
     * [description]
     * @return {[type]} [description]
     */
    contractScheduleVarietiesService.getAllAssociatedShippers = function () {
      return $http
      .get(API.url + entity + '/all/associated_shippers')
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * [description]
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    contractScheduleVarietiesService.saveData =function (data) {
      savedData = data;
    };

   /**
    * [description]
    * @return {[type]} [description]
    */
    contractScheduleVarietiesService.getData =function () {
      return savedData;
    };


    return contractScheduleVarietiesService;
  });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('ContractScheduleService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/contract_schedules';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/contract_schedules/';

    var contractScheduleService = {};
    /**
     * Function to get schedules of a contract.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    contractScheduleService.get = function (id) {
      return $http
        .get(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to get schedules of a contract.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    contractScheduleService.getAll = function () {
      return $http
        .get(API.url + entity)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to create a new contract schedule.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    contractScheduleService.create = function (data) {
      return $http
        .post(API.url + entity +'/create', data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to update a contract schedule.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    contractScheduleService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to patch a schedule.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    contractScheduleService.patch = function (id, data) {
      return $http
        .patch(API.url + entityES + id, data)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to delete a contract schedule.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    contractScheduleService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          return res.data;
        });
    };
    /**
     * Function to delete multiple contract schedules.
     * @param  {[type]} id
     * @return {[type]}
     *
     * TODO: add query string to bulk delete.
     */
    contractScheduleService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
        .delete(API.url + entity + '/bulk?ids=' + ids)
        .then(function (res) {
          return res.data;
        });
    };

    return contractScheduleService;
  });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('ContractPaymentScheduleService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity                  = '/contract_payment_schedules';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES                = '/contract_payment_schedules/';

      var contractPaymentScheduleService = {};
      /**
       * Function to create a new contract payment schedule.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      contractPaymentScheduleService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update an contract payment schedule.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      contractPaymentScheduleService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to patch an contract payment schedule.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      contractPaymentScheduleService.patch = function (id, field) {
        return $http
          .patch(API.url + entityES + id, field)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete an contract payment schedule.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      contractPaymentScheduleService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete multile contract payment schedule..
       * @param  {[type]} id
       * @return {[type]}
       *
       * TODO: add query string to bulk delete.
       */
      contractPaymentScheduleService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to get all contract payment schedule.
       * @param  {[type]} parameters [description]
       * @return {[type]}
       */
      contractPaymentScheduleService.getAll = function (parameters) {
        var params = {};
        if (parameters) {
          params = parameters;
        }
        return $http
          .get(API.url + entity, {params: params})
          .then(function (res) {
            return res.data;
          });
      };

      return contractPaymentScheduleService;
    });
})();

(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('ContractService', function ($http, $sessionStorage) {
    var API = {url: $sessionStorage.apiUrl};
    /* Use entity var without trailing slash */
    var entity = '/contracts';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES = '/contracts/';
    var payment_terms = '/payment_finance_terms';
    var grower_schedule = '/grower_schedule';

    var contractService = {};
    /**
     * Function to create a new contract.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    contractService.create = function (data) {
      return $http
      .post(API.url + entity + '/create', data)
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * Function to get a contract.
     * @param  {[type]} id         [description]
     * @param  {[type]} area_id    [description]
     * @param  {[type]} parameters [description]
     * @return {[type]}            [description]
     */
    contractService.get = function (id) {
      return $http
      .get(API.url + entityES + id)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to update a contract.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    contractService.update = function (id, data) {
      return $http
      .put(API.url + entityES + id, data)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to patch a contract.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    contractService.patch = function (id, field) {
      return $http
      .patch(API.url + entityES + id, field)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to delete a contract.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    contractService.delete = function (id) {
      return $http
      .delete(API.url + entityES + id)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to delete multiple contracts.
     * @param  {[type]} id
     * @return {[type]}
     *
     * TODO: add query string to bulk delete.
     */
    contractService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
      .delete(API.url + entity + '/bulk?ids=' + ids)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to get payment terms
     * @return {[type]}
     */
    contractService.getPaymentTerms = function () {
      return $http
      .get(API.url + entity + payment_terms)
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * [description]
     * @param  {[type]} offset              [description]
     * @param  {[type]} limit               [description]
     * @param  {[type]} area_fiscal_year_id [description]
     * @return {[type]}                     [description]
     */
    contractService.getContractsWithOffset = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      // /} (offset, limit, area_fiscal_year_id) {
      return $http
      .get(API.url + entity, {params: params})
      .then(function (res) {
        return res.data;
      });
    };

    /**
     * Function to get Contract's Grower Schedule
     * @return {[type]}
     */
    contractService.getContractGrowerSchedule = function (parameters) {
      var params = {};
      if (parameters) {
        params = parameters;
      }
      return $http
      .get(API.url + entity + grower_schedule, {params: params})
      .then(function (res) {
        return res.data;
      });
    };

    return contractService;
  });
})();

(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('CompanyService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    var entity = '/companies';
    var entityES = '/companies/';
    var companyBusinessRolesES = '/business_roles/';

    var companyService = {};
    /**
     * Function to create a new company.
     * @param  {[type]} data [description]
     * @return {[type]}      [description]
     */
    companyService.create = function (data) {
      return $http
      .post(API.url + entity + '/create', data)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to update an company.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    companyService.update = function (id, data) {
      return $http
      .put(API.url + entityES + id, data)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to patch an user.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    companyService.patch = function (id, field) {
      return $http
      .patch(API.url + entityES + id, field)
      .then(function (res) {
        if (res) {
          return res.data;
        }
      });
    };
    /**
     * Function to delete an company.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    companyService.delete = function (id) {
      return $http
      .delete(API.url + entityES + id)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to delete multile companies.
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     *
     * TODO: add query string to bulk delete.
     */
    companyService.bulkDelete = function (arrIds) {
      var ids = arrIds.join(',');
      return $http
      .delete(API.url + entity + '/bulk?ids=' + ids)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to get a company by id.
     *
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    companyService.getCompany = function (id) {
      return $http
      .get(API.url + entityES + id)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Function to get a company by business role.
     *
     * @param  {[type]} id [description]
     * @return {[type]}    [description]
     */
    companyService.getCompanyByBusinessRole = function (brName) {
      return $http
      .get(API.url + entity + '?business_role=' + brName)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Assign a business role group to a company.
     *
     * @param  {[type]} company_id [description]
     * @return {[type]}         [description]
     */
    companyService.companyBusinessRolesAddRelation = function (companyId, brId) {
      return $http
      .put(API.url + entityES + companyId + companyBusinessRolesES + brId)
      .then(function (res) {
        return res.data;
      });
    };
    /**
     * Remove a business role group from a company.
     *
     * @param  {[type]} company_id [description]
     * @return {[type]}         [description]
     */
    companyService.companyBusinessRolesRemoveRelation = function (companyId, brId) {
      return $http
      .delete(API.url + entityES + companyId + companyBusinessRolesES + brId)
      .then(function (res) {
        return res.data;
      });
    };

    companyService.get = function () {
      return $http
      .get(API.url + entityES)
      .then(function (res) {
        return res.data;
      });
    };

    companyService.getUploadImgUrl = function (companyId) {
      return API.url + entityES + companyId + '/add_image';
    };

    /**
     * [getCompaniesWithOffset description]
     * @param  {[type]} offset [description]
     * @param  {[type]} limit  [description]
     * @return {[type]}        [description]
     */
    companyService.getCompaniesWithOffset = function (offset, limit) {
      return $http
      .get(API.url + entity + '?limit=' + limit + '&offset=' + offset + '&order_by=id')
      .then(function (res) {
        return res.data;
      });
    };
    return companyService;
  });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('BlockService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity                  = '/blocks';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES                = '/blocks/';
      var savedFilterData         = {};
      var blockService = {};
      /**
       * Function to create a new block.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      blockService.create = function (data) {
        return $http
          .post(API.url + entity + '/create', data)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
            /**
       * Get block
       * @return {[type]} [description]
       */
      blockService.getBlock = function (id) {
        return $http
          .get(API.url + entityES + id)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      /**
       * Function to update an block.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      blockService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      /**
       * Function to patch an block.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      blockService.patch = function (id, field) {
        return $http
          .patch(API.url + entityES + id, field)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      /**
       * Function to delete an block.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      blockService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };
      /**
       * Function to delete multile blocks.
       * @param  {[type]} id
       * @return {[type]}
       *
       * TODO: add query string to bulk delete.
       */
      blockService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };

      /**
       * Get soil types
       * @return {[type]} [description]
       */
      blockService.getSoilTypes = function () {
        return $http
          .get(API.url + entity + '/soil_types')
          .then(function (res) {
            if(res) {
              return res.data;
            }
          });
      };

            /**
       * [getAreaBlocks description]
       * @param  {[type]} area_id [description]
       * @return {[type]}         [description]
       */
      blockService.getAreaBlocks = function (area_id) {
        return $http
          .get(API.url + entity  + '?area_id=' + area_id + '&limit=' + 999999)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * [getBlocksWithOffset description]
       * @param  {[type]} offset  [description]
       * @param  {[type]} limit   [description]
       * @param  {[type]} area_id [description]
       * @return {[type]}         [description]
       */
      blockService.getBlocksWithOffset = function (offset, limit, area_id) {
        return $http
          .get(API.url + entity  + '?limit=' + limit + '&offset=' + offset + '&order_by=name' + '&area_id=' + area_id)
          .then(function (res) {
            return res.data;
          });
      };


    /**
     * [description]
     * @param  {[type]} area_id    [description]
     * @param  {[type]} ranch_id   [description]
     * @param  {[type]} start_date [description]
     * @param  {[type]} end_date   [description]
     * @param  {[type]} company_id [description]
     * @return {[type]}            [description]
     */
      blockService.getBlocksForLease = function (area_id, ranch_id, start_date, end_date, company_id) {
        return $http
          .get(API.url + entity  + '?area_id=' + area_id + '&blocksForLease=' + true + '&search_by=ranch_id' + '&search=' + ranch_id
                       + '&lease_start_date=' + start_date + '&lease_end_date=' + end_date + '&company_id=' + company_id)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * [description]
       * @param  {[type]} area_id    [description]
       * @param  {[type]} ranch_id   [description]
       * @param  {[type]} start_date [description]
       * @param  {[type]} end_date   [description]
       * @param  {[type]} company_id [description]
       * @return {[type]}            [description]
       */
      blockService.getBlocksForSublease = function (area_id, ranch_id, start_date, end_date, company_id) {
        return $http
          .get(API.url + entity  + '?area_id=' + area_id + '&blocksForSublease=' + true + '&search_by=ranch_id' + '&search=' + ranch_id
                       + '&sublease_start_date=' + start_date + '&sublease_end_date=' + end_date + '&company_id=' + company_id)
          .then(function (res) {
            return res.data;
          });
      };


      /**
       * [getBlocksOfRanch description]
       * @param  {[type]} area_id      [description]
       * @param  {[type]} ranch_id     [description]
       * @param  {[type]} lease_status [description]
       * @return {[type]}              [description]
       */
      blockService.getBlocksOfRanch = function (ranch_id, lease_status) {
        return $http
          .get(API.url + entity  + '?search_by=ranch_id' + '&search=' + ranch_id + '&lease_status=' + lease_status)
          .then(function (res) {
            return res.data;
          });
      };

         /**
       * [saveFilterData description]
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      blockService.saveFilterData =function (data) {
        savedFilterData = data;
      };

      /**
       * [getFilterData description]
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      blockService.getFilterData =function () {
        return savedFilterData;
      };

      return blockService;
    });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('BusinessRoleService', function ($http, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      var entity = '/business_roles';
      var entityES = '/business_roles/';
      var businessRoleService = {};

      /**
       * Function to create a new Businees Role Group
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      businessRoleService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update a Businees Role Group
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      businessRoleService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete a Businees Role Group
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
      businessRoleService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete multile Businees Role Group.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       *
       * TODO: add query string to bulk delete.
       */ 
      businessRoleService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            return res.data;
          });
      };
      return businessRoleService;
    });
})();
(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('BlockBedSizeService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/block_bed_sizes';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/block_bed_sizes/';

    var blockBedSizeService = {};
      /**
       * Function to create a new block bed size.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
    blockBedSizeService.create = function (data) {
      return $http
        .post(API.url + entity + '/create', data)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      /**
       * Function to update an block bed size.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    blockBedSizeService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      /**
       * Function to patch an block bed size.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    blockBedSizeService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      /**
       * Function to delete an block bed size.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    blockBedSizeService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };

    /**
    * Get all block bed sizes
    * @return {[type]} [description]
    */
    blockBedSizeService.getBlockBedSizes = function (id) {
      return $http
      .get(API.url + entity + '/?block_id=' + id + '?limit=' + 999999)
      .then(function (res) {
        if(res) {
          return res.data;
        }
      });
    };


    return blockBedSizeService;
  });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('BlockBedDirectionsService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/block_bed_directions';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/block_bed_directions/';

    var blockBedDirectionsService = {};
      /**
       * Function to create a new block bed direction.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
    blockBedDirectionsService.create = function (data) {
      return $http
        .post(API.url + entity + '/create', data)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      /**
       * Function to update an block bed direction.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    blockBedDirectionsService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      /**
       * Function to patch an block bed direction.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    blockBedDirectionsService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      /**
       * Function to delete an block bed direction.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
    blockBedDirectionsService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };

      /**
       * Get all block bed directions
       * @return {[type]} [description]
       */
    blockBedDirectionsService.get = function () {
      return $http
        .get(API.url + entity + '?limit=' + 999999)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      
    return blockBedDirectionsService;
  });
})();
(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('BedSizeService', function ($http, $sessionStorage) {
    var API = { url: $sessionStorage.apiUrl };
    /* Use entity var without trailing slash */
    var entity                  = '/bed_sizes';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES                = '/bed_sizes/';

    var bedSizeService = {};
      /**
       * Function to create a new bed size.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
    bedSizeService.create = function (data) {
      return $http
        .post(API.url + entity + '/create', data)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      /**
       * Function to update an bed size.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    bedSizeService.update = function (id, data) {
      return $http
        .put(API.url + entityES + id, data)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      /**
       * Function to patch an bed size.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    bedSizeService.patch = function (id, field) {
      return $http
        .patch(API.url + entityES + id, field)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };
      /**
       * Function to delete an bed size.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
    bedSizeService.delete = function (id) {
      return $http
        .delete(API.url + entityES + id)
        .then(function (res) {
          if(res) {
            return res.data;
          }
        });
    };

      /**
       * [description]
       * @param  {[type]} blockId [description]
       * @return {[type]}         [description]
       */
    bedSizeService.getAvailablesBedSizes = function (blockId) {
      return $http
      .get(API.url + entity + '/?except_block_id=' + blockId + '&limit=' + 999999)
      .then(function (res) {
        if(res) {
          return res.data;
        }
      });
    };

    return bedSizeService;
  });
})();

(function() {
  'use strict';

  angular
  .module('app.services')
  .factory('BackgroundService', function ($http, API) {
    /* Use entity var without trailing slash */
    var entity   = '/background';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    var entityES = '/background/';
    var backgroundService = {};

    /**
     * Function to upload documents
     * @param  {[type]} data [description]
     * @return {[type]}
     */
    backgroundService.uploadFile = function (data) {
      var formData = new FormData();
      formData.append('upfile', data.upfile, 'background.jpg');

      return $http
        .post(
          API.url + entity + '/add_background',
          formData,
        {
          transformRequest: angular.identity,
          headers: {'Content-Type': undefined}
        }
        )
        .then(function (res) {
          if (res) {
            return res;
          }
        });
    };

    /**
     *
     */
    backgroundService.getUrl = function () {
      return API.url + entityES + 'add_background';
    };

    /**
     * Function upload img url
     */
    backgroundService.getUploadImgUrl = function () {
      return API.url + entity + '/image';
    };

    /**
     * Function to download a file
     */
    backgroundService.getFile = function () {
      return $http
        .get(API.url + entityES + 'image')
        .then(function (res) {
          return res;
        });
    };

    return backgroundService;
  });
})();

(function() {
  'use strict';
  /* Take a look at angular router form more info: https://github.com/angular-ui/ui-router/wiki */
  angular
    .module('app.services')
    .factory('BearerAuthInterceptor', function ($rootScope, $window, $q, $location, $injector, API, OAUTH_CLIENT_DEV) {
      return {
        request: function(config) {
          config.headers = config.headers || {};
          if ($window.localStorage.getItem('user_access_token')) {
            config.headers.Authorization = 'Bearer ' + JSON.parse($window.localStorage.getItem('user_access_token'));
          } else {
            config.headers.Authorization = 'Bearer ' + JSON.parse($window.localStorage.getItem('user_refresh_token'));
          }
          return config || $q.when(config);
        },
        responseError: function(response) {
          if (response.status === 401) {
            var tokenExpired = false;
            var tokenExpiresIn = JSON.parse($window.localStorage.getItem('user_token_expires_in'));
            if (tokenExpiresIn) {
              tokenExpired = moment().isAfter(tokenExpiresIn);
            }
            if(tokenExpired) {
              $window.localStorage.removeItem('user_access_token');
              var credentials = {
                grant_type: 'refresh_token',
                refresh_token: JSON.parse($window.localStorage.getItem('user_refresh_token')),
                client_id: OAUTH_CLIENT_DEV.client_id,
                client_secret: OAUTH_CLIENT_DEV.client_secret
              };
              var http = $injector.get('$http');
              return http
                .post(API.url + '/oauth/token', credentials)
                .then(function (res) {
                  if (res.data && res.data.access_token && res.data.access_token !== '') {
                    localStorage.setItem('user_access_token', JSON.stringify(res.data.access_token));
                  }
                  if (res.data && res.data.refresh_token && res.data.refresh_token !== '') {
                    localStorage.setItem('user_refresh_token', JSON.stringify(res.data.refresh_token));
                  }
                  if (res.data && res.data.expires_in && res.data.expires_in !== '') {
                    localStorage.setItem('user_token_expires_in', JSON.stringify(res.data.expires_in));
                  }
                  $rootScope.user = res.data.user;
                  // should retry
                  response.config.headers.Authorization = 'Bearer ' + res.data.access_token;
                  return $injector.get('$http')(response.config);
                }, function(error) {
                  console.error(error);
                  $location.url('/login');
                });
            }
            $location.url('/login');
          }
          return $q.reject(response);
        }
      };
    });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('AuthService', function (
      $q,
      $http,
      Session,
      $location,
      $rootScope,
      API,
      AclService,
      msNavigationService,
      ModuleService,
      UserService,
      msApi
    ) {
      var authService = {};

      /**
       * Function to perform login.
       * 
       * @param  {[type]} credentials [description]
       * @return {[type]}             [description]
       */
      authService.login = function (credentials) {
        return $http
          .post(API.url + '/oauth/token', credentials)
          .then(function (res) {
            if (res.data && res.data.access_token && res.data.access_token !== '') {
              localStorage.setItem('user_access_token', JSON.stringify(res.data.access_token));
            }
            if (res.data && res.data.refresh_token && res.data.refresh_token !== '') {
              localStorage.setItem('user_refresh_token', JSON.stringify(res.data.refresh_token));
            }
            if (res.data && res.data.expires_in && res.data.expires_in !== '') {
              localStorage.setItem('user_token_expires_in', JSON.stringify(res.data.expires_in));
            }
            $rootScope.user = res.data.user;
            return res.data.user;
          });
      };
      /**
       * Function to set ACL configuration
       *  - Check and get all modules_acess
       *  - Making map with different user roles and setting a list with modules that each user role can access.
       */
      authService.setACLConfig = function() {
        var q = $q.defer();
        $rootScope.modulesMap = {};
        $rootScope.modulesMapAux = {};
        ModuleService.getList().then(function(data) {
          data.modules.forEach(function(module) {
            // First create role user top map
            var rolesInScope = [];
            var roleNewCase = '';
            module.module_access.forEach(function(module_access) {
              // Avoid issues with roles names, normalize instead.
              roleNewCase = module_access.user_role.name.replace(/ /g, '_');
              roleNewCase = roleNewCase.toLowerCase();
              rolesInScope.push(roleNewCase);
              if(!$rootScope.modulesMap.hasOwnProperty([roleNewCase])) {
                $rootScope.modulesMap[roleNewCase] = [];
              }
              if(!$rootScope.modulesMapAux.hasOwnProperty([roleNewCase])) {
                $rootScope.modulesMapAux[roleNewCase] = [];
              }
            });
            // Then add pages when that user role can access
            rolesInScope.forEach(function(role) {
              module.pages.forEach(function(page) {
                if($rootScope.modulesMap[role].indexOf(page.name) === -1) {
                  $rootScope.modulesMap[role].push(page.name);
                }
                if($rootScope.modulesMapAux[role].findIndex(function(i) { i.name === page.name; }) === -1) {
                  $rootScope.modulesMapAux[role].push({ name: page.name, isAdmin: page.is_admin, section: page.section });
                }
              });
            });
          });
          AclService.setAbilities($rootScope.modulesMap);
          localStorage.setItem('pages', JSON.stringify($rootScope.modulesMapAux));
          q.resolve({status: 'success', acl: $rootScope.modulesMap});
        },
        function(err) {
          q.reject({status: 'Error loading ACL config'});
          console.error(err);
        });
        return q.promise;
      };

      /**
       * Function to get user roles each time an user request a page, this is in order to avoid browser hacking.
       *  - This function alse remove menues accordingly the role access level
       *  - Dashboard menu is always added for all roles in the system.
       */
      authService.addRoles = function() {
        var q = $q.defer();
        AclService.flushRoles();
        // Get user information
        if($rootScope.user) { // User existent user data from API (we use this to don't call the API twice).
          authService.validateMenuItemsAndAddRole($rootScope.user).then(function(data) {
            q.resolve(data);
            msNavigationService.sort();
          }, function(rejection) {
            q.reject(rejection);
          });
        } else { // We already have user data in browser but we need to validate from API to prevent browser hacking.
          var user = UserService.getLocalUser();
          // Search user info to validate data.
          if(user && user.hasOwnProperty('id')) {
            UserService.getUser(user.id).then(function(userData) {
              authService.validateMenuItemsAndAddRole(userData.user).then(function(data) {
                q.resolve(data);
                msNavigationService.sort();
              }, function(rejection) {
                q.reject(rejection);
              });
            });
          } else {
            q.reject('No user found.');
          }
        }
        return q.promise;
      };
      /**
       * Function to iterate over each role and each page to add proper menu
       * regarding user access over each module.
       *
       * @return {[type]} [description]
       */
      authService.validateMenuItemsAndAddRole = function(user) {
        var q = $q.defer();
        msApi.request('menuNavigationData@get',
          function(navigationInfo) {
            var sectionAdded = [];
            var pageAdded = [];
            var allRoles = [];
            /*---------------------------------------------------------------------------*/
            // Get pages DASHBOARD section data.
            var dashboardNavigationData = navigationInfo.dashboard_navigation_data;
            // Get pages PLANNING section data.
            var pagesNavigationData = navigationInfo.pages_navigation_data;
            // Get pages GROWING section data.
            var growingNavigationData = navigationInfo.growing_navigation_data;
            // Get pages FARM ADMIN section data.
            var farmAdminNavigationData = navigationInfo.farm_admin_navigation_data;
            // Get pages SYSTEM ADMIN section data.
            var adminNavigationData = navigationInfo.admin_navigation_data;
            /*---------------------------------------------------------------------------*/
            var menuset = localStorage.getItem('menuset');
            var localAclServiceData = JSON.parse(sessionStorage.getItem('AclService'));
            if(!localAclServiceData) {
              q.reject({status: 'error', msg: 'ACL service data was not loaded.'});
            } else {
              var pages = JSON.parse(localStorage.getItem('pages'));
              // Normalize roles before store.
              var roleNewCase = '';
              user.roles.forEach(function(role, i) { // Needed to flat roles.
                roleNewCase = role.name.replace(/ /g, '_');
                user.roles[i].name = roleNewCase.toLowerCase();
                allRoles.push(user.roles[i].name);
                AclService.attachRole(user.roles[i].name);
                // Smart choice to get pages.
              });
              q.resolve({status: 'success', aclServiceData: localAclServiceData});
              if(allRoles.indexOf('super_user') === -1 && (!menuset || menuset === undefined || menuset === null)) {
                // REMOVE ALL SECTIONS
                msNavigationService.clearNavigation();
                // Iterate over each role that current user has.
                allRoles.forEach(function(role) {
                  // Find pages through the current role
                  if(pages[role] && pages[role].length > 0) {
                    pages[role].forEach(function(page) {
                      if(pageAdded.indexOf(page.name) === -1) {
                        pageAdded.push(page.name); // add page to pageAdded list in order to no repeat this process.
                        if(page.hasOwnProperty('isAdmin') && page.isAdmin) {
                          if(sectionAdded.indexOf('admin') === -1) {
                            sectionAdded.push('admin');
                            // Navigation
                            msNavigationService.saveItem('admin', {
                              title: 'ADMIN',
                              group: true,
                              weight: 20
                            });
                          }
                          authService._setMenus(adminNavigationData, page.name);
                        } else {
                          if(page.section === 'planning') {
                            if(sectionAdded.indexOf('pages') === -1) {
                              sectionAdded.push('pages');
                              // Navigation
                              msNavigationService.saveItem('pages', {
                                title: 'PLANNING',
                                group: true,
                                weight: 1
                              });
                            }
                            authService._setMenus(pagesNavigationData, page.name);
                          }
                          if(page.section === 'dashboard') {
                            if(sectionAdded.indexOf('dashboard') === -1) {
                              sectionAdded.push('dashboard');
                              // Navigation
                              msNavigationService.saveItem('dashboard', {
                                title: 'DASHBOARD',
                                group: true,
                                weight: 0
                              });
                            }
                            authService._setMenus(dashboardNavigationData, page.name);
                          }
                          if(page.section === 'growing') {
                            if(sectionAdded.indexOf('growing') === -1) {
                              sectionAdded.push('growing');
                              // Navigation
                              msNavigationService.saveItem('growing', {
                                title: 'GROWING',
                                group: true,
                                weight: 2
                              });
                            }
                            authService._setMenus(growingNavigationData, page.name);
                          }
                          if(page.section === 'farm-admin') {
                            if(sectionAdded.indexOf('farm-admin') === -1) {
                              sectionAdded.push('farm-admin');
                              // Navigation
                              msNavigationService.saveItem('farm-admin', {
                                title: 'FARM ADMIN',
                                group: true,
                                weight: 3
                              });
                            }
                            authService._setMenus(farmAdminNavigationData, page.name);
                          }
                        }
                      }
                    });
                  }
                });
              }
            }
          },
          function(res) {
            if(res.status === 401) {
              $location.url('/login');
              q.reject({status: 'error'});
            }
          }
        );
        return q.promise;
      };
      /**
       * Function to set menus regarding the user role/module/page relations
       *
       * @param  {[type]} navigationData [description]
       * @param  {[type]} page           [description]
       * @return {[type]}                [description]
       */
      authService._setMenus = function(navigationData, page) {
        // Find menu information.
        var pageInfo = navigationData.find(function(localPage) {
          // Search for a page matching page parameter
          return localPage.slug.replace(/_/g, '-').split('.').pop() === page.replace(/_/g, '-');
        });
         // If it's children and has parent
        if(pageInfo.hasOwnProperty('parent')) {
          authService._loadParent(navigationData, pageInfo);
          
        } else if(pageInfo.hasOwnProperty('children') && pageInfo.children.length > 0) { // If it's parent and has children
          // Save parent item
          authService._navigationSaveItem(pageInfo);
          // Find children allowed to be saved.
          pageInfo.children.forEach(function() {
            var childPageInfo = navigationData.find(function(childPage) {

              // If it's children.. because sometimes has the same name, we need to check.
              if(childPage.hasOwnProperty('parent')) {
                return childPage.slug.replace(/_/g, '-').split('.').pop() === page.replace(/_/g, '-').split('.').pop();
              }
            });
            // Save child
            if(childPageInfo) {
              authService._navigationSaveChildItem(childPageInfo);
            }
          });
        } else {
          authService._navigationSaveChildItem(pageInfo);
        }
      };
      /**
       * Load parent recursive function to get first grandparent and then trigger to last child.
       * @return {[type]} [description]
       */
      authService._loadParent = function(navigationData, pageInfo) {
        // Search for a parent page and add parent/child items
        var parentPageInfo = navigationData.find(function(parentPage) {
          return parentPage.slug.replace(/_/g, '-').split('.').pop() === pageInfo.parent.replace(/_/g, '-').split('.').pop();
        });
        if(parentPageInfo.hasOwnProperty('parent')) {
          authService._loadParent(navigationData, parentPageInfo);
        } else {
          authService._navigationSaveItem(parentPageInfo);
        }
        authService._navigationSaveChildItem(pageInfo);
      };

      /**
       * Function to call msNavigationService and save child items.
       *
       * @param  {[type]} item [description]
       * @return {[type]}      [description]
       */
      authService._navigationSaveChildItem = function(item) {
        // Add navigation menu
        msNavigationService.saveItem(item.slug, {
          title : item.title,
          icon  : item.icon,
          state : item.state,
          weight: item.weight
        });
      };

      /**
       * Function to call msNavigationService and save single or parent items.
       *
       * @param  {[type]} item [description]
       * @return {[type]}      [description]
       */
      authService._navigationSaveItem = function(item) {
        // Add parent navigation menu
        msNavigationService.saveItem(item.slug, {
          title : item.title,
          icon  : item.icon,
          class : item.class,
          hidden: item.hidden,
          weight: item.weight
        });
      };

      /**
       * Check if it's authenticated.
       * 
       * @return {Boolean} [description]
       */
      authService.isAuthenticated = function () {
        return !!Session.userId;
      };
      /**
       * Check if user has authorization to perform action
       * 
       * @param  {[type]}  authorizedRoles [description]
       * @return {Boolean}                 [description]
       */
      authService.isAuthorized = function (authorizedRoles) {
        if (!angular.isArray(authorizedRoles)) {
          authorizedRoles = [authorizedRoles];
        }
        return (authService.isAuthenticated() &&
          authorizedRoles.indexOf(Session.userRole) !== -1);
      };

      return authService;
    })
    .service('Session', function () {
      this.create = function (sessionId, userId, userRole) {
        this.id = sessionId;
        this.userId = userId;
        this.userRole = userRole;
      };
      this.destroy = function () {
        this.id = null;
        this.userId = null;
        this.userRole = null;
      };
    });
})();

(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('AreaFiscalYearService', function ($http, Session, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity          = '/area_fiscal_years';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES        = '/area_fiscal_years/';
      var areaFiscalYearService = {};

      /**
       * Function to create a new areaFiscalYear.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      areaFiscalYearService.getList = function () {
        return $http
          .get(API.url + entity)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to create a new areaFiscalYear.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      areaFiscalYearService.getAreaFiscalYear = function (id) {
        return $http
          .get(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };

      return areaFiscalYearService;
    });
})();
(function() {
  'use strict';

  angular
    .module('app.services')
    .factory('AreaService', function ($http, Session, $sessionStorage) {
      var API = { url: $sessionStorage.apiUrl };
      /* Use entity var without trailing slash */
      var entity          = '/areas';
      /* Use entityES var with trailing slash (ES = Entity Slash) */
      var entityES        = '/areas/';
      var areaService       = {};

      /**
       * Function to create a new area.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      areaService.getList = function () {
        return $http
          .get(API.url + entity + '?limit=' + 999999)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to get area.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      areaService.getArea = function (id) {
        return $http
          .get(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Function to create a new area.
       * @param  {[type]} data [description]
       * @return {[type]}      [description]
       */
      areaService.create = function (data) {
        return $http
          .post(API.url + entity +'/create', data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to update a area.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      areaService.update = function (id, data) {
        return $http
          .put(API.url + entityES + id, data)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete a area.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */ 
      areaService.delete = function (id) {
        return $http
          .delete(API.url + entityES + id)
          .then(function (res) {
            return res.data;
          });
      };
      /**
       * Function to delete multile areas.
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       *
       * TODO: add query string to bulk delete.
       */ 
      areaService.bulkDelete = function (arrIds) {
        var ids = arrIds.join(',');
        return $http
          .delete(API.url + entity + '/bulk?ids=' + ids)
          .then(function (res) {
            return res.data;
          });
      };

      /**
       * Get locations of area
       * @param  {[type]} id [description]
       * @return {[type]}    [description]
       */
      areaService.getAreaLocations = function (id) {
        return $http
          .get(API.url + entityES + id + '/locations' + '?limit=' + 999999)
          .then(function (res) {
            return res.data;
          });
      };
      return areaService;
    });
})();
(function () {
  'use strict';

  angular
  .module('app.services')
  .factory('AnchorTypeDefinitionService', function ($http, $q) {
    /* Use entity var without trailing slash */
    //var entity = '/phase';
    /* Use entityES var with trailing slash (ES = Entity Slash) */
    //var entityES = '/phase/';
    var anchorTypeDefinitionService = {};
    var anchorDefinition = {
      id: 1,
      definitions: [
        {
          name: 'Wet Date',
          shortCode: 'WD',
          wetDate: true,
          harvestDate: false,
          id: 1,
          assignAnchorDate: false,
          preAnchor: false,
          postDate: false,
          repeats: false,
          display: false
        },
        {
          name: 'Harvest Date',
          shortCode: 'HD',
          wetDate: false,
          harvestDate: true,
          id: 2,
          assignAnchorDate: false,
          preAnchor: false,
          postDate: false,
          repeats: false,
          display: false
        },
        {
          name: 'Tillage Start',
          shortCode: 'TS',
          wetDate: false,
          harvestDate: false,
          id: 3,
          assignAnchorDate: false,
          preAnchor: true,
          postDate: false,
          repeats: false,
          display: true
        },
        {
          name: 'Pre-Water',
          shortCode: 'PW',
          wetDate: false,
          harvestDate: false,
          id: 4,
          assignAnchorDate: false,
          preAnchor: true,
          postDate: false,
          repeats: false,
          display: true
        },
        {
          name: 'Growing Start Date',
          shortCode: 'GSD',
          wetDate: false,
          harvestDate: false,
          id: 5,
          assignAnchorDate: false,
          preAnchor: false,
          postDate: true,
          repeats: true,
          display: true
        },
        {
          name: 'Planting Date',
          shortCode: 'PD',
          wetDate: false,
          harvestDate: false,
          id: 6,
          assignAnchorDate: true,
          preAnchor: false,
          postDate: false,
          repeats: false,
          display: true
        },
        {
          name: 'Normal',
          shortCode: '',
          wetDate: false,
          harvestDate: false,
          id: 7,
          assignAnchorDate: false,
          preAnchor: false,
          postDate: false,
          repeats: false,
          display: false
        }
      ]
    };

    var _ = window._;

    anchorTypeDefinitionService.selectedWorkTemplate = {};


    anchorTypeDefinitionService.get = function () {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve(anchorDefinition);
      }, 2000);

      return deferred.promise;
    };

    anchorTypeDefinitionService.getAnchorShortCode = function (id) {
      if (!id) {
        return '';
      }
      return anchorDefinition.definitions.filter(function (a) {
        return a.id == id;
      }).shift().shortCode;
    };

    anchorTypeDefinitionService.getAnchorName = function (id) {
      return anchorDefinition.definitions.filter(function (a) {
        return a.id == id;
      }).shift().name;
    };

    anchorTypeDefinitionService.getAnchor = function (id) {
      return anchorDefinition.definitions.filter(function (a) {
        return a.id == id;
      }).shift();
    };


    anchorTypeDefinitionService.getWorkTemplatesWithOffset = function (offset, limit) {
      var deferred = $q.defer();

      setTimeout(function () {
        deferred.resolve(_.take(_.drop(anchorDefinition, offset), limit));
      }, 2000);

      return deferred.promise;

    };

    anchorTypeDefinitionService.save = function (phase) {
      //var self = this;
      var deferred = $q.defer();

      setTimeout(function () {
        phase.id = anchorDefinition.length + 1;
        anchorDefinition.push(phase);
        deferred.resolve(phase);
      }, 500);

      return deferred.promise;
    };


    anchorTypeDefinitionService.update = function (wk) {
      var deferred = $q.defer();

      setTimeout(function () {
        var index = _.findIndex(anchorDefinition, function (w) {
          return w.id == wk.id;
        });

        _.assign(anchorDefinition[index], wk);

        deferred.resolve();
      }, 2000);

      return deferred.promise;
    };

    anchorTypeDefinitionService.bulkDelete = function (_tasks) {
      var deferred = $q.defer();


      setTimeout(function () {
        _tasks.forEach(function (_id) {
          _.remove(anchorDefinition, {
            id: _id
          });
        });

        deferred.resolve(anchorDefinition);
      }, 500);

      return deferred.promise;
    };

    anchorTypeDefinitionService.setSelected = function (wk) {
      anchorTypeDefinitionService.selectedWorkTemplate = wk;
    };


    anchorTypeDefinitionService.delete = function (phase) {
      var deferred = $q.defer();

      setTimeout(function () {
        _.remove(anchorDefinition.definitions, {
          id: phase.id
        });
        deferred.resolve(anchorDefinition);
      }, 500);

      return deferred.promise;
    };

    return anchorTypeDefinitionService;
  });
})();
(function () {
  'use strict';

  angular.module('app.pages.work-schedule')
  .controller('WorkScheduleCtrl', WorkScheduleCtrl);

  /** @ngInject */
  function WorkScheduleCtrl($mdDialog, msUtils, GrowerService, NotifyGroupService, GrowerScheduleService, $log, $document, $animate, $scope, $timeout, ganttUtils, GanttObjectModel, ganttDebounce, moment, $window, $mdSidenav, msApi, PhaseService, api, AnchorTypeDefinitionService) {
    var vm = this;
    var objectModel;
    var _ = window._;

    vm.growerSchedules = GrowerService.getGrowerSchedules();


    vm.exists = msUtils.exists;
    vm.userRoles = [];
    vm.allRolesGroups = [];
    vm.anchorDefinitions = [];

    vm.ganttBlockMode = true;
    vm.daylightOnly = false;

    vm.changeDaylight = function() {

      $scope.api.columns.generate();

    };

    vm.timeFrames = {
      day: {
        start: moment('08:00', 'HH:mm'),
        end: moment('20:00', 'HH:mm'),
        working: true, // This is a working period
        default: true, // It will be used for each day
        color: 'WhiteSmoke',
        classes: ['gantt-day']
      },
      night: {
        start: moment('20:00', 'HH:mm'),
        end: moment('23:59', 'HH:mm'),
        working: false, // This is a working period
        default: true, // It will be used for each day
        color: 'LightSlateGrey',
        classes: ['gantt-night']
      },
      night2: {
        start: moment('00:00', 'HH:mm'),
        end: moment('08:00', 'HH:mm'),
        working: false, // This is a working period
        default: true, // It will be used for each day
        color: 'LightSlateGrey',
        classes: ['gantt-night']
      }
    };

    /**
     * Users notify group from API
     */
    //vm.allNotifyGroups = NotifyGroupsData.notify_groups;
    vm.allNotifyGroups = [
      {name: 'Tractor', id: 1},
      {name: 'Sprinkler', id: 2},
      {name: 'Irrigation', id: 3},
      {name: 'Planter', id: 4},
      {name: 'Harvest', id: 5}
    ];

    NotifyGroupService.getList().then(function (data) {
      vm.allNotifyGroups = data.notify_groups;
    });


    api.roles.get({}, function (RolesData) {
      vm.allRolesGroups = RolesData.roles.filter(function (ng) {
        return ng.name.toLowerCase().indexOf('foreman') != -1;
      });
    },
    function (err) {
      console.error(err);
    });

    AnchorTypeDefinitionService.get().then(function (t) {
      vm.anchorDefinitions = t.definitions;
    });

    api.roles.get({}, function (RolesData) {
      vm.userRoles = RolesData.roles;
    }, function () {
      //console.log(err);
    });

    api.users.get({}, function (UsersData) {
      vm.users = UsersData.users;
    }, function () {
      //console.log(err);
    });


    vm.laborGroups = [
      {name: 'Tractor', id: 1},
      {name: 'Sprinkler', id: 2},
      {name: 'Irrigation', id: 3},
      {name: 'Planter', id: 4},
      {name: 'Harvest', id: 5}
    ];

    vm.equipmentGroups = [
      {name: 'Tractor', id: 1},
      {name: 'Sprinkler', id: 2},
      {name: 'Irrigation', id: 3},
      {name: 'Planter', id: 4},
      {name: 'Harvest', id: 5}
    ];

    // Data
    vm.live = {};

    // Event handler
    var logScrollEvent = function (left, date, direction) {
      if (date !== undefined) {
        $log.info('[Event] api.on.scroll: ' + left + ', ' + (date === undefined ? 'undefined' : date.format()) + ', ' + direction);
      }
    };

    // Event handler
    var logDataEvent = function (eventName) {
      $log.info('[Event] ' + eventName);
    };

    // Event handler
    var logTaskEvent = function (eventName, task) {
      $log.info('[Event] ' + eventName + ': ' + task.model.name);
    };

    // Event handler
    var logRowEvent = function (eventName, row) {
      $log.info('[Event] ' + eventName + ': ' + row.model.name);
    };

    // Event handler
    var logTimespanEvent = function (eventName, timespan) {
      $log.info('[Event] ' + eventName + ': ' + timespan.model.name);
    };

    // Event handler
    var logLabelsEvent = function (eventName, width) {
      $log.info('[Event] ' + eventName + ': ' + width);
    };

    // Event handler
    var logColumnsGenerateEvent = function (columns, headers) {
      $log.info('[Event] ' + 'columns.on.generate' + ': ' + columns.length + ' column(s), ' + headers.length + ' header(s)');
    };

    // Event handler
    var logRowsFilterEvent = function (rows, filteredRows) {
      $log.info('[Event] rows.on.filter: ' + filteredRows.length + '/' + rows.length + ' rows displayed.');
    };

    // Event handler
    var logTasksFilterEvent = function (tasks, filteredTasks) {
      $log.info('[Event] tasks.on.filter: ' + filteredTasks.length + '/' + tasks.length + ' tasks displayed.');
    };

    // Event handler
    var logReadyEvent = function () {
      $log.info('[Event] core.on.ready');
    };

    // Event utility function
    var addEventName = function (eventName, func) {
      return function (data) {
        return func(eventName, data);
      };
    };

    vm.minutesOfDay = function (m) {
      return m.minutes() + m.hours() * 60;
    };


    // angular-gantt options
    $scope.options = {
      mode: 'custom',
      scale: 'day',
      sortMode: undefined,
      sideMode: 'TreeTable',
      daily: false,
      showName: 'task',
      maxHeight: false,
      width: false,
      zoom: 1,
      columns: ['model.name'],
      treeTableColumns: [],
      columnsHeaders: {'model.name': 'Block'},
      columnsClasses: {'model.name': 'gantt-column-name'},
      columnsFormatters: {
        'from': function (from) {
          return from !== undefined ? from.format('lll') : undefined;
        },
        'to': function (to) {
          return to !== undefined ? to.format('lll') : undefined;
        }
      },
      treeHeaderContent: '<i class="icon s16 icon-view-dashboard" ></i> <span style="font-size: 18px;">Block Name</span>',
      columnsHeaderContents: {
        'Block': '<i class="fa fa-align-justify"></i> {{getHeader()}}'
      },
      autoExpand: 'none',
      taskOutOfRange: 'truncate',
      fromDate: moment(),
      toDate: moment(),
      columnScales: {
        two_hour: '2 hours',
        three_hour: '3 hours'
      },
      headerFormats: {
        'year': 'YYYY',
        'quarter': '[Q]Q YYYY',
        monthOnly: 'MMM',
        month: 'MMMM YYYY',
        week: '[Week] w',
        week_only: 'w',
        week_year: '[Week] w MMMM , gggg',
        day: 'dddd MMMM D, YYYY',
        dayOnly: 'dddd DD',
        hour: 'hh A',
        two_hour: 'hh A',
        three_hour: 'hh A',
        minute: 'H:mm',
        second: 'H:mm:ss',
        millisecond: 'H:mm:ss:SSS'
      },
      rowContentEnabled: true,
      rowContent: '<input type="radio"   ng-click="$event.stopPropagation();"  ng-checked="row.model.id == vm.selectedBlock.id;"  ng-model="scope.vm.selectedBlock"  aria-label="true" ng-value="row.model" />  <div class="no-text clickeable" ng-style="{\'background-color\':row.model.work_template.color}" style="height:15px;width:12px;margin-right:10px;border-radius: 10px;"></div> <span class="gantt-task-name">\n {{row.model.name }} <md-tooltip md-direction="top" class="gantt-chart-task-tooltip"><div layout="column" layout-align="center center">           <div class="tooltip-name">                <span>Wet date: {{scope.vm.moment(row.model.scheduled_wet_date).format("MM-DD-YYYY")}}</span> || \n<span>Harvest date: {{scope.vm.moment(row.model.original_harvest_date).format("MM-DD-YYYY")}}</span></div></md-tooltip> </span> ',
      taskContentEnabled: true,
      taskContent: '<span class="gantt-task-name">\n<md-tooltip ng-if="task.model.isInvalidDaylight" md-visible="task.model.isInvalidDaylight">This task is daylight only</md-tooltip>\n    {{task.model|anchor}}\n    <md-tooltip md-direction="top" class="gantt-chart-task-tooltip">\n        <div layout="column" layout-align="center center">\n            <div class="tooltip-name">\n                <b> {{task.model|anchor}}</b><span> ({{scope.vm.getDuration(task.model.from,task.model.to)}})</span>           </div>\n</div>\n   </md-tooltip>\n</span>',
      allowSideResizing: true,
      labelsEnabled: true,
      currentHeader: ['day', 'hour'],
      changeScale: function () {
        if ($scope.options.scale == 'day') {
          $scope.options.currentHeader = ['day', 'hour'];
        }

        if ($scope.options.scale == '2 days') {
          $scope.options.currentHeader = ['day', 'two_hour'];
        }

        if ($scope.options.scale == '3 days') {
          $scope.options.currentHeader = ['day', 'three_hour'];
        }

        if ($scope.options.scale == 'week') {
          $scope.options.currentHeader = ['week_year', 'dayOnly'];
        }
        if ($scope.options.scale == 'month') {
          $scope.options.currentHeader = ['month', 'week'];
        }
        if ($scope.options.scale == '6 months') {
          $scope.options.currentHeader = ['month', 'week_only'];
        }
        if ($scope.options.scale == 'year') {
          $scope.options.currentHeader = ['year', 'monthOnly'];
        }

        //vm.decideJoinTask();
      },
      changeShowName: function (_data) {
        _data.forEach(function (data) {
          data.tasks.forEach(function (task) {

            if ($scope.options.showName == 'task') {
              task.name = task.task_name;
              task.color = task.task_color || '#333';
            }

            if ($scope.options.showName == 'foreman') {
              task.name = task.task_name + ' - ' + task.foreman;
              task.color = task.foreman_color || '#333';
            }

            if ($scope.options.showName == 'labor_group') {
              task.name = task.task_name + ' - ' + task.labor_group;
              task.color = task.labor_color || '#333';
            }

            if ($scope.options.showName == 'equipment') {
              task.name = task.task_name + ' - ' + task.equipment;
              task.color = task.equipment_color || '#333';
            }

          });
        });
        vm.decideJoinTask();
      },
      currentDate: 'line',
      currentDateValue: moment(),
      draw: false,
      readOnly: false,
      groupDisplayMode: 'group',
      filterTask: '',
      filterRow: '',
      timeFrames: vm.timeFrames,
      dateFrames: {},
      timeFramesWorkingMode: 'hidden',
      timeFramesNonWorkingMode: 'visible',
      columnMagnet: '10 minutes',
      timeFramesMagnet: true,
      dependencies: {
        enabled: true,
        conflictChecker: true
      },
      movable: {
        allowRowSwitching: function () {
          return false;
        }
      },
      corner: {
        headersLabels: function (key) {
          return key.charAt(0).toUpperCase() + key.slice(1);
        },
        headersLabelsTemplates: '{{getLabel(header)}} <i class="fa fa-calendar"></i>'
      },
      targetDataAddRowIndex: undefined,
      canDraw: function (event) {
        var isLeftMouseButton = event.button === 0 || event.button === 1;
        return $scope.options.draw && !$scope.options.readOnly && isLeftMouseButton;
      },
      drawTaskFactory: function () {
        return {
          id: ganttUtils.randomUuid(),  // Unique id of the task.
          name: 'Drawn task', // Name shown on top of each task.
          color: '#AA8833' // Color of the task in HEX format (Optional).
        };
      },
      api: function (api) {
        // API Object is used to control methods and events from angular-gantt.
        $scope.api = api;

        api.core.on.ready($scope, function () {
          // Log various events to console
          api.scroll.on.scroll($scope, logScrollEvent);
          api.core.on.ready($scope, logReadyEvent);

          api.columns.on.generate($scope, function (columns,headers) {
            if(vm.daylightOnly) {
              var hourHeaders = headers.filter(function(h) {return h.length == 24;}).shift();

              _.remove(hourHeaders,function(header) {
                return !(header.date.format('HH') >= '08' && header.date.format('HH') < '20');
              });

            }



          });
          api.data.on.remove($scope, addEventName('data.on.remove', logDataEvent));
          api.data.on.load($scope, addEventName('data.on.load', logDataEvent));
          api.data.on.clear($scope, addEventName('data.on.clear', logDataEvent));
          api.data.on.change($scope, addEventName('data.on.change', logDataEvent));

          api.tasks.on.add($scope, addEventName('tasks.on.add', logTaskEvent));
          api.tasks.on.change($scope, addEventName('tasks.on.change', logTaskEvent));
          api.tasks.on.rowChange($scope, addEventName('tasks.on.rowChange', logTaskEvent));
          api.tasks.on.remove($scope, addEventName('tasks.on.remove', logTaskEvent));

          var _taskFrom = 0;
          var _taskTo = 0;

          if (api.tasks.on.moveBegin) {
            api.tasks.on.moveBegin($scope, addEventName('tasks.on.moveBegin', function (eventName, task) {
              _taskFrom = _.cloneDeep(task.model.from);
              _taskTo = _.cloneDeep(task.model.to);
            }));
            // api.tasks.on.move($scope, addEventName('tasks.on.move', logTaskEvent));
            api.tasks.on.moveEnd($scope, addEventName('tasks.on.moveEnd', function (eventName, task) {

              var rowName = $scope.live.row.name;

              if (task.model.daylight_only) {
                if (!(moment(task.model.to.format('HH:mm'), 'HH:mm').isBetween(moment('08:00', 'HH:mm'), moment('20:00', 'HH:mm'))) || (!(moment(task.model.from.format('HH:mm'), 'HH:mm').isBetween(moment('08:00', 'HH:mm'), moment('20:00', 'HH:mm'))))) {
                  task.$element.addClass('gantt-task-invalid');
                  task.model.isInvalidDaylight = true;
                } else {
                  task.$element.removeClass('gantt-task-invalid');
                  task.model.isInvalidDaylight = false;
                }
              }

              var currentRowIndex = _.findIndex($scope.data, function (block) {
                return block.name == rowName;
              });

              var currentRow = $scope.data[currentRowIndex];

              if (!currentRow.hasTasks) {

                var from = _.cloneDeep(task.model.from);
                var to = _.cloneDeep(task.model.to);

                var fromDiff = from.diff(_taskFrom, 'seconds');
                var toDiff = to.diff(_taskTo, 'seconds');


                if (currentRow.saved_tasks) {
                  currentRow.saved_tasks.filter(function (t) {
                    return t.phase_id === task.model.id;
                  }).forEach(function (_task) {
                    _task.to = moment(_task.to).add('s', (toDiff)).toISOString();
                    _task.from = moment(_task.from).add('s', (fromDiff)).toISOString();
                  });
                }

              }

            }));

            api.tasks.on.resizeBegin($scope, addEventName('tasks.on.resizeBegin', function (eventName, task) {

              _taskFrom = _.cloneDeep(task.model.from);
              _taskTo = _.cloneDeep(task.model.to);

            }));
            // api.tasks.on.resize($scope, addEventName('tasks.on.resize', logTaskEvent));
            api.tasks.on.resizeEnd($scope, addEventName('tasks.on.resizeEnd', function (eventName, task) {

              var rowName = $scope.live.row.name;

              var currentRowIndex = _.findIndex($scope.data, function (block) {
                return block.name == rowName;
              });

              var currentRow = $scope.data[currentRowIndex];

              if (!currentRow.hasTasks && currentRow.saved_tasks.length > 0) {

                var tasksByDateFrom = _.sortBy(currentRow.saved_tasks, [function (o) {
                  return o.from;
                }]);
                var tasksByDateTo = _.sortBy(currentRow.saved_tasks, [function (o) {
                  return o.to;
                }]);

                var first = _.first(tasksByDateFrom);
                var last = _.last(tasksByDateTo);

                var from = _.cloneDeep(task.model.from);
                var to = _.cloneDeep(task.model.to);

                var fromDiff = from.diff(_taskFrom, 'seconds');
                var toDiff = to.diff(_taskTo, 'seconds');


                first.from = moment(first.from).add('s', (fromDiff)).toISOString();
                first.to = moment(first.to).add('s', (fromDiff)).toISOString();
                last.to = moment(last.to).add('s', (toDiff)).toISOString();
                last.from = moment(last.from).add('s', (toDiff)).toISOString();

              }


            }));


          }

          if (api.tasks.on.drawBegin) {
            api.tasks.on.drawBegin($scope, addEventName('tasks.on.drawBegin', logTaskEvent));
            // api.tasks.on.draw($scope, addEventName('tasks.on.draw', logTaskEvent));
            api.tasks.on.drawEnd($scope, addEventName('tasks.on.drawEnd', logTaskEvent));
          }

          api.rows.on.add($scope, addEventName('rows.on.add', logRowEvent));
          api.rows.on.change($scope, addEventName('rows.on.change', logRowEvent));
          api.rows.on.move($scope, addEventName('rows.on.move', logRowEvent));
          api.rows.on.remove($scope, addEventName('rows.on.remove', logRowEvent));

          api.side.on.resizeBegin($scope, addEventName('labels.on.resizeBegin', logLabelsEvent));
          // api.side.on.resize($scope, addEventName('labels.on.resize', logLabelsEvent));
          api.side.on.resizeEnd($scope, addEventName('labels.on.resizeEnd', logLabelsEvent));

          api.timespans.on.add($scope, addEventName('timespans.on.add', logTimespanEvent));
          api.columns.on.generate($scope, logColumnsGenerateEvent);

          api.rows.on.filter($scope, logRowsFilterEvent);
          api.tasks.on.filter($scope, logTasksFilterEvent);

          api.data.on.change($scope, function () {

          });


          $scope.handleTaskIconClick = function (taskModel) {
            alert('Icon from ' + taskModel.name + ' task has been clicked.');
          };

          $scope.handleRowIconClick = function (rowModel) {
            alert('Icon from ' + rowModel.name + ' row has been clicked.');
          };

          $scope.expandAll = function () {
            $scope.api.tree.expandAll();
          };

          $scope.collapseAll = function () {
            $scope.api.tree.collapseAll();
          };

          $scope.$watch('options.sideMode', function (newValue, oldValue) {
            if (newValue !== oldValue) {
              $scope.api.side.setWidth(undefined);
              $timeout(function () {
                $scope.api.columns.refresh();
              });
            }
          });

          $scope.canAutoWidth = function (scale) {
            if (scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/)) {
              return false;
            }
            return true;
          };

          $scope.getColumnWidth = function (widthEnabled, scale, zoom) {
            if (!widthEnabled && $scope.canAutoWidth(scale)) {
              return undefined;
            }

            if (scale.match(/.*?week.*?/)) {
              return 150 * zoom;
            }

            if (scale.match(/.*?month.*?/)) {
              return 300 * zoom;
            }

            if (scale.match(/.*?quarter.*?/)) {
              return 500 * zoom;
            }

            if (scale.match(/.*?year.*?/)) {
              return 800 * zoom;
            }

            return 40 * zoom;
          };


          // Reload data action
          $scope.load = function () {
            generateTaskData();
          };

          // Remove data action
          $scope.remove = function () {
            $scope.api.data.remove();
            $scope.api.dependencies.refresh();
          };

          // Clear data action
          $scope.clear = function () {
            $scope.data = [];
          };

          // Add data to target row index
          $scope.addOverlapTaskToTargetRowIndex = function () {
            var targetDataAddRowIndex = parseInt($scope.options.targetDataAddRowIndex, 10);

            if (targetDataAddRowIndex) {
              var targetRow = $scope.data[$scope.options.targetDataAddRowIndex];

              if (targetRow && targetRow.tasks && targetRow.tasks.length > 0) {
                var firstTaskInRow = targetRow.tasks[0];
                var copiedColor = firstTaskInRow.color;
                var firstTaskEndDate = firstTaskInRow.to.toDate();
                var overlappingFromDate = new Date(firstTaskEndDate);

                overlappingFromDate.setDate(overlappingFromDate.getDate() - 1);

                var overlappingToDate = new Date(overlappingFromDate);

                overlappingToDate.setDate(overlappingToDate.getDate() + 7);

                targetRow.tasks.push({
                  'name': 'Overlapping',
                  'from': overlappingFromDate,
                  'to': overlappingToDate,
                  'color': copiedColor
                });
              }
            }
          };

          // Visual two way binding.
          $scope.live = {};

          var debounceValue = 1000;

          var listenTaskJson = ganttDebounce(function (taskJson) {
            if (taskJson !== undefined) {
              var task = angular.fromJson(taskJson);
              objectModel.cleanTask(task);
              var model = $scope.live.task;
              angular.merge(model, task);
            }
          }, debounceValue);
          $scope.$watch('live.taskJson', listenTaskJson);

          var listenRowJson = ganttDebounce(function (rowJson) {
            if (rowJson !== undefined) {
              var row = angular.fromJson(rowJson);
              objectModel.cleanRow(row);
              var tasks = row.tasks;

              delete row.tasks;
              delete row.drawTask;

              var rowModel = $scope.live.row;

              angular.merge(rowModel, row);

              var newTasks = {};
              var i;
              var l;

              if (tasks !== undefined) {
                for (i = 0, l = tasks.length; i < l; i++) {
                  objectModel.cleanTask(tasks[i]);
                }

                for (i = 0, l = tasks.length; i < l; i++) {
                  newTasks[tasks[i].id] = tasks[i];
                }

                if (rowModel.tasks === undefined) {
                  rowModel.tasks = [];
                }
                for (i = rowModel.tasks.length - 1; i >= 0; i--) {
                  var existingTask = rowModel.tasks[i];
                  var newTask = newTasks[existingTask.id];
                  if (newTask === undefined) {
                    rowModel.tasks.splice(i, 1);
                  } else {
                    objectModel.cleanTask(newTask);
                    angular.merge(existingTask, newTask);
                    delete newTasks[existingTask.id];
                  }
                }
              } else {
                delete rowModel.tasks;
              }

              angular.forEach(newTasks, function (newTask) {
                rowModel.tasks.push(newTask);
              });
            }
          }, debounceValue);
          $scope.$watch('live.rowJson', listenRowJson);

          $scope.$watchCollection('live.task', function (task) {
            $timeout(function () {
              $scope.live.taskJson = angular.toJson(task, true);
              $scope.live.rowJson = angular.toJson($scope.live.row, true);
            });
          });

          $scope.$watchCollection('live.row', function (row) {
            $timeout(function () {
              $scope.live.rowJson = angular.toJson(row, true);
              if (row !== undefined && row.tasks !== undefined && row.tasks.indexOf($scope.live.task) < 0) {
                $scope.live.task = row.tasks[0];
              }
            });

          });

          $scope.$watchCollection('live.row.tasks', function () {
            $timeout(function () {
              $scope.live.rowJson = angular.toJson($scope.live.row, true);
            });
          });

          // When gantt is ready, load data.
          // `data` attribute could have been used too.
          $scope.load();

          // Add some DOM events
          api.directives.on.new($scope, function (directiveName, directiveScope, element) {
            if (directiveName === 'ganttTask') {
              element.bind('click', function (event) {
                event.stopPropagation();
                logTaskEvent('task-click', directiveScope.task);
              });
              element.bind('mousedown touchstart', function (event) {
                event.stopPropagation();
                $scope.live.row = directiveScope.task.row.model;
                if (directiveScope.task.originalModel !== undefined) {
                  $scope.live.task = directiveScope.task.originalModel;
                } else {
                  $scope.live.task = directiveScope.task.model;
                }
                $scope.$digest();
              });


            } else if (directiveName === 'ganttRow') {
              element.bind('click', function (event) {
                event.stopPropagation();
                logRowEvent('row-click', directiveScope.row);
              });
              element.bind('mousedown touchstart', function (event) {
                event.stopPropagation();
                $scope.live.row = directiveScope.row.model;
                $scope.$digest();
              });
            } else if (directiveName === 'ganttRowLabel') {
              element.off('click');
              element.bind('click', function () {
                logRowEvent('row-label-click', directiveScope.row);
                //openDialog(event, directiveScope.row.model);
              });
              element.bind('mousedown touchstart', function () {
                $scope.live.row = directiveScope.row.model;
                $scope.$digest();
              });
            }
          });

          api.tasks.on.rowChange($scope, function (task) {
            $scope.live.row = task.row.model;
          });

          objectModel = new GanttObjectModel(api);
        });
      }
    };

    vm.addNewTask = function () {


    };

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.search = search;
    vm.setSortMode = setSortMode;
    vm.canAutoWidth = canAutoWidth;
    vm.getColumnWidth = getColumnWidth;
    vm.load = load;
    vm.reload = reload;
    vm.openDialogWorkSchedule = openDialogWorkSchedule;
    vm.openDialogAssignTeams = openDialogAssignTeams;
    vm.openGanttTaskDialog = openGanttTaskDialog;
    vm.changeWorkTemplate = changeWorkTemplate;

    vm.unjoinTasks = function () {
      if ($scope.data) {
        var _data = _.cloneDeep($scope.data);
        $scope.api.data.clear();
        $timeout(function () {
          $scope.data = _data;
          _data.forEach(function (item) {
            if (!item.hasTasks) {
              if (item.tasks.length > 0) {
                item.tasks = _.cloneDeep(item.saved_tasks);
              }
              item.hasTasks = true;
            }
          });
          vm.reload($scope.data);
        }, 250);
      }
    };

    vm.getAnchorName = function (date) {
      return AnchorTypeDefinitionService.getAnchorName(date.anchor_id);
    };

    vm.hasPreWaterTask = function (block) {

      var allTasks = _.flatten(block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));

      return _.findIndex(allTasks, function (t) {
        return t.pre_water == true;
      }) !== -1;

    };

    vm.hasGrowingTask = function (block) {

      var allTasks = _.flatten(block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));

      return _.findIndex(allTasks, function (t) {
        return t.growing_start_date == true;
      }) !== -1;

    };

    vm.hasTillageTask = function (block) {
      var allTasks = _.flatten(block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));

      return _.findIndex(allTasks, function (t) {
        return t.tillage_date == true;
      }) !== -1;
    };

    vm.hasIrrigationTask = function (block) {
      var allTasks = _.flatten(block.work_template.phases.map(function (phase) {
        return phase.tasks;
      }));

      return _.findIndex(allTasks, function (t) {
        return t.irrigation_date == true;
      }) !== -1;
    };


    vm.changeDate = function () {

      $scope.options.fromDate = moment($scope.options.pickerFromDate);
      $scope.options.toDate = $scope.options.fromDate;

    };

    vm.decideJoinTask = function () {

      if ($scope.options.showName == 'task') {
        vm.unjoinTasks();
      } else if ($scope.options.showName == 'phase') {
        vm.joinTasks();
      }

    };

    vm.joinTasks = function () {
      if ($scope.data) {
        var _data = _.cloneDeep($scope.data);
        $scope.api.data.clear();
        $timeout(function () {
          $scope.data = _data;
          _data.forEach(function (item) {
            if (item.tasks.length > 0 && item.hasTasks) {
              var savedTasks = _.cloneDeep(item.tasks);

              _.remove(item.tasks, function () {
                return true;
              });

              item.saved_tasks = savedTasks;
              item.hasTasks = false;

              var tasks_by_phase = _.groupBy(savedTasks, function (task) {
                return task.phase_id;
              });

              _.forEach(tasks_by_phase, function (phaseGroup) {

                var tasksByDateFrom = _.sortBy(phaseGroup, [function (o) {
                  return o.from;
                }]);
                var tasksByDateTo = _.sortBy(phaseGroup, [function (o) {
                  return o.to;
                }]);

                var first = _.head(tasksByDateFrom);
                var last = _.last(tasksByDateTo);

                var phaseObj = {
                  'id': first.phase_id,
                  'name': first.phase_name,
                  'classes': [],
                  'from': _.cloneDeep(first.from),
                  'to': _.cloneDeep(last.to),
                  'color': first.phase_color,
                  'time_anchor': false,
                  'labor_group': first.phase_name,
                  'foreman': first.phase_name,
                  'task_name': first.phase_name
                };

                item.tasks.push(phaseObj);

              });


            }

          });
          vm.reload($scope.data);
        }, 250);
      }

    };

    /**
     * Generate reload
     */
    function reload(_data) {
      $scope.api.data.clear();
      $timeout(function () {
        $scope.data = _.cloneDeep(_data);
        $scope.api.rows.refresh();
        $scope.api.dependencies.refresh();
        $scope.api.side.setWidth(undefined);
      }, 250);
    }


    vm.moment = function (date) {
      return moment(date);
    };


    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }


    /**
     * Search
     * @param sidenavId
     */
    function search(option, keyword) {
      if (option === 'rows') {
        $scope.options.filterRow = keyword;
      }
      else if (option === 'tasks') {
        $scope.options.filterTask = keyword;
      }
    }

    /**
     * Sort Mode
     * @param mode
     */
    function setSortMode(mode) {
      vm.options.sortMode = mode;

      if (angular.isUndefined(mode)) {
        vm.options.rowSortable = true;
      }
      else {
        vm.options.rowSortable = false;
      }
    }

    vm.goPreviousDate = function () {
      var unit = 'day';

      if ($scope.options.scale == 'week') {
        unit = 'week';
      }

      if ($scope.options.scale.indexOf('month') !== -1) {
        unit = 'month';
      }

      if ($scope.options.scale.indexOf('year') !== -1) {
        unit = 'year';
      }

      $scope.options.fromDate = _.cloneDeep($scope.options.fromDate.subtract(1, unit));
      $scope.options.toDate = _.cloneDeep($scope.options.toDate.subtract(1, unit));

    };


    vm.goNextDate = function () {
      var unit = 'day';

      if ($scope.options.scale == 'week') {
        unit = 'week';
      }

      if ($scope.options.scale.indexOf('month') !== -1) {
        unit = 'month';
      }

      if ($scope.options.scale.indexOf('year') !== -1) {
        unit = 'year';
      }

      $scope.options.fromDate = _.cloneDeep($scope.options.fromDate.add(1, unit));
      $scope.options.toDate = _.cloneDeep($scope.options.toDate.add(1, unit));

    };

    /**
     * Generate canAutoWidth
     */
    function canAutoWidth(scale) {
      if (scale.match(/.*?hour.*?/) || scale.match(/.*?minute.*?/)) {
        return false;
      }

      return true;
    }

    /**
     * Generate getColumnWidth
     */
    function getColumnWidth(widthEnabled, scale, zoom) {
      if (!widthEnabled && vm.canAutoWidth(scale)) {
        return undefined;
      }

      if (scale.match(/.*?week.*?/)) {
        return 150 * zoom;
      }

      if (scale.match(/.*?month.*?/)) {
        return 300 * zoom;
      }

      if (scale.match(/.*?quarter.*?/)) {
        return 500 * zoom;
      }

      if (scale.match(/.*?year.*?/)) {
        return 800 * zoom;
      }

      return 40 * zoom;
    }

    /**
     * Generate load
     */
    function load() {
      //vm.data = Tasks.data;
      generateTaskData();
      vm.timespans = {};

      // Fix for Angular-gantt-chart issue
      $animate.enabled(true);
      $animate.enabled($document.find('#gantt'), false);

    }

    /**
     * Generate data
     */
    function generateTaskData() {

      if (vm.ganttBlockMode) {

        vm.timeFrames = {
          day: {
            start: moment('08:00', 'HH:mm'),
            end: moment('20:00', 'HH:mm'),
            working: true, // This is a working period
            default: true, // It will be used for each day
            color: 'WhiteSmoke',
            classes: ['gantt-day']
          },
          night: {
            start: moment('20:00', 'HH:mm'),
            end: moment('23:59', 'HH:mm'),
            working: false, // This is a working period
            default: true, // It will be used for each day
            color: 'LightSlateGrey',
            classes: ['gantt-night']
          },
          night2: {
            start: moment('00:00', 'HH:mm'),
            end: moment('08:00', 'HH:mm'),
            working: false, // This is a working period
            default: true, // It will be used for each day
            color: 'LightSlateGrey',
            classes: ['gantt-night']
          }
        };

        $scope.data = vm.growerSchedules.map(function (g) {
          return {
            'id': g.id,
            'name': g.block_name,
            'height': '3em',
            'classes': [],
            'tasks': [],
            'scheduled_wet_date': g.scheduled_wet_date,
            'original_harvest_date': g.original_harvest_date,
            'scheduled_growing_date': g.scheduled_growing_date,
            'scheduled_tillage_date': g.scheduled_tillage_date,
            'scheduled_irrigation_date': g.scheduled_irrigation_date,
            'scheduled_pre_water_date': g.scheduled_pre_water_date,
            'acres_in_block': g.acres_in_block
          };
        });
      } else {

        vm.timeFrames = {
          day: {
            start: moment('08:00', 'HH:mm'),
            end: moment('00:00', 'HH:mm'),
            working: true, // This is a working period
            default: true, // It will be used for each day
            color: 'WhiteSmoke',
            classes: ['gantt-day']
          }
        };

        $scope.data = vm.users.map(function (g) {
          return {
            'id': g.id,
            'name': g.name,
            'height': '3em',
            'classes': [],
            'tasks': []
          };
        });

      }


      vm.reload($scope.data);


    }


    vm.changeGanttMode = function () {
      generateTaskData();
    };


    vm.getDuration = getDuration;

    /**
     * Generate getDuration
     */
    function getDuration(from, to) {
      return humanize_pro(moment.duration(_.cloneDeep(to).diff(_.cloneDeep(from))));
    }

    /**
     * Generate humanize_pro
     */
    function humanize_pro(time) {
      time = time._data;
      if (time.years > 0) {
        return time.years + ' years ' + time.months + ' months ';
      }
      if (time.months > 0) {
        return time.months + ' months ' + time.days + ' days ';
      }
      if (time.days > 0) {
        return time.days + ' days ' + time.hours + ' hours';
      }
      if (time.hours > 0) {
        return time.hours + ' hours ' + time.minutes + ' minutes';
      }
      if (time.minutes > 0) {
        return time.minutes + ' minutes ';
      }
      return '';
    }

    vm._rolesGroups = [];
    vm._laborGroups = [];

    /**
     * Generate openDialog
     */
    function openDialogWorkSchedule(ev, block) {


      $mdDialog.show({
        controller: 'GanttChartAddEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pages/work-schedule/dialogs/add-edit/block-work-template-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          dialogData: {
            block: block,
            data: $scope.data,
            reload: reload,
            changeShowName: $scope.options.changeShowName,
            changeWorkTemplate: vm.changeWorkTemplate,
            decideJoinTasks: vm.decideJoinTask,
            users: vm.users,
            labors: vm.laborGroups,
            foremans: vm.allRolesGroups,
            equipments: vm.equipmentGroups
          }
        }
      });
    }


    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function updateTaskModel(task, group) {
      if (vm.exists(group.id, task.ng)) {
        task.ng.splice(task.ng.indexOf(group.id), 1);
      } else {
        task.ng.push(group.id);
      }
    }

    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function openGanttTaskDialog(ev, block) {


      $mdDialog.show({
        controller: 'GanttTaskDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/farm-admin/work-schedule-template/work-schedule-tasks/task/dialog/task-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          dialogData: {
            task: {},
            tasks: vm.tasks,
            roles: vm.allRolesGroups,
            notifyGroups: vm.allNotifyGroups,
            block: block,
            filterIds: vm.filterIds,
            shownTasks: vm.shownTasks,
            reload: reload,
            ganttBlockMode: vm.ganttBlockMode,
            ganttData: $scope.data,
            updateTaskModel: updateTaskModel
          }
        }
      });


    }

    /**
     * Function to patch notify-group add or remove form an user.
     *
     * @return {[type]} [description]
     */
    function openDialogAssignTeams(ev, block) {


      $mdDialog.show({
        controller: 'GanttChartAddEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pages/work-schedule/dialogs/add-edit/assign-teams-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          dialogData: {
            block: block,
            data: $scope.data,
            reload: reload,
            changeShowName: $scope.options.changeShowName,
            changeWorkTemplate: vm.changeWorkTemplate,
            decideJoinTasks: vm.decideJoinTask,
            users: vm.users,
            labors: vm.laborGroups,
            foremans: vm.allRolesGroups,
            equipments: vm.equipmentGroups
          }
        }
      });
    }


    vm.openBlockPreparationCalculator = function (ev, block) {
      ev.stopPropagation();
      $mdDialog.show({
        controller: 'GanttChartAddEditDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pages/work-schedule/dialogs/add-edit/edit-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: false,
        locals: {
          dialogData: {
            block: block,
            data: $scope.data,
            reload: reload,
            changeShowName: $scope.options.changeShowName,
            changeWorkTemplate: vm.changeWorkTemplate,
            decideJoinTasks: vm.decideJoinTask,
            users: vm.users,
            labors: vm.laborGroups,
            foremans: vm.allRolesGroups
          }
        }
      });

    };

    /**
     * Generate changeWorkTemplate
     */
    function changeWorkTemplate(block) {


      /**
       * Generate getMinutes
       */
      function getMinutes(block, task) {
        if (task.time_to_complete_mesured_by_acre) {
          return task.estimated_minutes * block.acres_in_block;
        }
        return task.estimated_minutes2;
      }





      var phases = [];

      if (block.work_template.phases) {
        phases = block.work_template.phases;
      }

      var gantt_tasks = [];

      var rootTime = _.cloneDeep(moment());


      _.flatten(phases.map(function (phase) {
        phase.tasks.forEach(function (t) {
          t.phase_id = phase.id;
          t.phase_name = phase.name;
          t.phase_color = phase.color;
        });
        return phase.tasks;
      }));

      var wetDateId = vm.anchorDefinitions.filter(function (a) {
        return a.wetDate == true;
      }).shift();
      if (wetDateId) {
        wetDateId = wetDateId.id;
      } else {
        wetDateId = null;
      }

      var harvestDateId = vm.anchorDefinitions.filter(function (a) {
        return a.harvestDate == true;
      }).shift();
      if (harvestDateId) {
        harvestDateId = harvestDateId.id;
      } else {
        harvestDateId = null;
      }

      var assignAnchorId = vm.anchorDefinitions.filter(function (a) {
        return a.assignAnchorDate == true;
      }).shift();
      if (assignAnchorId) {
        assignAnchorId = assignAnchorId.id;
      } else {
        assignAnchorId = null;
      }

      var normalId = 7;
      var lastGroupId = normalId;

      _.forEach(phases, function (phase, _index) {

        if (phase.tasks.filter(function (t) {
          return t.anchor_id != normalId;
        }).length > 0) {
          phase.group = lastGroupId = phase.tasks.filter(function (t) {
            return t.anchor_id != normalId;
          }).shift().anchor_id;

        } else {
          phase.group = lastGroupId;
        }

        phase.posIndex = _index;

      });


      var _phases = _.groupBy(phases, function (p) {
        return p.group;
      });


      var finalPhases = [];

      if (!block.dates) {
        block._prevDates = [];
      } else {
        block._prevDates = _.cloneDeep(block.dates);
      }

      block.dates = [];

      _.forEach(_phases, function (p, index) {
        var tasks = _.flatten(_.map(p, function (pp) {
          return pp.tasks;
        }));

        var date;

        var savedDate = block._prevDates.filter(function (d) {
          return d.anchor_id == index;
        });

        if (savedDate.length > 0) {
          date = savedDate.shift().date;
        } else if (index == wetDateId) {
          date = moment(block.scheduled_wet_date);
        } else if (index == harvestDateId) {
          date = moment(block.original_harvest_date);
        } else {
          date = moment();
        }

        block.dates.push({anchor_id: index, date: date});

        finalPhases.push({tasks: tasks, anchor_id: index});
      });

      finalPhases = _.sortBy(finalPhases, function (p) {
        return block.dates.filter(function (d) {
          return d.anchor_id == p.anchor_id;
        }).shift().date;
      });

      _.forEach(finalPhases, function (phase, phase_index) {
        if (phase.tasks.length > 0) {

          var anchorTaskIndex = _.findIndex(phase.tasks, function (task) {
            return task.anchor_id != normalId;
          });

          if (anchorTaskIndex === -1) {
            anchorTaskIndex = 0;
          }

          var anchorTask = phase.tasks[anchorTaskIndex];

          if (anchorTask.anchor_id !== normalId) {

            rootTime = _.cloneDeep(moment(block.dates.filter(function (d) {
              return d.anchor_id == anchorTask.anchor_id;
            }).shift().date));

          }

          /* if (anchorTask.anchor_id == wetDateId) {
             rootTime = _.cloneDeep(moment(block.scheduled_wet_date));
           } else if (anchorTask.pre_water) {
             if (block.scheduled_pre_water_date !== null) {

               _index = _.findIndex(phase.tasks, function (task) {
                 return task.pre_water;
               });
               if (_index !== -1) {
                 anchorTaskIndex = _index;
               }

               rootTime = _.cloneDeep(moment(block.scheduled_pre_water_date));
             }
           } else if (anchorTask.growing_start_date) {
             if (block.scheduled_growing_date !== null) {

               _index = _.findIndex(phase.tasks, function (task) {
                 return task.growing_start_date;
               });
               if (_index !== -1) {
                 anchorTaskIndex = _index;
               }

               rootTime = _.cloneDeep(moment(block.scheduled_growing_date));
             }
           } else if (anchorTask.harvest_date) {
             rootTime = _.cloneDeep(moment(block.original_harvest_date));
           } else if (anchorTask.tillage_date) {
             if (block.scheduled_tillage_date !== null) {
               rootTime = _.cloneDeep(moment(block.scheduled_tillage_date));
             }
           } else if (anchorTask.irrigation_date) {
             if (block.scheduled_irrigation_date !== null) {

               _index = _.findIndex(phase.tasks, function (task) {
                 return task.irrigation_date;
               });
               if (_index !== -1) {
                 anchorTaskIndex = _index;
               }

               rootTime = _.cloneDeep(moment(block.scheduled_irrigation_date));
             }
           }*/
          //gantt_tasks = phase.tasks.slice(0, anchorTaskIndex).concat(phase.tasks[anchorTaskIndex]).concat(phase.tasks.slice(anchorTaskIndex + 1, phase.tasks.length));

          var _repeat = true;
          var _repeatCount = 0;
          while (_repeat) {

            var bucketSize = 0;
            _.forEach(phase.tasks, function (gt, index) {

              var anchorTime = moment(_.cloneDeep(rootTime));
              var times;
              if (index < anchorTaskIndex) {
                times = phase.tasks.slice(index, anchorTaskIndex).map(function (t) {
                  return getMinutes(block, t) * -1;
                });
              } else if (index === anchorTaskIndex) {
                times = [0];
              } else {
                times = phase.tasks.slice(anchorTaskIndex, index).map(function (t) {
                  return getMinutes(block, t);
                });
              }

              var total = 0;

              total += _.sum(times);

              var __phase = phases.filter(function (p) {
                return p.id == gt.phase_id;
              }).shift();

              var gap = 0;
              if (__phase.repeatGap) {
                gap = __phase.repeatGap;
                if (_repeatCount != 0)
                  total += gap * 24 * 60;
              }

              var from = _.cloneDeep((anchorTime)).add('m', total);
              var to = _.cloneDeep(from).add('m', getMinutes(block, gt));

              bucketSize += getMinutes(block, gt);


              var laborArr = vm.laborGroups.filter(function (u) {
                return u.id == gt.labor_task_group_id;
              });
              var laborName = '';
              if (laborArr.length > 0) {
                laborName = laborArr.shift().name;
              }

              var foremanArr = vm.userRoles.filter(function (u) {
                return u.id == gt.user_role_id;
              });
              var foreman = '';
              if (foremanArr.length > 0) {
                foreman = foremanArr.shift().name;
              }

              var equipmentArr = vm.equipmentGroups.filter(function (u) {
                return u.id == gt.equipment_task_group_id;
              });
              var equipmentName = '';
              if (equipmentArr.length > 0) {
                equipmentName = equipmentArr.shift().name;
              }

              var tt = {};
              if (block.tasks) {
                var blockTaskItem = block.tasks.filter(function (t) {
                  return t.original_id == gt.id;
                }).shift();
                if (blockTaskItem) {
                  tt = blockTaskItem;
                }
              }

              gantt_tasks.push({
                'id': ganttUtils.randomUuid(),
                'original_id': gt.id,
                'name': gt.name,
                'classes': [],
                'from': from,
                'to': to,
                'color': gt.color,
                'daylight_only': gt.daylight_only,
                'task_color': gt.color,
                'time_anchor': gt.time_anchor,
                'pre_water': gt.pre_water,
                'growing_start_date': gt.growing_start_date,
                'tillage_date': gt.tillage_date,
                'irrigation_date': gt.irrigation_date,
                'harvest_date': gt.harvest_date,
                'equipment_color': tt.equipment_color,
                'labor_color': tt.labor_color,
                'foreman_color': tt.foreman_color,
                'labor_group': laborName,
                'labor_group_id': gt.labor_task_group_id,
                'equipment_id': gt.equipment_task_group_id,
                'equipment': equipmentName,
                'foreman': foreman,
                'foreman_id': gt.user_role_id,
                'anchor_id': gt.anchor_id,
                'task_name': gt.name,
                'phase_id': gt.phase_id,
                'phase_name': gt.phase_name,
                'phase_color': gt.phase_color
              });

              if (index === phase.tasks.length - 1) {
                rootTime = _.cloneDeep(to);

              }

            });

            if (phase_index < finalPhases.length) {
              if (AnchorTypeDefinitionService.getAnchor(phase.tasks[anchorTaskIndex].anchor_id).repeats) {
                if (finalPhases[phase_index + 1] && finalPhases[phase_index + 1].tasks && finalPhases[phase_index + 1].tasks.length > 0) {

                  var nextAnchorTaskIndex = _.findIndex(finalPhases[phase_index + 1].tasks, function (task) {
                    return task.anchor_id != normalId;
                  });

                  if (nextAnchorTaskIndex != -1) {

                    var times2 = finalPhases[phase_index + 1].tasks.slice(0, nextAnchorTaskIndex).map(function (t) {
                      return getMinutes(block, t);
                    });

                    var _date2 = _.cloneDeep(moment(block.dates.filter(function (d) {
                      return d.anchor_id == finalPhases[phase_index + 1].tasks[nextAnchorTaskIndex].anchor_id;
                    }).shift().date));


                    var __total = 0;

                    __total += _.sum(times2);

                    if (_.cloneDeep(rootTime).add('m', bucketSize) >= _date2.add('m', __total * -1)) {
                      _repeat = false;
                    }

                  } else {
                    _repeat = false;
                  }
                } else {
                  _repeat = false;
                }

              } else {
                _repeat = false;
              }
            } else {
              _repeat = false;
            }


            _repeatCount++;

          }


          /* if (index < phases.length - 1 && phases[index + 1].tasks.length > 0) {

           var nextAnchorTaskIndex = _.findIndex(phases[index + 1].tasks, function (task) {
           return task.time_anchor;
           });

           var times = phase.tasks.slice(anchorTaskIndex, phase.tasks.length).map(function (t) {
           return getMinutes(block, t);
           });
           var times2 = phases[index + 1].tasks.slice(0, nextAnchorTaskIndex).map(function (t) {
           return getMinutes(block, t);
           });

           var total = 0;
           var gap = 10;

           total += _.sum(times.concat(times2));

           rootTime.add('m', total + gap);

           }*/


        }
      }
      );

      block.tasks = gantt_tasks;

      var tasksByDateFrom = _.sortBy(block.tasks, [function (o) {
        return o.from;
      }]);


      var first = _.first(tasksByDateFrom);

      if (first) {
        $scope.options.fromDate = _.cloneDeep(first.from);
        $scope.options.toDate = _.cloneDeep(first.from);
      }


      block.hasTasks = true;
      //$scope.options.changeShowName([block]);
      $scope.options.showName = 'task';


    }


  }
})();

(function () {
  'use strict';

  angular
    .module('app.pages.planting-schedule')
    .controller('PlantingScheduleCtrl', PlantingScheduleCtrl);

  /** @ngInject */
  function PlantingScheduleCtrl(
    $q,
    $scope,
    $mdToast,
    $mdSidenav,
    $mdDialog,
    $location,
    $document,
    $translate,
    $state,
    $filter,
    ContractService,
    PlantingScheduleService,
    SeasonsService,
    AreaFiscalYearService,
    AreaService,
    RanchService,
    CompanyService,
    msUtils,
    AclService,
    api,
    _
  ) {
    var vm = this;
    vm.listType = 'all';
    vm.filterIds = [];
    // Data
    vm.starredContracts = [];
    vm.allContracts = [];
    vm.contracts = [];
    vm.fiscal_years = [];
    vm.selected_fiscal_year = '';
    vm.offset = 20;
    vm.maxListLength = 20;
    vm.shippers = [];
    vm.allSeasons = [];
    vm.allWeekEnding = [];
    vm.allRanches = [];
    vm.allShippers = [];
    vm.allBlockStatus = [{ id: 1, name: 'Not Shaped' }, { id: 2, name: 'Shaped - Pending' }, { id: 3, name: 'Shaped - Approved' }];
    vm.allPlantingStatus = [{ id: 1, name: 'Not Scheduled' }, { id: 2, name: 'Scheduled - Pending' }, { id: 3, name: 'Scheduled - Grower Approved' }, { id: 4, name: 'Scheduled - Shipper Approved' }, { id: 5, name: 'Planted - Pending' }, { id: 6, name: 'Planted - Grower Approved' }, { id: 7, name: 'Planted - Shipper Approved' }];
    vm.season_id = null;
    vm.weekEnding_id = null;
    vm.ranch_id = null;
    vm.shipper_id = null;
    vm.blockStatus_id = null;
    vm.plantingStatus_id = null;
    vm.location_id = null;
    vm.starred_id = null;
    vm.user = null;

    //layout
    vm.selectedContracts = [];
    $scope.event = window.event;

    // Methods
    vm.selectAllContracts = selectAllContracts;
    vm.deselectContracts = deselectContracts;
    vm.toggleSelectContract = toggleSelectContract;
    vm.deleteSelectedContracts = deleteSelectedContracts;
    vm.deleteContract = deleteContract;
    vm.filterChange = filterChange;
    //vm.addContractDialog = addContractDialog;
    vm.editContract = editContract;
    vm.addContract = addContract;
    vm.patchStarred = patchStarred;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.loadMore = loadMore;
    vm.toggleSidenav = toggleSidenav;

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      $scope.loadingData = true;
      // api.contracts.get({}, function(ContractsData) {
      PlantingScheduleService.get().then(function (ContractsData) {
        vm.contracts = ContractsData;
        $scope.filteredContracts = vm.contracts;
        angular.forEach(vm.contracts, function (contract) {
          // Add shipper on filter array
          if (contract.company_id && contract.shipper) {
            var idx = _.find(vm.shippers, { 'id': contract.company_id });
            if (!idx) {
              vm.shippers.push({ id: contract.company_id, name: contract.shipper });
            }
          }
          vm.allContracts.push(contract.id);
          if (contract.starred === true) {
            vm.starredContracts.push(contract.id);
          }
          // allShippers.push(contract.shippers);
          if (!find(contract.shippers, vm.allShippers)) {
            vm.allShippers.push({ id: contract.shippers_id, name: contract.shippers });
          }
        });
        vm.shippers = _.orderBy(vm.shippers, ['name']);
        $scope.loadingData = false;

      },
        function (err) {
          console.error(err);
        });

      PlantingScheduleService.getPlantingScheduleWithOffset(0, vm.maxListLength).then(function (contractsData) {
        vm.shownContracts = contractsData;
        vm.shownContracts.forEach(function (contract) {
          vm.filterIds.push(contract.id);
        });
      });


      vm.user = JSON.parse(sessionStorage.getItem('user'));
      /* Get the area fiscal year and all locations under the global selected area id */
      if (vm.user && vm.user.default_global_area_fiscal_year_id) {
        AreaFiscalYearService.getAreaFiscalYear(vm.user.default_global_area_fiscal_year_id).then(function (areaFiscalYearData) {
          // calculate week endings of Fiscal Year
          if (areaFiscalYearData && areaFiscalYearData.area_fiscal_year && areaFiscalYearData.area_fiscal_year.fiscal_year) {
            var fiscal_year = areaFiscalYearData.area_fiscal_year.fiscal_year;
            calculateWeekEndings(fiscal_year.begin_date, fiscal_year.end_date);
          }
          var area_id = areaFiscalYearData.area_fiscal_year.area_id;
          AreaService.getAreaLocations(area_id).then(function (locationsData) {
            vm.allLocations = locationsData.locations;
          },
            function (err) {
              console.error(err);
            });
        },
          function (err) {
            console.error(err);
          });
      }


    }
    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function loadMore() {
      if (vm.shownContracts.length === vm.contracts.length) {
        return;
      }
      else {
        PlantingScheduleService.PlantingScheduleService(vm.offset, vm.maxListLength).then(function (contractsData) {
          if (contractsData.contracts.length > 0) {
            vm.shownContracts = vm.shownContracts.concat(contractsData);
            contractsData.contracts.forEach(function (contract) {
              vm.filterIds.push(contract.id);
            });
          }
          else
            return;
        });
        vm.offset += vm.maxListLength;
      }
    }

    /**
     * Change Contracts List Filter
     * @param type
     */
    function filterChange(type, type_id) {

      vm.shownContracts = vm.contracts;
      var aux_contracts = [];

      if (type === 'all') {
        vm.season_id = null;
        vm.weekEnding_id = null;
        vm.ranch_id = null;
        vm.shipper_id = null;
        vm.blockStatus_id = null;
        vm.plantingStatus_id = null;
        vm.location_id = null;
        vm.starred_id = null;
      }

      if (type === 'season') {
        vm.weekEnding_id = null;
        // remove Week Ending from filters
      }
      if (type === 'location') {
        RanchService.getRanchesByLocation(vm.location).then(function (ranchesData) {
          vm.allRanches = ranchesData.ranches;
        });
      }

      if (type === 'season') {
        var season_data = _.find(vm.allSeasons, { id: vm.season_id });
        calculateWeekEndings(season_data.start_day, season_data.end_day);
        aux_contracts = [];
        angular.forEach(vm.contracts, function (contract) {
          var season_start = new Date(season_data.start_day);
          var season_end = new Date(season_data.end_day);
          if (contract.scheduled_wet_date) {
            var date = new Date(contract.scheduled_wet_date);
            if (date >= season_start && date <= season_end) {
              aux_contracts.push(contract);
            }
          }
        });
        // vm.shownContracts = aux_contracts;
      }

      if (type === 'shipper' || vm.shipper_id != null) {
        if (type === 'shipper') {
          vm.shipper_id = type_id;
        }
        aux_contracts = [];
        angular.forEach(vm.shownContracts, function (contract) {
          if (contract.shippers_id === vm.shipper_id) {
            aux_contracts.push(contract);
          }
        });
        vm.shownContracts = aux_contracts;
      }
      if (type === 'blockStatus' || vm.blockStatus_id != null) {
        if (type === 'blockStatus') {
          vm.blockStatus_id = type_id;
        }
        aux_contracts = [];
        angular.forEach(vm.shownContracts, function (contract) {
          if (contract.block_status_id === vm.blockStatus_id) {
            aux_contracts.push(contract);
          }
        });
        vm.shownContracts = aux_contracts;
      }
      if (type === 'plantingStatus' || vm.plantingStatus_id != null) {
        if (type === 'plantingStatus') {
          vm.plantingStatus_id = type_id;
        }
        aux_contracts = [];
        angular.forEach(vm.shownContracts, function (contract) {
          if (contract.planting_status_id === vm.plantingStatus_id) {
            aux_contracts.push(contract);
          }
        });
        vm.shownContracts = aux_contracts;
      }
      if (type === 'starred' || vm.starred_id != null) {
        if (type === 'starred') {
          vm.starred_id = type_id;
        }
        aux_contracts = [];
        angular.forEach(vm.shownContracts, function (contract) {
          if (contract.starred) {
            aux_contracts.push(contract);
          }
        });
        vm.shownContracts = aux_contracts;
      }

    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }


    /**
     * Function to handle the behavior of add/edit an user.
     */
    /*
    function addContractDialog(ev) {
      $mdDialog.show({
        controller: 'PlantingScheduleDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pages/contracts/dialogs/planting-schedule/planting-schedule-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            shippers: vm.shippers,
            contracts: vm.contracts,
            shownContracts: vm.shownContracts,
            starredContracts: vm.starredContracts,
            filterIds: vm.filterIds,
            dialogType: 'add'
          }
        }
      });
    }*/

    /**
     * Deselect contracts
     */
    function deselectContracts() {
      vm.selectedContracts = [];
    }

    /**
     * Select all contracts
     */
    function selectAllContracts() {
      vm.selectedContracts = $scope.filteredContracts;
    }

    /**
     * Toggle selected status of the contract
     *
     * @param contract
     * @param event
     */
    function toggleSelectContract(contract) {
      event.stopPropagation();

      if (vm.selectedContracts.indexOf(contract) > -1) {
        vm.selectedContracts.splice(vm.selectedContracts.indexOf(contract), 1);
      } else {
        vm.selectedContracts.push(contract);
      }
    }

    /**
     * [addContract description]
     * @param  {[type]} ev    [description]
     * @param  {[type]}  [description]
     * @return {[type]}       [description]
     */
    function addContract() {
      $location.url('/planting-schedule/add');
    }

    /**
     * [editContract description]
     * @param  {[type]} ev    [description]
     * @param  {[type]} contract [description]
     * @return {[type]}       [description]
     */
    function editContract(ev, contract) {
      $location.url('/planting-schedule/edit/' + contract.id);
    }

    /**
     * Delete Selected Contracts
     */
    function deleteSelectedContracts(ev) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('PLANTING_SCHEDULE.ARE_YOU_SURE_TO_DELETE_BULK'))
        .htmlContent('<b>' + vm.selectedContracts.length + ' selected</b>' + ' will be deleted.')
        .ariaLabel('delete contracts')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        var arrIds = [];
        vm.selectedContracts.forEach(function (contract) {
          arrIds.push(contract.id);
        });
        ContractService.bulkDelete(arrIds).then(function () {
          vm.selectedContracts.forEach(function (contract) {
            vm.contracts.splice(vm.contracts.indexOf(contract), 1);
            vm.shownContracts.splice(vm.shownContracts.indexOf(contract), 1);
          });
          vm.selectedContracts = [];
          $mdToast.show({
            template: '<md-toast class="md-toast success">The contracts were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });

        },
          function () {
            $mdToast.show({
              template: '<md-toast class="md-toast error">The contracts could not be deleted.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
          });
      },
        function () {
          // avoid unhandled rejection message.
        });
    }

    /**
     * [deleteContract description]
     * @param  {[type]} id [description]
     * @return {[type]}
     */
    function deleteContract(ev, contract) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('PLANTING_SCHEDULE.ARE_YOU_SURE_TO_DELETE_BULK'))
        .htmlContent('The contract <b>' + contract.number + '</b>' + ' will be deleted.')
        .ariaLabel('delete contract')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        ContractService.delete(contract.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The contract ' + contract.number + ' were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.contracts.splice(vm.contracts.indexOf(contract), 1);
          vm.shownContracts.splice(vm.shownContracts.indexOf(contract), 1);
        },
          function () {
            $mdToast.show({
              template: '<md-toast class="md-toast error">The contract ' + contract.number + ' could not be deleted.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
          });
      },
        function () {
          // avoid unhandled rejection message.
        });
    }

    /**
     * Function to patch starred contract.
     *
     * @return {[type]} [description]
     */
    function patchStarred(contract) {
      event.stopPropagation();
      var starred = false;
      if (vm.starredContracts.indexOf(contract.id) >= 0) {
        starred = true;
      }
      PlantingScheduleService.update(contract.id, { starred: starred.toString() }).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The planting schedule ' + contract.block + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The planting schedule ' + contract.block + ' could not be starred.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
    }

    SeasonsService.getList().then(function (data) {
      vm.allSeasons = data.seasons;
    });

    /**
    * [calculateWeekEndings description]
    * @return {[type]}
    */
    function calculateWeekEndings(period_start, period_end) {
      var endings = [];
      var end = moment(period_end);
      var next_saturday = moment(period_start).day('Saturday')._d;
      while (next_saturday < end) {
        var obj = {
          id: next_saturday,
          name: $filter('date')(next_saturday)
        };
        endings.push(obj);
        next_saturday = moment(next_saturday.toISOString()).add(7, 'days')._d;
      }
      vm.allWeekEnding = endings;
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.grower-schedule', ['ang-drag-drop', 'md.data.table', 'fixed.table.header'])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.pages_grower_schedule', {
      url      : '/grower-schedule',
      views    : {
        'content@app': {
          templateUrl: 'app/main/pages/grower-schedule/grower-schedule.html',
          controller : 'GrowerScheduleCtrl as vm'
        }
      },
      bodyClass: 'grower-schedule',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('grower_schedule')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/pages/grower-schedule');

    // Api
    msApiProvider.register('sample', ['app/data/sample/sample.json']);

    // Navigation
    msNavigationServiceProvider.saveItem('pages.grower-schedule', {
      title : 'Grower Schedule',
      icon  : 'icon-leaf',
      state : 'app.pages_grower_schedule',
      weight: 10
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.pages.grower-schedule')
    .controller('GrowerScheduleCtrl', GrowerScheduleCtrl);

  /** @ngInject */
  function GrowerScheduleCtrl(
    $scope,
    $state,
    $mdToast,
    $mdSidenav,
    $mdDialog,
    $translate,
    $document,
    $location,
    $filter,
    $rootScope,
    $window,
    $q,
    msUtils,
    ContractService,
    CompanyService,
    AreaFiscalYearService,
    AreaService,
    SeasonsService,
    SeedService,
    BlockService,
    GrowerScheduleService,
    GrowerBlockService,
    GeneralFunctionsService,
    SubblockLocationService,
    UserService,
    ContractScheduleVarietiesService,
    FarmService,
    RanchService,
    FiscalYearSeasonsService,
    api,
    moment,
    _
  ) {
    var vm = this;
    vm.active_filters              = [];
    vm.contractListType            = 'All';
    vm.blockListType               = 'All';
    vm.displayNSContracts          = false;
    vm.displayNSBlocks             = false;
    vm.allLocations                = [];
    vm.location                    = null;
    vm.auxlocation                 = null;
    vm.allRanches                  = [];
    vm.ranch                       = null;
    vm.auxranch                    = null;
    vm.allBlocks                   = [];
    vm.block                       = null;
    vm.auxblock                    = null;
    vm.allFiscalYearSeasons        = [];
    vm.season                      = null;
    vm.auxseason                   = null;
    vm.allWeekEnding               = [];
    vm.we                          = null;
    vm.auxwe                       = null;
    vm.allShippers                 = [];
    vm.shipper                     = null;
    vm.auxshipper                  = null;
    vm.allOwners                   = [];
    vm.filteredContracts           = [];
    vm.isContractDisabled          = false;
    vm.weekEndingByHarvestDate     = false;
    vm.growerSchedules             = [];
    vm.fiscal_years                = [];
    vm.selected_fiscal_year        = '';
    vm.seeds                       = [];
    vm.varieties                   = [];
    vm.subblock_locations          = [];
    vm.pca_users                   = [];
    vm.dropped_gs                  = null;
    vm.dropped_gs_idx              = null;
    vm.modal_is_open               = false;
    vm.aux_id                      = -1;
    vm.deleted_rows_id             = 1;
    vm.num_of_records              = [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
    vm.contract_num_records        = 4;
    vm.gs_num_records              = 4;
    vm.double_crop_values          = [2, 3, 4];
    vm.double_crop_num             = 1;
    vm.aux_double_crop_num         = 1;
    vm.fiscal_year                 = null;
    vm.farm                        = null;
    vm.customError                 = false;
    vm.varietiesError              = false;
    vm.orderContractsBy            = 'original_wet_date';
    vm.filterByHarvestDate         = false;
    vm.doubleCropIsActive          = false;
    vm.auxSwitchChanged            = false;
    vm.search                      = null;
    vm.auxsearch                   = null;
    vm.blockSearch                 = null;
    vm.auxblockSearch              = null;
    vm.showSearch                  = false;
    vm.contractsAcresTotal         = 0;
    vm.blocksAcresTotal            = 0;
    vm.filtersObj                  = {};
    vm.toast                       = {};
    vm.fiscalYearId                = null;
    vm.clearedData                 = [];
    vm.delete_grower_blocks        = [];
    vm.delete_grower_schedules     = [];

    // ### Methods
    //
    // Contracts
    vm.contractAcresChanged        = contractAcresChanged;
    vm.addContract                 = addContract;
    vm.removeContract              = removeContract;
    vm.updateAvailableAcres        = updateAvailableAcres;
    // Grower Schedule
    vm.addSubBlock                 = addSubBlock;
    vm.removeSubBlock              = removeSubBlock;
    vm.addLocation                 = addLocation;
    vm.removeLocation              = removeLocation;
    vm.getSeedVarieties            = getSeedVarieties;
    vm.blockSchedAcresChanged      = blockSchedAcresChanged;
    vm.calculateGrowingDays        = calculateGrowingDays;
    vm.calculateBlockSchedAcresMax = calculateBlockSchedAcresMax;
    vm.clearData                   = clearData;
    vm.doubleCropLevelChanged      = doubleCropLevelChanged;
    vm.isInCurrentFiscalYear       = isInCurrentFiscalYear;
    // Shared
    vm.toggleSidenav               = toggleSidenav;
    vm.toggleInArray               = msUtils.toggleInArray;
    vm.exists                      = msUtils.exists;
    vm.onDrop                      = onDrop;
    vm.dropSuccessHandler          = dropSuccessHandler;
    vm.resetFilters                = resetFilters;
    vm.checkFilterLabels           = checkFilterLabels;
    vm.saveShipperContracts        = saveShipperContracts;
    vm.getVarietiesToSave          = getVarietiesToSave;
    vm.setTableHeight              = setTableHeight;
    vm.highligthRelated            = highligthRelated;
    vm.dragChannel                 = 'A';
    vm.calculateTableHeight        = calculateTableHeight;
    vm.toggleWeekEndingFilter      = toggleWeekEndingFilter;
    vm.saveAll                     = saveAll;
    vm.markAsChanged               = markAsChanged;
    vm.goToGSreports               = goToGSreports;
    vm.goToBlocks                  = goToBlocks;
    vm.goToRanches                 = goToRanches;
    vm.goTo                        = goTo;
    vm.getContractsAndBlocks       = getContractsAndBlocks;
    vm.validateSharedFilterChange  = validateSharedFilterChange;
    vm.onSharedFilterChange        = onSharedFilterChange;
    vm.schedulefilterChange        = schedulefilterChange;
    vm.closeSearch                 = closeSearch;
    vm.hideToast                   = hideToast;
    vm.restoreClearedRow           = restoreClearedRow;
    vm.clearAllRows                = clearAllRows;
    vm.searchChanged               = searchChanged;

    /**
     * Format datepickers date shown
     */
    vm.customDateFormat = {
      formatDate: function(date) {
        var m = null;
        if (date) {
          m = moment(date);
        }
        return m && m.isValid() ? m.format('ddd, MMM D') : null;
      }
    };

    /**
     * Watcher to recalculate Grower Schedule table height, if Contracts table is disabled and screen is resized
     */
    angular.element($window).bind('resize', function() {
      if (vm.isContractDisabled) {
        calculateTableHeight('growerSchedTableBody');
      }
    });

    $scope.$on('$destroy', function () {
      hideToast();
    });

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      $scope.loadingData = true;
      $scope.loadingData2 = true;
      calculateTableHeight('contractsTableBody', vm.contract_num_records);
      calculateTableHeight('growerSchedTableBody', vm.gs_num_records);
      // Get Farm	Owners
      CompanyService.getCompanyByBusinessRole('farm owner').then(function(companiesData) {
        vm.allOwners = _.unionBy(vm.allOwners, companiesData.companies, 'id');
        vm.allOwners = _.orderBy(vm.allOwners, ['name']);
      },
      function(err) {
        console.error(err);
      });
      // Get Seed Companies
      CompanyService.getCompanyByBusinessRole('seed company').then(function(companiesData) {
        vm.allOwners = _.unionBy(vm.allOwners, companiesData.companies, 'id');
        vm.allOwners = _.orderBy(vm.allOwners, ['name']);
      },
      function(err) {
        console.error(err);
      });
      // Get Shipper Companies
      CompanyService.getCompanyByBusinessRole('shipper').then(function(companiesData) {
        vm.allShippers = _.unionBy(vm.allOwners, companiesData.companies, 'id');
        vm.allShippers = _.orderBy(vm.allShippers, ['name']);
      },
      function(err) {
        vm.allShippers = vm.allOwners;
        console.error(err);
      });
      // Get Seeds list
      SeedService.getAll().then(function(seedsData) {
        vm.seeds = seedsData.seeds;
      },
      function(err) {
        console.error(err);
      });
      // Get PCA Users
      UserService.getList({role: 'pca'}).then(
        function (usersData) {
          vm.pca_users = usersData.users;
        },
        function (err) {
          console.error(err);
        }
      );
      FarmService.getFarm(1).then(function(FarmLandRefData) {
        vm.farm = FarmLandRefData.farm;
      },
      function(err) {
        console.error(err);
      });

      vm.user = JSON.parse(sessionStorage.getItem('user'));
      /* Get the area fiscal year and all locations under the global selected area id */
      if(vm.user && vm.user.default_global_area_fiscal_year_id) {
        AreaFiscalYearService.getAreaFiscalYear(vm.user.default_global_area_fiscal_year_id).then(function(areaFiscalYearData) {
          // calculate week endings of Fiscal Year
          if (areaFiscalYearData && areaFiscalYearData.area_fiscal_year && areaFiscalYearData.area_fiscal_year.fiscal_year) {
            vm.fiscal_year = areaFiscalYearData.area_fiscal_year.fiscal_year;
            vm.fiscalYearId = vm.fiscal_year.id;
            calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
          }
          var area_id = areaFiscalYearData.area_fiscal_year.area_id;
          AreaService.getAreaLocations(area_id).then(function(locationsData) {
            vm.allLocations = locationsData.locations;
          },
          function(err) {
            console.error(err);
          });

          /* Get all seasons */
          var data = {
            fiscal_year_id: vm.fiscalYearId,
          };

          FiscalYearSeasonsService.getByFiscalYearSeason(data).then(function(fiscalYearSeasonsData) {
            vm.allFiscalYearSeasons = fiscalYearSeasonsData.fiscal_year_seasons;
          },
          function(err) {
            console.error(err);
          });
        },
        function(err) {
          console.error(err);
        });
      }


      vm.subblock_locations = SubblockLocationService.getList();

      getContractsAndBlocks();
    }

    /**
     * Check if given date is on current Fiscal Year
     * Cannot be used yet because md-datepicker throws error when you want to change year
     * @param  {[type]}  origDate [description]
     * @return {Boolean}
     */
    function isInCurrentFiscalYear(origDate) {
      if (vm.fiscal_year && vm.fiscal_year.begin_date && vm.fiscal_year.end_date) {
        var begin = moment(vm.fiscal_year.begin_date).hours(0);
        var end   = moment(vm.fiscal_year.end_date).hours(0);
        var date  = moment(origDate).hours(0);
        if (date.isBetween(begin, end)) {
          return true;
        } else {
          return false;
        }
      } else {
        return true;
      }
    }

    /**
     * Open Grower Schedule Reports on a new tab
     * @return {[type]}
     */
    function goToGSreports() {
      $window.open('/grower-schedule-report', '_blank');
    }

    //// DON'T REMOVE - THIS WILL BE USED LATER WHEN FILTER AND PAGINATION WORK
    //// START

    /**
     * Get Grower Schedule Contracts, and then format them
     * This will be used on Pagination
     */
    /*function getContracts(filters) {
      $scope.loadingData = true;
      var filtersObj = {};
      if (filters) {
        filtersObj = filters;
      }
      ContractService.getContractGrowerSchedule(filtersObj).then(function(contractsData) {
        if(contractsData && contractsData.grower_schedule_contracts) {
          formatContractRows(contractsData.grower_schedule_contracts);
        }
        $scope.loadingData = false;
      },
      function(err) {
        console.error(err);
        var error;
        if(err && err.data && err.data.message) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">Shipper Schedules could not be loaded. ' + ((error !== undefined)? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
        $scope.loadingData = false;
      });
    }*/

    /**
     * Get Blocks, and then format them
     * This will be used on Pagination
     */
    // function getBlocks() {
    //   $scope.loadingData2 = true;
    //   GrowerBlockService.getAll({
    //     area_fiscal_year_id: vm.user.default_global_area_fiscal_year_id,
    //     crop_number        : vm.double_crop_num
    //   }).then(function(growerBlocksData) {
    //     if(growerBlocksData && growerBlocksData.grower_blocks) {
    //       formatBlocks(growerBlocksData.grower_blocks);
    //       $scope.loadingData2 = false;
    //     }
    //   },
    //   function(err) {
    //     console.error(err);
    //     var error;
    //     if(err && err.data && err.data.message) {
    //       error = err.data.message;
    //     }
    //     $mdToast.show({
    //       template: '<md-toast class="md-toast error">Blocks Information could not be loaded. ' + ((error !== undefined)? error : '') + '</md-toast>',
    //       position: 'top right',
    //       hideDelay: 4500
    //     });
    //   });
    // }

    //// END - DON'T REMOVE

    /**
    * Load Shipper Contracts, Blocks/Grower Blocks
    * @return {[type]}
    */
    function getContractsAndBlocks() {
      $scope.loadingData  = true;
      $scope.loadingData2 = true;
      var contractsFilter         = {};
      var blocksFilter            = {};
      var blockSearch             = [];
      // reset arrays to delete data
      vm.delete_grower_blocks     = [];
      vm.delete_grower_schedules  = [];
      // shared filters
      // Location - Season - Week Ending - Shipper
      if (vm.filtersObj) {
        contractsFilter = _.cloneDeep(vm.filtersObj);
        blocksFilter    = _.cloneDeep(vm.filtersObj);
      }
      // global search
      if (vm.search) {
        contractsFilter.search_word = vm.search;
        blockSearch.push(vm.search);
        blocksFilter.search_word    = blockSearch;
      }
      // Specific Contract Filters
      contractsFilter.order_by               = vm.orderContractsBy;
      contractsFilter.area_fiscal_year_id    = vm.user.default_global_area_fiscal_year_id;
      contractsFilter.by_wet_date            = !vm.filterByHarvestDate;
      contractsFilter.scheduled_contracts    = vm.contractListType;
      // Specific Block Filters
      // Block Search input
      if (vm.blockSearch) {
        blockSearch.push(vm.blockSearch);
        blocksFilter.search_word             = blockSearch;
      }
      if (blocksFilter.search_word && blocksFilter.search_word.length) {
        blocksFilter.search_word = blocksFilter.search_word.join(',');
      }
      blocksFilter.crop_number               = vm.double_crop_num;
      blocksFilter.area_fiscal_year_id       = vm.user.default_global_area_fiscal_year_id;
      blocksFilter.block_id                  = vm.block;
      blocksFilter.ranch_id                  = vm.ranch;
      blocksFilter.by_wet_date               = !vm.filterByHarvestDate;
      blocksFilter.scheduled                 = vm.blockListType;

      $q.all([
        ContractScheduleVarietiesService.getAll(contractsFilter),
        GrowerBlockService.getAll(blocksFilter)
      ]).then(function(response) {
        if (response && response.length > 0) {
          angular.forEach(response, function(resObj) {
            if (resObj.hasOwnProperty('grower_blocks')) {
              formatBlocks(resObj.grower_blocks);
              $scope.loadingData2 = false;
            }
            if(resObj.hasOwnProperty('contract_schedule_varieties')) {
              formatContractRows(resObj.contract_schedule_varieties);
              $scope.loadingData = false;
            }
          });
        } else {
          vm.toast = $mdToast.show({
            template: '<md-toast class="md-toast error">Grower Schedule Information could not be loaded.</md-toast>',
            position: 'top right',
            hideDelay: 0
          });
        }
      });
    }

    /**
     * Format Contracts and its childs to be shown properly on frontend
     * @param  {[type]} auxContracts [Original Contracts List returned from API]
     * @return {[type]}
     */
    function formatContractRows(auxContracts) {
      vm.filteredContracts = [];
      // Format contract_schedule_varieties
      angular.forEach(auxContracts, function(csv) {
        csv.company_id    = csv.contract_schedule.contract.company_id;
        csv.company_name  = csv.contract_schedule.contract.company.name;
        csv.seed_id       = csv.contract_schedule.seed_id;
        csv.seed_name     = csv.contract_schedule.seed.name;
        csv.seed          = csv.contract_schedule.seed;
        // acres calculations
        (typeof csv.acres           === 'string') ? csv.acres           = parseFloat(csv.acres)           : '';
        (typeof csv.acres_scheduled === 'string') ? csv.acres_scheduled = parseFloat(csv.acres_scheduled) : '';
        csv.not_scheduled_acres = parseFloat((csv.acres - csv.acres_scheduled).toFixed(1));
        if (csv.not_scheduled_acres < 0) {
          csv.availableContractAcres = 0; // aux value
        } else {
          csv.availableContractAcres = csv.not_scheduled_acres; // aux value
        }
        // auxiliar data
        csv.is_sub_row = false;
        csv.sub_row_of = csv.id;
        csv.draggable  = true;
        csv.max_acres_value = csv.acres + csv.not_scheduled_acres; // aux value
        csv.aux_acres = csv.acres;
        delete csv.contract_schedule;
        getGrowerScheduleFromContract(csv);
        vm.filteredContracts.push(csv);
        if (csv.hasOwnProperty('childs') && csv.childs.length) {
          angular.forEach(csv.childs, function(csvChild) {
            csvChild.company_id    = csvChild.contract_schedule.contract.company_id;
            csvChild.company_name  = csvChild.contract_schedule.contract.company.name;
            csvChild.seed_id       = csvChild.contract_schedule.seed_id;
            csvChild.seed_name     = csvChild.contract_schedule.seed.name;
            csvChild.seed          = csvChild.contract_schedule.seed;
            // acres calculations
            (typeof csvChild.acres === 'string') ? csvChild.acres = parseFloat(csvChild.acres) : '';
            (csvChild.acres === undefined || csvChild.acres === null) ? csvChild.acres = 0 : '';
            (typeof csvChild.acres_scheduled === 'string') ? csvChild.acres_scheduled = parseFloat(csvChild.acres_scheduled) : '';
            (csvChild.acres_scheduled === undefined || csvChild.acres_scheduled === null) ? csvChild.acres_scheduled = 0 : 0;
            csvChild.not_scheduled_acres = 0;
            // check if child has acres, to subtract them from father available acres (not_scheduled_acres)
            if (csvChild.acres && angular.isNumber(csvChild.acres)) {
              csv.aux_acres += csvChild.acres;
              csvChild.not_scheduled_acres = csvChild.acres - csvChild.acres_scheduled;
            }
            // auxiliar data
            csvChild.is_sub_row    = true;
            csvChild.sub_row_of    = csvChild.parent_id;
            csvChild.draggable     = true;
            // check parent seed_varieties_location, as the endpoint is not returning them to don't repeat data
            if (csv.variety && csv.variety.hasOwnProperty('seed_varieties_location')) {
              csvChild.variety.seed_varieties_location = csv.variety.seed_varieties_location;
            }
            delete csvChild.contract_schedule;
            getGrowerScheduleFromContract(csvChild);
            vm.filteredContracts.push(csvChild);
          });
          delete csv.childs;
        }
        csv.recalculate = true;
        contractAcresChanged(csv, false, true);
        updateAvailableAcres(csv);
      });
      vm.contractsAcresTotal = _.sumBy(vm.filteredContracts, 'acres');
    }

    /**
     * Format Blocks, Subblocks and Locations to show them properly on Blocks Information table
     * @param  {[type]} growerBlocks [Original Grower Blocks/Blocks List returned from API]
     * @return {[type]}
     */
    function formatBlocks(growerBlocks) {
      vm.growerSchedules = [];
      angular.forEach(growerBlocks, function (gs) {
        // aux variables
        var i, j      = 0;
        var locations = [];
        var auxObj    = {};
        var insert    = false;

        // format API fields
        (gs.block && gs.block.name) ? gs.block_name = gs.block.name : gs.block_name = '';
        (gs.block && gs.block.bed_direction_id) ? gs.block_bed_direction_id = gs.block.bed_direction_id : gs.block_bed_direction_id = null;
        gs.block_number_of_locations_in_bed = 1;
        gs.available_acres = parseFloat(gs.acres_available);
        gs.block_number_of_locations_in_bed = 1; // for default, 'All' location.
        (gs.block && gs.block.ranch && gs.block.ranch.location_id) ? gs.location_id = gs.block.ranch.location_id : gs.location_id = null;
        (gs.block && gs.block.ranch && gs.block.ranch.ranch_location && gs.block.ranch.ranch_location.name) ? gs.location_name = gs.block.ranch.ranch_location.name : gs.location_name = null;
        gs.contract_schedule_variety_id = null;

        // aux values needed to frontend logic works
        gs.isSubBlock = false;
        gs.hasSubBlock = false;
        gs.is_parent = false;
        gs.hasLocations = false;
        // if grower_block hasn't an ID, it's because it's a Not Scheduled Block (Not a Grower Block)
        if (!gs.id) {
          gs.id = vm.aux_id--;
        }
        gs.subBlockOf = gs.id;
        gs.grower_block_id = gs.id;
        gs.acres_in_block = parseFloat(gs.acres_in_block);
        gs.availableBlockAcres = parseFloat(gs.acres_in_block);
        gs.scheduled_acres = null;
        gs.max_sched_acres_block = gs.available_acres;
        gs.canAddLocation = true;
        gs.aux_acres_in_block = parseFloat(gs.acres_in_block); // aux field to save total acres amount
        gs.aux_block_name = gs.block_name; // aux field to save original name, as block_name changes with locations
        gs.grower_schedule_id = vm.aux_id--;

        // get location
        locations = SubblockLocationService.getByNumberOfLocations(
          gs.block_bed_direction_id,
          gs.block_number_of_locations_in_bed
        );

        if (locations && locations[0]) {
          gs.grower_schedule_sublocation = locations[0];
        }

        vm.growerSchedules.push(gs);

        // check if Block has Subblocks ('childs' array), and their have been scheduled
        // If not, check if it has Locations that has been scheduled ('grower_schedules' array)
        if (gs.hasOwnProperty('childs') && gs.childs.length) {
          gs.hasSubBlock   = true;
          var auxLocAmount = gs.childs.length;
          var auxLocIdx    = 0;
          // count how many locations will need, counting the locations that each child may have
          for (i = 0; i < gs.childs.length; i++) {
            if (gs.childs[i].grower_schedules && gs.childs[i].grower_schedules.length) {
              // don't consider main location that will be shown on first subblock
              auxLocAmount += (gs.childs[i].grower_schedules.length - 1);
            }
          }
          // total of locations needed from current Block
          gs.block_number_of_locations_in_bed = auxLocAmount;
          // check if father has all locations
          if (gs.block_number_of_locations_in_bed === 8) {
            gs.cannotAddSubblock = true;
            gs.canAddLocation = false;
            gs.hasAllLocations = true;
          }
          // get child locations
          locations = SubblockLocationService.getByNumberOfLocations(
            gs.block_bed_direction_id,
            gs.block_number_of_locations_in_bed
          );
          // format childs to show on table
          for (i = 0; i < gs.childs.length; i++) {
            // tag first child
            (i === 0) ? gs.childs[i].firstChild = true : null;
            // check if there are more locations to add
            (gs.block_number_of_locations_in_bed === 8) ? gs.childs[i].canAddLocation = false : gs.childs[i].canAddLocation = true;
            // only last subblock can be removed
            (i === (gs.childs.length - 1)) ? gs.childs[i].canRemove = true : gs.childs[i].canRemove = false;

            gs.childs[i].grower_block_id        = gs.childs[i].id;
            gs.childs[i].location_id            = gs.location_id;
            gs.childs[i].location_name          = gs.location_name;
            gs.childs[i].block_name             = gs.block_name + '-' + gs.childs[i].subblock_number.toString();
            gs.childs[i].aux_block_name         = gs.childs[i].block_name; // aux field to save original name, as block_name changes with locations
            gs.childs[i].isSubBlock             = true;
            gs.childs[i].hasSubBlock            = false;
            gs.childs[i].is_parent              = false;
            gs.childs[i].subBlockOf             = gs.id;
            gs.childs[i].block_bed_direction_id = gs.block_bed_direction_id;
            gs.childs[i].available_acres        = gs.available_acres;
            gs.childs[i].availableBlockAcres    = gs.availableBlockAcres;
            gs.childs[i].scheduled_acres        = null;
            gs.childs[i].acres_in_block         = parseFloat(gs.childs[i].acres_in_block);
            gs.childs[i].parent_acres_in_block  = gs.acres_in_block;
            gs.childs[i].max_sched_acres_block  = gs.childs[i].available_acres;
            gs.childs[i].contract_schedule_variety_id = null;
            gs.childs[i].last_harvest_date      = gs.last_harvest_date;
            gs.childs[i].max_harvest_date       = gs.max_harvest_date;
            gs.childs[i].max_schedule_level     = gs.max_schedule_level;

            // assign location
            if (locations && locations[auxLocIdx]) {
              gs.childs[i].grower_schedule_sublocation = locations[auxLocIdx];
              if (locations[auxLocIdx].name !== 'All') {
                gs.childs[i].block_name = gs.childs[i].aux_block_name + ' ' + locations[auxLocIdx].name;
              } else {
                gs.childs[i].block_name = gs.childs[i].aux_block_name;
              }
              vm.growerSchedules.push(gs.childs[i]);
              auxLocIdx++;
            }
            // Calculate available acres
            gs.childs[i].recalculate = true;
            blockSchedAcresChanged(gs.childs[i], false, false);
            // check if child has been scheduled (if has related grower_schedules)
            if (gs.childs[i].grower_schedules && gs.childs[i].grower_schedules.length) {
              gs.childs[i].block_number_of_locations_in_bed = gs.block_number_of_locations_in_bed;
              for (j = 0; j < gs.childs[i].grower_schedules.length; j++) {
                auxObj = {};
                // if it's not first SubBlock location, new record needs to be created to show it
                insert = false;
                // first grower_schedule must be shown on main row
                if (j === 0) {
                  auxObj = gs.childs[i];
                } else {
                  // block has scheduled Locations that are not the main one (related grower_schedules)
                  gs.childs[i].hasLocations = true;
                  auxObj = _.cloneDeep(gs.childs[i]);
                  (auxObj.id) ? delete auxObj.id : '';
                  auxObj.hasLocations   = false;
                  auxObj.isLocation     = true;
                  auxObj.canAddLocation = false;
                  auxObj.acres_in_block = 0;
                  auxObj.scheduled_acres = null;
                  auxObj.dropped        = false;
                  // it's not the first location, so new row must be created
                  insert = true;
                }

                // aux variables
                auxObj.locationOf             = gs.childs[i].id;
                // Format API fields
                auxObj.grower_schedule_id     = gs.childs[i].grower_schedules[j].id;
                auxObj.company_id             = gs.childs[i].grower_schedules[j].shipper_company_id;
                auxObj.company_name           = gs.childs[i].grower_schedules[j].shipper_company.name;
                auxObj.pca_id                 = gs.childs[i].grower_schedules[j].pca_user_id;
                auxObj.scheduled_wet_date     = new Date(gs.childs[i].grower_schedules[j].scheduled_wet_date);
                auxObj.seed_id                = gs.childs[i].grower_schedules[j].seed_id;
                auxObj.seed_name              = gs.childs[i].grower_schedules[j].seed.name;
                auxObj.seedVarieties          = [];
                auxObj.contract_schedule_variety_id = gs.childs[i].grower_schedules[j].contract_schedule_variety_id;
                if (gs.childs[i].grower_schedules[j].scheduled_acres) {
                  auxObj.scheduled_acres        = parseFloat(gs.childs[i].grower_schedules[j].scheduled_acres);
                }
                auxObj.scheduled_harvest_date = new Date(gs.childs[i].grower_schedules[j].scheduled_harvest_date);
                auxObj.variety_id             = gs.childs[i].grower_schedules[j].variety_id;
                if (gs.childs[i].grower_schedules[j].variety) {
                  auxObj.variety_name         = gs.childs[i].grower_schedules[j].variety.name;
                }
                // Calculate Growing Days (here varieties are loaded)
                calculateGrowingDays(auxObj, 'wet_date');
                // check if a new record needs to be inserted (as they are more than one location),
                // or it can be shown on existing row
                if (insert) {
                  // assign location
                  if (locations && locations[auxLocIdx]) {
                    auxObj.grower_schedule_sublocation = locations[auxLocIdx];
                    if (locations[auxLocIdx].name !== 'All') {
                      auxObj.block_name = auxObj.aux_block_name + ' ' + locations[auxLocIdx].name;
                    } else {
                      auxObj.block_name = auxObj.aux_block_name;
                    }
                    auxLocIdx++;
                  }
                  vm.growerSchedules.push(auxObj);
                }
                // check related contract
                if (auxObj.contract_schedule_variety_id) {
                  auxObj.dropped = true;
                }
                // recalculate acres
                auxObj.recalculate = true;
                blockSchedAcresChanged(auxObj, false, false);
              }
            }
          } // end childs for
        } else if (gs.hasOwnProperty('grower_schedules') && gs.grower_schedules.length) {
          // total of locations needed from current Block
          gs.block_number_of_locations_in_bed = gs.grower_schedules.length;
          // check if father has all locations
          if (gs.block_number_of_locations_in_bed === 8) {
            gs.cannotAddSubblock = true;
            gs.canAddLocation = false;
            gs.hasAllLocations = true;
          }
          // get child locations
          locations = SubblockLocationService.getByNumberOfLocations(
            gs.block_bed_direction_id,
            gs.block_number_of_locations_in_bed
          );
          // format locations
          for (i = 0; i < gs.grower_schedules.length; i++) {
            auxObj = {};
            // if it's not first Block location, new record needs to be created to show it
            insert = false;
            // first grower_schedule must be shown on main row
            if (i === 0) {
              auxObj = gs;
            } else {
              // if the Original Block has more than one Location, then Subblocks cannot be added
              gs.cannotAddSubblock = true;
              // block has more than one scheduled Locations (related grower_schedules)
              gs.hasLocations = true;
              auxObj = _.cloneDeep(gs);
              (auxObj.id) ? delete auxObj.id : '';
              auxObj.hasLocations   = false;
              auxObj.isLocation     = true;
              auxObj.canAddLocation = false;
              auxObj.acres_in_block = 0;
              auxObj.scheduled_acres = null;
              auxObj.dropped        = false;

              // it's not the first location, so new row must be created
              insert = true;
            }
            auxObj.locationOf             = gs.id;
            // Format API fields
            auxObj.grower_schedule_id     = gs.grower_schedules[i].id;
            auxObj.company_id             = gs.grower_schedules[i].shipper_company_id;
            auxObj.company_name           = gs.grower_schedules[i].shipper_company.name;
            auxObj.pca_id                 = gs.grower_schedules[i].pca_user_id;
            auxObj.scheduled_wet_date     = new Date(gs.grower_schedules[i].scheduled_wet_date);
            if (gs.grower_schedules[i].scheduled_acres) {
              auxObj.scheduled_acres        = parseFloat(gs.grower_schedules[i].scheduled_acres);
            }
            auxObj.scheduled_harvest_date = new Date(gs.grower_schedules[i].scheduled_harvest_date);
            auxObj.seed_id                = gs.grower_schedules[i].seed_id;
            auxObj.seed_name              = gs.grower_schedules[i].seed.name;
            auxObj.seedVarieties          = [];
            auxObj.contract_schedule_variety_id = gs.grower_schedules[i].contract_schedule_variety_id;
            // variety can be null
            auxObj.variety_id             = gs.grower_schedules[i].variety_id;
            if (gs.grower_schedules[i].variety) {
              auxObj.variety_name         = gs.grower_schedules[i].variety.name;
            }
            // Calculate Growing Days (here varieties are loaded)
            calculateGrowingDays(auxObj, 'wet_date');
            // assign location
            if (locations && locations[i]) {
              auxObj.grower_schedule_sublocation = locations[i];
              if (locations[i].name !== 'All') {
                auxObj.block_name = auxObj.aux_block_name + ' ' + locations[i].name;
              } else {
                auxObj.block_name = auxObj.aux_block_name;
              }
            }
            // check related contract
            if (auxObj.contract_schedule_variety_id) {
              auxObj.dropped = true;
            }
            // check if a new record needs to be inserted (as they are more than one location),
            // or it can be shown on existing row
            if (insert) {
              vm.growerSchedules.push(auxObj);
            }
            auxObj.recalculate = true;
            blockSchedAcresChanged(auxObj, false, false);
          } // end grower_schedules for
        } // end grower_schedules if
      });
      // update max values on each fields
      // I can't do this on above forEach since I need that all acres_available from all 'families' are calculated
      angular.forEach(vm.growerSchedules, function(grower) {
        grower.max_sched_acres_block = parseFloat((grower.scheduled_acres + grower.availableBlockAcres).toFixed(1));
        grower.recalculate = false;
      });
      // on Total Acres sum, only need to be considered the main rows (not locations, not subblocks)
      vm.blocksAcresTotal = _.sumBy(vm.growerSchedules, function(grower) {
        // chec if it's main block
        if (grower.subBlockOf === grower.id) {
          return grower.acres_in_block;
        } else {
          return 0;
        }
      });
    }

    /**
     * Get related Grower Schedule data from Contract
     * @param  {[type]} contract [contract_schedule_variety]
     * @return {[type]}
     */
    function getGrowerScheduleFromContract(contract) {
      if (contract.hasOwnProperty('grower_schedule') && contract.grower_schedule.length) {
        contract.scheduled_block = {
          id: contract.grower_schedule[0].grower_block_id,
          name: contract.grower_schedule[0].block_name,
          acres_scheduled: parseFloat(contract.grower_schedule[0].scheduled_acres),
          scheduled_wet_date: contract.grower_schedule[0].scheduled_wet_date
        };
        contract.draggable = false;
      }
    }

    /**
     * Calculate Block Grower Dates and validate Wet & Harvest date regarding them
     * Grower Date Begin = Wet_Date - farm.double_crop_bed_preparation_days
     * Grower Date End = Harvest_Date + farm.harvest_completion_days
     * @return {[type]}
     */
    function calculateGrowerDates(gs) {
      var growerDateBegin = null;
      var growerDateEnd   = null;
      // Calculate Grower Start-End Dates
      // Grower Start
      if (vm.farm && vm.farm.double_crop_bed_preparation_days && gs.scheduled_wet_date) {
        growerDateBegin = moment(gs.scheduled_wet_date).subtract(vm.farm.double_crop_bed_preparation_days, 'days').hours(0);
      } else if (gs.scheduled_wet_date) {
        growerDateBegin = moment(gs.scheduled_wet_date).hours(0); // just to avoid errors
      } else { // no wet date, so no error
        gs.wet_date_error          = false;
        gs.wet_date_period_error   = false;
        gs.last_harvest_date_error = false;
      }
      // Grower End
      if (vm.farm && vm.farm.harvest_completion_days && gs.scheduled_harvest_date) {
        growerDateEnd   = moment(gs.scheduled_harvest_date).add(vm.farm.harvest_completion_days, 'days').hours(0);
      } else if (gs.scheduled_harvest_date) {
        growerDateEnd   = moment(gs.scheduled_harvest_date).hours(0); // just to avoid errors
      } else { // no harvest date, so no error
        gs.harvest_date_error        = false;
        gs.harvest_date_period_error = false;
        gs.max_harvest_date_error    = false;
      }
      // Grower Start needs to be > Last Harvest Date (https://tracker.serfe.com/view.php?id=51227#c390757)
      if (growerDateBegin && growerDateBegin.isValid() && gs.last_harvest_date) {
        if (growerDateBegin <= moment(gs.last_harvest_date).hours(0)) {
          gs.last_harvest_date_error = true;
        } else {
          gs.last_harvest_date_error = false;
        }
      }
      // Check that Harvest Date is validate
      // If the Block has been scheduled also on next step, current Harvest Date cannot be greater than smallest Wet Date from next step
      if (gs.scheduled_harvest_date && gs.max_harvest_date) {
        var max_harvest_date = moment(gs.max_harvest_date).hours(0);
        if (vm.farm && vm.farm.double_crop_bed_preparation_days) {
          max_harvest_date.subtract(vm.farm.double_crop_bed_preparation_days, 'days');
        }
        if (moment(gs.scheduled_harvest_date).hours(0) >= max_harvest_date) {
          gs.max_harvest_date_error = true;
        } else {
          gs.max_harvest_date_error = false;
        }
      }

      // if Block is Leased, check Wet/Harvest dates are within lease dates range
      // if Block is subleased, check that Grower Dates are OUTSIDE of all sublease dates
      var leased    = false;
      var subleased = false;
      if (gs.block && gs.block.lease_dates && gs.block.lease_dates.length) {
        leased = true;
      }
      if (gs.block && gs.block.sublease_dates && gs.block.sublease_dates.length) {
        subleased = true;
      }
      // If Block is not Leased and is not Subleased, any date is valid on Grower Dates validation
      if (!leased && !subleased) {
        gs.wet_date_error            = false;
        gs.harvest_date_error        = false;
        gs.wet_date_period_error     = false;
        gs.harvest_date_period_error = false;
        return;
      } else if (leased) {
        gs.leased = true;
        checkDateOnLeasePeriods(gs, growerDateBegin, growerDateEnd);
      } else if (subleased) {
        gs.subleased = true;
        checkDateOnSubleasePeriods(gs, growerDateBegin, growerDateEnd);
      }
    }

    /**
     * If Block is leased, check that Grower Dates fit INSIDE of one of lease dates
     * @param  {[type]} gs              [description]
     * @param  {[type]} growerDateBegin [description]
     * @param  {[type]} growerDateEnd   [description]
     * @return {[type]}
     */
    function checkDateOnLeasePeriods(gs, growerDateBegin, growerDateEnd) {
      var beginDateOK   = false;
      var endDateOK     = false;
      var res           = null;
      var periodWetIdx  = null;
      var periodharvIdx = null;
      for (var i = 0; i < gs.block.lease_dates.length; i++) {
        var leaseStart = moment(gs.block.lease_dates[i].lease_start_date).hours(0);
        var leaseEnd   = moment(gs.block.lease_dates[i].lease_end_date).hours(0);
        // check if Scheduled Wet Date is valid
        if (growerDateBegin && growerDateBegin.isValid()) {
          res = growerDateBegin.isBetween(leaseStart, leaseEnd, null, []);
          if (res) {
            beginDateOK = true;
            periodWetIdx   = i;
          }
        }
        // check if Harvest Date is valid
        if (growerDateEnd && growerDateEnd.isValid()) {
          res = growerDateEnd.isBetween(leaseStart, leaseEnd, null, []);
          if (res) {
            endDateOK     = true;
            periodharvIdx = i;
          }
        }
      }
      // check to assign error
      if (beginDateOK) {
        gs.wet_date_error     = false;
      } else if (gs.scheduled_wet_date) {
        gs.wet_date_error     = true;
      }
      if (endDateOK) {
        gs.harvest_date_error     = false;
      } else if (gs.scheduled_harvest_date) {
        gs.harvest_date_error     = true;
      }
      // check if both are valid, but from different lease periods
      // _.isFinite => Checks if value is a finite primitive number.
      if (_.isFinite(periodWetIdx) && _.isFinite(periodharvIdx) && periodWetIdx !== periodharvIdx) {
        gs.wet_date_period_error     = true;
        gs.harvest_date_period_error = true;
      } else {
        gs.wet_date_period_error     = false;
        gs.harvest_date_period_error = false;
      }
    }

    /**
     * If Block is subleased, check that Grower Dates are OUTSIDE of all sublease dates
     * @param  {[type]} gs              [description]
     * @param  {[type]} growerDateBegin [description]
     * @param  {[type]} growerDateEnd   [description]
     * @return {[type]}
     */
    function checkDateOnSubleasePeriods(gs, growerDateBegin, growerDateEnd) {
      var beginDateOK         = null;
      var endDateOK           = null;
      var subleasePeriodNotOK = null;
      // check
      angular.forEach(gs.block.sublease_dates, function(subleaseDate) {
        var subleaseStart = moment(subleaseDate.sublease_start_date).hours(0);
        var subleaseEnd   = moment(subleaseDate.sublease_end_date).hours(0);
        // check that growerDateBegin not fit into current sublease
        if (beginDateOK !== false && growerDateBegin && growerDateBegin.isValid()) {
          beginDateOK = !growerDateBegin.isBetween(subleaseStart, subleaseEnd, null, []);
        }
        // check that growerDateEnd not fit into current sublease
        if (endDateOK !== false && growerDateEnd && growerDateEnd.isValid()) {
          endDateOK = !growerDateEnd.isBetween(subleaseStart, subleaseEnd, null, []);
        }
        // if both dates are valid, check that none sublease period is inside of them
        if (subleasePeriodNotOK !== true && beginDateOK && endDateOK && growerDateBegin && growerDateBegin.isValid() && growerDateEnd && growerDateEnd.isValid()) {
          subleasePeriodNotOK = moment(subleaseStart).isBetween(growerDateBegin, growerDateEnd);
          // if subleaseStart is outside Grower Date period, check subleaseEnd
          if (!subleasePeriodNotOK) {
            subleasePeriodNotOK = moment(subleaseEnd).isBetween(growerDateBegin, growerDateEnd);
          }
        }
      });

      // check to assign error
      if (beginDateOK) {
        gs.wet_date_error     = false;
      } else if (gs.scheduled_wet_date) {
        gs.wet_date_error     = true;
      }
      if (endDateOK) {
        gs.harvest_date_error     = false;
      } else if (gs.scheduled_harvest_date) {
        gs.harvest_date_error     = true;
      }
      if (subleasePeriodNotOK) {
        gs.wet_date_period_error     = true;
        gs.harvest_date_period_error = true;
      } else {
        gs.wet_date_period_error     = false;
        gs.harvest_date_period_error = false;
      }
    }

    /**
     * Get Varieties of selected Seed, and filter them
     * @return {[type]}
     */
    function getSeedVarieties(seed_id, gs, field, notShowMsge) {
      gs.seedVarieties = [];
      gs.wet_date_variety_error = false;
      // save selected variety_id, to check later when new varieties are loaded
      var auxVarId = _.cloneDeep(gs.variety_id);
      if (seed_id) {
        SeedService.getVarieties(seed_id).then(function(varietiesData) {
          var filteredVarieties = filterVarietiesByWetDate(gs, varietiesData.varieties);
          gs.seedVarieties = filteredVarieties;
          gs.variety_id = _.cloneDeep(auxVarId);
          // if variety is set, check if selected variety is present on new varieties loaded
          if (gs.seedVarieties.length && gs.variety_id) {
            var found = _.find(gs.seedVarieties, {id: gs.variety_id});

            if (!found) {
              gs.variety_id   = null;
              gs.variety_name = null;
            }
          } else {
            gs.variety_id   = null;
            gs.variety_name = null;
          }
          // if wet_date has changed and the variety is not present on new loaded varieties, show error
          if (field && field === 'wet_date' && auxVarId !== gs.variety_id) {
            gs.wet_date_variety_error = true;
          } else {
            gs.wet_date_variety_error = false;
          }
          checkDateErrors(gs, true, field, notShowMsge);
          // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
          // Check if Variety needs to be shown as required
          // checkVarietyIsRequired(gs);
        },
        function(err) {
          console.error(err);
        });
      }
    }

    /**
     * Function called when Contract switch is toggled.
     * If Contracts table is not visible, change Grower Schedule table heigth
     * Else restore the number of visible records per table
     */
    function setTableHeight(gs_table_id) {
      vm.isContractDisabled = !vm.isContractDisabled;
      if (vm.isContractDisabled) {
        calculateTableHeight(gs_table_id);
      } else {
        calculateTableHeight('contractsTableBody', vm.contract_num_records);
        calculateTableHeight('growerSchedTableBody', vm.gs_num_records);
      }
    }

    /**
     * Set table height regarding number of records to see that have been set
     * @param  {[type]} table_id   [description]
     * @param  {[type]} number_reg [description]
     * @return {[type]}
     */
    function calculateTableHeight(table_id, number_reg) {
      var table_body = document.getElementById(table_id);
      if (table_body) {
        // if contractsTable is not shown, calculate windowHeight
        // else calculate height regarding number of visible rows set
        if (vm.isContractDisabled) {
          var w = angular.element($window);
          table_body.style.maxHeight = (w.height() - 350).toString() + 'px';
        } else {
          var row_height = 56;
          if (number_reg) {
            row_height *= number_reg;
          }
          table_body.style.maxHeight = row_height.toString() + 'px';
        }
      }
    }

    /**
     * Filter Week Ending by Wet Date/Harvest Date
     * Change order of Contracts regarding switch value
     * @return {[type]}
     */
    function toggleWeekEndingFilter(growerFormInvalid, contractFormInvalid) {
      if (growerFormInvalid || contractFormInvalid || vm.customError || vm.varietiesError) {
        vm.weekEndingByHarvestDate = !vm.weekEndingByHarvestDate;
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">There are required fields empty or with errors. Please, check them</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
      } else {
        // call API to filter by Week Ending with new value
        vm.filterByHarvestDate = !vm.filterByHarvestDate;
        // change order of Contracts regarding switch value
        if (vm.filterByHarvestDate) {
          vm.orderContractsBy = 'original_harvest_date';
        } else {
          vm.orderContractsBy = 'original_wet_date';
        }
        saveAll();
      }
    }

    /**
     * [calculateWeekEndings description]
     * @return {[type]}
     */
    function calculateWeekEndings(period_start, period_end) {
      var endings         = [];
      var end             = moment(period_end);
      var week_start      = moment(period_start).day('Sunday');
      var next_saturday   = moment(period_start).day('Saturday');
      while (next_saturday < end) {
        var obj = {
          id              : next_saturday._d,
          name            : $filter('date')(next_saturday._d),
          header_label    : week_start.format('MMM D') + ' - ' + next_saturday.format('MMM D')
        };
        endings.push(_.cloneDeep(obj));
        next_saturday     = next_saturday.add(7, 'days');
        week_start        = _.cloneDeep(next_saturday).day('Sunday');
      }
      vm.allWeekEnding    = endings;
    }

    /**
     * [highligthRelated description]
     * @param  {[type]} entity  [description]
     * @param  {[type]} rowData [description]
     * @param  {[type]} action  [description]
     * @return {[type]}
     */
    function highligthRelated(entity, rowData, action) {
      if (action === 'enter') {
        rowData.over = true;
      } else {
        rowData.over = false;
      }
      if (entity === 'contract') {
        // check if contract has related block
        if (!_.isEmpty(rowData.scheduled_block)) {
          // search related block and set boolean to add/remove 'highligth' class
          var blockIdx = _.findIndex(vm.growerSchedules, {contract_schedule_variety_id: rowData.id});
          if (blockIdx > -1) {
            if (action === 'enter') {
              vm.growerSchedules[blockIdx].over = true;
            } else {
              vm.growerSchedules[blockIdx].over = false;
            }
          } else {
            // the related Block is not visible
            if (rowData.over) {
              rowData.related_not_visible = true;
            } else {
              rowData.related_not_visible = false;
            }
          }
        }
      } else {
        if (rowData.contract_schedule_variety_id) {
          var contractIdx = _.findIndex(vm.filteredContracts, {id: rowData.contract_schedule_variety_id});
          if (contractIdx > -1) {
            if (action === 'enter') {
              vm.filteredContracts[contractIdx].over = true;
            } else {
              vm.filteredContracts[contractIdx].over = false;
            }
          }
        }
      }
    }

    /**
     * Add Contract Row
     * @param {[type]} entity [description]
     * @param {[type]} index  [description]
     */
    function addContract(entity, index) {
      var entity_copy = angular.copy(entity);
      if (entity_copy.hasOwnProperty('id')) {
        delete entity_copy.id;
      }
      // values to save on database (differents than the father row)
      entity_copy.acres               = 0;
      entity_copy.acres_scheduled     = 0;
      entity_copy.scheduled_wet_date  = null;
      entity_copy.parent_id           = entity.id; // value to save on database
      entity_copy.is_parent           = false;
      entity_copy.childs              = [];
      // aux values to manage rows on frontend
      entity_copy.is_sub_row          = true;
      entity_copy.sub_row_of          = entity.id;
      entity_copy.max_acres_value     = entity.acres;
      entity_copy.not_scheduled_acres = 0;
      entity_copy.draggable           = true;
      entity_copy.scheduled_block     = null;
      entity_copy.over                = false;

      // create on database, if it's not created now, it will not be appear when filters are applied
      ContractScheduleVarietiesService.saveChilds([entity_copy]).then(function(newVarietiesArray) {
        // as only one was created, the new row is on 0 index from response
        if (newVarietiesArray[0]) {
          entity_copy.id = newVarietiesArray[0].id;
          // check the index to insert on the last position of its group
          // countBy returns an object like {'true': number of matchs, 'false': number of not matchs}
          var count = _.countBy(vm.filteredContracts, {sub_row_of: entity.id});
          var childRows = 1;
          (count.true) ? childRows = count.true : null;
          // insert on shown and original contract lists
          vm.filteredContracts.splice(index + childRows, 0, entity_copy);

          // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
          // // all available_acres will be assigned to new child
          // entity_copy.acres = entity.not_scheduled_acres;
          // // update related rows, since child acres have changed
          // entity_copy.recalculate = true;
          // contractAcresChanged(entity_copy);
          // updateAvailableAcres(entity_copy);
        }
      },
      function(err) {
        console.error(err);
        var error;
        if(err.status && err.status !== 500) {
          error = err.data.message;
        }
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">The contract could not be created. ' + ((error !== undefined)? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
      });
    }

    /**
     * Remove Contract Row
     * @param  {[type]} index    [description]
     * @param  {[type]} contract [description]
     * @return {[type]}
     */
    function removeContract(index, contract) {
      if (contract.scheduled_block && contract.scheduled_block.name) {
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">The contract could not be deleted. The resource can not be deleted because there are one or more resources associated with it</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
      } else {
        ContractScheduleVarietiesService.delete(contract.id).then(function() {
          vm.filteredContracts.splice(index, 1);
          if (!contract.acres_error && contract.acres >= 0) {
            contract.availableContractAcres += contract.acres;
          }

          contract.acres = 0;
          contract.not_scheduled_acres = 0;
          contract.acres_scheduled = 0;
          contract.recalculate = true;
          // update related rows, as its acres has changed
          contract.recalculate = true;
          contractAcresChanged(contract);
          updateAvailableAcres(contract);
        },
        function(err) {
          console.error(err);
          var error;
          if(err.status && err.status !== 500) {
            error = err.data.message;
          }
          vm.toast = $mdToast.show({
            template: '<md-toast class="md-toast error">The contract could not be deleted. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 0
          });
        });
      }
    }

    /**
     * Function called when Contract Scheduled Acres value has changed
     * @param  {[type]} contract [description]
     * @param  {[type]} error    [description]
     * @param  {[type]} notSend  [not mark row as modified, to send to API. It's used only when Contracts are loaded initially]
     * @return {[type]}
     */
    function contractAcresChanged(contract, error, notSend) {
      // contract.recalculate field was defined to avoid unwanted recalculations when max/min fields are updated
      if (contract.recalculate) {
        if (error) {
          contract.acres_error = true;
          contract.not_scheduled_acres = 0;
        } else {
          contract.acres_error = false;
        }
        if (!notSend) {
          contract.sendToAPI = true;
        }
        var message = '';
        var rows = _.filter(vm.filteredContracts, {sub_row_of: contract.sub_row_of});
        var mainRow = {};
        mainRow.aux_acres = 0;
        var childAcres = 0;
        var childAcresScheduled = 0;
        var totalAcresScheduled = 0;

        // childAcres = sum of all Acres from all childs except main row
        // calculate childAcres
        for (var i = 0; i < rows.length; i++) {
          if (!rows[i].is_sub_row) {
            mainRow = rows[i];
          } else if (!rows[i].acres_error && isFinite(parseFloat(rows[i].acres)) && angular.isNumber(parseFloat(rows[i].acres))) {
            // I'm using isFinite since angular.isNumber(NaN) returns true
            // I'm using angular.isNumber since isFinite(null) returns true
            rows[i].acres = parseFloat(rows[i].acres);
            childAcres   += parseFloat(rows[i].acres);
            if (rows[i].acres_scheduled) {
              childAcresScheduled += parseFloat((rows[i].acres_scheduled).toFixed(1));
            }
          }
        }
        // show acres on first child
        mainRow.acres = parseFloat((mainRow.aux_acres - childAcres).toFixed(1));
        // scheduled acres total from all childs are on totalAcresScheduled
        totalAcresScheduled = childAcresScheduled;
        // if mainRow has acres_scheduled, add them to totalAcresScheduled
        if (mainRow.acres_scheduled) {
          totalAcresScheduled += mainRow.acres_scheduled;
        }

        // calculate not_scheduled_acres acres from Block
        // mainRow.aux_acres has the total original amount of acres assigned to the Contract
        mainRow.not_scheduled_acres = parseFloat((mainRow.aux_acres - totalAcresScheduled).toFixed(1));

        // assign availableContractAcres on all rows
        // now, availableContractAcres are the ones from the mainRow (mainRow.acres)
        angular.forEach(rows, function(c) {
          if (mainRow.acres <= 0) {
            c.availableContractAcres = 0;
          } else {
            c.availableContractAcres = mainRow.acres;
          }
        });
        // as acres from mainRow has been recalculated, is needed to save them
        if (!notSend) {
          mainRow.sendToAPI = true;
        }
        // show proper error
        if (contract.acres_error) {
          message = 'Invalid quantity';
          if (contract.acres !== null && contract.max_acres_value > 0) {
            message = 'Contract acres summatory can not be greater than ' + mainRow.aux_acres + '. Please, enter a value between 0 and ' + contract.max_acres_value.toString();
          } else
          if (mainRow.acres <= 0) {
            message = 'There are no acres to assign';
          }
          vm.toast = $mdToast.show({
            template: '<md-toast class="md-toast error">' + message + '</md-toast>',
            position: 'top right',
            hideDelay: 0
          });
          return;
        } else { // no error on current field
          // update available acres to schedule, only if it's not main Contract
          if (contract.is_sub_row) {
            if (contract.acres_scheduled) {
              contract.not_scheduled_acres = parseFloat((contract.acres - contract.acres_scheduled).toFixed(1));
            } else {
              contract.not_scheduled_acres = contract.acres;
            }
          }
        }
      }
    }

    /**
     * Set new available acres on all related rows from this contract, when Scheduled Acres has lost the focus
     * @param  {[type]} contract [description]
     * @return {[type]}
     */
    function updateAvailableAcres(contract) {
      if (contract.recalculate) {
        contract.recalculate = !contract.recalculate;
        if (contract.acres === null || contract.acres === undefined || !isFinite(contract.acres) || !angular.isNumber(contract.acres)) {
          contract.acres = 0;
          contract.not_scheduled_acres = 0;
        }
        var rows = _.filter(vm.filteredContracts, {sub_row_of: contract.sub_row_of});
        for (var j = 0; j < rows.length; j++) {
          if (!rows[j].acres_error && angular.isNumber(rows[j].acres)) {
            rows[j].max_acres_value = rows[j].acres + contract.availableContractAcres;
          } else {
            rows[j].max_acres_value = contract.availableContractAcres;
          }
        }
      }
    }

    /**
     * Function to add subblock into grower schedule array
     * @param {[type]} index [Main Block index (father of new subblock)]
     * @param {[type]} gsRow [Grower Schedule row data]
     */
    function addSubBlock(index, gsRow) {
      // don't allow to restore data anymore in case that main row was cleared
      gsRow.cleared = false;
      gsRow.deleted_id = null;
      var subblock = {};
      var contract = null;
      var rows = _.filter(vm.growerSchedules, {subBlockOf: gsRow.id});
      angular.forEach(rows, function(row) {
        row.canRemove = false;
      });
      // check if it is first child to copy father row data
      if (rows.length === 1) {
        subblock                   = _.cloneDeep(gsRow);
        subblock.firstChild        = true;
        if (gsRow.sched_acres_error) {
          subblock.scheduled_acres = null;
        }
        subblock.acres_in_block    = subblock.scheduled_acres;
        // check if the subblock is already scheduled to mark as changed, as nothing may be changed on it
        if (gsRow.grower_schedule_id > 0) {
          subblock.sendToAPI = true;
        }
        // if mainRow has an associated Contract, don't propagate the association
        gsRow.contract_schedule_variety_id = null;
        gsRow.sendToAPI = false;
        // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
        // checkVarietyIsRequired(subblock);
      } else {
        subblock = {
          acres_in_block             : 0,
          availableBlockAcres        : gsRow.availableBlockAcres, // aux value
          available_acres            : gsRow.availableBlockAcres,
          block_bed_direction_id     : gsRow.block_bed_direction_id,
          company_id                 : null,
          contract_schedule_variety_id : null, // if mainRow has an associated Contract, don't propagate the association
          firstChild                 : false,
          grower_schedule_sublocation: gsRow.grower_schedule_sublocation,
          growing_days               : null,
          max_sched_acres_block      : gsRow.availableBlockAcres, // aux value
          // number of locations     : null,
          scheduled_harvest_date     : null,
          pca_id                     : null,
          scheduled_acres            : null,
          scheduled_wet_date         : null,
          seed_id                    : null,
          subBlockOf                 : gsRow.id,
          variety_id                 : null,
          location_id                : gsRow.location_id,
          location_name              : gsRow.location_name,
          last_harvest_date          : gsRow.last_harvest_date,
          max_harvest_date           : gsRow.max_harvest_date,
          max_schedule_level         : gsRow.max_schedule_level,

          // API fields
          area_fiscal_year_id        : gsRow.area_fiscal_year_id,
          block_id                   : gsRow.block_id,
        };
        gsRow.block_number_of_locations_in_bed++; // aux value: number of subblocks and locations
        if (gsRow.block_number_of_locations_in_bed === 8) {
          gsRow.cannotAddSubblock = true;
        }
      }

      var subblocksAmount       = _.filter(rows, function (r) {return (r.isLocation);});
      var subblockNumber        = rows.length - subblocksAmount.length;
      subblock.block_name       = gsRow.block_name + '-' + subblockNumber.toString();
      subblock.aux_block_name   = subblock.block_name; // aux value to save the original block name, as block_name changes with locations
      subblock.isSubBlock       = true;
      subblock.canRemove        = true;
      subblock.canAddLocation   = true;
      subblock.hasSubBlock      = false;
      subblock.hasLocations     = false;
      subblock.grower_schedule_id = vm.aux_id--;
      // API fields
      subblock.id               = vm.aux_id--; // negative to create is as auxiliar
      subblock.is_parent        = false;
      subblock.acres_available  = 0;
      subblock.parent_id        = gsRow.id;
      subblock.parent_acres_in_block = gsRow.acres_in_block;
      subblock.subblock_number  = subblockNumber;
      subblock.crop_status      = 'Grower Scheduled';
      subblock.over             = false;

      subblock.block_number_of_locations_in_bed = gsRow.block_number_of_locations_in_bed;

      vm.growerSchedules.splice(index + rows.length, 0, subblock);

      gsRow.hasSubBlock         = true;
      gsRow.is_parent           = true;
      gsRow.scheduled_acres     = null;

      // if mainRow already has an associated block, we need to show the new name '{block_name}-1' on the contract
      if (gsRow.contract_schedule_variety_id && subblock.firstChild) {
        var contractIdx = _.findIndex(vm.filteredContracts, {id: gsRow.contract_schedule_variety_id});
        if (contractIdx > -1) {
          vm.filteredContracts[contractIdx].scheduled_block = {
            id: subblock.id,
            name: subblock.block_name,
            acres_scheduled: subblock.scheduled_acres,
            scheduled_wet_date: subblock.scheduled_wet_date
          };
          // Add schedule_level on related Block Name
          if (vm.aux_double_crop_num > 1) {
            vm.filteredContracts[contractIdx].scheduled_block.name += ' (' + vm.aux_double_crop_num + ')';
          }
        }
      }

      /// Check if block has subBlocks with locations, if yes i'll need to update all
      var rows2 = _.filter(vm.growerSchedules, {subBlockOf: gsRow.subBlockOf, hasSubBlock: false}); // don't include mainRow
      gsRow.hasLocations = false;
      angular.forEach(rows2, function(row) {
        row.block_number_of_locations_in_bed = gsRow.block_number_of_locations_in_bed;
        if (!gsRow.hasLocations && row.hasLocations) {
          gsRow.hasLocations = true;
        }
        if (gsRow.block_number_of_locations_in_bed > 7) {
          row.hasAllLocations = true;
        } else {
          row.hasAllLocations = false;
        }
      });

      // If block has subblocks with locations, then I need to check the right location for the new subblock and update all group locations
      if (gsRow.block_number_of_locations_in_bed <= 8) {
        var locations = SubblockLocationService.getByNumberOfLocations(
          subblock.block_bed_direction_id,
          subblock.block_number_of_locations_in_bed
        );

        if (locations) {
          // update the location name from all group
          for (var i = 0; i < rows2.length; i++) {
            rows2[i].grower_schedule_sublocation = locations[i];
            if (locations[i].name !== 'All') {
              rows2[i].block_name = rows2[i].aux_block_name + ' ' + locations[i].name;
            } else {
              rows2[i].block_name = rows2[i].aux_block_name;
            }
            // as block_name has changed, update on related contract
            if (rows2[i].contract_schedule_variety_id) {
              contract = _.find(vm.filteredContracts, {id: rows2[i].contract_schedule_variety_id});
              if (contract && contract.scheduled_block) {
                contract.scheduled_block.name = rows2[i].block_name;
                // Add schedule_level on related Block Name
                if (vm.aux_double_crop_num > 1) {
                  contract.scheduled_block.name += ' (' + vm.aux_double_crop_num + ')';
                }
              }
            }
          }
        }
      }
    }

    /**
     * Filter given Varieties by Scheduled Wet Date
     * @return {[type]}
     */
    function filterVarietiesByWetDate(gs, varieties) {
      var filteredVarieties = GeneralFunctionsService.filterVarietiesByWetDate(gs.scheduled_wet_date, varieties, gs.location_id, vm.fiscal_year);
      return filteredVarieties;
    }


    /**
     * Block Scheduled Acres changed
     * Then update available acres
     * @param  {[type]} gs             [Grower Schedule row data]
     * @param  {[type]} error          [Boolean that indicates if current field has error]
     * @param  {[type]} updateContract [Boolean that indicates if related contract needs to be updated]
     * @return {[type]}
     */
    function blockSchedAcresChanged(gs, error, updateContract) {
      gs.sched_acres_error = error;
      if (gs.recalculate) {
        // check if it's a subblock (with Locations) or only Original Block (with no subblocks or locations)
        if (gs.isSubBlock || (!gs.hasLocations && !gs.hasSubBlock)) {
          subblockSchedAcresChanged(gs, updateContract);
        } else if (gs.hasLocations || gs.isLocation) {
          locationSchedAcresChanged(gs, updateContract);
        }
        // mark as changed only if key was pressed (gs.changed = true)
        if (gs.changed) {
          gs.changed = false;
          markAsChanged(gs);
        }
      }
    }

    /**
     * Scheduled Acres from a Subblock or Subblock with Locations have been changed
     * @param  {[type]} gs             [description]
     * @param  {[type]} updateContract [description]
     * @return {[type]}
     */
    function subblockSchedAcresChanged(gs, updateContract) {
      // if block is related to a contract, update its scheduled_acres too
      if (updateContract && gs && !gs.sched_acres_error && gs.contract_schedule_variety_id) {
        var contract = _.find(vm.filteredContracts, {id: gs.contract_schedule_variety_id});
        if (contract) {
          contract.acres_scheduled      = gs.scheduled_acres;
          contract.scheduled_block.acres_scheduled = contract.acres_scheduled;
          contract.not_scheduled_acres  = parseFloat((contract.acres - contract.acres_scheduled).toFixed(1));
          contract.recalculate = true;
          contractAcresChanged(contract, false);
          updateAvailableAcres(contract);
        }
      }

      var rows = _.filter(vm.growerSchedules, {subBlockOf: gs.subBlockOf});
      var mainRow = {};
      mainRow.acres_in_block = 0;
      var childSchedAcres = 0;
      // if main row has been changed, then there are no subblocks
      if (gs.id === gs.subBlockOf) {
        mainRow = gs;
      } else {
        // there are subblocks

        // childSchedAcres = sum of all Scheduled Acres from childs
        // calculate childSchedAcres
        for (var i = 0; i < rows.length; i++) {
          if (rows[i].id === gs.subBlockOf) {
            mainRow = rows[i];
          } else if (!rows[i].sched_acres_error && isFinite(parseFloat(rows[i].scheduled_acres)) && angular.isNumber(parseFloat(rows[i].scheduled_acres))) {
            rows[i].scheduled_acres = parseFloat(rows[i].scheduled_acres);
            childSchedAcres += parseFloat(rows[i].scheduled_acres);
          }
        }
      }

      if (mainRow.acres_in_block) {
        mainRow.availableBlockAcres = parseFloat((mainRow.acres_in_block - childSchedAcres).toFixed(1));
        // will enter here only if the block has no subblocks
        if (!mainRow.sched_acres_error && isFinite(parseFloat(mainRow.scheduled_acres)) && angular.isNumber(parseFloat(mainRow.scheduled_acres))) {
          mainRow.scheduled_acres     = parseFloat(mainRow.scheduled_acres);
          mainRow.availableBlockAcres = parseFloat((mainRow.availableBlockAcres - mainRow.scheduled_acres).toFixed(1));
        }
        mainRow.available_acres = mainRow.availableBlockAcres;
      } else {
        mainRow.availableBlockAcres = 0;
        mainRow.available_acres = mainRow.availableBlockAcres;
      }

      // if it's not main block, then there are subblocks
      if (gs.id !== gs.subBlockOf) {
        gs.availableBlockAcres = mainRow.availableBlockAcres;
        gs.available_acres = mainRow.availableBlockAcres;
        if (!gs.sched_acres_error) {
          gs.acres_in_block = gs.scheduled_acres;
        } else {
          gs.acres_in_block = 0;
        }
        angular.forEach(rows, function(block) {
          block.availableBlockAcres = gs.availableBlockAcres;
          block.available_acres     = gs.availableBlockAcres;
        });
      }

      if (gs.sched_acres_error) {
        var message = 'Invalid quantity';
        if (gs.availableBlockAcres > 0) {
          message = 'Please, enter a value between 0 and ' + gs.availableBlockAcres.toString();
        } else if (gs.availableBlockAcres === 0) {
          message = 'There are no available acres';
        }
        // if scheduled_acres input is empty, not show message
        if (gs.scheduled_acres !== undefined) {
          vm.toast = $mdToast.show({
            template: '<md-toast class="md-toast error">' + message + '</md-toast>',
            position: 'top right',
            hideDelay: 0
          });
        }
        return;
      }
    }

    /**
     * Scheduled Acres from a Location have been changed
     * @param  {[type]} gs             [description]
     * @param  {[type]} updateContract [description]
     * @return {[type]}
     */
    function locationSchedAcresChanged(gs, updateContract) {
      // if block is related to a contract, update its scheduled_acres too
      if (updateContract && gs && gs.contract_schedule_variety_id) {
        var contract = _.find(vm.filteredContracts, {id: gs.contract_schedule_variety_id});
        if (contract) {
          contract.acres_scheduled      = gs.scheduled_acres;
          contract.scheduled_block.acres_scheduled = contract.acres_scheduled;
          contract.not_scheduled_acres  = parseFloat((contract.acres - contract.acres_scheduled).toFixed(1));
          contract.recalculate = true;
          contractAcresChanged(contract, false);
          updateAvailableAcres(contract);
        }
      }

      var rows = _.filter(vm.growerSchedules, {subBlockOf: gs.subBlockOf}); // no need to use gs.locationOf, it works too
      var mainRow = {};
      mainRow.acres_in_block = 0;
      var childSchedAcres = 0;
      // childSchedAcres = sum of all Scheduled Acres from childs
      // calculate childSchedAcres
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].id === gs.subBlockOf) {
          mainRow = rows[i];
        } else if (!rows[i].sched_acres_error && isFinite(parseFloat(rows[i].scheduled_acres)) && angular.isNumber(parseFloat(rows[i].scheduled_acres))) {
          rows[i].scheduled_acres = parseFloat(rows[i].scheduled_acres);
          childSchedAcres        += parseFloat(rows[i].scheduled_acres);
        }
      }

      if (mainRow.acres_in_block) {
        mainRow.availableBlockAcres = parseFloat((mainRow.acres_in_block - childSchedAcres).toFixed(1));
        // will enter here only if the block has no subblocks
        if (!mainRow.sched_acres_error && isFinite(parseFloat(mainRow.scheduled_acres)) && angular.isNumber(parseFloat(mainRow.scheduled_acres))) {
          mainRow.scheduled_acres     = parseFloat(mainRow.scheduled_acres);
          mainRow.availableBlockAcres = parseFloat((mainRow.availableBlockAcres - mainRow.scheduled_acres).toFixed(1));
        }
        mainRow.available_acres = mainRow.availableBlockAcres;
      } else {
        mainRow.availableBlockAcres = 0;
        mainRow.available_acres = mainRow.availableBlockAcres;
      }

      // if it's not main block, then there are subblocks
      if (gs.id !== gs.subBlockOf) {
        gs.availableBlockAcres = mainRow.availableBlockAcres;
        gs.available_acres = mainRow.availableBlockAcres;
        if (!gs.sched_acres_error) {
          gs.acres_in_block = gs.scheduled_acres;
        } else {
          gs.acres_in_block = 0;
        }
        angular.forEach(rows, function(block) {
          block.availableBlockAcres = gs.availableBlockAcres;
          block.available_acres     = gs.availableBlockAcres;
        });
      }

      if (gs.sched_acres_error) {
        var message = 'Invalid quantity';
        if (gs.availableBlockAcres > 0) {
          message = 'Please, enter a value between 0 and ' + gs.availableBlockAcres.toString();
        } else if (gs.availableBlockAcres === 0) {
          message = 'There are no available acres';
        }
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">' + message + '</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
        return;
      }
    }

    /**
     * Calculate max value for scheduled_acres, and assign it also on related group
     * @param  {[type]} gs [Grower Schedule row data]
     * @return {[type]}
     */
    function calculateBlockSchedAcresMax(gs) {
      if (gs.recalculate) {
        gs.recalculate = !gs.recalculate;
        var rows = _.filter(vm.growerSchedules, {subBlockOf: gs.subBlockOf});
        angular.forEach(rows, function(block) {
          if (!block.sched_acres_error && angular.isNumber(block.scheduled_acres) && isFinite(parseFloat(block.scheduled_acres))) {
            block.max_sched_acres_block = parseFloat((block.scheduled_acres + gs.available_acres).toFixed(1));
          } else {
            block.max_sched_acres_block = gs.available_acres;
          }
        });
      }
    }

    /**
     * Function to remove subblock
     * @param  {[type]} index [Grower Schedule row index]
     * @param  {[type]} gs    [Grower Schedule row data]
     * @return {[type]}
     */
    function removeSubBlock(index, gs) {
      if (gs.hasOwnProperty('id') && gs.id > 0) {
        vm.delete_grower_blocks.push(gs.id);
      }

      var mainRow = {};
      var subBlockLocations = [];

      mainRow = _.find(vm.growerSchedules, {id: gs.subBlockOf});

      if (gs.firstChild) {
        mainRow.hasSubBlock         = false;
        mainRow.scheduled_acres     = null;
        mainRow.available_acres     = mainRow.acres_in_block;
        mainRow.availableBlockAcres = mainRow.acres_in_block;
        mainRow.seedVarieties       = [];
        // just for calculation of max values work when calculateBlockSchedAcresMax() is called
        gs.available_acres          = mainRow.available_acres;
        gs.availableBlockAcres      = mainRow.available_acres;
        gs.scheduled_acres          = 0;

        if (gs.locationOf) {
          mainRow.locationOf = null;
        }
        // set mainRow aux location
        if (gs.grower_schedule_sublocation) {
          mainRow.block_bed_direction_id = gs.grower_schedule_sublocation.block_bed_direction_id;
          mainRow.block_number_of_locations_in_bed = gs.grower_schedule_sublocation.number_of_locations_in_bed;
        }

        vm.growerSchedules[index - 1] = mainRow;

        // check if removed firstChild has an associated contract to delete its association
        if (gs.contract_schedule_variety_id) {
          var contractIdx = _.findIndex(vm.filteredContracts, {id: gs.contract_schedule_variety_id});
          if (contractIdx > -1) {
            vm.filteredContracts[contractIdx].scheduled_block = null;
            vm.filteredContracts[contractIdx].draggable = true;
            vm.filteredContracts[contractIdx].over = false;
            vm.filteredContracts[contractIdx].not_scheduled_acres = vm.filteredContracts[contractIdx].acres;
          }
        }
      } else {
        // if current scheduled_acres value has no errors, accumulate it on mainRow, as they are available acres now
        if (mainRow && !gs.sched_acres_error && gs.scheduled_acres) {
          mainRow.available_acres = parseFloat((mainRow.available_acres + gs.scheduled_acres).toFixed(1));
          mainRow.availableBlockAcres = parseFloat((mainRow.availableBlockAcres + gs.scheduled_acres).toFixed(1));
          // just for calculation of max values work when calculateBlockSchedAcresMax() is called
          gs.available_acres = mainRow.available_acres;
          gs.availableBlockAcres = mainRow.available_acres;
        }
        // check if removed subblock has an associated contract to delete its association
        if (gs.contract_schedule_variety_id) {
          var contractIdx2 = _.findIndex(vm.filteredContracts, {id: gs.contract_schedule_variety_id});
          if (contractIdx2 > -1) {
            vm.filteredContracts[contractIdx2].scheduled_block = null;
            vm.filteredContracts[contractIdx2].draggable = true;
            vm.filteredContracts[contractIdx2].over = false;
          }
        }
      }

      mainRow.cannotAddSubblock = false;
      // check if deleted row has locations, and update block_number_of_locations_in_bed on main block
      if (gs.hasLocations) {
        // count number of locations from subblock to delete all childs
        subBlockLocations = _.filter(vm.growerSchedules, {locationOf: gs.id});
        if (subBlockLocations.length > 0) {
          // check locations acres, to restore them to mainRow.available_acres
          // check if locations to remove, have an associated contract to delete its association
          angular.forEach(subBlockLocations, function(location) {
            if (location.id !== location.subBlockOf && location.id !== gs.id) { // don't include subblock, just its locations
              // check acres ro restore
              if (!location.firstChild && mainRow && !location.sched_acres_error && location.scheduled_acres) {
                mainRow.available_acres = parseFloat((mainRow.available_acres + location.scheduled_acres).toFixed(1));
                mainRow.availableBlockAcres = parseFloat((mainRow.availableBlockAcres + location.scheduled_acres).toFixed(1));
                // just for calculation of max values work when calculateBlockSchedAcresMax() is called
                gs.available_acres = mainRow.available_acres;
                gs.availableBlockAcres = mainRow.available_acres;
              }
              // remove related contract
              if (location.contract_schedule_variety_id) {
                var contractIdx2 = _.findIndex(vm.filteredContracts, {id: location.contract_schedule_variety_id});
                if (contractIdx2 > -1) {
                  vm.filteredContracts[contractIdx2].scheduled_block = null;
                  vm.filteredContracts[contractIdx2].draggable = true;
                  vm.filteredContracts[contractIdx2].over = false;
                }
              }
            }
          });
          // remove locations
          vm.growerSchedules.splice(index, subBlockLocations.length);
          // update block_number_of_locations_in_bed on main block
          if (gs.firstChild) {
            mainRow.block_number_of_locations_in_bed = 1; // only mainRow is left with no locations
          } else if (mainRow.block_number_of_locations_in_bed > 1) {
            mainRow.block_number_of_locations_in_bed -= subBlockLocations.length;
          }
        }
      } else {
        // as block don't have locations, just remove 1 row
        vm.growerSchedules.splice(index, 1);
        // update block_number_of_locations_in_bed on main block
        if (mainRow.block_number_of_locations_in_bed > 1) {
          mainRow.block_number_of_locations_in_bed--;
        }
      }

      // assign availableBlockAcres on all rows
      var rows = _.filter(vm.growerSchedules, {subBlockOf: gs.subBlockOf});
      angular.forEach(rows, function(row) {
        row.availableBlockAcres = mainRow.availableBlockAcres;
        row.available_acres = mainRow.availableBlockAcres;
      });

      // update block_number_of_locations_in_bed on all group rows
      var rows2 = _.filter(vm.growerSchedules, {subBlockOf: gs.subBlockOf, hasSubBlock: false}); // don't include mainRow
      var locationsFound = false;
      for (var i = 0; i < rows2.length; i++) {
        rows2[i].block_number_of_locations_in_bed = mainRow.block_number_of_locations_in_bed;
        // check if there are some subblocks with locations
        var blockLocations = _.filter(vm.growerSchedules, {locationOf: rows2[i].id, isLocation: true});
        if (blockLocations.length === 0) {
          rows2[i].hasLocations = false;
        } else {
          locationsFound = true;
        }
      }
      // update mainRow.hasLocations field with new data
      mainRow.hasLocations = locationsFound;

      // allow to add subblocks again, if there are no more locations
      if (!locationsFound) {
        mainRow.cannotAddSubblock = false;
      }

      ////// START - update locations on all group,
      ////// and search the last subblock to allow deletion (as exists locaations, could not be on current index - 1 position)

      // get locations
      var locations = SubblockLocationService.getByNumberOfLocations(
        mainRow.block_bed_direction_id,
        mainRow.block_number_of_locations_in_bed
      );

      var lastSubblockIdx = null;
      if (locations) {
        // update the location name from all group
        for (var j = 0; j < rows2.length; j++) {
          rows2[j].grower_schedule_sublocation = locations[j];
          // concatenate location name to block_name
          if (locations[j].name !== 'All') {
            rows2[j].block_name = rows2[j].aux_block_name + ' ' + locations[j].name;
          } else if (!gs.firstChild) { // if firstChild was deleted, don't assign its name to mainRow
            rows2[j].block_name = rows2[j].aux_block_name;
          }
          // as block_name has changed, update on related contract
          if (rows2[j].contract_schedule_variety_id) {
            var contract = _.find(vm.filteredContracts, {id: rows2[j].contract_schedule_variety_id});
            if (contract && contract.scheduled_block) {
              contract.scheduled_block.name = rows2[j].block_name;
              // Add schedule_level on related Block Name
              if (vm.aux_double_crop_num > 1) {
                contract.scheduled_block.name += ' (' + vm.aux_double_crop_num + ')';
              }
            }
          }
          // Allow to add new locations if there are at most 7 subblocks (as 8 are max locations)
          if (mainRow.block_number_of_locations_in_bed <= 7) {
            rows2[j].hasAllLocations = false;
          } else {
            rows2[j].hasAllLocations = true;
          }
          // Search index of last subblock that is not a location
          if (rows2[j].isSubBlock && !rows2[j].isLocation) {
            lastSubblockIdx = j;
          }
        }
      }
      // if lastSubblockIdx is null, thus the last subblock hasn't locations, and is on index - 1 position
      if (lastSubblockIdx !== null) {
        rows2[lastSubblockIdx].canRemove = true;
      }
      ////// END - Reset locations
      gs.recalculate = true;
      calculateBlockSchedAcresMax(gs);
      if (gs.firstChild) {
        clearInfo(mainRow);
      }
      // clean errors
      gs.wet_date_error               = false;
      gs.harvest_date_error           = false;
      gs.wet_date_period_error        = false;
      gs.harvest_date_period_error    = false;
      gs.wet_date_variety_error       = false;
      gs.last_harvest_date_error      = false;
      gs.max_harvest_date_error       = false;
      gs.wet_date_fiscal_year_error   = false;
      gs.harvest_date_fiscal_year_error = false;
      gs.varietyError                 = false;
      // check if there are errors on more datepickers from other rows
      checkDateErrors(gs);
      // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
      // check if there are errors on variety selector from other rows
      // checkVarietyIsRequired(gs, true);
    }

    /**
     * Function to add a Location into given Block
     * @param  {[type]} index [Grower Schedule row index]
     * @param  {[type]} gsRow [Grower Schedule row data]
     */
    function addLocation(index, gsRow) {
      // don't allow to restore data anymore in case that main row was cleared
      gsRow.cleared = false;
      gsRow.deleted_id = null;
      var newLocation            = _.cloneDeep(gsRow);
      // remove id
      (newLocation.id !== undefined) ? delete newLocation.id : null;
      // check if it is the main row, so it is not a location row
      if (!gsRow.isLocation) {
        gsRow.hasLocations       = true;
        gsRow.cannotAddSubblock  = true;
        gsRow.locationOf         = gsRow.id;
      }
      // set empty data
      newLocation.firstChild               = false;
      newLocation.isLocation               = true;
      newLocation.locationOf               = gsRow.id;
      newLocation.grower_block_id          = gsRow.id;
      newLocation.grower_schedule_id       = vm.aux_id--;
      newLocation.block_name               = null;
      newLocation.acres_in_block           = 0;
      newLocation.available_acres          = gsRow.availableBlockAcres;
      newLocation.max_sched_acres_block    = gsRow.availableBlockAcres; // aux value
      newLocation.company_id               = null;
      newLocation.seed_id                  = null;
      newLocation.variety_id               = null;
      newLocation.seedVarieties            = [];
      newLocation.scheduled_acres          = null;
      newLocation.growing_days             = null;
      newLocation.scheduled_harvest_date   = null;
      newLocation.canAddLocation           = false;
      newLocation.hasLocations             = false;
      // clean errors
      newLocation.wet_date_error           = false;
      newLocation.harvest_date_error       = false;
      newLocation.wet_date_period_error    = false;
      newLocation.harvest_date_period_error = false;
      newLocation.wet_date_variety_error   = false;
      newLocation.last_harvest_date_error  = false;
      newLocation.max_harvest_date_error   = false;
      newLocation.wet_date_fiscal_year_error = false;
      newLocation.harvest_date_fiscal_year_error = false;
      newLocation.varietyError             = false;
      // empty fields if the mainRow has been related to a Contract (drag & drop)
      newLocation.dropped                  = false;
      newLocation.company_name             = null;
      newLocation.seed_name                = null;
      newLocation.variety_name             = null;
      newLocation.contract_schedule_variety_id = null;
      newLocation.recalculate              = false;
      newLocation.over                     = false;

      if (newLocation.isSubBlock) {
        gsRow.hasLocations = true;
        setSubBlockLocation(newLocation, index);
      } else {
        setMainBlockLocations(newLocation, index);
      }
      // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
      // checkVarietyIsRequired(newLocation);
    }

    /**
     * Location added on a mainRow. Get the Location for new row and update the Locations on all group rows
     * @param {[type]} newGsRow [description]
     * @param {[type]} index    [description]
     */
    function setMainBlockLocations(newGsRow, index) {
      // check if the block has already the max number of locations
      if (newGsRow.grower_schedule_sublocation.number_of_locations_in_bed < 8) {
        // increment number of current locations for group
        newGsRow.grower_schedule_sublocation.number_of_locations_in_bed++;
        if (newGsRow.grower_schedule_sublocation.number_of_locations_in_bed === 8) {
          vm.growerSchedules[index].hasAllLocations = true;
        }

        // get all locations for the current number of locations
        var locations = SubblockLocationService.getByNumberOfLocations(
          newGsRow.grower_schedule_sublocation.block_bed_direction_id,
          newGsRow.grower_schedule_sublocation.number_of_locations_in_bed
        );

        if (locations) {
          var rows = [];
          rows = _.filter(vm.growerSchedules, {locationOf: newGsRow.locationOf});
          // insert the new row
          vm.growerSchedules.splice(index + rows.length, 0, newGsRow);
          // filter again to have the new row binded on the results
          rows = _.filter(vm.growerSchedules, {locationOf: newGsRow.locationOf});

          // update the location name from all group
          for (var i = 0; i < rows.length; i++) {
            rows[i].grower_schedule_sublocation = locations[i];
            if (locations[i].name !== 'All') {
              rows[i].block_name = rows[i].aux_block_name + ' ' + locations[i].name;
            } else {
              rows[i].block_name = rows[i].aux_block_name;
            }
            // as block_name has changed, update on related contract
            if (rows[i].contract_schedule_variety_id) {
              var contract = _.find(vm.filteredContracts, {id: rows[i].contract_schedule_variety_id});
              if (contract && contract.scheduled_block) {
                contract.scheduled_block.name = rows[i].block_name;
                // Add schedule_level on related Block Name
                if (vm.aux_double_crop_num > 1) {
                  contract.scheduled_block.name += ' (' + vm.aux_double_crop_num + ')';
                }
              }
            }
          }
        }
      } else {
        // should never enter here
        vm.growerSchedules[index].hasAllLocations = true;
      }
    }

    /**
     * Location added on a Subblock. Get the Location for new row and update the Locations on all block rows (including all subblocks)
     * @param {[type]} newGsRow [description]
     * @param {[type]} index    [description]
     */
    function setSubBlockLocation(newGsRow, index) {
      var  mainRow = _.find(vm.growerSchedules, {subBlockOf: newGsRow.subBlockOf, hasSubBlock: true});
      mainRow.hasLocations = true;

      // check if the block has already the max number of locations
      if (mainRow.block_number_of_locations_in_bed <= 8) {
        // increment number of current locations for group
        mainRow.block_number_of_locations_in_bed++;

        if (mainRow.block_number_of_locations_in_bed === 8) {
          mainRow.cannotAddSubblock = true;
        }

        // get all locations for the current number of locations
        var locations = SubblockLocationService.getByNumberOfLocations(
          mainRow.block_bed_direction_id,
          mainRow.block_number_of_locations_in_bed
        );

        if (locations) {
          // count number of locations of current subblock, to insert the new one on the last index
          var subblockLocations = _.filter(vm.growerSchedules, {locationOf: newGsRow.locationOf, isLocation: true});
          // insert the new row
          vm.growerSchedules.splice(index + subblockLocations.length + 1, 0, newGsRow);

          // get all subblocks and locations from current block
          var rows = _.filter(vm.growerSchedules, {subBlockOf: newGsRow.subBlockOf, hasSubBlock: false}); // don't include mainRow
          // update the location name from all group
          for (var i = 0; i < rows.length; i++) {
            rows[i].grower_schedule_sublocation = locations[i];
            // concatenate location name to block_name
            if (locations[i].name !== 'All') {
              rows[i].block_name = rows[i].aux_block_name + ' ' + locations[i].name;
            } else {
              rows[i].block_name = rows[i].aux_block_name;
            }
            // as block_name has changed, update on related contract
            if (rows[i].contract_schedule_variety_id) {
              var contract = _.find(vm.filteredContracts, {id: rows[i].contract_schedule_variety_id});
              if (contract && contract.scheduled_block) {
                contract.scheduled_block.name = rows[i].block_name;
                // Add schedule_level on related Block Name
                if (vm.aux_double_crop_num > 1) {
                  contract.scheduled_block.name += ' (' + vm.aux_double_crop_num + ')';
                }
              }
            }
            // update block_number_of_locations_in_bed on current row
            rows[i].block_number_of_locations_in_bed = mainRow.block_number_of_locations_in_bed;
            if (mainRow.block_number_of_locations_in_bed === 8) {
              rows[i].hasAllLocations = true;
            }
          }
        }
      } else {
        // should never enter here
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">The block has reached the maximum number of locations</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
      }
    }

    /**
     * Remove location
     * @param  {[type]} index [description]
     * @param  {[type]} gsRow [description]
     * @return {[type]}
     */
    function removeLocation(index, gsRow) {
      if (gsRow.hasOwnProperty('grower_schedule_id') && gsRow.grower_schedule_id > 0) {
        vm.delete_grower_schedules.push(gsRow.grower_schedule_id);
      }
      if (gsRow.isSubBlock) {
        removeSubblockLocation(index, gsRow);
      } else {
        removeMainBlockLocation(index, gsRow);
      }
    }

    /**
     * Functionality to remove Locations from an Original Block (No Subblocks) from view
     * @param  {[type]} index [description]
     * @param  {[type]} gsRow [description]
     * @return {[type]}
     */
    function removeMainBlockLocation(index, gsRow) {
      var mainRow = _.find(vm.growerSchedules, {locationOf: gsRow.locationOf, hasLocations: true});

      // get all locations for the current number of locations
      gsRow.grower_schedule_sublocation.number_of_locations_in_bed--;
      var locations = SubblockLocationService.getByNumberOfLocations(
        gsRow.grower_schedule_sublocation.block_bed_direction_id,
        gsRow.grower_schedule_sublocation.number_of_locations_in_bed
      );

      vm.growerSchedules.splice(index, 1);
      // clean errors
      gsRow.wet_date_error               = false;
      gsRow.harvest_date_error           = false;
      gsRow.wet_date_period_error        = false;
      gsRow.harvest_date_period_error    = false;
      gsRow.wet_date_variety_error       = false;
      gsRow.last_harvest_date_error      = false;
      gsRow.max_harvest_date_error       = false;
      gsRow.wet_date_fiscal_year_error   = false;
      gsRow.harvest_date_fiscal_year_error = false;
      gsRow.varietyError                 = false;
      // check if there are errors on more datepickers from other rows
      checkDateErrors(gsRow);
      // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
      // check if there are errors on variety selector from other rows
      // checkVarietyIsRequired(gsRow, true);

      mainRow.hasAllLocations = false;

      if (mainRow && !gsRow.sched_acres_error && gsRow.scheduled_acres) {
        mainRow.available_acres = parseFloat((mainRow.available_acres + gsRow.scheduled_acres).toFixed(1));
        mainRow.availableBlockAcres = parseFloat((mainRow.availableBlockAcres + gsRow.scheduled_acres).toFixed(1));
        // just for calculation of max values work when calculateBlockSchedAcresMax() is called
        gsRow.available_acres = mainRow.availableBlockAcres;
        gsRow.availableBlockAcres = mainRow.availableBlockAcres;
      }

      // update availableBlockAcres and location name from all group
      var rows = _.filter(vm.growerSchedules, {locationOf: gsRow.locationOf});
      for (var i = 0; i < rows.length; i++) {
        rows[i].availableBlockAcres         = mainRow.available_acres;
        rows[i].grower_schedule_sublocation = locations[i];
        if (locations[i].name !== 'All') {
          rows[i].block_name = rows[i].aux_block_name + ' ' + locations[i].name;
        } else {
          rows[i].block_name = rows[i].aux_block_name;
        }
        // as block_name has changed, update on related contract
        if (rows[i].contract_schedule_variety_id) {
          var contract = _.find(vm.filteredContracts, {id: rows[i].contract_schedule_variety_id});
          if (contract && contract.scheduled_block) {
            contract.scheduled_block.name = rows[i].block_name;
            // Add schedule_level on related Block Name
            if (vm.aux_double_crop_num > 1) {
              contract.scheduled_block.name += ' (' + vm.aux_double_crop_num + ')';
            }
          }
        }
      }
      if (rows.length === 1) {
        mainRow.hasLocations = false;
        mainRow.cannotAddSubblock = false; // allow to add subblocks again, as there are no more locations
      }
      gsRow.recalculate = true;
      calculateBlockSchedAcresMax(gsRow);
      // check if location has a related Contract, to remove its association
      if (gsRow.contract_schedule_variety_id) {
        var contractIdx = _.findIndex(vm.filteredContracts, {id: gsRow.contract_schedule_variety_id});
        if (contractIdx > -1) {
          vm.filteredContracts[contractIdx].scheduled_block = null;
          vm.filteredContracts[contractIdx].draggable = true;
          vm.filteredContracts[contractIdx].over = false;
          vm.filteredContracts[contractIdx].not_scheduled_acres = vm.filteredContracts[contractIdx].acres;
        }
      }
    }

    /**
     * Functionality to remove Locations from a Subblock from the view
     * @param  {[type]} index [description]
     * @param  {[type]} gsRow [description]
     * @return {[type]}
     */
    function removeSubblockLocation(index, gsRow) {
      var mainRow = _.find(vm.growerSchedules, {subBlockOf: gsRow.subBlockOf, hasSubBlock: true});
      // remove location
      vm.growerSchedules.splice(index, 1);
      // clean errors
      gsRow.wet_date_error               = false;
      gsRow.harvest_date_error           = false;
      gsRow.wet_date_period_error        = false;
      gsRow.harvest_date_period_error    = false;
      gsRow.wet_date_variety_error       = false;
      gsRow.last_harvest_date_error      = false;
      gsRow.max_harvest_date_error       = false;
      gsRow.wet_date_fiscal_year_error   = false;
      gsRow.harvest_date_fiscal_year_error = false;
      gsRow.varietyError                 = false;
      // check if there are errors on more datepickers from other rows
      checkDateErrors(gsRow);
      // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
      // check if there are errors on variety selector from other rows
      // checkVarietyIsRequired(gsRow, true);

      // get all locations for the current number of locations
      mainRow.block_number_of_locations_in_bed--;
      var locations = SubblockLocationService.getByNumberOfLocations(
        mainRow.block_bed_direction_id,
        mainRow.block_number_of_locations_in_bed
      );

      mainRow.cannotAddSubblock = false;

      // restore deleted row acres on mainRow
      if (mainRow && !gsRow.sched_acres_error && gsRow.scheduled_acres) {
        mainRow.available_acres = parseFloat((mainRow.available_acres + gsRow.scheduled_acres).toFixed(1));
        mainRow.availableBlockAcres = parseFloat((mainRow.availableBlockAcres + gsRow.scheduled_acres).toFixed(1));
        // just for calculation of max values work when calculateBlockSchedAcresMax() is called
        gsRow.available_acres = mainRow.availableBlockAcres;
        gsRow.availableBlockAcres = mainRow.availableBlockAcres;
      }

      // update availableBlockAcres and location name from all group
      var rows = _.filter(vm.growerSchedules, {subBlockOf: gsRow.subBlockOf, hasSubBlock: false});
      var locationsFound = false;
      for (var i = 0; i < rows.length; i++) {
        rows[i].availableBlockAcres               = mainRow.available_acres;
        rows[i].block_number_of_locations_in_bed  = mainRow.block_number_of_locations_in_bed;
        rows[i].grower_schedule_sublocation       = locations[i];
        // concatenate location name to block_name
        if (locations[i].name !== 'All') {
          rows[i].block_name = rows[i].aux_block_name + ' ' + locations[i].name;
        } else {
          rows[i].block_name = rows[i].aux_block_name;
        }
        // as block_name has changed, update on related contract
        if (rows[i].contract_schedule_variety_id) {
          var contract = _.find(vm.filteredContracts, {id: rows[i].contract_schedule_variety_id});
          if (contract && contract.scheduled_block) {
            contract.scheduled_block.name = rows[i].block_name;
            // Add schedule_level on related Block Name
            if (vm.aux_double_crop_num > 1) {
              contract.scheduled_block.name += ' (' + vm.aux_double_crop_num + ')';
            }
          }
        }
        // as are locations available, allow to add new ones
        rows[i].hasAllLocations = false;
        var blockLocations = _.filter(vm.growerSchedules, {locationOf: rows[i].id, isLocation: true});
        if (blockLocations.length === 0) {
          rows[i].hasLocations = false;
        } else {
          locationsFound = true;
        }
      }
      // if no subblock has locations
      if (!locationsFound) {
        mainRow.hasLocations = false;
      }
      if (rows.length === 0) {
        mainRow.hasLocations = false;
        mainRow.hasSubBlock = false;
        mainRow.is_parent = false;
        mainRow.cannotAddSubblock = false; // allow to add subblocks again, as there are no more locations
      }
      gsRow.recalculate = true;
      calculateBlockSchedAcresMax(gsRow);
      // check if location has a related Contract, to remove its association
      if (gsRow.contract_schedule_variety_id) {
        var contractIdx = _.findIndex(vm.filteredContracts, {id: gsRow.contract_schedule_variety_id});
        if (contractIdx > -1) {
          vm.filteredContracts[contractIdx].scheduled_block = null;
          vm.filteredContracts[contractIdx].draggable = true;
          vm.filteredContracts[contractIdx].over = false;
          vm.filteredContracts[contractIdx].not_scheduled_acres = vm.filteredContracts[contractIdx].acres;
        }
      }
    }

    /**
     * [resetFilters description]
     */
    function resetFilters() {
      vm.active_filters = [];
      vm.location       = null;
      vm.ranch          = null;
      vm.allRanches     = [];
      vm.block          = null;
      vm.allBlocks      = [];
      vm.season         = null;
      vm.we             = null;
      vm.shipper        = null;
      vm.filtersObj     = {};
      getContractsAndBlocks();
      if (vm.fiscal_year.begin_date && vm.fiscal_year.end_date) {
        calculateWeekEndings(vm.fiscal_year.begin_date, vm.fiscal_year.end_date);
      }
    }

    /**
     * Function called when global search or blocks search are changed
     * @param  {[type]} growerFormInvalid   [description]
     * @param  {[type]} contractFormInvalid [description]
     * @param  {[type]} field               [description]
     * @return {[type]}
     */
    function searchChanged(growerFormInvalid, contractFormInvalid, field) {
      if (growerFormInvalid || contractFormInvalid || vm.customError || vm.varietiesError) {
        // restore old search value
        vm['aux' + field] = vm[field];
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">There are required fields empty or with errors. Please, check them</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
      } else {
        // update old search value
        vm[field] = vm['aux' + field];
        saveAll();
      }
    }

    /**
     * Contracts/Blocks schedule filter changed (bottom filters)
     * @param  {[type]} growerFormInvalid   [description]
     * @param  {[type]} contractFormInvalid [description]
     * @param  {[type]} switchType          [description]
     * @param  {[type]} listType            [description]
     */
    function schedulefilterChange(growerFormInvalid, contractFormInvalid, switchType, listType) {
      if (growerFormInvalid || contractFormInvalid || vm.customError || vm.varietiesError) {
        vm[switchType] = !vm[switchType];
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">There are required fields empty or with errors. Please, check them</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
      } else {
        (vm[switchType]) ? vm[listType] = 'Not Scheduled' : vm[listType] = 'All';
        saveAll();
      }
    }

    /**
     * Validate that forms have no errors, so changes can be saved before change the filter
     * @param  {[type]} growerFormInvalid   [description]
     * @param  {[type]} contractFormInvalid [description]
     * @param  {[type]} filterType          [description]
     * @param  {[type]} filterId            [description]
     * @param  {[type]} filterObj           [description]
     */
    function validateSharedFilterChange(growerFormInvalid, contractFormInvalid, filterType, filterId, filterObj) {
      // check if the forms have errors, to call saveAll() function without any errors
      if (growerFormInvalid || contractFormInvalid || vm.customError || vm.varietiesError) {
        setTimeout(function() {
          vm[filterType] = vm['aux'+filterType];
        });
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">There are required fields empty or with errors. Please, check them</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
      } else {
        setTimeout(function() {
          vm['aux'+filterType] = filterId;
          onSharedFilterChange(vm.contractListType, filterType);
          checkFilterLabels(filterObj);
        });
      }
    }

    /**
     * Filters have changed
     * Filter Object returns Location - Season - Week Ending - Shipper (Shared filters)
     * @param  {[type]} type [description]
     */
    function onSharedFilterChange(type, subtype) {
      // if Location has changed, load its Ranches
      if (subtype && subtype === 'location') {
        vm.ranch      = null;
        vm.block      = null;
        vm.allRanches = [];
        vm.allBlocks  = [];
        // remove Ranch from active filters shown (on tables Header)
        removeFromShownFilters('Ranch');
        // remove Block from active filters shown (on tables Header)
        removeFromShownFilters('Block');
        RanchService.getRanchesByLocation(vm.location, {}).then(function(ranchesData) {
          vm.allRanches = ranchesData.ranches;
        });
      }
      // if Ranch has changed, load its Blocks
      if (subtype && subtype === 'ranch') {
        vm.block      = null;
        vm.allBlocks  = [];
        // remove Block from active filters shown (on tables Header)
        removeFromShownFilters('Block');
        // search Blocks from selected Ranch
        var ranch  = _.find(vm.allRanches, {id: vm.ranch});
        if (ranch && ranch.hasOwnProperty('blocks') && ranch.blocks.length) {
          vm.allBlocks = ranch.blocks;
        }
      }
      // if Season filter has changed, I need to remove the Week Ending filter
      if (subtype && subtype === 'season') {
        vm.we            = null;
        vm.allWeekEnding = [];
        // remove Week Ending from active filters shown (on tables Header)
        removeFromShownFilters('Week');
      }
      // check location filter
      if (vm.location) {
        vm.filtersObj['location_id'] = vm.location;
      }
      // check season filter
      if (vm.season) {
        vm.filtersObj['season_id'] = vm.season;
        // show season week endings
        var season_data = _.find(vm.allFiscalYearSeasons, {season_id: vm.season});
        calculateWeekEndings(season_data.start_date, season_data.end_date);
      }
      // check week ending
      if (vm.we) {
        // endpoint only accepts date without time
        vm.filtersObj['week_ending'] = moment(vm.we).hours(0).format('YYYY-MM-DD');
      }
      // check shipper filter
      if (vm.shipper) {
        vm.filtersObj['company_id'] = vm.shipper;
      }

      // save changes, since the filter will change and the data will be lost
      getVarietiesToSave(true);
    }

    /**
     * Show active filters label on Shipper Contracts & Blocks Information table headers
     * @param  {[type]} obj [filter data]
     * @return {[type]}
     */
    function checkFilterLabels(obj) {
      var idx = _.findIndex(vm.active_filters, {type: obj.type});
      if (idx > -1) {
        vm.active_filters[idx] = obj;
      } else {
        vm.active_filters.push(obj);
        vm.active_filters = _.orderBy(vm.active_filters, ['id']);
      }
    }

    /**
     * Remove given filter from shown filters on tables headers (active filters)
     * @param  {[type]} type [filter type, assigned on main-sidenav.html]
     * @return {[type]}
     */
    function removeFromShownFilters(type) {
      var idx = _.findIndex(vm.active_filters, {'type': type});
      if (idx > -1) {
        vm.active_filters.splice(idx, 1);
      }
    }

    /**
      * Toggle sidenav
      *
      * @param sidenavId
      */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /* DRAG N DROP FUNCTIONS */

    /**
     * Function to handle the information of grower schedule specific row affected when contract is dropped on it
     * @param  {[type]} gs    [grower schedule row information]
     * @param  {[type]} index [grower schedule row index]
     * @return {[type]}
     */
    function onDrop(gs, index) {
      hideToast();
      if (!vm.growerSchedules[index].dropped) {
        vm.dropped_gs       = gs;
        vm.dropped_gs_idx   = index;
      } else {
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">The selected block already has an associated contract</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
      }
    }

    /**
     * Function to hadle information about the contract row dragged to grower schedule specific row.
     *
     * @param  {Event}  event          event of drag & drop
     * @param  {int}    index          index
     * @param  {Object} contractData   contract data object
     * @return {[type]}                [description]
     */
    function dropSuccessHandler(ev, contractData) {
      // check if the contract has been dragged without lost the focus
      // if yes, call updateAvailableAcres() to set the maximun values on its related Contracts
      if (contractData.recalculate) {
        updateAvailableAcres(contractData);
      }
      if (vm.dropped_gs) {
        // validate that is not main row with subblocks, since in this case will be empty
        if (!vm.growerSchedules[vm.dropped_gs_idx].hasSubBlock) {
          var message = '';
          // validate that the Block is not scheduled yet
          if (vm.growerSchedules[vm.dropped_gs_idx].hasOwnProperty('grower_schedule_id') && vm.growerSchedules[vm.dropped_gs_idx].grower_schedule_id > 0) {
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">The Block is already scheduled</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
            vm.dropped_gs       = null;
            vm.dropped_gs_idx   = null;
            return;
          }
          // check if contract.acres amount is valid
          if (contractData.acres_error) {
            message = 'Please, enter a valid number of acres for the contract';
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">' + message + '</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
            vm.dropped_gs       = null;
            vm.dropped_gs_idx   = null;
            return;
          }

          associateContractWithBlock(contractData);
          vm.dropped_gs       = null;
          vm.dropped_gs_idx   = null;
        }
      }
    }

    /**
     * [associateContractWithBlock description]
     * @param  {[type]} contractData [description]
     * @return {[type]}
     */
    function associateContractWithBlock(contractData) {
      contractData.scheduled_block = {
        id: vm.dropped_gs.id,
        name: vm.dropped_gs.block_name,
        acres_scheduled: vm.dropped_gs.scheduled_acres,
        scheduled_wet_date: vm.dropped_gs.scheduled_wet_date
      };
      if (vm.aux_double_crop_num > 1) {
        contractData.scheduled_block.name += ' (' + vm.aux_double_crop_num + ')';
      }
      contractData.draggable = false;

      vm.growerSchedules[vm.dropped_gs_idx].cleared                 = false;
      vm.growerSchedules[vm.dropped_gs_idx].dropped                 = true;
      vm.growerSchedules[vm.dropped_gs_idx].sendToAPI               = true; // aux field to indicate changes to save
      vm.growerSchedules[vm.dropped_gs_idx].contract_schedule_variety_id = contractData.id;
      vm.growerSchedules[vm.dropped_gs_idx].company_id              = contractData.company_id;
      vm.growerSchedules[vm.dropped_gs_idx].company_name            = contractData.company_name;
      if (!vm.growerSchedules[vm.dropped_gs_idx].scheduled_wet_date) {
        vm.growerSchedules[vm.dropped_gs_idx].scheduled_wet_date    = new Date(contractData.original_wet_date);
      }
      vm.growerSchedules[vm.dropped_gs_idx].scheduled_harvest_date  = new Date(contractData.original_harvest_date);
      vm.growerSchedules[vm.dropped_gs_idx].seed_id                 = contractData.seed_id;
      vm.growerSchedules[vm.dropped_gs_idx].seed_name               = contractData.seed_name;
      vm.growerSchedules[vm.dropped_gs_idx].seedVarieties           = [];
      // get seed varieties
      if (contractData.seed && contractData.seed.seed_varieties && contractData.seed.seed_varieties.length) {
        var filteredVarieties = [];
        filteredVarieties = filterVarietiesByWetDate(vm.growerSchedules[vm.dropped_gs_idx], contractData.seed.seed_varieties);
        vm.growerSchedules[vm.dropped_gs_idx].seedVarieties = filteredVarieties;
      }
      // check if variety is on filtered list, regarding wet_date (valid variety)
      if (contractData.variety_id && contractData.variety && contractData.variety.name) {
        var found = _.find(vm.growerSchedules[vm.dropped_gs_idx].seedVarieties, {id: contractData.variety_id});
        if (found) {
          vm.growerSchedules[vm.dropped_gs_idx].variety_id              = contractData.variety_id;
          vm.growerSchedules[vm.dropped_gs_idx].variety_name            = contractData.variety.name;
          vm.growerSchedules[vm.dropped_gs_idx].wet_date_variety_error  = false;
        } else {
          vm.growerSchedules[vm.dropped_gs_idx].variety_id              = null;
          vm.growerSchedules[vm.dropped_gs_idx].variety_name            = null;
          vm.growerSchedules[vm.dropped_gs_idx].wet_date_variety_error  = true;
        }
      }
      // get variety from contractData, to show planting dates errors if needed
      if (contractData.variety) {
        vm.growerSchedules[vm.dropped_gs_idx].variety = contractData.variety;
      }

      // restart Block acres, in case that it already has scheduled_acres (but not saved yet)
      vm.growerSchedules[vm.dropped_gs_idx].scheduled_acres = null;
      vm.growerSchedules[vm.dropped_gs_idx].recalculate     = true;
      blockSchedAcresChanged(vm.growerSchedules[vm.dropped_gs_idx], false, false);

      // calculate acres

      // Check if Block has more available acres than contract has, or viceversa
      if (contractData.acres <= vm.growerSchedules[vm.dropped_gs_idx].availableBlockAcres) {
        vm.growerSchedules[vm.dropped_gs_idx].availableBlockAcres = parseFloat((vm.growerSchedules[vm.dropped_gs_idx].availableBlockAcres - contractData.acres).toFixed(1));
        vm.growerSchedules[vm.dropped_gs_idx].scheduled_acres   = contractData.acres;
        // acres_in_block = scheduled_acres only on child rows
        if (vm.growerSchedules[vm.dropped_gs_idx].isSubBlock || vm.growerSchedules[vm.dropped_gs_idx].isLocation) {
          vm.growerSchedules[vm.dropped_gs_idx].acres_in_block  = vm.growerSchedules[vm.dropped_gs_idx].scheduled_acres;
        }

        contractData.acres_scheduled                          = contractData.acres;
        contractData.not_scheduled_acres                      = 0;
      } else {
        vm.growerSchedules[vm.dropped_gs_idx].available_acres = 0;
        vm.growerSchedules[vm.dropped_gs_idx].scheduled_acres = vm.growerSchedules[vm.dropped_gs_idx].availableBlockAcres;
        // acres_in_block = scheduled_acres only on child rows
        if (vm.growerSchedules[vm.dropped_gs_idx].isSubBlock || vm.growerSchedules[vm.dropped_gs_idx].isLocation) {
          vm.growerSchedules[vm.dropped_gs_idx].acres_in_block  = vm.growerSchedules[vm.dropped_gs_idx].scheduled_acres;
        }
        vm.growerSchedules[vm.dropped_gs_idx].availableBlockAcres = 0;

        contractData.acres_scheduled                          = vm.growerSchedules[vm.dropped_gs_idx].acres_in_block;
        contractData.acres                                    = contractData.acres_scheduled;
        contractData.not_scheduled_acres                      = 0;
      }

      contractData.scheduled_block.acres_scheduled = contractData.acres_scheduled;

      // assign availableBlockAcres to related rows
      var rows = _.filter(vm.growerSchedules, {subBlockOf: vm.growerSchedules[vm.dropped_gs_idx].subBlockOf}); // no need to use gs.locationOf, it works too
      angular.forEach(rows, function(block) {
        block.availableBlockAcres = vm.growerSchedules[vm.dropped_gs_idx].availableBlockAcres;
        block.available_acres     = vm.growerSchedules[vm.dropped_gs_idx].availableBlockAcres;
      });

      vm.growerSchedules[vm.dropped_gs_idx].recalculate = true;
      blockSchedAcresChanged(vm.growerSchedules[vm.dropped_gs_idx], false, false);
      calculateBlockSchedAcresMax(vm.growerSchedules[vm.dropped_gs_idx]);
      calculateGrowingDays(vm.growerSchedules[vm.dropped_gs_idx], 'wet_date', true, true);

      if (vm.growerSchedules[vm.dropped_gs_idx].hasLocations || vm.growerSchedules[vm.dropped_gs_idx].isLocation) {
        var relatedLocations = [];
        relatedLocations = _.filter(vm.growerSchedules, function (row) {
          return row.locationOf === vm.growerSchedules[vm.dropped_gs_idx].locationOf && (row.isLocation || row.hasLocations);
        });
        angular.forEach(relatedLocations, function(location) {
          location.scheduled_wet_date      = contractData.scheduled_wet_date;
          // calculateGrowingDays(location, 'wet_date');
        });
      }

      // recalculate contract acres
      contractData.recalculate = true;
      contractAcresChanged(contractData, false);
      updateAvailableAcres(contractData);
      markAsChanged(vm.growerSchedules[vm.dropped_gs_idx]);
      // check if there are errors, to show them on popup
      if (vm.growerSchedules[vm.dropped_gs_idx].wet_date_error ||
          vm.growerSchedules[vm.dropped_gs_idx].wet_date_variety_error ||
          vm.growerSchedules[vm.dropped_gs_idx].last_harvest_date_error ||
          vm.growerSchedules[vm.dropped_gs_idx].wet_date_fiscal_year_error ||
          vm.growerSchedules[vm.dropped_gs_idx].wet_date_period_error ||
          vm.growerSchedules[vm.dropped_gs_idx].harvest_date_error ||
          vm.growerSchedules[vm.dropped_gs_idx].max_harvest_date_error ||
          vm.growerSchedules[vm.dropped_gs_idx].harvest_date_fiscal_year_error ||
          vm.growerSchedules[vm.dropped_gs_idx].harvest_date_period_error
        ) {
        showErrorsDialog(vm.growerSchedules[vm.dropped_gs_idx]);
      }
    }

    /**
     * Calculate Growing Days and Scheduled Wet Date
     * Growing days = Estimated Harvest Date - Scheduled Wet Date
     * @param  {[type]} gs              [description]
     * @param  {[type]} field           [description]
     * @param  {[type]} notGetVarieties [description]
     * @param  {[type]} fieldIdx        [description]
     * @return {[type]}
     */
    function calculateGrowingDays(gs, field, notShowMsge, notGetVarieties) {
      // validate that Estimated Harvest Date >= Scheduled Wet Date
      if (gs.scheduled_wet_date && gs.scheduled_harvest_date) {
        var aux_wet = null;
        var aux_harvest = null;
        // check if Wet Date is a Date or ISOString that came from API
        if (typeof gs.scheduled_wet_date === 'string') {
          aux_wet = new Date(gs.scheduled_wet_date);
        } else {
          aux_wet = gs.scheduled_wet_date;
        }
        // check if Harvest Date is a Date or ISOString that came from API
        if (typeof gs.scheduled_harvest_date === 'string') {
          aux_harvest = new Date(gs.scheduled_harvest_date);
        } else {
          aux_harvest = gs.scheduled_harvest_date;
        }
        if (aux_harvest < aux_wet) {
          gs.scheduled_harvest_date = gs.scheduled_wet_date;
        }
      }

      // Calculate Growing Days
      var res = GeneralFunctionsService.calculateGrowingDays(field, gs.scheduled_wet_date, gs.scheduled_harvest_date, gs.growing_days);
      if (res) {
        gs.scheduled_wet_date     = res.wet_date;
        gs.scheduled_harvest_date = res.harvest_date;
        gs.growing_days           = res.growing_days;
      }

      // if Block has locations, update on them too
      if (gs.hasLocations) {
        var rows = _.filter(vm.growerSchedules, {locationOf: gs.locationOf, isLocation: true});
        angular.forEach(rows, function(location) {
          location.scheduled_wet_date     = gs.scheduled_wet_date;
          location.sendToAPI              = true;
          // Calculate Growing Days
          calculateGrowingDays(location, 'wet_date');
          // if wet change and the child locations has related contracts, update on them too
          if (location.contract_schedule_variety_id && field === 'wet_date') {
            var contract = _.find(vm.filteredContracts, {id: location.contract_schedule_variety_id});
            if (contract) {
              contract.scheduled_wet_date = location.scheduled_wet_date;
            }
          }
        });
      }

      // if scheduled_wet_date is updated on Grower Scheduled & has a related Contract, update on it too
      if (gs && gs.contract_schedule_variety_id && field === 'wet_date') {
        var contract = _.find(vm.filteredContracts, {id: gs.contract_schedule_variety_id});
        if (contract) {
          contract.scheduled_wet_date = gs.scheduled_wet_date;
          if (contract.scheduled_block && contract.scheduled_block.hasOwnProperty('scheduled_wet_date')) {
            contract.scheduled_block.scheduled_wet_date = gs.scheduled_wet_date;
          }
        }
      }
      // check if Grower Dates are valid
      calculateGrowerDates(gs);
      // if gs.scheduled_wet_date has changed, filter seed varieties
      if (!notGetVarieties && gs.seed_id && gs.scheduled_wet_date) {
        getSeedVarieties(gs.seed_id, gs, field, notShowMsge);
      } else {
        checkDateErrors(gs, true, field, notShowMsge);
      }
    }

    /**
     * Check errors to show on datepickers from current Grower Schedule row
     * @param  {[type]} gs [grower schedule data]
     * @return {[type]}
     */
    function checkDateErrors(gs, validateCurrentRow, field, notShowMsge) {
      var message = '';
      // check errors on current row
      if (validateCurrentRow && field) {
        // check if dates are on current fiscal_year
        if (gs.scheduled_wet_date) {
          if (!isInCurrentFiscalYear(gs.scheduled_wet_date)) {
            gs.wet_date_fiscal_year_error = true;
            vm.customError = true;
          } else {
            gs.wet_date_fiscal_year_error = false;
          }
        }
        if (gs.scheduled_harvest_date) {
          if (!isInCurrentFiscalYear(gs.scheduled_harvest_date)) {
            gs.harvest_date_fiscal_year_error = true;
            vm.customError = true;
          } else {
            gs.harvest_date_fiscal_year_error = false;
          }
        }
        // check if selected wet_date is outside Variety Planting period
        if (!notShowMsge && gs.wet_date_variety_error) {
          // no need to add vm.customError = true;
          vm.toast = $mdToast.show({
            template: '<md-toast class="md-toast error">Selected Wet Date is not within Variety Planting period</md-toast>',
            position: 'top right',
            hideDelay: 0
          });
        }
        // check errors regarding Grower Dates calculation
        if (gs.last_harvest_date_error) {
          vm.customError = true;
          if (!notShowMsge && (field === 'wet_date' || (field === 'growing_days' && gs.growing_days !== null))) {
            message = 'Selected Wet Date needs to be greater than Last Harvest Date';
            if (vm.farm && vm.farm.double_crop_bed_preparation_days) {
              if (vm.farm.double_crop_bed_preparation_days === 1) {
                message = message + ' + ' + vm.farm.double_crop_bed_preparation_days + ' day';
              } else {
                message = message + ' + ' + vm.farm.double_crop_bed_preparation_days + ' days';
              }
            }
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">' + message + '</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
          }
        }
        if (gs.max_harvest_date_error) {
          vm.customError = true;
          if (!notShowMsge && (field === 'harvest_date' || (field === 'growing_days' && gs.growing_days !== null))) {
            var max = moment(gs.max_harvest_date);
            message = 'Selected Harvest Date can not be greater than ' + max.format('ddd, MMM D') + ' (next Scheduled Wet Date for the Block)';
            if (vm.farm && vm.farm.double_crop_bed_preparation_days) {
              if (vm.farm.double_crop_bed_preparation_days === 1) {
                message = message + ' - ' + vm.farm.double_crop_bed_preparation_days + ' day';
              } else {
                message = message + ' - ' + vm.farm.double_crop_bed_preparation_days + ' days';
              }
            }
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">' + message + '</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
          }
        }
        if (gs.wet_date_error) {
          vm.customError = true;
          // leased Block error
          if (gs.leased && !notShowMsge && (field === 'wet_date' || (field === 'growing_days' && gs.growing_days !== null))) {
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">The Block is not Leased during the selected Wet Date allotted tillage timeframe</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
          }
          // subleased Block error
          if (gs.subleased && !notShowMsge && (field === 'wet_date' || (field === 'growing_days' && gs.growing_days !== null))) {
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">The Block is Subleased to another Grower during the selected Wet Date allotted timeframe</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
          }
        }
        if (gs.harvest_date_error) {
          vm.customError = true;
          // leased Block error
          if (gs.leased && !notShowMsge && (field === 'harvest_date' || (field === 'growing_days' && gs.growing_days !== null))) {
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">The Block is not Leased during the allotted growing timeframe of estimated Harvest Date</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
          }
          // subleased Block error
          if (gs.subleased && !notShowMsge && (field === 'harvest_date' || (field === 'growing_days' && gs.growing_days !== null))) {
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">The Block is Subleased to another Grower during the allotted growing timeframe of estimated Harvest Date</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
          }
        }
        if (gs.wet_date_period_error && gs.harvest_date_period_error) {
          vm.customError = true;
          if (gs.leased && !notShowMsge) {
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">Selected Wet Date and Harvest Date must be on the same Lease period of the Block</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
          }
          if (gs.subleased && !notShowMsge) {
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">Allotted growing timeframe is invalid, since the Block is Subleased to another Grower during it</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
          }
        }
      }
      // if there are no errors on current row, check if there are errors on other rows, to disable Save btn
      if (!gs.wet_date_error && !gs.wet_date_period_error && !gs.harvest_date_error && !gs.harvest_date_period_error && !gs.last_harvest_date_error && !gs.max_harvest_date_error && !gs.wet_date_fiscal_year_error && !gs.harvest_date_fiscal_year_error) {
        var rowError = _.filter(vm.growerSchedules, function(row) {
          return (row.wet_date_error || row.wet_date_period_error || row.harvest_date_error || row.harvest_date_period_error || row.last_harvest_date_error || row.max_harvest_date_error || row.wet_date_fiscal_year_error || row.harvest_date_fiscal_year_error);
        });
        if (rowError.length) {
          vm.customError = true;
        } else {
          vm.customError = false;
        }
      }
    }

    // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
    /**
     * When the Block is associated to a Shipper Contract, validate that Block Wet Date is inside Variety Planting Location period
     * This is because in this case, the Variety is read only
     * @param  {[type]} gs [description]
     * @return {[type]}
     */
    // function checkVarietyDates(gs) {
    //   if (gs.hasOwnProperty('seedVarieties') && gs.seedVarieties.length && gs.scheduled_wet_date) {
    //     angular.forEach(gs.seedVarieties, function(variety) {
    //       if (variety.hasOwnProperty('seed_varieties_location') && variety.seed_varieties_location.length) {
    //         // check if selected Wet Date is valid for current variety start-end dates, regarding its location
    //         var found = false;
    //         angular.forEach(variety.seed_varieties_location, function(varLocation) {
    //           if (varLocation.location_id === gs.location_id) {
    //             var res = GeneralFunctionsService.dateIsBetween(varLocation.begin_date, varLocation.end_date, gs.scheduled_wet_date);
    //             if (res && !found) {
    //               found = true;
    //               gs.wet_date_variety_error = false;
    //             }
    //           }
    //         });
    //         if (!found) {
    //           gs.wet_date_variety_error = true;
    //         }
    //       }
    //     });
    //   }
    // }

    /**
     * Function to delete the relation between a Contract and Grower Schedule Block
     * @param  {[type]} gs [description]
     * @return {[type]}
     */
    function clearData(gs) {
      // small timeout added, to don't show both options (clear & restore) for a tiny period of time
      setTimeout(function () {
        gs.deleted_id = vm.deleted_rows_id++;
        gs.cleared    = true;
        vm.clearedData.push(_.cloneDeep(gs));
        if (gs.grower_schedule_id && gs.grower_schedule_id > 0) {
          vm.delete_grower_schedules.push(gs.grower_schedule_id);
        }
        clearInfo(gs);
      }, 100);
    }

    /**
     * Clear Row Data (Not remove, just left fields empty)
     * @param  {[type]} gs                [description]
     * @param  {[type]} forceSchedWetDate [description]
     * @return {[type]}
     */
    function clearInfo(gs, forceSchedWetDate) {
      $scope.growerSchedForm.$setDirty();
      // allow to restore old data in case that was removed and errors
      if (gs.deleted_id) {
        gs.cleared = true;
      }
      if (gs.contract_schedule_variety_id) {
        var contract = _.find(vm.filteredContracts, {id: gs.contract_schedule_variety_id});
        if (contract) {
          // clear related Block data on Contract, and allow to be dragged again
          contract.scheduled_block      = null;
          contract.draggable            = true;
          contract.acres_scheduled      = 0;
          contract.not_scheduled_acres  = contract.acres;
          contract.scheduled_acres      = 0;
          contract.scheduled_wet_date   = null;
          contract.recalculate = true;
          contractAcresChanged(contract, false);
          updateAvailableAcres(contract);
        }
      }
      // clean errors
      gs.wet_date_error               = false;
      gs.harvest_date_error           = false;
      gs.wet_date_period_error        = false;
      gs.harvest_date_period_error    = false;
      gs.wet_date_variety_error       = false;
      gs.last_harvest_date_error      = false;
      gs.max_harvest_date_error       = false;
      gs.wet_date_fiscal_year_error   = false;
      gs.harvest_date_fiscal_year_error = false;
      gs.varietyError                 = false;
      // clear Block data
      gs.contract_schedule_variety_id = null;
      gs.grower_schedule_id           = vm.aux_id--;
      gs.pca_id                       = null;
      gs.dropped                      = false;
      gs.company_id                   = null;
      gs.company_name                 = null;
      gs.seed_id                      = null;
      gs.seed_name                    = null;
      gs.variety_id                   = null;
      gs.variety_name                 = null;
      gs.seedVarieties                = [];
      gs.scheduled_acres              = null;
      if (!gs.isLocation || forceSchedWetDate) {
        gs.scheduled_wet_date         = null;
      }
      gs.scheduled_harvest_date       = null;
      gs.growing_days                 = null;
      gs.available_acres              = gs.acres_in_block;
      gs.over                         = false;
      gs.recalculate                  = true;
      blockSchedAcresChanged(gs, false, false);
      calculateBlockSchedAcresMax(gs);
      // check if there are errors on more datepickers from other rows
      checkDateErrors(gs);
      // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
      // check if there are errors on variety selector from other rows
      // checkVarietyIsRequired(gs);
    }

    /**
     * [saveAll description]
     * @return {[type]}
     */
    function saveAll() {
      getVarietiesToSave();
    }

    /**
     * Filter all the varieties that have changed, to send to API
     * @return {[type]}
     */
    function getVarietiesToSave(notShowMsge) {
      var changed = _.filter(vm.filteredContracts, {sendToAPI: true});
      if (changed.length) {
        angular.forEach(changed, function (contract) {
          // don't update these fields, since grower_schedule endpoint update it
          if (contract.hasOwnProperty('acres_scheduled')) {
            delete contract.acres_scheduled;
          }
          if (contract.hasOwnProperty('scheduled_wet_date')) {
            delete contract.scheduled_wet_date;
          }
        });
        saveShipperContracts(changed, notShowMsge);
      } else {
        // Save Grower Schedules if needed
        formatGrowerSchedulesToSave();
      }
    }

    /**
     * [saveShipperContracts description]
     * @param  {[type]} varieties   [Array of contract scheduled varieties to save]
     * @param  {[type]} showMessage [Boolean to indicate if success message not needed to be displayed]
     * @return {[type]}
     */
    function saveShipperContracts(varieties, notShowMsge) {
      if (varieties && varieties.length) {
        ContractScheduleVarietiesService.saveChilds(varieties).then(function() {
          // reset form changes, to disable 'save' button
          $scope.contractsForm.$setPristine();
          $scope.contractsForm.$setUntouched();
          angular.forEach(varieties, function (variety) {
            // as changes were saved, reset tag to update on API when 'save' btn is clicked
            variety.sendToAPI = false;
          });
          if (!notShowMsge) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">Shipper Schedules have been updated</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
          }
          // Save Grower Schedules if needed
          formatGrowerSchedulesToSave();
        },
        function(err) {
          console.error(err);
          var error;
          if(err.status && err.status !== 500) {
            error = err.data.message;
          }
          vm.toast = $mdToast.show({
            template: '<md-toast class="md-toast error">Shipper Schedules could not be updated. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 0
          });
        });
      }
    }

    /**
     * Tag a row as changed, to indicate that it needs to be send to API to be saved
     * @param  {[type]} gs [description]
     * @return {[type]}
     */
    function markAsChanged(gs) {
      // @@ REMOVE THIS LINE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
      // checkVarietyIsRequired(gs);

      // mark as changed only if all required fields are valid.
      // Scheduled Acres can be 0 or greater (https://tracker.serfe.com/view.php?id=50721#c385050)
      if (gs.scheduled_acres >= 0 && gs.company_id && gs.pca_id && gs.seed_id &&
        gs.scheduled_wet_date && gs.scheduled_harvest_date && gs.grower_schedule_sublocation && gs.grower_schedule_sublocation.id) {
        gs.sendToAPI = true;
        if (gs.isLocation) {
          var parent = _.find(vm.growerSchedules, {locationOf: gs.locationOf});
          if (parent) {
            parent.sendToAPI = true;
          }
        }
      } else {
        gs.sendToAPI = false;
      }
    }

    /**
     * [formatGrowerSchedulesToSave description]
     * @return {[type]}
     */
    function formatGrowerSchedulesToSave() {
      var growerToSend = [];
      var changed = _.filter(vm.growerSchedules, {sendToAPI: true});
      if (changed.length || vm.delete_grower_blocks.length || vm.delete_grower_schedules.length) {
        // format data to send
        angular.forEach(changed, function(row) {
          // !row.isSubBlock && !row.isLocation => Original Block with/without locations
          // row.isSubBlock && !row.isLocation => Subblock with/without locations
          if ((!row.isSubBlock && !row.isLocation) || (row.isSubBlock && !row.isLocation)) {
            var block = {};
            // check if row has id > 0, else it's a new row (auxiliar ids are < 0)
            if (row.id && row.id > 0) {
              block.id = row.id;
            }
            block.block_id                   = row.block_id;
            block.aux_grower_block_id        = row.id;
            block.area_fiscal_year_id        = vm.user.default_global_area_fiscal_year_id;
            block.acres_in_block             = row.parent_acres_in_block || row.acres_in_block;
            block.acres_available            = row.available_acres; // it's not the same field! available_acres has the correct value
            block.block_bed_count_status     = row.block_bed_count_status;
            block.subblock_number            = row.subblock_number;
            block.crop_status                = row.crop_status;
            block.parent_id                  = row.parent_id;
            block.aux_parent_id              = row.parent_id;
            block.is_parent                  = row.is_parent;
            block.grower_schedules           = [];
            var aux_grower_schedule          = {
              aux_grower_schedule_id        : row.grower_schedule_id,
              contract_schedule_variety_id  : row.contract_schedule_variety_id,
              seed_id                       : row.seed_id,
              variety_id                    : row.variety_id,
              scheduled_wet_date            : row.scheduled_wet_date,
              scheduled_harvest_date        : row.scheduled_harvest_date,
              subblock_location_id          : row.grower_schedule_sublocation.id,
              shipper_company_id            : row.company_id,
              scheduled_acres               : row.scheduled_acres,
              pca_user_id                   : row.pca_id,
              schedule_level                : vm.double_crop_num
            };
            if (row.grower_schedule_id && row.grower_schedule_id > 0) {
              aux_grower_schedule.id = row.grower_schedule_id;
            }
            if (vm.double_crop_num > 1) {
              block.double_crop = true;
            }

            block.grower_schedules.push(aux_grower_schedule);

            var block_locations = _.filter(changed, {locationOf: row.id, isLocation: true});
            if (block_locations.length) {
              angular.forEach(block_locations, function(location) {
                var locationObj = {
                  aux_grower_schedule_id        : location.grower_schedule_id,
                  contract_schedule_variety_id  : location.contract_schedule_variety_id,
                  seed_id                       : location.seed_id,
                  variety_id                    : location.variety_id,
                  scheduled_wet_date            : location.scheduled_wet_date,
                  scheduled_harvest_date        : location.scheduled_harvest_date,
                  subblock_location_id          : location.grower_schedule_sublocation.id,
                  shipper_company_id            : location.company_id,
                  scheduled_acres               : location.scheduled_acres,
                  pca_user_id                   : location.pca_id,
                  schedule_level                : vm.double_crop_num
                };
                if (location.grower_schedule_id && location.grower_schedule_id > 0) {
                  locationObj.id = location.grower_schedule_id;
                }
                if (location.grower_block_id && location.grower_block_id > 0) {
                  locationObj.grower_block_id = location.grower_block_id;
                }
                block.grower_schedules.push(locationObj);
              });
            }
            growerToSend.push(block);
          }
        });
        var fullObjToSend = {
          grower_blocks         : growerToSend,
          delete_grower_blocks  : vm.delete_grower_blocks,
          delete_grower_schedule: vm.delete_grower_schedules
        };
        saveGrowerSchedules(fullObjToSend, changed);
      } else {
        // just filters has changed, without any change
        changeDoubleCropLevel();
        getContractsAndBlocks();
      }
    }

    /**
     * [saveGrowerSchedules description]
     * @param  {[type]} schedules [description]
     * @return {[type]}
     */
    function saveGrowerSchedules(schedules/*, changed*/) {
      // console.log('data send');
      // console.log(_.cloneDeep(schedules));
      GrowerScheduleService.saveMultiple(schedules).then(function () {
        $scope.growerSchedForm.$setPristine();
        $scope.growerSchedForm.$setUntouched();
        changeDoubleCropLevel();
        getContractsAndBlocks();
        // console.log('endpoint response');
        // console.log(response);
        //
        // angular.forEach(response, function(growerBlock) {
        //   console.log(growerBlock);
        //   console.log(growerBlock.aux_grower_block_id <= 0 && growerBlock.id);
        //   var origMainBlock = null; // parent Block, if exists
        //   var origBlock     = null; // current  Block/Subblock
        //   if (growerBlock.aux_grower_block_id <= 0 && growerBlock.id) {
        //     origBlock = _.find(vm.growerSchedules, {id: growerBlock.aux_grower_block_id});
        //     console.log('origBlock');
        //     console.log(origBlock);
        //     if (origBlock) {
        //       origBlock.id                  = growerBlock.id;
        //       origBlock.grower_block_id     = growerBlock.id;
        //       origBlock.sendToAPI           = false;
        //     }
        //     // check if it has parent, and if yes, check if parent was already created
        //     if (growerBlock.aux_parent_id <= 0 && growerBlock.parent_id) { // parent and child are new
        //       // update main block with subblock new ID
        //       origMainBlock = _.find(vm.growerSchedules, {id: growerBlock.aux_parent_id});
        //       if (origMainBlock) {
        //         origMainBlock.id              = growerBlock.parent_id;
        //         origMainBlock.grower_block_id = growerBlock.parent_id;
        //         origMainBlock.subBlockOf      = growerBlock.parent_id;
        //       }
        //       // update current block data with new parent data
        //       origBlock.aux_parent_id         = growerBlock.parent_id;
        //     } else if (growerBlock.parent_id && growerBlock.aux_parent_id === growerBlock.parent_id) { // parent already exist
        //       // parent already exists, only update Block data
        //       origBlock.subBlockOf            = growerBlock.parent_id;
        //     }
        //
        //     // check if grower schedules were created
        //     angular.forEach(growerBlock.grower_schedules, function(blockGS) {
        //       var origGS = null;
        //       if (blockGS.aux_grower_schedule_id <= 0 && blockGS.id) {
        //         origGS = _.find(vm.growerSchedules, {grower_schedule_id: blockGS.aux_grower_schedule_id});
        //         if (origGS) {
        //           origGS.grower_schedule_id     = blockGS.id;
        //           origGS.sendToAPI              = false;
        //           if (origGS.hasSubBlock) {
        //             origGS.parent_id            = growerBlock.parent_id;
        //             origGS.subBlockOf           = growerBlock.parent_id;
        //           }
        //           origGS.locationOf             = growerBlock.id;
        //           origGS.grower_block_id        = growerBlock.id;
        //         }
        //       }
        //     });
        //   }
        // });
        //
        // console.log('vm.growerSchedules');
        // console.log(_.cloneDeep(vm.growerSchedules));
        // console.log('changed');
        // console.log(_.cloneDeep(originalSchedules));
        $mdToast.show({
          template: '<md-toast class="md-toast success">Grower Schedules have been updated</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function(err) {
        console.error(err);
        var error;
        if(err.status && err.status !== 500) {
          error = err.data.message;
        }
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">Grower Schedules could not be updated. ' + ((error !== undefined)? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
      });
    }

    /**
     * Set Variety selector as required and set global Variety error if needed, to disable Save btn
     * (Solves issue with Variety selector, that was removing the last variety_id (last scheduled row) from the table
     * when a Subblock/Location was added)
     * @param {[type]} gs         [grower schedule row]
     * @param {[type]} forceCheck [force to check errors on other rows]
     */
    // @@ REMOVE WHEN ALL FUNCTIONALITY IS CONFIRMED BY GREG
    // function checkVarietyIsRequired(gs, forceCheck) {
    //   if (gs.pca_id || gs.company_id || gs.scheduled_wet_date ||
    //   gs.seed_id || gs.scheduled_acres > 0 || gs.growing_days || gs.scheduled_harvest_date) {
    //     if (!gs.variety_id) {
    //       gs.varietyError   = true;
    //       vm.varietiesError = true;
    //     } else {
    //       gs.varietyError   = false;
    //     }
    //   } else {
    //     gs.varietyError     = false;
    //   }
    //
    //   // if there is no Variety error on current row, check if there are errors on other rows, to disable Save btn
    //   if (forceCheck || !gs.varietyError) {
    //     var rowError = _.filter(vm.growerSchedules, {varietyError: true});
    //     if (rowError.length) {
    //       vm.varietiesError = true;
    //     } else {
    //       vm.varietiesError = false;
    //     }
    //   }
    // }

    /**
     * Check if there are form errors, in order to save data and change Double Crop Level after saving all data
     * @param  {[type]} switchChanged       [true = the switch has value changed , false = level selector has changed]
     * @param  {[type]} growerFormInvalid   [true = growerFrom has errors , false = growerFrom OK]
     * @param  {[type]} contractFormInvalid [true = contractFrom has errors , false = contractFrom OK]
     */
    function doubleCropLevelChanged(switchChanged, growerFormInvalid, contractFormInvalid) {
      // check if the forms have errors, to call saveAll() function without any errors
      if (growerFormInvalid || contractFormInvalid || vm.customError || vm.varietiesError) {
        vm.toast = $mdToast.show({
          template: '<md-toast class="md-toast error">There are required fields empty or with errors. Please, check them</md-toast>',
          position: 'top right',
          hideDelay: 0
        });
        if (switchChanged) {
          vm.doubleCropIsActive  = !vm.doubleCropIsActive;
        }
        vm.aux_double_crop_num = vm.double_crop_num;
        return;
      } else {
        vm.auxSwitchChanged    = switchChanged;
        saveAll();
      }
    }

    /**
     * Change Blocks view, to show the Blocks that has been scheduled more than once or common view
     * vm.double_crop_num = 1 ==> initial Blocks listing
     * vm.double_crop_num Cannot be changed before the saveAll(), this is why I need to make this function
     */
    function changeDoubleCropLevel() {
      if (vm.auxSwitchChanged) {
        if (!vm.doubleCropIsActive) {
          vm.aux_double_crop_num = 1;
        } else {
          vm.aux_double_crop_num = 2;
        }
      }
      vm.double_crop_num = vm.aux_double_crop_num;
      vm.auxSwitchChanged = false;
    }

    /**
     * Go to ranches page
     * @return {[type]} [description]
     */
    function goToRanches() {
      var data = {};
      var location = _.find(vm.allLocations, {id: vm.location});
      if (location && location.id && location.name) {
        data = {
          location_id: location.id,
          location_name: location.name,
        };
      }
      RanchService.saveFilterData(data);
      $location.url('/ranches');
    }

    /**
     * Go to Blocks page
     * @return {[type]} [description]
     */
    function goToBlocks() {
      var data = {};
      var location = _.find(vm.allLocations, {id: vm.location});
      if (location && location.id && location.name) {
        data.location_id   = location.id;
        data.location_name = location.name;
      }
      var ranch    = _.find(vm.allRanches, {id: vm.ranch});
      if (ranch && ranch.id && ranch.name) {
        data.ranch_id   = ranch.id;
        data.ranch_name = ranch.name;
      }
      BlockService.saveFilterData(data);
      $location.url('/blocks');
    }

    /**
     * Redirect to given section
     * @return {[type]} [description]
     */
    function goTo(section) {
      if (section === '/seed') {
        GrowerScheduleService.saveData({'fromGrower': true});
      }
      $location.url(section);
    }

    /**
     * Close Search div
     * @return {[type]}
     */
    function closeSearch() {
      vm.showSearch  = false;
      if (vm.search) {
        vm.search    = null;
        vm.auxsearch = null;
        getContractsAndBlocks();
      }
    }

    /**
     * Hide toast
     */
    function hideToast() {
      if (!_.isEmpty(vm.toast)) {
        vm.toast = {};
        $mdToast.hide();
      }
    }

    /**
     * [showErrorsDialog description]
     * @param  {[type]} ev   [description]
     * @param  {[type]} crop [description]
     * @return {[type]}
     */
    function showErrorsDialog(gs) {
      var contract = _.find(vm.filteredContracts, {id: gs.contract_schedule_variety_id});
      gs.forceHighligth = true;
      if (contract) {
        contract.forceHighligth = true;
      }
      $mdDialog.show({
        controller         : 'ShowErrorsDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/pages/grower-schedule/dialogs/show-errors/show-errors-dialog.html',
        parent             : angular.element($document.body),
        clickOutsideToClose: false,
        locals             : {
          dialogData: {
            gs      : gs,
            farm    : vm.farm
          }
        }
      })
      .finally(function() {
        gs.forceHighligth = false;
        if (contract) {
          contract.forceHighligth = false;
        }
        clearInfo(gs);
      });
    }

    /**
     * Restore data from a row that has been Cleared
     * @param  {[type]} gs [description]
     * @return {[type]}
     */
    function restoreClearedRow(gs) {
      $scope.growerSchedForm.$setDirty();
      var clearedRow = _.find(vm.clearedData, {'deleted_id': gs.deleted_id});
      if (clearedRow) {
        // if Block has a related Contract, validate that it has not been assigned to another Block
        if (clearedRow.contract_schedule_variety_id) {
          var block = _.find(vm.growerSchedules, {'contract_schedule_variety_id': clearedRow.contract_schedule_variety_id});
          if (block) {
            var message = 'The Shipper Contract has been scheduled on another Block';
            if (block.block_name) {
              message = 'The Shipper Contract has been scheduled on Block ' + block.block_name;
            }
            vm.toast = $mdToast.show({
              template: '<md-toast class="md-toast error">' + message + '</md-toast>',
              position: 'top right',
              hideDelay: 0
            });
            return;
          }
        }
        // restore cleared data on original row
        _.assign(gs, clearedRow);
        // remove aux fields to restore
        gs.cleared = false;
        _.remove(vm.clearedData, {'deleted_id': gs.deleted_id});
        gs.deleted_id = null;
        // remove id from delete_grower_schedules array, in order to don't delete row from database
        if (gs.grower_schedule_id && gs.grower_schedule_id > 0) {
          var delIdx = _.indexOf(vm.delete_grower_schedules, gs.grower_schedule_id);
          if (delIdx > -1) {
            vm.delete_grower_schedules.splice(delIdx, 1);
          }
        }
        // restore association with contract if needed
        if (gs.contract_schedule_variety_id) {
          var gsIdx    = _.findIndex(vm.growerSchedules, {'id': gs.id});
          var contract = _.find(vm.filteredContracts, {'id': gs.contract_schedule_variety_id});
          if (contract && gsIdx > -1) {
            vm.dropped_gs       = gs;
            vm.dropped_gs_idx   = gsIdx;
            associateContractWithBlock(contract);
          }
        }
      }
    }

    /**
     * Clear all rows from current Block
     * Shown only when Block has Locations
     * @param  {[type]} gs [description]
     * @return {[type]}
     */
    function clearAllRows(gs) {
      var rows = _.filter(vm.growerSchedules, {'locationOf': gs.id});
      angular.forEach(rows, function(row) {
        if (row.grower_schedule_id && row.grower_schedule_id > 0) {
          vm.delete_grower_schedules.push(row.grower_schedule_id);
        }
        clearInfo(row, true);
      });
    }

  }
})();

(function () {
  'use strict';

  angular
  .module('app.pages.contracts')
  .controller('ContractsCtrl', ContractsCtrl);

  /** @ngInject */
  function ContractsCtrl(
    $q,
    $scope,
    $mdToast,
    $mdSidenav,
    $mdDialog,
    $location,
    $document,
    $translate,
    $state,
    ContractService,
    CompanyService,
    msUtils,
    AclService,
    api,
    _
  ) {
    var vm = this;
    vm.listType = 'all';
    vm.filterIds = [];
    // Data
    vm.starredContracts = [];
    vm.allContracts = [];
    vm.contracts = [];
    vm.fiscal_years = [];
    vm.selected_fiscal_year = '';
    vm.offset = 20;
    vm.maxListLength = 20;
    vm.shippers = [];
    vm.areaFiscalYear_id = null;
    //layout
    vm.selectedContracts = [];
    $scope.event = window.event;

    // Methods
    vm.deleteContract = deleteContract;
    vm.filterChange = filterChange;
    vm.addContractDialog = addContractDialog;
    vm.editContract = editContract;
    vm.addContract = addContract;
    vm.patchStarred = patchStarred;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.exists = msUtils.exists;
    vm.loadMore = loadMore;
    vm.toggleSidenav = toggleSidenav;

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      $scope.loadingData = true;
      api.contracts.get({}, function(ContractsData) {
        vm.contracts = ContractsData.contracts;
        $scope.filteredContracts = vm.contracts;
        angular.forEach(vm.contracts, function (contract) {
          // Add shipper on filter array
          if (contract.company_id && contract.shipper) {
            var idx = _.find(vm.shippers, {'id': contract.company_id});
            if (!idx) {
              vm.shippers.push({id: contract.company_id, name:contract.shipper});
            }
          }
          vm.allContracts.push(contract.id);
          if (contract.starred === true) {
            vm.starredContracts.push(contract.id);
          }
        });
        vm.shippers = _.orderBy(vm.shippers, ['name']);
        $scope.loadingData = false;
      },
      function(err) {
        console.error(err);
      });

      var user = sessionStorage.getItem('user');
      vm.user = JSON.parse(user);
      vm.areaFiscalYear_id=vm.user.default_global_area_fiscal_year_id;
      var data = {
        limit: vm.maxListLength,
        offset: 0,
        area_fiscal_year: vm.areaFiscalYear_id,
        search_by: 'area_fiscal_year_id',
        search: vm.areaFiscalYear_id,
        order_by: 'id'
      };
      ContractService.getContractsWithOffset(data).then(function (contractsData) {
        vm.shownContracts = contractsData.contracts;
        vm.shownContracts.forEach(function (contract) {
          vm.filterIds.push(contract.id);
          if (vm.user) {
            ContractService.get(contract.id).then(function(response) {
              contract.acres = response.contract.acres;
            });
          }
        });
      });
    }

    /**
     * [loadMore description]
     * @return {[type]} [description]
     */
    function loadMore() {
      if(vm.shownContracts.length === vm.contracts.length) {
        return;
      }
      else{
        var data = {
          limit: vm.maxListLength,
          offset: vm.offset,
          area_fiscal_year: vm.areaFiscalYear_id,
          search_by: 'area_fiscal_year_id',
          search: vm.areaFiscalYear_id,
          order_by: 'id'
        };
        ContractService.getContractsWithOffset(data).then(function (contractsData) {
          if (contractsData.contracts.length > 0) {
            vm.shownContracts = vm.shownContracts.concat(contractsData.contracts);
            contractsData.contracts.forEach(function (contract) {
              vm.filterIds.push(contract.id);
              if (vm.user) {
                ContractService.get(contract.id).then(function(response) {
                  contract.acres = response.contract.acres;
                });
              }
            });
          }
          else
            return;
        });
        vm.offset += vm.maxListLength;
      }
    }

    /**
     * Change Contracts List Filter
     * @param type
     */
    function filterChange(type, data) {
      vm.selectedContracts = [];
      if (type === 'all') {
        vm.filterIds = vm.allContracts;
        vm.listType = type;
      } else if (type === 'starred') {
        vm.filterIds = vm.starredContracts;
        vm.listType = type;
      } else if (data && angular.isObject(data)) {
        if (type === 'shipper') {
          // search by shipper
          var arrayIds = [];
          vm.listType = {name: data.name};
          vm.contracts.forEach(function (contract) {
            if (contract.company_id && contract.company_id === data.id) {
              arrayIds.push(contract.id);
            }
          });
        }
        vm.filterIds = arrayIds;
      }
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }


    /**
     * Function to handle the behavior of add/edit an user.
     */
    function addContractDialog(ev) {
      $mdDialog.show({
        controller: 'ContractDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/pages/contracts/dialogs/contract/contract-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            shippers: vm.shippers,
            contracts: vm.contracts,
            shownContracts: vm.shownContracts,
            starredContracts: vm.starredContracts,
            filterIds: vm.filterIds,
            dialogType: 'add'
          }
        }
      });
    }

    /**
     * [addContract description]
     * @param  {[type]} ev    [description]
     * @param  {[type]}  [description]
     * @return {[type]}       [description]
     */
    function addContract() {
      $location.url('/contracts/add');
    }

    /**
     * [editContract description]
     * @param  {[type]} ev    [description]
     * @param  {[type]} contract [description]
     * @return {[type]}       [description]
     */
    function editContract(ev, contract) {
      $location.url('/contracts/edit/' + contract.id + '/' + 0);
    }



    /**
     * [deleteContract description]
     * @param  {[type]} id [description]
     * @return {[type]}
     */
    function deleteContract(ev, contract) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('CONTRACTS.ARE_YOU_SURE_TO_DELETE_BULK'))
      .htmlContent('The contract <b>' + contract.number + '</b>' + ' will be deleted.')
      .ariaLabel('delete contract')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        ContractService.delete(contract.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The contract ' + contract.number + ' were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.contracts.splice(vm.contracts.indexOf(contract), 1);
          vm.shownContracts.splice(vm.shownContracts.indexOf(contract), 1);
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The contract ' + contract.number + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Function to patch starred contract.
     *
     * @return {[type]} [description]
     */
    function patchStarred(contract) {
      event.stopPropagation();
      var starred = false;
      if (vm.starredContracts.indexOf(contract.id) >= 0) {
        starred = true;
      }
      ContractService.patch(contract.id, {starred: starred.toString()}).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The contract ' + contract.number + ((starred === true) ? ' has been starred.' : ' has been unstarred.') + ' </md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      },
      function () {
        $mdToast.show({
          template: '<md-toast class="md-toast error">The contract ' + contract.number + ' could not be starred.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
    }
  }
})();

(function ()
{
  'use strict';

  angular
  .module('app.growing.pesticide-manager', [])
  .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {

    $stateProvider.state('app.growing_pesticide_manager', {
      url    : '/pesticide-manager',
      views  : {
        'content@app': {
          templateUrl: 'app/main/growing/pesticide-manager/pesticide-manager.html',
          controller : 'MasterScheduleCtrl as vm'
        }
      },
      bodyClass: 'pesticide-manager',
      resolve: {
        acl: function($q, AclService) {
          if(!AclService.can('pesticide_manager')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    // $translatePartialLoaderProvider.addPart('app/main/growing/pesticide-manager');

    // // Navigation
    msNavigationServiceProvider.saveItem('growing.pesticide-manager', {
      title : 'Pesticide Manager',
      icon  : 'icon-timetable',
      state : 'app.growing_pesticide_manager',
      weight: 8
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.growing.pesticide-manager')
  .controller('PesticideManagerCtrl', PesticideManagerCtrl);

  /** @ngInject */
  function PesticideManagerCtrl() {}
})();

(function ()
{
  'use strict';

  angular
  .module('app.growing.messaging', [])
  .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {

    $stateProvider.state('app.growing_messaging', {
      url    : '/messaging',
      views  : {
        'content@app': {
          templateUrl: 'app/main/growing/messaging/messaging.html',
          controller : 'MessagingCtrl as vm'
        }
      },
      bodyClass: 'messaging',
      resolve: {
        acl: function($q, AclService) {
          if(!AclService.can('messaging')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    // $translatePartialLoaderProvider.addPart('app/main/growing/messaging');

    // // Navigation
    msNavigationServiceProvider.saveItem('growing.messaging', {
      title : 'Messaging',
      icon  : 'icon-message-alert',
      state : 'app.growing_messaging',
      weight: 9
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.growing.messaging')
  .controller('MessagingCtrl', MessagingCtrl);

  /** @ngInject */
  function MessagingCtrl() {}
})();

(function ()
{
  'use strict';

  angular
  .module('app.growing.master-schedule', [])
  .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {

    $stateProvider.state('app.growing_master_schedule', {
      url    : '/master-schedule',
      views  : {
        'content@app': {
          templateUrl: 'app/main/growing/master-schedule/master-schedule.html',
          controller : 'MasterScheduleCtrl as vm'
        }
      },
      bodyClass: 'master-schedule',
      resolve: {
        acl: function($q, AclService) {
          if(!AclService.can('master_schedule')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    // $translatePartialLoaderProvider.addPart('app/main/growing/master-schedule');

    // // Navigation
    msNavigationServiceProvider.saveItem('growing.master-schedule', {
      title : 'Master Schedule',
      icon  : 'icon-timetable',
      state : 'app.growing_master_schedule',
      weight: 5
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.growing.master-schedule')
  .controller('MasterScheduleCtrl', MasterScheduleCtrl);

  /** @ngInject */
  function MasterScheduleCtrl() {}
})();

(function ()
{
  'use strict';

  angular
  .module('app.growing.harvest-manager', [])
  .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {

    $stateProvider.state('app.growing_harvest_manager', {
      url    : '/harvest-manager',
      views  : {
        'content@app': {
          templateUrl: 'app/main/growing/harvest-manager/harvest-manager.html',
          controller : 'MasterScheduleCtrl as vm'
        }
      },
      bodyClass: 'harvest-manager',
      resolve: {
        acl: function($q, AclService) {
          if(!AclService.can('harvest_manager')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    // $translatePartialLoaderProvider.addPart('app/main/growing/harvest-manager');

    // // Navigation
    msNavigationServiceProvider.saveItem('growing.harvest-manager', {
      title : 'Harvest Manager',
      icon  : 'icon-timetable',
      state : 'app.growing_harvest_manager',
      weight: 9
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.growing.harvest-manager')
  .controller('HarvestManagerCtrl', HarvestManagerCtrl);

  /** @ngInject */
  function HarvestManagerCtrl() {}
})();

(function ()
{
  'use strict';

  angular
  .module('app.growing.farm-manager-approvals', [])
  .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {

    $stateProvider.state('app.growing_farm-manager-approvals', {
      url    : '/farm-manager-approvals',
      views  : {
        'content@app': {
          templateUrl: 'app/main/growing/farm-manager-approvals/farm-manager-approvals.html',
          controller : 'FarmManagerApprovalsCtrl as vm'
        }
      },
      bodyClass: 'farm-manager-approvals',
      resolve: {
        acl: function($q, AclService) {
          if(!AclService.can('farm_manager_approvals')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    // $translatePartialLoaderProvider.addPart('app/main/growing/farm-manager-approvals');

    // Navigation
    msNavigationServiceProvider.saveItem('growing.farm-manager-approvals', {
      title : 'Farm Manager Approvals',
      icon  : 'icon-account-check',
      state : 'app.growing_farm-manager-approvals',
      weight: 10
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.growing.farm-manager-approvals')
  .controller('FarmManagerApprovalsCtrl', FarmManagerApprovalsCtrl);

  /** @ngInject */
  function FarmManagerApprovalsCtrl() {}
})();

(function ()
{
  'use strict';

  angular
  .module('app.growing.block-activity', [])
  .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
  {

    $stateProvider.state('app.growing_block_activity', {
      url    : '/block-activity',
      views  : {
        'content@app': {
          templateUrl: 'app/main/growing/block-activity/block-activity.html',
          controller : 'BlockActivityCtrl as vm'
        }
      },
      bodyClass: 'block-activity',
      resolve: {
        acl: function($q, AclService) {
          if(!AclService.can('block_activity')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    // $translatePartialLoaderProvider.addPart('app/main/growing/block-activity');

    // // Navigation
    msNavigationServiceProvider.saveItem('growing.block-activity', {
      title : 'Block Activity',
      icon  : 'icon-arrange-bring-to-front',
      state : 'app.growing_block_activity',
      weight: 7
    });
  }

})();

(function () {
  'use strict';

  angular.module('app.growing.block-activity')
  .controller('BlockActivityCtrl', BlockActivityCtrl);

  /** @ngInject */
  function BlockActivityCtrl() {}
})();

var app = angular.module('ms-resize', []);

app.directive('resize', function ($window) {
  return { 
    restrict: 'A',
    link: function (scope) {
      var w = angular.element($window);
      scope.getWindowDimensions = function () {
        return {
          'h': w.height(),
        };
      };
      scope.$watch(scope.getWindowDimensions, function (newValue) {
        scope.windowHeight = newValue.h;
        scope.setSize = function (dif) {
          return {
            'max-height': (newValue.h - dif) + 'px',
          };
        };
        scope.setSizeMedium = function (dif) {
          return {
            'height': (newValue.h - dif) + 'px',
          };
        };

      }, true);

      w.bind('resize', function () {
        scope.$apply();
      });
    },
  };
});
var app = angular.module('ms-pw-check', []);
var $ = window.$;

/**
 * Directive used to check passowrds match
 * @return {[type]} [description]
 */
app.directive('pwCheck', [function () {
  return {
    require: 'ngModel',
    link: function (scope, elem, attrs, ctrl) {
      var firstPassword = '#' + attrs.pwCheck;
      elem.add(firstPassword).on('keyup', function () {
        scope.$apply(function () {
          var v = elem.val() === $(firstPassword).val();
          ctrl.$setValidity('pwmatch', v);
        });
      });
    }
  };
}]);

(function () {
  'use strict';

  angular
  .module('app.directives', [
    'flow',
    'app.directives.msPaymentSchedule.dialogs',
    'app.directives.msLeaseBlock.dialogs',
    'app.directives.fileUpload.dialogs',
    'ngFileSaver',
    'dynamicNumber',
    'ms-resize',
    'ms-letters-only',
    'ms-datepicker',
    'ms-draggable',
    'ms-http-img-src',
    'xeditable'])
  .config(config)
  .directive('uniqueValue', function () {
    return {
      require: 'ngModel',
      scope: {
        getValues: '&uniqueValue'
      },
      restrict: 'A',
      link: function (scope, element, attrs, ngModelCtrl) {
        scope.isExistingValue = function (values, value) {
          return values.indexOf(value) !== -1;
        };
        ngModelCtrl.$validators.uniqueValue = function (viewValue) {
          if (!ngModelCtrl.$isEmpty(viewValue)) {
            return !scope.isExistingValue(scope.getValues(), viewValue);
          }
          return true;
        };
      }

    };
  });
  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    // Translation
    $translatePartialLoaderProvider.addPart('app/main/directives/ms-file-upload');
    $translatePartialLoaderProvider.addPart('app/main/directives/ms-payment-schedule');
    $translatePartialLoaderProvider.addPart('app/main/directives/ms-lease-information');
    $translatePartialLoaderProvider.addPart('app/main/directives/ms-lease-block');
    $translatePartialLoaderProvider.addPart('app/main/directives/ms-custom-stepper');
    $translatePartialLoaderProvider.addPart('app/main/directives/ms-lease-list-blocks');

  }

})();

(function () {
  'use strict';

  angular
    .module('app.directives')
    .controller('MsLoaderController', MsLoaderController)
    .directive('msLoader', msLoader);

  /** @ngInject */
  function MsLoaderController(
    $scope
  ) {
    var vm = this;
    init();
    /**
     * Init
     */
    function init() { 
      if ($scope.diameter) {
        vm.diameter = $scope.diameter;
      } else {
        vm.diameter = 50;
      }
    }
  }
  /**
   * [msPaymentSchedule description]
   * @return {[type]} [description]
   */
  function msLoader() {
    return {
      restrict    : 'E',
      scope      : {
        diameter:   '='
      },
      controller : 'MsLoaderController as vm',
      templateUrl: 'app/main/directives/ms-loader/ms-loader.html'
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('app.directives')
    .controller('MsPaymentScheduleCtrl', MsPaymentScheduleCtrl)
    .directive('msPaymentSchedule', msPaymentSchedule)
    .run(function(editableOptions) {
      editableOptions.theme = 'bs3';
    });

  /** @ngInject */
  function MsPaymentScheduleCtrl(
    $scope,
    $mdToast,
    $mdDialog,
    $document,
    $filter,
    $translate,
    msUtils,
    $rootScope
    ) {
    var vm           = this;
    vm.payments      = [];
    vm.entity        = $scope.entity;
    vm.service       = $scope.service;
    vm.related_id    = $scope.relatedId;
    vm.newLease      = $scope.newLease;
    vm.paymentsForm      = {};
    vm.paymentIdsUpdated = [];
    vm.paymentsUpdated   = [];

    // Methods
    vm.addPaymentDialog             = addPaymentDialog;
    vm.deletePaymentSchedule        = deletePaymentSchedule;
    vm.deletePaymentScheduleConfirm = deletePaymentScheduleConfirm;
    vm.patchPayment                 = patchPayment;
    vm.broadcast                    = broadcast;

    $scope.customDateFormat = {
      formatDate: function(date) {
        var m = moment(date);
        return m.isValid() ? m.format('ll') : '';
      }
    };


    init();
    /**
     * [init description]
     * @return {[type]}
     */
    function init() {
      $scope.loadingData = true;
      vm.service.getAll({
        'order_by'  : (vm.entity === 'contract') ? 'due_date' : 'payment_due_date',
        'search_by' : [vm.entity + '_id'],
        'search'    : vm.related_id
      }).then(function (payments) {
        angular.forEach(payments[vm.entity + '_payment_schedules'], function (payment) {
          payment.changed = false;
          (payment.amount) ? payment.amount = msUtils.parseMoneyAsNumber(payment.amount) : null;
          (payment.amount_paid) ? payment.amount_paid = msUtils.parseMoneyAsNumber(payment.amount_paid) : null;
          (payment.contract_incentive_amount) ? payment.contract_incentive_amount = msUtils.parseMoneyAsNumber(payment.contract_incentive_amount) : null;
        });
        angular.forEach(payments[vm.entity + '_payment_schedules'], function (payment) {
          if(payment.amount_paid === 0) {
            payment.amount_paid = null;
          }
        });
        vm.payments = payments[vm.entity + '_payment_schedules'];
        insertPaymentPos();
        $scope.loadingData = false;
      },
      function(err) { //reject
        var error;
        if(err.status && err.status !== 500) {
          error = err.data.message;
        }
        console.error('Payments could not be loaded. ' + ((error !== undefined) ? error : ''));
      });
    }

    /**
     * Insert pos# field
     * @return {[type]}
     */
    function insertPaymentPos() {
      for (var i = 0; i < vm.payments.length; i++) {
        vm.payments[i].pos = i + 1;
      }
    }

    /**
     * Function to handle the behavior of add payment.
     */
    function addPaymentDialog(ev, payment) {
      // format Incentive Amount (money) as number
      var aux_payment = {};
      if(payment) {
        aux_payment = angular.copy(payment);
      }
      $mdDialog.show({
        controller         : 'PaymentScheduleDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/directives/ms-payment-schedule/templates/dialogs/payment-schedule-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            related_id     : vm.related_id,
            service        : vm.service,
            entity         : vm.entity,
            payments       : vm.payments,
            payment        : (payment) ? aux_payment : ''
          }
        }
      });
    }


    /**
     * Delete payment schedule
     */
    function deletePaymentScheduleConfirm(ev,payment) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('PAYMENT_SCHEDULE.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('Payment <b>#' + payment.pos  + ' </b>' + ' will be deleted.')
      .ariaLabel('delete payment')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deletePaymentSchedule(payment);
      }, function () {

      });
    }

    /**
     * [deletePaymentSchedule description]
     * @param  {[type]} payment [description]
     * @return {[type]}         [description]
     */
    function deletePaymentSchedule(payment) {
      if (vm.service.hasOwnProperty('delete')) {
        vm.service.delete(payment.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The scheduled payment #'+ payment.pos + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.payments.splice(vm.payments.indexOf(payment), 1);
          insertPaymentPos();
          closeDialog();
        },
        function(err) { //reject
          var error;
          if(err.status && err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">The scheduled payment #'+ payment.pos + ' could not be deleted. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000
          });
        });
      } else {
        console.error('"delete" function is not defined on service');
      }
    }

    /**
     * Update payment_made field
     * @param  {[type]} payment [description]
     * @return {[type]}         [description]
     */
    function patchPayment(payment, data) {
      if (!payment.error && payment.changed) {
        if(data && data.payment_made === true) {
          payment.amount_paid = payment.amount;
          payment.date_paid = payment.payment_due_date;
          data.amount_paid = payment.amount_paid;
          data.date_paid = payment.payment_due_date;
        }

        if (vm.service.hasOwnProperty('patch')) {
          vm.service.patch(payment.id, data).then(
            function (response) {
              var field = Object.keys(data)[0];
              if (field && response[vm.entity + '_payment_schedule'].hasOwnProperty(field)) {
                payment[field] = response[vm.entity + '_payment_schedule'][field];
              }
              payment.changed = false;
              $mdToast.show({
                template: '<md-toast class="md-toast success">The scheduled payment #' + payment.pos + ' has been updated.</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });
            },
            function () {
              var message = 'The scheduled payment #' + payment.pos + ' could not be updated. ';
              $mdToast.show({
                template: '<md-toast class="md-toast error">' + message + '</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });
            }
          );
        } else {
          console.error('"patch" function is not defined on service');
        }
      }
    }


      /**
    * Close dialog
    */
    function closeDialog() {
      $mdDialog.hide();
    }

  /**
   * [broadcast description]
   * @return {[type]} [description]
   */
    function broadcast(payment, date_paid) {
      if(date_paid === 'set_date_paid') {
        payment.payment_made = true;
        payment.amount_paid = payment.amount;
      }
      if(vm.paymentIdsUpdated.indexOf(payment.id)<0) {
        vm.paymentIdsUpdated.push(payment.id);
        vm.paymentsUpdated.push(payment);
      }
      $rootScope.$broadcast('paymentsForm', vm.paymentsForm, vm.paymentsUpdated);
    }


  }

  /**
   * [msPaymentSchedule description]
   * @return {[type]} [description]
   */
  function msPaymentSchedule() {
    return {
      restrict    : 'E',
      scope       : {
        relatedId : '=',
        entity    : '=',
        service   : '=',
        newLease  : '='
      },
      bindToController: {
        vm: '='
      },
      controller : 'MsPaymentScheduleCtrl as vm',
      templateUrl: 'app/main/directives/ms-payment-schedule/templates/ms-payment-schedule.html'
    };
  }

})();

var app = angular.module('ms-load-image', []);

app.directive('msload', ['$parse', function ($parse) {
  return {
    restrict: 'A',
    link: function (scope, elem, attrs) {
      var fn = $parse(attrs.msload);
      elem.on('load', function (event) {
        scope.$apply(function() {
          fn(scope, { $event: event });
        });
      });
    }
  };
}]);
var app = angular.module('ms-limit-to', []);

/**
 * Directive used to limit characters
 * @return {[type]} [description]
 */
app.directive('limitTo', [function() {
  //Directive for only limit to keypress in input original_growing_days
  return {
    restrict: 'A',
    link: function(scope, elem, attrs) {
      var limit = parseInt(attrs.limitTo);
      angular.element(elem).on('keypress', function(e) {
        if (this.value.length == limit) e.preventDefault();
      });
    }
  };
}]);


var app = angular.module('ms-letters-only', []);
/**
 * Directive to allow only letters and spaces on inputs
 * @return {[type]} [description]
 */
app.directive('lettersOnly', function () {
  return {
    require: 'ngModel',
    link: function (scope, element, attr, ngModelCtrl) {
      /**
       * [fromUser description]
       * @param  {[type]} text [description]
       * @return {[type]}      [description]
       */
      function fromUser(text) {
        if (text) {
          var transformedInput = text.replace(/[^A-Za-z ]/g, '');
          if (transformedInput !== text) {
            ngModelCtrl.$setViewValue(transformedInput);
            ngModelCtrl.$render();
          }
          return transformedInput;
        }
        return undefined;
      }
      ngModelCtrl.$parsers.push(fromUser);
    }
  };
});

(function () {
  'use strict';

  angular
    .module('app.directives')
    .controller('MsLeaseListBlocksCtrl', MsLeaseListBlocksCtrl)
    .directive('msLeaseListBlocks', msLeaseListBlocks);

  /** @ngInject */
  function MsLeaseListBlocksCtrl(
    $scope,
    $location,
    $mdToast,
    $mdDialog

    ) {
    var vm = this;

    // Data    
    vm.lease          = $scope.lease;
    vm.title          = 'Blocks of lease ' + vm.lease.lease_number;

    if(vm.lease.lease_id) {
      vm.title                = 'Blocks of sublease ' + vm.lease.lease_number;
    }

    // Methods
    vm.goToBlock          = goToBlock;
    vm.closeDialog        = closeDialog;

    //////////


    /**
     * Go to block
     * @param  {[type]} ev    [description]
     * @param  {[type]} block [description]
     * @return {[type]}       [description]
     */
    function goToBlock(ev, block) {
      $location.url('/blocks/edit/' + block.id);
      closeDialog();
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }
  }

      /**
     * [leasePaymentSchedule description]
     * @return {[type]} [description]
     */
  function msLeaseListBlocks() {
    return {
      restrict   : 'E',
      scope      : {
        lease: '=' },
      bindToController: {
        vm: '='
      },
      controller : 'MsLeaseListBlocksCtrl as vm',
      templateUrl: 'app/main/directives/ms-lease-list-blocks/templates/ms-lease-list-blocks.html'
    };
  }

})();
(function () {
  'use strict';

  angular
    .module('app.directives')
    .controller('MsLeaseInformationController', MsLeaseInformationController)
    .directive('msLeaseInformation', msLeaseInformation);

  /** @ngInject */
  function MsLeaseInformationController(
    $scope,
    $location,
    $filter,
    LeaseService,
    CompanyService,
    $rootScope
  ) {
    var vm                  = this;
    vm.paymentTerms         = [];
    vm.lessee_company       = [];
    vm.lease                = $scope.lease;
    vm.service              = $scope.service;
    vm.isLease              = $scope.isLease;
    vm.title                = 'Lease Information';
    vm.leaseOwner           = 'Land Owner';
    if(!vm.isLease || (vm.lease && vm.lease.lease_id)) {
      vm.title                = 'Sublease Information';
      vm.leaseOwner           = 'Lessor';
    }
    vm.informationForm      = {};

    // Methods
    vm.init                 = init;

    vm.goToCompanies        = goToCompanies;
    vm.goToLeases           = goToLeases;
    vm.setLandOwner         = setLandOwner;
    vm.broadcast            = broadcast;
    vm.stopPropagation      = stopPropagation;

    $scope.customDateFormat = {
      formatDate: function(date) {
        var m = moment(date);
        return m.isValid() ? m.format('ll') : '';
      }
    };


    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      vm.lease                = $scope.lease;
      /* Get land owner companies */
      CompanyService.getCompanyByBusinessRole('land owner').then(function(companiesData) {
        vm.landOwnerCompanies = companiesData.companies;
      },
      function(err) {
        console.error(err);
      });
      if(vm.isLease) {
     /* Get lessee companies */
        CompanyService.getCompanyByBusinessRole('landlord').then(function(companiesData) {
          vm.landlordCompanies = companiesData.companies;
        },
        function(err) {
          console.error(err);
        });
      }
      else{
     /* Get tenant companies */
        CompanyService.getCompanyByBusinessRole('tenant').then(function(companiesData) {
          vm.tenantCompanies = companiesData.companies;
        },
        function(err) {
          console.error(err);
        });
      }
      /* Get Payment terms */
      vm.service.getPaymentTerms().then(function(paymentTermsData) {
        vm.paymentTerms = paymentTermsData.payment_terms;
      },
      function(err) {
        console.error(err);
      });


    }
    /**
     * Go to Companies page
     * @param  {[type]} ev [description]
     * @return {[type]}    [description]
     */
    function goToCompanies() {
      $location.url('/companies/');
    }

    /**
     * [goToLeases description]
     * @return {[type]} [description]
     */
    function goToLeases() {
      $location.url('/leases');
    }

      /**
   * [setLandOwner description]
   * @param {[type]} company_id [description]
   */
    function setLandOwner(company_id) {
      if(!vm.lease.land_owner_company_id) {
        vm.landOwnerCompanies.forEach(function(company) {
          if(company.id === company_id) {
            vm.lease.land_owner_company_id = company_id;
            return;
          }
        });
      }
    }

    /**
     * [broadcast description]
     * @param  {[type]} number [description]
     * @return {[type]}        [description]
     */
    function broadcast() {
      vm.informationForm.$pristine = false;
      $rootScope.$broadcast('informationForm', vm.informationForm);
    }

    /**
     * [stopPropagation description]
     * @return {[type]} [description]
     */
    function stopPropagation() {
      event.stopPropagation();
    }

  }

        /**
     * [leaseInformation description]
     * @return {[type]} [description]
     */
  function msLeaseInformation() {
    return {
      restrict   : 'E',
      scope      : {
        lease:   '=',
        isLease: '=',
        service: '='},

      bindToController: {
        vm: '='
      },
      controller : 'MsLeaseInformationController as vm',
      templateUrl: 'app/main/directives/ms-lease-information/templates/ms-lease-information.html',
    };

  }
})();

(function () {
  'use strict';

  angular
    .module('app.directives')
    .controller('MsLeaseBlockController', MsLeaseBlockController)
    .directive('msLeaseBlock', msLeaseBlock);

  /** @ngInject */
  function MsLeaseBlockController(
    $scope,
    $mdToast,
    $mdDialog,
    $document,
    LeaseService,
    $translate,
    _
  ) {
    var vm                  = this;
    vm.fileUpload           = {title:'', description:''};
    vm.listType             = 'all';
    vm.blockClone = [];
    $scope.loadingData = true;
    if ($scope.lease) {
      vm.lease= $scope.lease;
    }
    $scope.loadingData = false;
    vm.service              = $scope.service;
    vm.isLease              = $scope.isLease;

    // Methods
    vm.addBlockDialog     = addBlockDialog;
    vm.deleteBlock = deleteBlock;
    vm.deleteBlockConfirm = deleteBlockConfirm;
    vm.updateLeaseAcres   = updateLeaseAcres;


     /**
     * Function to handle the behavior of add payment.
     */
    function addBlockDialog(ev, block) {
      vm.blockClone = _.cloneDeep(block);
      $mdDialog.show({
        controller         : 'LeaseBlockDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/directives/ms-lease-block/templates/dialogs/lease-block-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            lease           : vm.lease,
            block           : vm.blockClone,
            blockId         : block ? block.id : null,
            service         : vm.service,
            isLease         : vm.isLease
          }
        }
      });
    }


     /**
     * Unassign block
     */
    function deleteBlockConfirm(ev,block) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('LEASES.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('<b>' + block.name  + ' </b>' + ' will be deleted.')
      .ariaLabel('delete block')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        deleteBlock(block);
      }, function () {

      });
    }

    /**
     * [deleteBlock description]
     * @param  {[type]} block [description]
     * @return {[type]}       [description]
     */
    function deleteBlock(block) {
      vm.service.unassignBlock(vm.lease.id,block.id).then(function () {
        $mdToast.show({
          template: '<md-toast class="md-toast success">The block '+ block.name + ' has been unassigned.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.lease.blocks.splice(vm.lease.blocks.indexOf(block), 1);
        updateLeaseAcres(vm.lease);
        closeDialog();
      },
      function(err) { //reject
        var error;
        if(err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">The block '+ block.name + ' could not be unassigned. ' + ((error !== undefined)? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000
        });
      });
    }

    /**
     * Close dialog
     */
    function closeDialog() {
      $mdDialog.hide();
    }

    /**
     * [updateLeaseAcres description]
     * @return {[type]} [description]
     */
    function updateLeaseAcres(lease) {
      var acresAmount = 0;
      lease.blocks.forEach(function(block) {
        acresAmount += block.acres;
      });
      var data = {
        acres: acresAmount
      };
      vm.service.patch(vm.lease.id,data).then(function() {},
      function(err) {
        console.error(err);
      });
    }

  }

      /**
     * [leaseBlock description]
     * @return {[type]} [description]
     */
  function msLeaseBlock() {
    return {
      restrict   : 'E',
      scope      : {
        lease: '=',
        service: '=',
        isLease: '='
      },
      bindToController: {
        vm: '='
      },
      controller : 'MsLeaseBlockController as vm',
      templateUrl: 'app/main/directives/ms-lease-block/templates/ms-lease-block.html'
    };
  }

})();

var app = angular.module('ms-http-img-src', []);

app.directive('httpImgSrc', ['$http', function ($http) {
  return {
  // do not share scope with sibling img tags and parent
  // (prevent show same images on img tag)
    scope: {},
    link: function ($scope, elem, attrs) {
      /**
       * [revokeObjectURL description]
       * @return {[type]} [description]
       */
      function revokeObjectURL() {
        if ($scope.objectURL) {
          URL.revokeObjectURL($scope.objectURL);
        }
      }

      $scope.$watch('objectURL', function (objectURL) {
        elem.attr('src', objectURL);
      });

      $scope.$on('$destroy', function () {
        revokeObjectURL();
      });

      attrs.$observe('httpImgSrc', function (url) {
        revokeObjectURL();

        if(url && url.indexOf('data:') === 0) {
          $scope.objectURL = url;
        } else if(url) {
          $http.get(url, {
            responseType: 'arraybuffer',
            headers: {
              'accept': 'image/webp,image/*,*/*;q=0.8'
            }
          })
          .then(function (response) {
            var blob = new Blob(
              [ response.data ],
              { type: response.headers('Content-Type') }
            );
            elem[0].classList.remove('pdf-no-image');
            $scope.objectURL = URL.createObjectURL(blob);

            var divZoom = elem.parent()[0];
            if(divZoom.hasAttribute('back-img')) {
              divZoom.style['background-image'] = 'url(' + $scope.objectURL +')';
            }
          }, function() {
            $scope.objectURL = attrs.noImg;
            elem[0].classList += ' pdf-no-image ';
          });
        }
      });
    }
  };
}]);

(function () {
  'use strict';
/* ng-infinite-scroll - v1.2.0 - 2015-02-14 */
  var mod;

  mod = angular.module('ms-infinite-scroll', []);

  mod.value('THROTTLE_MILLISECONDS', null);

  mod.directive('msInfiniteScroll', [  
    '$rootScope', '$window', '$interval', 'THROTTLE_MILLISECONDS', function ($rootScope, $window, $interval, THROTTLE_MILLISECONDS, Exception) {
      return {
        scope: {
          msInfiniteScroll: '&',
          msInfiniteScrollContainer: '=',
          msInfiniteScrollDistance: '=',
          msInfiniteScrollDisabled: '=',
          msInfiniteScrollUseDocumentBottom: '=',
          msInfiniteScrollListenForEvent: '@'
        },
        link: function (scope, elem, attrs) {
          var changeContainer, checkWhenEnabled, container, handleInfiniteScrollContainer, handleInfiniteScrollDisabled, handleInfiniteScrollDistance, handleInfiniteScrollUseDocumentBottom, handler, height, immediateCheck, offsetTop, pageYOffset, scrollDistance, scrollEnabled, throttle, unregisterEventListener, useDocumentBottom, windowElement;
          windowElement = angular.element($window);
          scrollDistance = null;
          scrollEnabled = null;
          checkWhenEnabled = null;
          container = null;
          immediateCheck = true;
          useDocumentBottom = false;
          unregisterEventListener = null;
          height = function (elem) {
            elem = elem[0] || elem;
            if (isNaN(elem.offsetHeight)) {
              return elem.document.documentElement.clientHeight;
            } else {
              return elem.offsetHeight;
            }
          };
          offsetTop = function (elem) {
            if (!elem[0].getBoundingClientRect || elem.css('none')) {
              return;
            }
            return elem[0].getBoundingClientRect().top + pageYOffset(elem);
          };
          pageYOffset = function (elem) {
            elem = elem[0] || elem;
            if (isNaN(window.pageYOffset)) {
              return elem.document.documentElement.scrollTop;
            } else {
              return elem.ownerDocument.defaultView.pageYOffset;
            }
          };
          handler = function () {
            var containerBottom, containerTopOffset, elementBottom, remaining, shouldScroll;
            if (container === windowElement) {
              containerBottom = height(container) + pageYOffset(container[0].document.documentElement);
              elementBottom = offsetTop(elem) + height(elem);
            } else {
              containerBottom = height(container);
              containerTopOffset = 0;
              if (offsetTop(container) !== void 0) {
                containerTopOffset = offsetTop(container);
              }
              elementBottom = offsetTop(elem) - containerTopOffset + height(elem);
            }
            if (useDocumentBottom) {
              elementBottom = height((elem[0].ownerDocument || elem[0].document).documentElement);
            }
            remaining = elementBottom - containerBottom;
            shouldScroll = remaining <= height(container) * scrollDistance + 1;
            if (shouldScroll) {
              checkWhenEnabled = true;
              if (scrollEnabled) {
                if (scope.$$phase || $rootScope.$$phase) {
                  return scope.msInfiniteScroll();
                } else {
                  return scope.$apply(scope.msInfiniteScroll);
                }
              }
            } else {
              return checkWhenEnabled = false;
            }
          };
          throttle = function (func, wait) {
            var later, previous, timeout;
            timeout = null;
            previous = 0;
            later = function () {
              previous = new Date().getTime();
              $interval.cancel(timeout);
              timeout = null;
              func.call();
              return null;
            };
            return function () {
              var now, remaining;
              now = new Date().getTime();
              remaining = wait - (now - previous);
              if (remaining <= 0) {
                clearTimeout(timeout);
                $interval.cancel(timeout);
                timeout = null;
                previous = now;
                return func.call();
              } else {
                if (!timeout) {
                  return timeout = $interval(later, remaining, 1);
                }
              }
            };
          };
          if (THROTTLE_MILLISECONDS != null) {
            handler = throttle(handler, THROTTLE_MILLISECONDS);
          }
          scope.$on('$destroy', function () {
            container.unbind('scroll', handler);
            if (unregisterEventListener != null) {
              unregisterEventListener();
              return unregisterEventListener = null;
            }
          });
          handleInfiniteScrollDistance = function (v) {
            return scrollDistance = parseFloat(v) || 0;
          };
          scope.$watch('msInfiniteScrollDistance', handleInfiniteScrollDistance);
          handleInfiniteScrollDistance(scope.msInfiniteScrollDistance);
          handleInfiniteScrollDisabled = function (v) {
            scrollEnabled = !v;
            if (scrollEnabled && checkWhenEnabled) {
              checkWhenEnabled = false;
              return handler();
            }
          };
          scope.$watch('msInfiniteScrollDisabled', handleInfiniteScrollDisabled);
          handleInfiniteScrollDisabled(scope.msInfiniteScrollDisabled);
          handleInfiniteScrollUseDocumentBottom = function (v) {
            return useDocumentBottom = v;
          };
          scope.$watch('msInfiniteScrollUseDocumentBottom', handleInfiniteScrollUseDocumentBottom);
          handleInfiniteScrollUseDocumentBottom(scope.msInfiniteScrollUseDocumentBottom);
          changeContainer = function (newContainer) {
            if (container != null) {
              container.unbind('scroll', handler);
            }
            container = newContainer;
            if (newContainer != null) {
              return container.bind('scroll', handler);
            }
          };
          changeContainer(windowElement);
          if (scope.msInfiniteScrollListenForEvent) {
            unregisterEventListener = $rootScope.$on(scope.msInfiniteScrollListenForEvent, handler);
          }
          handleInfiniteScrollContainer = function (newContainer) {
            if ((newContainer == null) || newContainer.length === 0) {
              return;
            }
            if (newContainer instanceof HTMLElement) {
              newContainer = angular.element(newContainer);
            } else if (typeof newContainer.append === 'function') {
              newContainer = angular.element(newContainer[newContainer.length - 1]);
            } else if (typeof newContainer === 'string') {
              newContainer = angular.element(document.querySelector(newContainer));
            }
            if (newContainer != null) {
              return changeContainer(newContainer);
            } else {
              throw new Exception('invalid infinite-scroll-container attribute.');
            }
          };
          scope.$watch('msInfiniteScrollContainer', handleInfiniteScrollContainer);
          handleInfiniteScrollContainer(scope.msInfiniteScrollContainer || []);
          if (attrs.msInfiniteScrollParent != null) {
            changeContainer(angular.element(elem.parent()));
          }
          if (attrs.msInfiniteScrollImmediateCheck != null) {
            immediateCheck = scope.$eval(attrs.msInfiniteScrollImmediateCheck);
          }
          return $interval((function () {
            if (immediateCheck) {
              return handler();
            }
          }), 0, 1);
        }
      };
    }]);
})();
(function () {
  'use strict';

  angular
    .module('app.directives')
    .controller('MsFileUploadController', MsFileUploadController)
    .directive('msFileUpload', msFileUpload);

    /**
     * [FileUploadController description]
     * @param {[type]} $scope    [description]
     * @param {[type]} $document [description]
     * @param {[type]} $state    [description]
     */
  function MsFileUploadController(
    $http,
    $scope,
    $document,
    $timeout,
    $state,
    $stateParams,
    $window,
    $mdToast,
    $mdDialog,
    $translate,
    $sce,
    msUtils,
    DocumentService,
    DocumentCategoryService,
    FileSaver,
    msApi,
    _
  ) {
    $scope.event              = window.event;
    var vm                    = this;
    vm.ngFlowOptions          = {
      // You can configure the ngFlow from here
      allowDuplicateUploads: true,
      simultaneousUploads: 5
    };
    // ng-flow will be injected into here through its directive
    vm.ngFlow                 = {flow: {}};
    vm.dropping               = false;
    vm.imageZoomOptions       = {};
    vm.files                  = [];
    vm.file_entity            = null;
    vm.file_entity_id         = null;
    vm.file_description       = null;
    vm.file_service           = null;
    vm.documents              = [];
    vm.selectedTab            = null;
    vm.document_category      = null;
    vm.new_tab_name           = null;
    vm.files_to_upload        = [];
    vm.primary_file_over      = false;
    vm.image_types            = [
      'image/bmp',
      'image/gif',
      'image/jpeg',
      'image/png',
      'image/tiff',
      'image/x-icon'
    ];
    vm.mime_types             = [];
    vm.loadingData            = false;

    // Methods
    vm.init                   = init;
    vm.fileAdded              = fileAdded;
    vm.upload                 = upload;
    vm.registerVars           = registerVars;
    vm.updateImageZoomOptions = updateImageZoomOptions;
    vm.deleteFile             = deleteFile;
    vm.deleteTab              = deleteTab;
    vm.addNewTab              = addNewTab;
    vm.setPrimary             = setPrimary;
    vm.trustAsResourceUrl     = trustAsResourceUrl;
    vm.exists                 = msUtils.exists;
    vm.downloadFile           = downloadFile;
    vm.patchDocument          = patchDocument;
    vm.getDocumentData        = getDocumentData;
    vm.checkForAllowedType    = checkForAllowedType;
    vm.openDocumentInANewTab  = openDocumentInANewTab;
    vm.zoom                   = zoom;
    vm.zoomOut                = zoomOut;

    /**
     * [registerVars description]
     * @param  {[type]} element [description]
     * @param  {[type]} scope   [description]
     * @return {[type]}         [description]
     */
    function registerVars(element, scope) {
      vm.file_entity      = scope.fileEntity;
      vm.file_entity_id   = scope.fileEntityId;
      vm.file_service     = scope.fileService;
      init();
    }

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      msApi.request('mimeTypes@get',
        function(data) {
          vm.mime_types = data.mimeTypes;
        }, function(err) {
          console.error(err);
        });
      // Get current document category, to create tabs if necessary
      DocumentCategoryService.getAll({
        search_by   : 'name',
        search      : vm.file_entity
      }).then(function(categoryData) {
        var capitalized_entity = null;
        capitalized_entity = vm.file_entity.charAt(0).toUpperCase() + vm.file_entity.slice(1);
        vm.document_category = _.find(categoryData.rows, {'name': capitalized_entity});
      });
      // Get documents of current entity
      DocumentService.getAll({
        search_by   : 'name',
        search      : vm.file_entity,
        entity_name : vm.file_entity,
        entity_id   : vm.file_entity_id
      }).then(function(documentsData) {
        if (documentsData.documents) {
          documentsData.documents = _.sortBy(documentsData.documents, ['id']);
          for (var i = 0; i < documentsData.documents.length; i++) {
            var aux = documentsData.documents[i];
            aux.files = [];
            aux.primary_file = null;
            if (documentsData.documents[i].hasOwnProperty(vm.file_entity + '_document')) {
              aux.files = documentsData.documents[i][vm.file_entity + '_document'];
              delete aux[vm.file_entity + '_document'];

              // check if this documents have the primary file
              // add 'over' variable on each file, to show delete icon
              for (var j = 0; j < aux.files.length; j++) {
                aux.files[j].over = false;
                // get icon to show
                aux.files[j].icon = 'icon-file';
                if (aux.files[j].file_type && aux.files[j].file_type.name) {
                  aux.files[j].icon = getIcon(aux.files[j].file_type.name);
                }
                // check if it is primary file
                if (aux.files[j].primary) {
                  vm.setPrimary(aux.files[j], true);
                  aux.primary_file = aux.files[j];
                }
              }
            }
            vm.documents.push(aux);
          }
        }
      });
    }

    /**
     * [trustAsResourceUrl description]
     * @param  {[type]} url [description]
     * @return {[type]}
     */
    function trustAsResourceUrl(url) {
      return $sce.trustAsResourceUrl(url);
    }

    /**
     * File added callback
     * Triggers when files added to the uploader
     *
     * @param file
     */
    function fileAdded(Flowfile) {
      if (Flowfile) {
        vm.files_to_upload.push(Flowfile);
      }
    }

    /**
     * Upload
     * Automatically triggers when files added to the uploader
     */
    function upload() {
      vm.loadingData = true;
      for (var i = 0; i < vm.files_to_upload.length; i++) {
        var dataToPost = {
          document_id  : vm.documents[vm.selectedTab].id,
          upfile: vm.files_to_upload[i].file,
          primary: false,
          entity_name: vm.file_entity,
          entity_id: vm.file_entity_id
        };
        DocumentService.uploadFile(dataToPost).then(
        function (file) {
          /**
           * Timeout in order to wait before call the next request to database.
           * 
           * @param  {[type]} )   {                       var aux_file [description]
           * @param  {[type]} 500 [description]
           * @return {[type]}     [description]
           */
          setTimeout(function() {
            var aux_file = file.data[vm.file_entity + '_document'];
            aux_file.file_type = file.data.mimetype;
            aux_file.icon = getIcon(aux_file.file_type.name);
            vm.documents[vm.selectedTab].files.push(aux_file);
            $mdToast.show({
              template: '<md-toast class="md-toast success">The file ' + aux_file.original_name + ' was uploaded.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            vm.loadingData = false;
          }, 500);
        },
        function (err) {
          var message = 'The file could not be uploaded.';
          if (err.data && err.data.message) {
            message = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">' + message + '</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.loadingData = false;
        });
      }
      vm.files_to_upload = [];
    }

    /**
     * Function to create a new Document Type (tab)
     */
    function addNewTab(ev) {
      $mdDialog.show({
        controller         : 'DocumentCategoryDialogController',
        controllerAs       : 'vm',
        templateUrl        : 'app/main/directives/ms-file-upload/dialogs/category/category-dialog.html',
        parent             : angular.element($document.body),
        targetEvent        : ev,
        clickOutsideToClose: true,
        locals             : {
          dialogData: {
            document_category_id  : vm.document_category.id,
            document_categories   : vm.documents,
          }
        }
      });
    }

    /**
     * [setPrimary description]
     * @param {[type]} file [description]
     */
    function setPrimary(file, loadFileOnly) {
      if($scope.event) {
        $scope.event.stopPropagation();
      }
      if (file && file.id) {
        if(loadFileOnly) {
          vm.getDocumentData(file).then(function(documentData) {
            file.documentData = documentData;
            file.primary = true;
            vm.documents[vm.selectedTab].primary_file = file;
          }, function() {
            $mdToast.show({
              template: '<md-toast class="md-toast error">The file could not be loaded.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
          });
        } else {
          DocumentService.setAsPrimary(vm.file_entity, file.id).then(
            function () {
              vm.getDocumentData(file).then(function(documentData) {
                file.documentData = documentData;
                file.primary = true;
                vm.documents[vm.selectedTab].primary_file = file;
                $mdToast.show({
                  template: '<md-toast class="md-toast success">The file ' + file.original_name + ' has been set as primary.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              }, function() {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">The file could not be loaded.</md-toast>',
                  position: 'top right',
                  hideDelay: 4500
                });
              });
            },
            function () {
              $mdToast.show({
                template: '<md-toast class="md-toast error">The file could not be set as primary.</md-toast>',
                position: 'top right',
                hideDelay: 4500
              });
            }
          );
        }
      }
    }

    /**
     * Function to patch a document
     * @param  {[type]} id   [document id]
     * @param  {[type]} data [object with data to patch, for ex {'food_safety_document': 'true'}]
     * @return {[type]}
     */
    function patchDocument(id, data) {
      DocumentService.patch(vm.file_entity, id, data).then(
        function (response) {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The document ' + response.document.name + ' has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function (err) {
          var message = 'The document could not be updated.';
          if (err && err.data && err.data.message) {
            message = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">' + message + '</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        }
      );
    }

    /**
     * Download Primary File
     * @param  {[type]} primary_file [description]
     * @return {[type]}
     */
    function downloadFile(primary_file) {
      DocumentService.getFile(vm.file_entity, primary_file.id).then(
        function (response) {
          FileSaver.saveAs(response.data, primary_file.original_name);
        },
        function (err) {
          var message = 'The file could not be downloaded.';
          if (err && err.data && err.data.message) {
            message = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">' + message + '</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        }
      );
    }

    /**
     * [deleteFile description]
     * @param  {[type]} file_id [description]
     */
    function deleteFile(ev, file_id) {
      $scope.event.stopPropagation();

      var confirm = $mdDialog.confirm()
        .title($translate.instant('EC.ARE_YOU_SURE_TO_DELETE'))
        .htmlContent('The selected document will be deleted.')
        .ariaLabel('delete document')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        DocumentService.deleteFile(vm.file_entity, file_id).then(function (file) {
          var pos = _.findIndex(vm.documents[vm.selectedTab].files, {id: file_id});
          if (pos !== undefined && pos > -1) {
            if (vm.documents[vm.selectedTab].files[pos].primary) {
              vm.documents[vm.selectedTab].primary_file = null;
            }
            vm.documents[vm.selectedTab].files.splice(pos, 1);
          }
          $mdToast.show({
            template: '<md-toast class="md-toast success">' + file.deleted_object.original_name + ' has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The file could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Function to delete tab document
     * @param  {[type]} id [description]
     * @return {[type]}
     */
    function deleteTab(ev, tab) {
      var confirm = $mdDialog.confirm()
        .title($translate.instant('EC.ARE_YOU_SURE_TO_DELETE'))
        .htmlContent('The tab <b>' + tab.name + '</b> will be deleted.')
        .ariaLabel('delete document')
        .targetEvent(ev)
        .ok('OK')
        .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        DocumentService.delete(tab.id).then(function () {
          var pos = _.findIndex(vm.documents, {id: tab.id});
          if (pos !== undefined && pos > -1) {
            vm.documents.splice(pos, 1);
          }
          $mdToast.show({
            template: '<md-toast class="md-toast success">The document has been deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function (err) {
          var message = 'The document could not be deleted.';
          if (err && err.data && err.data.message) {
            message = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">' + message + '</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }

    /**
     * Return icon to show for given file type
     * @param  {[type]} type [file type]
     * @return {[type]}
     */
    function getIcon(type) {
      switch (type) {
      // Pdf
      case 'application/pdf':
        return 'icon-file-pdf-box';
      // Excel
      case 'application/vnd.ms-excel':
      case 'application/vnd.ms-excel.addin.macroEnabled.12':
      case 'application/vnd.ms-excel.sheet.binary.macroEnabled.12':
      case 'application/vnd.ms-excel.sheet.macroEnabled.12':
      case 'application/vnd.ms-excel.template.macroEnabled.12':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.template':
      case 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet':
        return 'icon-file-excel-box';
      // Word
      case 'application/msword':
      case 'application/vnd.ms-word.document.macroEnabled.12':
      case 'application/vnd.ms-word.template.macroEnabled.12':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.template':
      case 'application/vnd.openxmlformats-officedocument.wordprocessingml.document':
        return 'icon-file-word-box';
      // Power point
      case 'application/vnd.ms-powerpoint':
      case 'application/vnd.ms-powerpoint.addin.macroEnabled.12':
      case 'application/vnd.ms-powerpoint.presentation.macroEnabled.12':
      case 'application/vnd.ms-powerpoint.slide.macroEnabled.12':
      case 'application/vnd.ms-powerpoint.slideshow.macroEnabled.12':
      case 'application/vnd.ms-powerpoint.template.macroEnabled.12':
      case 'application/vnd.openxmlformats-officedocument.presentationml.template':
      case 'application/vnd.openxmlformats-officedocument.presentationml.slideshow':
      case 'application/vnd.openxmlformats-officedocument.presentationml.slide':
      case 'application/vnd.openxmlformats-officedocument.presentationml.presentation':
        return 'icon-file-powerpoint';
      // Image
      case 'image/bmp':
      case 'image/gif':
      case 'image/jpeg':
      case 'image/png':
      case 'image/tiff':
      case 'image/x-icon':
        return 'icon-file-image-box';
      default:
        return 'icon-file';
      }
    }

    /**
     * Update image zoom options
     *
     * @param url
     */
    function updateImageZoomOptions(url) {
      vm.imageZoomOptions = {
        images: [
          {
            thumb : url,
            medium: url,
            large : url
          }
        ]
      };
    }
    /**
     * Funtion to zoom over the document image.
     * 
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    function zoom(e) {
      var zoomer = e.currentTarget;
      var img = e.currentTarget.children[0];
      zoomer.style.height = '400px';
      img.style.height = '400px';
      zoomer.style['vertical-align'] = 'middle';
      zoomer.style['-webkit-transition'] = 'height 2s';
      zoomer.style['-moz-transition'] = 'height 2s';
      zoomer.style['-ms-transition'] = 'height 2s';
      zoomer.style['-o-transition'] = 'height 2s';
      zoomer.style['transition'] = 'height 2s';
      var offsetX, offsetY, x, y;
      e.offsetX ? offsetX = e.offsetX : offsetX = ((e.touches)? e.touches[0].pageX : '');
      e.offsetY ? offsetY = e.offsetY : offsetY = ((e.touches)? e.touches[0].pageY : '');
      x = offsetX / zoomer.offsetWidth * 100;
      y = offsetY / zoomer.offsetHeight * 100;
      zoomer.style.backgroundPosition = x + '% ' + y + '%';
    }

    /**
     * [zoomOut description]
     * @param  {[type]} e [description]
     * @return {[type]}   [description]
     */
    function zoomOut(e) {
      var zoomer = e.currentTarget;
      var img = e.currentTarget.children[0];
      zoomer.style.height = 'auto';
      img.style.height = 'auto';
    }
    /**
     * Function to get document information and display in page.
     *
     * @return {$sce} trusted resource
     */
    function getDocumentData(docData) {
      return $http.get(docData.view_url, {
        responseType: 'arraybuffer'
      }).then(function (response) {
        var file = new Blob([response.data], {type: 'application/pdf'});
        var fileURL = window.URL.createObjectURL(file);
        return $sce.trustAsResourceUrl(fileURL);
      }, function(err) {
        console.error(err);
      });
    }

    /**
     * Function to check for allowed mime-type
     *
     * @param  {[type]} type [description]
     * @return {[type]}      [description]
     */
    function checkForAllowedType(type) {
      if(vm.mime_types) {
        vm.mime_types.forEach(function(mimeObj) {
          if(mimeObj.type === type) {
            return true;
          }
        });
      }
      return false;
    }

    /**
     * [openDocumentInANewTab description]
     * @param  {[type]} document [description]
     * @return {[type]}          [description]
     */
    function openDocumentInANewTab(document) {
      $window.open(document.primary_file.documentData, '_blank');
    }
  }

  /**
   * DIRECTIVE FUNCTION (MUST BE OUTSIDE OF THE CONTROLLER SCOPE)
   *
   * [fileUpload description]
   * @return {[type]} [description]
   */
  function msFileUpload() {
    return {
      restrict   : 'E',
      scope      : {
        fileEntity    : '=?',
        fileEntityId  : '=?',
        fileService   : '=?'
      },
      bindToController: {
        vm: '='
      },
      controller : 'MsFileUploadController as vm',
      templateUrl: 'app/main/directives/ms-file-upload/templates/ms-file-upload.html',
      compile : function () {
        return function postLink(scope, iElement, iAttrs, ctrl) {
          var MsFileUploadController = ctrl;
          // Register directive vars.
          MsFileUploadController.registerVars(iElement, scope);
        };
      }
    };
  }
})();

/*jslint node: true */
(function(root, factory) {
  'use strict';

  if (typeof module !== 'undefined' && typeof module.exports ===
    'object') {
    module.exports = factory('angular');

  } else {
    return factory(root.angular);
  }
}(window, function(angular) {
  'use strict';
  var wasPasted = false;
  /**
   * Convertion model to view
   * @param {*} modelValue
   * @param {*} viewSeparator
   */
  function convModelToView(modelValue, viewSeparator) {
    if (modelValue === undefined || modelValue === null || modelValue ===
      '') {
      return '';
    }
    var newViewValue = '';
    if (viewSeparator === ',') {
      newViewValue = String(modelValue).replace('.', ',');
    } else {
      newViewValue = String(modelValue);
    }
    return newViewValue;
  }
  /**
   * Convertion view to model
   * @param {*} viewValue
   * @param {*} viewSeparator
   */
  function convViewToModel(viewValue, viewSeparator) {
    if (viewSeparator === ',') {
      return String(viewValue).replace(/['\.\s]/g, '').replace(',', '.');
    } else if (viewSeparator === '.') {
      return String(viewValue).replace(/[',\s]/g, '');
    }
  }
  /**
   * Add prepend append
   * @param {*} value
   * @param {*} prepend
   * @param {*} append
   */
  function addPrependAppend(value, prepend, append) {
    var newViewValue = value;
    if (append) {
      newViewValue = newViewValue + append;
    }
    if (prepend) {
      if (/^\-.+/.test(newViewValue)) {
        newViewValue = newViewValue.replace('-', '-' + prepend);
      } else {
        newViewValue = prepend + newViewValue;
      }
    }
    return newViewValue;
  }
  /**
   * Init interger part
   * @param {*} attrs_num_int
   * @param {*} def_num_int
   */
  function initIntegerPart(attrs_num_int, def_num_int) {
    if (attrs_num_int >= 0) {
      var _num_int = parseInt(attrs_num_int, 10);
      if (isNaN(_num_int) === false && isFinite(_num_int) && _num_int >= 0) {
        return _num_int;
      }
    }
    return def_num_int;
  }
  /**
   * Init fraction part
   * @param {*} attrs_num_fract
   * @param {*} def_num_fract
   */
  function initFractionPart(attrs_num_fract, def_num_fract) {
    if (attrs_num_fract >= 0) {
      var _num_fract = parseInt(attrs_num_fract, 10);
      if (isNaN(_num_fract) === false && isFinite(_num_fract) && _num_fract >=
        0) {
        return _num_fract;
      }
    }
    return def_num_fract;
  }
  /**
   * Init separator
   * @param {*} attrs_num_sep
   * @param {*} def_num_sep
   */
  function initSeparator(attrs_num_sep, def_num_sep) {
    if (attrs_num_sep === ',') {
      return ',';
    } else if (attrs_num_sep === '.') {
      return '.';
    }
    return def_num_sep;
  }
  /**
   * Init is positive
   * @param {*} attrs_num_pos
   * @param {*} def_num_pos
   */
  function initIsPositive(attrs_num_pos, def_num_pos) {
    if (attrs_num_pos === 'false' || attrs_num_pos === false) {
      return false;
    } else if (attrs_num_pos === 'true' || attrs_num_pos === true) {
      return true;
    }
    return def_num_pos;
  }
  /**
   * Init is negative
   * @param {*} attrs_num_neg
   * @param {*} def_num_neg
   */
  function initIsNegative(attrs_num_neg, def_num_neg) {
    if (attrs_num_neg === 'false' || attrs_num_neg === false) {
      return false;
    } else if (attrs_num_neg === 'true' || attrs_num_neg === true) {
      return true;
    }
    return def_num_neg;
  }
  /**
   * Init round
   * @param {*} attrs_round
   * @param {*} def_round
   */
  function initRound(attrs_round, def_round) {
    if (attrs_round === 'floor') {
      return Math.floor;
    } else if (attrs_round === 'ceil') {
      return Math.ceil;
    } else if (attrs_round === 'round') {
      return Math.round;
    }
    return def_round;
  }
  /**
   * Init is fixed
   * @param {*} attrs_fixed
   * @param {*} def_fixed
   */
  function initIsFixed(attrs_fixed, def_fixed) {
    if (attrs_fixed === 'false' || attrs_fixed === false) {
      return false;
    } else if (attrs_fixed === 'true' || attrs_fixed === true) {
      return true;
    }
    return def_fixed;
  }
  /**
   * Init is thousand
   * @param {*} attrs_thousand
   * @param {*} def_thousand
   */
  function initIsThousand(attrs_thousand, def_thousand) {
    if (attrs_thousand === 'false' || attrs_thousand === false) {
      return false;
    } else if (attrs_thousand === 'true' || attrs_thousand === true) {
      return true;
    }
    return def_thousand;
  }
  /**
   * Init thousand separator
   * @param {*} attrs_thousand
   * @param {*} fractionSeparator
   * @param {*} def_thousand
   */
  function initThousandSeparator(attrs_thousand, fractionSeparator,
    def_thousand) {
    if (!attrs_thousand) {
      return def_thousand;
    }
    var regexp;
    if (fractionSeparator === '.') {
      regexp = new RegExp('^[\',\\s]$');
    } else {
      regexp = new RegExp('^[\'\\.\\s]$');
    }
    if (regexp.test(attrs_thousand)) {
      return attrs_thousand;
    } else {
      return def_thousand;
    }
  }
  /**
   * Init num append prepend
   * @param {*} attrs_num_char
   */
  function initNumAppendPrepend(attrs_num_char) {
    var regexp = new RegExp('[^\\d,\\.\\s\\-]{1}');
    if (regexp.test(attrs_num_char)) {
      return attrs_num_char;
    }
    return null;
  }
  /**
   * Build reg exp
   * @param {*} integerPart
   * @param {*} fractionPart
   * @param {*} fractionSeparator
   * @param {*} isPositiveNumber
   * @param {*} isNegativeNumber
   */
  function buildRegexp(integerPart, fractionPart, fractionSeparator,
    isPositiveNumber, isNegativeNumber) {
    var negativeRegex = '-?';
    if (isPositiveNumber === false && isNegativeNumber === true) {
      negativeRegex = '-';
    } else if (isPositiveNumber === true && isNegativeNumber === false) {
      negativeRegex = '';
    }
    var intRegex = '[0-9]{0,' + (integerPart) + '}';
    if (integerPart === 0) {
      intRegex = '0';
    }
    var fractRegex = '(\\' + fractionSeparator + '([0-9]){0,' +
      fractionPart + '})';
    if (fractionPart === 0) {
      fractRegex = '';
    }
    return new RegExp('^' + negativeRegex + intRegex + fractRegex + '?$');
  }
  /**
   * Remove leading zero
   * @param {*} value
   */
  function removeLeadingZero(value) {
    return String(value)
      .replace(/^(-?)(0+)$/g, '$10') //change 00000 to '0' and -00000 to '-0'
      .replace(/^0(\d+)/g, '$1') //change 000001 to '1'
      .replace(/^-0(\d+)/g, '-$1') //change -013212 to -0
      .replace(new RegExp('^-([\\.,\\s])', 'g'), '-0$1') //change -. to -0.
      .replace(new RegExp('^[\\.,\\s]', 'g'), '0$&'); //change . to 0.
  }
  /**
   * Remove prepend append chars
   * @param {*} value
   * @param {*} prepend
   * @param {*} append
   */
  function removePrependAppendChars(value, prepend, append) {
    var newValue = value;
    if (prepend) {
      newValue = newValue.replace(new RegExp('[\\' + prepend + ']', 'g'),
        '');
    }
    if (append) {
      newValue = newValue.replace(new RegExp('[\\' + append + ']', 'g'), '');
    }
    return newValue;
  }
  /**
   * Remove thousand separators
   * @param {*} value
   * @param {*} thousandSeparator
   */
  function removeThousandSeparators(value, thousandSeparator) {
    if (thousandSeparator === '.') {
      return String(value).replace(/\./g, '');
    } else if (thousandSeparator === ',') {
      return String(value).replace(/,/g, '');
    } else {
      return String(value).replace(new RegExp('[\'\\s]', 'g'), '');
    }
  }
  /**
   * Add thousand separator
   * @param {*} value
   * @param {*} fractionSeparator
   * @param {*} thousandSeparator
   */
  function addThousandSeparator(value, fractionSeparator, thousandSeparator) {
    value = String(value).split(fractionSeparator);
    value[0] = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, thousandSeparator);
    return value.join(fractionSeparator);
  }
  /**
   * Add fixed zeros
   * @param {*} value
   * @param {*} parameters
   */
  function addFixedZeros(value, parameters) {
    var newValue = value;
    if (parameters.isFixed) {
      var fractionPart = newValue.split(parameters.fractionSeparator)[1];
      var fractionLength = (fractionPart && fractionPart.length) ?
        fractionPart.length : 0;
      if (fractionLength === 0) {
        newValue += parameters.fractionSeparator;
      }
      for (var i = fractionLength; i < parameters.fractionPart; i++) {
        newValue += '0';
      }
    }
    return newValue;
  }
  /**
   * Change view value
   * @param {*} ngModelController
   * @param {*} value
   * @param {*} parameters
   * @param {*} state
   * @param {*} disable
   */
  function changeViewValue(ngModelController, value, parameters, state,
    disable) {

    if (disable) {
      state.enable = false;
    }
    var valueString = String(value);
    var valueWithFixedZeros = addFixedZeros(valueString, parameters);
    var valueWithPrependAppend = addPrependAppend(valueWithFixedZeros,
      parameters.prepend, parameters.append);
    // https://github.com/angular/angular.js/issues/13068
    // ngModelController.$viewValue = value;
    var version = angular.version;
    if (version.major === 1 && version.minor === 2) {
      ngModelController.$viewValue = valueWithPrependAppend;
    } else {
      ngModelController.$setViewValue(valueWithPrependAppend);
    }
    ngModelController.$render();
  }
  /**
   * Filter Model Value
   * @param {*} value
   * @param {*} fractionPart
   * @param {*} fractionSeparator
   * @param {*} roundFunction
   * @param {*} numFixed
   * @param {*} isThousandSeparator
   * @param {*} thousandSeparator
   * @param {*} prepend
   * @param {*} append
   */
  function filterModelValue(
    value,
    fractionPart,
    fractionSeparator,
    roundFunction,
    numFixed,
    isThousandSeparator,
    thousandSeparator,
    prepend,
    append
  ) {
    if (value === '' || value === undefined || value === null) {
      return '';
    }
    value = Number(value);
    if (!isNaN(value) && isFinite(value)) {
      var powerOfTen = Math.pow(10, fractionPart);
      if (numFixed) {
        value = convModelToView((roundFunction(value * powerOfTen) /
            powerOfTen).toFixed(fractionPart), fractionSeparator, prepend,
          append);
      } else {
        value = convModelToView(String(roundFunction(value * powerOfTen) /
          powerOfTen), fractionSeparator, prepend, append);
      }
      value = addPrependAppend(value, prepend, append);
      if (isThousandSeparator) {
        value = addThousandSeparator(value, fractionSeparator,
          thousandSeparator);
      }
      return value;
    }
    if (numFixed) {
      return (0).toFixed(fractionPart);
    } else {
      return '0';
    }
  }
  /**
   * from this source:
   * http://stackoverflow.com/a/2897229/4138339
   */
  function getCaretPosition(oField) {
    var iCaretPos = 0;
    if (document.selection) {
      // oField.focus(); // commented to fix focus issue
      var oSel = document.selection.createRange();
      oSel.moveStart('character', -oField.value.length);
      iCaretPos = oSel.text.length;
    } else if (oField.selectionStart || oField.selectionStart == '0')
      iCaretPos = oField.selectionDirection == 'backward' ? oField.selectionStart :
      oField.selectionEnd;
    return (iCaretPos);
  }
  /**
   * from this source
   * http://stackoverflow.com/a/22574572/4138339
   */
  function setCaretPosition(elem, caretPos) {
    if (elem !== null) {
      if (elem.createTextRange) {
        var range = elem.createTextRange();
        range.move('character', caretPos);
        range.select();
      } else {
        if (elem.selectionStart) {
          // commented to fix focus issue
          // elem.focus();
          // elem.setSelectionRange(caretPos, caretPos);
        } else {
          // commented to fix focus issue
          // elem.focus();
        }
      }
    }
  }
  /**
   * Count thousand separator to position
   * @param {*} value
   * @param {*} separator
   * @param {*} position
   */
  function countThousandSeparatorToPosition(value, separator, position) {
    var countPosition = 0;
    var countDots = 0;
    for (var i = 0; i < value.length; i++) {
      if (value[i] !== separator) {
        countPosition++;
        if (countPosition >= position) break;
      } else {
        countDots++;
      }
    }
    return countDots;
  }
  /**
   * Cut surplus fraction part
   * @param {*} value
   * @param {*} parameters
   */
  function cutSurplusFractionPart(value, parameters) {

    var newValue = value;
    var splitedValue = newValue.split(parameters.fractionSeparator);
    var integerPart = splitedValue[0];
    var fractionPart = splitedValue[1];
    if (fractionPart && fractionPart.length > parameters.fractionPart) {
      fractionPart = fractionPart.slice(0, parameters.fractionPart);
      newValue = [integerPart, fractionPart].join(parameters.fractionSeparator);
    }
    return newValue;
  }
  /**
   * Prepare response
   * @param {*} value
   */
  function prepareResponse(value) {
    if (value === null) {
      return null;
    } else {
      return Number(value);
    }
  }
  /**
   * Create property object
   * @param {*} scope
   * @param {*} key
   * @param {*} value
   */
  function createPropertyObject(scope, key, value) {
    var properties = {
      currencyInput: scope.currencyInput,
      numInt: scope.numInt,
      numFract: scope.numFract,
      numSep: scope.numSep,
      numPos: scope.numPos,
      numNeg: scope.numNeg,
      numRound: scope.numRound,
      numThousand: scope.numThousand,
      numThousandSep: scope.numThousandSep,
      numPrepend: scope.numPrepend,
      numAppend: scope.numAppend,
      numFixed: scope.numFixed
    };
    if (key) {
      properties[key] = value;
    }
    return properties;
  }
  /**
   * Remove doubled decimal separators
   * @param {*} value
   * @param {*} parameters
   */
  function removeDoubledDecimalSeparators(value, parameters) {
    return value.replace(new RegExp('[\\' + parameters.fractionSeparator +
      ']+', 'g'), parameters.fractionSeparator);
  }
  /**
   * Init all properties
   * @param {*} properties
   * @param {*} element
   * @param {*} attrs
   * @param {*} ngModelController
   * @param {*} dynamicNumberStrategy
   */
  function initAllProperties(properties, element, attrs, ngModelController,
    dynamicNumberStrategy) {
    var strategy = {};
    if (properties.currencyInput) {
      strategy = dynamicNumberStrategy.getStrategy(properties.currencyInput);
    }
    var integerPart = initIntegerPart(properties.numInt !== undefined ?
      properties.numInt : strategy.numInt, 6);
    var fractionPart = initFractionPart(properties.numFract !== undefined ?
      properties.numFract : strategy.numFract, 2);
    var fractionSeparator = initSeparator(properties.numSep !== undefined ?
      properties.numSep : strategy.numSep, '.');
    var isPositiveNumber = initIsPositive(properties.numPos !== undefined ?
      properties.numPos : strategy.numPos, true);
    var isNegativeNumber = initIsNegative(properties.numNeg !== undefined ?
      properties.numNeg : strategy.numNeg, true);
    var roundFunction = initRound(properties.numRound !== undefined ?
      properties.numRound : strategy.numRound, Math.round);
    var isThousandSeparator = initIsThousand(properties.numThousand !==
      undefined ? properties.numThousand : strategy.numThousand, false);
    var thousandSeparator = initThousandSeparator(properties.numThousandSep !==
      undefined ? properties.numThousandSep : strategy.numThousandSep,
      fractionSeparator, fractionSeparator === '.' ? ',' : '.');
    var prepend = initNumAppendPrepend(properties.numPrepend !== undefined ?
      properties.numPrepend : strategy.numPrepend);
    var append = initNumAppendPrepend(properties.numAppend !== undefined ?
      properties.numAppend : strategy.numAppend);
    var isFixed = initIsFixed(properties.numFixed !== undefined ?
      properties.numFixed : strategy.numFixed, false);
    if (isPositiveNumber === false && isNegativeNumber === false) {
      throw new Error(
        'Number is set to not be positive and not be negative. Change num_pos attr or/and num_neg attr to true'
      );
    }

    var viewRegexTest = buildRegexp(integerPart, fractionPart,
      fractionSeparator, isPositiveNumber, isNegativeNumber);
    return {
      element: element,
      attrs: attrs,
      ngModelController: ngModelController,
      viewRegexTest: viewRegexTest,
      integerPart: integerPart,
      fractionPart: fractionPart,
      fractionSeparator: fractionSeparator,
      isPositiveNumber: isPositiveNumber,
      isNegativeNumber: isNegativeNumber,
      roundFunction: roundFunction,
      isThousandSeparator: isThousandSeparator,
      thousandSeparator: thousandSeparator,
      prepend: prepend,
      append: append,
      isFixed: isFixed
    };
  }
  /**
   * Directive parser
   * @param {*} value
   * @param {*} parameters
   * @param {*} state
   */
  function directiveParser(value, parameters, state) {
    var element = parameters.element;
    var ngModelController = parameters.ngModelController;
    var viewRegexTest = parameters.viewRegexTest;
    var fractionPart = parameters.fractionPart;
    var fractionSeparator = parameters.fractionSeparator;
    var isPositiveNumber = parameters.isPositiveNumber;
    var isNegativeNumber = parameters.isNegativeNumber;
    var isThousandSeparator = parameters.isThousandSeparator;
    var thousandSeparator = parameters.thousandSeparator;
    var prepend = parameters.prepend;
    var append = parameters.append;

    var parsedValue = String(value);

    if (wasPasted) {
      wasPasted = false;

      // Remove all characters which are not number-relevant
      var regex = new RegExp('[^' + ((isNegativeNumber) ? '-' : '') +
        fractionSeparator + thousandSeparator + '0-9]+', 'g');
      parsedValue = parsedValue.replace(regex, '');

      // Remove trailing separators
      regex = new RegExp('^[' + fractionSeparator + thousandSeparator + ']');
      parsedValue = parsedValue.replace(regex, '');

      // Replace separator if at fraction position
      regex = new RegExp('[' + fractionSeparator + thousandSeparator +
        ']([0-9]{' + fractionPart + '})$');
      parsedValue = parsedValue.replace(regex, fractionSeparator + '$1');
    }
    parsedValue = removePrependAppendChars(parsedValue, prepend, append);
    parsedValue = removeDoubledDecimalSeparators(parsedValue, parameters);
    if (new RegExp('^[\.,' + thousandSeparator + ']{2,}').test(parsedValue)) {
      changeViewValue(ngModelController, '', parameters, state);
      return null;
    }
    var cursorPosition = getCaretPosition(element[0]);
    if (prepend) {
      cursorPosition--;
    }
    var valBeforeCursor = parsedValue.slice(0, cursorPosition);
    valBeforeCursor = removeThousandSeparators(valBeforeCursor,
      thousandSeparator);
    parsedValue = removeThousandSeparators(parsedValue, thousandSeparator);
    valBeforeCursor = removeLeadingZero(valBeforeCursor);
    var beforeRemovingLeadingZero = parsedValue;
    parsedValue = removeLeadingZero(parsedValue);
    if (parsedValue === '0' + fractionSeparator &&
      beforeRemovingLeadingZero === fractionSeparator && isPositiveNumber) {
      if (fractionPart) {
        changeViewValue(ngModelController, '' + fractionSeparator,
          parameters, state, true);
        setCaretPosition(element[0], 2);
        return null;
      } else {
        changeViewValue(ngModelController, '', parameters, state);
        return null;
      }
    }
    if (parsedValue === '' && String(value).charAt(0) === '0') {
      changeViewValue(ngModelController, '', parameters);
      return null;
    }
    if (parsedValue === undefined || parsedValue === '') {
      changeViewValue(ngModelController, '', parameters);
      return null;
    }
    if (parsedValue === '-') {
      if (isPositiveNumber && !isNegativeNumber) {
        changeViewValue(ngModelController, '', parameters, state);
      } else {
        changeViewValue(ngModelController, '-', parameters, state);
      }
      return null;
    }

    parsedValue = cutSurplusFractionPart(parsedValue, parameters);
    /**
     * view value failed 'correct view format' test
     * therefore view value is set from last correct model value (it must be formatted - change dot to comma)
     */
    if (viewRegexTest.test(parsedValue) === false) {
      var modelValue = convModelToView(ngModelController.$modelValue,
        fractionSeparator, parameters);

      if (isThousandSeparator) {
        modelValue = addThousandSeparator(modelValue, fractionSeparator,
          thousandSeparator);
      }
      changeViewValue(ngModelController, modelValue, parameters, state);
      setCaretPosition(element[0], cursorPosition - 1);
      return ngModelController.$modelValue;
    }
    /**
     * view value success 'correct view format' test
     * therefore model value is set from correct view value (it must be formatter - change comma to dot)
     */
    else {
      var dots = 0;
      var currentPosition = valBeforeCursor.length;
      if (isThousandSeparator) {
        parsedValue = addThousandSeparator(parsedValue, fractionSeparator,
          thousandSeparator);
        dots = countThousandSeparatorToPosition(parsedValue,
          thousandSeparator, currentPosition);
      }
      if (prepend) {
        dots++;
        if (new RegExp('^(\\-\\d)$').test(parsedValue)) {
          dots += 2;
        }
        if (new RegExp('^(\\d)$').test(parsedValue)) {
          dots++;
        }
      }
      changeViewValue(ngModelController, parsedValue, parameters, state);
      setCaretPosition(element[0], currentPosition + dots);
      return convViewToModel(parsedValue, fractionSeparator,
        thousandSeparator);
    }
  }
  /**
   * Triggers parsers
   * @param {*} ngModelController
   * @param {*} value
   */
  function triggerParsers(ngModelController, value) {
    ngModelController.$setViewValue('');
    ngModelController.$render();
    ngModelController.$setViewValue(value);
    ngModelController.$render();
  }
  /**
   * On property watch
   * @param {*} ngModelController
   * @param {*} initObject
   */
  function onPropertyWatch(ngModelController, initObject) {
    var value = filterModelValue(
      ngModelController.$modelValue,
      initObject.fractionPart,
      initObject.fractionSeparator,
      initObject.roundFunction,
      initObject.isFixed,
      initObject.isThousandSeparator,
      initObject.thousandSeparator,
      initObject.prepend,
      initObject.append
    );
    triggerParsers(ngModelController, value);
  }
  /**
   * Dynamic number directive
   * @param {*} dynamicNumberStrategy
   */
  function dynamicNumberDirective(dynamicNumberStrategy) {
    return {
      restrict: 'A',
      require: '?ngModel',
      scope: {
        currencyInput: '@',
        numInt: '@',
        numFract: '@',
        numSep: '@',
        numPos: '@',
        numNeg: '@',
        numRound: '@',
        numThousand: '@',
        numThousandSep: '@',
        numPrepend: '@',
        numAppend: '@',
        numFixed: '@',
        valMax: '@',
        valMin: '@'
      },
      link: function(scope, element, attrs, ngModelController) {
        if (!element[0] || element[0].tagName !== 'INPUT' || (element[0].type !==
            'text' && element[0].type !== 'tel')) {
          console.warn(
            'Directive angular-dynamic-number works only for \'input\' tag with type = \'text\' or type = \'tel\''
          );
          return;
        }
        if (!ngModelController) {
          console.warn(
            'Directive angular-dynamic-number need ngModel attribute');
          return;
        }
        var initObject = initAllProperties(
          createPropertyObject(scope),
          element,
          attrs,
          ngModelController,
          dynamicNumberStrategy
        );

        element.on('paste', function() {
          wasPasted = true;
        });

        scope.$watch('numInt', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numInt', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });

        scope.$watch('numFract', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numFract', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });

        scope.$watch('numSep', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numSep', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });

        scope.$watch('numPos', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numPos', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });

        scope.$watch('numNeg', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numNeg', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });

        scope.$watch('numThousand', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numThousand', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });

        scope.$watch('numThousandSep', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numThousandSep', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });

        scope.$watch('numAppend', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numAppend', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });

        scope.$watch('numPrepend', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numPrepend', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });
        scope.$watch('numFixed', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'numFixed', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });
        scope.$watch('valMax', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'valMax', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });
        scope.$watch('valMin', function(newProperty, oldProperty) {
          if (oldProperty === newProperty) {
            return;
          }
          initObject = initAllProperties(createPropertyObject(scope,
              'valMin', newProperty), element, attrs,
            ngModelController, dynamicNumberStrategy);
          onPropertyWatch(ngModelController, initObject);
        });
        var state = {
          enable: true,
          count: 0
        };
        ngModelController.$parsers.unshift(function(value) {
          if (state.enable) {
            state.count++;
            var aux = prepareResponse(directiveParser(value, initObject, state));
            var isValid = true;
            if (aux < attrs.valMin || aux > attrs.valMax) {
              isValid = false;
            }
            ngModelController.$setValidity(attrs.name, isValid);
            return aux;
          } else {
            state.enable = true;
            return value;
          }
        });
        /**
         * it is like filter,
         */
        ngModelController.$formatters.push(function(value) {
          return filterModelValue(
            value,
            initObject.fractionPart,
            initObject.fractionSeparator,
            initObject.roundFunction,
            initObject.isFixed,
            initObject.isThousandSeparator,
            initObject.thousandSeparator,
            initObject.prepend,
            initObject.append
          );
        });
      }
    };
  }

  var moduleName = 'dynamicNumber';

  angular.module(moduleName, [])
    .provider('dynamicNumberStrategy', function() {
      var strategies = {};

      this.addStrategy = addStrategy;
      this.getStrategy = getStrategy;
      this.getStrategies = getStrategies;

      var strategyProvider = {
        addStrategy: addStrategy,
        getStrategy: getStrategy,
        getStrategies: getStrategies
      };

      this.$get = function() {
        return strategyProvider;
      };
      /**
       * Add strategy
       * @param {*} name
       * @param {*} strategy
       */
      function addStrategy(name, strategy) {
        strategies[name] = strategy;
      }
      /**
       * Get strategy
       * @param {*} name
       */
      function getStrategy(name) {
        return strategies[name];
      }
      /**
       * Get strategies
       */
      function getStrategies() {
        return strategies;
      }
    })
    .filter('currencyInput', ['dynamicNumberStrategy', function(
      dynamicNumberStrategy) {
      return function(value, numFract, numSep, numRound, numFixed,
        numThousand, numThousandSep, numPrepend, numAppend) {
        var strategy = {};
        if (angular.isString(numFract)) {
          strategy = dynamicNumberStrategy.getStrategy(numFract);
          numFract = strategy.numFract;
        }
        var fractionPart = initFractionPart(numFract, 2);
        var fractionSeparator = initSeparator(numSep !== undefined ?
          numSep : strategy.numSep, '.');
        var roundFunction = initRound(numRound !== undefined ?
          numRound : strategy.numRound, Math.round);
        var isFixed = initIsFixed(numFixed !== undefined ? numFixed :
          strategy.numFixed, false);
        var isThousandSeparator = initIsThousand(numThousand !==
          undefined ? numThousand : strategy.numThousand, false);
        var thousandSeparator = initThousandSeparator(numThousandSep !==
          undefined ? numThousandSep : strategy.numThousandSep,
          fractionSeparator, fractionSeparator === '.' ? ',' : '.');
        var prepend = initNumAppendPrepend(numPrepend !== undefined ?
          numPrepend : strategy.numPrepend);
        var append = initNumAppendPrepend(numAppend !== undefined ?
          numAppend : strategy.numAppend);
        var filteredValue = filterModelValue(value, fractionPart,
          fractionSeparator, roundFunction, isFixed,
          isThousandSeparator, thousandSeparator, prepend, append);
        if (filteredValue === '') {
          return '0';
        }
        return filteredValue;
      };
    }])
    .directive('currencyInput', ['dynamicNumberStrategy', dynamicNumberDirective])
    .config(['dynamicNumberStrategyProvider', function(dynamicNumberStrategyProvider) {
      var strategyTypes = {
        'money': {
          numInt: 7,
          numFract: 2
        },
        'acres': {
          numInt: 4,
          numFract: 1
        },
        'integer': {
          numFract: 0
        },
        'integerFourNum': {
          numInt: 4,
          numFract: 0
        }
      };
      for (var k in strategyTypes) {
        dynamicNumberStrategyProvider.addStrategy(k, {
          numInt: (strategyTypes[k] && strategyTypes[k].hasOwnProperty('numInt') ? strategyTypes[k].numInt : '2'),
          numFract: (strategyTypes[k] && strategyTypes[k].hasOwnProperty('numFract') ? strategyTypes[k].numFract : '0'),
          numSep: (strategyTypes[k] && strategyTypes[k].hasOwnProperty('numSep') ? strategyTypes[k].numSep : '.'),
          numPos: (strategyTypes[k] && strategyTypes[k].hasOwnProperty('numPos') ? strategyTypes[k].numPos : true),
          numNeg: (strategyTypes[k] && strategyTypes[k].hasOwnProperty('numNeg') ? strategyTypes[k].numNeg : false),
          numRound: (strategyTypes[k] && strategyTypes[k].hasOwnProperty('numRound') ? strategyTypes[k].numRound : 'round'),
          numThousand: (strategyTypes[k] && strategyTypes[k].hasOwnProperty('numThousand') ? strategyTypes[k].numThousand : true)
        });
      }
    }]);
  return moduleName;
}));

var app = angular.module('ms-draggable', []);

app.directive('draggable', function () {
  return {
    restrict: 'A',
    link: function(scope, element) {
      element.draggable({
        stop: function(event) {
          event.stopPropagation();
        }
      });
    }
  };
});

var app = angular.module('ms-datepicker', []);

app.directive('datepicker', function () {
  return {
    restrict: 'A',
    require: 'mdDatepicker',
    link: function (scope, element, attrs, mdDatepickerCtrl) {
      // Fix to clear error state when setting date programatically from null
      // Bug https://github.com/angular/material/issues/6086
      mdDatepickerCtrl.$scope.$watch(function () { return mdDatepickerCtrl.date; }, function (newVal, oldVal) {
        if (newVal && !oldVal) {
          mdDatepickerCtrl.updateErrorState.call(mdDatepickerCtrl);
        }
      });
    }
  };
});

(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function () {
  'use strict';

  angular
    .module('app.core')
    .controller('MsCustomThemeOptionsController', MsCustomThemeOptionsController)
    .directive('msCustomThemeOptions', msCustomThemeOptions);

    /** @ngInject */
  function MsCustomThemeOptionsController(
    $cookies,
    FarmService,
    fuseTheming,
    $mdToast,
    UserService,
    $scope,
    $mdSidenav,
    $timeout
  )
    {
    var vm = this;

    // Data
    vm.themes = fuseTheming.themes;
    var user = UserService.getLocalUser();
    vm.roles = user.roles;
    vm.farm = [];
    var userLocal = vm.roles.findIndex(function (i) {
      return i.name.toLowerCase() === 'super_user';
    }) !== -1;
    /**
     * Check user local in data base
     */
    UserService.getUser(user.id).then(function(userData) {
      var userOnlineDataBase = userData.user.roles.findIndex(function (i) {
        return i.name.toLowerCase() === 'super user';
      }) >= 0;
      if (userLocal && userOnlineDataBase) {
        $scope.admin = true;
      }
    });
    vm.layoutModes = [
      {
        label: 'Boxed',
        value: 'boxed'
      },
      {
        label: 'Wide',
        value: 'wide'
      }
    ];
    vm.layoutStyles = [
      {
        label : 'Vertical Navigation',
        value : 'verticalNavigation',
        figure: '/assets/images/theme-options/vertical-nav.jpg'
      },
      {
        label : 'Vertical Navigation with Fullwidth Toolbar',
        value : 'verticalNavigationFullwidthToolbar',
        figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
      },
      {
        label : 'Vertical Navigation with Fullwidth Toolbar 2',
        value : 'verticalNavigationFullwidthToolbar2',
        figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
      },
      {
        label : 'Horizontal Navigation',
        value : 'horizontalNavigation',
        figure: '/assets/images/theme-options/horizontal-nav.jpg'
      },
      {
        label : 'Content with Toolbar',
        value : 'contentWithToolbar',
        figure: '/assets/images/theme-options/content-with-toolbar.jpg'
      },
      {
        label : 'Content Only',
        value : 'contentOnly',
        figure: '/assets/images/theme-options/content-only.jpg'
      },
    ];

    vm.layoutMode = 'wide';
    vm.layoutStyle = $cookies.get('layoutStyle') || vm.auxLayoutStyle;

    // Methods
    vm.setActiveTheme = setActiveTheme;
    vm.getActiveTheme = getActiveTheme;
    vm.updateLayoutMode = updateLayoutMode;
    vm.updateLayoutStyle = updateLayoutStyle;

    /**
     * Load data
     */
    FarmService.getFarm(1).then(function(FarmData) {
      vm.farm = FarmData.farm;
      vm.auxLayoutStyle = FarmData.farm.layout_type;
    },
      function(err) {
        console.error(err);
      });
    /**
     * Set active theme
     *
     * @param themeName
     */
    function setActiveTheme(themeName)
    {
      if ($scope.admin === true) {
        vm.farm.color_palette = themeName;
        FarmService.update(1, vm.farm).then(function() {
          $mdToast.show({
            template: '<md-toast class="md-toast success">Theme has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        },
        function(err) { //reject
          var error;
          if(err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">Theme could not be saved. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000,
            controller: 'FiscalYearCtrl',
          });
        });
        fuseTheming.setActiveTheme(themeName);
      }
    }
    /**
     * Get active theme
     *
     * @returns {service.themes.active|{name, theme}}
     */
    function getActiveTheme()
    {
      return fuseTheming.themes.active;
    }
    /**
     * Update layout mode
     */
    function updateLayoutMode()
    {
      var bodyEl = angular.element('body');
      // Update class on body element
      bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
    }
    /**
     * Update layout style
     */
    function updateLayoutStyle()
    {
      if ($scope.admin === true) {
        vm.farm.layout_type = vm.layoutStyle;
        FarmService.update(1, vm.farm).then(function() {
          $mdToast.show({
            template: '<md-toast class="md-toast success">Layout has been updated.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          $timeout(function() {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);
            // Reload the page to apply the changes
            location.reload();
          }, 1000);
        },
        function(err) { //reject
          var error;
          if(err.status !== 500) {
            error = err.data.message;
          }
          $mdToast.show({
            template: '<md-toast class="md-toast error">Layout could not be saved. ' + ((error !== undefined)? error : '') + '</md-toast>',
            position: 'top right',
            hideDelay: 6000,
            controller: 'FiscalYearCtrl',
          });
        });
      }
    }
  }
  /** @ngInject */
  function msCustomThemeOptions($mdSidenav)
  {
    return {
      restrict   : 'E',
      scope      : {},
      controller : 'MsCustomThemeOptionsController as vm',
      templateUrl: 'app/main/directives/ms-custom-theme-options/custom-theme-options.html',
      compile    : function (tElement)
      {
        tElement.addClass('ms-custom-theme-options');

        return function postLink(scope)
        {
          /**
           * Toggle options sidenav
           */
          function toggleOptionsSidenav()
          {
            // Toggle the fuse theme options panel
            $mdSidenav('fuse-theme-options').toggle();
          }

          // Expose the toggle function
          scope.toggleOptionsSidenav = toggleOptionsSidenav;
        };
      }
    };
  }
})();

(function () {
  'use strict';

  angular
  .module('app.directives')
  .controller('MsCustomStepperController', MsCustomStepperController)
  .directive('msHorizontalCustomStepper', msHorizontalCustomStepperDirective)
  .directive('msHorizontalCustomStepperStep', msHorizontalCustomStepperStepDirective)
  .directive('msVerticalCustomStepper', msVerticalCustomStepperDirective)
  .directive('msVerticalCustomStepperStep', msVerticalCustomStepperStepDirective);


  /** @ngInject */
  function MsCustomStepperController($timeout,
                                     StepperService) {
    var vm = this;

    // Data
    vm.mainForm = undefined;

    vm.orientation = 'horizontal';
    vm.steps = [];
    vm.currentStep = undefined;
    vm.currentStepNumber = 1;

    // Methods
    vm.setOrientation = setOrientation;
    vm.registerMainForm = registerMainForm;
    vm.registerStep = registerStep;
    vm.setupSteps = setupSteps;
    vm.resetForm = resetForm;

    vm.setCurrentStep = setCurrentStep;

    vm.gotoStep = gotoStep;
    vm.gotoPreviousStep = gotoPreviousStep;
    vm.gotoNextStep = gotoNextStep;
    vm.gotoFirstStep = gotoFirstStep;
    vm.gotoLastStep = gotoLastStep;

    vm.isFirstStep = isFirstStep;
    vm.isLastStep = isLastStep;

    vm.isStepCurrent = isStepCurrent;
    vm.isStepDisabled = isStepDisabled;
    vm.isStepOptional = isStepOptional;
    vm.isStepHidden = isStepHidden;
    vm.filterHiddenStep = filterHiddenStep;
    vm.isStepValid = isStepValid;
    vm.isStepNumberValid = isStepNumberValid;
    vm.hasSave = hasSave;
    vm.isFormValid = isFormValid;

    //////////

    /**
     * Set the orientation of the stepper
     *
     * @param orientation
     */
    function setOrientation(orientation) {
      vm.orientation = orientation || 'horizontal';
    }

    /**
     * Register the main form
     *
     * @param form
     */
    function registerMainForm(form) {
      vm.mainForm = form;
    }

    /**
     * Register a step
     *
     * @param element
     * @param scope
     * @param form
     */
    function registerStep(element, scope, form) {
      var step = {
        element: element,
        scope: scope,
        form: form,
        stepNumber: scope.step || (vm.steps.length + 1),
        stepTitle: scope.stepTitle,
        stepTitleTranslate: scope.stepTitleTranslate
      };

      // Push the step into steps array
      vm.steps.push(step);

      // Sort steps by stepNumber
      vm.steps.sort(function (a, b) {
        return a.stepNumber - b.stepNumber;
      });

      return step;
    }

    /**
     * Setup steps for the first time
     */
    function setupSteps() {
      vm.setCurrentStep(vm.currentStepNumber);
    }

    /**
     * Reset steps and the main form
     */
    function resetForm() {
      // Timeout is required here because we need to
      // let form model to reset before setting the
      // statuses
      $timeout(function () {
        // Reset all the steps
        for (var x = 0; x < vm.steps.length; x++) {
          vm.steps[x].form.$setPristine();
          vm.steps[x].form.$setUntouched();
        }

        // Reset the main form
        vm.mainForm.$setPristine();
        vm.mainForm.$setUntouched();

        // Go to first step
      });
    }

    /**
     * Set current step
     *
     * @param stepNumber
     */
    function setCurrentStep(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return;
      }

      // Update the current step number
      vm.currentStepNumber = stepNumber;
      StepperService.setStepNumber(stepNumber);
      if (vm.orientation === 'horizontal') {
        // Hide all steps
        for (var i = 0; i < vm.steps.length; i++) {
          vm.steps[i].element.hide();
        }

        // Show the current step
        vm.steps[vm.currentStepNumber - 1].element.show();
      }
      else if (vm.orientation === 'vertical') {
        // Hide all step content
        for (var j = 0; j < vm.steps.length; j++) {
          vm.steps[j].element.find('.ms-custom-stepper-step-content').hide();
        }

        // Show the current step content
        vm.steps[vm.currentStepNumber - 1].element.find('.ms-custom-stepper-step-content').show();
      }
    }

    /**
     * Go to a step
     *
     * @param stepNumber
     */
    function gotoStep(stepNumber) {
      // If the step we are about to go
      // is hidden, bail...
      if (isStepHidden(stepNumber)) {
        return;
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the previous step
     */
    function gotoPreviousStep() {
      var stepNumber = vm.currentStepNumber - 1;

      // Test the previous steps and make sure we
      // will land to the one that is not hidden
      for (var s = stepNumber; s >= 1; s--) {
        if (!isStepHidden(s)) {
          stepNumber = s;
          break;
        }
      }

      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the next step
     */
    function gotoNextStep() {
      var stepNumber = vm.currentStepNumber + 1;

      // Test the following steps and make sure we
      // will land to the one that is not hidden
      for (var s = stepNumber; s <= vm.steps.length; s++) {
        if (!isStepHidden(s)) {
          stepNumber = s;
          break;
        }
      }
      vm.setCurrentStep(stepNumber);
    }

    /**
     * Go to the first step
     */
    function gotoFirstStep() {
      vm.setCurrentStep(1);
    }

    /**
     * Go to the last step
     */
    function gotoLastStep() {
      vm.setCurrentStep(vm.steps.length);
    }

    /**
     * Check if the current step is the first step
     *
     * @returns {boolean}
     */
    function isFirstStep() {
      return vm.currentStepNumber === 1;
    }

    /**
     * Check if the current step is the last step
     *
     * @returns {boolean}
     */
    function isLastStep() {
      return vm.currentStepNumber === vm.steps.length;
    }

    /**
     * Check if the given step is the current one
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepCurrent(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      return vm.currentStepNumber === stepNumber;
    }

    /**
     * Check if the given step should be disabled
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepDisabled(stepNumber) {
      var disabled = false;

      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      for (var i = 1; i < stepNumber; i++) {
        if (!isStepValid(i)) {
          disabled = true;
          break;
        }
      }

      return disabled;
    }

    /**
     * Check if the given step is optional
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepOptional(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      return vm.steps[stepNumber - 1].scope.optionalStep;
    }

    /**
     * Check if the given step is optional
     *
     * @param hasSave
     */
    function hasSave() {
      return !vm.hideSave;
    }

    /**
     * Check if the given step is hidden
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepHidden(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      return !!vm.steps[stepNumber - 1].scope.hideStep;
    }

    /**
     * Check if the given step is hidden as a filter
     *
     * @param step
     * @returns {boolean}
     */
    function filterHiddenStep(step) {
      return !isStepHidden(step.stepNumber);
    }

    /**
     * Check if the given step is valid
     *
     * @param stepNumber
     * @returns {null|boolean}
     */
    function isStepValid(stepNumber) {
      // If the stepNumber is not a valid step number, bail...
      if (!isStepNumberValid(stepNumber)) {
        return null;
      }

      // If the step is optional, always return true
      if (isStepOptional(stepNumber)) {
        return true;
      }

      return vm.steps[stepNumber - 1].form.$valid;
    }

    /**
     * Check if the given step number is a valid step number
     *
     * @param stepNumber
     * @returns {boolean}
     */
    function isStepNumberValid(stepNumber) {
      return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
    }

    /**
     * Check if the entire form is valid
     *
     * @returns {boolean}
     */
    function isFormValid() {
      return vm.mainForm.$valid;
    }
  }

  /** @ngInject */
  function msHorizontalCustomStepperDirective() {
    return {
      restrict: 'A',
      scope: {
        'hideSave': '=?'
      },
      require: ['form', 'msHorizontalCustomStepper'],
      priority: 1001,
      controller: 'MsCustomStepperController as MsStepper',
      bindToController: {
        'ngModel': '=',
      },
      transclude: true,
      templateUrl: 'app/main/directives/ms-custom-stepper/templates/horizontal/horizontal.html',
      compile: function (tElement) {
        tElement.addClass('ms-custom-stepper');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsCustomStepperCtrl = ctrls[1];

          // Register the main form and setup
          // the steps for the first time
          MsCustomStepperCtrl.setOrientation('horizontal');
          MsCustomStepperCtrl.registerMainForm(FormCtrl);
          MsCustomStepperCtrl.setupSteps();
          MsCustomStepperCtrl.hideSave = scope.hideSave;
        };
      }
    };
  }

  /** @ngInject */
  function msHorizontalCustomStepperStepDirective() {
    return {
      restrict: 'E',
      require: ['form', '^msHorizontalCustomStepper'],
      priority: 1000,
      scope: {
        step: '=?',
        stepTitle: '=?',
        stepTitleTranslate: '=?',
        optionalStep: '=?',
        hideStep: '=?'
      },
      compile: function (tElement) {
        tElement.addClass('ms-custom-stepper-step');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsCustomStepperCtrl = ctrls[1];

          // Is it an optional step?
          scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

          // Register the step
          MsCustomStepperCtrl.registerStep(iElement, scope, FormCtrl);

          // Hide the step by default
          iElement.hide();
        };
      }
    };
  }

  /** @ngInject */
  function msVerticalCustomStepperDirective($timeout) {
    return {
      restrict: 'A',
      scope: {
        'hideSave': '=?'
      },
      require: ['form', 'msVerticalCustomStepper'],
      priority: 1001,
      controller: 'MsCustomStepperController as MsStepper',
      bindToController: {
        model: '=ngModel'
      },
      transclude: true,
      templateUrl: 'app/main/directives/ms-custom-stepper/templates/vertical/vertical.html',
      compile: function (tElement) {
        tElement.addClass('ms-custom-stepper');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsCustomStepperCtrl = ctrls[1];

          // Register the main form and setup
          // the steps for the first time

          // Timeout is required in vertical stepper
          // as we are using transclusion in steps.
          // We have to wait for them to be transcluded
          // and registered to the controller
          $timeout(function () {
            MsCustomStepperCtrl.setOrientation('vertical');
            MsCustomStepperCtrl.registerMainForm(FormCtrl);
            MsCustomStepperCtrl.setupSteps();
            MsCustomStepperCtrl.hideSave = scope.hideSave;
          });
        };
      }
    };
  }

  /** @ngInject */
  function msVerticalCustomStepperStepDirective() {
    return {
      restrict: 'E',
      require: ['form', '^msVerticalCustomStepper'],
      priority: 1000,
      scope: {
        step: '=?',
        stepTitle: '=?',
        stepTitleTranslate: '=?',
        optionalStep: '=?',
        hideStep: '=?'
      },
      transclude: true,
      templateUrl: 'app/main/directives/ms-custom-stepper/templates/vertical/step/vertical-step.html',
      compile: function (tElement) {
        tElement.addClass('ms-custom-stepper-step');

        return function postLink(scope, iElement, iAttrs, ctrls) {
          var FormCtrl = ctrls[0],
            MsCustomStepperCtrl = ctrls[1];

          // Is it an optional step?
          scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

          // Register the step
          scope.stepInfo = MsCustomStepperCtrl.registerStep(iElement, scope, FormCtrl);

          // Expose the controller to the scope
          scope.MsStepper = MsCustomStepperCtrl;

          // Hide the step content by default
          iElement.find('.ms-custom-stepper-step-content').hide();
        };
      }
    };
  }
})();
(function() {
  'use strict';

  angular
    .module('app.dashboard.foreman', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.dashboard_foreman', {
      url      : '/foreman',
      views    : {
        'content@app': {
          templateUrl: 'app/main/dashboard/foreman/foreman.html',
          controller : 'ForemanCtrl as vm'
        }
      },
      resolve  : {
        acl: function($q, AclService) {

          if(!AclService.can('foreman')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      },
      bodyClass: 'foreman'
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/dashboard/foreman');

    // Navigation
    msNavigationServiceProvider.saveItem('dashboard.foreman', {
      title : 'Foreman',
      icon  : 'icon-file-document-box',
      state : 'app.dashboard_foreman',
      weight: 1
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.dashboard.foreman')
    .controller('ForemanCtrl', ForemanCtrl);

  /** @ngInject */
  function ForemanCtrl() {}
})();

(function () {
  'use strict';

  angular
    .module('app.admin.seasons-definition', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider) {
    // State
    $stateProvider
      .state('app.admin_seasons-definition', {
        url: '/seasons-definition',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/seasons/seasons.html',
            controller: 'SeasonsCtrl as vm'
          }
        },
        bodyClass: 'admin',
        resolve  : {
          acl: function($q, AclService) {
            if(!AclService.can('seasons_definition')) {
              // Does not have permission
              return $q.reject('unauthorized');
            }
          }
        }
      });

    // Translation for seasons
    $translatePartialLoaderProvider.addPart('app/main/admin/seasons');

  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin.seasons-definition')
    .controller('SeasonsCtrl', SeasonsCtrl);

  /**
   * Controller to handle seasons information
   *
   * @param {[type]} $scope    [description]
   * @param {[type]} $mdToast  [description]
   * @param {[type]} $mdDialog [description]
   */
  function SeasonsCtrl(
    $q,
    $scope,
    $state,
    $translate,
    $mdToast,
    moment,
    msUtils,
    FiscalYearService,
    SeasonsService,
    StepperService
  ) {
    $scope.title = 'Seasons';
    $scope.stepCurrent = 1;
    var toastInstance = {};
    var vm = this;
    vm.seasons = {
      one: {
        id: 1,
        name: '',
        start_day: '',
        end_day: '',
        type: 'one'
      },
      two: {
        id: 2,
        name: '',
        start_day: '',
        end_day: '',
        type: 'two'
      },
      three: {
        id: 3,
        name: '',
        start_day: '',
        end_day: '',
        type: 'three'
      },
      four: {
        id: 4,
        name: '',
        start_day: '',
        end_day: '',
        type: 'four'
      }
    };

    // Methods
    vm.init = init;
    vm.saveSeasons = saveSeasons;
    vm.setData = setData;
    vm.toggleInArray = msUtils.toggleInArray;
    vm.hideToast = hideToast;
    vm.currentStep = currentStep;
    // vm.checkStep = checkStep;
    vm.openForm = openForm;
    vm.titles = titles;
    vm.title = {};
    vm.checkIfValidEndDate = checkIfValidEndDate;

    /**
     * Check Validate end date
     * @param {*} endDate
     */
    function checkIfValidEndDate(endDate) {
      if (!endDate) {
        return false;
      } else {
        return true;
      }
    }
    /* Init function */
    init();

    /**
     * Function to initialize necessary components
     *
     * @return {[type]} [description]
     */
    function init() {
      var currentDate = new Date();
      vm.minDate = new Date(currentDate.getFullYear() -1,'12','01');

      // Call to fiscal year to get current fiscal year start date and set as a date for first season
      FiscalYearService.getFiscalYear(1).then(function(fy) {
        vm.seasons.one.start_day = fy.fiscal_year.begin_date;
      },
      function() {
        // Handle errors
      });

      var seasons = [];
      // Check if exist a seasons (check by ids 1, 2, 3, 4)
      SeasonsService.getList().then(function(res) {
        seasons = res.seasons;
        if(seasons && seasons.length > 0) {
          angular.forEach(seasons, function(ssObj) {
            vm.seasons[ssObj.type].id = ssObj.id;
            vm.seasons[ssObj.type].name = ssObj.name;
            vm.seasons[ssObj.type].start_day = ssObj.start_day;
            vm.seasons[ssObj.type].end_day = ssObj.end_day;
          });
        }
      },
      function(err) {
        console.error(err);
        toastInstance = $mdToast.show({
          template: '<md-toast>\
            The seasons could not be loaded, please try again. ' +
            '<md-button ng-click="hideToast()">X</md-button></md-toast>',
          position: 'top right',
          hideDelay: false,
          controller: 'SeasonsCtrl',
        });
      });
    }
    /**
     * Current Step
     */
    function currentStep() {
      $scope.stepCurrent = StepperService.getStepNumber();
    }
    /**
     * Change in step
     */
    function openForm() {
      currentStep();
      titles();
    }
    /**
     * Titles
     */
    function titles() {
      if ($scope.stepCurrent === 1) {
        vm.title = {
          season: 'Season 1',
          name: vm.seasons.one.name,
          start: vm.seasons.one.start_day,
          end: vm.seasons.one.end_day
        };
      }
      if ($scope.stepCurrent === 2) {
        vm.title = {
          season: 'Season 2',
          name: vm.seasons.two.name,
          start:vm.seasons.two.start_day,
          end: vm.seasons.two.end_day
        };
      }
      if ($scope.stepCurrent === 3) {
        vm.title = {
          season: 'Season 3',
          name: vm.seasons.three.name,
          start: vm.seasons.three.start_day,
          end: vm.seasons.three.end_day
        };
      }
      if ($scope.stepCurrent === 4) {
        vm.title = {
          season: 'Season 4',
          name: vm.seasons.four.name,
          start: vm.seasons.four.start_day,
          end: vm.seasons.four.end_day
        };
      }
      if (isNaN(vm.title.end)) {
        vm.title.end = null;
      }
    }
    /**
     * [saveSeasons description]
     * @return {[type]} [description]
     */
    function saveSeasons() {
      vm.setData();
      var counter = 0;
      var errors = [];
      var fncThen = function(obj) {
        if(obj && obj.success === true) {
          counter++;
        }
      };
      var fncRjct = function(obj) {
        if(obj && obj.success !== true) {
          errors.push(obj);
        }
      };
      $q.all([
        SeasonsService.update(vm.seasons.one.id, vm.seasons.one).then(fncThen, fncRjct),
        SeasonsService.update(vm.seasons.two.id, vm.seasons.two).then(fncThen, fncRjct),
        SeasonsService.update(vm.seasons.three.id, vm.seasons.three).then(fncThen, fncRjct),
        SeasonsService.update(vm.seasons.four.id, vm.seasons.four).then(fncThen, fncRjct)
      ]).then(function(response) {
        if(response && response.length > 0) {
          angular.forEach(response, function(resObj) {
            if(resObj && resObj.hasOwnProperty('season')) {
              var ssObj = resObj.seasons;
              vm.seasons[ssObj.type].id = ssObj.id;
              vm.seasons[ssObj.type].name = ssObj.name;
              vm.seasons[ssObj.type].dates.start = ssObj.begin_date;
              vm.seasons[ssObj.type].dates.end = ssObj.end_date;
            }
          });

          if(counter === 4) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">All information for seasons have been updated successfully.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            }, $state.go($state.current, {}, {reload: true}));
          }
          if(errors.length > 0) {
            var ssn = '';
            angular.forEach(errors, function(obj, key) {
              if(obj && obj.seasons && obj.seasons.name) {
                if(key < 3) {
                  ssn += obj.seasons.name + ', ';
                } else {
                  ssn += obj.seasons.name;
                }
              }
            });
            toastInstance = $mdToast.show({
              template: '<md-toast>\
                The seasons '+ ((ssn)? ssn : '') + ' could not be updated, please try again later. ' +
                '<md-button ng-click="hideToast()">X</md-button></md-toast>',
              position: 'top right',
              hideDelay: false,
              controller: 'FiscalYearCtrl',
            });
          }
        }
      });
    }
    /**
     * [setData description]
     */
    function setData() {
      var season_one_end_day = moment(vm.seasons.two.start_day).subtract(1, 'days');
      var season_two_end_day = moment(vm.seasons.three.start_day).subtract(1, 'days');
      var season_three_end_day = moment(vm.seasons.four.start_day).subtract(1, 'days');
      var season_four_end_day = moment(vm.seasons.one.start_day).subtract(1, 'days').add(1, 'years');

      /* Season one end day equal to 2nd season start day -1 */
      vm.seasons.one.end_day = season_one_end_day.toDate();
      /* Season two end day equal to 3th season start day -1 */
      vm.seasons.two.end_day = season_two_end_day.toDate();
      /* Season three end day equal to 4th season start day -1 */
      vm.seasons.three.end_day = season_three_end_day.toDate();
      /* Season four end day equal to 1st season start day -1 */
      vm.seasons.four.end_day = season_four_end_day.toDate();
    }

    /**
     * [hideToast description]
     * @return {[type]} [description]
     * // TODO: MOVE THIS TO A TOAST CONTROLLER
     */
    function hideToast() {
      $mdToast.hide(toastInstance);
    }
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.modules')
    .controller('ModulesController', ModulesController);

    /** @ngInject */
  function ModulesController($mdSidenav, BoardService, BoardList, CardFilters) {
    var vm = this;

    // Data
    vm.currentView = 'board';
    vm.board = BoardService.data;
    vm.boardList = BoardList.data;
    vm.boardSelectorVisible = false;

    // Methods
    vm.toggleSidenav = toggleSidenav;
    vm.updateBoardUri = updateBoardUri;
    vm.clearFilters = CardFilters.clear;
    vm.filteringIsOn = CardFilters.isOn;

    /**
     * Update Board Uri
     *
     * Once you connect your app to your server,
     * you would do this on your API server.
     */
    function updateBoardUri() {
      if (vm.boardList.getById(vm.board.id)) {
        vm.boardList.getById(vm.board.id).name = vm.board.name;
        vm.boardList.getById(vm.board.id).uri = vm.board.uri = encodeURIComponent(vm.board.name).replace(/%20/g, '-').toLowerCase();
      }
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Array prototype
     *
     * Get by id
     *
     * @param value
     * @returns {T}
     */
    Array.prototype.getById = function (value) {
      return this.filter(function (x) {
        return x.id === value;
      })[0];
    };
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin.land-reference-names', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.admin_land-reference-names', {
        url: '/land-reference',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/land-reference/land-reference.html',
            controller: 'LandReferenceCtrl as vm'
          }
        },
        bodyClass: 'admin',
        resolve  : {
          acl: function($q, AclService) {
            if(!AclService.can('land_reference_names')) {
              // Does not have permission
              return $q.reject('unauthorized');
            }
          }
        }

      });

    // Translation for land references
    $translatePartialLoaderProvider.addPart('app/main/admin/land-reference');

    msNavigationServiceProvider.saveItem('admin.land-reference-names', {
      title: 'Land Reference Names',
      icon : 'icon-routes',
      state: 'app.admin_land-reference-names',
      weight: 36
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin.land-reference-names')
    .controller('LandReferenceCtrl', LandReferenceCtrl);

  /**
   * Controller to handle land references names information
   *
   * @param {[type]} $scope    [description]
   * @param {[type]} $mdToast  [description]
   * @param {[type]} $mdDialog [description]
   */
  function LandReferenceCtrl(
    $q,
    $scope,
    $state,
    $translate,
    $location,
    $mdToast,
    moment,
    msUtils,
    FarmService,
    api
  ) {

    $scope.title              = 'Land Reference Names';
    var toastInstance         = {};
    var vm                    = this;

    api.farms.get({ id: 1 }, function(FarmData) {
      if(FarmData && FarmData.farm) {
        vm.land_ref           = FarmData.farm;
      }
      else {
        vm.land_ref = {
          farm_company_id:          1,
          ranch_reference_name:    '',
          area_reference_name:     '',
          location_reference_name: '',
          section_reference_name:  '',
          block_reference_name:    ''
        };
      }
    },
    function(err) {
      console.error(err);
    });




    // Methods
    vm.init                 = init;
    vm.saveLandReference    = saveLandReference;
    vm.toggleInArray        = msUtils.toggleInArray;
    vm.hideToast            = hideToast;

    /* Init function */
    init();

    /**
     * Function to initialize necessary components
     *
     * @return {[type]} [description]
     */
    function init() {
      FarmService.getFarm(1).then(function(FarmLandRefData) {
        vm.land_ref = FarmLandRefData.farm;
      },
      function(err) {
        console.error(err);
      });
    }

    /**
     * Function to save land reference names (harcoded to id = 1)
     * @return {[type]} [description]
     */
    function saveLandReference() {
      vm.land_ref.farm_company_id = 1;
      FarmService.update(1, vm.land_ref).then(function(data) {
        $mdToast.show({
          template: '<md-toast class="md-toast success">All information for Land Reference has been updated.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        }),
        vm.land_ref = data.farm;
      },
      function(err) { //reject
        var error;
        if(err.status !== 500) {
          error = err.data.message;
        }
        $mdToast.show({
          template: '<md-toast class="md-toast error">The Land reference names could not be saved. ' + ((error !== undefined)? error : '') + '</md-toast>',
          position: 'top right',
          hideDelay: 6000,
          controller: 'FiscalYearCtrl',
        });
      });
    }

    /**
     * [hideToast description]
     * @return {[type]} [description]
     * // TODO: MOVE THIS TO A TOAST CONTROLLER
     */
    function hideToast() {
      $mdToast.hide(toastInstance);
    }

  }

})();

(function () {
  'use strict';

  angular
    .module('app.admin.growing-seasons-definition', [])
    .config(config);

  /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider
      .state('app.admin_growing-seasons-definition', {
        url: '/growing-seasons-definition',
        views: {
          'content@app': {
            templateUrl: 'app/main/admin/growing-seasons-definition/growing-seasons-definition.html',
            controller: 'GrowingSeasonsDefinitionCtrl as vm'
          }
        },
        bodyClass: 'admin',
        resolve  : {
          acl: function($q, AclService) {
            if(!AclService.can('growing_seasons_definition')) {
              // Does not have permission
              return $q.reject('unauthorized');
            }
          }
        }
      });

    // Translation for fiscal year
    $translatePartialLoaderProvider.addPart('app/main/admin/growing-seasons-definition');

    // Navigation
    msNavigationServiceProvider.saveItem('admin.growing-seasons-definition', {
      title: 'Growing Seasons Definition',
      icon : 'icon-calendar-check-multiple',
      state: 'app.admin_growing-seasons-definition',
      weight: 34
    });
  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin.growing-seasons-definition')
    .controller('GrowingSeasonsDefinitionCtrl', GrowingSeasonsDefinitionCtrl);

  /**
   * Controller to handle fiscal year information
   *
   * @param {[type]} $scope     [description]
   * @param {[type]} $translate [description]
   */
  function GrowingSeasonsDefinitionCtrl(
    $q,
    $scope,
    $state,
    $translate,
    $location,
    moment,
    msUtils,
    $mdToast,
    FiscalYearService,
    _,
    $mdDialog,
    $document,
    api
  ) {

    var vm                = this;
    var toastInstance     = {};
    $scope.title          = 'Growing Seasons Definition';
    vm.isAdmin            = true;
    vm.growingYears       = [];

    // Methods
    vm.init                      = init;
    vm.addGrowingSeasonDialog    = addGrowingSeasonDialog;
    vm.saveFiscalYears           = saveFiscalYears;
    vm.toggleInArray             = msUtils.toggleInArray;
    vm.calculateFiscalYears      = calculateFiscalYears;
    vm.mapObject                 = mapObject;
    vm.hideToast                 = hideToast;
    vm.deleteGrowingYear         = deleteGrowingYear;

    /* Init function */
    init();

    /**
     * Function to initialize necessary components
     *
     * @return {[type]} [description]
     */
    function init() {
      api.fiscal_years.get(function(FiscalYearsData) {
        vm.growingYears  = FiscalYearsData.fiscal_years;
      });

    }

    /**
     * [addGrowingSeasonDialog description]
     * @param {[type]} ev            [description]
     * @param {[type]} growingSeason [description]
     * @param {[type]} avoidClone    [description]
     */
    function addGrowingSeasonDialog(ev, growingYear, avoidClone) {
      if (!avoidClone) {
        vm.growingYearClone = _.cloneDeep(growingYear);
        vm.adminClone = _.cloneDeep($scope.admin);
        vm.selectedGrowingYear = growingYear;
      }
      $mdDialog.show({
        controller: 'GrowingYearDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/main/admin/growing-seasons-definition/dialogs/growing-year-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            addGrowingYearDialog: vm.addGrowingYearDialog,
            admin: vm.adminClone,
            growingYears: vm.growingYears,
            growingYear: vm.growingYearClone,
            dialogType: 'add',
            ev: ev
          }
        }
      })
      .finally(function() {
        if (vm.growingYearClone.save) {
          vm.growingYearClone.save = null;
          _.assign(vm.selectedGrowingYear, vm.growingYearClone);
        }
      });
    }

    /**
     * [saveFiscalYears description]
     * @return {[type]} [description]
     */
    function saveFiscalYears() {
      vm.calculateFiscalYears();
      var counter = 0;
      var errors = [];
      var fncThen = function(obj) {
        if(obj && obj.success === true) {
          counter++;
        }
      };
      var fncRjct = function(obj) {
        if(obj && obj.success !== true) {
          errors.push(obj);
        }
      };
      $q.all([
        FiscalYearService.update(vm.fiscal.current.id, vm.mapObject(vm.fiscal.current, 'current')).then(fncThen, fncRjct),
        FiscalYearService.update(vm.fiscal.last.id, vm.mapObject(vm.fiscal.last, 'last')).then(fncThen, fncRjct),
        FiscalYearService.update(vm.fiscal.next.id, vm.mapObject(vm.fiscal.next, 'next')).then(fncThen, fncRjct)
      ]).then(function(response) {
        if(response && response.length > 0) {
          angular.forEach(response, function(resObj) {
            if(resObj && resObj.hasOwnProperty('fiscal_year')) {
              var fyObj = resObj.fiscal_year;
              if(fyObj.type === 'current') { // Set start date based on current year.
                vm.fiscal.start_date = fyObj.begin_date;
              }
              vm.fiscal[fyObj.type].id = fyObj.id;
              vm.fiscal[fyObj.type].name = fyObj.name;
              vm.fiscal[fyObj.type].dates.start = fyObj.begin_date;
              vm.fiscal[fyObj.type].dates.end = fyObj.end_date;
            }
          });

          if(counter === 3) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">All information for fiscal years been updated successfully.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
          }
          if(errors.length > 0) {
            var fyn = '';
            angular.forEach(errors, function(obj, key) {
              if(obj && obj.fiscal_year && obj.fiscal_year.name) {
                if(key < 2) {
                  fyn += obj.fiscal_year.name + ', ';
                } else {
                  fyn += obj.fiscal_year.name;
                }
              }
            });
            toastInstance = $mdToast.show({
              template: '<md-toast class="md-toast error">\
                The fiscal years '+ ((fyn)? fyn : '') + ' could not be updated, please try again later. ' +
                '<md-button ng-click="hideToast()">X</md-button></md-toast>',
              position: 'top right',
              hideDelay: false,
              controller: 'FiscalYearCtrl',
            });
          }
        }
      });
    }

    /**
     * Function to calculate current, last & next fiscal years.
     * @return {[type]} [description]
     */
    function calculateFiscalYears() {
      if(typeof vm.fiscal.start_date !== 'moment') {
        vm.fiscal.start_date = moment(vm.fiscal.start_date);
      }
      /* Current year end date */
      var current_end_date = moment(vm.fiscal.start_date).add(364, 'days');
      /* Last year start date */
      var last_start_date = moment(vm.fiscal.start_date).subtract(1, 'year');
      /* Last year end date */
      var last_end_date = moment(vm.fiscal.start_date).subtract(1, 'days');
      /* Next year start date */
      var next_start_date = moment(vm.fiscal.start_date).add(1, 'year');
      /* Next year end date */
      var next_end_date = moment(vm.fiscal.start_date).add(2, 'year').subtract(1, 'days');

      /* Calculate current fiscal year */
      vm.fiscal.current.dates.start = vm.fiscal.start_date.toDate();
      vm.fiscal.current.dates.end = current_end_date.toDate();

      /* Calculate last fiscal year */
      vm.fiscal.last.dates.start = last_start_date.toDate();
      vm.fiscal.last.dates.end = last_end_date.toDate();

      /* Calculate next fiscal year */
      vm.fiscal.next.dates.start = next_start_date.toDate();
      vm.fiscal.next.dates.end = next_end_date.toDate();
    }
    /**
     * [mapObject description]
     * @return {[type]} [description]
     */
    function mapObject(objToMap, type) {
      var mappedObj = {
        id: objToMap.id,
        name: objToMap.name,
        begin_date: moment(objToMap.dates.start).toISOString(),
        end_date: moment(objToMap.dates.end).toISOString(),
        type: type,
        display_on_home_page: false
      };

      return mappedObj;
    }

    /**
     * [hideToast description]
     * @return {[type]} [description]
     * // TODO: MOVE THIS TO A TOAST CONTROLLER
     */
    function hideToast() {
      $mdToast.hide(toastInstance);
    }



    /**
     * [deleteGrowingYear description]
     * @param  {[type]} ev          [description]
     * @param  {[type]} growingYear [description]
     * @return {[type]}             [description]
     */
    function deleteGrowingYear(ev, growingYear) {
      var confirm = $mdDialog.confirm()
      .title($translate.instant('GROWING_SEASONS.ARE_YOU_SURE_TO_DELETE'))
      .htmlContent('The growing year <b>' + growingYear.name + '</b>' + ' will be deleted.')
      .ariaLabel('delete growing year')
      .targetEvent(ev)
      .ok('OK')
      .cancel('CANCEL');

      $mdDialog.show(confirm).then(function () {
        FiscalYearService.delete(growingYear.id).then(function () {
          $mdToast.show({
            template: '<md-toast class="md-toast success">The growing year ' + growingYear.name + ' were deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
          vm.growingYears.splice(vm.growingYears.indexOf(growingYear), 1);

        },
        function () {
          $mdToast.show({
            template: '<md-toast class="md-toast error">The growing year ' + growingYear.name + ' could not be deleted.</md-toast>',
            position: 'top right',
            hideDelay: 4500
          });
        });
      },
      function () {
        // avoid unhandled rejection message.
      });
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.admin.cronjobs', [
      // 3rd Party Dependencies
      'xeditable',
      'ms-infinite-scroll',
      'vAccordion',
      'ngAnimate',
      'ms-resize'
    ])
    .config(config);

    /** @ngInject */
  function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider) {
    // State
    $stateProvider.state('app.admin_cronjobs', {
      url      : '/cronjobs/:id',
      views    : {
        'content@app': {
          templateUrl: 'app/main/admin/cronjobs/cronjobs.html',
          controller : 'CronjobsCtrl as vm'
        }
      },
      bodyClass: 'cronjobs',
      resolve  : {
        acl: function($q, AclService) {
          if(!AclService.can('cronjobs')) {
            // Does not have permission
            return $q.reject('unauthorized');
          }
        }
      }
    });

    // Translation
    $translatePartialLoaderProvider.addPart('app/main/admin/cronjobs');

    // Navigation
    msNavigationServiceProvider.saveItem('admin.cronjobs', {
      title : 'Cronjobs',
      icon  : 'icon-alarm',
      state : 'app.admin_cronjobs',
      weight: 40
    });
  }

})();

(function () {
  'use strict';

  angular
  .module('app.admin.cronjobs')
  .controller('CronjobsCtrl', CronjobsCtrl);

  /** @ngInject */
  function CronjobsCtrl(
    $scope,
    $mdToast,
    CronjobService
  ) {

    var vm = this;

    // Methods
    vm.executeCron = executeCron;

    init();

    /**
     * Initialization function
     * 
     * @return {[type]} [description]
     */
    function init() {
      $scope.loadingData = true;
      CronjobService.getList().then(function(cronData) {
        vm.cronjobs = cronData.cronjobs;
        $scope.loadingData = false;
      },
      function(err) {
        console.error(err);
      });
    }

    /**
     * Function to force cron execution, only if cron is still "pending" of execution.
     * 
     * @return {[type]} [description]
     */
    function executeCron(cronjob, i) {
      CronjobService.forceCronjob(cronjob.name).then(function(data) {
        var message = '';
        if(data && data.message) {
          message = data.message;
        } else {
          message = 'Cronjob executed.';
        }
        $mdToast.show({
          template: '<md-toast class="md-toast success">'+ message +'.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
        vm.cronjobs[i] = data.cronjob;
      },
      function(err) {
        console.error(err);
        $mdToast.show({
          template: '<md-toast class="md-toast error">There was an error running cronjobs, please check the error looking at motive field.</md-toast>',
          position: 'top right',
          hideDelay: 4500
        });
      });
      
    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {
                shortcuts = [
                    {
                        'title'      : 'Sample',
                        'icon'       : 'icon-tile-four',
                        'state'      : 'app.sample',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'sample',
                        '_path'      : 'apps.sample',
                        'uisref'     : 'app.sample',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }
            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists            : exists,
            detectBrowser     : detectBrowser,
            guidGenerator     : guidGenerator,
            isMobile          : isMobile,
            toggleInArray     : toggleInArray,
            parseMoneyAsNumber: parseMoneyAsNumber
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            if(!list){
                return false;
            }
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }

        /**
         * Function to parse money as number
         * @param  {[type]} value [description]
         * @return {[type]}
         */
        function parseMoneyAsNumber(value)
        {
          if (value) {
            value = value.replace('$', '');
            if (value.match(',')) {
              var comma = value.match(',').length;
              for (var i = 0; i<=comma; i++) {
                value = value.replace(',', '');
              }
            }
            return parseFloat(value);
          }
        }
    }
}());

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        //////////

        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');
                
                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');
                            
                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');
                            
                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('numberFilter', numberFilter);

    /** @ngInject */
    function numberFilter($filter)
    {
        return function (value, fractionSize)
        {
            var decimals = 2;

            if (fractionSize !== undefined && fractionSize !== null && typeof fractionSize === 'number') {
              decimals = fractionSize;
            }

            if (typeof value === 'string') {
              value = parseFloat(value);
            }

            value = $filter('number')(value, decimals);

            return value;
        };
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {
            if(!ids || !items){
                return items;
            }

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function () {
  'use strict';

  angular
    .module('app.toolbar', [
      'angular.img',
      'app.toolbar.dialogs',
      'app.toolbar.dialogs-profile',
    ])
    .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider) {
    $translatePartialLoaderProvider.addPart('app/toolbar');
  }
})();

(function () {
  'use strict';

  angular
    .module('app.toolbar')
    .controller('ToolbarController', ToolbarController);

  /** @ngInject */
  function ToolbarController(
    $rootScope,
    $q,
    $http,
    $state,
    $location,
    $timeout,
    apiResolver,
    $mdDialog,
    $document,
    $mdSidenav,
    $translate,
    $mdToast,
    AreaService,
    UserService,
    RoleService,
    NotifyGroupService,
    FiscalYearService,
    AreaFiscalYearService,
    msNavigationService,
    AclService,
    $window,
    $scope,
    api
   ) {
    var vm = this;
    var _ = window._;
    var toastInstance = {};
    var dataToPost = {
      area_id: 1,
      fiscal_year_id: null
    };
    vm.user = null;

    // Data
    $rootScope.global = {
      search: ''
    };

    vm.areas = [];
    vm.fiscalYears = [];
    vm.areaFiscalYear = {
      area: {
        id: '',
        name: ''
      },
      fiscal_year: {
        id: '',
        begin_date: '',
        end_date: ''
      }
    };

    vm.bodyEl = angular.element('body');
    vm.userStatusOptions = [
      {
        'title': 'Online',
        'icon': 'icon-checkbox-marked-circle',
        'color': '#4CAF50'
      },
      {
        'title': 'Away',
        'icon': 'icon-clock',
        'color': '#FFC107'
      },
      {
        'title': 'Do not disturb',
        'icon': 'icon-minus-circle',
        'color': '#F44336'
      },
      {
        'title': 'Invisible',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#BDBDBD'
      },
      {
        'title': 'Offline',
        'icon': 'icon-checkbox-blank-circle-outline',
        'color': '#616161'
      }
    ];
    vm.languages = {
      en: {
        'title': 'English',
        'translation': 'TOOLBAR.ENGLISH',
        'code': 'en',
        'flag': 'us'
      },
      es: {
        'title': 'Español',
        'translation': 'TOOLBAR.SPANISH',
        'code': 'es',
        'flag': 'mx'
      }
    };

    // Methods
    vm.init = init;
    vm.toggleSidenav = toggleSidenav;
    vm.logout = logout;
    vm.changeLanguage = changeLanguage;
    vm.setUserStatus = setUserStatus;
    vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.search = search;
    vm.searchResultClick = searchResultClick;
    vm.areaFiscalYearDialog = areaFiscalYearDialog;
    vm.editUserDialog = editUserDialog;
    vm.hideToast = hideToast;
    vm.changeStatus = changeStatus;
    vm.redirectToLogin = redirectToLogin;

    var user = UserService.getLocalUser();

    vm.roles = user.roles;
    var userLocal = vm.roles.findIndex(function (i) {
      return i.name.toLowerCase() === 'super_user';
    }) >= 0;
    // Set default avatar
    if (user !== undefined && user !== null) {
      if(!user.image_url) {
        user.image_url = 'assets/images/avatars/profile.jpg';
      }
      vm.user = user;
    }
    if (vm.userOnline !== undefined && vm.userOnline !== null) {
      if(!vm.userOnline.avatar) {
        vm.userOnline.avatar = 'assets/images/avatars/profile.jpg';
      }
      vm.user = vm.userOnline;
      vm.user.notify_groups = [];
    }
    init();

    /**
     * Initialize
     */
    function init() {
      // Select the first status as a default
      vm.userStatus = vm.userStatusOptions[0];
      /**
       * Check user local in data base
       */
      UserService.getUser(user.id).then(function(userData) {
        vm.user = userData.user;
        if (vm.myUserUpdate) {
          if (vm.user.id === vm.myUserUpdate.id) {
            vm.user.image_url = vm.myUserUpdate.image_url;
          }
        }
        UserService.patch(vm.user.id, {online_status: vm.userStatus.title}).then(function () {});
        var userOnlineDataBase = userData.user.roles.findIndex(function (i) {
          return i.name.toLowerCase() === 'super user';
        }) >= 0;
        if (userLocal && userOnlineDataBase) {
          $scope.admin = true;
        }
        /**
         * Add notify groups for validation
         */
        vm.user.ng = [];
        if (vm.user.notify_groups) {
          vm.user.notify_groups.forEach(function (ng) {
            vm.user.ng.push(ng.id);
          });
        }
        /**
         * Add roles for validation
         */
        vm.user.r = [];
        vm.user.roles.forEach(function (r) {
          vm.user.r.push(r.id);
        });
        var condition = {};
        if ($scope.admin === false) {
          condition = {except: 10};
        }
        api.roles.get(condition, function (RolesData) {
          vm.allRolesGroups = RolesData.roles;
        },
        function (err) {
          console.error(err);
        });
        /**
         * Users notify group from API
         */
        api.notify_groups.get({}, function (NotifyGroupsData) {
          vm.allNotifyGroups = NotifyGroupsData.notify_groups;
        },
        function (err) {
          console.error(err);
        });
      });

      // Get the selected language directly from angular-translate module setting
      vm.selectedLanguage = vm.languages[$translate.preferredLanguage()];

      $q.all([
        AreaService.getList(),
        FiscalYearService.getList()
      ]).then(function (resources) {
        resources.forEach(function (resource) {
          if (resource && resource.areas) {
            vm.areas = resource.areas;
          }
          if (resource && resource.fiscal_years) {
            vm.fiscalYears = resource.fiscal_years;
            vm.fiscalYears.forEach(function (fy) {
              if (fy.type === 'current') {
                dataToPost.fiscal_year_id = fy.id;
              }
            });
          }
        });
        /* Load global settings Area & Fiscal Year */
        if (vm.user && vm.user.default_global_area_fiscal_year_id) {
          AreaFiscalYearService.getAreaFiscalYear(vm.user.default_global_area_fiscal_year_id).then(function (areaFiscalYearInfo) {
            vm.areaFiscalYear = {
              area: {
                id: areaFiscalYearInfo.area_fiscal_year.area.id,
                name: areaFiscalYearInfo.area_fiscal_year.area.name
              },
              fiscal_year: {
                id: areaFiscalYearInfo.area_fiscal_year.fiscal_year.id,
                name: areaFiscalYearInfo.area_fiscal_year.fiscal_year.name,
                begin_date: areaFiscalYearInfo.area_fiscal_year.fiscal_year.begin_date,
                end_date: areaFiscalYearInfo.area_fiscal_year.fiscal_year.end_date
              }
            };
          },
            function () {
              toastInstance = $mdToast.show({
                template: '<md-toast class="md-toast error">\
                The global settings could not be loaded, please try again later. ' +
                '<md-button ng-click="vm.hideToast()">X</md-button></md-toast>',
                position: 'top right',
                hideDelay: false,
                controller: 'ToolbarController',
              });
            });
        } else {
          /* Set default global area & fiscal year current if there's no previous selection for this user */
          UserService.setGlobalAreaFiscalYear(dataToPost).then(function (data) {
            $mdToast.show({
              template: '<md-toast class="md-toast success">' + data.message + '.</md-toast>',
              position: 'top right',
              hideDelay: 4500
            });
            var user = UserService.getLocalUser();
            if (data.user) {
              user.default_global_area_fiscal_year = data.user.default_global_area_fiscal_year_id;
              UserService.saveLocalUser(user);
            }
          },
          function () {
            toastInstance = $mdToast.show({
              template: '<md-toast class="md-toast error">\
              The global settings could not be saved, please try again later. ' +
              '<md-button ng-click="vm.hideToast()">X</md-button></md-toast>',
              position: 'top right',
              hideDelay: false,
              controller: 'AreaFiscalYearDialogController',
            });
          });
        }
      });
    }
    /**
     * Method that will updated user online in toolbar by list
     */
    $scope.$on('updateUserOnlineToolbar', function() {
      vm.user = UserService.getLocalUser();
    });
    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      $mdSidenav(sidenavId).toggle();
    }

    /**
     * Sets User Status
     * @param status
     */
    function setUserStatus(status) {
      vm.userStatus = status;
      UserService.patch(vm.user.id, {online_status: status.title}).then(function () {
      });
    }

    /**
     * Change an offline
     */
    function changeStatus() {
      vm.userStatus = vm.userStatusOptions[4];
      UserService.patch(vm.user.id, {online_status: vm.userStatus.title}).then(function () {
        vm.logout();
      },
      function (err) {
        console.error(err);
        vm.logout();
      });
    }
    /**
     * Go to Login page. It's called for change login background
     * @return {[type]} [description]
     */
    function redirectToLogin() {
      $location.url('/login');
    }

    /**
     * Logout Function
     */
    function logout() {
      sessionStorage.removeItem('user');
      localStorage.removeItem('user');
      localStorage.removeItem('user_access_token');
      localStorage.removeItem('user_refresh_token');
      localStorage.removeItem('pages');
      localStorage.removeItem('menuset');
      AclService.flushStorage();
      $state.go('app.pages_auth_login', {}, { reload: true});
      setTimeout(function() { // This is in order to get all menu items refreshed. (this is a Fuse issue)
        $window.location.reload();
      });
    }

    /**
     * Change Language
     */
    function changeLanguage(lang) {
      vm.selectedLanguage = lang;

      /**
       * Show temporary message if user selects a language other than English
       *
       * angular-translate module will try to load language specific json files
       * as soon as you change the language. And because we don't have them, there
       * will be a lot of errors in the page potentially breaking couple functions
       * of the template.
       *
       * To prevent that from happening, we added a simple "return;" statement at the
       * end of this if block. If you have all the translation files, remove this if
       * block and the translations should work without any problems.
       */
      if (lang.code !== 'en') {
        var message = 'Fuse supports translations through angular-translate module, but currently we do not have any translations other than English language. If you want to help us, send us a message through ThemeForest profile page.';
        $mdToast.show({
          template: '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
          hideDelay: 7000,
          position: 'top right',
          parent: '#content'
        });
        return;
      }
      // Change the language
      $translate.use(lang.code);
    }

    /**
     * Toggle horizontal mobile menu
     */
    function toggleHorizontalMobileMenu() {
      vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
    }

    /**
     * Toggle msNavigation folded
     */
    function toggleMsNavigationFolded() {
      msNavigationService.toggleFolded();
    }

    /**
     * Search action
     *
     * @param query
     * @returns {Promise}
     */
    function search(query) {
      var navigation = [],
        flatNavigation = msNavigationService.getFlatNavigation(),
        deferred = $q.defer();

      // Iterate through the navigation array and
      // make sure it doesn't have any groups or
      // none ui-sref items
      for (var x = 0; x < flatNavigation.length; x++) {
        if (flatNavigation[x].uisref) {
          navigation.push(flatNavigation[x]);
        }
      }

      // If there is a query, filter the navigation;
      // otherwise we will return the entire navigation
      // list. Not exactly a good thing to do but it's
      // for demo purposes.
      if (query) {
        navigation = navigation.filter(function (item) {
          if (angular.lowercase(item.title).search(angular.lowercase(query)) > -1) {
            return true;
          }
        });
      }

      // Fake service delay
      $timeout(function () {
        deferred.resolve(navigation);
      }, 1000);

      return deferred.promise;
    }

    /**
     * Search result click action
     *
     * @param item
     */
    function searchResultClick(item) {
      // If item has a link
      if (item.uisref) {
        // If there are state params,
        // use them...
        if (item.stateParams) {
          $state.go(item.state, item.stateParams);
        }
        else {
          $state.go(item.state);
        }
      }
    }

    /**
     * Function to handle the behavior of add/edit an user.
     */
    function areaFiscalYearDialog(ev) {
      $mdDialog.show({
        controller: 'AreaFiscalYearDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/toolbar/dialogs/area-fiscal-year/area-fiscal-year-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          areaFiscalYear: vm.areaFiscalYear,
          areas: vm.areas,
          fiscalYears: vm.fiscalYears,
          parentInit: vm.init
        }
      });
    }
    /**
     * Dialog for edit user profile.
     */
    function editUserDialog(ev, user, avoidClone) {
      if (!avoidClone) {
        vm.userClone = _.cloneDeep(vm.user);
        vm.adminClone = _.cloneDeep($scope.admin);
      }

      $mdDialog.show({
        controller: 'EditProfileDialogController',
        controllerAs: 'vm',
        templateUrl: 'app/toolbar/dialogs/user/edit-dialog.html',
        parent: angular.element($document.body),
        targetEvent: ev,
        clickOutsideToClose: true,
        locals: {
          dialogData: {
            allNotifyGroups: vm.allNotifyGroups,
            allRolesGroups: vm.allRolesGroups,
            patchNotifyGroup: vm.patchNotifyGroup,
            patchRoleGroup: vm.patchRoleGroup,
            addUserDialog: vm.editUserDialog,
            ev: ev,
            admin: vm.user.roles.findIndex(function (i) {
              return i.name.toLowerCase() === 'super_user';
            }) >= 0,
            user: vm.userClone,
            dialogType: 'add'
          }
        }
      })
      .finally(function() {
        if (vm.userClone.save) {
          vm.userClone.save = null;
          _.assign(vm.user, vm.userClone);
          vm.user.image_url = vm.userClone.image_url;
        }
      });
    }

    /**
     * [hideToast description]
     * @return {[type]} [description]
     * // TODO: MOVE THIS TO A TOAST CONTROLLER
     */
    function hideToast() {
      $mdToast.hide(toastInstance);
    }

  }
})();

(function ()
{
  'use strict';

  angular
      .module('app.theme-panel', [])
      .config(config);

  /** @ngInject */
  function config($translatePartialLoaderProvider)
  {
    // Translation
    $translatePartialLoaderProvider.addPart('app/theme-panel');

  }
})();

(function () {
  'use strict';

  angular
    .module('app.theme-panel')
    .controller('ThemePanelController', ThemePanelController);

  /** @ngInject */
  function ThemePanelController() {
    // Data
  }
})();

(function () {
  'use strict';

  angular
    .module('app.quick-panel')
    .controller('QuickPanelController', QuickPanelController);

  /** @ngInject */
  function QuickPanelController(msApi) {
    var vm = this;
    // Data
    vm.date = new Date();
    vm.settings = {
        notify: true,
        cloud : false,
        retro : true
    };
  }
})();
(function () {
  'use strict';

  angular
    .module('app.navigation', ['ms-load-image'])
    .config(config);

  /** @ngInject */
  function config() {

  }

})();

(function () {
  'use strict';

  angular
    .module('app.navigation')
    .controller('NavigationController', NavigationController);

  /** @ngInject */
  function NavigationController(
    $scope,
    CompanyService
  ) {
    var vm = this;
    vm.company = null;

    // Data
    vm.bodyEl = angular.element('body');
    vm.folded = true;
    vm.msScrollOptions = {
      suppressScrollX: true
    };

    // Methods
    vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
    vm.init = init;

    init();

    /**
     * [init description]
     * @return {[type]} [description]
     */
    function init() {
      CompanyService.getCompany(1).then(function(cData) {
        vm.company = cData.company;
      });
    }

    //////////

    /**
     * Toggle folded status
     */
    function toggleMsNavigationFolded()
    {
      vm.folded = !vm.folded;
    }

    // Close the mobile menu on $stateChangeSuccess
    $scope.$on('$stateChangeSuccess', function ()
    {
      vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
    });
  }
})();

(function() {
  'use strict';

/**
 * Main module of the Fuse
 */
  angular
    .module('fuse', [
      // Environment
      'environment',
      // ACL Management
      'mm.acl',
      // NgStorage
      'ngStorage',
      // Core
      'app.core',
      // Shared
      'app.directives',
      // Navigation
      'app.navigation',
      // Toolbar
      'app.toolbar',
      // Quick Panel
      'app.quick-panel',
      // Theme Panel
      'app.theme-panel',
      // Dashboard
      'app.dashboard',
      // Growing
      'app.growing',
      // Farm Admin
      'app.farm-admin',
      // Pages
      'app.pages',
      // Admin
      'app.admin',
      // Services
      'app.services',
      // Material Datepicker
      'ngMaterialDatePicker'
    ]).config(config);

  /**
   * Main config function
   *
   * @param  {[type]} msApiProvider [description]
   * @return {[type]}               [description]
   */
  function config(msApiProvider) {
    // Countries
    msApiProvider.register('countries', ['/assets/countries/countries.min.js']);
    // States
    msApiProvider.register('states', ['/assets/states/states.min.js']);
    // Menu navigation data
    msApiProvider.register('menuNavigationData', ['/assets/menu/menu-map.js']);
    // Mime Types
    msApiProvider.register('mimeTypes', ['/assets/mime-types/mime.js']);
    // Environment configurations
    msApiProvider.register('environment', ['/env.js']);
  }
})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .controller('MainController', MainController);

  /** @ngInject */
  function MainController($scope, $rootScope) {
    // Data

    //////////

    // Remove the splash screen
    $scope.$on('$viewContentAnimationEnded', function(event) {
      if (event.targetScope.$id === $scope.$id) {
        $rootScope.$broadcast('msSplashScreen::remove');
      }
    });
  }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function() {
  'use strict';

  angular
    .module('fuse')
    .run(runBlock);

  /** @ngInject */
  function runBlock(
    $location,
    $rootScope,
    $timeout,
    $state,
    $mdToast,
    envService,
    msApi,
    $sessionStorage,
    $window,
    ModuleService,
    AclService,
    AuthService,
    UserService,
    GanttColumnsManager
  ) {
    if(!AclService.resume()) {
      $rootScope.modulesMap = {};
      ModuleService.getList().then(function(data) {
        data.modules.forEach(function(module) {
          // First create role user top map
          var rolesInScope = [];
          var roleNewCase = '';
          module.module_access.forEach(function(module_access) {
            // Avoid issues with roles names, normalize instead.
            roleNewCase = module_access.user_role.name.replace(/ /g, '_');
            roleNewCase = roleNewCase.toLowerCase();
            rolesInScope.push(roleNewCase);
            if(!$rootScope.modulesMap.hasOwnProperty([roleNewCase])) {
              $rootScope.modulesMap[roleNewCase] = [];
            }
          });
          // Then add pages when that user role can access
          rolesInScope.forEach(function(role) {
            module.pages.forEach(function(page) {
              if($rootScope.modulesMap[role].indexOf(page.name) === -1) {
                $rootScope.modulesMap[role].push(page.name);
              }
            });
          });
        });
        AclService.setAbilities($rootScope.modulesMap);
      },
      function(err) {
        console.error(err);
      });
    }

    // If the route change failed due to our "Unauthorized" error, redirect them
    $rootScope.$on('$stateChangeError', function(event, toState, toParams, fromState, fromParams, error) {
      //try again once:
      if($location.url().indexOf('login') === -1) {
        // wait for roles to be loaded
        AuthService.addRoles().then(function() {
          setTimeout(function() {
            if($rootScope.referrerUrl) {
              var entityName = $rootScope.referrerUrl.split('/');
              if(!entityName[1].isNAN) {
                entityName = $location.url().split('/');
              }
              var section = entityName[1].replace('/', '').replace('-', '_');
            }
            if(section && !AclService.can(section)) {
              if(error == 'unauthorized') {
                $mdToast.show({
                  template: '<md-toast class="md-toast error">You do not have right permissions to access to this area.</md-toast>',
                  position: 'top right',
                  hideDelay: 6500
                });
                setTimeout(function() {
                  $location.path('/error-401');
                });
              }
            } else {
              setTimeout(function() {
                if($rootScope.referrerUrl && $rootScope.referrerUrl.indexOf('login') === -1) {
                  $location.path($rootScope.referrerUrl);
                }
                $window.location.reload();
              });
            }
          }, 500);
        }, function(rejection) {
          console.error(rejection);
          $location.path('/error-401');
        });
      }
    });

    // Activate loading indicator
    var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function(event, nextRoute, currentRoute) {
      if($rootScope.referrerUrl === undefined && nextRoute.url.indexOf('login') === -1 && nextRoute.url.indexOf('forgot-password') === -1) {
        $rootScope.referrerUrl = nextRoute.url.replace(/:id/g, ((currentRoute && currentRoute.id)? currentRoute.id : '')).replace(/:tab/g, ((currentRoute && currentRoute.tab)? currentRoute.tab : 0));
      }
      $rootScope.loadingProgress = true;
    });

    //OVERRIDE ANGULAR GANTT DIRECTIVE (FOR SALES)
    GanttColumnsManager.prototype.getHeaderScale = function(header) {
      var scale;
      var headersScales = this.gantt.options.value('headersScales');
      if (headersScales !== undefined) {
        scale = headersScales[header];
      }
      if (scale === undefined) {
        scale = header;
      }

      if(scale === 'monthOnly') {
        scale='month';
      }
      if(scale === 'week_year' || scale === 'week_only') {
        scale='week';
      }
      if (['millisecond','6 months','six_month', 'second','monthOnly','week_only', 'minute', 'hour','2 hours','3 hours', 'day', 'week','week_year', 'month', 'quarter', 'year'].indexOf(scale) === -1) {
        scale = 'day';
      }
      return scale;
    };

    // De-activate loading indicator
    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function() {
      $timeout(function() {
        if($location.url().indexOf('login') === -1) {
          AuthService.addRoles();
        }
        $rootScope.loadingProgress = false;
      });
    });

    // Store state in the root scope for easy access
    $rootScope.state = $state;

    // Cleanup
    $rootScope.$on('$destroy', function() {
      stateChangeStartEvent();
      stateChangeSuccessEvent();
    });
    /* Check environment and switch properly */
    var apiUrl = $sessionStorage.apiUrl;
    if(apiUrl === undefined) {
      msApi.request('environment@get',
        function(config) {
          envService.set(config.environment);
          if (envService && envService.environment === 'staging') { // dev.cropchecker.com
            $sessionStorage.apiUrl = envService.data.API.staging.url;
          } else if(envService && envService.environment === 'development') { // local
            $sessionStorage.apiUrl = envService.data.API.development.url;
          } else if(envService && envService.environment === 'demo') { // local
            $sessionStorage.apiUrl = envService.data.API.demo.url;
          }
          var localUser = UserService.getLocalUser();
          if($location.url().indexOf('login') !== -1 && localUser) {
            $window.location.reload();
          }
        },
        function(err) {
          console.error('Configuration cannot be loaded, please review the configuration file.');
          console.error(err);
        }
      );
    }
  }
})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .config(routeConfig);

  /** @ngInject */
  function routeConfig($stateProvider, $urlRouterProvider, $locationProvider) {
    $locationProvider.html5Mode(true);

    $urlRouterProvider.otherwise('/login');

    /**
     * Layout Style Switcher
     *
     * This code is here for demonstration purposes.
     * If you don't need to switch between the layout
     * styles like in the demo, you can set one manually by
     * typing the template urls into the `State definitions`
     * area and remove this code
     */
    // Inject $cookies
    var $cookies;

    angular.injector(['ngCookies']).invoke([
      '$cookies', function(_$cookies) {
        $cookies = _$cookies;
      }
    ]);

    // Get active layout
    var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

    var layouts = {
      verticalNavigation                 : {
        main      : 'app/main/layouts/vertical-navigation.html',
        toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar : {
        main      : 'app/main/layouts/vertical-navigation-fullwidth-toolbar.html',
        toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
      },
      verticalNavigationFullwidthToolbar2: {
        main      : 'app/main/layouts/vertical-navigation-fullwidth-toolbar-2.html',
        toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
        navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
      },
      horizontalNavigation               : {
        main      : 'app/main/layouts/horizontal-navigation.html',
        toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
        navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
      },
      contentOnly                        : {
        main      : 'app/main/layouts/content-only.html',
        toolbar   : '',
        navigation: ''
      },
      contentWithToolbar                 : {
        main      : 'app/main/layouts/content-with-toolbar.html',
        toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
        navigation: ''
      }
    };
    // END - Layout Style Switcher

    // State definitions
    $stateProvider
      .state('app', {
        abstract: true,
        views   : {
          'main@'         : {
            templateUrl: layouts[layoutStyle].main,
            controller : 'MainController as vm'
          },
          'toolbar@app'   : {
            templateUrl: layouts[layoutStyle].toolbar,
            controller : 'ToolbarController as vm'
          },
          'navigation@app': {
            templateUrl: layouts[layoutStyle].navigation,
            controller : 'NavigationController as vm'
          },
          'quickPanel@app': {
            templateUrl: 'app/quick-panel/quick-panel.html',
            controller : 'QuickPanelController as vm'
          },
          'themePanel@app': {
            templateUrl: 'app/theme-panel/theme-panel.html',
            controller : 'ThemePanelController as vm'
          }
        }
      });
  }

})();

(function() {
  'use strict';

  angular
    .module('fuse')
    .filter('capitalize', function() {
      return function(input) {
        if(input) {
          input = input.replace(/_/g, ' ');
          if(input.indexOf(' ') !== -1) {
            var inputPieces,
              i;

            input = input.toLowerCase();
            inputPieces = input.split(' ');

            for(i = 0; i < inputPieces.length; i++) {
              inputPieces[i] = capitalizeString(inputPieces[i]);
            }

            return inputPieces.toString().replace(/,/g, ' ');
          }
          else {
            input = input.toLowerCase();
            return capitalizeString(input);
          }

          function capitalizeString(inputString) {
            return inputString.substring(0,1).toUpperCase() + inputString.substring(1);
          }
        }
      };
    })
    .controller('IndexController', IndexController);

  /** @ngInject */
  function IndexController(fuseTheming, $mdSidenav, $cookies, UserService, $scope) {
    var vm = this;
    // Data
    vm.themes = fuseTheming.themes;
    vm.toggleSidenav = toggleSidenav;

    load();

    var user = UserService.getLocalUser();
    if(user && user.hasOwnProperty('roles')) {
      vm.roles = user.roles;
    }

    if (vm.roles) {
      $scope.admin = vm.roles.findIndex(function (i) {
        return i.name.toLowerCase() === 'super_user';
      }) >= 0;
      if ($cookies.get('layoutStyle') === 'contentOnly' && $scope.admin === true) {
        vm.auxContentOnly = true;
      }
    }

    /**
     * Toggle sidenav
     *
     * @param sidenavId
     */
    function toggleSidenav(sidenavId) {
      vm.hideButton = true;
      $mdSidenav(sidenavId).toggle();
      $mdSidenav(sidenavId).onClose(function () {
        vm.hideButton = false;
      });
    }

	/**
     * Load
     */
    function load() {
      if (localStorage.getItem('user')) {
        sessionStorage.setItem('user', localStorage.getItem('user'));
      }
    }

  }
})();

(function() {
  'use strict';

  angular
    .module('app.core')
    .constant('AUTH_EVENTS', {
      loginSuccess: 'auth-login-success',
      loginFailed: 'auth-login-failed',
      logoutSuccess: 'auth-logout-success',
      sessionTimeout: 'auth-session-timeout',
      notAuthenticated: 'auth-not-authenticated',
      notAuthorized: 'auth-not-authorized'
    })
    .constant('OAUTH_CLIENT_DEV', {
      name: 'greenSky',
      grant_type: 'password',
      client_id: 'OI7553Pz',
      client_secret: '1uKmG5Pm7qaLYGc5qFFH'
    })
    .constant('API', {
      url: 'http://localhost:3000/api'
    })
    .constant('_', window._);
})();

(function() {
  'use strict';

  angular
        .module('fuse')
        .config(config);

    /** @ngInject */
  function config($translateProvider, $httpProvider, $qProvider, $mdThemingProvider, envServiceProvider) {
      // Register BearerAuthInterceptor.
    $httpProvider.interceptors.push('BearerAuthInterceptor');
    $qProvider.errorOnUnhandledRejections(false);

      // Put your common app configurations here

      // angular-translate configuration
    $translateProvider.useLoader('$translatePartialLoader', {
      urlTemplate: '{part}/i18n/{lang}.json'
    });
    $translateProvider.preferredLanguage('en');
    $translateProvider.useSanitizeValueStrategy('sanitize');
      /* Custom theme pallete config */
    $mdThemingProvider.definePalette('greyPallete', {
      '50': 'FAFAFA',
      '100': 'F5F5F5',
      '200': 'EEEEEE',
      '300': 'E0E0E0',
      '400': 'BDBDBD',
      '500': '9E9E9E',
      '600': '757575',
      '700': '616161',
      '800': '424242',
      '900': '212121',
      'A100': 'F5F5F5',
      'A200': 'EEEEEE',
      'A400': 'BDBDBD',
      'A700': '616161',
      'contrastDefaultColor': 'light',    // whether, by default, text (contrast)
                                            // on this palette should be dark or light

      'contrastDarkColors': ['50', '100', '200', '300', '400', 'A100'], //hues which contrast should be 'dark' by default
      'contrastLightColors': undefined    // could also specify this if default was 'dark'
    });

    $mdThemingProvider.theme('lightGrey')
        .backgroundPalette('greyPallete');

    envServiceProvider.config({
      domains: {
        development: ['localhost', 'greensky.local'],
        staging: ['dev.grower360.com', '*.grower360.com','greensky-dev.s3-website-us-west-2.amazonaws.com'],
        production: ['www.grower360.com'],
      },
      API: {
        development: {
          url: 'http://localhost:3000/api'
        },
        staging: {
          url: 'https://api.grower360.com/api'
        },
        demo: {
          url: 'https://demo.api.grower360.com/api'
        },
        production: {
          url: 'https://api.grower360.com/api'
        }
      },
      current: ''
    });

      // run the environment check, so the comprobation is made
      // before controllers and services are built
    envServiceProvider.check();
  }

})();

(function() {
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource, $sessionStorage) {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        /* Alphabetically sorted */
        /* keep this in alphabetical order if you add a new resource please. */
        var api = {};
        var API = {
          url: $sessionStorage.apiUrl
        };
        /* keep this in alphabetical order if you add a new resource please. */
        /* keep this in alphabetical order if you add a new resource please. */
        /* keep this in alphabetical order if you add a new resource please. */
        api.areas                       = $resource(API.url + '/areas/:id', {id: '@id'});
        api.area_fiscal_years           = $resource(API.url + '/area_fiscal_years/:id');
        api.areas.locations             = $resource(API.url + '/areas/:id/locations', {id: '@id'});
        api.bed_sizes                   = $resource(API.url + '/bed_sizes/:id', {id: '@id'});
        api.blocks                      = $resource(API.url + '/blocks/:id', {id: '@id'});
        api.business_roles              = $resource(API.url + '/business_roles');
        api.background                  = $resource(API.url + '/background');
        api.contracts                   = $resource(API.url + '/contracts/:id', {id: '@id'});
        api.contract_schedules          = $resource(API.url + '/contract_schedules/:id', {id: '@id'});
        api.contract_schedule_varieties = $resource(API.url + '/contract_schedule_varieties/:id', {id: '@id'});
        api.companies                   = $resource(API.url + '/companies/:id', {id: '@id'});
        api.farms                       = $resource(API.url + '/farms/:id', {id: '@id'});
        api.fiscal_years                = $resource(API.url + '/fiscal_years/:id');
        api.grower_schedules            = $resource(API.url + '/grower_schedules/:id', {id: '@id'});
        api.leases                      = $resource(API.url + '/leases/:id', {id: '@id'});
        api.lease_payment_schedules     = $resource(API.url + '/lease_payment_schedules/:id', {id: '@id'});
        api.locations                   = $resource(API.url + '/locations/:id', {id: '@id'});
        api.notify_groups               = $resource(API.url + '/notify_groups');
        api.pages                       = $resource(API.url + '/pages/:id', {id: '@id'});
        api.page_settings               = $resource(API.url + '/page_settings/:id', {id: '@id'});
        api.ranches                     = $resource(API.url + '/ranches/:id', {id: '@id'});
        api.subleases                   = $resource(API.url + '/subleases/:id', {id: '@id'});
        api.roles                       = $resource(API.url + '/roles');
        api.seasons                     = $resource(API.url + '/seasons/:id', {id: '@id'});
        api.seeds                       = $resource(API.url + '/seeds/:id', {id: '@id'});
        api.soil_types                  = $resource(API.url + '/soil_types', {id: '@id'});
        api.users                       = $resource(API.url + '/users/:id', {id: '@id'});
        api.water_districts             = $resource(API.url + '/water_districts', {area_id: '@area_id'});
        /* keep this in alphabetical order if you add a new resource please. */
        /* keep this in alphabetical order if you add a new resource please. */
        /* keep this in alphabetical order if you add a new resource please. */

        return api;
   }

})();

(function () {
  'use strict';

  angular
  .module('app.pages', [
    'app.pages.auth.login',
    'app.pages.auth.login.dialogs',
    'app.pages.auth.forgot-password',
    'app.pages.error-401',
    'app.pages.contracts',
    'app.pages.contracts.dialogs-contract',
    'app.pages.contracts.dialogs-crop',
    'app.pages.contracts.dialogs-variety',
    'app.pages.contracts.dialogs-grower-dates',
    'app.pages.planting-schedule',
    'app.pages.planting-schedule.dialog',
    'app.pages.grower-schedule',
    'app.pages.grower-schedule.dialogs-planting-report',
    'app.pages.grower-schedule.dialogs-show-errors',
    'app.pages.work-schedule',
    'app.pages.reports.grower-schedule-report',
    'app.pages.reports.planting-schedule-report',
    'app.pages.reports.contract-schedule-report',
    'app.pages.reports.resource-requirements-report'
  ])
  .filter('anchor', ['AnchorTypeDefinitionService',function (AnchorTypeDefinitionService) {

    return function (task) {
      return task.name + ' ' + AnchorTypeDefinitionService.getAnchorShortCode(task.anchor_id);
    };


  }])
  .config(config);

  /** @ngInject */
  function config(msNavigationServiceProvider) {
    // Navigation
    msNavigationServiceProvider.saveItem('pages', {
      title: 'PLANNING',
      group: true,
      weight: 1
    });
    msNavigationServiceProvider.saveItem('pages.reports', {
      title : 'Reports',
      icon  : 'icon-chart-areaspline',
      class : 'navigation-reports',
      hidden: true,
      weight: 12
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('app.growing', [
    'app.growing.master-schedule',
    'app.growing.block-activity',
    'app.growing.pesticide-manager',
    'app.growing.harvest-manager',
    'app.growing.messaging',
    'app.growing.farm-manager-approvals'
  ])
  .config(config);

  /** @ngInject */
  function config(msNavigationServiceProvider) {
    // Navigation
    msNavigationServiceProvider.saveItem('growing', {
      title: 'GROWING',
      group: true,
      weight: 1
    });
  }
})();

(function () {
  'use strict';

  angular
  .module('app.farm-admin', [
    'app.farm-admin.users.companies',
    'app.farm-admin.users.companies.dialogs',
    'app.farm-admin.users.farm-owner',
    'app.farm-admin.users.users',
    'app.farm-admin.users.users.dialogs',
    'app.farm-admin.users.users.notify-group.dialog',
    'app.farm-admin.work-schedule-template.phase-types',
    'app.farm-admin.work-schedule-template.phase-types.dialog',
    'app.farm-admin.work-schedule-template.phase-name.dialog',
    'app.farm-admin.work-schedule-template.phase-name.color-picker-dialog',
    'app.farm-admin.work-schedule-template.work-schedule-tasks.timeline-placeholders',
    'app.farm-admin.work-schedule-template.work-schedule-tasks.tasks',
    'app.farm-admin.work-schedule-template.work-schedule-tasks.tasks.dialog',
    'app.farm-admin.work-schedule-template.work-schedule-tasks.tasks.dialog.gantt',
    'app.farm-admin.work-schedule-template.work-template',
    'app.farm-admin.work-schedule-template.work-template.dialog',
    'app.farm-admin.work-schedule-template.clone-work-template.dialog',
    'app.farm-admin.work-schedule-template.work-template-2',
    'app.farm-admin.land.blocks',
    'app.farm-admin.land.blocks.dialogs-block-bed-sizes',
    'app.farm-admin.land.ranches',
    'app.farm-admin.land.leases',
    'app.farm-admin.land.leases.dialogs-leaseListBlocks',
    'app.farm-admin.land.subleases',
    'app.farm-admin.land.subleases.dialogs-subleaseListBlocks',
    'app.farm-admin.land.land-definition',
    'app.farm-admin.land.land.dialogs',
    'app.farm-admin.land.land.dialogs-location',
    'app.farm-admin.farm-resources.seed',
    'app.farm-admin.farm-resources.seed.dialogs',
    'app.farm-admin.farm-resources.seed.dialogs-location',
    'app.farm-admin.farm-resources.seed.dialogs-variety',
    'app.farm-admin.farm-resources.equipment',
    'app.farm-admin.farm-resources.labor',
    'app.farm-admin.farm-resources.fertilizer-definition',
    'app.farm-admin.farm-resources.pesticide-definition',
    'app.farm-admin.farm-resources.water'
  ])
  .config(config);

  /** @ngInject */
  function config(msNavigationServiceProvider) {
    // Navigation
    msNavigationServiceProvider.saveItem('farm-admin', {
      title: 'FARM ADMIN',
      group: true,
      weight: 10
    });
    msNavigationServiceProvider.saveItem('farm-admin.users', {
      title: 'Users',
      icon: 'icon-account-multiple',
      class: 'navigation-users',
      hidden: true,
      weight: 20
    });
    msNavigationServiceProvider.saveItem('farm-admin.work-schedule-template', {
      title: 'Work Schedule Templates',
      icon: 'icon-timetable',
      class: 'navigation-work-schedule-template',
      hidden: true,
      weight: 21
    });
    msNavigationServiceProvider.saveItem('farm-admin.work-schedule-template.work-schedule-tasks', {
      title: 'Work Schedule Tasks',
      icon: 'icon-timetable',
      class: 'navigation-work-schedule-tasks',
      hidden: true,
      weight: 24
    });
    msNavigationServiceProvider.saveItem('farm-admin.land', {
      title: 'Land',
      icon: 'icon-panorama',
      class: 'navigation-land',
      hidden: true,
      weight: 23
    });
    msNavigationServiceProvider.saveItem('farm-admin.farm-resources', {
      title: 'Farm Resources',
      icon: 'icon-panorama',
      class: 'navigation-land',
      hidden: true,
      weight: 24
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.dashboard', [
      'app.dashboard.foreman'
    ]).config(config);


  /** @ngInject */
  function config(msNavigationServiceProvider) {
    // Navigation
    msNavigationServiceProvider.saveItem('dashboard', {
      title: 'DASHBOARD',
      group: true,
      weight: 0
    });
  }
})();

(function () {
  'use strict';

  angular
    .module('app.admin', [
      'angular.img',
      'app.admin.modules',
      'app.admin.cronjobs',
      'app.admin.land-reference-names',
      'app.admin.growing-seasons-definition',
      'app.admin.growing-seasons-definition.dialogs',
      'app.admin.seasons-definition'
    ]).config(config);


  /** @ngInject */
  function config(msNavigationServiceProvider) {
    // Navigation
    msNavigationServiceProvider.saveItem('admin', {
      title: 'SYSTEM ADMIN',
      group: true,
      weight: 20
    });
  }

})();

angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/theme-panel/theme-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"THEMEPANEL.LAYOUT\">SETTINGS LAYOUT</span></md-tab-label><md-tab-body><md-content \nclass=\"today-tab scrollable\" ms-scroll ng-include=\"\'app/theme-panel/tabs/settings-layout/settings-layout.html\'\">\n</md-content></md-tab-body></md-tab></md-tabs></md-content>");
$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/main/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"theme-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"theme-panel\" ms-scroll ui-view=\"themePanel\"></md-sidenav>\n</div>");
$templateCache.put("app/main/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n<md-sidenav id=\"theme-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"theme-panel\" ms-scroll \nui-view=\"themePanel\"></md-sidenav></div>");
$templateCache.put("app/main/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav><md-sidenav id=\"theme-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"theme-panel\" ms-scroll ui-view=\"themePanel\"></md-sidenav>\n</div>");
$templateCache.put("app/main/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav><md-sidenav id=\"theme-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"theme-panel\" ms-scroll ui-view=\"themePanel\"></md-sidenav>\n</div></div>");
$templateCache.put("app/main/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav><md-sidenav id=\"theme-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"theme-panel\" ms-scroll ui-view=\"themePanel\"></md-sidenav>\n</div></div>");
$templateCache.put("app/main/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n<md-sidenav id=\"theme-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"theme-panel\" ms-scroll \nui-view=\"themePanel\"></md-sidenav></div>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/admin/cronjobs/cronjobs.html","<div id=\"cronjobs\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" layout-align=\"start center\"><md-button \nid=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CRONJOBS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-alarm\" class=\"s40\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CRONJOBS.CRONJOBS\">Cronjobs</span></div></div><div flex-xs=\"45\" \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for cronjob\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"CRONJOBS.SEARCH_FOR_CRONJOBS\"></md-input-container></div></div><div \nng-show=\"vm.selectedCronjobs.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedCronjobs =[]\"><md-button \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"CRONJOBS.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"selected-cronjobs-count\"><span>{{vm.selectedCronjobs.length}}</span> <span translate=\"CRONJOBS.SELECTED\">\nselected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"CRONJOBS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllCronjobs()\" translate=\"CRONJOBS.SELECT_ALL\">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectCronjobs()\" \ntranslate=\"CRONJOBS.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedCronjobs($event)\" \naria-label=\"delete selected\" translate translate-attr-label=\"CRONJOBS.DELETE_SELECTED\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/admin/cronjobs/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\"><md-list \nclass=\"cronjobs-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\"><div \nclass=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \nng-if=\"vm.listType === \'all\'\" translate=\"CRONJOBS.ALL_CRONJOBS\">All cronjobs</span> <span \nng-if=\"vm.listType === \'all\' && vm.cronjobs.length\" class=\"secondary-text cronjobs-count\">({{vm.cronjobs.length}}) \n</span><span ng-if=\"vm.listType === \'frequent\'\" translate=\"CRONJOBS.FREQUENTLY_COMPANYED\">Frequnetly </span><span \nng-if=\"vm.listType === \'starred\'\" translate=\"CRONJOBS.STARRED_CRONJOBS\">Starred cronjobs</span> <span \nng-if=\"vm.listType.name\">{{vm.listType.name}}</span> <span ng-if=\"vm.listType !== \'all\' && vm.filterIds.length\" \nclass=\"secondary-text cronjobs-count\">({{vm.filterIds.length}})</span></div><div class=\"edit-group-form\" \nng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span ng-show=\"editGroupForm.$visible\" \neditable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup($event, vm.listType)\"></span><div>\n<md-button class=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"edit group name\" translate translate-attr-label=\"CRONJOBS.EDIT_GROUP_NAME\"><md-icon \nmd-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button ng-if=\"filteredCronjobs.length!=0\" \nng-disabled=\"filteredCronjobs.length!=0\" class=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup($event)\" \nng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate translate-attr-label=\"CRONJOBS.DELETE_GROUP\">\n<md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button><md-button ng-if=\"filteredCronjobs.length==0\" \nclass=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup($event)\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"delete group\" translate translate-attr-label=\"CRONJOBS.DELETE_GROUP\"><md-icon \nmd-font-icon=\"icon-delete s18\"></md-icon></md-button></div></div></div></md-subheader><div \nclass=\"content white-bg md-whiteframe-4dp\"><div><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text name\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CRONJOBS.CRONJOB_NAME\">\n</span></div></th><th class=\"secondary-text description\" hide-xs><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CRONJOBS.DESCRIPTION\"></span></div></th><th class=\"secondary-text execution_start\" hide-xs><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CRONJOBS.LAST_EXECUTION_START_DATE\"></span></div></th><th \nclass=\"secondary-text execution_end\" hide-xs><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CRONJOBS.LAST_EXECUTION_END_DATE\"></span></div></th><th class=\"secondary-text next_execution_date\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CRONJOBS.NEXT_EXECUTION_DATE\"></span></div></th><th \nclass=\"secondary-text status\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CRONJOBS.STATUS\"></span>\n</div></th><th class=\"secondary-text motive\" hide-xs><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CRONJOBS.MOTIVE\"></span></div></th><th class=\"secondary-text actions\"><div class=\"table-header actions\">\n<span class=\"column-title\" translate=\"CRONJOBS.ACTIONS\"></span></div></th></tr></thead><tbody resize \nclass=\"scrollable constrained\" ng-if=\"!loadingData && vm.cronjobs\" ms-scroll ms-infinite-scroll=\"vm.loadMore()\" \nms-infinite-scroll-container=\'\".constrained\"\'><tr \nng-repeat=\"cronjob in vm.cronjobs  | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredCronjobs track by cronjob.id | limitTo:vm.offset\" \nng-click=\"vm.openCronjobDialog($event, cronjob)\" ng-class=\"{\'selected\': vm.isSelected(cronjob)}\"><td class=\"name\" \nng-style=\"{\'font-weight\':\'bold\'}\">{{ cronjob.name | capitalize }}</td><td class=\"description\" hide-xs>\n{{ cronjob.description }}</td><td class=\"execution_start\" hide-xs>\n{{ cronjob.last_execution_start_date | date: \'medium\' }}</td><td class=\"execution_end\" hide-xs>\n{{ cronjob.last_execution_end_date | date: \'medium\' }}</td><td class=\"next_execution_date\">\n{{ cronjob.next_execution_date | date: \'medium\' }}</td><td class=\"status\">{{ cronjob.status }}</td><td class=\"motive\" \nhide-xs>{{ cronjob.motive }}</td><td class=\"actions\"><md-menu ng-disable=\"finishUpdate\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event);\" aria-label=\"More\" translate=\"\" \ntranslate-attr-aria-label=\"CRONJOBS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"execute-now\" \nng-click=\"vm.executeCron(cronjob, $index)\" translate=\"CRONJOBS.EXECUTE_NOW\"></md-button></md-menu-item>\n</md-menu-content></md-menu></td></tr></tbody></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" \nlayout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && filteredCronjobs.length === 0\"><p class=\"padding-left-0\" translate=\"CRONJOBS.NO_RESULTS\">\nNo results..</p></md-list-item></div></div></md-list></div></div></div>");
$templateCache.put("app/main/admin/growing-seasons-definition/growing-seasons-definition.html","<div id=\"growing-seasons\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"GROWING_SEASONS.GROWING_YEAR\">Growing Year</span></div></div></div><div class=\"content\" md-background-bg \nlayout=\"row\" layout-align=\"start start\"><div class=\"main\"><md-list class=\"growing-seasons-list\"><div \nclass=\"content white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\"><thead><tr><th class=\"year\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"GROWING_SEASONS.GROWING_YEAR\"></span></div></th><th \nclass=\"season-name\"><div class=\"table-header\"><span class=\"column-title\" translate=\"GROWING_SEASONS.SEASON_1\"></span>\n</div></th><th class=\"season-name\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"GROWING_SEASONS.SEASON_2\"></span></div></th><th class=\"season-name\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"GROWING_SEASONS.SEASON_3\"></span></div></th><th class=\"season-name\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"GROWING_SEASONS.SEASON_4\"></span></div></th><th \nclass=\"w-100 actions\"><div class=\"table-header\"><span class=\"column-title\" translate=\"GROWING_SEASONS.ACTIONS\"></span>\n</div></th></tr></thead><tbody class=\"scrollable constrained\" ms-scroll ng-if=\"!loadingData\" \nms-infinite-scroll=\"vm.loadMore()\" ms-infinite-scroll-container=\'\".constrained\"\' ng-style=\"setSize(318)\" resize><tr \nclass=\"growing-season-item\" ng-repeat=\"year in vm.growingYears\" ng-click=\"vm.addGrowingSeasonDialog(ev, year)\"><td \nclass=\"year\">{{year.name}}</td><td class=\"season-name\">{{year.fiscal_year_seasons[0].season.name}}<br>\n{{year.fiscal_year_seasons[0].start_date | date: \'mediumDate\' }}</td><td class=\"season-name\">\n{{year.fiscal_year_seasons[1].season.name}}<br>{{year.fiscal_year_seasons[1].start_date | date: \'mediumDate\' }}</td><td\n class=\"season-name\">{{year.fiscal_year_seasons[2].season.name}}<br>\n{{year.fiscal_year_seasons[2].start_date | date: \'mediumDate\' }}</td><td class=\"season-name\">\n{{year.fiscal_year_seasons[3].season.name}}<br>{{year.fiscal_year_seasons[3].start_date | date: \'mediumDate\' }}</td><td\n class=\"w-100 actions\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"GROWING_SEASONS.MORE\" ng-click=\"$mdMenu.open($event); event.stopPropagation()\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" id=\"icon-dot\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button aria-label=\"edit-growing\" translate=\"GROWING_SEASONS.EDIT_GROWING_SEASON\" \nng-click=\"vm.addGrowingSeasonDialog(ev, year)\"></md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"!year.removable\" aria-label=\"delete-year\" translate=\"GROWING_SEASONS.DELETE_GROWING_SEASON\" \nng-click=\"vm.deleteGrowingYear(ev, year)\"></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader>\n</ms-loader></md-list-item><md-list-item class=\"md-white-bg\" ng-show=\"!loadingData && filteredContracts.length === 0\">\n<p class=\"padding-left-8\" translate=\"GROWING_SEASONS.NO_RESULTS\">No results..</p></md-list-item></div></md-list></div>\n</div><md-button show-xs show-sm hide-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nid=\"add-growing-season-button-mobile\" ng-click=\"vm.addGrowingSeasonDialog()\" aria-label=\"add contract\" translate \ntranslate-attr-aria-label=\"GROWING_SEASONS.ADD_GROWING_SEASON\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button hide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" id=\"add-growing-season-button\" \nng-click=\"vm.addGrowingSeasonDialog()\" aria-label=\"add contract\" translate \ntranslate-attr-aria-label=\"GROWING_SEASONS.ADD_GROWING_SEASON\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div>");
$templateCache.put("app/main/admin/land-reference/land-reference.html","<div id=\"land-reference-class\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\">\n</div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-routes\"></md-icon><span translate=\"LAND_REFERENCE.TITLE\">\nLand Reference</span></div></div></div><div class=\"main scrollable\" ms-scroll><form class=\"land-reference-form\" \nname=\"land-reference\" ms-vertical-stepper ng-submit=\"vm.saveLandReference()\" ng-model=\"vm.stepper\" novalidate>\n<ms-vertical-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Day to Day Land Reference Name\'\"><div \nng-include=\"\'app/main/admin/land-reference/form/step1.html\'\"></div></ms-vertical-stepper-step><ms-vertical-stepper-step\n ng-form=\"step2\" step=\"2\" step-title=\"\'Area Reference Name\'\"><div \nng-include=\"\'app/main/admin/land-reference/form/step2.html\'\"></div></ms-vertical-stepper-step><ms-vertical-stepper-step\n ng-form=\"step2\" step=\"3\" step-title=\"\'Location Reference Name\'\"><div \nng-include=\"\'app/main/admin/land-reference/form/step3.html\'\"></div></ms-vertical-stepper-step><ms-vertical-stepper-step\n ng-form=\"step2\" step=\"4\" step-title=\"\'Section Reference Name\'\"><div \nng-include=\"\'app/main/admin/land-reference/form/step4.html\'\"></div></ms-vertical-stepper-step><ms-vertical-stepper-step\n ng-form=\"step2\" step=\"5\" step-title=\"\'Block Reference Name\'\"><div \nng-include=\"\'app/main/admin/land-reference/form/step5.html\'\"></div></ms-vertical-stepper-step></form></div></div></div>");
$templateCache.put("app/main/admin/modules/modules.html","<div id=\"modules\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header md-accent-bg\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" layout=\"column\"><div class=\"header-content\" layout=\"row\" \nlayout-align=\"space-between\" layout-wrap flex><div layout=\"row\" layout-align=\"center center\" flex-order=\"1\" \nflex-order-xs=\"2\"><md-button class=\"md-accent md-raised md-hue-2 header-boards-button\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-700-bg\'\" ng-click=\"vm.boardSelectorVisible = !vm.boardSelectorVisible\" \naria-label=\"boards button\" translate translate-attr-aria-label=\"SB.BOARDS_BUTTON\"><md-icon md-font-icon=\"icon-trello\" \nclass=\"icon\"></md-icon><span translate=\"SB.BOARDS\">BOARDS</span></md-button></div><div class=\"header-board-name\" \nlayout=\"row\" layout-align=\"center center\" flex-order=\"2\" flex-order-xs=\"1\" flex-xs=\"100\"><i \nng-if=\"vm.board.settings.subscribed\" class=\"board-subscribe s16 icon-eye\"></i> <span editable-text=\"vm.board.name\" \nonaftersave=\"vm.updateBoardUri()\">{{vm.board.name}}</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\" flex-order=\"3\"><md-button ng-if=\"vm.filteringIsOn()\" class=\"md-icon-button\" \nng-click=\"vm.clearFilters()\" aria-label=\"Clear Filters\" translate translate-attr-aria-label=\"SB.CLEAR_FILTERS\"><md-icon\n md-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip sb.clear_filters>Clear Filters</md-tooltip></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'filters-sidenav\')\" aria-label=\"Filter Cards\" translate \ntranslate-attr-aria-label=\"SB.FILTER_CARDS\"><md-icon md-font-icon=\"icon-filter-variant\"></md-icon><md-tooltip><span \ntranslate=\"SB.FILTER_CARDS\">Filter Cards</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" aria-label=\"Settings\" translate \ntranslate-attr-aria-label=\"SB.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon><md-tooltip><span \ntranslate=\"SB.SETTINGS\">Settings</span></md-tooltip></md-button></div></div></div><div \nng-show=\"vm.boardSelectorVisible\" id=\"board-selector\" \nclass=\"md-accent-bg animate-slide-down board-list md-whiteframe-3dp\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" \nui-sref=\"app.modules.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"space-between center\">\n<div class=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex class=\"board-name\">{{board.name}}</div><div \nclass=\"board-options\"><i class=\"icon-dots-horizontal\"></i></div><div ng-if=\"board.id === vm.board.id\" \nclass=\"selected-icon green-bg\"><i class=\"icon-check s24\"></i></div></div><div class=\"board-list-item add-new-board\" \nui-sref=\"app.modules.boards.addBoard\" ui-sref-active=\"hidden\" layout=\"column\" layout-align=\"space-between center\"><div \nclass=\"board-icon\"><i class=\"icon-trello s64\"></i></div><div flex class=\"board-name\" translate=\"SB.ADD_NEW_BOARD\">\nAdd New Board</div></div></div><md-backdrop class=\"board-selector-backdrop md-dialog-backdrop md-opaque\" \nng-show=\"vm.boardSelectorVisible\" ng-click=\"vm.boardSelectorVisible = false\" aria-hidden=\"true\"></md-backdrop>\n<md-content class=\"content\" flex layout=\"column\" ui-view=\"modulesContent\"></md-content><md-sidenav \nclass=\"settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" \nng-include=\"\'app/main/admin/modules/sidenavs/settings/settings-sidenav.html\'\" \nng-controller=\"SettingsSidenavController as vm\" ms-sidenav-helper></md-sidenav><md-sidenav \nclass=\"filters-sidenav md-sidenav-right\" md-component-id=\"filters-sidenav\" \nng-include=\"\'app/main/admin/modules/sidenavs/filters/filters-sidenav.html\'\" \nng-controller=\"FiltersSidenavController as vm\" ms-sidenav-helper></md-sidenav></div>");
$templateCache.put("app/main/admin/seasons/seasons.html","<div id=\"seasons-class\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-calendar-multiple\"></md-icon><span>{{vm.title.season}}</span></div><div \nclass=\"season-title secondary-text\"><span ng-if=\"vm.title.length!==0 && vm.title.name\"><b>Season name:</b>\n {{vm.title.name}}</span> <span ng-if=\"vm.title.length!==0 && vm.title.start\"><b>Start:</b>\n {{vm.title.start | date: \'mediumDate\' }} </span><span ng-if=\"vm.title.length!==0 && vm.title.end\"><b>End:</b>\n {{vm.title.end | date: \'mediumDate\' }}</span></div></div></div><div class=\"main scrollable\" ms-scroll><form \nname=\"seasons\" ng-disabled=\"fiscalYearExist\" ng-open=\"vm.openForm()\" ms-vertical-custom-stepper \nng-submit=\"vm.saveSeasons()\" ng-model=\"vm.stepper\" novalidate><ms-vertical-custom-stepper-step ng-form=\"step1\" \nstep=\"1\" step-title=\"\'Season 1\'\"><div ng-include=\"\'app/main/admin/seasons/form/step1.html\'\"></div>\n</ms-vertical-custom-stepper-step><ms-vertical-custom-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Season 2\'\">\n<div ng-include=\"\'app/main/admin/seasons/form/step2.html\'\"></div></ms-vertical-custom-stepper-step>\n<ms-vertical-custom-stepper-step ng-form=\"step2\" step=\"3\" step-title=\"\'Season 3\'\"><div \nng-include=\"\'app/main/admin/seasons/form/step3.html\'\"></div></ms-vertical-custom-stepper-step>\n<ms-vertical-custom-stepper-step ng-form=\"step2\" step=\"4\" step-title=\"\'Season 4\'\"><div \nng-include=\"\'app/main/admin/seasons/form/step4.html\'\"></div></ms-vertical-custom-stepper-step></form></div></div></div>");
$templateCache.put("app/main/dashboard/foreman/foreman.html","<h1>FOREMAN</h1>");
$templateCache.put("app/main/directives/ms-custom-theme-options/custom-theme-options.html","<div class=\"ms-custom-theme-options\"><div class=\"ms-custom-theme-options-list\" layout=\"column\"><div \nclass=\"theme-option layout-options\"><div class=\"option-title\">Layout Style:</div><md-radio-group layout=\"row\" \nlayout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" ng-click=\"vm.updateLayoutStyle()\"><md-radio-button \nng-repeat=\"layoutStyle in vm.layoutStyles\" ng-value=\"layoutStyle.value\"><div layout=\"column\" \nlayout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> <span class=\"text-center font-size-12 mt-8\">\n{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div><div class=\"theme-separator\"></div><div \nclass=\"theme-option color-palettes\"><div class=\"option-title\">Color palette:</div><div layout=\"row\" \nlayout-align=\"center center\" layout-wrap><md-button ng-repeat=\"(themeName, theme) in vm.themes.list\" \nclass=\"md-raised theme-button\" layout=\"row\" layout-align=\"center center\" aria-label=\"{{themeName}}\" \nng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/directives/ms-loader/ms-loader.html","<div class=\"progress\" layout=\"row\" layout-align=\"center center\"><md-progress-circular class=\"md-accent p-12\" \nmd-diameter=\"{{vm.diameter}}\"></md-progress-circular></div>");
$templateCache.put("app/main/growing/block-activity/block-activity.html","<h1>BLOCK ACTIVITY</h1>");
$templateCache.put("app/main/growing/farm-manager-approvals/farm-manager-approvals.html","<h1>Farm Manager Approvals</h1>");
$templateCache.put("app/main/growing/harvest-manager/harvest-manager.html","<h1>HARVEST MANAGER</h1>");
$templateCache.put("app/main/growing/master-schedule/master-schedule.html","<h1>MASTER SCHEDULE</h1>");
$templateCache.put("app/main/growing/messaging/messaging.html","<h1>MESSAGING</h1>");
$templateCache.put("app/main/growing/pesticide-manager/pesticide-manager.html","<h1>PESTICIDE MANAGER</h1>");
$templateCache.put("app/main/pages/contracts/contracts.html","<div id=\"contracts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" layout-align=\"start center\"><md-button \nid=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"CONTRACTS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CONTRACTS.CONTRACTS\">Contracts</span></div></div><div flex-xs=\"45\" \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for contract\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"CONTRACTS.SEARCH_FOR_CONTRACT\"></md-input-container></div></div><div class=\"content\" \nmd-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/pages/contracts/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\"><md-list \nclass=\"contracts-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\"><div \nclass=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \nng-if=\"vm.listType === \'all\'\" translate=\"CONTRACTS.ALL_CONTRACTS\"></span> <span ng-if=\"vm.listType === \'starred\'\" \ntranslate=\"CONTRACTS.STARRED_CONTRACTS\"></span> <span ng-if=\"vm.listType.name\">{{vm.listType.name}}</span> <span \nng-if=\"vm.filterIds.length\" class=\"secondary-text contracts-count\">({{vm.filterIds.length}})</span></div></div>\n</md-subheader><div class=\"content white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\"><thead><tr><th\n class=\"shipper\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACTS.SHIPPER\"></span></div></th>\n<th class=\"number\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACTS.CONTRACT_NUMBER\"></span>\n</div></th><th class=\"acres\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACTS.ACRES\"></span>\n</div></th><th class=\"date\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACTS.START_DATE\">\n</span></div></th><th class=\"date\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACTS.END_DATE\">\n</span></div></th><th class=\"w-100 actions\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CONTRACTS.ACTIONS\"></span></div></th></tr></thead><tbody class=\"scrollable constrained\" ms-scroll \nng-if=\"!loadingData && vm.filterIds.length>0\" ms-infinite-scroll=\"vm.loadMore()\" \nms-infinite-scroll-container=\'\".constrained\"\' ng-style=\"setSize(318)\" resize><tr class=\"contract-item\" \nng-repeat=\"contract in vm.shownContracts | filter: vm.search | filter: global.search | filterByIds: vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContracts track by contract.id | limitTo:vm.offset\" \nng-click=\"vm.editContract(ev, contract)\"><td class=\"shipper\">{{ contract.shipper }}</td><td class=\"number\">\n{{ contract.number }}</td><td class=\"acres\">{{ contract.acres | numberFilter:1 }}</td><td class=\"date\">\n{{ contract.start_date | date: \'mediumDate\' }}</td><td class=\"date\">{{ contract.end_date | date: \'mediumDate\' }}</td>\n<td class=\"w-100 actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleInArray(contract.id, vm.starredContracts);vm.patchStarred(contract)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"CONTRACTS.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.exists(contract.id,vm.starredContracts)\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.exists(contract.id,vm.starredContracts)\" md-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"CONTRACTS.MORE\" \nng-click=\"$mdMenu.open($event); event.stopPropagation()\"><md-icon md-font-icon=\"icon-dots-vertical\" id=\"icon-dot\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"edit-contract\" \ntranslate=\"CONTRACTS.EDIT_CONTRACT\" ng-click=\"vm.editContract(ev, contract)\"></md-button></md-menu-item><md-menu-item>\n<md-button ng-disabled=\"!contract.deletable\" aria-label=\"delete-contract\" translate=\"CONTRACTS.DELETE_CONTRACT\" \nng-click=\"vm.deleteContract(ev, contract)\"></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader>\n</ms-loader></md-list-item><md-list-item class=\"md-white-bg\" ng-show=\"!loadingData && filteredContracts.length === 0\">\n<p class=\"padding-left-8\" translate=\"CONTRACTS.NO_RESULTS\">No results..</p></md-list-item></div></md-list></div></div>\n<md-button show-xs show-sm hide-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nid=\"add-contract-button-mobile\" ng-click=\"vm.addContract()\" aria-label=\"add contract\" translate \ntranslate-attr-aria-label=\"CONTRACTS.ADD_CONTRACT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nhide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" id=\"add-contract-button\" \nng-click=\"vm.addContract()\" aria-label=\"add contract\" translate translate-attr-aria-label=\"CONTRACTS.ADD_CONTRACT\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/grower-schedule/grower-schedule.html","<div id=\"grower-schedule\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.hideToast(); vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"GROWER_SCHEDULE.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><span \nclass=\"logo-text\" translate=\"GROWER_SCHEDULE.GROWER_SCHEDULE\">Grower Schedule</span><div class=\"switch-container\">\n<md-switch class=\"switch\" ng-click=\"vm.hideToast(); vm.setTableHeight(\'growerSchedTableBody\')\" aria-label=\"Disabled\">\nShipper Schedule</md-switch><md-tooltip><div>Hide Shipper Schedule</div></md-tooltip></div><div \nclass=\"switch-container custom-color\"><md-switch md-invert=\"true\" class=\"switch week-ending\" \nng-model=\"vm.weekEndingByHarvestDate\" \nng-change=\"vm.hideToast(); vm.toggleWeekEndingFilter(growerSchedForm.$invalid, contractsForm.$invalid)\" \naria-label=\"Disabled\"><span ng-class=\"{\'disabled\': vm.weekEndingByHarvestDate}\">Wet Date</span></md-switch><span \nng-click=\"vm.hideToast(); vm.weekEndingByHarvestDate = !vm.weekEndingByHarvestDate; vm.toggleWeekEndingFilter(growerSchedForm.$invalid, contractsForm.$invalid)\" \nng-model=\"vm.weekEndingByHarvestDate\" class=\"switch-label\" ng-class=\"{\'disabled\': !vm.weekEndingByHarvestDate}\">\nHarvest Date</span><md-tooltip><div>Filter Season/Week Ending by Wet Date or Harvest Date</div></md-tooltip></div><div \nclass=\"double-crop-container\"><div class=\"switch-container\"><md-switch class=\"switch\" ng-model=\"vm.doubleCropIsActive\" \nng-change=\"vm.hideToast(); vm.doubleCropLevelChanged(true, growerSchedForm.$invalid, contractsForm.$invalid)\" \naria-label=\"Double Crop\">Double Crop</md-switch><md-tooltip><div>Show Double Crop Blocks</div></md-tooltip></div>\n<md-select ng-hide=\"!vm.doubleCropIsActive\" aria-label=\"records\" ng-model=\"vm.aux_double_crop_num\" \nng-change=\"vm.doubleCropLevelChanged(false, growerSchedForm.$invalid, contractsForm.$invalid)\" class=\"num-records\">\n<md-option ng-repeat=\"num in vm.double_crop_values\" ng-value=\"{{num}}\">{{num}}</md-option></md-select></div></div>\n</div><div layout=\"row\" layout-align=\"end center\" class=\"\"><div ng-show=\"!vm.showSearch\" class=\"show-hide-search\">\n<md-button ng-click=\"vm.hideToast(); vm.showSearch = true\" class=\"md-raised md-background custom-btn\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search\"></md-icon></md-button><md-button \nng-click=\"vm.hideToast(); vm.goToGSreports()\" class=\"md-raised md-background custom-btn\"><md-icon \nmd-font-icon=\"icon-chart-areaspline\" class=\"icon\"></md-icon><md-tooltip><div>Grower Schedule Reports</div></md-tooltip>\n</md-button></div><div ng-show=\"vm.showSearch\" flex-xs=\"45\" class=\"search-input-wrapper show-hide-search\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"md-icon-float md-icon-right md-block\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><input id=\"search\" placeholder=\"Search\" type=\"text\" ng-model=\"vm.auxsearch\" \nng-model-options=\"{ debounce: 1000 }\" \nng-change=\"vm.hideToast(); vm.searchChanged(growerSchedForm.$invalid, contractsForm.$invalid, \'search\')\"><md-icon \nmd-font-icon=\"icon-close\" class=\"close\" ng-click=\"vm.closeSearch()\"></md-icon></md-input-container></div><md-button \nclass=\"md-raised md-background\" ng-click=\"vm.hideToast(); vm.saveAll()\" \nng-disabled=\"contractsForm.$invalid || growerSchedForm.$invalid || (growerSchedForm.$pristine && contractsForm.$pristine) || vm.customError || vm.varietiesError\">\n<span>Save</span></md-button></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\">\n<md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" \nng-include=\"\'app/main/pages/grower-schedule/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"main scrollable\" ms-scroll><md-content layout=\"column\" flex class=\"md-whiteframe-4dp\" \nng-hide=\"vm.isContractDisabled\"><form id=\"contractsForm\" name=\"contractsForm\"><md-table-container \nid=\"contractsTableBody\" class=\"scrollable constrained\" ms-scroll><table md-table id=\"contractsTable\" \nclass=\"row-border hover\"><thead fix-head md-head><tr md-row class=\"md-accent-bg md-hue-1 section-titles\"><th md-column \ncolspan=\"9\" class=\"\"><div class=\"first\"><span translate=\"GROWER_SCHEDULE.SHIPPER_SCHEDULE\" class=\"font-weight-500\">\n</span> <span ng-if=\"vm.filteredContracts.length\" class=\"contracts-count font-weight-500\">\n({{vm.filteredContracts.length}})</span></div><div class=\"filters\" ng-if=\"vm.active_filters.length\"><span \nng-repeat=\"filter in vm.active_filters\"><span>{{filter.type}}: </span><span class=\"font-weight-300\">{{filter.value}}\n</span> <span ng-if=\"!$last\">-</span></span></div></th><th md-column colspan=\"4\" class=\"second\"><div layout=\"row\" \nlayout-align=\"start center\"><div flex=\"90\"><span translate=\"GROWER_SCHEDULE.GROWER_SCHEDULE_DETAILS\" \nclass=\"font-weight-500\"></span></div><div flex=\"10\"><md-select ng-hide=\"vm.isContractDisabled\" aria-label=\"records\" \nng-model=\"vm.contract_num_records\" ng-change=\"vm.calculateTableHeight(\'contractsTableBody\', vm.contract_num_records)\" \nng-click=\"vm.hideToast();\" class=\"num-records\"><md-option ng-repeat=\"num in vm.num_of_records\" ng-value=\"{{num}}\">\n{{num}}</md-option></md-select></div></div></th></tr><tr md-row class=\"column-titles\"><th md-column class=\"w-50\"></th>\n<th md-column class=\"w-min-100\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE.SHIPPER\"></span></th><th \nmd-column class=\"w-dates text-center\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE.SHIPPER_WET_DATE\"></span>\n</th><th md-column class=\"w-min-100\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE.SEED\"></span></th><th \nmd-column class=\"w-min-100\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE.VARIETY\"></span></th><th md-column \nclass=\"w-dates text-center\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE.SHIPPER_HARVEST_DATE\"></span></th><th\n md-column class=\"w-acres text-center\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE.SHIPPER_ACRES\"></span>\n</th><th md-column class=\"w-acres acres-column text-center\"><span class=\"column-title acres-column\" \ntranslate=\"GROWER_SCHEDULE.NOT_SCHEDULED_ACRES\"></span></th><th md-column \nclass=\"w-15 md-accent-bg md-hue-1 separation\"></th><th md-column class=\"w-min-100 shipper\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.ASSIGNED_BLOCK\"></span></th><th md-column class=\"w-acres text-center\"><span \nclass=\"column-title\" translate=\"GROWER_SCHEDULE.SCHEDULED_ACRES\"></span></th><th md-column class=\"w-dates text-center\">\n<span class=\"column-title\" translate=\"GROWER_SCHEDULE.SCHEDULED_WET_DATE\"></span></th></tr></thead><tbody md-body \nui-on-drop=\"vm.onDrop($event, $index, contract)\" ng-if=\"!loadingData\"><tr md-row class=\"contract-item\" \nng-repeat=\"contract in vm.filteredContracts\" \nng-class=\"{\n                      \'highligth\'          : contract.over || contract.forceHighligth,\n                      \'related\'            : contract.scheduled_block.name,\n                      \'related-not-visible\': contract.related_not_visible,\n                      \'thin-border\'        : contract.is_sub_row,\n                      \'scheduled\'          : contract.scheduled_block && contract.scheduled_block.name\n                    }\" \nng-mouseover=\"vm.highligthRelated(\'contract\', contract, \'enter\')\" \nng-mouseleave=\"vm.highligthRelated(\'contract\', contract, \'leave\')\"><td md-cell class=\"w-50\" \nng-class=\"{\'child-row\': contract.is_sub_row}\"><md-button ng-hide=\"contract.is_sub_row\" aria-label=\"add contract\" \nclass=\"no-width md-accent\" ng-click=\"vm.hideToast(); vm.addContract(contract, $index)\" \nng-class=\"{\'disabled\': contract.availableContractAcres <= 0 || !contract.scheduled_block}\" \nng-disabled=\"contract.availableContractAcres <= 0 || !contract.scheduled_block\"><md-icon \nclass=\"icon-plus-circle font-size-20\"></md-icon></md-button><md-button ng-show=\"contract.is_sub_row\" \naria-label=\"remove contract\" class=\"no-width md-accent\" ng-click=\"vm.hideToast(); vm.removeContract($index, contract)\">\n<md-icon class=\"icon-minus-circle font-size-20\"></md-icon></md-button></td><td md-cell class=\"w-min-100\"><span \nng-hide=\"contract.is_sub_row\">{{contract.company_name}}</span></td><td md-cell class=\"w-dates text-center\"><span \nng-hide=\"contract.is_sub_row\">{{contract.original_wet_date | date:\'EEE, MMM d\'}}</span></td><td md-cell \nclass=\"w-min-100\"><span ng-hide=\"contract.is_sub_row\">{{contract.seed_name}}</span></td><td md-cell class=\"w-min-100\">\n<span ng-hide=\"contract.is_sub_row\">{{contract.variety.name}}</span></td><td md-cell class=\"w-dates text-center\"><span \nng-hide=\"contract.is_sub_row\">{{contract.original_harvest_date | date:\'EEE, MMM d\'}}</span></td><td md-cell \nclass=\"w-acres text-center draggable\" ui-draggable=\"contract.draggable && contract.acres > 0\" drag=\"contract\" \non-drop-success=\"vm.dropSuccessHandler($event, contract, $index)\" drag-channel=\"{{vm.dragChannel}}\"><div class=\"w-70p\">\n<span ng-if=\"!contract.is_sub_row\">{{contract.acres | numberFilter:1}}</span></div><md-input-container \nng-if=\"contract.is_sub_row\" class=\"md-block editable-row\"><input id=\"contractAcres{{$index}}\" \nname=\"contractAcres{{$index}}\" currency-input=\"acres\" class=\"text-center\" aria-label=\"acres\" ng-model=\"contract.acres\" \ntype=\"text\" val-max=\"{{contract.max_acres_value}}\" ng-keydown=\"contract.recalculate = true;\" \nng-blur=\"vm.updateAvailableAcres(contract)\" ng-focus=\"vm.hideToast();\" \nng-change=\"vm.hideToast(); vm.contractAcresChanged(contract, contractsForm.contractAcres{{$index}}.$invalid)\">\n</md-input-container><md-icon md-font-icon=\"icon-menu\" class=\"icon-drag\" \nng-class=\"{\'disabled\': !contract.draggable || contract.acres === 0}\" ng-click=\"vm.hideToast();\"></md-icon></td><td \nmd-cell class=\"w-acres acres-column text-center\"><span \nng-if=\"!contract.is_sub_row && contract.not_scheduled_acres > 0\" class=\"acres-column\">\n{{contract.not_scheduled_acres | numberFilter:1}} </span><span \nng-if=\"!contract.is_sub_row && contract.not_scheduled_acres < 0\" class=\"acres-column\" \nng-class=\"{\'negative-acres\': contract.not_scheduled_acres < 0}\">\n+{{ contract.not_scheduled_acres * -1 | numberFilter:1}}</span></td><td md-cell \nclass=\"w-15 md-accent-bg md-hue-1 separation\"></td><td md-cell class=\"w-min-100 shipper\">\n{{contract.scheduled_block.name}}</td><td md-cell class=\"w-acres text-center\"><span \nng-if=\"contract.scheduled_block.acres_scheduled\">{{contract.scheduled_block.acres_scheduled | numberFilter:1}}</span>\n</td><td md-cell class=\"w-dates text-center\">{{contract.scheduled_block.scheduled_wet_date | date:\'EEE, MMM d\'}}</td>\n</tr><tr md-row ng-hide=\"!loadingData && vm.filteredContracts.length === 0\"><td md-cell colspan=\"5\"></td><td md-cell \nclass=\"w-dates text-center\"><span class=\"total\">Acres Total:</span></td><td md-cell class=\"w-acres text-center\"><div \nclass=\"w-70p\"><span class=\"total\">{{vm.contractsAcresTotal | numberFilter:1}}</span></div></td><td md-cell colspan=\"5\">\n</td></tr><tr md-row ng-show=\"!loadingData && vm.filteredContracts.length === 0\"><td md-cell colspan=\"16\"><span \ntranslate=\"GROWER_SCHEDULE.NO_RESULTS\">No results..</span></td></tr><tr md-row ng-if=\"loadingData\" class=\"loader\" \nlayout=\"row\" layout-align=\"center center\"><ms-loader ng-if=\"loadingData\"></ms-loader></tr></tbody></table>\n</md-table-container></form></md-content><md-content layout=\"column\" flex class=\"md-whiteframe-4dp\" \nng-class=\"{\'margin-top-9\': !vm.isContractDisabled}\"><form id=\"growerSchedForm\" name=\"growerSchedForm\">\n<md-table-container id=\"growerSchedTableBody\" class=\"scrollable constrained\" ms-scroll><table md-table \nid=\"growerSchedTable\" class=\"row-border hover\"><thead fix-head md-head><tr md-row \nclass=\"md-accent-bg md-hue-1 section-titles\"><th md-column colspan=\"7\" class=\"\"><div class=\"first\"><span \ntranslate=\"GROWER_SCHEDULE.BLOCK_INFORMATION\" class=\"font-weight-500\"></span> <span ng-if=\"vm.growerSchedules.length\" \nclass=\"contracts-count font-weight-500\">({{vm.growerSchedules.length}})</span></div><div class=\"filters\" \nng-if=\"vm.active_filters.length\"><span ng-repeat=\"filter in vm.active_filters\"><span>{{filter.type}}: </span><span \nclass=\"font-weight-300\">{{filter.value}}</span> <span ng-if=\"!$last\">-</span></span></div></th><th md-column \ncolspan=\"9\" class=\"second\"><div layout=\"row\" layout-align=\"start center\"><div flex=\"70\"><span \ntranslate=\"GROWER_SCHEDULE.GROWER_SCHEDULE\" class=\"font-weight-500\"></span></div><div flex=\"25\" \nclass=\"search-input-wrapper block-search\"><md-input-container md-no-float class=\"md-icon-float md-block block-search\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><input id=\"block_search\" placeholder=\"Search\" type=\"text\" \nng-model=\"vm.auxblockSearch\" ng-model-options=\"{ debounce: 1000 }\" \nng-change=\"vm.hideToast(); vm.searchChanged(growerSchedForm.$invalid, contractsForm.$invalid, \'blockSearch\')\">\n</md-input-container></div><div flex=\"5\"><md-select \nng-hide=\"vm.isContractDisabled || (!loadingData2 && vm.growerSchedules.length === 0)\" aria-label=\"records\" \nng-model=\"vm.gs_num_records\" ng-change=\"vm.calculateTableHeight(\'growerSchedTableBody\', vm.gs_num_records)\" \nng-click=\"vm.hideToast();\" class=\"num-records\"><md-option ng-repeat=\"num in vm.num_of_records\" ng-value=\"{{num}}\">\n{{num}}</md-option></md-select></div></div></th></tr><tr md-row class=\"column-titles\"><th md-column class=\"w-50\"></th>\n<th md-column class=\"w-block\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE.BLOCK\"></span></th><th md-column \nclass=\"location\"></th><th md-column class=\"w-acres text-center\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.ACRES\"></span></th><th md-column class=\"w-acres text-center\"><span \nclass=\"column-title acres-column\" translate=\"GROWER_SCHEDULE.AVAILABLE_ACRES\"></span></th><th md-column \nclass=\"w-dates text-center\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE.LAST_HARVEST_DATE\"></span></th><th \nmd-column class=\"w-15 md-accent-bg md-hue-1 separation\"></th><th md-column class=\"shipper\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.SHIPPER\"></span></th><th md-column><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.PCA\"></span></th><th md-column class=\"w-dates text-center\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.SCHEDULED_WET_DATE\"></span></th><th md-column><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.SEED\"></span></th><th md-column><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.VARIETY\"></span></th><th md-column class=\"text-center\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.SCHEDULED_ACRES\"></span></th><th md-column class=\"text-center\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.GROWING_DAYS\"></span></th><th md-column class=\"text-center\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE.ESTIMATED_HARVEST_DATE\"></span></th><th md-column class=\"w-50\"></th></tr></thead><tbody \nmd-body ng-if=\"!loadingData2\"><tr md-row ui-on-drop=\"vm.onDrop(gs, $index)\" drop-channel=\"{{vm.dragChannel}}\" \nclass=\"grower-schedule-item\" \nng-class=\"{\n                      \'highligth\'         : gs.over || gs.forceHighligth,\n                      \'related\'           : gs.contract_schedule_variety_id,\n                      \'thin-border\'       : gs.isSubBlock || gs.isLocation,\n                      \'scheduled\'         : gs.company_id && gs.pca_id && gs.scheduled_wet_date && gs.seed_id &&\n                                            gs.scheduled_acres >= 0 && gs.growing_days >= 0 && gs.scheduled_harvest_date\n                    }\" \nng-repeat=\"gs in vm.growerSchedules track by $index\" ng-mouseover=\"vm.highligthRelated(\'block\', gs, \'enter\')\" \nng-mouseleave=\"vm.highligthRelated(\'block\', gs, \'leave\')\"><td md-cell class=\"w-50\" \nng-class=\"{\'child-row\': gs.isSubBlock}\"><md-button ng-hide=\"gs.isSubBlock || gs.isLocation\" aria-label=\"add sub block\" \nclass=\"no-width md-accent\" \nng-class=\"{\'disabled\': !gs.availableBlockAcres || !gs.available_acres || gs.cannotAddSubblock}\" \nng-disabled=\"!gs.availableBlockAcres || !gs.available_acres || gs.cannotAddSubblock\" \nng-click=\"vm.hideToast(); vm.addSubBlock($index, gs)\"><md-icon class=\"icon-plus-circle font-size-20\"></md-icon>\n<md-tooltip><div>Different Wet Date</div></md-tooltip></md-button><md-button class=\"no-width md-accent\" \nng-show=\"gs.isSubBlock && !gs.isLocation\" ng-class=\"{\'disabled\': !gs.canRemove}\" ng-disabled=\"!gs.canRemove\" \naria-label=\"add sub block\" ng-click=\"vm.hideToast(); vm.removeSubBlock($index, gs)\"><md-icon \nclass=\"icon-minus-circle font-size-20\"></md-icon></md-button></td><td md-cell class=\"w-block\"><span>{{gs.block_name}}\n</span></td><td md-cell class=\"text-center location\"><md-button class=\"no-width md-accent\" \nng-hide=\"gs.hasSubBlock || !gs.canAddLocation\" ng-disabled=\"gs.hasAllLocations || gs.availableBlockAcres === 0\" \nng-class=\"{\'disabled\': gs.hasAllLocations || gs.availableBlockAcres === 0}\" aria-label=\"add location\" \nng-click=\"vm.hideToast(); vm.addLocation($index, gs)\"><md-icon class=\"icon-plus-circle font-size-20\"></md-icon>\n<md-tooltip><div>Common Wet Date</div></md-tooltip></md-button><md-button ng-show=\"gs.isLocation\" \nng-disabled=\"gs.grower_schedule_id > 0\" ng-class=\"{\'disabled\': gs.grower_schedule_id > 0}\" \naria-label=\"remove location\" ng-click=\"vm.hideToast(); vm.removeLocation($index, gs)\" class=\"no-width md-accent\">\n<md-icon class=\"icon-minus-circle font-size-20\"></md-icon></md-button></td><td md-cell class=\"w-acres text-center\">\n<span>{{gs.acres_in_block | numberFilter:1}}</span></td><td md-cell class=\"w-acres text-center\"><span \nng-if=\"gs.available_acres && (gs.hasSubBlock || (gs.hasLocations && !gs.isSubBlock) || (!gs.isSubBlock && !gs.isLocation))\" \nclass=\"acres-column\">{{gs.available_acres | numberFilter:1}}</span></td><td md-cell class=\"w-dates text-center\"><span \nng-if=\"gs.hasSubBlock || (gs.hasLocations && !gs.isSubBlock) || (!gs.isSubBlock && !gs.isLocation)\">\n{{gs.last_harvest_date | date:\'EEE, MMM d\'}}</span></td><td md-cell class=\"w-15 md-accent-bg md-hue-1 separation\"></td>\n<td md-cell class=\"w-min-100 shipper\"><span ng-if=\"!gs.hasSubBlock && gs.dropped \">{{gs.company_name}}</span><md-select\n id=\"shipper{{$index}}\" md-no-asterisk=\"true\" ng-if=\"!gs.hasSubBlock && !gs.dropped\" aria-label=\"owners\" \nng-model=\"gs.company_id\" ng-change=\"vm.markAsChanged(gs)\" ng-click=\"vm.hideToast()\" \nng-required=\"gs.pca_id || gs.scheduled_wet_date || gs.seed_id ||\n                          gs.variety_id || gs.scheduled_acres > 0 || gs.growing_days || gs.scheduled_harvest_date\">\n<md-option ng-if=\"vm.allOwners.length === 0\" ng-click=\"vm.goTo(\'/companies/\')\">No <b>Shippers</b> to show<br>\nGo to Companies page</md-option><md-option ng-if=\"vm.allOwners.length > 0\" ng-repeat=\"owner in vm.allOwners\" \nng-value=\"{{owner.id}}\">{{owner.name}}</md-option></md-select></td><td md-cell class=\"w-min-100\"><md-select \nmd-no-asterisk=\"true\" ng-if=\"!gs.hasSubBlock\" aria-label=\"pca_users\" ng-model=\"gs.pca_id\" \nng-change=\"vm.markAsChanged(gs)\" ng-click=\"vm.hideToast()\" \nng-required=\"gs.company_id || gs.scheduled_wet_date || gs.seed_id ||\n                          gs.variety_id || gs.scheduled_acres > 0 || gs.growing_days || gs.scheduled_harvest_date\">\n<md-option ng-if=\"vm.pca_users.length === 0\" ng-click=\"vm.goTo(\'/users\')\">No <b>PCA Users</b> to show<br>\nGo to Users page</md-option><md-option ng-if=\"vm.pca_users.length > 0\" ng-repeat=\"pca in vm.pca_users\" \nng-value=\"{{pca.id}}\">{{pca.login_name}}</md-option></md-select></td><td md-cell class=\"w-dates text-center\"><span \nng-show=\"!gs.hasSubBlock && gs.isLocation\" \nng-class=\"{\'ng-invalid\': gs.wet_date_error || gs.wet_date_period_error || gs.last_harvest_date_error}\">\n{{gs.scheduled_wet_date | date:\'EEE, MMM d\' }}</span><md-datepicker datepicker id=\"scheduledWetDate{{$index}}\" \nname=\"scheduledWetDate{{$index}}\" ng-if=\"!gs.hasSubBlock && !gs.isLocation\" ng-model=\"gs.scheduled_wet_date\" \nng-class=\"{\'ng-invalid\': gs.wet_date_error || gs.wet_date_period_error || gs.last_harvest_date_error}\" \nmd-date-locale=\"vm.customDateFormat\" md-date-filter=\"vm.isInCurrentFiscalYear\" md-placeholder=\"\" md-open-on-focus \nmd-hide-icons=\"calendar\" \nng-change=\"vm.hideToast(); vm.calculateGrowingDays(gs, \'wet_date\', false); vm.markAsChanged(gs);\" \nng-focus=\"vm.hideToast()\" \nng-required=\"gs.pca_id || gs.company_id || gs.seed_id ||\n                        gs.variety_id || gs.scheduled_acres > 0 || gs.growing_days || gs.scheduled_harvest_date\">\n</md-datepicker></td><td md-cell class=\"w-min-100\"><span ng-if=\"!gs.hasSubBlock && gs.dropped\">{{gs.seed_name}}</span>\n<md-select md-no-asterisk=\"true\" ng-if=\"!gs.hasSubBlock && !gs.dropped\" aria-label=\"seeds\" ng-model=\"gs.seed_id\" \nng-change=\"vm.markAsChanged(gs)\" ng-click=\"vm.hideToast()\" \nng-required=\"gs.pca_id || gs.company_id || gs.scheduled_wet_date ||\n                        gs.variety_id || gs.scheduled_acres > 0 || gs.growing_days || gs.scheduled_harvest_date\">\n<md-option ng-if=\"vm.seeds.length === 0\" ng-disabled=\"true\">No <b>Seeds</b> to show<br></md-option><md-option \nng-if=\"vm.seeds.length > 0\" ng-repeat=\"seed in vm.seeds\" ng-value=\"{{seed.id}}\" \nng-click=\"gs.seed_name = seed.name; vm.getSeedVarieties(seed.id, gs);\">{{seed.name}}</md-option></md-select></td><td \nmd-cell class=\"w-min-100\"><md-select id=\"variety{{$index}}\" name=\"variety{{$index}}\" md-no-asterisk=\"true\" \nng-if=\"!gs.hasSubBlock\" aria-label=\"varieties\" ng-model=\"gs.variety_id\" ng-change=\"vm.markAsChanged(gs)\" \nng-click=\"vm.hideToast()\" ng-class=\"{\'ng-invalid\': gs.varietyError}\"><md-option \nng-if=\"gs.scheduled_wet_date && gs.seed_id && gs.seedVarieties.length === 0\" ng-disabled=\"true\"><span>No <b>Varieties\n</b> with selected <b>Wet Date</b><br></span></md-option><md-option ng-if=\"gs.scheduled_wet_date && !gs.seed_id\" \nng-disabled=\"true\"><span>Enter <b>Seed</b></span></md-option><md-option ng-if=\"!gs.scheduled_wet_date\" \nng-disabled=\"true\"><span>Enter <b>Wet Date</b></span></md-option><md-option ng-repeat=\"variety in gs.seedVarieties\" \nng-value=\"{{variety.id}}\" ng-click=\"gs.variety_name = variety.name\">{{variety.name}}</md-option></md-select></td><td \nmd-cell class=\"w-acres text-center\"><md-input-container class=\"editable-row\" ng-if=\"!gs.hasSubBlock\"><input \nid=\"blockSchedAcres{{$index}}\" name=\"blockSchedAcres{{$index}}\" currency-input=\"acres\" class=\"text-center\" \naria-label=\"scheduled_acres\" ng-model=\"gs.scheduled_acres\" type=\"text\" val-min=\"0\" \nval-max=\"{{gs.max_sched_acres_block}}\" ng-focus=\"vm.hideToast()\" \nng-keydown=\"gs.recalculate = true; gs.changed = true;\" ng-blur=\"vm.calculateBlockSchedAcresMax(gs)\" \nng-change=\"vm.hideToast(); vm.blockSchedAcresChanged(gs, growerSchedForm.blockSchedAcres{{$index}}.$invalid, true)\" \nng-required=\"gs.pca_id || gs.company_id || gs.scheduled_wet_date || gs.seed_id ||\n                            gs.variety_id || gs.growing_days || gs.scheduled_harvest_date\">\n</md-input-container></td><td md-cell class=\"w-growing text-center\"><md-input-container class=\"editable-row\" \nng-hide=\"gs.hasSubBlock\"><input id=\"growingDays{{$index}}\" name=\"growingDays{{$index}}\" currency-input=\"integer\" \nclass=\"text-center\" aria-label=\"growing_days\" ng-model=\"gs.growing_days\" ng-model-options=\"{ debounce: 800 }\" \ntype=\"text\" val-min=\"0\" ng-focus=\"vm.hideToast()\" \nng-change=\"vm.hideToast(); vm.calculateGrowingDays(gs, \'growing_days\', false); vm.markAsChanged(gs);\" \nng-required=\"gs.pca_id || gs.company_id || gs.scheduled_wet_date || gs.seed_id ||\n                          gs.variety_id || gs.scheduled_acres > 0 || gs.scheduled_harvest_date\">\n</md-input-container></td><td md-cell class=\"w-dates text-center\"><md-datepicker datepicker \nid=\"scheduledHarvestDate{{$index}}\" name=\"scheduledHarvestDate{{$index}}\" ng-hide=\"gs.hasSubBlock\" \nng-model=\"gs.scheduled_harvest_date\" \nng-class=\"{\'ng-invalid\': gs.harvest_date_error || gs.harvest_date_period_error || gs.max_harvest_date_error}\" \nng-change=\"vm.hideToast(); vm.calculateGrowingDays(gs, \'harvest_date\', false); vm.markAsChanged(gs);\" \nng-focus=\"vm.hideToast()\" md-min-date=\"gs.scheduled_wet_date\" md-date-filter=\"vm.isInCurrentFiscalYear\" \nmd-date-locale=\"vm.customDateFormat\" md-open-on-focus md-hide-icons=\"calendar\" md-placeholder=\"\" \nng-required=\"gs.pca_id || gs.company_id || gs.scheduled_wet_date || gs.seed_id ||\n                        gs.variety_id || gs.scheduled_acres > 0 || gs.growing_days\">\n</md-datepicker></td><td md-cell class=\"w-50 text-center\"><md-menu><md-button ng-show=\"!gs.hasSubBlock\" \nclass=\"md-icon-button actions\" ng-click=\"vm.hideToast(); $mdMenu.open($event)\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"CONTRACTS.CROPS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" id=\"icon-dot\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-disabled=\"gs.hasLocations ||\n                                                 (!gs.isSubBlock && !gs.hasLocations && !gs.isLocation && gs.max_schedule_level &&  vm.aux_double_crop_num !== gs.max_schedule_level) ||\n                                                 (gs.isSubBlock && !gs.canRemove && gs.max_schedule_level && vm.aux_double_crop_num !== gs.max_schedule_level)\" \naria-label=\"clear-data\" translate=\"GROWER_SCHEDULE.CLEAR_DATA\" ng-click=\"vm.clearData(gs)\"></md-button></md-menu-item>\n<md-menu-item ng-if=\"gs.cleared\"><md-button aria-label=\"clear-data\" translate=\"GROWER_SCHEDULE.RESTORE_DATA\" \nng-click=\"vm.restoreClearedRow(gs)\"></md-button></md-menu-item><md-menu-item ng-if=\"gs.hasLocations\"><md-button \naria-label=\"clear-data\" translate=\"GROWER_SCHEDULE.CLEAR_ALL\" ng-click=\"vm.clearAllRows(gs)\"></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr><tr md-row \nng-hide=\"!loadingData2 && vm.growerSchedules.length === 0\"><td md-cell colspan=\"3\" class=\"text-right\"><span \nclass=\"total\">Acres Total:</span></td><td md-cell class=\"w-acres text-center\"><span class=\"total\">\n{{vm.blocksAcresTotal | numberFilter:1}}</span></td><td md-cell colspan=\"12\"></td></tr><tr md-row \nng-show=\"!loadingData2 && vm.growerSchedules.length === 0\"><td md-cell colspan=\"16\"><span \ntranslate=\"GROWER_SCHEDULE.NO_RESULTS\">No results..</span></td></tr><tr ng-if=\"loadingData2\" md-row class=\"loader\" \nlayout=\"row\" layout-align=\"center center\"><ms-loader ng-if=\"loadingData2\"></ms-loader></tr></tbody></table>\n</md-table-container></form></md-content></div></div></div>");
$templateCache.put("app/main/pages/planting-schedule/planting-schedule.html","<div id=\"planting-schedule\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" layout-align=\"start center\"><md-button \nid=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"PLANTING_SCHEDULE.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><span \nclass=\"logo-text\" translate=\"PLANTING_SCHEDULE.CONTRACTS\">Planting Schedules</span></div></div><div flex-xs=\"45\" \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for planting schedule\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"PLANTING_SCHEDULE.SEARCH_FOR_CONTRACT\"></md-input-container></div></div><div \nng-show=\"vm.selectedContracts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContracts =[]\"><md-button \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"PLANTING_SCHEDULE.BACK\">Back</span></md-button></div><div flex layout=\"row\" \nlayout-align=\"space-between center\"><div><span class=\"selected-planting-schedule-count\"><span>\n{{vm.selectedContracts.length}}</span> <span translate=\"PLANTING_SCHEDULE.SELECTED\">selected</span></span><md-menu \nclass=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \naria-label=\"multi select toggle\" translate translate-attr-aria-label=\"PLANTING_SCHEDULE.MULTI_SELECT_TOGGLE\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectAllContracts()\" translate=\"PLANTING_SCHEDULE.SELECT_ALL\">Select all</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.deselectContracts()\" translate=\"PLANTING_SCHEDULE.SELECT_NONE\">Select none\n</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div class=\"content\" md-background-bg \nlayout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/pages/planting-schedule/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\"><md-list\n class=\"planting-schedule-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\">\n<div class=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \nng-if=\"vm.listType === \'all\'\" translate=\"PLANTING_SCHEDULE.ALL_CONTRACTS\"></span> <span ng-if=\"vm.listType === \'all\'\" \nclass=\"secondary-text planting-schedule-count\"></span> <span ng-if=\"vm.listType === \'starred\'\" \ntranslate=\"PLANTING_SCHEDULE.STARRED_CONTRACTS\"></span> <span ng-if=\"vm.listType.name\">{{vm.listType.name}}</span> \n<span ng-if=\"vm.listType !== \'all\' && vm.filterIds.length\" class=\"secondary-text contracts-count\">\n({{vm.filterIds.length}})</span></div></div></md-subheader><div class=\"content white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"w-10-p\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE.SHIPPERS\"></span></div></th><th class=\"w-10-p\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"PLANTING_SCHEDULE.WET_DATE\"></span></div></th><th class=\"w-10-p\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.BLOCK\"></span></div></th><th \nclass=\"w-10-p\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.SEED\"></span></div>\n</th><th class=\"w-10-p\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.VARIETY\">\n</span></div></th><th class=\"w-10-p\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE.ACRES\"></span></div></th><th class=\"w-10-p\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"PLANTING_SCHEDULE.PLANTING_DATE\"></span></div></th><th class=\"w-10-p\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.BED_COUNT\"></span></div></th><th \nclass=\"w-10-p\"><div class=\"table-header\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.BED_STATUS\"></span>\n</div></th><th class=\"w-10-p\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE.PLANTING_STATUS\"></span></div></th><th class=\"w-100\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.ACTIONS\"></span></div></th>\n</tr></thead><tbody class=\"scrollable constrained\" ms-scroll ng-if=\"!loadingData && vm.filterIds.length>0\" \nms-infinite-scroll=\"vm.loadMore()\" ms-infinite-scroll-container=\'\".constrained\"\' ng-style=\"setSize(318)\" resize><tr \nclass=\"planting-schedule-item md-white-bg\" ng-click=\"vm.editContract(ev, contract)\" \nng-repeat=\"contract in vm.shownContracts | filter: vm.search | filter: global.search | filterByIds: vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContracts track by contract.id | limitTo:vm.offset \">\n<td class=\"w-10-p shipper\">{{ contract.shipper }}</td><td class=\"w-10-p\">{{ contract.wet_date | date: \'mediumDate\' }}\n</td><td class=\"w-10-p\">{{ contract.block }}</td><td class=\"w-10-p\">{{ contract.seed }}</td><td class=\"w-10-p\">\n{{ contract.variety }}</td><td class=\"w-10-p\">{{ contract.acres }}</td><td class=\"w-10-p\">\n{{ contract.planting_date | date: \'mediumDate\' }}</td><td class=\"w-10-p\">{{ contract.bed_count }}</td><td \nclass=\"w-10-p\">{{ contract.bed_status }}</td><td class=\"w-10-p\">{{ contract.planting_status }}</td><td \nclass=\"actions w-100\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleInArray(contract.id, vm.starredContracts);vm.patchStarred(contract)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"PLANTING_SCHEDULE.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.exists(contract.id,vm.starredContracts)\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.exists(contract.id,vm.starredContracts)\" md-font-icon=\"icon-star-outline\"></md-icon></md-button></td></tr>\n</tbody></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader>\n</ms-loader></md-list-item><md-list-item class=\"md-white-bg\" ng-show=\"!loadingData && filteredContracts.length === 0\">\n<p class=\"padding-left-8\" translate=\"PLANTING_SCHEDULE.NO_RESULTS\">No results..</p></md-list-item></div></md-list>\n</div></div><md-button show-xs show-sm hide-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nid=\"add-planting-schedule-button-mobile\" ng-click=\"vm.addContract()\" aria-label=\"add contract\" translate \ntranslate-attr-aria-label=\"PLANTING_SCHEDULE.ADD_CONTRACT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button hide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" id=\"add-planting-schedule-button\" \nng-click=\"vm.addContract()\" aria-label=\"add contract\" translate \ntranslate-attr-aria-label=\"PLANTING_SCHEDULE.ADD_CONTRACT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n</div>");
$templateCache.put("app/main/pages/work-schedule/work-schedule.html","<div id=\"gantt-chart\" class=\"page-layout carded fullwidth\" \nng-class=\"{\'date-filter-active\':vm.dateFilterActive, \'search-active\': vm.searchActive}\" layout=\"row\"><div \nclass=\"top-bg md-accent-bg\"></div><div class=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"column\"><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-text\" class=\"icon\"></md-icon>\n</span><span class=\"logo-text\" translate=\"GANTT.GANTT_CHART\">Gantt Chart</span></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-icon-button\" ng-click=\"vm.searchActive = !vm.searchActive\" \naria-label=\"Search\" translate translate-attr-aria-label=\"GANTT.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon>\n<md-tooltip><span translate=\"GANTT.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.dateFilterActive = !vm.dateFilterActive\" aria-label=\"Filter Date\" translate \ntranslate-attr-aria-label=\"GANTT.FILTER_DATE\"><md-icon md-font-icon=\"icon-calendar\"></md-icon><md-tooltip><span \ntranslate=\"GANTT.FILTER_DATE\">Filter Date</span></md-tooltip></md-button></div></div><div class=\"bottom\" \nlayout=\"column\" layout-gt-sm=\"row\" layout-align-gt-sm=\"end center\"><div class=\"search-boxes\" flex \nng-show=\"vm.searchActive\" layout=\"column\" layout-gt-xs=\"row\"><div class=\"search md-whiteframe-3dp mr-8\" flex \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex \nng-model=\"searchRowKeyword\" ng-change=\"vm.search(\'rows\', vm.searchRowKeyword)\" type=\"text\" \nplaceholder=\"Search in rows\" translate translate-attr-placeholder=\"GANTT.SEARCH_IN_ROWS\"></div><div \nclass=\"search md-whiteframe-3dp\" flex layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input flex ng-model=\"vm.searchTaskKeyword\" \nng-change=\"vm.search(\'tasks\', vm.searchTaskKeyword)\" type=\"text\" placeholder=\"Search in tasks\" translate \ntranslate-attr-placeholder=\"GANTT.SEARCH_IN_TASKS\"></div></div><div class=\"date-filter-box md-whiteframe-3dp\" \nng-show=\"vm.dateFilterActive\" layout=\"column\" layout-gt-xs=\"row\" layout-align-gt-xs=\"center center\"><div layout=\"row\" \nlayout-align=\"center center\" class=\"filter from\"><span class=\"label\">Date:</span><md-datepicker md-open-on-focus \nms-datepicker-fix ng-change=\"vm.changeDate()\" ng-model=\"options.pickerFromDate\" md-placeholder=\"Enter date\">\n</md-datepicker></div></div></div></div><div class=\"content-card scrollable constrained\" ms-scroll \nng-style=\"setSize(318)\" resize layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button ng-if=\"vm.ganttBlockMode\" \nng-disabled=\"!vm.selectedBlock\" class=\"md-icon-button\" ng-click=\"vm.openDialogWorkSchedule($event,vm.selectedBlock);\" \naria-label=\"Back\"><md-icon md-font-icon=\"icon-indent\" class=\"icon\"></md-icon><md-tooltip>Work schedule template\n</md-tooltip></md-button><md-button ng-if=\"vm.ganttBlockMode\" \nng-disabled=\"!vm.selectedBlock || !vm.selectedBlock.work_template\" class=\"md-icon-button\" \nng-click=\"vm.openDialogAssignTeams($event,vm.selectedBlock);\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-worker\" \nclass=\"icon\"></md-icon><md-tooltip>Assign Teams</md-tooltip></md-button><md-button ng-if=\"vm.ganttBlockMode\" \nng-disabled=\"!vm.selectedBlock || !vm.selectedBlock.work_template\" class=\"md-icon-button\" \nng-click=\"vm.openGanttTaskDialog($event,vm.selectedBlock);\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-plus\" \nclass=\"icon\"></md-icon><md-tooltip>Add Task</md-tooltip></md-button><md-button ng-if=\"!vm.ganttBlockMode\" \nng-disabled=\"!vm.selectedBlock\" class=\"md-icon-button\" ng-click=\"vm.openGanttTaskDialog($event,vm.selectedBlock);\" \naria-label=\"Back\"><md-icon md-font-icon=\"icon-plus\" class=\"icon\"></md-icon><md-tooltip>Add Task</md-tooltip>\n</md-button><md-switch ng-change=\"vm.changeGanttMode()\" ng-model=\"vm.ganttBlockMode\" aria-label=\"Switch 1\"><label>\nForeman tasks</label></md-switch><label></label><md-switch ng-change=\"vm.changeDaylight()\" ng-model=\"vm.daylightOnly\" \naria-label=\"Switch 1\"><label>Daylight only</label></md-switch></div><div layout=\"row\" layout-align=\"start center\">\n<md-select class=\"simplified select-scale\" ng-change=\"options.changeShowName(data)\" ng-model=\"options.showName\" \nplaceholder=\"Show Name By\"><md-option value=\"task\">Task</md-option><md-option value=\"phase\">Phase</md-option><md-option\n value=\"foreman\">Foreman</md-option><md-option value=\"labor_group\">Labor Group</md-option><md-option value=\"equipment\">\nEquipment</md-option></md-select><md-select class=\"simplified select-scale\" ng-change=\"options.changeScale()\" \nng-model=\"options.scale\" placeholder=\"Scale\"><md-option value=\"day\" translate=\"GANTT.DAY\">day</md-option><md-option \nvalue=\"2 days\" translate=\"GANTT.TWO_DAYS\">two days</md-option><md-option value=\"3 days\" translate=\"GANTT.THREE_DAYS\">\nthree days</md-option><md-option value=\"week\" translate=\"GANTT.WEEK\">week</md-option><md-option value=\"month\" \ntranslate=\"GANTT.MONTH\">month</md-option><md-option value=\"6 months\">6 months</md-option><md-option value=\"year\" \ntranslate=\"GANTT.YEAR\">year</md-option></md-select></div></div><div layout=\"row\" \nstyle=\"background-color:#fafafa;padding:5px;margin-bottom:-35px\"><div style=\"width:300px\"></div><div flex=\"50\" \nlayout=\"row\" layout-align=\"start center\"><md-button ng-click=\"vm.goPreviousDate()\" style=\"z-index:2\" \nclass=\"md-icon-button\"><i class=\"fa fa-24 fa-arrow-left\"></i></md-button></div><div flex=\"50\" layout=\"row\" \nlayout-align=\"end center\"><md-button ng-click=\"vm.goNextDate()\" style=\"z-index:2\" class=\"md-icon-button\"><i \nclass=\"fa fa-24 fa-arrow-right\"></i></md-button></div></div><md-content id=\"chart-container\" class=\"content\" flex \nlayout=\"column\"><div flex layout-fill id=\"gantt\" gantt data=\"data\" timespans=\"timespans\" \nshow-side=\"options.labelsEnabled\" daily=\"options.daily\" filter-task=\"{\'name\': options.filterTask}\" \nfilter-row=\"{\'name\': options.filterRow}\" sort-mode=\"options.sortMode\" view-scale=\"options.scale\" \ncolumn-width=\"getColumnWidth(options.width, options.scale, options.zoom)\" auto-expand=\"options.autoExpand\" \ntask-out-of-range=\"options.taskOutOfRange\" from-date=\"options.fromDate\" to-date=\"options.toDate\" \nallow-side-resizing=\"options.allowSideResizing\" \ntask-content=\"options.taskContentEnabled ? options.taskContent : undefined\" \nrow-content=\"options.rowContentEnabled ? options.rowContent : undefined\" current-date=\"options.currentDate\" \ncurrent-date-value=\"options.currentDateValue\" headers=\"options.currentHeader\" headers-formats=\"options.headerFormats\" \nmax-height=\"options.maxHeight && 300 || 0\" time-frames=\"options.timeFrames\" date-frames=\"options.dateFrames\" \nheaders-scales=\"options.columnScales\" time-frames-working-mode=\"\'visible\'\" time-frames-non-working-mode=\"\'visible\'\" \ntime-frames-magnet=\"options.timeFramesMagnet\" api=\"options.api\" column-magnet=\"options.columnMagnet\"><gantt-tree \nenabled=\"options.sideMode === \'Tree\' || options.sideMode === \'TreeTable\'\" header-content=\"options.treeHeaderContent\" \nkeep-ancestor-on-filter-row=\"true\"></gantt-tree><gantt-table \nenabled=\"options.sideMode === \'Table\' || options.sideMode === \'TreeTable\'\" \ncolumns=\"options.sideMode === \'TreeTable\' ? options.treeTableColumns : options.columns\" \nheaders=\"options.columnsHeaders\" classes=\"options.columnsClasses\" formatters=\"options.columnsFormatters\" \ncontents=\"options.columnsContents\" header-contents=\"options.columnsHeaderContents\"></gantt-table><gantt-corner \nheaders-labels=\"options.corner.headersLabels\" headers-labels-templates=\"options.corner.headersLabelsTemplates\">\n</gantt-corner><gantt-groups \nenabled=\"options.groupDisplayMode === \'group\' || options.groupDisplayMode === \'overview\' || options.groupDisplayMode === \'promote\'\" \ndisplay=\"options.groupDisplayMode\"></gantt-groups><gantt-tooltips></gantt-tooltips><gantt-bounds></gantt-bounds>\n<gantt-progress></gantt-progress><gantt-sortable></gantt-sortable><gantt-sections></gantt-sections><gantt-movable \nenabled=\"!options.readOnly\" allow-row-switching=\"options.movable.allowRowSwitching\"></gantt-movable><gantt-draw-task \nenabled=\"options.canDraw\" move-threshold=\"2\" task-factory=\"options.drawTaskFactory\"></gantt-draw-task><gantt-overlap \nenabled=\"false\" global=\"false\"></gantt-overlap><gantt-resize-sensor></gantt-resize-sensor><gantt-dependencies \nenabled=\"options.dependencies.enabled\" conflict-checker=\"options.dependencies.conflictChecker\" \nread-only=\"options.readOnly\"></gantt-dependencies></div></md-content></div></div></div>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-collapsed\">\n{{vm.company.name.charAt(0).toUpperCase() || \'G\'}}</span> <span class=\"logo-full\"><img width=\"260\" height=\"151\" \nhttp-src=\"{{vm.company.image_url || \'assets/images/logos/ggs-white.png\'}}\" alt=\"GoGreenSky technologies\"></span></div>\n<md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/theme-panel/tabs/settings-layout/settings-layout.html","<md-list class=\"colors\"><md-list-item class=\"color md-3-line\"><ms-custom-theme-options></ms-custom-theme-options>\n</md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.users.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div \nclass=\"online_status {{contact.online_status}}\"></div><div ng-if=\"contact.unread\" \nclass=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div class=\"md-list-item-text\"><h3>{{contact.name}}\n</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div></md-list-item></md-list><md-divider></md-divider>\n<md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat\n</span></md-subheader><md-list-item class=\"contact\" ng-repeat=\"contact in vm.users.all\" \nng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div \nclass=\"online_status {{contact.online_status}}\"></div><div class=\"md-list-item-text\"><h3>{{contact.name}}</h3></div>\n</md-list-item></md-list><md-divider></md-divider></div><div class=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" \nlayout=\"column\"><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate translate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon \nmd-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4><span>{{vm.chat.contact.name}}</span></h4></div><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"md-icon-button\" aria-label=\"Call\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon md-font-icon=\"icon-phone\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div></div></md-toolbar><md-content flex layout-paddings \nms-scroll id=\"chat-dialog\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat.contact.dialog\" \nclass=\"md-padding message-row\" ng-class=\"dialog.who\"><img ng-if=\"dialog.who ===\'contact\'\" \nng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img ng-if=\"dialog.who ===\'user\'\" \nclass=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div class=\"message\">{{dialog.message}}\n</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content><form ng-submit=\"vm.reply()\" \nlayout=\"row\" class=\"reply\" layout-align=\"start center\"><md-button class=\"md-fab md-mini\" type=\"submit\" \naria-label=\"Send message\" translate translate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon \nmd-font-icon=\"icon-send\" class=\"s16\"></md-icon></md-button></form></div>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>{{event.detail}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" ng-repeat=\"note in vm.notes\">\n<div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>{{note.detail}}</p></div></md-list-item></md-list><md-divider>\n</md-divider><md-list><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings\n</span></md-subheader><md-list-item><h3 translate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch \nclass=\"md-secondary\" ng-model=\"vm.settings.notify\" aria-label=\"Notifications\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item><md-list-item><h3 \ntranslate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.cloud\" \naria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch class=\"md-secondary md-warn\" \nng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/toolbar/dialogs/area-fiscal-year/area-fiscal-year-dialog.html","<md-dialog class=\"area-fiscal-year-dialog\" aria-label=\"New Task\"><form name=\"areaFiscalYear\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"TOOLBAR.AREA_FISCAL_YEAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block pb-20\" flex-gt-sm>\n<label translate=\"TOOLBAR.AREA_FISCAL_YEAR.AREA_NAME\"></label><md-icon md-font-icon=\"icon-earth\" class=\"name\">\n</md-icon><md-select required ng-model=\"vm.area.id\"><md-option ng-repeat=\"area in vm.areas\" value=\"{{area.id}}\" \nng-selected=\"vm.getSelected(area)\">{{area.name}}</md-option></md-select><div ng-messages=\"vm.form.area.id.$error\"><div \nng-message=\"required\">Area is required.</div></div></md-input-container><md-input-container class=\"md-block pb-20\" \nflex-gt-sm><label translate=\"TOOLBAR.AREA_FISCAL_YEAR.GROWING_YEAR\"></label><md-icon \nmd-font-icon=\"icon-calendar-check\" class=\"name\"></md-icon><md-select required ng-model=\"vm.fy.id\"><md-option \nng-repeat=\"fy in vm.fiscalYears track by fy.id\" value=\"{{fy.id}}\" ng-selected=\"vm.getSelected(\'\', fy)\">{{fy.name}}\n</md-option></md-select><div ng-messages=\"vm.form.fy.id.$error\"><div ng-message=\"required\">Fiscal year is required.\n</div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newUser\" ng-click=\"vm.saveAreaFiscalYear()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"areaFiscalYear.$invalid || areaFiscalYear.$pristine\" aria-label=\"SAVE\" \ntranslate=\"TOOLBAR.AREA_FISCAL_YEAR.SET\" translate-attr-aria-label=\"TOOLBAR.AREA_FISCAL_YEAR.SET\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/toolbar/dialogs/user/edit-dialog.html","<md-dialog class=\"user-dialog\" aria-label=\"New Task\"><form name=\"userForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog(true)\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"USERS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div name=\"file\" class=\"clickeable\" \nngf-select=\"vm.openImgCropDialog(event,$file)\" ngf-max-size=\"1MB\" ng-model=\"vm.picFile\" accept=\"image/*\" \nngf-resize=\"{width: 250, height: 250}\" ngf-before-model-change=\"vm.invalidImage($files)\" layout=\"column\" \nlayout-align=\"center center\"><md-tooltip md-direction=\"top\"><span>Avatar</span></md-tooltip><span \nng-if=\"userForm.$dirty && userForm.file.$error.maxSize\" class=\"danger\">Max file size 1MB</span> <img \nhttp-src=\"{{vm.user.image_url || \'assets/images/avatars/profile.jpg\'}}\" class=\"md-avatar avatar user-avatar huge\" \nalt=\"{{vm.user.name}}\"><div class=\"user-name\">{{vm.user.name}}</div></div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-click=\"event.stopPropagation();vm.starredUser(vm.user);\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon ng-if=\"vm.user.starred\" md-font-icon=\"icon-star\" \nclass=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.user.starred\" md-font-icon=\"icon-star-outline\"></md-icon></md-button>\n</div></div></md-toolbar><md-dialog-content ms-scroll><md-checkbox ng-checked=\"vm.user.active\" \nng-model=\"vm.user.active\">Active</md-checkbox><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"USERS.NAME_REQUIRED\"></label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"vm.user.name\" type=\"text\" ng-pattern=\"/^[a-zA-Z\\s]*$/\" md-maxlength=\"50\" required md-autofocus><div \nng-messages=\"vm.user.name.$error\" role=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\">\n<span translate=\"USERS.FIELD_REQUIRED\"></span></div><div ng-message=\"pattern\"><span translate=\"USERS.ONLY_LETTERS\">\n</span></div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"USERS.NICKNAME\"></label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"vm.user.login_name\" type=\"text\" md-maxlength=\"30\" required></md-input-container><md-autocomplete \nstyle=\"margin-bottom: -18px\" class=\"black-text\" required md-selected-item=\"vm.user.company\" md-no-cache=\"false\" \nmd-search-text-change=\"vm.searchTextChange(vm.companySearchText)\" md-search-text=\"vm.companySearchText\" \nmd-selected-item-change=\"vm.selectedCompanyChange(item)\" md-items=\"item in vm.queryCompany(vm.companySearchText)\" \nmd-item-text=\"item.name\" md-min-length=\"0\" md-require-match md-floating-label=\"Company\"><md-item-template><span \nmd-highlight-text=\"vm.companySearchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo results matching \"{{vm.companySearchText}}\" were found.</md-not-found></md-autocomplete><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"USERS.EMAIL\"></label><md-icon md-font-icon=\"icon-email\" class=\"email\">\n</md-icon><input ng-model=\"vm.user.email_address\" type=\"email\" md-maxlength=\"30\" required></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"USERS.PASSWORD\"></label><md-icon \nmd-font-icon=\"icon-lock\" class=\"password\"></md-icon><input ng-model=\"vm.user.password\" id=\"password\" name=\"password\" \ntype=\"password\" md-maxlength=\"50\" ng-required=\"vm.newUser\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"USERS.PASSWORD_CONFIRM\"></label><md-icon md-font-icon=\"icon-lock\" \nclass=\"password\"></md-icon><input ng-keydown=\"vm.checkTabKey($event);\" pw-check=\"password\" name=\"password_confirm\" \nng-model=\"vm.user.password_confirm\" type=\"password\" ng-pattern=\"/^.{6,}$/\" md-maxlength=\"50\" ng-required=\"vm.newUser\">\n<div ng-messages=\"userForm.password_confirm.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"USERS.PASSWORD_REQUIRED\"></span></div><div ng-message=\"pattern\"><span translate=\"USERS.PASSWORD_LENGTH\">\n</span></div><div ng-message=\"pwmatch\"><span translate=\"USERS.PASSWORD_NOT_MATCH\"></span></div></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon>\n<label translate=\"USERS.CELL_PHONE\"></label><input ng-model=\"vm.user.cell_phone\" ui-mask=\"{{vm.phoneMask}}\" \nng-pattern=\"/^[0-9\\+\\-\\\\)\\\\(\\\\ \\/]*$/\" required></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><label translate=\"USERS.OFFICE_PHONE\"></label><input \nng-model=\"vm.user.office_phone\" ui-mask=\"{{vm.phoneMask}}\" ng-pattern=\"/^[0-9\\+\\-\\\\)\\\\(\\\\ \\/]*$/\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label translate=\"USERS.FAX\">\n</label><input ng-model=\"vm.user.fax\" ui-mask=\"{{vm.phoneMask}}\" ng-pattern=\"/^[0-9\\+\\-\\\\)\\\\(\\\\ \\/]*$/\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveUser()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"userForm.$invalid\" aria-label=\"SAVE\" translate=\"USERS.SAVE\" \ntranslate-attr-aria-label=\"USERS.SAVE\">SAVE</md-button></div><div layout=\"row\"><md-button ng-if=\"vm.user.id\" \nclass=\"send-button md-accent md-raised\" ng-click=\"vm.closeDialog(true)\" aria-label=\"Cancel\" translate \ntranslate-attr-aria-label=\"USERS.CANCEL\">CANCEL</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">G</span> <span class=\"logo-text\">\nGREENSKY Technologies</span></div><div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div><div class=\"area-fiscal-year-toolbar padding-10\"><md-icon md-font-icon \naria-label=\"area-fiscal-year\" class=\"icon-earth\" ng-click=\"vm.areaFiscalYearDialog($event)\"></md-icon></div><div \nclass=\"toolbar-separator\"></div><div hide-sm hide-xs class=\"padding-10 area-fiscal-year-info\"><span \nclass=\"global-area-name\">{{vm.areaFiscalYear.area.name | capitalize}}</span> <span ng-if=\"vm.areaFiscalYear.area.name\" \nclass=\"afy-colon\">:</span> <span class=\"global-fiscal-year\">{{vm.areaFiscalYear.fiscal_year.name}}</span> <span \nclass=\"please-set-area-fiscal-year-msg\" \nng-if=\"!vm.areaFiscalYear.area.name && !vm.areaFiscalYear.fiscal_year.begin_date\">\nPlease set global area and fiscal year.</span></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nhttp-src=\"{{vm.user.image_url  || \'assets/images/avatars/profile.jpg\'}}\"><md-icon md-font-icon \naria-label=\"user-status\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide show-gt-sm>{{ vm.user.name }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.editUserDialog($event, vm.user, false)\">My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"icon\"></md-icon><md-button id=\"theme-panel-toggle\" ng-click=\"vm.toggleSidenav(\'theme-panel\')\" \naria-label=\"Toggle theme panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_THEME_PANEL\">Layout Settings\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"icon\"></md-icon><md-button ng-click=\"vm.redirectToLogin()\">\nChange Login Background</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.changeStatus()\">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">G</span> <span class=\"logo-text\">\nGREENSKY Technologies</span></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular><ms-shortcuts></ms-shortcuts><div class=\"area-fiscal-year-toolbar padding-10\"><md-icon \nmd-font-icon aria-label=\"area-fiscal-year\" class=\"icon-earth\" ng-click=\"vm.areaFiscalYearDialog($event)\"></md-icon>\n</div><div hide-sm hide-xs class=\"padding-10 area-fiscal-year-info\"><span class=\"global-area-name\">\n{{vm.areaFiscalYear.area.name | capitalize}}</span> <span ng-if=\"vm.areaFiscalYear.area.name\" class=\"afy-colon\">:\n</span> <span class=\"global-fiscal-year\">{{vm.areaFiscalYear.fiscal_year.name}}</span> <span \nclass=\"please-set-area-fiscal-year-msg\" \nng-if=\"!vm.areaFiscalYear.area.name && !vm.areaFiscalYear.fiscal_year.begin_date\">\nPlease set global area and fiscal year.</span></div><md-menu-bar id=\"user-menu\"><md-menu \nmd-position-mode=\"left bottom\"><md-button class=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" \ntranslate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nhttp-src=\"{{vm.user.image_url  || \'assets/images/avatars/profile.jpg\'}}\"><md-icon md-font-icon \naria-label=\"user-status\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide show-gt-sm>{{ vm.user.name }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.editUserDialog($event, vm.user, false)\">My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"icon\"></md-icon><md-button id=\"theme-panel-toggle\" ng-click=\"vm.toggleSidenav(\'theme-panel\')\" \naria-label=\"Toggle theme panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_THEME_PANEL\">Layout Settings\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"icon\"></md-icon><md-button ng-click=\"vm.redirectToLogin()\">\nChange Login Background</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.changeStatus()\">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" \ndebounce=\"300\"></ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts hide-xs hide-sm></ms-shortcuts><div \nclass=\"toolbar-separator\"></div><div class=\"area-fiscal-year-toolbar padding-10\"><md-icon md-font-icon \naria-label=\"area-fiscal-year\" class=\"icon-earth\" ng-click=\"vm.areaFiscalYearDialog($event)\"></md-icon></div><div \nclass=\"toolbar-separator\"></div><div hide-sm hide-xs class=\"padding-10 area-fiscal-year-info\"><span \nclass=\"global-area-name\">{{vm.areaFiscalYear.area.name | capitalize}}</span> <span ng-if=\"vm.areaFiscalYear.area.name\" \nclass=\"afy-colon\">:</span> <span class=\"global-fiscal-year\">{{vm.areaFiscalYear.fiscal_year.name}}</span> <span \nclass=\"please-set-area-fiscal-year-msg\" \nng-if=\"!vm.areaFiscalYear.area.name && !vm.areaFiscalYear.fiscal_year.begin_date\">\nPlease set global area and fiscal year.</span></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"45\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nhttp-src=\"{{vm.user.image_url  || \'assets/images/avatars/profile.jpg\'}}\"><md-icon md-font-icon \naria-label=\"user-status\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide show-gt-sm>{{ vm.user.name }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.editUserDialog($event, vm.user, false)\">My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"icon\"></md-icon><md-button id=\"theme-panel-toggle\" ng-click=\"vm.toggleSidenav(\'theme-panel\')\" \naria-label=\"Toggle theme panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_THEME_PANEL\">Layout Settings\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"icon\"></md-icon><md-button ng-click=\"vm.redirectToLogin()\">\nChange Login Background</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.changeStatus()\">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu hide-xs id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div><div class=\"area-fiscal-year-toolbar padding-10\">\n<md-icon md-font-icon aria-label=\"area-fiscal-year\" class=\"icon-earth\" ng-click=\"vm.areaFiscalYearDialog($event)\">\n</md-icon></div><div class=\"toolbar-separator\"></div><div hide-sm hide-xs class=\"padding-10 area-fiscal-year-info\">\n<span class=\"global-area-name\">{{vm.areaFiscalYear.area.name | capitalize}}</span> <span \nng-if=\"vm.areaFiscalYear.area.name\" class=\"afy-colon\">:</span> <span class=\"global-fiscal-year\">\n{{vm.areaFiscalYear.fiscal_year.name}}</span> <span class=\"please-set-area-fiscal-year-msg\" \nng-if=\"!vm.areaFiscalYear.area.name && !vm.areaFiscalYear.fiscal_year.begin_date\">\nPlease set global area and fiscal year.</span></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nhttp-src=\"{{vm.user.image_url  || \'assets/images/avatars/profile.jpg\'}}\"><md-icon md-font-icon \naria-label=\"user-status\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide show-gt-sm>{{ vm.user.name }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.editUserDialog($event, vm.user, false)\">My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"icon\"></md-icon><md-button id=\"theme-panel-toggle\" ng-click=\"vm.toggleSidenav(\'theme-panel\')\" \naria-label=\"Toggle theme panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_THEME_PANEL\">Layout Settings\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"icon\"></md-icon><md-button ng-click=\"vm.redirectToLogin()\">\nChange Login Background</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.changeStatus()\">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdMenu.open()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">G</span> <span class=\"logo-text\">\nGREENSKY Technologies</span></div><div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" \nclass=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div><div class=\"area-fiscal-year-toolbar padding-10\">\n<md-icon md-font-icon aria-label=\"area-fiscal-year\" class=\"icon-earth\" ng-click=\"vm.areaFiscalYearDialog($event)\">\n</md-icon></div><div class=\"toolbar-separator\"></div><div hide-sm hide-xs class=\"padding-10 area-fiscal-year-info\">\n<span class=\"global-area-name\">{{vm.areaFiscalYear.area.name | capitalize}}</span> <span \nng-if=\"vm.areaFiscalYear.area.name\" class=\"afy-colon\">:</span> <span class=\"global-fiscal-year\">\n{{vm.areaFiscalYear.fiscal_year.name}}</span> <span class=\"please-set-area-fiscal-year-msg\" \nng-if=\"!vm.areaFiscalYear.area.name && !vm.areaFiscalYear.fiscal_year.begin_date\">\nPlease set global area and fiscal year.</span></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdMenu.open()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nhttp-src=\"{{vm.user.image_url  || \'assets/images/avatars/profile.jpg\'}}\"><md-icon md-font-icon \naria-label=\"user-status\" ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" \nclass=\"icon status s16\"></md-icon></div><span class=\"username\" hide show-gt-sm>{{ vm.user.name }}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.editUserDialog($event, vm.user, false)\">My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"icon\"></md-icon><md-button id=\"theme-panel-toggle\" ng-click=\"vm.toggleSidenav(\'theme-panel\')\" \naria-label=\"Toggle theme panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_THEME_PANEL\">Layout Settings\n</md-button></md-menu-item><md-menu-item ng-if=\"admin === true\" class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-file-image-box\" class=\"icon\"></md-icon><md-button ng-click=\"vm.redirectToLogin()\">\nChange Login Background</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon \nng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdMenu.open()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.changeStatus()\">Logout</md-button></md-menu-item></md-menu-content>\n</md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdMenu.open()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/admin/growing-seasons-definition/dialogs/growing-year-dialog.html","<md-dialog class=\"growing-year-dialog\" aria-label=\"New Task\"><form name=\"growingYearForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTRACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div flex layout=\"column\" layout-padding><section><md-input-container \nclass=\"md-block margin-top-0 padding-top-0\" flex-gt-sm=\"95\"><label translate=\"GROWING_SEASONS.GROWING_YEAR_NAME\">\n</label><md-icon md-font-icon=\"icon-document\"></md-icon><input required name=\"acres\" aria-label=\"acres\" \nng-model=\"vm.growingYear.name\" type=\"text\"><div ng-messages=\"growingYearForm.acres.$error\"><div class=\"error-message\" \nng-message=\"required\">Growing Year Name is required.</div></div></md-input-container></section><section flex>\n<md-input-container class=\"md-block margin-top-0 padding-top-0 padding-bottom-15 margin-bottom-0\"><div \nclass=\"signature\"><label translate=\"GROWING_SEASONS.SEASON_1_START_DATE\"></label></div><md-datepicker md-open-on-focus \nng-model=\"vm.growingYear.fiscal_year_seasons[0].start_date\" \nng-change=\"vm.calculateMinMaxDates(vm.growingYear.fiscal_year_seasons[0].start_date, 1)\" \nmd-date-locale=\"customDateFormat\" name=\"start_date_1\" md-open-on-focus required></md-datepicker><div \nng-messages=\"growingYearForm.start_date_1.$error\"><div class=\"error-message datepicker\" ng-message=\"required\">\nSeason 1 Start Date is required.</div></div></md-input-container></section><section flex><md-input-container \nclass=\"md-block margin-top-0 padding-top-0 padding-bottom-15 margin-bottom-0\"><div class=\"signature\"><label \ntranslate=\"GROWING_SEASONS.SEASON_2_START_DATE\"></label></div><md-datepicker md-open-on-focus \nng-model=\"vm.growingYear.fiscal_year_seasons[1].start_date\" \nng-disabled=\"!vm.growingYear.fiscal_year_seasons[0].start_date\" \nng-change=\"vm.calculateMinMaxDates(vm.growingYear.fiscal_year_seasons[1].start_date, 2)\" \nmd-date-locale=\"customDateFormat\" md-min-date=\"vm.season2MinDate\" md-max-date=\"vm.seasonMaxDate\" name=\"start_date_2\" \nmd-open-on-focus required></md-datepicker><div ng-messages=\"growingYearForm.start_date_2.$error\"><div \nclass=\"error-message datepicker\" ng-message=\"required\">Season 2 Start Date is required.</div></div>\n</md-input-container></section><section flex><md-input-container \nclass=\"md-block margin-top-0 padding-top-0 padding-bottom-15 margin-bottom-0\"><div class=\"signature\"><label \ntranslate=\"GROWING_SEASONS.SEASON_3_START_DATE\"></label></div><md-datepicker md-open-on-focus \nng-model=\"vm.growingYear.fiscal_year_seasons[2].start_date\" \nng-disabled=\"!vm.growingYear.fiscal_year_seasons[1].start_date\" \nng-change=\"vm.calculateMinMaxDates(vm.growingYear.fiscal_year_seasons[2].start_date, 3)\" \nmd-date-locale=\"customDateFormat\" md-min-date=\"vm.season3MinDate\" md-max-date=\"vm.seasonMaxDate\" name=\"start_date_3\" \nmd-open-on-focus required></md-datepicker><div ng-messages=\"growingYearForm.start_date_3.$error\"><div \nclass=\"error-message datepicker\" ng-message=\"required\">Season 3 Start Date is required.</div></div>\n</md-input-container></section><section flex><md-input-container \nclass=\"md-block margin-top-0 padding-top-0 padding-bottom-15 margin-bottom-0\"><div class=\"signature\"><label \ntranslate=\"GROWING_SEASONS.SEASON_4_START_DATE\"></label></div><md-datepicker md-open-on-focus \nng-model=\"vm.growingYear.fiscal_year_seasons[3].start_date\" \nng-disabled=\"!vm.growingYear.fiscal_year_seasons[2].start_date\" \nng-change=\"vm.calculateMinMaxDates(vm.growingYear.fiscal_year_seasons[3].start_date, 4)\" \nmd-date-locale=\"customDateFormat\" md-min-date=\"vm.season4MinDate\" md-max-date=\"vm.seasonMaxDate\" name=\"start_date_4\" \nmd-open-on-focus required></md-datepicker><div ng-messages=\"growingYearForm.start_date_1.$error\"><div \nclass=\"error-message datepicker\" ng-message=\"required\">Season 4 Start Date is required.</div></div>\n</md-input-container></section></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveGrowingYear()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"growingYearForm.$invalid || growingSeasonForm.$pristine\" aria-label=\"Save Variety\" \ntranslate=\"CONTRACTS.VARIETIES.SAVE_VARIETY\" translate-attr-aria-label=\"CONTRACTS.VARIETIES.SAVE_VARIETY\"></md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/admin/land-reference/form/step1.html","<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"LAND_REFERENCE.LAND_REF_NAME\">\n</label><input required name=\"landRefName\" ng-model=\"vm.land_ref.ranch_reference_name\" md-autofocus md-maxlength=\"10\" \nmaxlength=\"10\"><div ng-messages=\"vm.form.land_ref.ranch_reference_name.$error\"><div ng-message=\"required\" \ntranslate=\"LAND_REFERENCE.ERRORS.FIELD_REQUIRED\"></div></div></md-input-container></div>");
$templateCache.put("app/main/admin/land-reference/form/step2.html","<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"LAND_REFERENCE.AREA_REF_NAME\">\n</label><input required name=\"landRefName\" ng-model=\"vm.land_ref.area_reference_name\" md-autofocus md-maxlength=\"10\" \nmaxlength=\"10\"><div ng-messages=\"vm.form.land_ref.area_reference_name.$error\"><div ng-message=\"required\" \ntranslate=\"LAND_REFERENCE.ERRORS.FIELD_REQUIRED\"></div></div></md-input-container></div>");
$templateCache.put("app/main/admin/land-reference/form/step3.html","<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"LAND_REFERENCE.LOCATION_REF_NAME\">\n</label><input required name=\"landRefName\" ng-model=\"vm.land_ref.location_reference_name\" md-autofocus \nmd-maxlength=\"10\" maxlength=\"10\"><div ng-messages=\"vm.form.land_ref.location_reference_name.$error\"><div \nng-message=\"required\" translate=\"LAND_REFERENCE.ERRORS.FIELD_REQUIRED\"></div></div></md-input-container></div>");
$templateCache.put("app/main/admin/land-reference/form/step4.html","<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"LAND_REFERENCE.SECTION_REF_NAME\">\n</label><input required name=\"landRefName\" ng-model=\"vm.land_ref.section_reference_name\" md-autofocus \nmd-maxlength=\"10\" maxlength=\"10\"><div ng-messages=\"vm.form.land_ref.section_reference_name.$error\"><div \nng-message=\"required\" translate=\"LAND_REFERENCE.ERRORS.FIELD_REQUIRED\"></div></div></md-input-container></div>");
$templateCache.put("app/main/admin/land-reference/form/step5.html","<div layout-gt-xs=\"row\"><md-input-container class=\"md-block\" flex><label translate=\"LAND_REFERENCE.BLOCK_REF_NAME\">\n</label><input required name=\"landRefName\" ng-model=\"vm.land_ref.block_reference_name\" md-autofocus md-maxlength=\"10\" \nmaxlength=\"10\"><div ng-messages=\"vm.form.land_ref.block_reference_name.$error\"><div ng-message=\"required\" \ntranslate=\"LAND_REFERENCE.ERRORS.FIELD_REQUIRED\"></div></div></md-input-container></div>");
$templateCache.put("app/main/admin/seasons/form/step1.html","<div layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align-gt-sm=\"space between\"><div flex>\n<md-input-container class=\"md-block\" flex-xs=\"90\" flex><div class=\"signature\"><label for=\"signature\" \ntranslate=\"SEASONS.NAME\"></label></div><md-icon md-font-icon=\"icon-weather-partlycloudy\" class=\"name\"></md-icon><input \nrequired name=\"seasonName\" ng-model=\"vm.seasons.one.name\" md-autofocus><div \nng-messages=\"vm.form.seasons.one.name.$error\"><div ng-message=\"required\" translate=\"SEASONS.ERRORS.FIELD_REQUIRED\">\n</div></div></md-input-container></div><div flex layout=\"column\"><div layout=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0\" flex><md-input-container class=\"season-date margin-bottom-0 padding-bottom-0\" \nflex=\"90\"><div class=\"signature\"><label for=\"signature\" translate=\"SEASONS.START_DAY\"></label></div><md-datepicker \nmd-open-on-focus disabled=\"disabled\" ng-model=\"vm.seasons.one.start_day\" required md-min-date=\"vm.minDate\" \nmd-max-date=\"vm.seasons.one.end_day\"></md-datepicker></md-input-container></div><div class=\"div-date\" layout=\"row\" \nng-if=\"vm.checkIfValidEndDate(vm.seasons.one.end_day)\"><span class=\"text-bold padding-left-10\">End Day:</span> <span \nclass=\"padding-left-5\">{{ vm.seasons.one.end_day | date: \'mediumDate\' }}</span></div></div></div>");
$templateCache.put("app/main/admin/seasons/form/step2.html","<div layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align-gt-sm=\"space between\"><div flex>\n<md-input-container class=\"md-block\" flex-xs=\"90\" flex><div class=\"signature\"><label for=\"signature\" \ntranslate=\"SEASONS.NAME\"></label></div><md-icon md-font-icon=\"icon-weather-partlycloudy\" class=\"name\"></md-icon><input \nrequired name=\"seasonName\" ng-model=\"vm.seasons.two.name\" md-autofocus><div \nng-messages=\"vm.form.seasons.two.name.$error\"><div ng-message=\"required\" translate=\"SEASONS.ERRORS.FIELD_REQUIRED\">\n</div></div></md-input-container></div><div flex layout=\"column\"><div layout=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0\" flex><md-input-container class=\"season-date margin-bottom-0 padding-bottom-0\" \nflex=\"90\"><div class=\"signature\"><label for=\"signature\" translate=\"SEASONS.START_DAY\"></label></div><md-datepicker \nmd-open-on-focus ng-model=\"vm.seasons.two.start_day\" required md-min-date=\"vm.minDate\" \nmd-max-date=\"vm.seasons.two.end_day\"></md-datepicker></md-input-container></div><div class=\"div-date\" layout=\"row\" \nng-if=\"vm.checkIfValidEndDate(vm.seasons.two.end_day)\"><span class=\"text-bold padding-left-10\">End Day:</span> <span \nclass=\"padding-left-5\">{{ vm.seasons.two.end_day | date: \'mediumDate\' }}</span></div></div></div>");
$templateCache.put("app/main/admin/seasons/form/step3.html","<div layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align-gt-sm=\"space between\"><div flex>\n<md-input-container class=\"md-block\" flex-xs=\"90\" flex><div class=\"signature\"><label for=\"signature\" \ntranslate=\"SEASONS.NAME\"></label></div><md-icon md-font-icon=\"icon-weather-partlycloudy\" class=\"name\"></md-icon><input \nrequired name=\"seasonName\" ng-model=\"vm.seasons.three.name\" md-autofocus><div \nng-messages=\"vm.form.seasons.three.name.$error\"><div ng-message=\"required\" translate=\"SEASONS.ERRORS.FIELD_REQUIRED\">\n</div></div></md-input-container></div><div flex layout=\"column\"><div layout=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0\" flex><md-input-container class=\"season-date margin-bottom-0 padding-bottom-0\" \nflex=\"90\"><div class=\"signature\"><label for=\"signature\" translate=\"SEASONS.START_DAY\"></label></div><md-datepicker \nmd-open-on-focus ng-model=\"vm.seasons.three.start_day\" required md-min-date=\"vm.minDate\" \nmd-max-date=\"vm.seasons.three.end_day\"></md-datepicker></md-input-container></div><div class=\"div-date\" layout=\"row\" \nng-if=\"vm.checkIfValidEndDate(vm.seasons.three.end_day)\"><span class=\"text-bold padding-left-10\">End Day:</span> <span \nclass=\"padding-left-5\">{{ vm.seasons.three.end_day | date: \'mediumDate\' }}</span></div></div></div>");
$templateCache.put("app/main/admin/seasons/form/step4.html","<div layout-gt-sm=\"row\" layout-xs=\"column\" layout-sm=\"column\" layout-align-gt-sm=\"space between\"><div flex>\n<md-input-container class=\"md-block\" class=\"fiscal-date\" flex-xs=\"90\" flex><div class=\"signature\"><label \nfor=\"signature\" translate=\"SEASONS.NAME\"></label></div><md-icon md-font-icon=\"icon-weather-partlycloudy\" class=\"name\">\n</md-icon><input required name=\"seasonName\" ng-model=\"vm.seasons.four.name\" md-autofocus><div \nng-messages=\"vm.form.seasons.four.name.$error\"><div ng-message=\"required\" translate=\"SEASONS.ERRORS.FIELD_REQUIRED\">\n</div></div></md-input-container></div><div flex layout=\"column\"><div layout=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0\" flex><md-input-container class=\"season-date margin-bottom-0 padding-bottom-0\" \nflex=\"85\"><div class=\"signature\"><label for=\"signature\" translate=\"SEASONS.START_DAY\"></label></div><md-datepicker \nmd-open-on-focus ng-model=\"vm.seasons.four.start_day\" required md-min-date=\"vm.minDate\" \nmd-max-date=\"vm.seasons.four.end_day\"></md-datepicker></md-input-container></div><div class=\"div-date\" layout=\"row\" \nng-if=\"vm.checkIfValidEndDate(vm.seasons.four.end_day)\"><span class=\"text-bold padding-left-10\">End Day:</span> <span \nclass=\"padding-left-5\">{{ vm.seasons.four.end_day | date: \'mediumDate\' }}</span></div></div></div>");
$templateCache.put("app/main/directives/ms-file-upload/templates/ms-file-upload.html","<div id=\"file-upload\" ng-style=\"setSizeMedium(224)\" resize \nclass=\"page-layout simple left-sidenav inner-sidenav padding-bottom-55 scrollable\" ms-scroll><md-button \nid=\"add-document\" class=\"hide-xs hide-sm md-fab md-fab-bottom-right md-accent md-icon-button add-category\" \nng-click=\"vm.addNewTab($event)\" aria-label=\"Add Category\" \ntranslate-attr-aria-label=\"TABS.SECTION_PAYMENT_SCHEDULE.ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button id=\"add-document-mobile\" show-xs show-sm hide-gt-sm \nclass=\"md-fab md-fab-bottom-right md-accent md-icon-button\" ng-click=\"vm.addNewTab($event)\" aria-label=\"Add Category\" \ntranslate-attr-aria-label=\"TABS.SECTION_PAYMENT_SCHEDULE.ADD\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<div class=\"md-whiteframe-4dp no-results\" ng-style=\"setSizeMedium(256)\" resize md-dynamic-height \nng-if=\"!vm.documents.length\"><div class=\"no-tabs\"></div><div class=\"hint-text\"><span>\nClick on Add Button to create a tab</span></div></div><md-tabs ng-if=\"vm.documents.length\" class=\"md-whiteframe-4dp\" \nmd-dynamic-height md-border-bottom md-selected=\"vm.selectedTab\"><md-tab label=\"{{document.name}}\" \nng-repeat=\"document in vm.documents\"><md-content class=\"document-tab-content\"><md-button ng-if=\"!vm.dropping\" \nclass=\"md-icon-button\" ng-click=\"vm.deleteTab($event, document)\" aria-label=\"Delete Tab\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button><div class=\"file-detail-form-container md-background-bg\"><div \nid=\"file-image-uploader\" flow-init=\"vm.ngFlowOptions\" flow-name=\"vm.ngFlow.flow\" flow-files-submitted=\"vm.upload()\" \nflow-file-added=\"vm.fileAdded($file)\" flow-complete=\"vm.uploadComplete()\" flow-drop flow-drag-enter=\"vm.dropping=true\" \nflow-drag-leave=\"vm.dropping=false\" ng-class=\"{\'dropping\': vm.dropping}\"><div ng-if=\"vm.dropping\" class=\"hint-text\" \nlayout=\"row\" layout-align=\"center center\"><span translate=\"EC.DROP_TO_UPLOAD\">Drop to upload</span></div><div \nng-if=\"!vm.dropping\"><div class=\"food-safety\" layout=\"column\" layout-align=\"right right\"><md-switch \nng-model=\"document.food_safety_document\" \nng-change=\"vm.patchDocument(document.id, {\'food_safety_document\': document.food_safety_document})\" \naria-label=\"Food Safety\">Food Safety Document</md-switch></div><div class=\"upload-button\" layout=\"column\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" flow-btn>Upload</md-button><span \nclass=\"secondary-text mt-8\" translate=\"EC.MAX_FILE_SIZE_ALLOWED\"></span> <span class=\"secondary-text mt-8\" \ntranslate=\"EC.NOTICE_ABOUT_IMAGES\"></span></div><div ng-if=\"vm.loadingData\" class=\"upload-text-container\" \nlayout=\"column\" layout-align=\"center center\"><span class=\"uploading-text\">Uploading, please wait...</span></div>\n<md-list-item ng-if=\"vm.loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader></ms-loader>\n</md-list-item><div ng-if=\"!vm.loadingData\" class=\"mv-32\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"image-zoom-area\" layout=\"row\" layout-align=\"center center\" ng-mouseenter=\"vm.primary_file_over = true\" \nng-mouseleave=\"vm.primary_file_over = false\"><md-button ng-if=\"document.primary_file\" class=\"md-icon-button download\" \nng-click=\"vm.downloadFile(document.primary_file)\" aria-label=\"Download File\"><md-icon md-font-icon=\"icon-download\">\n</md-icon></md-button><div class=\"zoom\" ng-mousemove=\"vm.zoom($event)\" ng-mouseleave=\"vm.zoomOut($event)\" back-img><img\n \nng-if=\"document.primary_file && document.primary_file.view_url\n                                && vm.exists(document.primary_file.file_type.name, vm.image_types)\" \nhttp-img-src=\"{{document.primary_file.view_url}}\"></div><div \nng-if=\"document.primary_file && !vm.exists(document.primary_file.file_type.name, vm.image_types) && document.primary_file.file_type.name !== \'application/pdf\'\" \nclass=\"not-image hint-text\"><div class=\"not-image-content\"><md-icon md-font-icon=\"{{document.primary_file.icon}}\">\n</md-icon><span>{{document.primary_file.original_name}}</span></div></div><div \nng-if=\"document.primary_file && document.primary_file.file_type.name === \'application/pdf\'\" class=\"pdf-image\"><div>\n<span ng-click=\"vm.openDocumentInANewTab(document)\"><img http-img-src=\"{{document.primary_file.view_image_url}}\" \nno-img=\"assets/images/documents/pdf.png\"> </span><span class=\"description\">{{document.primary_file.original_name}}\n</span></div></div><div ng-if=\"!document.primary_file\" class=\"not-image hint-text\"><div class=\"not-image-content\"><span\n class=\"no-primary-file\">Primary file not set</span></div></div></div></div><div layout=\"row\" \nlayout-align=\"start start\" layout-wrap><div ng-repeat=\"file in document.files\"><div class=\"file-preview\" layout=\"row\" \nlayout-align=\"center center\" ng-mouseover=\"file.over = true\" ng-mouseleave=\"file.over = false\" \nng-click=\"vm.setPrimary(file)\"><md-button ng-if=\"file.over\" class=\"md-icon-button\" \nng-click=\"vm.deleteFile(ev, file.id)\" aria-label=\"Delete File\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button><div ng-if=\"!vm.exists(file.file_type.name, vm.image_types)\" class=\"not-image hint-text\"><img \nclass=\"media\" ng-if=\"file.view_image_thumb_url\" http-img-src=\"{{file.view_image_thumb_url}}\"></div><img class=\"media\" \nng-if=\"vm.exists(file.file_type.name, vm.image_types)\" http-src=\"{{file.view_url}}\"></div></div></div></div></div>\n</div></md-content></md-tab></md-tabs></div>");
$templateCache.put("app/main/directives/ms-lease-block/templates/ms-lease-block.html","<div id=\"lease-blocks\" ng-style=\"setSizeMedium(221)\" resize \nclass=\"page-layout simple left-sidenav inner-sidenav padding-bottom-10\"><div \nclass=\"pl-8 main margin-top-0 padding-top-0\" layout=\"row\" layout-align=\"center center\"><md-list \nclass=\"lease-blocks-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\"><div \nclass=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \nng-if=\"vm.listType === \'all\'\" translate=\"BLOCK.ALL_BLOCKS\"></span> <span class=\"secondary-text lease-blocks-count\">\n({{vm.lease.blocks.length}})</span></div></div></md-subheader><div class=\"content white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border\"><thead><tr><th class=\"ranch-name\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"BLOCK.RANCH_NAME\"></span></div></th><th class=\"block-name\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"BLOCK.BLOCK_NAME\"></span></div></th><th hide-xs class=\"acres\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"BLOCK.ACRES\"></span></div></th><th hide-xs \nclass=\"w-400 notes\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BLOCK.NOTES\"></span></div></th><th \nclass=\"w-70\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BLOCK.ACTIONS\"></span></div></th></tr>\n</thead><tbody class=\"scrollable\" ms-scroll ng-style=\"setSize(340)\" resize ng-if=\"!loadingData\"><tr \nclass=\"lease-block-item\" \nng-repeat=\"block in vm.lease.blocks | filter: vm.search | filter: global.search | orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredLeases track by block.id \" \nng-click=\"vm.addBlockDialog($event,block)\"><td class=\"ranch-name\">{{ block.ranch_name }}</td><td class=\"block-name\">\n{{ block.name }}</td><td class=\"acres\" hide-xs>{{ block.acres | numberFilter:1 }}</td><td ng-if=\"vm.isLease\" \nclass=\"w-400\" hide-xs><textarea class=\"form-control expandable\" type=\"text\" ng-readonly=\"true\" \nng-click=\"$event.stopPropagation()\" ng-keydown=\"$event.stopPropagation()\" maxlength=\"250\" \nng-model=\"block.lease_block.description \" rows=\"1\"></textarea></td><td ng-if=\"!vm.isLease\" class=\"w-400\" hide-xs>\n<textarea class=\"form-control expandable\" type=\"text\" ng-readonly=\"true\" ng-click=\"$event.stopPropagation()\" \nng-keydown=\"$event.stopPropagation()\" maxlength=\"250\" ng-model=\"block.sublease_block.description \" rows=\"1\"></textarea>\n</td><td class=\"w-70\"><div layout=\"row\" layout-align=\"start center\"><md-menu><md-button \nng-click=\"$mdMenu.open($event)\" class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"BLOCK.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"delete-block\" \nng-click=\"vm.deleteBlockConfirm(ev,block)\" translate=\"BLOCK.DELETE_BLOCK\"></md-button></md-menu-item><md-menu-item>\n<md-button aria-label=\"edit-block\" ng-click=\"vm.addBlockDialog($event,block)\" translate=\"BLOCK.EDIT_BLOCK\"></md-button>\n</md-menu-item></md-menu-content></md-menu></div></td></tr></tbody></table><md-list-item ng-if=\"loadingData\" \nclass=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item \nclass=\"md-white-bg\" ng-show=\"!loadingData && vm.lease.blocks.length === 0\"><p class=\"padding-left-8\" \ntranslate=\"BLOCK.NO_RESULTS\">No results..</p></md-list-item></div></md-list></div><md-button \nid=\"add-block-button-mobile\" show-xs show-sm hide-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nng-click=\"vm.addBlockDialog($event)\" aria-label=\"add block\" translate translate-attr-aria-label=\"BLOCK.ADD\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button ng-show=\"!vm.lease.newLease && !vm.lease.newSublease\" \nid=\"add-block-button\" hide-xs hide-sm show-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nng-click=\"vm.addBlockDialog($event)\" aria-label=\"add block\" translate translate-attr-aria-label=\"BLOCK.ADD\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/directives/ms-lease-information/templates/ms-lease-information.html","<form id=\"information-form\" name=\"vm.informationForm\"><div id=\"information\"><md-card md-theme-watch><md-card-content \nclass=\"lease-information-title margin-bottom-20\" layout=\"row\"><div layout=\"row\" layout-align=\"space between\" flex><div \nflex layout=\"row\" layout-align=\"start center\"><md-card-title class=\"padding-bottom-0\"><md-card-title-text><span \nclass=\"md-headline\">{{vm.title}}</span></md-card-title-text></md-card-title></div><div flex \nclass=\"padding-top-8 padding-right-25\" layout=\"row\" layout-align-xs=\"end center\" layout-align-sm=\"end center\" \nlayout-align-gt-sm=\"end center\"><md-card-actions><md-input-container class=\"md-block\" flex-gt-sm><md-button \nclass=\"md-icon-button\" ng-click=\"vm.stopPropagation();vm.lease.starred = !vm.lease.starred; vm.broadcast()\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"RANCHES.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.lease.starred\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.lease.starred\" \nmd-font-icon=\"icon-star-outline\"></md-icon><input ng-model=\"vm.lease.starred\" type=\"hidden\"></md-button>\n</md-input-container></md-card-actions></div></div></md-card-content><md-card-content flex layout=\"row\"><div \nclass=\"margin-left-20 margin-right-60\" flex layout-xs=\"column\" layout-sm=\"column\"><div flex-gt-xs=\"100\"><div \nlayout-gt-sm=\"row\" class=\"padding-bottom-10\"><div flex-gt-sm=\"100\"><md-input-container class=\"md-block\" lex \nflex-xs=\"100\"><label ng-if=\"vm.isLease\">Lease Number</label><label ng-if=\"!vm.isLease\">Subease Number</label><md-icon \nmd-font-icon=\"icon-numeric\" class=\"name\"></md-icon><input ng-if=\"vm.isLease\" required aria-label=\"Lease Number\" \nname=\"leaseNumber\" ng-model=\"vm.lease.lease_number\" ng-change=\"vm.broadcast()\" md-autofocus md-maxlength=\"30\" \nmaxlength=\"30\"> <input ng-if=\"!vm.isLease\" required aria-label=\"Sublease Number\" name=\"subleaseNumber\" \nng-model=\"vm.lease.sublease_number\" ng-change=\"vm.broadcast()\" md-autofocus md-maxlength=\"30\" maxlength=\"30\">\n</md-input-container></div><div ng-show=\"vm.isLease\" flex=\"10\" hide-xs hide-sm></div><div ng-show=\"vm.isLease\" \nflex-gt-sm=\"45\" class=\"padding-bottom-10\"><md-input-container class=\"md-block\" ng-if=\"vm.isLease\" flex flex-xs=\"100\">\n<label for=\"signature\" translate=\"LEASES.SECTION_INFO.LANDLORD_COMPANY\"></label><md-icon md-font-icon=\"icon-city\" \nclass=\"name\"></md-icon><md-select ng-model=\"vm.lease.landlord_company_id\"><md-option \nng-if=\"vm.landlordCompanies.length>0\" ng-repeat=\"company in vm.landlordCompanies\" value=\"{{company.id}}\" \nng-click=\"vm.setLandOwner(company.id); vm.broadcast()\">{{company.name}}</md-option><md-option \nng-if=\"vm.landlordCompanies.length===0\" ng-click=\"vm.goToCompanies()\">No Companies with <b>\'LandLord\'</b> role.<br>\nGo to Companies page</md-option></md-select><div ng-messages=\"vm.form.lease.landlord_company_id.$error\"><div \nng-message=\"required\">Land lord company is required.</div></div></md-input-container></div></div><div \nlayout-gt-sm=\"row\" flex-gt-sm=\"100\" class=\"padding-bottom-10\"><div flex-gt-sm=\"45\" \nclass=\"padding-bottom-10 margin-bottom-0\"><md-input-container ng-show=\"vm.isLease\" class=\"md-block padding-right-10\" \nflex-gt-sm><label>{{vm.leaseOwner}}</label><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><md-select \nng-required=\"vm.newLease\" ng-model=\"vm.lease.land_owner_company_id\"><md-option ng-if=\"vm.landOwnerCompanies.length>0\" \nng-repeat=\"company in vm.landOwnerCompanies\" value=\"{{company.id}}\" ng-click=\"vm.broadcast()\">{{company.name}}\n</md-option><md-option ng-if=\"vm.landOwnerCompanies.length===0\" ng-click=\"vm.goToCompanies()\">No Companies with <b>\n\'Land Owner\'</b> role.<br>Go to Companies page</md-option></md-select><div \nng-messages=\"vm.form.lease.land_owner_company_id.$error\"><div ng-message=\"required\">Land Owner is required.</div></div>\n</md-input-container><md-input-container ng-show=\"!vm.isLease\" class=\"md-block\" flex flex-xs=\"100\"><label \ntranslate=\"LEASES.SECTION_INFO.TENANT_COMPANY\"></label><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon>\n<md-select ng-required=\"vm.newLease\" ng-model=\"vm.lease.tenant_company_id\"><md-option \nng-if=\"vm.tenantCompanies.length>0\" ng-repeat=\"company in vm.tenantCompanies\" value=\"{{company.id}}\" \nng-click=\"vm.broadcast()\">{{company.name}}</md-option><md-option ng-if=\"vm.tenantCompanies.length===0\" \nng-click=\"vm.goToCompanies()\">No Companies with <b>\'Tenant\'</b> role.<br>Go to Companies page</md-option></md-select>\n<div ng-messages=\"vm.form.lease.tenant_company_id.$error\"><div ng-message=\"required\">Tenant is required.</div></div>\n</md-input-container></div><div flex=\"10\" hide-xs hide-sm></div><div class=\"height-5\" flex=\"5\" hide show-xs show-sm>\n</div><div flex-gt-sm=\"45\" class=\"padding-left-0 padding-bottom-10 margin-bottom-0\"><md-input-container \nclass=\"md-block\" lex flex-xs=\"100\"><label>Acres</label><md-icon md-font-icon=\"icon-numeric\" class=\"name\"></md-icon>\n<input disabled=\"disabled\" aria-label=\"Acres\" name=\"acres\" ng-model=\"vm.lease.acres\" currency-input=\"acres\" \ntype=\"text\"></md-input-container></div></div><div flex layout=\"column\" layout-padding class=\"column-signature\"><div \nflex layout=\"row margin-top-30\"><md-input-container class=\"md-block\" \nng-class=\"{true: \'lease-date\', false: \'sublease-date\'}[vm.isLease]\" flex flex-xs=\"100\"><div class=\"signature\"><label \nfor=\"signature\" translate=\"LEASES.SECTION_INFO.SIGNATURE_DAY\"></label></div><md-datepicker md-open-on-focus \nng-model=\"vm.lease.signature_date\" ng-change=\"vm.broadcast()\" md-date-locale=\"customDateFormat\" required>\n</md-datepicker><div ng-messages=\"vm.form.lease.signature_date.$error\"><div ng-message=\"required\">\nSignature day is required.</div></div></md-input-container></div></div></div></div></md-card-content></md-card></div>\n<div id=\"dates\"><md-card md-theme-watch><md-card-content class=\"lease-information-title margin-bottom-20\" layout=\"row\">\n<md-card-title><md-card-title-text><span class=\"md-headline\">Start - End Dates</span></md-card-title-text>\n</md-card-title></md-card-content><md-card-content flex layout=\"row\"><div class=\"margin-left-20 margin-right-60\" flex \nlayout-xs=\"column\" layout-sm=\"column\"><div flex-gt-xs=\"100\"><div layout-gt-sm=\"row\"><div flex-gt-sm=\"45\" \nclass=\"padding-bottom-0 margin-bottom-0\"><md-input-container class=\"md-block\" flex flex-gt-sm><label \nclass=\"custom-label-date\" translate=\"LEASES.SECTION_INFO.START_DAY\"></label><md-datepicker md-open-on-focus \nng-disabled=\"vm.lease.blocks.length\" ng-model=\"vm.lease.start_date\" ng-change=\"vm.broadcast()\" \nmd-date-locale=\"customDateFormat\" required></md-datepicker></md-input-container><div \nng-messages=\"vm.form.lease.start_date.$error\"><div ng-message=\"required\">Start day is required.</div></div></div><div \nflex=\"10\" hide-xs hide-sm></div><div class=\"height-5\" flex=\"5\" hide show-xs show-sm></div><div flex-gt-sm=\"45\" \nclass=\"padding-left-0 padding-bottom-15 margin-bottom-0\"><md-input-container class=\"md-block\" flex flex-xs=\"100\"><label\n class=\"custom-label-endDate\" translate=\"LEASES.SECTION_INFO.END_DAY\"></label><md-datepicker md-open-on-focus \nng-disabled=\"vm.lease.blocks.length\" ng-model=\"vm.lease.end_date\" md-min-date=\"vm.lease.start_date\" \nng-change=\"vm.broadcast()\" md-date-locale=\"customDateFormat\" required></md-datepicker></md-input-container><div \nng-messages=\"vm.form.lease.end_date.$error\"><div ng-message=\"required\">End day is required.</div></div></div></div>\n</div></div></md-card-content></md-card></div><div id=\"payment\"><md-card md-theme-watch><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Payment Information</span></md-card-title-text></md-card-title>\n<md-card-content class=\"no-padding\" flex layout=\"row\" layout-xs=\"column\"><div flex layout=\"column\" layout-padding \nclass=\"padding-right-0 margin-left-20 margin-right-60\"><div flex layout=\"row\"><md-input-container \nclass=\"md-block payment-info margin-bottom-10\" flex flex-xs=\"100\"><label class=\"custom-label\" \ntranslate=\"LEASES.SECTION_INFO.PAYMENT_TERMS\"></label><md-icon md-font-icon=\"icon-document\" class=\"name\"></md-icon>\n<md-select required ng-model=\"vm.lease.payment_terms\"><md-option ng-repeat=\"payment in vm.paymentTerms\" \nvalue=\"{{payment}}\" ng-click=\"vm.broadcast()\">{{payment}}</md-option></md-select><div \nng-messages=\"vm.form.lease.payment_terms.$error\"><div ng-message=\"required\">Payment terms is required.</div></div>\n</md-input-container></div><div flex layout=\"row margin-top-30\"><md-input-container class=\"md-block\" flex \nflex-xs=\"100\"><label class=\"custom-label\" translate=\"LEASES.SECTION_INFO.PAYMENT_AMOUNT\"></label><md-icon \nmd-font-icon=\"icon-square-inc-cash\"></md-icon><input required name=\"paymentAmount\" ng-model=\"vm.lease.amount_per_acre\" \ncurrency-input=\"money\" onfocus=\"placeholder=\'Max: 9,999,999.99\'\" onblur=\"placeholder=\'\'\" type=\"text\" \nng-change=\"vm.broadcast(vm.lease.amount_per_acre)\"><div ng-messages=\"vm.form.lease.amount_per_acre.$error\"><div \nng-message=\"required\">Payment amount is required.</div></div></md-input-container></div></div></md-card-content>\n</md-card></div><div id=\"notes\"><md-card md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">\nNotes</span></md-card-title-text></md-card-title><md-card-content class=\"no-padding\" flex layout=\"row\" \nlayout-xs=\"column\"><div flex layout=\"column\" layout-padding class=\"padding-right-0 margin-left-20 margin-right-60\"><div\n flex layout=\"row\"><md-input-container class=\"md-block payment-info margin-bottom-10\" flex flex-xs=\"100\"><label \nclass=\"custom-label\" translate=\"LEASES.SECTION_INFO.NOTES\"></label><md-icon md-font-icon=\"icon-note\"></md-icon><input \nname=\"description\" ng-model=\"vm.lease.description\" md-autofocus md-maxlength=\"250\" maxlength=\"250\" \nng-change=\"vm.broadcast(vm.lease.description)\"></md-input-container></div></div></md-card-content></md-card></div>\n</form>");
$templateCache.put("app/main/directives/ms-lease-list-blocks/templates/ms-lease-list-blocks.html","<form name=\"listBlocksForm\" class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"LEASES_LIST_BLOCKS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-list flex>\n<md-list-item class=\"md-3-line\" ng-repeat=\"block in vm.lease.blocks\" ng-click=\"vm.goToBlock(ev,block)\"><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{ block.name }}</h3><p>Ranch {{ block.ranch_name }}</p></div>\n</md-list-item></md-list></md-dialog-content></form>");
$templateCache.put("app/main/directives/ms-payment-schedule/templates/ms-payment-schedule.html","<div id=\"payment-schedule\" ng-style=\"setSizeMedium(221)\" resize \nclass=\"page-layout simple left-sidenav inner-sidenav padding-bottom-10\"><div \nclass=\"pl-8 main margin-top-0 padding-top-0\" layout=\"row\" layout-align=\"center center\"><md-list \nclass=\"payment-schedule-list\" ng-class=\"{\'contract-payments-list\': vm.entity === \'contract\'}\"><md-subheader \nclass=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\"><div class=\"list-title\" layout=\"row\" \nlayout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span class=\"\" translate=\"PAYMENT_SCHEDULE.ALL_PAYMENTS\">\n</span> <span ng-if=\"vm.payments.length\" class=\"payment-count\">({{vm.payments.length}})</span></div></div>\n</md-subheader><div class=\"content white-bg md-whiteframe-4dp\"><form id=\"paymentsForm\" name=\"vm.paymentsForm\"><table \nclass=\"dataTable row-border\"><thead><tr><th class=\"w-70\"><div class=\"table-header text-center\"><span \nclass=\"column-title\" translate=\"PAYMENT_SCHEDULE.PAYMENT_NUMBER\"></span></div></th><th class=\"w-150\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"PAYMENT_SCHEDULE.PAYMENT_DUE_DATE\"></span></div>\n</th><th class=\"w-150\"><div class=\"table-header text-center\"><span ng-if=\"vm.entity !== \'contract\'\" \nclass=\"column-title\" translate=\"PAYMENT_SCHEDULE.AMOUNT_DUE\"></span> <span ng-if=\"vm.entity === \'contract\'\" \nclass=\"column-title\" translate=\"PAYMENT_SCHEDULE.CONTRACT_AMOUNT\"></span></div></th><th class=\"w-150\" \nng-if=\"vm.entity === \'contract\'\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"PAYMENT_SCHEDULE.ADDITIONAL_INCENTIVE_AMOUNT\"></span></div></th><th class=\"w-100\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"PAYMENT_SCHEDULE.PAYMENT_MADE\"></span></div>\n</th><th class=\"w-150\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"PAYMENT_SCHEDULE.AMOUNT_PAID\"></span></div></th><th class=\"w-200\"><div class=\"table-header text-center\">\n<span class=\"column-title\" translate=\"PAYMENT_SCHEDULE.DATE_PAID\"></span></div></th><th class=\"w-300\" hide-xs><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PAYMENT_SCHEDULE.NOTES\"></span></div></th><th class=\"w-70\">\n<div class=\"table-header text-center\"><span class=\"column-title\" translate=\"PAYMENT_SCHEDULE.ACTIONS\"></span></div>\n</th></tr></thead><tbody class=\"scrollable\" ms-scroll ng-style=\"setSize(350)\" resize ng-if=\"!loadingData\"><tr \nclass=\"payment-row\" ng-repeat=\"payment in vm.payments\" ng-click=\"vm.addPaymentDialog($event,payment)\"><td \nclass=\"w-70 text-center\">{{ payment.pos }}</td><td class=\"w-150 text-center\">\n{{ payment.payment_due_date | date: \'mediumDate\' }}</td><td class=\"w-150 text-center\">\n{{ payment.amount | currency:undefined:0 }}</td><td class=\"w-150 text-center\" ng-if=\"vm.entity === \'contract\'\">\n$ {{payment.contract_incentive_amount}}</td><td class=\"w-100 text-center\"><md-checkbox \nng-checked=\"payment.payment_made\" \nng-click=\"$event.stopPropagation();payment.changed = true;vm.patchPayment(payment, {\'payment_made\': !payment.payment_made})\" \naria-label=\"payment-made-selection\"></md-checkbox></td><td class=\"w-150 text-center\"><md-input-container \nclass=\"no-margin md-block editable-row money\"><md-icon>$</md-icon><input aria-label=\"amount_paid\" \nng-model=\"payment.amount_paid\" class=\"text-center\" type=\"text\" currency-input=\"money\" \nonfocus=\"placeholder=\'Max: 9,999,999.99\'\" onblur=\"placeholder=\'\'\" ng-click=\"$event.stopPropagation()\" \nng-keydown=\"$event.stopPropagation()\" ng-change=\"payment.changed = true; vm.broadcast(payment)\"></md-input-container>\n</td><td class=\"w-200 text-center\"><div class=\"custom-date\"><md-datepicker md-open-on-focus \nng-model=\"payment.date_paid\" md-date-locale=\"customDateFormat\" ng-click=\"$event.stopPropagation();\" \nng-change=\"payment.changed = true; vm.broadcast(payment,\'set_date_paid\')\"></md-datepicker></div></td><td class=\"w-300\" \nhide-xs><textarea class=\"form-control expandable\" type=\"text\" ng-click=\"$event.stopPropagation()\" \nng-change=\"$event.stopPropagation(); vm.broadcast(payment)\" ng-keydown=\"$event.stopPropagation()\" maxlength=\"250\" \nng-model=\"payment.description\" rows=\"1\"></textarea></td><td class=\"w-70 text-center\"><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"PAYMENT_SCHEDULE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"edit-payment\" \nng-click=\"vm.addPaymentDialog($event,payment)\" translate=\"PAYMENT_SCHEDULE.EDIT_PAYMENT\"></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"delete-payment\" ng-click=\"vm.deletePaymentScheduleConfirm(ev,payment)\" \ntranslate=\"PAYMENT_SCHEDULE.DELETE_PAYMENT\"></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table></form></div><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\">\n<ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && vm.payments.length === 0\"><p translate=\"CONTRACTS.NO_RESULTS\">No results..</p></md-list-item>\n</md-list></div><md-button id=\"payment-button-mobile\" show-xs show-sm hide-gt-sm \nclass=\"md-fab md-fab-bottom-right md-accent md-icon-button\" ng-click=\"vm.addPaymentDialog($event)\" \naria-label=\"add payment\" translate translate-attr-aria-label=\"TABS.SECTION_PAYMENT_SCHEDULE.ADD\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button id=\"add-payment\" ng-show=\"!vm.newLease\" hide-xs hide-sm \nshow-gt-sm ng-class=\"{\'contract-payments\': vm.entity === \'contract\'}\" \nclass=\"md-fab md-fab-bottom-right md-accent md-icon-button\" ng-click=\"vm.addPaymentDialog($event)\" \naria-label=\"add payment\" translate translate-attr-aria-label=\"TABS.SECTION_PAYMENT_SCHEDULE.ADD\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/farm-admin/farm-resources/equipment/equipment.html","");
$templateCache.put("app/main/farm-admin/farm-resources/fertilizer-definition/fertilizer-definition.html","");
$templateCache.put("app/main/farm-admin/farm-resources/labor/labor.html","");
$templateCache.put("app/main/farm-admin/farm-resources/pesticide-definition/pesticide-definition.html","");
$templateCache.put("app/main/farm-admin/farm-resources/seed/seed.html","<div id=\"seeds\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div ng-show=\"stepCurrent===1\" class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><div ng-if=\"vm.fromContracts\" class=\"back-button\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.backToContractCropPage()\" aria-label=\"Back\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button></div><div ng-if=\"vm.fromGrowerSchedule\" \nclass=\"back-button\"><md-button class=\"md-icon-button\" ng-click=\"vm.backToGrowerSchedule()\" aria-label=\"Back\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button></div><md-icon md-font-icon=\"icon-barley\">\n</md-icon><span>Seed</span></div><div class=\"seed-count secondary-text\"><span>Total Seeds: {{vm.seeds.length}}</span>\n</div><div class=\"seed-title secondary-text\"><span></span></div></div><div><md-button class=\"md-raised md-background\" \nid=\"save-seed-button\" ng-click=\"vm.saveSeedConfirm($event)\"><span aria-label translate=\"SEEDS.SAVE\"></span></md-button>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-seed-button\" ng-click=\"vm.openSeedDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div ng-show=\"stepCurrent===2\" class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><div ng-if=\"vm.fromContracts\" class=\"back-button\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.backToContractCropPage()\" aria-label=\"Back\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button></div><md-icon md-font-icon=\"icon-barley\">\n</md-icon><span>Variety</span></div><div class=\"seed-count secondary-text\" layout=\"column\"><span>\nTotal Varieties: {{vm.varieties.length}}</span></div><div class=\"seed-title secondary-text\"><span><b>Seed:</b>\n {{seedName}}</span></div></div><div><md-button class=\"md-raised md-background\" id=\"save-seed-button\" \nng-click=\"vm.saveVarietyConfirm($event)\"><span aria-label translate=\"SEEDS.SAVE\"></span></md-button><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-seed-button\" ng-click=\"vm.openVarietyDialog($event)\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div></div><div ng-show=\"stepCurrent===3\" class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><div ng-if=\"vm.fromContracts\" class=\"back-button\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.backToContractCropPage()\" aria-label=\"Back\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button></div><md-icon md-font-icon=\"icon-barley\">\n</md-icon><span>{{vm.land_ref.location_reference_name}}</span></div><div class=\"seed-count secondary-text\"><span>\nTotal {{vm.land_ref.location_reference_name}}: {{vm.varietiesLocations.length}}</span></div><div \nclass=\"seed-title secondary-text\"><span><b>Seed:</b> {{seedName}} <b>Variety:</b> {{varietyName}}</span></div></div>\n<div><md-button class=\"md-raised md-background\" id=\"save-seed-button\" \nng-click=\"vm.saveVarietyPlantingLocationConfirm($event)\"><span aria-label translate=\"SEEDS.SAVE\"></span></md-button>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-seed-button\" \nng-click=\"vm.openVarietyPlantingLocationDialog($event)\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>\n</div><form name=\"seed-setup-form\" ms-horizontal-custom-stepper hide-save=\"true\" ng-open=\"vm.openForm()\" \nng-submit=\"vm.saveForm($event)\" ng-model=\"vm.stepper\" novalidate><ms-horizontal-custom-stepper-step ng-form=\"step1\" \nstep=\"1\" step-title=\"\'Seed\'\"><div ng-include=\"\'app/main/farm-admin/farm-resources/seed/form/step1.html\'\"></div>\n</ms-horizontal-custom-stepper-step><ms-horizontal-custom-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Variety\'\">\n<div ng-include=\"\'app/main/farm-admin/farm-resources/seed/form/step2.html\'\"></div></ms-horizontal-custom-stepper-step>\n<ms-horizontal-custom-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Location and Planting Timeframe\'\"><div \nng-include=\"\'app/main/farm-admin/farm-resources/seed/form/step3.html\'\"></div></ms-horizontal-custom-stepper-step>\n</form></div></div>");
$templateCache.put("app/main/farm-admin/farm-resources/water/water.html","");
$templateCache.put("app/main/farm-admin/land/blocks/blocks.html","<div id=\"blocks\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" layout-align=\"start center\"><md-button \nid=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"BLOCKS.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div ng-if=\"vm.from_page_name\" class=\"back-button\">\n<md-button ng-if=\"vm.fromRanch\" class=\"md-icon-button\" ng-click=\"vm.backToRanchPage()\" aria-label=\"Back\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button><md-button ng-if=\"vm.fromLeaseBlocks\" \nclass=\"md-icon-button\" ng-click=\"vm.backToLeaseBlocksPage()\" aria-label=\"Back\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-satellite\" class=\"s24\">\n</md-icon></span><span class=\"logo-text\" translate=\"BLOCKS.BLOCKS\">Blocks</span></div></div><div flex-xs=\"45\" \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for block\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"BLOCKS.SEARCH_FOR_BLOCK\"></md-input-container></div></div><div class=\"content\" \nmd-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/farm-admin/land/blocks/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\"><md-list \nclass=\"blocks-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\"><div \nclass=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \nng-if=\"vm.listType.name === \'all\'\" translate=\"BLOCKS.ALL_BLOCKS\"></span> <span \nng-if=\"vm.listType.name && vm.listType.name !== \'all\' && vm.filterTitle === \'\' \">{{vm.listType.name}} </span><span \nng-if=\"vm.filterTitle !== \'\' \">{{vm.filterTitle }} </span><span ng-if=\"vm.filterIds.length\" \nclass=\"secondary-text blocks-count\">({{vm.filterIds.length}})</span></div></div></md-subheader><div \nclass=\"content white-bg md-whiteframe-4dp\"><div flex><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text block\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BLOCKS.BLOCK_NAME\"></span>\n</div></th><th class=\"secondary-text acres\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"BLOCKS.ACRES\"></span></div></th><th class=\"secondary-text lease\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"BLOCKS.LEASE_END_DATE\"></span></div></th><th class=\"secondary-text subleased\" hide-xs>\n<div class=\"table-header\"><span class=\"column-title\" translate=\"BLOCKS.SUBLEASED\"></span></div></th><th \nclass=\"secondary-text active\" hide-xs><div class=\"table-header\"><span class=\"column-title\" translate=\"BLOCKS.ACTIVE\">\n</span></div></th><th class=\"secondary-text w-90\"><div class=\"table-header actions\"><span class=\"column-title\" \ntranslate=\"BLOCKS.ACTIONS\"></span></div></th></tr></thead><tbody class=\"scrollable constrained\" \nng-if=\"!loadingData && vm.filterIds.length>0\" ms-scroll ms-infinite-scroll=\"vm.loadMore(vm.area_id)\" \nms-infinite-scroll-container=\'\".constrained\"\' ng-style=\"setSize(318)\" resize><tr class=\"block-item\" \nng-repeat=\"block in vm.shownBlocks | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredBlocks track by block.id | limitTo:vm.offset\" \nng-click=\"vm.editBlock(ev, block)\"><td class=\"block\" ng-style=\"{\'font-weight\':\'bold\'}\">{{ block.name }}</td><td \nclass=\"acres\">{{ block.acres | numberFilter:1 }}</td><td class=\"lease\" ng-if=\"block.ofFarmOwner\">Owned</td><td \nclass=\"lease\" ng-if=\"!block.ofFarmOwner && block.lease_end_date\">{{block.lease_end_date | date: \'mediumDate\'}}</td><td \nclass=\"lease\" ng-if=\"!block.ofFarmOwner && !block.lease_end_date\">Not leased</td><td class=\"subleased\" hide-xs>\n{{block.subleased ? \'Yes\':\'No\'}}</td><td class=\"active\" hide-xs><md-button class=\"md-icon-button\" \nng-click=\"block.active = !block.active; vm.patchActive(block)\" aria-label=\"Toggle active\" translate \ntranslate-attr-aria-label=\"BLOCKS.TOGGLE_ACTIVE\"><md-icon ng-if=\"block.active\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon ng-if=\"!block.active\" \nmd-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></td><td class=\"actions w-90\"><md-button \nclass=\"md-icon-button hide show-gt-xs\" ng-click=\"vm.patchStarred(block); vm.toggleInArray(block.id, vm.starredBlocks)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"BLOCKS.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.exists(block.id,vm.starredBlocks)\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.exists(block.id,vm.starredBlocks)\" md-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"BLOCKS.MORE\" \nng-click=\"$mdMenu.open($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button \nng-disabled=\"block.lease_end_date !== \'Owned\' || block.sublease_end_date !== \'not_subleased\'\" \naria-label=\"delete-block\" translate=\"BLOCKS.DELETE_BLOCK\" ng-click=\"vm.deleteBlockConfirm(block,ev)\"></md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><md-list-item ng-if=\"loadingData\" class=\"loader\" \nlayout=\"row\" layout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && vm.filterIds.length === 0\"><p class=\"padding-left-8\" translate=\"BLOCKS.NO_RESULTS\">\nNo results..</p></md-list-item></div></div></md-list></div></div><md-button show-xs show-sm hide-gt-sm \nclass=\"md-fab md-fab-bottom-right md-accent md-icon-button\" id=\"add-block-button-mobile\" ng-click=\"vm.addBlock()\" \naria-label=\"add block\" translate translate-attr-aria-label=\"BLOCKS.ADD_BLOCK\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button><md-button hide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" \nid=\"add-block-button\" ng-click=\"vm.addBlock()\" aria-label=\"add block\" translate \ntranslate-attr-aria-label=\"BLOCKS.ADD_BLOCK\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/farm-admin/land/land/land.html","<div id=\"lands\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div ng-show=\"stepCurrent===1\" class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-map-marker-radius\"></md-icon><span>\n{{vm.land_ref.area_reference_name}}</span></div><div class=\"land-count secondary-text\"><span>\nTotal {{vm.land_ref.area_reference_name}}: {{vm.areas.length}}</span></div><div class=\"land-title secondary-text\">\n<span></span></div></div><div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-land-button\" \nng-click=\"vm.openAreaDialog()\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nclass=\"md-raised md-background\" id=\"save-land-button\" ng-click=\"vm.saveAreaConfirm($event)\"><span aria-label \ntranslate=\"LANDS.SAVE\"></span></md-button></div></div><div ng-show=\"stepCurrent===2\" class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-map-marker-radius\"></md-icon><span>\n{{vm.land_ref.location_reference_name}}</span></div><div class=\"land-count secondary-text\"><span>\nTotal {{vm.land_ref.location_reference_name }}: {{vm.locations.length}}</span></div><div \nclass=\"land-title secondary-text\"><span><b>Area:</b> {{areaName}}</span></div></div><div><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-land-button\" ng-click=\"vm.openLocationDialog()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-raised md-background\" id=\"save-land-button\" \nng-click=\"vm.saveLocationConfirm($event)\"><span aria-label translate=\"LANDS.SAVE\"></span></md-button></div></div><form \nname=\"land-form\" hide-save=\"true\" ng-open=\"vm.openForm()\" ms-horizontal-custom-stepper ng-submit=\"vm.saveForm($event)\" \nng-model=\"vm.land_ref\"><ms-horizontal-custom-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Area\'\"><div \nng-include=\"\'app/main/farm-admin/land/land/form/step1.html\'\"></div></ms-horizontal-custom-stepper-step>\n<ms-horizontal-custom-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Location\'\"><div \nng-include=\"\'app/main/farm-admin/land/land/form/step2.html\'\"></div></ms-horizontal-custom-stepper-step></form></div>\n</div>");
$templateCache.put("app/main/farm-admin/land/leases/leases.html","<div id=\"leases\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" layout-align=\"start center\"><md-button \nid=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"LEASES.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><span \nclass=\"logo-text\" translate=\"LEASES.LEASES\">Leases</span></div></div><div flex-xs=\"45\" class=\"search-input-wrapper\" \nlayout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label>\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for lease\" type=\"text\" \nng-model=\"vm.search\" translate translate-attr-placeholder=\"LEASES.SEARCH_FOR_LEASE\"></md-input-container></div></div>\n<div ng-show=\"vm.selectedLeases.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedLeases =[]\"><md-button layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"LEASES.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"selected-leases-count\"><span>{{vm.selectedLeases.length}}</span> <span translate=\"LEASES.SELECTED\">\nselected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"LEASES.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllLeases()\" translate=\"LEASES.SELECT_ALL\">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectLeases()\" \ntranslate=\"LEASES.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div></div></div><div\n class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/farm-admin/land/leases/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\"><md-list \nclass=\"leases-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\"><div \nclass=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \nng-if=\"vm.listType.name === \'all\'\" translate=\"LEASES.ALL_LEASES\"></span> <span \nng-if=\"vm.listType.name && vm.listType.name !== \'all\' && vm.filterTitle === \'\'\">{{vm.listType.name }} </span><span \nng-if=\"vm.filterTitle !== \'\' \">{{vm.filterTitle }} </span><span ng-if=\"vm.filterIds.length\" \nclass=\"secondary-text leases-count\">({{vm.filterIds.length}})</span></div></div></md-subheader><div \nclass=\"content white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text lessee\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LEASES.LANDLORD_COMPANY\">\n</span></div></th><th class=\"secondary-text number\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LEASES.LEASE_NUMBER\"></span></div></th><th class=\"secondary-text acres\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LEASES.ACRES\"></span></div></th><th class=\"secondary-text start\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LEASES.START_DATE\"></span></div></th><th \nclass=\"secondary-text end\"><div class=\"table-header\"><span class=\"column-title\" translate=\"LEASES.END_DATE\"></span>\n</div></th><th class=\"secondary-text subleased\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"LEASES.SUBLEASED\"></span></div></th><th class=\"secondary-text blocks\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"LEASES.BLOCKS\"></span></div></th><th class=\"secondary-text actions-title w-100\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"LEASES.ACTIONS\"></span></div></th></tr></thead><tbody \nclass=\"scrollable constrained\" ms-scroll ng-if=\"!loadingData && vm.filterIds.length>0\" \nms-infinite-scroll=\"vm.loadMore()\" ms-infinite-scroll-container=\'\".constrained\"\' ng-style=\"setSize(318)\" resize><tr \nclass=\"lease-item\" \nng-repeat=\"lease in vm.shownLeases | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredLeases track by lease.id | limitTo:vm.offset\" \nng-click=\"vm.editLease(ev, lease)\"><td class=\"lessee\" ng-style=\"{\'font-weight\':\'bold\'}\">\n{{ lease.landlord_company.name }}</td><td class=\"number\">{{ lease.lease_number }}</td><td class=\"acres\">\n{{ lease.acres | numberFilter:1 }}</td><td class=\"start\">{{ lease.start_date | date: \'mediumDate\' }}</td><td \nclass=\"end\">{{ lease.end_date | date: \'mediumDate\' }}</td><td class=\"subleased\">{{ lease.is_subleased ? \'Yes\':\'No\'}}\n</td><td class=\"blocks\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"Blocks\" \nng-disabled=\"lease.blocks.length === 0\" data-ng-mouseover=\"$mdMenu.open($event)\" ng-click=\"$mdMenu.open($event)\" \ntranslate translate-attr-aria-label=\"LEASES.BLOCKS\"><md-icon md-font-icon=\"icon-view-dashboard\"></md-icon></md-button>\n<md-menu-content class=\"md-menu\" width=\"3\" data-ng-mouseleave=\"$mdMenu.close($event)\"><md-list><md-list-item \nng-repeat=\"block in lease.blocks\"><p class=\"pl-8\">{{block.name }}</p></md-list-item></md-list></md-menu-content>\n</md-menu></td><td class=\"actions w-100\"><md-button class=\"md-icon-button custom-button\" \nng-click=\"vm.patchStarred(lease); vm.toggleInArray(lease.id, vm.starredLeases)\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"LEASES.TOGGLE_STARRED\"><md-icon ng-if=\"vm.exists(lease.id,vm.starredLeases)\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.exists(lease.id,vm.starredLeases)\" \nmd-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu class=\"custom-menu\"><md-button class=\"md-icon-button\" \naria-label=\"More\" ng-click=\"$mdMenu.open($event)\" translate translate-attr-aria-label=\"LEASES.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" id=\"icon-dot\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button aria-label=\"edit-lease\" translate=\"LEASES.EDIT_LEASE\" ng-click=\"vm.editLease(ev, lease)\"></md-button>\n</md-menu-item><md-menu-item><md-button ng-disabled=\"lease.blocks.length===0\" aria-label=\"view-blocks\" \ntranslate=\"LEASES.VIEW_BLOCKS\" ng-click=\"vm.goToBlockTab(ev,lease)\"></md-button></md-menu-item><md-menu-item><md-button\n ng-disabled=\"lease.blocks.length>0\" aria-label=\"delete-lease\" translate=\"LEASES.DELETE_LEASE\" \nng-click=\"vm.deleteLeaseConfirm(ev,lease)\"></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody>\n</table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader>\n</ms-loader></md-list-item><md-list-item class=\"md-white-bg\" ng-show=\"!loadingData && vm.filterIds.length === 0\"><p \nclass=\"padding-left-8\" translate=\"LEASES.NO_RESULTS\">No results..</p></md-list-item></div></md-list></div></div>\n<md-button show-xs show-sm hide-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nid=\"add-lease-button-mobile\" ng-click=\"vm.addLease()\" aria-label=\"add lease\" translate \ntranslate-attr-aria-label=\"LEASES.ADD_LEASE\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nhide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" id=\"add-lease-button\" ng-click=\"vm.addLease()\" \naria-label=\"add lease\" translate translate-attr-aria-label=\"LEASES.ADD_LEASE\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div>");
$templateCache.put("app/main/farm-admin/land/ranches/ranches.html","<div id=\"ranches\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" layout-align=\"start center\"><md-button \nid=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"RANCHES.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div \nng-if=\"vm.from_page_name && vm.from_page_name !== \'blocks\'\" class=\"back-button\"><md-button \nng-if=\"vm.from_page_name===\'lease_blocks\'\" class=\"md-icon-button\" ng-click=\"vm.backToLeaseBlocksPage()\" \naria-label=\"Back\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button><md-button \nng-if=\"vm.from_page_name===\'sublease_blocks\'\" class=\"md-icon-button\" ng-click=\"vm.backToSubleaseBlocksPage()\" \naria-label=\"Back\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button><md-button \nng-if=\"vm.from_page_name===\'add_block\'\" class=\"md-icon-button\" ng-click=\"vm.backToBlocksPage()\" aria-label=\"Back\">\n<md-icon md-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button></div><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-view-dashboard\" \nclass=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"RANCHES.RANCHES\">Ranches</span></div></div><div \nflex-xs=\"45\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for ranch\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"RANCHES.SEARCH_FOR_RANCH\"></md-input-container></div></div><div \nng-show=\"vm.selectedRanches.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedRanches =[]\"><md-button \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"RANCHES.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"selected-ranches-count\"><span>{{vm.selectedRanches.length}}</span> <span translate=\"RANCHES.SELECTED\">\nselected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"RANCHES.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllRanches()\" translate=\"RANCHES.SELECT_ALL\">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectRanches()\" \ntranslate=\"RANCHES.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedRanches($event)\" \naria-label=\"delete selected\" translate translate-attr-label=\"RANCHES.DELETE_SELECTED\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/farm-admin/land/ranches/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\"><md-list\n class=\"ranches-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType.name === \'all\'\" translate=\"RANCHES.ALL_RANCHES\">All ranches\n</span> <span ng-if=\"vm.listType.name && vm.listType.name !== \'all\' && vm.filterTitle === \'\'\">{{vm.listType.name }} \n</span><span ng-if=\"vm.filterTitle !== \'\' \">{{vm.filterTitle }} </span><span ng-if=\"vm.filterIds.length\" \nclass=\"secondary-text ranches-count\">({{vm.filterIds.length}})</span></div><div flex></div></div></md-subheader><div \nclass=\"content white-bg md-whiteframe-4dp\"><div><table class=\"dataTable row-border hover h-100-p\"><thead><tr><th \nclass=\"secondary-text ranch\"><div class=\"table-header\"><span class=\"column-title\" translate=\"RANCHES.NAME\"></span>\n</div></th><th class=\"secondary-text location\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"RANCHES.LOCATION\"></span></div></th><th class=\"secondary-text section\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"RANCHES.SECTION\"></span></div></th><th class=\"secondary-text town\" hide-xs><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"RANCHES.TOWNSHIP\"></span></div></th><th \nclass=\"secondary-text range\" hide-xs><div class=\"table-header\"><span class=\"column-title\" translate=\"RANCHES.RANGE\">\n</span></div></th><th class=\"secondary-text active-title\" hide-xs><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"RANCHES.ACTIVE\"></span></div></th><th class=\"secondary-text view-blocks\" hide-xs><div \nclass=\"table-header view-blocks\"><span class=\"column-title\" translate=\"RANCHES.VIEW_BLOCKS\"></span></div></th><th \nclass=\"secondary-text w-90\"><div class=\"table-header actions\"><span class=\"column-title\" translate=\"RANCHES.ACTIONS\">\n</span></div></th></tr></thead><tbody class=\"scrollable constrained\" ng-if=\"!loadingData && vm.filterIds.length>0\" \nms-scroll ms-infinite-scroll=\"vm.loadMore(vm.area_id)\" ms-infinite-scroll-container=\'\".constrained\"\' \nng-style=\"setSize(318)\" resize><tr class=\"ranch-item\" \nng-repeat=\"ranch in vm.shownRanches | filter: vm.search | filter: global.search | filterByIds:vm.filterIds | orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredRanches track by ranch.id | limitTo:vm.maxListLength \" \nng-class=\"{\'selected\': vm.isSelected(ranch)}\" ng-click=\"vm.editRanch(ev, ranch)\"><td class=\"ranch\" \nng-style=\"{\'font-weight\':\'bold\'}\">{{ ranch.name }}</td><td class=\"location\">{{ ranch.ranch_location.name }}</td><td \nclass=\"section\">{{ ranch.section_name }}</td><td class=\"town\" hide-xs>{{ ranch.township }}</td><td class=\"range\" \nhide-xs>{{ ranch.range }}</td><td class=\"active\" hide-xs><md-button class=\"md-icon-button\" \nng-click=\"ranch.active = !ranch.active;$event.stopPropagation(); vm.patchActive(ranch)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"RANCHES.TOGGLE_ACTIVE\"><md-icon ng-if=\"ranch.active\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon ng-if=\"!ranch.active\" \nmd-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></td><td class=\"view-blocks\" \nalign=\"center center\" hide-xs><md-button class=\"md-icon-button\" \nng-click=\"$event.stopPropagation(); vm.viewBlocks(ranch.ranch_location.id, ranch.ranch_location.name, ranch.id, ranch.name)\" \naria-label=\"View Blocks\" translate translate-attr-aria-label=\"RANCHES.VIEW_BLOCKS\"><md-icon \nmd-font-icon=\"icon-view-dashboard\"></md-icon></md-button></td><td class=\"actions w-90\"><md-button \nclass=\"md-icon-button custom-button hide show-gt-xs\" \nng-click=\"$event.stopPropagation();vm.toggleInArray(ranch.id, vm.starredRanches);vm.patchStarred(ranch)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"RANCHES.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.exists(ranch.id,vm.starredRanches)\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.exists(ranch.id,vm.starredRanches)\" md-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"RANCHES.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"edit-ranch\" ng-click=\"vm.editRanch(ev, ranch)\" \ntranslate=\"RANCHES.EDIT_RANCH\"></md-button></md-menu-item><md-menu-item><md-button aria-label=\"add-cocument\" \nng-click=\"vm.viewBlocks(ranch.ranch_location.id, ranch.ranch_location.name, ranch.id, ranch.name)\" \ntranslate=\"RANCHES.VIEW_BLOCKS\"></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody><tfoot>\n</tfoot></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader>\n</ms-loader></md-list-item><md-list-item class=\"md-white-bg\" ng-show=\"!loadingData && vm.filterIds.length === 0\"><p \nclass=\"padding-left-8\" translate=\"RANCHES.NO_RESULTS\">No results..</p></md-list-item></div></div></md-list></div></div>\n<md-button show-xs show-sm hide-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nid=\"add-ranch-button-mobile\" ng-click=\"vm.addRanch($event)\" aria-label=\"add ranch\" translate \ntranslate-attr-aria-label=\"RANCHS.ADD_RANCH\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nhide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" id=\"add-ranch-button\" \nng-click=\"vm.addRanch($event)\" aria-label=\"add contract\" translate translate-attr-aria-label=\"RANCHS.ADD_RANCH\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/farm-admin/land/subleases/subleases.html","<div id=\"subleases\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" layout-align=\"start center\"><md-button \nid=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"SUBLEASES.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><span \nclass=\"logo-text\" translate=\"SUBLEASES.SUBLEASES\">Subleases</span></div></div><div flex-xs=\"45\" \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for sublease\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"SUBLEASES.SEARCH_FOR_SUBLEASE\"></md-input-container></div></div><div \nng-show=\"vm.selectedSubleases.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedSubleases =[]\"><md-button \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"SUBLEASES.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\">\n<div><span class=\"selected-subleases-count\"><span>{{vm.selectedSubleases.length}}</span> <span \ntranslate=\"SUBLEASES.SELECTED\">selected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"SUBLEASES.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllSubleases()\" \ntranslate=\"SUBLEASES.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deselectSubleases()\" translate=\"SUBLEASES.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/farm-admin/land/subleases/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\">\n<md-list class=\"subleases-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType.name === \'all\'\" translate=\"SUBLEASES.ALL_SUBLEASES\"></span> \n<span ng-if=\"vm.listType.name && vm.listType.name !== \'all\' && vm.filterTitle === \'\'\">{{vm.listType.name }} </span>\n<span ng-if=\"vm.filterTitle !== \'\' \">{{vm.filterTitle }} </span><span ng-if=\"vm.filterIds.length\" \nclass=\"secondary-text subleases-count\">({{vm.filterIds.length}})</span></div></div></md-subheader><div \nclass=\"content white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text tenant\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBLEASES.TENANT_COMPANY\"></span></div></th><th class=\"secondary-text number\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"SUBLEASES.SUBLEASE_NUMBER\"></span></div></th><th class=\"secondary-text acres\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"SUBLEASES.ACRES\"></span></div></th><th \nclass=\"secondary-text start\"><div class=\"table-header\"><span class=\"column-title\" translate=\"SUBLEASES.START_DATE\">\n</span></div></th><th class=\"secondary-text end\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"SUBLEASES.END_DATE\"></span></div></th><th class=\"secondary-text blocks\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"SUBLEASES.BLOCKS\"></span></div></th><th class=\"secondary-text actions-title w-100\"><div\n class=\"table-header\"><span class=\"column-title\" translate=\"SUBLEASES.ACTIONS\"></span></div></th></tr></thead><tbody \nclass=\"scrollable constrained\" ng-if=\"!loadingData && vm.filterIds.length>0\" ms-scroll \nms-infinite-scroll=\"vm.loadMore()\" ms-infinite-scroll-container=\'\".constrained\"\' ng-style=\"setSize(318)\" resize><tr \nclass=\"sublease-item\" \nng-repeat=\"sublease in vm.shownSubleases | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredSubleases track by sublease.id | limitTo:vm.offset\" \nng-click=\"vm.editSublease(ev, sublease)\"><td class=\"tenant\" ng-style=\"{\'font-weight\':\'bold\'}\">\n{{ sublease.tenant_company.name }}</td><td class=\"number\">{{ sublease.sublease_number }}</td><td class=\"acres\">\n{{ sublease.acres | numberFilter:1 }}</td><td class=\"start\">{{ sublease.start_date | date: \'mediumDate\' }}</td><td \nclass=\"end\">{{ sublease.end_date | date: \'mediumDate\' }}</td><td class=\"blocks\"><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"Blocks\" ng-disabled=\"sublease.blocks.length === 0\" \ndata-ng-mouseover=\"$mdMenu.open($event)\" ng-click=\"$event.stopPropagation();\" translate \ntranslate-attr-aria-label=\"SUBLEASES.BLOCKS\"><md-icon md-font-icon=\"icon-view-dashboard\"></md-icon></md-button>\n<md-menu-content class=\"md-menu\" width=\"3\" data-ng-mouseleave=\"$mdMenu.close($event)\"><md-list><md-list-item \nng-repeat=\"block in sublease.blocks\"><p class=\"pl-8\">{{block.name }}</p></md-list-item></md-list></md-menu-content>\n</md-menu></td><td class=\"actions w-100\"><md-button class=\"md-icon-button custom-button\" \nng-click=\"vm.patchStarred(sublease); vm.toggleInArray(sublease.id, vm.starredSubleases)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"SUBLEASES.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.exists(sublease.id,vm.starredSubleases)\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.exists(sublease.id,vm.starredSubleases)\" md-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"SUBLEASES.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"edit-lease\" translate=\"SUBLEASES.EDIT_SUBLEASE\" \nng-click=\"vm.editSublease(ev, sublease)\"></md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"sublease.blocks.length===0\" aria-label=\"view-blocks\" translate=\"SUBLEASES.VIEW_BLOCKS\" \nng-click=\"vm.goToBlockTab(ev,sublease)\"></md-button></md-menu-item><md-menu-item><md-button \nng-disabled=\"sublease.blocks.length>0\" aria-label=\"delete-sublease\" translate=\"SUBLEASES.DELETE_SUBLEASE\" \nng-click=\"vm.deleteSubleaseConfirm(ev, sublease)\"></md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader>\n</ms-loader></md-list-item><md-list-item class=\"md-white-bg\" ng-show=\"!loadingData && vm.filterIds.length === 0\"><p \nclass=\"padding-left-8\" translate=\"SUBLEASES.NO_RESULTS\">No results..</p></md-list-item></div></md-list></div></div>\n<md-button show-xs show-sm hide-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nid=\"add-sublease-button-mobile\" ng-click=\"vm.addSublease()\" aria-label=\"add sublease\" translate \ntranslate-attr-aria-label=\"SUBLEASES.ADD_SUBLEASE\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nhide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" id=\"add-sublease-button\" \nng-click=\"vm.addSublease()\" aria-label=\"add sublease\" translate translate-attr-aria-label=\"SUBLEASES.ADD_SUBLEASE\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/farm-admin/users/companies/companies.html","<div id=\"companies\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" layout-align=\"start center\"><md-button \nid=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" \naria-label=\"Toggle sidenav\" translate translate-attr-aria-label=\"COMPANIES.TOGGLE_SIDENAV\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\">\n<span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-office\" class=\"s40\"></md-icon></span><span \nclass=\"logo-text\" translate=\"COMPANIES.COMPANIES\">Companies</span></div></div><div flex-xs=\"45\" \nclass=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for company\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"COMPANIES.SEARCH_FOR_COMPANY\"></md-input-container></div></div><div \nng-show=\"vm.selectedCompanies.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedCompanies =[]\"><md-button \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"COMPANIES.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\">\n<div><span class=\"selected-companies-count\"><span>{{vm.selectedCompanies.length}}</span> <span \ntranslate=\"COMPANIES.SELECTED\">selected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"COMPANIES.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllCompanies()\" \ntranslate=\"COMPANIES.SELECT_ALL\">Select all</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.deselectCompanies()\" translate=\"COMPANIES.SELECT_NONE\">Select none</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div class=\"multi-select-actions\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteSelectedCompanies(event)\" aria-label=\"delete selected\" translate \ntranslate-attr-label=\"COMPANIES.DELETE_SELECTED\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div></div>\n</div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/farm-admin/users/companies/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\">\n<md-list class=\"companies-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\">\n<div class=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \nng-if=\"vm.listType === \'all\'\" translate=\"COMPANIES.ALL_COMPANIES\">All companies</span> <span \nng-if=\"vm.listType === \'all\' && vm.companies.length\" class=\"secondary-text companies-count\">({{vm.companies.length}}) \n</span><span ng-if=\"vm.listType === \'frequent\'\" translate=\"COMPANIES.FREQUENTLY_COMPANYED\">Frequnetly </span><span \nng-if=\"vm.listType === \'starred\'\" translate=\"COMPANIES.STARRED_COMPANIES\">Starred companies</span> <span \nng-if=\"vm.listType.name\">{{vm.listType.name }}</span> <span ng-if=\"vm.listType !== \'all\' && vm.filterIds.length\" \nclass=\"secondary-text companies-count\">({{vm.filterIds.length}})</span></div><div class=\"edit-group-form\" \nng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span ng-show=\"editGroupForm.$visible\" \neditable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup(event, vm.listType)\"></span><div>\n<md-button class=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"edit group name\" translate translate-attr-label=\"COMPANIES.EDIT_GROUP_NAME\"><md-icon \nmd-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button type=\"submit\" class=\"send-button md-accent md-raised\" \nng-show=\"editGroupForm.$visible\" ng-click=\"editGroupForm.$save()\">Save</md-button><md-button type=\"button\" \nclass=\"send-button md-accent md-raised\" ng-show=\"editGroupForm.$visible\" ng-click=\"editGroupForm.$cancel()\">Cancel\n</md-button><md-button ng-if=\"filteredCompanies.length!=0\" ng-disabled=\"filteredCompanies.length!=0\" \nclass=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup(event)\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"delete group\" translate translate-attr-label=\"COMPANIES.DELETE_GROUP\"><md-icon \nmd-font-icon=\"icon-delete s18\"></md-icon></md-button><md-button ng-if=\"filteredCompanies.length==0\" \nclass=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup(event)\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"delete group\" translate translate-attr-label=\"COMPANIES.DELETE_GROUP\"><md-icon \nmd-font-icon=\"icon-delete s18\"></md-icon></md-button></div></div></div></md-subheader><div \nclass=\"content white-bg md-whiteframe-4dp\"><div><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text w-130\"></th><th class=\"secondary-text company\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"COMPANIES.COMPANY_NAME\"></span></div></th><th class=\"secondary-text user\" hide-xs><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.PERSON_CONTACT\"></span></div></th><th \nclass=\"secondary-text email\" hide-xs><div class=\"table-header\"><span class=\"column-title\" translate=\"COMPANIES.EMAIL\">\n</span></div></th><th class=\"secondary-text cell\" hide-xs><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"COMPANIES.CELL_PHONE\"></span></div></th><th class=\"secondary-text w-90\"><div class=\"table-header actions\">\n<span class=\"column-title\" translate=\"COMPANIES.ACTIONS\"></span></div></th></tr></thead><tbody ng-style=\"setSize(318)\" \nresize class=\"scrollable constrained\" ng-if=\"!loadingData && vm.shownCompanies\" ms-scroll \nms-infinite-scroll=\"vm.loadMore()\" ms-infinite-scroll-container=\'\".constrained\"\'><tr \nng-repeat=\"company in vm.shownCompanies  | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredCompanies track by company.id | limitTo:vm.offset\" \nng-attr-id=\"{{ \'company-row-\' + company.id }}\" ng-click=\"vm.openCompanyDialog($event, company, false)\" \nng-class=\"{\'selected\': vm.isSelected(company)}\" class=\"company-table-row\"><td class=\"w-130\"><md-checkbox \nng-checked=\"vm.exists(company, vm.selectedCompanies)\" \nng-click=\"vm.toggleSelectCompany(company, event);$event.stopPropagation()\" \naria-label=\"{{vm.exists(company, vm.selectedCompanies) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><ms-loader \nng-show=\"!company.photo\" class=\"photo float-right\" data-diameter=\"15\"></ms-loader><img ng-show=\"company.photo\" \nmsload=\"vm.loaded(company)\" class=\"company-logo float-right\" alt=\"Avatar\" \nhttp-src=\"{{company.image_url || \'assets/images/avatars/office.png\'}}\"></td><td class=\"company\" \nng-style=\"{\'font-weight\':\'bold\'}\">{{ company.name }}</td><td class=\"user\" hide-xs>{{ company.contact_person }}</td><td \nclass=\"email\" hide-xs>{{ company.email_address }}</td><td class=\"cell\" hide-xs>{{ company.cell_phone }}</td><td \nclass=\"actions w-90\"><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"vm.toggleInArray(company.id, vm.starredCompanies);vm.patchStarred(company)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"COMPANIES.TOGGLE_STARRED\"><md-icon ng-if=\"company.starred\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!company.starred\" md-font-icon=\"icon-star-outline\">\n</md-icon></md-button><md-menu ng-disable=\"finishUpdate\" md-offset=\"0 -10\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event);\" ng-mouseup=\"vm.setHighlight(company.id)\" aria-label=\"More\" translate=\"\" \ntranslate-attr-aria-label=\"COMPANIES.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content class=\"md-menu\" width=\"4\"><v-accordion ng-if=\"vm.allBusinessGroups\" id=\"companies-accordion\" \nclass=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header class=\"no-border\"><md-list-item>Business Roles\n</md-list-item></v-pane-header><v-pane-content><md-menu-item class=\"md-menu-item\"><md-button class=\"md-button-br\" \nng-if=\"vm.allBusinessGroups\" ng-repeat=\"group in vm.allBusinessGroups\" ng-click=\"vm.patchCompanyGroup(company, group)\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" \nng-class=\"{\'header-color\':vm.exists(group.id, company.br),\'bold\':vm.exists(group.id, company.br)}\"><p class=\"pl-8\">\n{{group.name}}</p></md-button></md-menu-item></v-pane-content></v-pane></v-accordion></md-menu-content></md-menu></td>\n</tr></tbody></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\">\n<ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && filteredCompanies.length === 0\"><p class=\"padding-left-0\" translate=\"COMPANIES.NO_RESULTS\">\nNo results..</p></md-list-item></div></div></md-list></div></div><md-button show-xs show-sm hide-gt-sm \nclass=\"md-fab md-fab-bottom-right md-button md-accent s54\" id=\"add-company-button-mobile\" \nng-click=\"vm.openCompanyDialog(event, {})\" aria-label=\"add company\" translate \ntranslate-attr-aria-label=\"COMPANIES.ADD_COMPANY\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nhide-xs hide-sm show-gt-sm class=\"md-fab md-button md-accent s54\" id=\"add-company-button\" \nng-click=\"vm.openCompanyDialog(event, {})\" aria-label=\"add company\" translate \ntranslate-attr-aria-label=\"COMPANIES.ADD_COMPANY\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/farm-admin/users/farm-owner/farm-owner.html","<div id=\"company\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-panorama\"></md-icon><span translate=\"COMPANY.TITLE\">Farm Definition</span></div></div>\n</div><div class=\"main-scrollable\" ms-scroll><form name=\"company-form\" ms-horizontal-stepper \nng-submit=\"vm.saveCompany()\" ng-model=\"vm.company\" novalidate><ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/farm-admin/users/farm-owner/form/step1.html\'\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Contact Info\'\"><div \nng-include=\"\'app/main/farm-admin/users/farm-owner/form/step2.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Address\'\"><div \nng-include=\"\'app/main/farm-admin/users/farm-owner/form/step3.html\'\"></div></ms-horizontal-stepper-step></form></div>\n</div></div>");
$templateCache.put("app/main/farm-admin/users/users/users.html","<div id=\"users\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex-xs=\"45\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"USERS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"USERS.USERS\">\nUsers</span></div></div><div flex-xs=\"55\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input \nid=\"search\" placeholder=\"Search for user\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"USERS.SEARCH_FOR_USER\"></md-input-container></div></div><div \nng-show=\"vm.selectedUsers.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedUsers =[]\"><md-button layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"USERS.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"selected-users-count\"><span>{{vm.selectedUsers.length}}</span> <span translate=\"USERS.SELECTED\">selected\n</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"USERS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllUsers()\" translate=\"USERS.SELECT_ALL\">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectUsers()\" \ntranslate=\"USERS.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedUsers($event)\" \naria-label=\"delete selected\" translate translate-attr-label=\"USERS.DELETE_SELECTED\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/farm-admin/users/users/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main\"><md-list \nclass=\"users-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\"><div \nclass=\"list-title\" layout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \nng-if=\"vm.listType === \'all\'\" translate=\"USERS.ALL_USERS\">All users</span> <span ng-if=\"vm.listType === \'all\'\" \nclass=\"secondary-text users-count\">({{vm.users.length}}) </span><span ng-if=\"vm.listType === \'frequent\'\" \ntranslate=\"USERS.FREQUENTLY_USERED\">Frequnetly usered</span> <span ng-if=\"vm.listType === \'starred\'\" \ntranslate=\"USERS.STARRED_USERS\">Starred users</span> <span ng-if=\"vm.listType.name\">{{vm.listType.name }}</span> <span \nng-if=\"vm.listType !== \'all\' && vm.filterIds.length\" class=\"secondary-text users-count\">({{vm.filterIds.length}})\n</span></div><div class=\"edit-group-form\" ng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span \nng-show=\"editGroupForm.$visible\" editable-text=\"vm.listType.name\" e-form=\"editGroupForm\" \nonaftersave=\"vm.editGroup($event, vm.listType)\"></span><div ng-show=\"admin === true\"><md-button \nclass=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"edit group name\" translate translate-attr-label=\"USERS.EDIT_GROUP_NAME\"><md-icon \nmd-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button type=\"submit\" class=\"send-button md-accent md-raised\" \nng-show=\"editGroupForm.$visible\" ng-click=\"editGroupForm.$save()\">Save</md-button><md-button type=\"button\" \nclass=\"send-button md-accent md-raised\" ng-show=\"editGroupForm.$visible\" ng-click=\"editGroupForm.$cancel()\">Cancel\n</md-button><md-button ng-if=\"vm.filterIds.length != 0\" class=\"md-icon-button edit-group-button\" \nclass=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup($event, vm.listType)\" \nng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate translate-attr-label=\"USERS.DELETE_GROUP\"><md-icon\n md-font-icon=\"icon-delete s18\"></md-icon></md-button><md-button ng-if=\"vm.filterIds.length == 0\" \nclass=\"md-icon-button edit-group-button\" class=\"md-icon-button edit-group-button\" \nng-click=\"vm.deleteGroup($event, vm.listType)\" ng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate \ntranslate-attr-label=\"USERS.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button></div><div \nng-show=\"admin != true\" ng-if=\"groupType === \'notify_groups\'\"><md-button class=\"md-icon-button edit-group-button\" \nng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" aria-label=\"edit group name\" translate \ntranslate-attr-label=\"USERS.EDIT_GROUP_NAME\"><md-icon md-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button \nng-if=\"vm.filterIds.length!=0\" ng-disabled=\"true\" class=\"md-icon-button edit-group-button\" \nclass=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup($event, vm.listType)\" \nng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate translate-attr-label=\"USERS.DELETE_GROUP\"><md-icon\n md-font-icon=\"icon-delete s18\"></md-icon></md-button><md-button ng-if=\"vm.filterIds.length==0\" \nclass=\"md-icon-button edit-group-button\" class=\"md-icon-button edit-group-button\" \nng-click=\"vm.deleteGroup($event, vm.listType)\" ng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate \ntranslate-attr-label=\"USERS.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button></div></div>\n</div></md-subheader><div class=\"content white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover\"><thead>\n<tr><th class=\"secondary-text w-130\"></th><th class=\"secondary-text name\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"USERS.NAME\"></span></div></th><th hide-xs class=\"secondary-text company\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"USERS.COMPANY\"></span></div></th><th hide-xs \nclass=\"secondary-text email\"><div class=\"table-header\"><span class=\"column-title\" translate=\"USERS.EMAIL\"></span></div>\n</th><th hide-xs class=\"secondary-text cell\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"USERS.CELL_PHONE\"></span></div></th><th hide-xs class=\"secondary-text active\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"USERS.ACTIVE\"></span></div></th><th class=\"secondary-text w-90\"><div \nclass=\"table-header actions\"><span class=\"column-title\" translate=\"USERS.ACTIONS\"></span></div></th></tr></thead><tbody\n ng-style=\"setSize(318)\" resize class=\"scrollable constrained\" ng-if=\"!loadingData && vm.shownUsers\" ms-scroll \nms-infinite-scroll=\"vm.loadMore()\" ms-infinite-scroll-container=\'\".constrained\"\'><tr class=\"user-table-row\" \nng-repeat=\"user in vm.shownUsers | filter: vm.search | filter: global.search | filterByIds: vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredUsers track by user.id | limitTo:vm.offset\" \nng-class=\"{\'bold\':idUserOnline === user.id}\" ng-attr-id=\"{{ \'user-row-\' + user.id }}\" \nng-click=\"vm.addUserDialog($event, user, false)\"><td class=\"w-130\"><md-checkbox \nng-checked=\"vm.exists(user, vm.selectedUsers)\" ng-click=\"vm.toggleSelectUser(user)\" \naria-label=\"{{vm.exists(user, vm.selectedUsers) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><ms-loader \nng-show=\"!user.photo\" class=\"photo float-right\" data-diameter=\"15\"></ms-loader><img ng-show=\"user.photo\" \nmsload=\"vm.loaded(user)\" class=\"md-avatar float-right\" alt=\"Avatar\" \nhttp-src=\"{{user.image_url || \'assets/images/avatars/profile.jpg\'}}\"></td><td class=\"name\">{{ user.name }}</td><td \nclass=\"company\" hide-xs>{{ user.company.name }}</td><td class=\"email\" hide-xs>{{ user.email_address }}</td><td \nclass=\"cell\" hide-xs>{{ user.cell_phone }}</td><td class=\"active\" hide-xs><md-button class=\"md-icon-button\" \nng-click=\"user.active = !user.active; vm.patchActive(user)\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"USERS.TOGGLE_ACTIVE\"><md-icon ng-if=\"user.active\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon ng-if=\"!user.active\" \nmd-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></td><td class=\"actions w-90\"><md-button \nclass=\"md-icon-button hide show-gt-xs\" \nng-click=\"$event.stopPropagation();vm.toggleInArray(user.id, vm.starredUsers);vm.patchStarred(user)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_STARRED\"><md-icon ng-if=\"user.starred\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!user.starred\" md-font-icon=\"icon-star-outline\">\n</md-icon></md-button><md-menu md-offset=\"0 -10\"><md-button ng-disable=\"finishUpdate\" class=\"md-icon-button\" \naria-label=\"More\" translate translate-attr-aria-label=\"USERS.MORE\" ng-click=\"$mdMenu.open($event);\" \nng-mouseup=\"vm.setHighlight(user.id)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content\n class=\"md-menu\" width=\"4\"><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane \nng-if=\"vm.allRolesGroups\"><v-pane-header class=\"no-border\"><md-list-item>Users Roles</md-list-item></v-pane-header>\n<v-pane-content><md-menu-item class=\"md-menu-item\"><md-button class=\"md-button-br\" ng-if=\"vm.allRolesGroups\" \nng-repeat=\"group in vm.allRolesGroups\" ng-click=\"vm.patchRoleGroup(user, group)\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" \nng-class=\"{\'header-color\': vm.exists(group.id, user.r) ,\'fw-500\': vm.exists(group.id, user.r) }\"><p class=\"pl-8\">\n{{group.name }}</p></md-button></md-menu-item></v-pane-content></v-pane><v-pane ng-if=\"vm.allNotifyGroups.length > 0\">\n<v-pane-header class=\"no-border\"><md-list-item>Notify Groups</md-list-item></v-pane-header><v-pane-content>\n<md-menu-item class=\"md-menu-item\"><md-button class=\"md-button-br\" ng-if=\"vm.allNotifyGroups\" \nng-repeat=\"group in vm.allNotifyGroups\" ng-click=\"vm.patchNotifyGroup(user, group)\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" \nng-class=\"{\'header-color\':vm.exists(group.id, user.ng) ,\'fw-500\':vm.exists(group.id, user.ng) }\"><p class=\"pl-8\">\n{{group.name }}</p></md-button></md-menu-item></v-pane-content></v-pane></v-accordion></md-menu-content></md-menu></td>\n</tr></tbody></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\">\n<ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && filteredUsers.length === 0\"><p class=\"padding-left-8\" translate=\"USERS.NO_RESULTS\">\nNo results...</p></md-list-item></div></md-list></div></div><md-button show-xs show-sm hide-gt-sm \nclass=\"md-fab md-fab-bottom-right md-accent md-icon-button\" id=\"add-user-button-mobile\" \nng-click=\"vm.addUserDialog($event,{})\" aria-label=\"add user\" translate translate-attr-aria-label=\"USERS.ADD_USER\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button hide-xs hide-sm show-gt-sm \nclass=\"md-fab md-accent md-icon-button add-icon-large\" id=\"add-user-button\" ng-click=\"vm.addUserDialog($event,{})\" \naria-label=\"add user\" translate translate-attr-aria-label=\"USERS.ADD_USER\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/phase-type/phase-type.html","<div id=\"lands\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" layout=\"column\" flex><div ng-show=\"stepCurrent===1\" class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Phase type</span>\n</div><div class=\"land-count secondary-text\"></div><div class=\"land-title secondary-text\"><span></span></div></div>\n<div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-land-button\" ng-click=\"vm.showDialogStep1()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button ng-disabled=\"vm.checkStep1FormValid()\" \nclass=\"md-raised md-background\" id=\"save-land-button\" ng-click=\"vm.saveWorkType($event)\"><span aria-label \ntranslate=\"LANDS.SAVE\"></span></md-button></div></div><div ng-show=\"stepCurrent===2\" class=\"header\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"white-fg\" layout=\"column\" layout-align=\"start start\"><div class=\"h1\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-cube-outline\"></md-icon><span>Phase type</span>\n</div><div class=\"land-count secondary-text\"></div><div class=\"land-title secondary-text\"><span></span></div></div>\n<div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-land-button\" ng-click=\"vm.showDialogStep2()\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button class=\"md-raised md-background\" id=\"save-land-button\" \nng-disabled=\"vm.step2.$invalid\" ng-click=\"vm.savePhase($event)\"><span aria-label translate=\"LANDS.SAVE\"></span>\n</md-button></div></div><form class=\"formLand\" name=\"land-form\" hide-save=\"true\" ng-open=\"vm.openForm()\" \nms-horizontal-custom-stepper ng-model=\"vm.stepper\" novalidate><ms-horizontal-custom-stepper-step ng-form=\"vm.step1\" \nstep=\"1\" step-title=\"\'Name\'\"><div ng-include=\"\'app/main/farm-admin/work-schedule-template/phase-type/form/step1.html\'\">\n</div></ms-horizontal-custom-stepper-step><ms-horizontal-custom-stepper-step ng-form=\"vm.step2\" step=\"2\" \nstep-title=\"\'Phase Names\'\"><div ng-include=\"\'app/main/farm-admin/work-schedule-template/phase-type/form/step2.html\'\">\n</div></ms-horizontal-custom-stepper-step></form></div></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-template/work-template.html","<div id=\"work-template\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"45\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"USERS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"WORK_TEMPLATE.TITLE\"></span></div></div><div flex-xs=\"55\" class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label>\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for user\" type=\"text\" \nng-model=\"vm.search\" translate translate-attr-placeholder=\"WORK_TEMPLATE.SEARCH_WORK\"></md-input-container></div></div>\n<div ng-show=\"vm.selectedWT.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedWT =[]\"><md-button layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"USERS.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"selected-users-count\"><span>{{vm.selectedWT.length}}</span> <span translate=\"USERS.SELECTED\">selected\n</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"USERS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllUsers()\" translate=\"USERS.SELECT_ALL\">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectUsers()\" \ntranslate=\"USERS.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedWT($event)\" \naria-label=\"delete selected\" translate translate-attr-label=\"USERS.DELETE_SELECTED\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/farm-admin/work-schedule-template/work-template/sidenavs/main/main-sidenav.html\'\"></md-sidenav>\n<div class=\"main scrollable constrained\"><md-list class=\"users-list\"><md-subheader class=\"md-no-sticky md-white-bg\">\n<div class=\"row-header\" layout=\"row\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" translate=\"WORK_TEMPLATE.ALL_TEMPLATE\">\nAll work templates</span> <span ng-if=\"vm.listType === \'all\'\" class=\"secondary-text users-count\">\n({{vm.shownWorkTemplates.length}}) </span><span ng-if=\"vm.listType === \'frequent\'\" translate=\"USERS.FREQUENTLY_USERED\">\nFrequnetly usered</span> <span ng-if=\"vm.listType === \'starred\'\" translate=\"USERS.STARRED_USERS\">Starred work templates\n</span> <span ng-if=\"vm.listType.name\">{{vm.listType.name }}</span> <span \nng-if=\"vm.listType !== \'all\' && vm.filterIds.length\" class=\"secondary-text users-count\">({{vm.filterIds.length}})\n</span></div><div class=\"edit-group-form\" ng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span \nng-show=\"editGroupForm.$visible\" editable-text=\"vm.listType.name\" e-form=\"editGroupForm\" \nonaftersave=\"vm.editGroup($event, vm.listType)\"></span><div ng-show=\"admin != true\" \nng-if=\"groupType === \'notify_groups\'\"><md-button class=\"md-icon-button edit-group-button\" \nng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" aria-label=\"edit group name\" translate \ntranslate-attr-label=\"USERS.EDIT_GROUP_NAME\"><md-icon md-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button \nng-if=\"filteredUsers.length!=0\" ng-disabled=\"true\" class=\"md-icon-button edit-group-button\" \nclass=\"md-icon-button edit-group-button\" ng-click=\"vm.deleteGroup($event, vm.listType)\" \nng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate translate-attr-label=\"USERS.DELETE_GROUP\"><md-icon\n md-font-icon=\"icon-delete s18\"></md-icon></md-button><md-button ng-if=\"filteredUsers.length==0\" \nclass=\"md-icon-button edit-group-button\" class=\"md-icon-button edit-group-button\" \nng-click=\"vm.deleteGroup($event, vm.listType)\" ng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate \ntranslate-attr-label=\"USERS.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button></div></div>\n</div></md-subheader><div class=\"content white-bg md-whiteframe-4dp\"><div><table class=\"dataTable row-border hover\" \nms-responsive-table ms-infinite-scroll=\"vm.loadMore()\" ms-infinite-scroll-container=\'\".constrained\"\'><thead><tr><th \nclass=\"secondary-text w-130\"></th><th class=\"secondary-text\" class=\"w-5-p\"></th><th class=\"secondary-text name\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_TEMPLATE.NAME\"></span></div></th><th hide-xs \nclass=\"secondary-text text-center company\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_TEMPLATE.PHASE_TYPE\"></span></div></th><th hide-xs class=\"secondary-text text-center company\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_TEMPLATE.SEASONS\"></span></div></th><th hide-xs \nclass=\"secondary-text text-center company\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"WORK_TEMPLATE.SEED\"></span></div></th><th hide-xs class=\"secondary-text text-center company\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"WORK_TEMPLATE.WORK_ACTIVE\"></span></div></th><th \nclass=\"secondary-text w-90\"><div class=\"table-header actions\"><span class=\"column-title\" translate=\"USERS.ACTIONS\">\n</span></div></th></tr></thead><tbody ng-style=\"setSize(318)\" resize class=\"scrollable constrained\" ms-scroll \nng-if=\"!loadingData && vm.filterIds.length>0\"><tr ng-click=\"vm.goWTpage(workTemplate)\" class=\"user-table-row\" \nng-repeat=\"workTemplate in vm.shownWorkTemplates | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredUsers track by $index | limitTo:vm.offset\">\n<td class=\"w-130\"><md-checkbox ng-checked=\"vm.exists(workTemplate, vm.selectedWT)\" \nng-click=\"vm.toggleSelectWT(workTemplate, $event);\" \naria-label=\"{{vm.exists(workTemplate, vm.selectedWT) ? \'Deselect\' : \'Select\'}}\"></md-checkbox></td><td><div flex=\"50\" \nclass=\"badge no-text clickeable\" ng-style=\"{\'background-color\':workTemplate.color}\"></div></td><td class=\"name\"><div \nlayout=\"row\" flex><span flex=\"100\">{{ workTemplate.name }}</span></div></td><td class=\"company\" hide-xs>\n{{vm.showPhaseTypeName(workTemplate)}}</td><td class=\"company\" hide-xs>{{vm.showSeasonName(workTemplate)}}</td><td \nclass=\"company\" hide-xs>{{vm.showSeedName(workTemplate)}}</td><td class=\"active\" hide-xs><md-button \nclass=\"md-icon-button\" \nng-click=\"$event.stopPropagation(); workTemplate.active = !workTemplate.active; vm.patchActive(workTemplate)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_ACTIVE\"><md-icon \nng-if=\"workTemplate.active\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon \nng-if=\"!workTemplate.active\" md-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></td><td \nclass=\"actions w-150\"><md-button \nng-click=\"$event.stopPropagation();vm.openCloneWorkTemplateDialog($event,workTemplate)\" class=\"md-icon-button\"><i \nstyle=\"font-size:18px\" class=\"fa fa-files-o\" aria-hidden=\"true\"></i></md-button><md-button \nclass=\"md-icon-button hide show-gt-xs\" \nng-click=\"$event.stopPropagation();vm.toggleInArray(workTemplate.id, vm.starredWT);vm.patchStarred(workTemplate)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_STARRED\"><md-icon \nng-if=\"workTemplate.starred\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!workTemplate.starred\" md-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"USERS.MORE\" \nng-click=\"$mdMenu.open($event)\"><md-icon ng-disable=\"finishUpdate\" md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"4\"><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane \nng-if=\"vm.allRolesGroups\"><v-pane-header class=\"no-border\"><md-list-item>Seasons</md-list-item></v-pane-header>\n<v-pane-content><md-list><md-list-item ng-if=\"vm.seasons\" ng-repeat=\"group in vm.seasons\" \nng-click=\"vm.patchSeason(workTemplate, group)\" \nng-class=\"{\'header-color\':vm.exists(group.id, workTemplate.seasons) ,\'fw-500\':vm.exists(group.id, workTemplate.seasons) }\">\n<p class=\"pl-8\">{{group.name}}</p></md-list-item></md-list></v-pane-content></v-pane><v-pane \nng-if=\"vm.allNotifyGroups\"><v-pane-header class=\"no-border\"><md-list-item>Seeds</md-list-item></v-pane-header>\n<v-pane-content><md-list><md-list-item ng-if=\"vm.seeds\" ng-repeat=\"group in vm.seeds\" \nng-click=\"vm.patchSeed(workTemplate, group)\" \nng-class=\"{\'header-color\':vm.exists(group.id, workTemplate.seeds) ,\'fw-500\':vm.exists(group.id, workTemplate.seeds) }\">\n<p class=\"pl-8\">{{group.name}}</p></md-list-item></md-list></v-pane-content></v-pane></v-accordion></md-menu-content>\n</md-menu></td></tr></tbody></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" \nlayout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && filteredUsers.length === 0\"><p class=\"padding-left-8\" translate=\"USERS.NO_RESULTS\">\nNo results...</p></md-list-item></div></div></md-list></div></div><md-button show-xs show-sm hide-gt-sm \nclass=\"md-fab md-fab-bottom-right md-accent md-icon-button\" id=\"add-user-button-mobile\" \nng-click=\"vm.openWTDialog($event,{color:\'#000\'})\" aria-label=\"add user\" translate \ntranslate-attr-aria-label=\"USERS.ADD_USER\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button hide-xs \nhide-sm show-gt-sm class=\"md-fab md-fab-top-right md-accent md-icon-button add-icon-large\" id=\"add-user-button\" \nng-click=\"vm.openWTDialog($event,{color:\'#000\'})\" aria-label=\"add user\" translate \ntranslate-attr-aria-label=\"USERS.ADD_USER\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-template-2/work-template-2.html","<div id=\"tasks\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex-xs=\"45\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"USERS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.$window.history.back();\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-chevron-left\" class=\"icon\">\n</md-icon></md-button><span hide-xs hide-sm class=\"logo-icon\"><md-icon md-font-icon=\"icon-account-multiple\" \nclass=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"WORK_TEMPLATE_2.TITLE\"></span></div></div><div \nflex-xs=\"55\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"phaseForm.$invalid || vm.invalidPhases()\" class=\"md-raised md-background\" id=\"save-land-button\" \nng-click=\"vm.save()\"><span aria-label translate=\"LANDS.SAVE\"></span></md-button></div></div><div class=\"content\" \nmd-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" \nms-scroll md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/farm-admin/work-schedule-template/work-template-2/sidenavs/main/main-sidenav.html\'\"></md-sidenav>\n<div class=\"main scrollable constrained\" ms-scroll><md-list class=\"users-list\"><form name=\"phaseForm\" novalidate>\n<md-card class=\"padding-15 padding-bottom-5\"><md-card-header><h1>Work Template Information</h1></md-card-header><div \nlayout=\"row\" flex><md-input-container flex=\"10\"><div layout=\"row\" flex><div flex=\"40\"><label>Color</label></div><div \nflex=\"30\" ng-click=\"vm.openColorPicker($event,vm.workTemplate)\" style=\"margin-top:7px\" \nclass=\"badge no-text clickeable\" ng-style=\"{\'background-color\':vm.workTemplate.color}\"></div></div>\n</md-input-container><md-input-container flex=\"25\"><label translate=\"WORK_TEMPLATE_2.DIALOG_NAME\"></label><input \ntype=\"text\" required ng-model=\"vm.workTemplate.name\"></md-input-container><md-input-container flex=\"20\"><label>\nPhase Type</label><md-select disabled=\"disabled\" required ng-model=\"vm.workTemplate.phase_type_id\" \nplaceholder=\"Phase Type\"><md-option ng-value=\"phase.id\" ng-repeat=\"phase in vm.phaseType\">{{ phase.name }}</md-option>\n</md-select></md-input-container><md-input-container flex=\"20\"><label>Seed</label><md-select required \nng-model=\"vm.workTemplate.seed_id\" placeholder=\"Seed\"><md-option ng-value=\"seed.id\" ng-repeat=\"seed in vm.seeds\">\n{{ seed.name }}</md-option></md-select></md-input-container><md-input-container flex=\"25\"><label>Season</label>\n<md-select required ng-model=\"vm.workTemplate.season_id\" placeholder=\"Season\"><md-option ng-value=\"season.id\" \nng-repeat=\"season in vm.seasons\">{{ season.name }}</md-option></md-select></md-input-container></div></md-card></form>\n<md-card style=\"padding-bottom: 20px\" class=\"phases-body\"><md-card-header><h1>Work Template Detail</h1>\n</md-card-header><md-list><md-list-item><div layout=\"row\" flex layout-align=\"center center\"><div flex-xs=\"20\" \nflex=\"10\"></div><div flex-xs=\"70\" flex=\"10\"><span class=\"column-title\" translate=\"WORK_TEMPLATE_2.NAME\"></span></div>\n<div hide-xs flex=\"10\"><span class=\"column-title\" translate=\"WORK_TEMPLATE_2.DAYLIGHT_ONLY\"></span></div><div hide-xs \nflex=\"10\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\" \ntranslate=\"WORK_TEMPLATE_2.ESTIMATED_MINUTES\"></span></div><div hide-xs layout=\"row\" layout-align=\"center center\" \nflex=\"10\"><span class=\"column-title\" translate=\"WORK_TEMPLATE_2.NOTIFY_GROUP\"></span></div><div hide-xs layout=\"row\" \nlayout-align=\"center center\" flex=\"10\"><span class=\"column-title\" translate=\"WORK_TEMPLATE_2.NOTIFY_START\"></span>\n</div><div hide-xs layout=\"row\" layout-align=\"center center\" flex=\"10\"><span class=\"column-title\" \ntranslate=\"WORK_TEMPLATE_2.NOTIFY_END\"></span></div><div hide-xs layout=\"row\" layout-align=\"center center\" flex=\"10\">\n<span class=\"column-title\" translate=\"WORK_TEMPLATE_2.EQUIPMENT_GROUP\"></span></div><div hide-xs layout=\"row\" \nlayout-align=\"center center\" flex=\"10\"><span class=\"column-title\" translate=\"WORK_TEMPLATE_2.LABOR_GROUP\"></span></div>\n<div flex=\"10\" layout=\"row\" layout-align=\"center center\"><span class=\"column-title\">Actions</span></div></div>\n</md-list-item><ul ng-if=\"vm.getAnchorTasks().length>1\" style=\"background-color: #ffe8a7\" \nclass=\"margin-0 padding-left-15 clickeable animated drag-task-item\" layout=\"row\" flex layout-align=\"left center\"><p \nrole=\"alert\" class=\"margin-left-20\">\n{{vm.anchorTask.name}} is already assigned to Template, Template can only have one Anchor Task.</p></ul><v-accordion \nclass=\"vAccordion--default taskAcc phase-item\" onexpand=\"vm.phaseExpand(index, id,true)\" \noncollapse=\"vm.phaseExpand(index, id,false)\" control=\"vm.accordion\" multiple=\"true\"><div \nng-repeat=\"phase in vm.getFilteredPhases()\"><v-pane id=\"{{$index}}\"><v-pane-header><md-list-item dnd-list \ndnd-drop=\"vm.insertOnLast($index, item, external, type,phase)\"><div flex layout=\"row\" \nclass=\"padding-left-20 drag-task-list clickeable\"><div flex=\"30\" layout=\"row\"><div \nng-click=\"vm.openColorPicker($event,phase)\" class=\"badge no-text clickeable\" \nng-style=\"{\'background-color\':phase.color}\"></div><p class=\"margin-top-0 margin-left-10\">\n{{phase.name}} | ({{phase.tasks.length}} Tasks)</p></div></div></md-list-item></v-pane-header><v-pane-content><md-list \nclass=\"padding-0\"><ul dnd-list=\"phase.tasks\" class=\"padding-0 margin-0\" \ndnd-inserted=\"vm.setInserted($index, item, external, type,phase)\" \ndnd-drop=\"vm.checkIfTaskIsAdded(index, item, external, type,phase)\"><li class=\"padding-0 margin-0\" \nng-repeat=\"task in phase.tasks\"><div dnd-handle ng-click=\"vm.openTaskDialog($event,task)\" \nng-class=\"{\'bg-whiteSmoke\':vm.taskSelected == task}\" class=\"clickeable animated drag-task-item\" dnd-draggable=\"task\" \ndnd-effect-allowed=\"move\" dnd-selected=\"vm.taskSelected = task\" dnd-moved=\"phase.tasks.splice($index, 1)\" flex \nlayout=\"row\" layout-align=\"left center\"><div layout-align=\"left center\" layout=\"row\" flex><div layout=\"row\" \nflex-xs=\"100\" flex=\"30\" layout-align=\"left center\"><div class=\"handle\" flex=\"15\"></div><div class=\"handle\" flex=\"10\">\n:::</div><div flex=\"10\">{{$index+1}}</div><div class=\"color\" flex=\"20\"><div class=\"badge no-text clickeable\" \nng-style=\"{\'background-color\':task.color}\"></div></div><div class=\"name\" flex=\"45\">{{task.name}} <b>\n{{vm.getAnchorShortCode(task.anchor_id)}}</b></div></div><div hide-xs flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" style=\"margin:0px;padding:0px\" ng-click=\"\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_ACTIVE\"><md-icon \nng-if=\"task.daylight_only\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon \nng-if=\"!task.daylight_only\" md-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></div><div \nng-if=\"task.time_to_complete_mesured_by_acre\" hide-xs flex=\"10\" layout=\"row\" layout-align=\"center center\">\n{{task.estimated_minutes || 0}} P.A</div><div ng-if=\"!task.time_to_complete_mesured_by_acre\" hide-xs flex=\"10\" \nlayout=\"row\" layout-align=\"center center\">{{task.estimated_minutes2 || 0}}</div><div hide-xs flex=\"10\" layout=\"row\" \nlayout-align=\"center center\">{{vm.showTaskNotifyGroupName(task)}}</div><div hide-xs flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" style=\"margin:0px;padding:0px\" ng-click=\"\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_ACTIVE\"><md-icon \nng-if=\"task.notify_at_start\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon \nng-if=\"!task.notify_at_start\" md-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></div><div \nhide-xs flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-icon-button\" \nstyle=\"margin:0px;padding:0px\" ng-click=\"\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"USERS.TOGGLE_ACTIVE\"><md-icon ng-if=\"task.notify_at_end\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon ng-if=\"!task.notify_at_end\" \nmd-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></div><div hide-xs flex=\"10\" layout=\"row\" \nlayout-align=\"center center\">{{vm.showTaskEquipmentGroupName(task)}}</div><div hide-xs flex=\"10\" layout=\"row\" \nlayout-align=\"center center\">{{vm.showTaskLaborGroupName(task)}}</div><div layout=\"row\" layout-align=\"center center\" \nflex=\"10\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"More\" translate=\"\" \ntranslate-attr-aria-label=\"COMPANIES.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"$event.stopPropagation();phase.tasks.splice($index, 1);vm.checkIfIsAnchorTaskAndRemove(task)\">Delete\n</md-button></md-menu-item></md-menu-content></md-menu></div></div></div></li><li class=\"dndPlaceholder\">\nDrop any task here</li></ul></md-list></v-pane-content></v-pane></div></v-accordion></md-list><md-list-item \nng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader></ms-loader></md-list-item>\n</md-card></md-list></div></div></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img src=\"../assets/images/logos/ggs.svg\" alt=\"GreenSky logo\"></div><div class=\"title\" \ntranslate=\"FORGOT_PASSWORD.TITLE\"></div><form name=\"forgotPasswordForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" \ntranslate translate-attr-placeholder=\"FORGOT_PASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div class=\"error-message\" \nng-message=\"required\"><span translate=\"FORGOT_PASSWORD.ERRORS.EMAIL_REQUIRED\"></span></div><div class=\"error-message\" \nng-message=\"pattern\"><span translate=\"FORGOT_PASSWORD.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container>\n<md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" ng-click=\"vm.requestPassword()\" \ntranslate=\"FORGOT_PASSWORD.SEND_RESET_LINK\" translate-attr-aria-label=\"FORGOT_PASSWORD.SEND_RESET_LINK\"></md-button>\n</form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"FORGOT_PASSWORD.GO_BACK\"></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/forgot-password/set-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo\"><img src=\"../assets/images/logos/ggs.svg\" alt=\"GreenSky logo\"></div><div class=\"title\" \ntranslate=\"NEW_PASSWORD.TITLE\"></div><form name=\"setPasswordForm\" novalidate><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"NEW_PASSWORD.PASSWORD\" ng-pattern=\"/^.{6,}$/\" ng-required=\"!vm.isValidPassword()\"><div \nng-messages=\"setPasswordForm.password.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"NEW_PASSWORD.ERRORS.PASSWORD_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"NEW_PASSWORD.ERRORS.PASSWORD_MUST_MATCH\"></span></div></div></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password_confirm\" ng-model=\"vm.form.password_confirm\" \nplaceholder=\"Confirm Password\" translate translate-attr-placeholder=\"NEW_PASSWORD.PASSWORD_CONFIRM\" \nng-pattern=\"/^.{6,}$/\" ng-required=\"!vm.isValidPassword()\"><div ng-messages=\"setPasswordForm.password_confirm.$error\" \nrole=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"NEW_PASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"NEW_PASSWORD.ERRORS.PASSWORD_MUST_MATCH\"></span></div></div></md-input-container><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"setPasswordForm.$invalid || vm.setPasswordForm.$pristine\" ng-click=\"vm.setNewPassword()\" \ntranslate=\"NEW_PASSWORD.SET_NEW_PASSWORD\" translate-attr-aria-label=\"NEW_PASSWORD.SET_NEW_PASSWORD\"></md-button></form>\n</div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" style=\"background-image: url({{vm.background.image_url}})\" class=\"flex-scrollable\" layout=\"column\" \nms-scroll><div id=\"login-form-wrapper\" layout=\"column\" layout-align=\"center center\"><div id=\"login-form\" \nclass=\"md-whiteframe-8dp\"><div class=\"logo\"><img src=\"../assets/images/logos/ggs.svg\" alt=\"GreenSky logo\"></div><div \nclass=\"title\" translate=\"LOGIN.TITLE\"></div><form name=\"loginForm\" ng-submit=\"vm.login()\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div class=\"error-message\" ng-message=\"required\">\n<span translate=\"LOGIN.ERRORS.EMAIL_REQUIRED\"></span></div><div class=\"error-message\" ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\"></span></div></div></md-input-container><md-input-container class=\"md-block\" \nmd-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"LOGIN.PASSWORD\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div \nclass=\"error-message\" ng-message=\"required\"><span translate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\"></span></div></div>\n</md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"remember\" aria-label=\"Remember Me\"><span\n translate=\"LOGIN.REMEMBER_ME\">Remember Me</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" \nclass=\"forgot-password md-accent-color\" translate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" translate=\"LOGIN.LOG_IN\" \ntranslate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form></div></div><div ng-if=\"changeBack\" \nclass=\"change-background-button md-primary-bg\" ng-click=\"vm.changeBackground($event, vm.background)\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"white-text\"></md-icon></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo\"><img \nsrc=\"../assets/images/logos/ggs.svg\" alt=\"GreenSky logo\"></div><div class=\"title\" translate=\"REGISTER.TITLE\">\nCreate an account</div><form name=\"registerForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input \nname=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" translate translate-attr-placeholder=\"REGISTER.NAME\" \nrequired><div ng-messages=\"registerForm.username.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Username field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"REGISTER.PASSWORD\" required>\n<div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required><div ng-messages=\"registerForm.passwordConfirm.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nPassword (Confirm) field is required</span></div></div></md-input-container><div class=\"terms\" layout=\"row\" \nlayout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required>\n</md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">\nI read and accept</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a>\n</div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"REGISTER.LOGIN\">Log in</a>\n</div></div></div></div>");
$templateCache.put("app/main/pages/contracts/tabs/tabs.html","<div ng-cloak><div id=\"tabs\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.backListing()\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\">\n<md-icon hide-xs md-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><span ng-show=\"vm.contract.id\" \nclass=\"logo-text\" translate=\"CONTRACTS.CONTRACT_EDIT\">Contracts</span> <span ng-show=\"!vm.contract.id\" \nclass=\"logo-text\" translate=\"CONTRACTS.CONTRACT_ADD\">Contracts</span></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button \nng-disabled=\"(vm.informationForm.$invalid || vm.informationForm.$pristine) && (vm.paymentsForm.$invalid || vm.paymentsForm.$pristine) && !vm.isCropUpdated\" \nclass=\"md-raised md-background\" ng-click=\"vm.tabsSave($event)\"><span ng-show=\"vm.contract.id\">Save</span> <span \nng-show=\"!vm.contract.id\">Add</span></md-button></div></div></div><md-content><md-tabs md-dynamic-height \nmd-border-bottom md-selected=\"vm.selectedTab\"><md-tab label=\"Information\"><md-content \nclass=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/pages/contracts/tabs/sections/information/information.html\'\"></div></div></md-content></md-tab>\n<md-tab ng-if=\"vm.contract.id\" label=\"Crops\"><md-content class=\"custom-content md-padding\" layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/pages/contracts/tabs/sections/crops/crops.html\'\"></div></div></md-content></md-tab><md-tab \nng-if=\"vm.contract.id\" label=\"Payment Schedule\"><md-content class=\"custom-content-payment md-padding\" \nlayout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/pages/contracts/tabs/sections/payment-schedule/payment-schedule.html\'\"></div></div></md-content>\n</md-tab><md-tab ng-if=\"vm.contract.id\" label=\"Documents\"><md-content class=\"custom-content md-padding\" \nlayout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/pages/contracts/tabs/sections/documents/documents.html\'\"></div></div></md-content></md-tab>\n</md-tabs></md-content></div>");
$templateCache.put("app/main/pages/errors/401/error-401.html","<div id=\"error-401\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR401.CODE\">401</div><div class=\"message\" \ntranslate=\"ERROR401.MESSAGE\">Sorry but you don\'t have access to the page you are looking for</div><a \nclass=\"back-link md-accent-color\" href=\"/login\" translate=\"ERROR401.GO_BACK_LOGIN\">Go back to login</a></div></div>");
$templateCache.put("app/main/pages/planting-schedule/tabs/tabs.html","<div ng-cloak><div id=\"tabs-planting-schedule\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.backListing()\" aria-label=\"Back\"><md-icon \nmd-font-icon=\"icon-chevron-left\" class=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon hide-xs md-font-icon=\"icon-satellite\" class=\"s24\">\n</md-icon></span><span class=\"logo-text\" translate=\"PLANTING_SCHEDULE.PLANTING_SCHEDULE\"></span> <span \nclass=\"logo-text\">: {{vm.blockNumber}}</span></div></div><div layout=\"row\" layout-align=\"end center\"><md-button \nng-show=\"vm.newBlock\" class=\"md-raised md-background\" ng-click=\"vm.addPlantingSchedule()\"><span>Confirm</span>\n</md-button></div></div></div><div id=\"tab-planting-schedule-content\"><md-content><md-tabs md-dynamic-height \nmd-border-bottom md-selected=\"vm.selectedTab\"><md-tab label=\"Information\" ng-if=\"vm.newBlock\"><md-content \nclass=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/pages/planting-schedule/tabs/sections/add-new/add-new.html\'\"></div></div></md-content></md-tab>\n<md-tab label=\"Block Information\" ng-if=\"!vm.newBlock\"><md-content class=\"custom-content md-padding\" \nlayout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/pages/planting-schedule/tabs/sections/block-information/block-information.html\'\"></div></div>\n</md-content></md-tab><md-tab label=\"Planting Schedule Information\" ng-if=\"!vm.newBlock\"><md-content \nclass=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/pages/planting-schedule/tabs/sections/planting-schedule-information/planting-schedule-information.html\'\">\n</div></div></md-content></md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/pages/reports/contract-schedule-report/contract-schedule-report.html","<div id=\"contract-schedule-report\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" \nlayout-align=\"start center\"><md-button id=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"BLOCKS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-chart-areaspline\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"CONTRACT_SCHEDULE_REPORT.CONTRACT_SCHEDULE_REPORT\">Contract Schedule Report</span><div><md-switch \nclass=\"switch\" ng-click=\"vm.toggleWeekEndingTotals()\" aria-label=\"Disabled\"></md-switch><md-tooltip><div class=\"name\">\n{{vm.byWetDate ? \"Calculate Week Ending by Wet Date\" : \"Calculate Week Ending by Harvest Date\"}}</div></md-tooltip>\n</div></div></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/pages/reports/contract-schedule-report/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"main\" ms-scroll><md-list class=\"contract-schedule-report-list\"><div class=\"content white-bg md-whiteframe-4dp\">\n<table class=\"dataTable row-border hover h-100-p\"><thead><tr class=\"section-titles md-accent-bg padding-bottom-0\"><div>\n<th class=\"filter-shipper\"><span ng-if=\"vm.shipper_name === \'\'\" translate=\"CONTRACT_SCHEDULE_REPORT.ALL_SHIPPERS\">\n</span> <span ng-if=\"vm.shipper_name !== \'\'\">{{vm.shipper_name }}</span></th></div></tr><tr \nclass=\"section-titles md-accent-bg padding-bottom-0\" ng-if=\"vm.startYear && vm.endYear\"><div><th class=\"year-range\">\n<span>{{vm.startYear }} - {{vm.endYear}}</span></th></div></tr><tr class=\"section-titles md-accent-bg\"><div><th \nclass=\"filter-season\"><span ng-if=\"vm.season_name === \'\'\" translate=\"CONTRACT_SCHEDULE_REPORT.ALL_SEASONS\"></span> \n<span ng-if=\"vm.season_name !== \'\'\" class=\"font-weight-300\">{{vm.season_name }}</span></th><th class=\"filter-week\">\n<span ng-if=\"vm.week_ending_name === \'\'\" translate=\"CONTRACT_SCHEDULE_REPORT.ALL_WEEKS\"></span> <span \nng-if=\"vm.week_ending_name !== \'\'\">{{vm.week_ending_name }}</span></th><th class=\"filter-location\"><span \nng-if=\"vm.location_name === \'\'\" translate=\"CONTRACT_SCHEDULE_REPORT.ALL_LOCATIONS\"></span> <span \nng-if=\"vm.location_name !== \'\'\">{{vm.location_name }}</span></th></div></tr><tr class=\"align-center\"><th \nclass=\"secondary-text shipper\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CONTRACT_SCHEDULE_REPORT.SHIPPER\"></span></div></th><th class=\"secondary-text season\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CONTRACT_SCHEDULE_REPORT.SEASON\"></span></div></th><th \nclass=\"secondary-text wet-date\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CONTRACT_SCHEDULE_REPORT.WET_DATE\"></span></div></th><th class=\"secondary-text location\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CONTRACT_SCHEDULE_REPORT.LOCATION\"></span></div></th><th \nclass=\"secondary-text acres\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CONTRACT_SCHEDULE_REPORT.ACRES\"></span></div></th><th class=\"secondary-text seed\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"CONTRACT_SCHEDULE_REPORT.SEED\"></span></div></th><th \nclass=\"secondary-text variety\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CONTRACT_SCHEDULE_REPORT.VARIETY\"></span></div></th><th class=\"secondary-text growing-days\"><div \nclass=\"table-header\"><span class=\"column-title\">Est. Growing<br>Days</span></div></th><th \nclass=\"secondary-text harvest-date w-100\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"CONTRACT_SCHEDULE_REPORT.HARVEST_DATE\"></span></div></th></tr></thead><tbody \nng-if=\"!loadingData && vm.filterIds.length>0\" class=\"scrollable constrained\" ng-style=\"setSize(318)\" resize ms-scroll \nms-infinite-scroll=\"\" ms-infinite-scroll-container=\'\".constrained\"\' \nng-repeat=\"contractSchedulesOfWeek in vm.contractSchedules track by $index\"><tr class=\"contract-report-item\" \nng-if=\"contractSchedulesOfWeek.contract_schedules.length\" \nng-repeat=\"contractSchedule in contractSchedulesOfWeek.contract_schedules | filter: vm.search | filter: global.search | filterByIds:vm.filterIds | orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContracts track by contractSchedule.id | limitTo:vm.limit\">\n<td class=\"shipper\">{{contractSchedule.contract_schedule.contract.company.name}}</td><td class=\"season\">\n{{contractSchedule.season.name}}</td><td class=\"wet-date\">{{contractSchedule.original_wet_date | date:\'EEE, MMM d\'}}\n</td><td class=\"location\">{{contractSchedule.contract_schedule.location.name}}</td><td class=\"acres\">\n{{contractSchedule.acres | number:0}}</td><td class=\"seed\">{{contractSchedule.contract_schedule.seed.name}}</td><td \nclass=\"variety\">{{contractSchedule.variety.name}}</td><td class=\"growing-days\">\n{{contractSchedule.original_growing_days}}</td><td class=\"harvest-date w-100\">\n{{contractSchedule.original_harvest_date | date:\'EEE, MMM d\'}}</td></tr><tr \nng-if=\"contractSchedulesOfWeek.contract_schedules.length\" class=\"text-bold border-top margin-bottom-10\"><td \nclass=\"shipper\"><span translate=\"CONTRACT_SCHEDULE_REPORT.WEEK_ENDING_TOTALS\"></span></td><td class=\"season\"></td><td \nclass=\"wet-date\" ng-if=\"vm.byWetDate\">{{contractSchedulesOfWeek.week_ending | date:\'EEE, MMM d\'}}</td><td \nclass=\"wet-date\" ng-if=\"!vm.byWetDate\"></td><td class=\"location\"></td><td class=\"acres\">\n{{contractSchedulesOfWeek.total_acres}}</td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\">\n</td><td class=\"harvest-date w-100\" ng-if=\"!vm.byWetDate\">{{contractSchedulesOfWeek.week_ending | date:\'EEE, MMM d\'}}\n</td><td class=\"harvest-date w-100\" ng-if=\"vm.byWetDate\"></td></tr></tbody><tfoot \nng-if=\"!loadingData && vm.filterIds.length>0\"><tr class=\"text-bold border-foot height-5 padding-top-15\" \nng-if=\"vm.seasonsTotals.length\"><td class=\"shipper custom-padding\"><span \ntranslate=\"CONTRACT_SCHEDULE_REPORT.SEASON_TOTALS\"></span></td><td class=\"season\"></td><td class=\"wet-date\"></td><td \nclass=\"location\"></td><td class=\"acres\"></td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\">\n</td><td class=\"harvest-date w-100\"></td></tr><tr ng-if=\"vm.seasonsTotals.length\" \nng-repeat=\"seasonTotal in vm.seasonsTotals\" class=\"text-bold border-foot\"><td class=\"shipper\"></td><td class=\"season\">\n{{seasonTotal.name}}</td><td class=\"wet-date\"></td><td class=\"location\"></td><td class=\"acres\">{{seasonTotal.total}}\n</td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\"></td><td class=\"harvest-date w-100\"></td>\n</tr><tr ng-if=\"vm.seasonsTotals.length\" class=\"text-bold border-foot\"><td class=\"shipper\"></td><td class=\"season\">\n<span translate=\"CONTRACT_SCHEDULE_REPORT.ALL_SEASONS\"></span></td><td class=\"wet-date\"></td><td class=\"location\"></td>\n<td class=\"acres\">{{vm.annualTotal}}</td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\"></td>\n<td class=\"harvest-date w-100\"></td></tr></tfoot></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" \nlayout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && vm.filterIds.length === 0\"><p class=\"padding-left-8\" \ntranslate=\"CONTRACT_SCHEDULE_REPORT.NO_RESULTS\">No results..</p></md-list-item></div></md-list></div></div></div>");
$templateCache.put("app/main/pages/reports/grower-schedule-report/grower-schedule-report.html","<div id=\"grower-schedule-report\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" \nlayout-align=\"start center\"><md-button id=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"BLOCKS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-chart-areaspline\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"GROWER_SCHEDULE_REPORT.GROWER_SCHEDULE_REPORT\">Grower Schedule Report</span><div><md-switch class=\"switch\" \nng-click=\"vm.toggleWeekEndingTotals()\" aria-label=\"Disabled\"></md-switch><md-tooltip><div class=\"name\">\n{{vm.byWetDate ? \"Calculate Week Ending by Wet Date\" : \"Calculate Week Ending by Harvest Date\"}}</div></md-tooltip>\n</div></div></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/pages/reports/grower-schedule-report/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"main\" ms-scroll><md-list class=\"grower-schedule-report-list\"><div class=\"content white-bg md-whiteframe-4dp\">\n<table class=\"dataTable row-border hover h-100-p\"><thead><tr class=\"section-titles md-accent-bg padding-bottom-0\"><div>\n<th class=\"filter-shipper\"><span ng-if=\"vm.shipper_name === \'\'\" translate=\"CONTRACT_SCHEDULE_REPORT.ALL_SHIPPERS\">\n</span> <span ng-if=\"vm.shipper_name !== \'\'\">{{vm.shipper_name }}</span></th></div></tr><tr \nclass=\"section-titles md-accent-bg padding-bottom-0\" ng-if=\"vm.startYear && vm.endYear\"><div><th class=\"year-range\">\n<span>{{vm.startYear }} - {{vm.endYear}}</span></th></div></tr><tr class=\"section-titles md-accent-bg\"><th><div><th \nclass=\"first-filter\"><span ng-if=\"vm.season_name === \'\'\" translate=\"GROWER_SCHEDULE_REPORT.ALL_SEASONS\"></span> <span \nng-if=\"vm.season_name !== \'\'\">{{vm.season_name }}</span></th><th class=\"filters-padding\"><span \nng-if=\"vm.week_ending_name === \'\'\" translate=\"GROWER_SCHEDULE_REPORT.ALL_WEEKS\"></span> <span \nng-if=\"vm.week_ending_name !== \'\'\">{{vm.week_ending_name }}</span></th><th class=\"filters-padding\"><span \nng-if=\"vm.location_name === \'\'\" translate=\"GROWER_SCHEDULE_REPORT.ALL_LOCATIONS\"></span> <span \nng-if=\"vm.location_name !== \'\'\">{{vm.location_name }}</span></th><th class=\"filters-padding\"><span \nng-if=\"vm.ranch_name === \'\'\" translate=\"GROWER_SCHEDULE_REPORT.ALL_RANCHES\"></span> <span ng-if=\"vm.ranch_name !== \'\'\">\n{{vm.ranch_name }}</span></th><th class=\"filters-padding\"><span ng-if=\"vm.block_name === \'\'\" \ntranslate=\"GROWER_SCHEDULE_REPORT.ALL_BLOCKS\"></span> <span ng-if=\"vm.block_name !== \'\'\">{{vm.block_name }}</span></th>\n<th class=\"filter-pca\"><span ng-if=\"vm.pca_name === \'\'\" translate=\"GROWER_SCHEDULE_REPORT.ALL_PCA\"></span> <span \nng-if=\"vm.pca_name !== \'\'\">{{vm.pca_name }}</span></th></div></th></tr><tr class=\"align-center\"><th \nclass=\"secondary-text shipper\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE_REPORT.SHIPPER\"></span></div></th><th class=\"secondary-text pca\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"GROWER_SCHEDULE_REPORT.PCA\"></span></div></th><th class=\"secondary-text season\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE_REPORT.SEASON\"></span></div></th><th \nclass=\"secondary-text wet-date\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE_REPORT.WET_DATE\"></span></div></th><th class=\"secondary-text location\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE_REPORT.LOCATION\"></span></div></th><th \nclass=\"secondary-text ranch\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE_REPORT.RANCH\"></span></div></th><th class=\"secondary-text block\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"GROWER_SCHEDULE_REPORT.BLOCK\"></span></div></th><th class=\"secondary-text acres\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"GROWER_SCHEDULE_REPORT.ACRES\"></span></div></th><th \nclass=\"secondary-text seed\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE_REPORT.SEED\"></span></div></th><th class=\"secondary-text variety\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"GROWER_SCHEDULE_REPORT.VARIETY\"></span></div></th><th \nclass=\"secondary-text growing-days\"><div class=\"table-header\"><span class=\"column-title\">Est. Growing<br>Days</span>\n</div></th><th class=\"secondary-text harvest-date w-90\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"GROWER_SCHEDULE_REPORT.HARVEST_DATE\"></span></div></th></tr></thead><tbody \nng-if=\"!loadingData && vm.filterIds.length>0\" class=\"scrollable constrained\" ng-style=\"setSize(318)\" resize ms-scroll \nms-infinite-scroll=\"\" ms-infinite-scroll-container=\'\".constrained\"\' \nng-repeat=\"growerSchedulesOfWeek in vm.growerSchedules\"><tr class=\"grower-report-item\" \nng-if=\"growerSchedulesOfWeek.grower_schedules.length\" \nng-repeat=\"growerSchedule in growerSchedulesOfWeek.grower_schedules  | filter: vm.search | filter: global.search | filterByIds:vm.filterIds | orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredGrowers track by growerSchedule.id | limitTo:vm.limit\">\n<td class=\"shipper\">{{growerSchedule.shipper_company.name}}</td><td class=\"pca\">{{growerSchedule.pca_user.name}}</td>\n<td class=\"season\">{{growerSchedule.season.name}}</td><td class=\"wet-date\">\n{{growerSchedule.scheduled_wet_date | date:\'EEE, MMM d\'}}</td><td class=\"location\">\n{{growerSchedule.grower_block.block.ranch.ranch_location.name}}</td><td class=\"ranch\">\n{{growerSchedule.grower_block.block.ranch.name}}</td><td class=\"block\">{{growerSchedule.grower_block.block.name}}</td>\n<td class=\"acres\">{{growerSchedule.scheduled_acres | number:0}}</td><td class=\"seed\">{{growerSchedule.seed.name}}</td>\n<td class=\"variety\">{{growerSchedule.variety.name}}</td><td class=\"growing-days\">\n{{growerSchedule.original_growing_days}}</td><td class=\"harvest-date w-90\">\n{{growerSchedule.scheduled_harvest_date | date:\'EEE, MMM d\'}}</td></tr><tr \nng-if=\"growerSchedulesOfWeek.grower_schedules.length\" class=\"text-bold border-top margin-bottom-10\"><td \nclass=\"shipper\"><span translate=\"GROWER_SCHEDULE_REPORT.WEEK_ENDING_TOTALS\"></span></td><td class=\"pca\"></td><td \nclass=\"season\"></td><td class=\"wet-date\" ng-if=\"vm.byWetDate\">\n{{growerSchedulesOfWeek.week_ending | date: \'mediumDate\'}}</td><td class=\"wet-date\" ng-if=\"!vm.byWetDate\"></td><td \nclass=\"location\"></td><td class=\"ranch\"></td><td class=\"block\"></td><td class=\"acres\">\n{{growerSchedulesOfWeek.total_acres}}</td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\"></td>\n<td class=\"harvest-date w-90\" ng-if=\"vm.byWetDate\"></td><td class=\"harvest-date w-90\" ng-if=\"!vm.byWetDate\">\n{{growerSchedulesOfWeek.week_ending | date: \'mediumDate\'}}</td></tr></tbody><tfoot \nng-if=\"!loadingData && vm.filterIds.length>0\"><tr class=\"text-bold border-foot height-5 padding-top-15\" \nng-if=\"vm.seasonsTotals.length\"><td class=\"shipper custom-padding\"><span \ntranslate=\"GROWER_SCHEDULE_REPORT.SEASON_TOTALS\"></span></td><td class=\"pca\"></td><td class=\"season\"></td><td \nclass=\"wet-date\"></td><td class=\"location\"></td><td class=\"ranch\"></td><td class=\"block\"></td><td class=\"acres\"></td>\n<td class=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\"></td><td class=\"harvest-date w-90\"></td></tr>\n<tr ng-if=\"vm.seasonsTotals.length\" ng-repeat=\"seasonTotal in vm.seasonsTotals\" class=\"text-bold border-foot\"><td \nclass=\"shipper\"></td><td class=\"pca\"></td><td class=\"season\">{{seasonTotal.name}}</td><td class=\"wet-date\"></td><td \nclass=\"location\"></td><td class=\"ranch\"></td><td class=\"block\"></td><td class=\"acres\">{{seasonTotal.total}}</td><td \nclass=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\"></td><td class=\"harvest-date w-90\"></td></tr><tr \nng-if=\"vm.seasonsTotals.length\" class=\"text-bold border-foot\"><td class=\"shipper\"></td><td class=\"pca\"></td><td \nclass=\"season\"><span translate=\"GROWER_SCHEDULE_REPORT.ALL_SEASONS\"></span></td><td class=\"wet-date\"></td><td \nclass=\"location\"></td><td class=\"ranch\"></td><td class=\"block\"></td><td class=\"acres\">{{vm.annualTotal}}</td><td \nclass=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\"></td><td class=\"harvest-date w-90\"></td></tr>\n</tfoot></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader>\n</ms-loader></md-list-item><md-list-item class=\"md-white-bg\" ng-show=\"!loadingData && vm.filterIds.length === 0\"><p \nclass=\"padding-left-8\" translate=\"GROWER_SCHEDULE_REPORT.NO_RESULTS\">No results..</p></md-list-item></div></md-list>\n</div></div></div>");
$templateCache.put("app/main/pages/reports/planting-schedule-report/planting-schedule-report.html","<div id=\"planting-schedule-report\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" \nlayout-align=\"start center\"><md-button id=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"BLOCKS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-chart-areaspline\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"PLANTING_SCHEDULE_REPORT.PLANTING_SCHEDULE_REPORT\">Planting Schedule Report</span><div><md-switch \nclass=\"switch\" ng-click=\"vm.toggleWeekEndingTotals()\" aria-label=\"Disabled\"></md-switch><md-tooltip><div class=\"name\">\n{{vm.byWetDate ? \"Calculate Week Ending by Wet Date\" : \"Calculate Week Ending by Harvest Date\"}}</div></md-tooltip>\n</div></div></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/pages/reports/planting-schedule-report/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"main\" ms-scroll><md-list class=\"planting-schedule-report-list\"><div class=\"content white-bg md-whiteframe-4dp\">\n<table class=\"dataTable row-border hover h-100-p\"><thead><tr class=\"section-titles md-accent-bg padding-bottom-0\"><div>\n<th class=\"filter-shipper\"><span ng-if=\"vm.shipper_name === \'\'\" translate=\"CONTRACT_SCHEDULE_REPORT.ALL_SHIPPERS\">\n</span> <span ng-if=\"vm.shipper_name !== \'\'\">{{vm.shipper_name }}</span></th></div></tr><tr \nclass=\"section-titles md-accent-bg padding-bottom-0\" ng-if=\"vm.startYear && vm.endYear\"><div><th class=\"year-range\">\n<span>{{vm.startYear }} - {{vm.endYear}}</span></th></div></tr><tr class=\"section-titles md-accent-bg\"><div><th \nclass=\"first-filter\"><span ng-if=\"vm.season_name === \'\'\" translate=\"GROWER_SCHEDULE_REPORT.ALL_SEASONS\"></span> <span \nng-if=\"vm.season_name !== \'\'\">{{vm.season_name }}</span></th><th class=\"filters-padding\"><span \nng-if=\"vm.week_ending_name === \'\'\" translate=\"GROWER_SCHEDULE_REPORT.ALL_WEEKS\"></span> <span \nng-if=\"vm.week_ending_name !== \'\'\">{{vm.week_ending_name }}</span></th><th class=\"filters-padding\"><span \nng-if=\"vm.location_name === \'\'\" translate=\"GROWER_SCHEDULE_REPORT.ALL_LOCATIONS\"></span> <span \nng-if=\"vm.location_name !== \'\'\">{{vm.location_name }}</span></th><th class=\"filters-padding\"><span \nng-if=\"vm.ranch_name === \'\'\" translate=\"GROWER_SCHEDULE_REPORT.ALL_RANCHES\"></span> <span ng-if=\"vm.ranch_name !== \'\'\">\n{{vm.ranch_name }}</span></th><th class=\"filters-padding w-90\"><span ng-if=\"vm.block_name === \'\'\" \ntranslate=\"GROWER_SCHEDULE_REPORT.ALL_BLOCKS\"></span> <span ng-if=\"vm.block_name !== \'\'\">{{vm.block_name }}</span></th>\n</div></tr><tr class=\"align-center\"><th class=\"secondary-text owner\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"PLANTING_SCHEDULE_REPORT.OWNER\"></span></div></th><th class=\"secondary-text foreman\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE_REPORT.FOREMAN\"></span></div></th><th\n class=\"secondary-text wet-date\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE_REPORT.WET_DATE\"></span></div></th><th class=\"secondary-text day\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE_REPORT.DAY\"></span></div></th><th \nclass=\"secondary-text ranch\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE_REPORT.RANCH\"></span></div></th><th class=\"secondary-text block\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE_REPORT.BLOCK\"></span></div></th><th \nclass=\"secondary-text block-location\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE_REPORT.BLOCK_LOCATION\"></span></div></th><th class=\"secondary-text beds-number\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE_REPORT.BEDS_NUMBER\"></span></div></th><th \nclass=\"secondary-text acres\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE_REPORT.ACRES\"></span></div></th><th class=\"secondary-text seed\"><div class=\"table-header\">\n<span class=\"column-title\" translate=\"PLANTING_SCHEDULE_REPORT.SEED\"></span></div></th><th \nclass=\"secondary-text variety\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE_REPORT.VARIETY\"></span></div></th><th class=\"secondary-text bed-direction\"><div \nclass=\"table-header\"><span class=\"column-title\">Bed<br>Direction</span></div></th><th class=\"secondary-text lines-bed\">\n<div class=\"table-header\"><span class=\"column-title\">Lines<br>per Bed</span></div></th><th \nclass=\"secondary-text seed-spacing w-90\"><div class=\"table-header\"><span class=\"column-title\">Seed spacing<br>(inch)\n</span></div></th></tr></thead><tbody ng-if=\"!loadingData && vm.filterIds.length>0\" class=\"scrollable constrained\" \nng-style=\"setSize(318)\" resize ms-scroll ms-infinite-scroll=\"\" ms-infinite-scroll-container=\'\".constrained\"\' \nng-repeat=\"plantingSchedulesOfWeek in vm.orderedPlantingSchedules\"><tr class=\"planting-report-item\" \nng-if=\"plantingSchedulesOfWeek.planting_schedules.length\" \nng-repeat=\"plantingSchedule in plantingSchedulesOfWeek.planting_schedules  | filter: vm.search | filter: global.search | filterByIds:vm.filterIds | orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredPlantings track by plantingSchedule.id | limitTo:vm.limit\">\n<td class=\"owner\">{{plantingSchedule.owner.name}}</td><td class=\"foreman\">{{plantingSchedule.foreman.name}}</td><td \nclass=\"wet-date\">{{plantingSchedule.actual_wet_date | date: \'mediumDate\'}}</td><td class=\"day\">\n{{plantingSchedule.actual_wet_date | date: \'EEEE\'}}</td><td class=\"ranch\">\n{{plantingSchedule.planting_block.block.ranch_name}}</td><td class=\"block\">\n{{plantingSchedule.planting_block.block.name}}</td><td class=\"block-location\">\n{{plantingSchedule.planting_block.block.location_name}}</td><td class=\"beds-number\">\n{{plantingSchedule.planting_block.block.beds_number}}</td><td class=\"acres\">{{plantingSchedule.acres | number:0}}</td>\n<td class=\"seed\">{{plantingSchedule.seed.name}}</td><td class=\"variety\">{{plantingSchedule.variety.name}}</td><td \nclass=\"bed-direction\">{{plantingSchedule.planting_block.block.bed_direction}}</td><td class=\"lines-bed\">\n{{plantingSchedule.planting_block.block.lines_per_bed}}</td><td class=\"seed-spacing w-90\">\n{{plantingSchedule.seed_spacing}}</td></tr><tr ng-if=\"plantingSchedulesOfWeek.planting_schedules.length\" \nclass=\"text-bold border-top margin-bottom-10\"><td class=\"owner\"><span \ntranslate=\"PLANTING_SCHEDULE_REPORT.WEEK_ENDING_TOTALS\"></span></td><td class=\"foreman\"></td><td class=\"wet-date\">\n{{plantingSchedulesOfWeek.week_ending | date: \'mediumDate\'}}</td><td class=\"day\">\n{{plantingSchedulesOfWeek.week_ending | date: \'EEEE\'}}</td><td class=\"ranch\"></td><td class=\"block\"></td><td \nclass=\"block-location\"></td><td class=\"beds-number\"></td><td class=\"acres\">{{plantingSchedulesOfWeek.total_acres}}</td>\n<td class=\"seed\"></td><td class=\"variety\"></td><td class=\"bed-direction\"></td><td class=\"lines-bed\"></td><td \nclass=\"seed-spacing w-90\"></td></tr></tbody><tfoot ng-if=\"!loadingData && vm.filterIds.length>0\"><tr \nclass=\"text-bold border-foot height-5 padding-top-15\" ng-if=\"vm.seasonsTotals.length\"><td class=\"owner custom-padding\">\n<span translate=\"PLANTING_SCHEDULE_REPORT.SEASON_TOTALS\"></span></td><td class=\"foreman\"></td><td class=\"wet-date\">\n</td><td class=\"day\"></td><td class=\"ranch\"></td><td class=\"block\"></td><td class=\"block-location\"></td><td \nclass=\"beds-number\"></td><td class=\"acres\"></td><td class=\"seed\"></td><td class=\"variety\"></td><td \nclass=\"bed-direction\"></td><td class=\"lines-bed\"></td><td class=\"seed-spacing w-90\"></td></tr><tr \nng-if=\"vm.seasonsTotals.length\" ng-repeat=\"seasonTotal in vm.seasonsTotals\" class=\"text-bold border-foot\"><td \nclass=\"owner\"></td><td class=\"foreman\"></td><td class=\"wet-date\"></td><td class=\"day\">{{seasonTotal.name}}</td><td \nclass=\"ranch\"></td><td class=\"block\"></td><td class=\"block-location\"></td><td class=\"beds-number\"></td><td \nclass=\"acres\">{{seasonTotal.total}}</td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"bed-direction\"></td>\n<td class=\"lines-bed\"></td><td class=\"seed-spacing w-90\"></td></tr><tr ng-if=\"vm.seasonsTotals.length\" \nclass=\"text-bold border-foot\"><td class=\"owner\"></td><td class=\"foreman\"></td><td class=\"wet-date\"></td><td \nclass=\"day\"><span translate=\"PLANTING_SCHEDULE_REPORT.ALL_SEASONS\"></span></td><td class=\"ranch\"></td><td \nclass=\"block\"></td><td class=\"block-location\"></td><td class=\"beds-number\"></td><td class=\"acres\">{{vm.annualTotal}}\n</td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"bed-direction\"></td><td class=\"lines-bed\"></td><td \nclass=\"seed-spacing w-90\"></td></tr></tfoot></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" \nlayout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && vm.filterIds.length === 0\"><p class=\"padding-left-8\" \ntranslate=\"PLANTING_SCHEDULE_REPORT.NO_RESULTS\">No results..</p></md-list-item></div></md-list></div></div></div>");
$templateCache.put("app/main/pages/reports/resource-requirements-report/resource-requirements-report.html","<div id=\"resource-requirements-report\" class=\"page-layout simple left-sidenav inner-sidenav\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"55\" layout=\"row\" \nlayout-align=\"start center\"><md-button id=\"navigation-sidenav\" class=\"md-icon-button sidenav-toggle\" hide-gt-md \nng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"BLOCKS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-chart-areaspline\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"RESOURCE_REQUIREMENTS_REPORT.RESOURCE_REQUIREMENTS_REPORT\">Contract Schedule Report</span><div><md-switch \nclass=\"switch\" ng-click=\"vm.toggleWeekEndingTotals()\" aria-label=\"Disabled\"></md-switch><md-tooltip><div class=\"name\">\n{{vm.byWetDate ? \"Calculate Week Ending by Wet Date\" : \"Calculate Week Ending by Harvest Date\"}}</div></md-tooltip>\n</div></div></div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><md-sidenav \nclass=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/pages/reports/resource-requirements-report/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div \nclass=\"main\" ms-scroll><md-list class=\"resource-requirements-report-list\"><div \nclass=\"content white-bg md-whiteframe-4dp\"><table class=\"dataTable row-border hover h-100-p\"><thead><tr \nclass=\"section-titles md-accent-bg padding-bottom-0\"><div><th class=\"filter-shipper\"><span \nng-if=\"vm.shipper_name === \'\'\" translate=\"RESOURCE_REQUIREMENTS_REPORT.ALL_SHIPPERS\"></span> <span \nng-if=\"vm.shipper_name !== \'\'\">{{vm.shipper_name }}</span></th></div></tr><tr \nclass=\"section-titles md-accent-bg padding-bottom-0\" ng-if=\"vm.startYear && vm.endYear\"><div><th class=\"year-range\">\n<span>{{vm.startYear }} - {{vm.endYear}}</span></th></div></tr><tr class=\"section-titles md-accent-bg\"><div><th \nclass=\"filter-season\"><span ng-if=\"vm.season_name === \'\'\" translate=\"RESOURCE_REQUIREMENTS_REPORT.ALL_SEASONS\"></span> \n<span ng-if=\"vm.season_name !== \'\'\" class=\"font-weight-300\">{{vm.season_name }}</span></th><th class=\"filter-week\">\n<span ng-if=\"vm.week_ending_name === \'\'\" translate=\"RESOURCE_REQUIREMENTS_REPORT.ALL_WEEKS\"></span> <span \nng-if=\"vm.week_ending_name !== \'\'\">{{vm.week_ending_name }}</span></th><th class=\"filter-location\"><span \nng-if=\"vm.location_name === \'\'\" translate=\"RESOURCE_REQUIREMENTS_REPORT.ALL_LOCATIONS\"></span> <span \nng-if=\"vm.location_name !== \'\'\">{{vm.location_name }}</span></th></div></tr><tr class=\"align-center\"><th \nclass=\"secondary-text shipper\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"RESOURCE_REQUIREMENTS_REPORT.SHIPPER\"></span></div></th><th class=\"secondary-text season\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"RESOURCE_REQUIREMENTS_REPORT.SEASON\"></span></div></th><th \nclass=\"secondary-text wet-date\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"RESOURCE_REQUIREMENTS_REPORT.WET_DATE\"></span></div></th><th class=\"secondary-text location\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"RESOURCE_REQUIREMENTS_REPORT.LOCATION\"></span></div></th><th\n class=\"secondary-text acres\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"RESOURCE_REQUIREMENTS_REPORT.ACRES\"></span></div></th><th class=\"secondary-text seed\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"RESOURCE_REQUIREMENTS_REPORT.SEED\"></span></div></th><th \nclass=\"secondary-text variety\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"RESOURCE_REQUIREMENTS_REPORT.VARIETY\"></span></div></th><th class=\"secondary-text growing-days\"><div \nclass=\"table-header\"><span class=\"column-title\">Est. Growing<br>Days</span></div></th><th \nclass=\"secondary-text harvest-date w-100\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"RESOURCE_REQUIREMENTS_REPORT.HARVEST_DATE\"></span></div></th></tr></thead><tbody \nng-if=\"!loadingData && vm.filterIds.length>0\" class=\"scrollable constrained\" ng-style=\"setSize(318)\" resize ms-scroll \nms-infinite-scroll=\"\" ms-infinite-scroll-container=\'\".constrained\"\' \nng-repeat=\"contractSchedulesOfWeek in vm.contractSchedules track by $index\"><tr class=\"contract-report-item\" \nng-if=\"contractSchedulesOfWeek.contract_schedules.length\" \nng-repeat=\"contractSchedule in contractSchedulesOfWeek.contract_schedules | filter: vm.search | filter: global.search | filterByIds:vm.filterIds | orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContracts track by contractSchedule.id | limitTo:vm.limit\">\n<td class=\"shipper\">{{contractSchedule.contract_schedule.contract.company.name}}</td><td class=\"season\">\n{{contractSchedule.season.name}}</td><td class=\"wet-date\">{{contractSchedule.original_wet_date | date:\'EEE, MMM d\'}}\n</td><td class=\"location\">{{contractSchedule.contract_schedule.location.name}}</td><td class=\"acres\">\n{{contractSchedule.acres | number:0}}</td><td class=\"seed\">{{contractSchedule.contract_schedule.seed.name}}</td><td \nclass=\"variety\">{{contractSchedule.variety.name}}</td><td class=\"growing-days\">\n{{contractSchedule.original_growing_days}}</td><td class=\"harvest-date w-100\">\n{{contractSchedule.original_harvest_date | date:\'EEE, MMM d\'}}</td></tr><tr \nng-if=\"contractSchedulesOfWeek.contract_schedules.length\" class=\"text-bold border-top margin-bottom-10\"><td \nclass=\"shipper\"><span translate=\"RESOURCE_REQUIREMENTS_REPORT.WEEK_ENDING_TOTALS\"></span></td><td class=\"season\"></td>\n<td class=\"wet-date\" ng-if=\"vm.byWetDate\">{{contractSchedulesOfWeek.week_ending | date:\'EEE, MMM d\'}}</td><td \nclass=\"wet-date\" ng-if=\"!vm.byWetDate\"></td><td class=\"location\"></td><td class=\"acres\">\n{{contractSchedulesOfWeek.total_acres}}</td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\">\n</td><td class=\"harvest-date w-100\" ng-if=\"!vm.byWetDate\">{{contractSchedulesOfWeek.week_ending | date:\'EEE, MMM d\'}}\n</td><td class=\"harvest-date w-100\" ng-if=\"vm.byWetDate\"></td></tr></tbody><tfoot \nng-if=\"!loadingData && vm.filterIds.length>0\"><tr class=\"text-bold border-foot height-5 padding-top-15\" \nng-if=\"vm.seasonsTotals.length\"><td class=\"shipper custom-padding\"><span \ntranslate=\"RESOURCE_REQUIREMENTS_REPORT.SEASON_TOTALS\"></span></td><td class=\"season\"></td><td class=\"wet-date\"></td>\n<td class=\"location\"></td><td class=\"acres\"></td><td class=\"seed\"></td><td class=\"variety\"></td><td \nclass=\"growing-days\"></td><td class=\"harvest-date w-100\"></td></tr><tr ng-if=\"vm.seasonsTotals.length\" \nng-repeat=\"seasonTotal in vm.seasonsTotals\" class=\"text-bold border-foot\"><td class=\"shipper\"></td><td class=\"season\">\n{{seasonTotal.name}}</td><td class=\"wet-date\"></td><td class=\"location\"></td><td class=\"acres\">{{seasonTotal.total}}\n</td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\"></td><td class=\"harvest-date w-100\"></td>\n</tr><tr ng-if=\"vm.seasonsTotals.length\" class=\"text-bold border-foot\"><td class=\"shipper\"></td><td class=\"season\">\n<span translate=\"RESOURCE_REQUIREMENTS_REPORT.ALL_SEASONS\"></span></td><td class=\"wet-date\"></td><td class=\"location\">\n</td><td class=\"acres\">{{vm.annualTotal}}</td><td class=\"seed\"></td><td class=\"variety\"></td><td class=\"growing-days\">\n</td><td class=\"harvest-date w-100\"></td></tr></tfoot></table><md-list-item ng-if=\"loadingData\" class=\"loader\" \nlayout=\"row\" layout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && vm.filterIds.length === 0\"><p class=\"padding-left-8\" \ntranslate=\"RESOURCE_REQUIREMENTS_REPORT.NO_RESULTS\">No results..</p></md-list-item></div></md-list></div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/admin/cronjobs/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluars.png\"> <span class=\"font-weight-500 font-size-14\">\n{{ vm.cronjob.name }}Cronjob Filter</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\">\n<md-list><md-list-item aria-label=\"filters\" ng-click=\"vm.filterChange(\'all\')\" \nng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CRONJOBS.ALL_CRONJOBS\"></p></md-list-item></md-list></div>");
$templateCache.put("app/main/admin/modules/dialogs/card/card-dialog.html","<md-dialog class=\"card-dialog\" aria-permission=\"Card Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-menu md-offset=\"0 48\" class=\"labels\">\n<md-button aria-label=\"outline\" class=\"md-icon-button\" aria-permission=\"Permission\" translate \ntranslate-attr-aria-permission=\"SB.PERMISSION\" ng-click=\"vm.permissionTabIndex = 0; $mdMenu.open($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-label-outline\"></md-icon></md-button><md-menu-content class=\"labels-menu-content\" \nwidth=\"4\" ms-scroll><md-tabs md-selected=\"vm.permissionTabIndex\" md-dynamic-height><md-tab><md-tab-body><md-menu-item>\n<md-input-container class=\"no-errors-spacer\" md-no-float><input placeholder=\"Search permissions...\" type=\"text\" \nng-model=\"vm.permissionSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"SB.SEARCH_PERMISSIONS\">\n</md-input-container></md-menu-item><md-menu-item class=\"label\" \nng-repeat=\"permission in vm.permissions | filter: vm.filterPermission\"><md-button class=\"label-toggle-button\" \nmd-prevent-menu-close ng-class=\"\'md-\'+permission.color+\'-bg\'\" \nng-click=\"vm.toggleInArray(permission.id, vm.board.cards[vm.card.id].idPermissions)\" \naria-permission=\"Toggle Permission\" translate translate-attr-aria-permission=\"SB.TOGGLE_PERMISSION\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{permission.name}}</span> <i \nng-if=\"vm.exists(permission.id, vm.card.idPermissions)\" class=\"icon-check s16\"></i></div></md-button><md-button \naria-label=\"edit button\" class=\"md-icon-button permission-edit-button\" md-prevent-menu-close \nng-click=\"vm.editPermissionId = permission.id; vm.permissionTabIndex = 2\" aria-permission=\"Edit Permission\" translate \ntranslate-attr-aria-permission=\"SB.EDIT_PERMISSION\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button aria-label=\"new permission\" \nclass=\"add-permission-button\" md-prevent-menu-close ng-click=\"vm.permissionTabIndex = 1\"><md-icon \nmd-font-icon=\"icon-plus-circle-outline\"></md-icon><span translate=\"SB.ADD_NEW_PERMISSION\">Add new permission</span>\n</md-button></md-menu-item></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"add-permission-tab-content\"><div \nclass=\"header\" layout=\"row\" layout-align=\"space-between center\"><md-button aria-label=\"back\" class=\"md-icon-button\" \nmd-prevent-menu-close ng-click=\"vm.permissionTabIndex = 0\" aria-permission=\"Back\" translate \ntranslate-attr-aria-permission=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex \ntranslate=\"SB.CREATE_PERMISSION\">Create Permission</span></div><div class=\"content\" layout=\"column\" \nlayout-align=\"start stretch\"><form ng-submit=\"vm.addNewPermission(); vm.permissionTabIndex = 0\" layout=\"column\">\n<md-input-container class=\"no-errors-spacer\" md-no-float><input placeholder=\"Permission Name\" type=\"text\" \nng-model=\"vm.newPermissionName\" translate translate-attr-placeholder=\"SB.PERMISSION_NAME\"></md-input-container><div \nclass=\"label-color-picker\" layout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newPermissionColor\" ng-value=\"palette\" \naria-permission=\"{{palette}}\"> <i class=\"icon-check s18\" ng-if=\"vm.newPermissionColor === palette\"></i></label></div>\n<md-button type=\"submit\" md-prevent-menu-close class=\"create-button md-accent md-raised\" aria-permission=\"Create\" \ntranslate translate-attr-aria-permission=\"SB.CREATE\"><span translate=\"SB.CREATE\">Create</span></md-button></form></div>\n</div></md-tab-body></md-tab><md-tab><md-tab-body><div class=\"edit-permission-tab-content\"><div class=\"header\" \nlayout=\"row\" layout-align=\"space-between center\"><md-button aria-label=\"close\" class=\"md-icon-button\" \nmd-prevent-menu-close ng-click=\"vm.permissionTabIndex = 0\" aria-permission=\"back\" translate \ntranslate-attr-aria-permission=\"SB.BACK\"><i class=\"icon-arrow-left s20\"></i></md-button><span flex \ntranslate=\"SB.EDIT_PERMISSION\">Edit Permission</span></div><div class=\"content\" layout=\"column\" \nlayout-align=\"start stretch\"><md-input-container class=\"no-errors-spacer\" md-no-float><input \nplaceholder=\"Permission Name\" type=\"text\" ng-model=\"vm.board.permissions.getById(vm.editPermissionId).name\" translate \ntranslate-attr-placeholder=\"SB.PERMISSION_NAME\"></md-input-container><div class=\"label-color-picker\" layout=\"row\" \nlayout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" \nng-model=\"vm.board.permissions.getById(vm.editPermissionId).color\" ng-value=\"palette\" aria-permission=\"{{palette}}\"> <i\n ng-if=\"vm.board.permissions.getById(vm.editPermissionId).color === palette\" class=\"icon-check s18\"></i></label></div>\n<div layout=\"row\" layout-align=\"end center\" flex><md-button aria-label=\"remove\" class=\"remove-button md-icon-button\" \ntype=\"submit\" md-prevent-menu-close ng-click=\"vm.removePermission(); vm.permissionTabIndex=0\" aria-permission=\"remove\" \ntranslate translate-attr-aria-permission=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div>\n</div></div></md-tab-body></md-tab></md-tabs></md-menu-content></md-menu><md-menu md-offset=\"0 48\" class=\"roles\">\n<md-button class=\"md-icon-button\" aria-permission=\"Roles\" ng-click=\"$mdMenu.open($event)\"><md-icon md-menu-origin \nmd-font-icon=\"icon-account-multiple\"></md-icon></md-button><md-menu-content class=\"roles-menu-content\" width=\"4\" \nms-scroll><md-menu-item><md-input-container class=\"no-errors-spacer\" md-no-float><input placeholder=\"Search roles...\" \nautocomplete=\"off\" type=\"text\" ng-model=\"vm.roleSearchText\" translate translate-attr-placeholder=\"SB.SEARCH_ROLES\">\n</md-input-container></md-menu-item><md-menu-item class=\"role\" ng-repeat=\"role in vm.roles  | filter: vm.filterRole\">\n<md-button ng-click=\"vm.toggleInArray(role.id, vm.board.cards[vm.card.id].idRoles)\" md-prevent-menu-close \naria-permission=\"toggle role\" translate translate-attr-aria-permission=\"SB.TOGGLE_ROLE\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><div layout=\"row\" layout-align=\"start center\"><img alt=\"{{ role.name }}\" \nng-src=\"/assets/images/material-letter-icons/png/{{role.name.toUpperCase().charAt(0)}}.png\" class=\"avatar\"><p \nclass=\"role-name\">{{ role.name }}</p></div><i class=\"icon-check s16\" ng-if=\"vm.exists(role.id, vm.card.idRoles)\"></i>\n</div></md-button></md-menu-item></md-menu-content></md-menu><span flex></span><md-button type=\"md-icon-button\" \nclass=\"md-raised md-accent\" aria-label=\"SAVE\" ng-click=\"vm.savePageSettings();\" translate \ntranslate-attr-aria-label=\"SB.ADD\"><span translate=\"SB.SAVE\">SAVE</span></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-permission=\"Close Dialog\" translate translate-attr-aria-permission=\"SB.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nlayout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" layout-align=\"start stretch\" flex><div \nclass=\"card-breadcrumb\" layout=\"row\" layout-align=\"start center\"><span>{{vm.board.name}}</span> <i \nclass=\"icon-menu-right\"></i> <span>{{vm.getCardList().name}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon ng-if=\"vm.card.subscribed\" class=\"card-subscribe s18\" md-font-icon=\"icon-eye\"></md-icon><div \nclass=\"card-name\"><span>{{vm.card.name | capitalize}}</span></div></div></div></div><div class=\"documents-on-page\">\n<md-checkbox ng-model=\"vm.card.documents_on_page\" ng-change=\"vm.updateCard()\" aria-label=\"documents on page\" \naria-permission=\"documents on page\"><label translate=\"SB.DOCUMENTS_ON_PAGE\"></label></md-checkbox></div><div \nclass=\"sections\"><div class=\"s1\"></div><div class=\"page-section\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-chart-pie s18\"></i> <span class=\"section-title\" \ntranslate=\"SB.SECTION_TITLE\"></span></div><md-select ng-model=\"vm.card.section\" placeholder=\"Select a section\" \nng-change=\"vm.updateCard()\" ng-selected=\"vm.getSelectedIndex(vm.card.section)\"><md-option ng-value=\"section\" \nng-repeat=\"section in vm.sections\">{{ section | capitalize }}</md-option></md-select></div><div \nng-if=\"vm.board.cards[vm.card.id].idPermissions[0] || vm.board.cards[vm.card.id].idRoles[0]\" class=\"section\" \nlayout=\"row\"><div ng-if=\"vm.board.cards[vm.card.id].idPermissions[0]\" flex class=\"labels\"><div class=\"section-header\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-label-outline s18\"></i> <span class=\"section-title\" \ntranslate=\"SB.PERMISSIONS\">Permissions</span></div><div class=\"section-content\"><md-chips class=\"label-chips\" \nng-model=\"vm.board.cards[vm.card.id].idPermissions\" md-autocomplete-snap md-require-match=\"true\" \nmd-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedPermission\" \nmd-search-text=\"vm.searchPermissionText\" md-items=\"permission in vm.permissionQuerySearch(vm.searchPermissionText)\" \nmd-item-text=\"permission.name\" placeholder=\"Search for a permission\"><span md-highlight-text=\"vm.searchPermissionText\">\n{{permission.name}}</span></md-autocomplete><md-chip-template class=\"label-chip\" ng-class=\"\'md-blue-bg\'\"><span>\n{{vm.board.permissions.getById($chip).name}}</span></md-chip-template><button md-chip-remove class=\"md-primary\" \naria-label=\"close button\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button></md-chips></div></div><div\n ng-if=\"vm.board.cards[vm.card.id].idRoles[0]\" flex class=\"roles\"><div class=\"section-header\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-account-multiple s18\"></i> <span class=\"section-title\" translate=\"SB.ROLES\">\nRoles</span></div><div class=\"section-content\"><md-chips class=\"role-chips\" \nng-model=\"vm.board.cards[vm.card.id].idRoles\" md-autocomplete-snap md-require-match=\"true\" \nmd-transform-chip=\"$chip.id\"><md-autocomplete md-selected-item=\"vm.selectedRole\" md-search-text=\"vm.searchText\" \nmd-items=\"role in vm.roleQuerySearch(vm.searchText)\" md-item-text=\"role.name\" placeholder=\"Search for a role\"><span \nmd-highlight-text=\"vm.searchText\">{{role.name}}</span></md-autocomplete><md-chip-template class=\"role-chip\"><img \nclass=\"role-chip-avatar\" \nng-src=\"/assets/images/material-letter-icons/png/{{vm.board.roles.getById($chip).name.toUpperCase().charAt(0)}}.png\">\n<md-tooltip>{{vm.board.roles.getById($chip).name}}</md-tooltip></md-chip-template><button md-chip-remove \nclass=\"md-primary\" aria-label=\"remove button\"><md-icon md-font-icon=\"icon-close\" class=\"s18\"></md-icon></button>\n</md-chips></div></div></div><div ng-if=\"vm.card.actions\" class=\"section\" ng-repeat=\"action in vm.card.actions\"><div \nclass=\"action\"><div class=\"section-header\" layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-checkbox-marked s18\"></i> <span flex class=\"section-title\" ng-hide=\"editActionForm.$visible\">\n{{action.name}}</span> <span flex class=\"section-title\" editable-text=\"action.name\" ng-show=\"editActionForm.$visible\" \ne-form=\"editActionForm\"></span></div><div class=\"section-content\"><div class=\"check-items\"><div class=\"check-item\" \nng-repeat=\"checkItem in action.checkItems\" layout=\"row\" layout-align=\"space-between center\"><md-checkbox \nng-model=\"checkItem.checked\" ng-change=\"vm.updateCheckedCount(action)\" aria-label=\"{{checkItem.name}}\" \nng-hide=\"editCheckItemForm.$visible\">{{checkItem.name}}</md-checkbox><span flex editable-text=\"checkItem.name\" \nng-show=\"editCheckItemForm.$visible\" e-form=\"editCheckItemForm\"></span><md-menu md-position-mode=\"target-right target\" \nclass=\"options\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"options\" translate \ntranslate-attr-aria-label=\"SB.OPTIONS\"><md-icon md-menu-origin md-font-icon=\"icon-dots-vertical\" class=\"s20\"></md-icon>\n</md-button><md-menu-content class=\"options-menu-content\"><md-menu-item><md-button \nng-click=\"editCheckItemForm.$show()\" aria-label=\"Edit\" translate translate-attr-aria-label=\"SB.EDIT\"><md-icon \nmd-font-icon=\"icon-pencil\" class=\"s20\"></md-icon><span translate=\"SB.EDIT\">Edit</span></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.removeActionItem($event, checkItem, action.checkItems)\" aria-label=\"Remove\" \ntranslate translate-attr-aria-label=\"SB.REMOVE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><span \ntranslate=\"SB.REMOVE\">Remove</span></md-button></md-menu-item></md-menu-content></md-menu></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"no-errors-spacer\" flex><md-select \nng-model=\"vm.card.action\" placeholder=\"Select a action\"><md-option ng-value=\"action\" ng-repeat=\"action in vm.actions\">\n{{ action.name }}</md-option></md-select></md-input-container></div></div></div><div class=\"section\"></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/admin/modules/directives/ms-sb-add-card/ms-sb-add-card.html","<div class=\"ms-sb-add-card-button\" layout=\"row\" layout-align=\"start center\" ng-hide=\"formActive\"><div><i \nclass=\"icon-plus s20\"></i></div><span translate=\"SB.ADD_A_PAGE\"></span></div><div class=\"ms-sb-add-card-form-wrapper\" \nng-hide=\"!formActive\"><form class=\"ms-sb-add-card-form\" layout=\"column\"><md-input-container flex md-no-float>\n<md-autocomplete ng-disabled=\"\" md-no-cache=\"true\" md-selected-item=\"vm.selectedCard\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"(card) ? vm.addNewCard($event, card) : \'\'\" md-items=\"card in vm.querySearch(vm.searchText)\" \nmd-item-text=\"card.name\" md-min-length=\"0\" placeholder=\"Type the name of the page to find it\"><md-item-template><span \nmd-highlight-text=\"vm.searchText\" md-highlight-flags=\"^i\">{{card.name | capitalize}}</span></md-item-template>\n<md-not-found>No pages found. <a ng-click=\"vm.addNewCard($event, vm.searchText)\">Create a new one!</a></md-not-found>\n</md-autocomplete></md-input-container></form></div>");
$templateCache.put("app/main/admin/modules/sidenavs/filters/filters-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><span flex \nclass=\"menu-title\" translate=\"SB.FILTER_CARDS\">Filter Cards</span><md-button ng-if=\"vm.filteringIsOn()\" \nng-click=\"vm.clearFilters()\" class=\"md-icon-button\" aria-label=\"clear filters\"><md-icon \nmd-font-icon=\"icon-filter-remove\"></md-icon><md-tooltip><span translate=\"SB.CLEAR_FILTER\">Clear Filters</span>\n</md-tooltip></md-button></div></md-toolbar><md-content class=\"\" ms-scroll><md-list><md-subheader class=\"md-no-sticky\" \ntranslate=\"SB.FILTER_BY_CARD_NAME\">Filter by Card Name</md-subheader><md-list-item><input flex \nplaceholder=\"Type Card Name\" type=\"text\" ng-model=\"vm.cardFilters.name\" translate \ntranslate-attr-placeholder=\"SB.TYPE_CARD_NAME\"></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\" translate=\"SB.FILTER_BY_MEMBERS\">Filter by Members</md-subheader><md-list-item class=\"member\" \nng-repeat=\"member in vm.members\" ng-click=\"vm.toggleInArray(member.id, vm.cardFilters.members)\" \naria-label=\"Toggle Member\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p \nclass=\"member-name\">{{ member.name }}</p><i class=\"icon-check s16\" \nng-if=\"vm.exists(member.id, vm.cardFilters.members)\"></i></md-list-item></md-list></md-content>");
$templateCache.put("app/main/admin/modules/views/board/board-view.html","<textarea>{{vm.board}}</textarea><div id=\"board\" ng-class=\"vm.board.settings.color+\'-100-bg\'\" \nui-sortable=\"vm.sortableListOptions\" ng-model=\"vm.board.lists\" layout=\"row\"><div \nclass=\"list-wrapper module-id-{{list.id}}\" ng-repeat=\"list in vm.board.lists | orderBy: \'sort\'\" \nng-init=\"parentListIndex = $index\"><div class=\"list md-whiteframe-1dp\" layout=\"column\"><div class=\"list-header\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"list-header-name\"><span editable-text=\"list.name\" \nonaftersave=\"vm.updateListName(list)\">{{list.name}}</span></div><div class=\"list-card-member\" \nng-repeat=\"memberId in list.idMembers\" ng-click=\"vm.removeMember($event, parentListIndex, list, memberId)\"><img \nng-class=\"vm.getClassQtyMembers(list.idMembers.length)\" class=\"list-card-member-avatar\" \nng-src=\"/assets/images/material-letter-icons/png/{{vm.board.members.getById(memberId).name.toUpperCase().charAt(0)}}.png\">\n<md-tooltip><div class=\"name\">{{ vm.board.members.getById(memberId).name}}</div></md-tooltip></div><md-menu \nmd-offset=\"0 48px\" class=\"options list-header-option-button\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" \nwidth=\"4\"><md-menu-item><md-button ng-click=\"vm.removeList($event,list)\" aria-label=\"Remove List\" translate \ntranslate-attr-aria-label=\"SB.REMOVE_MODULE\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target></md-icon><span \ntranslate=\"SB.REMOVE_MODULE\">Remove Module</span></md-button></md-menu-item><v-accordion class=\"vAccordion--default\" \nmultiple=\"multiple\"><v-pane ng-if=\"vm.board.members\"><v-pane-header class=\"no-border\"><md-list-item>User Roles\n</md-list-item></v-pane-header><v-pane-content><md-list><md-list-item ng-if=\"vm.board.members\" \nng-repeat=\"member in vm.board.members\" ng-click=\"vm.addMemberToList(parentListIndex, list, member)\" \nng-class=\"{\'header-color\': vm.exists(member.id, list.idMembers) ,\'fw-500\': vm.exists(member.id, list.idMembers) }\"><p \nclass=\"pl-8\">{{member.name}}</p></md-list-item></md-list></v-pane-content></v-pane></v-accordion></md-menu-content>\n</md-menu></div><div class=\"list-content\" layout=\"column\"><div class=\"list-cards\" ui-sortable=\"vm.sortableCardOptions\" \nng-model=\"list.idCards\" ms-scroll><div ng-if=\"cardId\" class=\"list-card md-whiteframe-2dp\" \nng-repeat=\"cardId in list.idCards | filter: vm.cardFilter track by $index\" \nng-click=\"vm.openCardDialog($event, cardId, vm.removeCard)\"><div \nng-if=\"vm.board.settings.cardCoverImages && vm.board.cards.getById(cardId).idAttachmentCover\" class=\"list-card-cover\">\n<img \nng-src=\"{{vm.board.cards.getById(cardId).attachments.getById(vm.board.cards.getById(cardId).idAttachmentCover).src}}\">\n</div><div class=\"list-card-details\"><div class=\"list-card-sort-handle\"><md-icon md-font-icon=\"icon-cursor-move\" \nclass=\"icon s16\"></md-icon></div><div ng-if=\"vm.board.cards.getById(cardId).idLabels.length > 0\" \nclass=\"list-card-labels\" layout=\"row\" layout-wrap><span class=\"list-card-label\" \nng-class=\"\'md-\'+vm.board.labels.getById(labelId).color+\'-bg\'\" \nng-repeat=\"labelId in vm.board.cards.getById(cardId).idLabels\"><md-tooltip>{{vm.board.labels.getById(labelId).name}}\n</md-tooltip></span></div><div class=\"list-card-name\">{{vm.board.cards.getById(cardId).name | capitalize}}</div>\n<md-menu md-offset=\"0 48px\" class=\"options card-header-option-button\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"Options\" translate translate-attr-aria-label=\"SB.OPTIONS\"><md-icon \nmd-menu-origin md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"options-menu-content\" \nwidth=\"4\"><md-menu-item><md-button \nng-click=\"vm.removeCard($event, parentListIndex, list, vm.board.cards.getById(cardId))\" aria-label=\"Remove Page\" \ntranslate translate-attr-aria-label=\"SB.REMOVE_CARD\"><md-icon md-font-icon=\"icon-delete\" md-menu-align-target>\n</md-icon><span translate=\"SB.REMOVE_CARD\">Remove Page</span></md-button></md-menu-item></md-menu-content></md-menu>\n<div ng-if=\"vm.board.cards.getById(cardId).due || vm.board.cards.getById(cardId).checkItems\" class=\"list-card-badges\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"badge due-date\" \nng-class=\"{\'overdue\': vm.isOverdue(vm.board.cards.getById(cardId).due)}\" ng-if=\"vm.board.cards.getById(cardId).due\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-clock s16\"></i> <span>\n{{vm.board.cards.getById(cardId).due | date:\'mediumDate\'}}</span> </span><span \nng-if=\"vm.board.cards.getById(cardId).checkItems\" class=\"badge check-items\" \nng-class=\"{\'completed\': vm.board.cards.getById(cardId).checkItemsChecked === vm.board.cards.getById(cardId).checkItems}\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-checkbox-marked-circle s16\"></i> <span>\n{{vm.board.cards.getById(cardId).checkItemsChecked}}</span> <span>/</span> <span>\n{{vm.board.cards.getById(cardId).checkItems}}</span></span></div><div \nng-if=\"vm.board.cards.getById(cardId).idMembers.length > 0\" class=\"list-card-members\" layout=\"row\"></div></div><div \nclass=\"list-card-footer\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><span ng-if=\"vm.board.cards.getById(cardId).subscribed\" class=\"list-card-footer-item\" \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon-eye s18\"></i> </span><span \nng-if=\"vm.board.cards.getById(cardId).description !== \'\'\" class=\"list-card-footer-item\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-document s18\"></i></span></div><div layout=\"row\" layout-align=\"end center\">\n<span class=\"list-card-footer-item\" ng-if=\"vm.board.cards.getById(cardId).attachments\" layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon-attachment s18\"></i> <span class=\"value\">\n{{vm.board.cards.getById(cardId).attachments.length}}</span> </span><span class=\"list-card-footer-item\" \nng-if=\"vm.board.cards.getById(cardId).comments\" layout=\"row\" layout-align=\"start center\"><i class=\"icon-comment s18\">\n</i> <span class=\"value\">{{vm.board.cards.getById(cardId).comments.length}}</span></span></div></div></div></div></div>\n<div class=\"list-footer\"><ms-sb-add-card ms-list-id=\"list.id\"></ms-sb-add-card></div></div></div><div \nclass=\"new-list-wrapper\"><div class=\"list new-list md-whiteframe-1dp\"><span editable-text=\"vm.newListName\" \ne-form=\"newListForm\" onaftersave=\"vm.addNewList()\"></span><md-button class=\"new-list-form-button\" \nng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon-plus md-red-bg\"></i> <span translate=\"SB.ADD_A_LIST\">Add a list</span></div></md-button></div></div></div>");
$templateCache.put("app/main/admin/modules/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"md-accent\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><md-button \nng-hide=\"vm.selectedMenu === \'Settings\'\" class=\"md-icon-button\" ng-click=\"vm.selectedMenu = \'Settings\'\" \naria-label=\"back\" translate translate-attr-aria-label=\"SB.BACK\"><md-icon md-font-icon=\"icon-arrow-left\"></md-icon>\n</md-button><span flex class=\"menu-title\">{{vm.selectedMenu}}</span></div></md-toolbar><md-content \nng-show=\"vm.selectedMenu === \'Settings\'\" class=\"animate-slide-right settings\" ms-scroll ms-sidenav-helper><md-list>\n<md-list-item class=\"item\" ng-click=\"vm.selectedMenu = \'Board Color\'\"><md-icon md-font-icon=\"icon-format-color-fill\" \nclass=\"s18\"></md-icon><p class=\"title\" translate=\"SB.BOARD_COLOR\">Board Color</p></md-list-item><md-list-item \nclass=\"item\"><md-icon md-font-icon=\"icon-delete\" class=\"s18\"></md-icon><p class=\"title\" translate=\"SB.DELETE_BOARD\">\nDelete Board</p></md-list-item><md-divider></md-divider><md-list-item class=\"item\" \nng-click=\"vm.selectedMenu = \'Members\'\" aria-label=\"inbox\"><md-icon md-font-icon=\"icon-account-multiple\" class=\"s18\">\n</md-icon><p class=\"title\" translate=\"SB.MEMBERS\">Members</p></md-list-item></md-list></md-content><md-content \nng-show=\"vm.selectedMenu === \'Board Color\'\" class=\"animate-slide-left board-color-selection\"><div layout=\"column\" \nlayout-fill ng-include=\"\'app/main/admin/modules/sidenavs/settings/menus/color/color-menu.html\'\" \nng-controller=\"ColorMenuController as vm\"></div></md-content><md-content ng-show=\"vm.selectedMenu === \'Members\'\" \nclass=\"animate-slide-left members\"><div layout=\"column\" layout-fill \nng-include=\"\'app/main/admin/modules/sidenavs/settings/menus/members/members-menu.html\'\" \nng-controller=\"MembersMenuController as vm\"></div></md-content>");
$templateCache.put("app/main/admin/modules/views/boards/boards-view.html","<div id=\"boards\" class=\"md-accent-bg\" layout=\"column\" flex><div id=\"board-selector\" layout=\"column\" \nlayout-align=\"start center\" flex><h1 translate=\"SB.SCRUMBOARD_APP\"></h1><div class=\"board-list\" layout=\"row\" \nlayout-align=\"center center\" layout-wrap><div class=\"board-list-item\" ng-repeat=\"board in vm.boardList\" \nui-sref=\"app.modules.boards.board({id:board.id, uri:board.uri})\" layout=\"column\" layout-align=\"center center\"><md-icon \nmd-font-icon=\"icon-trello\" class=\"icon s64\"></md-icon><div class=\"board-name\">{{board.name}}</div></div></div></div>\n</div>");
$templateCache.put("app/main/admin/modules/views/calendar/calendar-view.html","<div id=\"board-calendar\" class=\"page-layout simple right-sidenav\" flex layout=\"row\" \nng-class=\"vm.board.settings.color+\'-100-bg\'\"><md-sidenav class=\"sidenav scheduled-tasks-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"scheduled-tasks-sidenav\" \nng-include=\"\'app/main/admin/modules/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html\'\" ms-scroll \nms-sidenav-helper></md-sidenav><div id=\"calendar\" class=\"md-whiteframe-2dp\" flex layout=\"column\" \nng-class=\"vm.currentMonthShort\"><div class=\"calendar-header\" layout=\"row\" layout-align=\"space-between center\" \nlayout-xs=\"column\"><md-button hide-gt-md class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'scheduled-tasks-sidenav\')\" \naria-label=\"Scheduled Cards Sidenav\"><md-icon md-font-icon=\"icon-calendar-clock\"></md-icon><md-tooltip><span \ntranslate=\"SB.SCHEDULED_CARDS\">Scheduled Cards</span></md-tooltip></md-button><div class=\"\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"SB.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\">\n</md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" \nng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate translate-attr-aria-label=\"SB.NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div><div><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"SB.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"SB.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"SB.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"SB.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"SB.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"SB.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"SB.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"SB.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"calendar-main\" ms-scroll flex \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.eventSources\" calendar=\"main\"></div></div></div>");
$templateCache.put("app/main/directives/ms-custom-stepper/templates/horizontal/horizontal.html","<div class=\"ms-custom-stepper-horizontal\"><div class=\"ms-custom-stepper-navigation-wrapper\"><div \nclass=\"ms-custom-stepper-navigation\" layout=\"row\" layout-align=\"center center\"><span \nclass=\"ms-custom-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': !MsStepper.isStepCurrent(step.stepNumber) && step.stepNumber > MsStepper.currentStepNumber, \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"MsStepper.isStepCurrent(step.stepNumber)\">{{$index + 1}} </span><span \nng-if=\"!MsStepper.isStepCurrent(step.stepNumber) && MsStepper.currentStepNumber > step.stepNumber\"><i \nclass=\"icon icon-check s18\"></i> </span><span \nng-if=\"!MsStepper.isStepCurrent(step.stepNumber) && step.stepNumber > MsStepper.currentStepNumber \">{{$index + 1}}\n</span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></span></div></div><div \nclass=\"ms-custom-stepper-steps\" ng-transclude></div><div class=\"ms-custom-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-custom-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep() && MsStepper.hasSave()\" ng-disabled=\"!MsStepper.isFormValid()\">Save</md-button></div>\n</div>");
$templateCache.put("app/main/directives/ms-custom-stepper/templates/vertical/vertical.html","<div class=\"ms-custom-stepper-vertical\"><div class=\"ms-custom-stepper-vertical-line\"></div><div \nclass=\"ms-custom-stepper-steps\" ng-transclude></div></div>");
$templateCache.put("app/main/directives/ms-file-upload/dialogs/category/category-dialog.html","<md-dialog class=\"category-dialog\" aria-label=\"New category\"><form name=\"categoryForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate=\"\" \ntranslate-attr-aria-label=\"EC.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div flex=\"95\" layout=\"column\" layout-align=\"start\"><md-input-container \nclass=\"md-icon-float md-block\"><div class=\"label\"><label translate=\"EC.NAME\"></label></div><md-icon \nmd-font-icon=\"icon-tab\" class=\"name\"></md-icon><input ng-model=\"vm.document_name\" type=\"text\" required md-autofocus>\n<div ng-messages=\"vm.form.document_name.$error\"><div ng-message=\"required\">Tab Name is required</div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.addNewDocument()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"categoryForm.$invalid || categoryForm.$pristine\" \naria-label=\"Add Document\" translate=\"EC.ADD_DOCUMENT\" translate-attr-aria-label=\"EC.ADD_DOCUMENT\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/directives/ms-lease-block/templates/dialogs/lease-block-dialog.html","<md-dialog class=\"block-dialog\" aria-label=\"New Task\"><form name=\"blockForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"BLOCK.DIALOG.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div ng-if=\"!vm.newBlock\" \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><md-input-container class=\"md-block\"><span>{{vm.block.name}}</span>\n</md-input-container></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block padding-bottom-15\" flex-gt-sm><label>Location</label><md-icon md-font-icon=\"icon-view-dashboard\" \nclass=\"name\"></md-icon><md-select ng-required=\"!vm.block.location_id\" ng-model=\"vm.block.location_id\"><md-option \nng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" ng-click=\"vm.getLocationRanches(location.id,\'true\')\">\n{{location.name}}</md-option><md-option ng-if=\"vm.locations.length===0\" ng-click=\"vm.goToLand()\">No <b>Locations</b>\n exist<br>Go to Land page</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block padding-bottom-15\" flex-gt-sm><label>Ranch</label><md-icon md-font-icon=\"icon-view-dashboard\" \nclass=\"name\"></md-icon><md-select ng-required=\"!vm.block.ranch_id\" ng-model=\"vm.block.ranch_id\"><md-option \nng-if=\"!vm.block.location_id\">No Ranches. First select a Location.</md-option><md-option \nng-if=\"vm.block.location_id && vm.ranches\" ng-repeat=\"ranch in vm.ranches\" value=\"{{ranch.id}}\" \nng-click=\"vm.getRanchBlocks(vm.area_id, ranch.id,\'true\')\">{{ranch.name}}</md-option><md-option \nng-if=\"vm.block.location_id && vm.ranches.length===0\" ng-click=\"vm.goToRanches()\">No <b>Ranches</b> in that location.\n<br>Go to Ranches page.</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block padding-bottom-15\" flex-gt-sm><label>Block</label><md-icon md-font-icon=\"icon-view-dashboard\" \nclass=\"name\"></md-icon><md-select ng-required=\"!vm.blockId\" ng-model=\"vm.blockId\" name=\"blockId\"><md-option \nng-if=\"!vm.block.ranch_id\">No Blocks. First select a Ranch.</md-option><md-option \nng-if=\"vm.block.ranch_id && vm.blocks.length>0 && vm.newBlock\" ng-repeat=\"block in vm.blocks\" value=\"{{block.id}}\">\n{{block.name}}</md-option><md-option ng-if=\"vm.block.ranch_id && vm.isLease && vm.blocks.length===0  && vm.newBlock\" \nng-click=\"vm.goToBlocks()\">No <b>Blocks</b> availables for lease in that ranch.<br>Go to Blocks page.</md-option>\n<md-option ng-if=\"vm.block.ranch_id && !vm.isLease && vm.blocks.length===0 && vm.newBlock\" ng-click=\"vm.goToBlocks()\">\nNo <b>Blocks</b> availables for sublease in that ranch.<br>Go to Blocks page.</md-option><md-option \nng-if=\"vm.block.ranch_id  && vm.blocksForEdit.length>0 && !vm.newBlock\" ng-repeat=\"block in vm.blocksForEdit\" \nvalue=\"{{block.id}}\">{{block.name}}</md-option></md-select></md-input-container><div layout=\"row\" \nclass=\"md-block textarea-wrapper\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-note\"></md-icon>\n<md-input-container flex><label translate translate-attr-placeholder=\"BLOCK.DIALOG.NOTES\">Notes</label><textarea \nng-if=\"vm.isLease\" ng-model=\"vm.block.lease_block.description\" type=\"text\" md-maxlength=\"250\" maxlength=\"250\">\n</textarea><textarea ng-if=\"!vm.isLease\" ng-model=\"vm.block.sublease_block.description\" type=\"text\" md-maxlength=\"250\" \nmaxlength=\"250\"></textarea></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"vm.newBlock\" ng-click=\"vm.assignNewBlock()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"blockForm.$invalid || blockForm.$pristine\" aria-label=\"SAVE\" translate=\"BLOCK.DIALOG.SAVE\" \ntranslate-attr-aria-label=\"BLOCK.DIALOG.SAVE\"></md-button><md-button type=\"submit\" ng-if=\"!vm.newBlock\" \nng-click=\"vm.saveLeaseBlock()\" class=\"send-button md-accent md-raised\" ng-disabled=\"blockForm.$pristine\" \naria-label=\"SAVE\" translate=\"BLOCK.DIALOG.SAVE\" translate-attr-aria-label=\"BLOCK.DIALOG.SAVE\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/directives/ms-payment-schedule/templates/dialogs/payment-schedule-dialog.html","<md-dialog class=\"payment-schedule-dialog\" aria-label=\"New Task\"><form name=\"paymentScheduleForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div \nclass=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span class=\"title\">\n{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"PAYMENT_SCHEDULE.DIALOG.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div ng-if=\"!vm.newPaymentSchedule\" class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><md-input-container \nclass=\"md-block\"><span translate=\"PAYMENT_SCHEDULE.PAYMENT_NUMBER\" \ntranslate-attr-aria-label=\"PAYMENT_SCHEDULE.PAYMENT_NUMBER\"></span> <span>{{vm.auxPaymentSchedule.pos}}</span>\n</md-input-container></div></div></md-toolbar><md-dialog-content ms-scroll><div flex layout=\"column\" layout-padding>\n<section flex><md-input-container class=\"md-block margin-top-0 padding-top-0 padding-bottom-15 margin-bottom-0\"><div \nclass=\"signature\"><label for=\"signature\">Payment Due Date</label></div><md-datepicker md-open-on-focus \nng-if=\"vm.entity !== \'contract\'\" name=\"due_date\" ng-model=\"vm.auxPaymentSchedule.payment_due_date\" required>\n</md-datepicker><md-datepicker md-open-on-focus ng-if=\"vm.entity === \'contract\'\" name=\"due_date\" \nng-model=\"vm.auxPaymentSchedule.due_date\" required></md-datepicker><div \nng-messages=\"paymentScheduleForm.due_date.$error\"><div class=\"error-message datepicker\" ng-message=\"required\">\nDue Date field is required.</div></div></md-input-container></section><section ng-if=\"vm.entity !== \'contract\'\">\n<md-input-container class=\"md-block margin-top-0 padding-top-0\" flex-gt-sm=\"95\"><div class=\"signature\"><label \nfor=\"signature\" translate=\"PAYMENT_SCHEDULE.DIALOG.AMOUNT\"></label></div><md-icon md-font-icon=\"icon-square-inc-cash\">\n</md-icon><input name=\"amount\" aria-label=\"Amount\" required ng-model=\"vm.auxPaymentSchedule.amount\" \ncurrency-input=\"money\" onfocus=\"placeholder=\'Max: 9,999,999.99\'\" onblur=\"placeholder=\'\'\" type=\"text\"><div \nng-messages=\"paymentScheduleForm.amount.$error\" role=\"alert\"><div class=\"error-message\" ng-message=\"required\">\nAmount field is required.</div><div class=\"error-message\" ng-message=\"amount\">\nAmount field must be equal or greater than 0.01</div></div></md-input-container></section><section \nng-if=\"vm.entity === \'contract\'\"><md-input-container class=\"md-block margin-top-0 padding-top-0\" flex-gt-sm=\"95\"><div \nclass=\"signature\"><label for=\"signature\" translate=\"PAYMENT_SCHEDULE.DIALOG.CONTRACT_AMOUNT\"></label></div><md-icon \nmd-font-icon=\"icon-square-inc-cash\"></md-icon><input name=\"amount\" aria-label=\"Amount\" required \nng-model=\"vm.auxPaymentSchedule.amount\" currency-input=\"money\" onfocus=\"placeholder=\'Max: 9,999,999.99\'\" \nonblur=\"placeholder=\'\'\" type=\"text\"><div ng-messages=\"paymentScheduleForm.amount.$error\" role=\"alert\"><div \nclass=\"error-message\" ng-message=\"required\">Amount field is required.</div><div class=\"error-message\" \nng-message=\"amount\">Amount field must be equal or greater than 0.01</div></div></md-input-container></section><section \nng-if=\"vm.entity === \'contract\'\"><md-input-container class=\"md-block margin-top-0 padding-top-0\" flex-gt-sm=\"95\"><div \nclass=\"signature\"><label for=\"signature\" translate=\"PAYMENT_SCHEDULE.DIALOG.ADDITIONAL_INCENTIVE_AMOUNT\"></label></div>\n<md-icon md-font-icon=\"icon-square-inc-cash\"></md-icon><input aria-label=\"Amount\" name=\"contract_incentive_amount\" \nng-model=\"vm.auxPaymentSchedule.contract_incentive_amount\" currency-input=\"money\" \nonfocus=\"placeholder=\'Max: 9,999,999.99\'\" onblur=\"placeholder=\'\'\" type=\"text\"></md-input-container></section><section \nng-if=\"vm.auxPaymentSchedule.id\"><md-input-container class=\"md-block margin-top-0 padding-top-0\" flex-gt-sm=\"95\"><div \nclass=\"signature\"><label for=\"signature\" translate=\"PAYMENT_SCHEDULE.DIALOG.AMOUNT_PAID\"></label></div><md-icon \nmd-font-icon=\"icon-square-inc-cash\"></md-icon><input aria-label=\"Amount\" ng-model=\"vm.auxPaymentSchedule.amount_paid\" \ncurrency-input=\"money\" onfocus=\"placeholder=\'Max: 9,999,999.99\'\" onblur=\"placeholder=\'\'\" type=\"text\">\n</md-input-container></section><section ng-if=\"vm.auxPaymentSchedule.id\"><md-input-container \nclass=\"md-block margin-top-0 padding-top-0\" flex-gt-sm=\"95\"><div class=\"option-title\">Payment made:</div>\n<md-radio-group layout=\"row\" layout-align=\"start center\" required ng-model=\"vm.auxPaymentSchedule.payment_made\">\n<md-radio-button ng-value=\"1\">Yes</md-radio-button><md-radio-button ng-value=\"0\" ng-checked>No</md-radio-button>\n</md-radio-group></md-input-container></section><section ng-if=\"vm.auxPaymentSchedule.id\"><md-input-container \nclass=\"md-block margin-top-0 padding-top-0\"><div class=\"signature\"><label for=\"signature\" \ntranslate=\"PAYMENT_SCHEDULE.DIALOG.DATE_PAID\"></label></div><md-datepicker md-open-on-focus \nng-model=\"vm.auxPaymentSchedule.date_paid\"></md-datepicker></md-input-container></section><section><div layout=\"row\" \nclass=\"md-block textarea-wrapper\" layout-align=\"start start\" flex-gt-sm=\"95\"><md-input-container flex><label translate \ntranslate-attr-placeholder=\"PAYMENT_SCHEDULE.NOTES\">Notes</label><md-icon md-font-icon=\"icon-note\"></md-icon><textarea \nng-model=\"vm.auxPaymentSchedule.description\" type=\"text\" md-maxlength=\"250\" maxlength=\"250\"></textarea>\n</md-input-container></div></section></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newPaymentSchedule\" ng-click=\"vm.savePaymentSchedule()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"paymentScheduleForm.$invalid || paymentScheduleForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"PAYMENT_SCHEDULE.DIALOG.SAVE\" translate-attr-aria-label=\"PAYMENT_SCHEDULE.DIALOG.SAVE\"></md-button>\n<md-button type=\"submit\" ng-if=\"vm.newPaymentSchedule\" ng-click=\"vm.addNewPaymentSchedule()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"paymentScheduleForm.$invalid || paymentScheduleForm.$pristine\" \naria-label=\"SAVE\" translate=\"PAYMENT_SCHEDULE.DIALOG.SAVE\" translate-attr-aria-label=\"PAYMENT_SCHEDULE.DIALOG.SAVE\">\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/farm-admin/farm-resources/seed/form/step1.html","<div id=\"seed-step\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text class-radio w-30\"></th><th class=\"secondary-text name-seed\"><div class=\"table-header\"><span \nclass=\"column-title\">Name</span></div></th><th class=\"secondary-text description-seed\"><div class=\"table-header\"><span \nclass=\"column-title\">Description</span></div></th><th class=\"secondary-text class-action\"><div class=\"table-header\">\n<span class=\"column-title\">Actions</span></div></th></tr></thead><tbody class=\"scrollable\" ms-scroll \nng-style=\"setSize(466)\" resize ng-if=\"!loadingData\"><tr ng-repeat=\"seed in vm.seeds\"><td \nclass=\"radio-icon class-radio\"><md-radio-group required ng-model=\"vm.groupSeed\"><md-radio-button aria-label=\"true\" \nng-click=\"vm.seedId(seed.id, seed.name)\" ng-value=\"seed.id\"></md-radio-button></md-radio-group></td><td \nclass=\"name-seed\"><md-input-container class=\"md-block\" ng-model=\"seed.name\" flex-gt-sm><input aria-label=\"true\" \nng-model=\"seed.name\" letters-only md-autofocus maxlength=\"20\" type=\"text\"></md-input-container></td><td \nclass=\"description-seed\"><md-input-container class=\"md-block\" ng-model=\"seed.description\" flex-gt-sm><input \naria-label=\"true\" ng-model=\"seed.description\" md-autofocus maxlength=\"250\"></md-input-container></td><td \nclass=\"radio-icon class-action\"><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" \nng-show=\"seed.seed_varieties.length==0\" aria-label=\"true\" translate translate-attr-aria-label=\"SEEDS.DELETE_SEED\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-list-item \naria-label=\"true\" ng-click=\"vm.deleteSeedConfirm(seed, ev)\"><p translate=\"SEEDS.DELETE_SEED\"></p></md-list-item>\n</md-menu-content><md-button class=\"md-icon-button\" ng-show=\"seed.seed_varieties.length>=1\" \nng-disabled=\"seed.seed_varieties.length>=1\" aria-label=\"true\" translate translate-attr-aria-label=\"SEEDS.DELETE_SEED\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></md-menu></td></tr></tbody></table><md-radio-group \nng-if=\"vm.seeds.length === 0\" ng-hide=\"true\" required ng-model=\"aux\"><md-radio-button aria-label=\"true\">\n</md-radio-button></md-radio-group><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" \nlayout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && vm.seeds.length === 0\"><p class=\"padding-left-0\" translate=\"SEEDS.NO_RESULTS\">No results..</p>\n</md-list-item></div></div></div>");
$templateCache.put("app/main/farm-admin/farm-resources/seed/form/step2.html","<div id=\"seed-step\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text class-radio\"></th><th class=\"secondary-text variety-variety\"><div class=\"table-header\"><span \nclass=\"column-title\">Variety</span></div></th><th class=\"secondary-text description-variety\"><div class=\"table-header\">\n<span class=\"column-title\">Description</span></div></th><th class=\"secondary-text public-domain-header\"><div \nclass=\"table-header\"><span class=\"column-title\">Public Domain</span></div></th><th class=\"secondary-text class-action\">\n<div class=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody class=\"scrollable\" \nms-scroll ng-style=\"setSize(466)\" resize ng-if=\"!loadingDataVarieties\"><tr class=\"ng-scope odd\" \nng-repeat=\"variety in vm.varieties\"><td class=\"radio-icon class-radio\"><md-radio-group required \nng-model=\"vm.groupVariety\"><md-radio-button aria-label=\"true\" ng-click=\"vm.varietyId(variety.id, variety.name)\" \nng-value=\"variety.id\"></md-radio-button></md-radio-group></td><td class=\"variety-variety\"><md-input-container \nclass=\"md-block\" ng-model=\"variety.name\" flex-gt-sm><input aria-label=\"true\" ng-model=\"variety.name\" md-autofocus \nletters-only maxlength=\"20\"></md-input-container></td><td class=\"description-variety\"><md-input-container \nclass=\"md-block\" ng-model=\"variety.description\" flex-gt-sm><input aria-label=\"true\" ng-model=\"variety.description\" \nmd-autofocus maxlength=\"250\"></md-input-container></td><td class=\"radio-icon public-domain\"><md-button \nclass=\"md-icon-button\" aria-label=\"Toggle public domain\" translate \nng-click=\"variety.public_domain = !variety.public_domain;\" translate-attr-aria-label=\"SEEDS.TOGGLE_PUBLIC_DOMAIN\">\n<md-icon ng-if=\"variety.public_domain\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon>\n<md-icon ng-if=\"!variety.public_domain\" md-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></td>\n<td class=\"radio-icon class-action\"><md-menu><md-button class=\"md-icon-button\" \nng-show=\"variety.seed_varieties_location.length==0\" ng-click=\"$mdMenu.open($event)\" aria-label=\"true\" translate \ntranslate-attr-aria-label=\"SEEDS.DELETE_VARIETY\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-list-item aria-label=\"true\" ng-click=\"vm.deleteVarietyConfirm(variety, ev)\"><p \ntranslate=\"SEEDS.DELETE_VARIETY\"></p></md-list-item></md-menu-content><md-button class=\"md-icon-button\" \nng-show=\"variety.seed_varieties_location.length>=1\" ng-disabled=\"variety.seed_varieties_location.length>=1\" \naria-label=\"true\" translate translate-attr-aria-label=\"SEEDS.DELETE_VARIETY\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button></md-menu></td></tr></tbody></table><md-radio-group \nng-if=\"vm.varieties.length === 0\" ng-hide=\"true\" required ng-model=\"aux\"><md-radio-button aria-label=\"true\">\n</md-radio-button></md-radio-group><md-list-item ng-if=\"loadingDataVarieties\" class=\"loader\" layout=\"row\" \nlayout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingDataVarieties && vm.varieties.length === 0\"><p class=\"padding-left-0\" translate=\"SEEDS.NO_RESULTS\">\nNo results..</p></md-list-item></div></div></div>");
$templateCache.put("app/main/farm-admin/farm-resources/seed/form/step3.html","<div id=\"seed-step\" class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"content-card\" layout=\"column\" flex>\n<div class=\"content fullpage-datatable\" layout=\"column\" flex><table class=\"dataTable row-border hover\"><thead><tr><th \nclass=\"secondary-text states-planting\"><div class=\"table-header\"><span class=\"column-title\">Location</span></div></th>\n<th class=\"secondary-text start-planting\"><div class=\"table-header\"><span class=\"column-title\">Planting Start Day\n</span></div></th><th class=\"secondary-text end-planting\"><div class=\"table-header\"><span class=\"column-title\">\nPlanting End Day</span></div></th><th class=\"secondary-text class-action\"><div class=\"table-header\"><span \nclass=\"column-title\">Actions</span></div></th></tr></thead><tbody class=\"scrollable\" ms-scroll ng-style=\"setSize(466)\" \nresize ng-if=\"!loadingDataLocation\"><tr class=\"ng-scope odd\" ng-repeat=\"seed in vm.varietiesLocations\"><td \nclass=\"states-planting\"><md-input-container class=\"md-block\" flex-gt-sm><md-select class=\"selection\" \nng-model=\"seed.location_id\" md-on-open=\"loadLocation()\" aria-label=\"true\" flex-gt-sm><md-option \nng-if=\"vm.locations.length===0\" ng-click=\"vm.redirectLand()\">There are no locations to display</md-option><md-option \nng-if=\"vm.locations.length!=0\" class=\"option\" ng-repeat=\"location in vm.locations\" ng-value=\"location.id\">\n{{location.name}}</md-option></md-select></md-input-container></td><td class=\"start-planting\"><md-datepicker \nmd-open-on-focus ng-model=\"seed.begin_date\" md-placeholder=\"seed.begin_date\" md-date-locale=\"customDateFormat\" \nng-change=\"vm.seedDateChanged(seed)\"></md-datepicker></td><td class=\"end-planting\"><md-datepicker md-open-on-focus \nng-model=\"seed.end_date\" md-placeholder=\"seed.end_date\" md-date-locale=\"customDateFormat\" md-min-date=\"seed.min_date\" \nng-change=\"vm.seedDateChanged(seed)\"></md-datepicker></td><td class=\"radio-icon class-action\"><md-menu><md-button \nclass=\"md-icon-button\" aria-label=\"true\" ng-click=\"$mdMenu.open($event)\" translate \ntranslate-attr-aria-label=\"SEEDS.DELETE_VARIETY\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-list-item aria-label=\"true\" \nng-click=\"vm.deleteVarietyPlantingLocationConfirm(seed, ev)\"><p translate=\"SEEDS.DELETE_PLANTING_LOCATION\"></p>\n</md-list-item></md-menu-content></md-menu></td></tr></tbody></table><md-list-item ng-if=\"loadingDataLocation\" \nclass=\"loader\" layout=\"row\" layout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item \nclass=\"md-white-bg\" ng-show=\"!loadingDataLocation && vm.varietiesLocations.length === 0\"><p class=\"padding-left-0\" \ntranslate=\"SEEDS.NO_RESULTS\">No results..</p></md-list-item></div></div></div>");
$templateCache.put("app/main/farm-admin/land/blocks/tabs/tabs.html","<div ng-cloak><div id=\"tabs\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.backListing()\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><div class=\"custom-font-size\">\n<span ng-show=\"vm.block.id\" translate=\"BLOCKS.EDIT_BLOCK\"></span> <span ng-show=\"!vm.block.id\" \ntranslate=\"BLOCKS.ADD_BLOCK\"></span> <span>&nbsp;{{vm.block.name}}</span></div></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button \nng-disabled=\"(vm.informationForm.$invalid || vm.informationForm.$pristine) && (vm.bedSizesForm.$invalid || vm.bedSizesForm.$pristine)&& vm.saveDisabled\" \nclass=\"md-raised md-background\" ng-click=\"vm.tabsSave($event)\"><span ng-show=\"vm.block.id\">Save</span> <span \nng-show=\"!vm.block.id\">Add</span></md-button></div></div></div><md-content><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"Information\"><md-content class=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs \nflex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/blocks/tabs/sections/information/block-info.html\'\"></div></div></md-content>\n</md-tab><md-tab ng-if=\"vm.block.id\" label=\"Bed size\"><md-content class=\"custom-content md-padding\" layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/blocks/tabs/sections/bed-sizes/block-bed-sizes.html\'\"></div></div></md-content>\n</md-tab><md-tab ng-if=\"vm.block.id\" label=\"Map\"><md-content class=\"custom-content md-padding\" layout-xs=\"column\" \nlayout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/blocks/tabs/sections/map/index.html\'\"></div></div></md-content></md-tab><md-tab \nng-if=\"vm.block.id\" label=\"Documents\"><md-content class=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\">\n<div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/blocks/tabs/sections/documents/documents.html\'\"></div></div></md-content>\n</md-tab></md-tabs></md-content></div>");
$templateCache.put("app/main/farm-admin/land/land/form/step1.html","<div id=\"land-step\" class=\"page-layout carded\" layout=\"row\"><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content datatable\" layout=\"column\" flex><ms-loader ng-if=\"loadingData\"></ms-loader><table ng-if=\"!loadingData\" \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text radio-icon w-50\"></th><th \nclass=\"secondary-text area\"><div class=\"table-header\"><span class=\"column-title\">{{vm.land_ref.area_reference_name}}\n</span></div></th><th class=\"secondary-text w-90\"><div class=\"table-header\"><span class=\"column-title\">Actions</span>\n</div></th></tr></thead><tbody class=\"scrollable\" ms-scroll ng-style=\"setSize(466)\" resize><tr \nng-repeat=\"area in vm.areas\"><td class=\"radio-icon w-50\"><md-radio-group required ng-model=\"dataAreaId\">\n<md-radio-button ng-click=\"vm.areaId(area.id, area.name)\" aria-label=\"true\" ng-value=\"area.id\"></md-radio-button>\n</md-radio-group></td><td class=\"area\"><md-input-container class=\"md-block\" ng-model=\"area.name\" flex-gt-sm><input \nname=\"area_name\" ng-model=\"area.name\" aria-label=\"true\" letters-only md-autofocus ng-change=\"vm.changedAreas()\"><div \nng-messages=\"area_name.$error\"><div ng-message=\"required\">Area name is required.</div></div></md-input-container></td>\n<td class=\"w-90\"><md-menu><md-button class=\"md-icon-button\" ng-show=\"area.Locations.length==0\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"true\" translate translate-attr-aria-label=\"AREA.DELETE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-list-item aria-label=\"true\" \nng-click=\"vm.deleteAreaConfirm(area, ev)\"><p translate=\"LANDS.DELETE_AREA\"></p></md-list-item></md-menu-content>\n<md-button class=\"md-icon-button\" ng-show=\"area.Locations.length>=1\" ng-disabled=\"area.Locations.length>=1\" \naria-label=\"true\" translate translate-attr-aria-label=\"AREA.DELETE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button></md-menu></td></tr><tr ng-if=\"!loadingData && vm.areas.length === 0\"><td><md-list-item><p \nclass=\"custom-msg\" translate=\"LANDS.NO_RESULTS\">No results..</p></md-list-item></td></tr></tbody></table>\n<md-radio-group ng-if=\"vm.areas.length === 0\" ng-hide=\"true\" required ng-model=\"aux\"><md-radio-button \naria-label=\"true\"></md-radio-button></md-radio-group></div></div></div>");
$templateCache.put("app/main/farm-admin/land/land/form/step2.html","<div id=\"land-step\" class=\"page-layout carded fullwidth\" layout=\"row\"><form><div class=\"content-card\" layout=\"column\" \nflex><div class=\"content fullpage-datatable\" layout=\"column\" flex><ms-loader ng-if=\"loadingDataLocation\"></ms-loader>\n<table ng-if=\"!loadingDataLocation\" class=\"dataTable row-border hover\"><thead><tr><th class=\"secondary-text location\">\n<div class=\"table-header\"><span class=\"column-title\">Location</span></div></th><th class=\"secondary-text short\"><div \nclass=\"table-header\"><span class=\"column-title\">Short Code</span></div></th><th class=\"secondary-text w-90\"><div \nclass=\"table-header\"><span class=\"column-title\">Actions</span></div></th></tr></thead><tbody class=\"scrollable\" \nms-scroll ng-style=\"setSize(466)\" resize><tr ng-if=\"vm.locations.length > 0\" class=\"ng-scope odd\" \nng-repeat=\"location in vm.locations\"><td class=\"location\"><md-input-container class=\"md-block\" \nng-model=\"location.name\" flex-gt-sm><input name=\"location_name\" required aria-label=\"true\" letters-only \nng-model=\"location.name\" ng-pattern=\"/^[a-zA-Z\\s]*$/\" md-autofocus ng-minlength=\"2\"><div \nng-messages=\"location_name.$error\"><div ng-message=\"required\">Location name is required.</div></div>\n</md-input-container></td><td class=\"short\"><md-input-container class=\"md-block\" \nng-model=\"location.location_short_code\" flex-gt-sm><input name=\"location_short_code\" required aria-label=\"true\" \nng-model=\"location.location_short_code\" ng-change=\"location.updatedCode=true\" md-autofocus ng-maxlength=\"2\" \nng-pattern=\"/^[a-zA-Z\\s]*$/\"><div ng-messages=\"location_short_code.$error\"><div ng-message=\"required\">\nLocation short code is required.</div></div></md-input-container></td><td class=\"w-90\"><md-menu><md-button \nclass=\"md-icon-button\" ng-disabled=\"location.ranches.length>0\" ng-click=\"$mdMenu.open($event)\" aria-label=\"true\" \ntranslate translate-attr-aria-label=\"LANDS.DELETE_LOCATION\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-list-item aria-label=\"true\" \nng-click=\"vm.deleteLocationConfirm(location, ev)\"><p translate=\"LANDS.DELETE_LOCATION\"></p></md-list-item>\n</md-menu-content></md-menu></td></tr><tr ng-if=\"!loadingDataLocation && vm.locations.length === 0\"><td><md-list-item \nclass=\"custom-msg\"><p translate=\"LANDS.NO_RESULTS\">No results..</p></md-list-item></td></tr></tbody></table></div>\n</div></form></div>");
$templateCache.put("app/main/farm-admin/land/leases/tabs/tabs.html","<div ng-cloak><div id=\"tabs\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.backListing()\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><span \nng-if=\"vm.lease.id && !vm.lease.lease_id\" class=\"logo-text\" translate=\"LEASES.LEASE_EDIT\">Leases</span> <span \nng-if=\"!vm.lease.id\" class=\"logo-text\" translate=\"LEASES.LEASE_ADD\">Leases</span></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button \nng-disabled=\"(vm.informationForm.$invalid || vm.informationForm.$pristine) && (vm.paymentsForm.$invalid || vm.paymentsForm.$pristine)\" \nclass=\"md-raised md-background\" ng-click=\"vm.tabsSave()\"><span ng-show=\"vm.lease.id\">Save</span> <span \nng-show=\"!vm.lease.id\">Add</span></md-button></div></div><div id=\"tab-content\"><md-content><md-tabs md-dynamic-height \nmd-border-bottom md-selected=\"vm.selectedTab\"><md-tab ng-if=\"vm.lease\" label=\"Information\"><md-content \nclass=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/leases/tabs/sections/information/information.html\'\"></div></div></md-content>\n</md-tab><md-tab ng-if=\"vm.lease.id\" label=\"Payment Schedule\"><md-content class=\"custom-content-payment md-padding\" \nlayout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/leases/tabs/sections/payment-schedule/payment-schedule.html\'\"></div></div>\n</md-content></md-tab><md-tab ng-if=\"vm.lease.id\" label=\"Blocks\"><md-content class=\"custom-content-block md-padding\" \nlayout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/leases/tabs/sections/block/block.html\'\"></div></div></md-content></md-tab><md-tab\n ng-if=\"vm.lease.id\" label=\"Documents\"><md-content class=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\">\n<div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/leases/tabs/sections/documents/documents.html\'\"></div></div></md-content>\n</md-tab></md-tabs></md-content></div></div></div>");
$templateCache.put("app/main/farm-admin/land/ranches/tabs/tabs.html","<div ng-cloak><div id=\"tabs\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.backListing()\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-view-dashboard\" class=\"s24\"></md-icon></span><div \nclass=\"custom-font-size\"><span ng-show=\"vm.ranch.id\" translate=\"RANCHES.EDIT_RANCH\"></span> <span \nng-show=\"!vm.ranch.id\" translate=\"RANCHES.ADD_RANCH\"></span> <span>&nbsp;{{vm.ranch.name}}</span></div></div></div><div\n layout=\"row\" layout-align=\"end center\"><md-button \nng-disabled=\"(vm.informationForm.$invalid || vm.informationForm.$pristine) && vm.saveDisabled\" \nclass=\"md-raised md-background\" ng-click=\"vm.tabsSave($event)\"><span ng-show=\"vm.ranch.id\">Save</span> <span \nng-show=\"!vm.ranch.id\">Add</span></md-button></div></div></div><md-content><md-tabs md-dynamic-height md-border-bottom>\n<md-tab label=\"Information\"><md-content class=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs \nflex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/ranches/tabs/sections/information/ranch.html\'\"></div></div></md-content></md-tab>\n<md-tab md-dynamic-height label=\"Map\" ng-if=\"vm.ranch.id\"><md-content class=\"custom-content md-padding\" \nlayout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/ranches/tabs/sections/map/index.html\'\"></div></div></md-content></md-tab><md-tab \nlabel=\"Documents\" ng-if=\"vm.ranch.id\"><md-content class=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\">\n<div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/ranches/tabs/sections/documents/documents.html\'\"></div></div></md-content>\n</md-tab></md-tabs></md-content></div>");
$templateCache.put("app/main/farm-admin/land/subleases/tabs/tabs.html","<div ng-cloak><div id=\"tabs\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.backListing()\" aria-label=\"Back\"><md-icon md-font-icon=\"icon-chevron-left\" \nclass=\"icon\"></md-icon></md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs \nclass=\"logo-icon\"><md-icon md-font-icon=\"icon-satellite\" class=\"s24\"></md-icon></span><span ng-show=\"vm.sublease.id\" \nclass=\"logo-text\" translate=\"SUBLEASES.SUBLEASE_EDIT\">Subleases</span> <span ng-show=\"!vm.sublease.id\" \nclass=\"logo-text\" translate=\"SUBLEASES.SUBLEASE_ADD\">Subleases</span></div></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button \nng-disabled=\"(vm.informationForm.$invalid || vm.informationForm.$pristine) && (vm.paymentsForm.$invalid || vm.paymentsForm.$pristine)\" \nclass=\"md-raised md-background\" ng-click=\"vm.tabsSave($event)\"><span ng-show=\"vm.sublease.id\">Save</span> <span \nng-show=\"!vm.sublease.id\">Add</span></md-button></div></div><md-content><md-tabs md-dynamic-height md-border-bottom \nmd-selected=\"vm.selectedTab\"><md-tab ng-if=\"vm.sublease\" label=\"Information\"><md-content \nclass=\"custom-content md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/subleases/tabs/sections/information/information.html\'\"></div></div></md-content>\n</md-tab><md-tab ng-if=\"vm.sublease.id\" label=\"Payment Schedule\"><div class=\"custom-background\"><md-content \nclass=\"custom-content-payment md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" \nlayout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/subleases/tabs/sections/payment-schedule/payment-schedule.html\'\"></div></div>\n</md-content></div></md-tab><md-tab ng-if=\"vm.sublease.id\" label=\"Blocks\"><div class=\"custom-background\"><md-content \nclass=\"custom-content-block md-padding\" layout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\">\n<div ng-include=\"\'app/main/farm-admin/land/subleases/tabs/sections/block/block.html\'\"></div></div></md-content></div>\n</md-tab><md-tab ng-if=\"vm.sublease.id\" label=\"Documents\"><md-content class=\"custom-content md-padding\" \nlayout-xs=\"column\" layout=\"row\"><div flex-xs flex-gt-xs=\"100\" layout=\"column\"><div \nng-include=\"\'app/main/farm-admin/land/subleases/tabs/sections/documents/documents.html\'\"></div></div></md-content>\n</md-tab></md-tabs></md-content></div></div>");
$templateCache.put("app/main/farm-admin/users/farm-owner/form/step1.html","<div layout-xs=\"column\" layout-sm=\"column\" layout=\"row\" class=\"layout-row\"><md-input-container class=\"md-block\" flex>\n<label>Company Name</label><input required name=\"companyName\" ng-model=\"vm.company.name\" ng-disabled=\"vm.showCompany\" \nmd-autofocus><div ng-messages=\"vm.form.company.name.$error\"><div ng-message=\"required\">Company name is required.</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex><label>Contact Name</label><input required \nname=\"companyContactName\" ng-model=\"vm.company.contact_person\" ng-disabled=\"vm.showCompany\" md-autofocus><div \nng-messages=\"vm.form.company.contact_person.$error\"><div ng-message=\"required\">Company name is required.</div></div>\n</md-input-container></div>");
$templateCache.put("app/main/farm-admin/users/farm-owner/form/step2.html","<div layout-xs=\"column\" layout-sm=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>Email\n</label><input required name=\"companyEmail\" ng-model=\"vm.company.email_address\" ng-disabled=\"vm.showCompany\" \nmd-autofocus><div ng-messages=\"vm.form.company.email_address.$error\"><div ng-message=\"required\">Email is required.\n</div></div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Office Phone</label><input \nui-mask=\"(999) 999-9999\" placeholder=\"(999) 999-9999\" ui-mask-placeholder ui-mask-placeholder-char=\"_\" required \nname=\"companyOffice\" ng-model=\"vm.company.office_phone\" ng-disabled=\"vm.showCompany\"><div \nng-messages=\"vm.form.company.office_number.$error\"><div ng-message=\"required\">Phone is required.</div></div>\n</md-input-container></div><div layout-xs=\"column\" layout-sm=\"column\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Mobile Phone</label><input ui-mask=\"(999) 999-9999\" placeholder=\"(999) 999-9999\" \nui-mask-placeholder ui-mask-placeholder-char=\"_\" name=\"companyMobile\" ng-model=\"vm.company.cell_phone\" \nng-disabled=\"vm.showCompany\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Fax</label>\n<input ui-mask=\"(999) 999-9999\" placeholder=\"(999) 999-9999\" ui-mask-placeholder ui-mask-placeholder-char=\"_\" \nname=\"companyFax\" ng-model=\"vm.company.fax\" ng-disabled=\"vm.showCompany\"></md-input-container></div>");
$templateCache.put("app/main/farm-admin/users/farm-owner/form/step3.html","<div layout-xs=\"column\" layout-sm=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><label>\nAddress 1</label><input required name=\"companyAddress1\" ng-model=\"vm.company.address1\" ng-disabled=\"vm.showCompany\" \nmd-autofocus><div ng-messages=\"vm.form.company.address1.$error\"><div ng-message=\"required\">Address is required.</div>\n</div></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Address 2</label><input \nname=\"companyAddress2\" ng-model=\"vm.company.address2\" ng-disabled=\"vm.showCompany\"></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block padding-bottom-40\" flex-gt-sm ng-show=\"!vm.showCompany\"><label>\nCountry</label><md-select required ng-model=\"vm.company.country\"><md-option ng-repeat=\"country in vm.countries\" \nvalue=\"{{country.name}}\" ng-click=\"vm.checkIfCountryUSA(country.name)\">{{country.name}}</md-option></md-select><div \nng-messages=\"vm.form.company.country.$error\"><div ng-message=\"required\">Country is required.</div></div>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm ng-show=\"vm.stateInput\"><label>State</label><input\n required ng-model=\"vm.company.state\" ng-disabled=\"!vm.stateInput\"></md-input-container><md-input-container \nclass=\"md-block padding-bottom-40\" flex-gt-sm ng-show=\"!vm.stateInput\"><label>State</label><md-select \nng-required=\"!vm.stateInput\" ng-model=\"vm.company.state\"><md-option ng-repeat=\"state in vm.states\" \nvalue=\"{{state.abbreviation}}\">{{state.name}}</md-option></md-select><div ng-messages=\"vm.form.company.state.$error\">\n<div ng-message=\"required\">State is required.</div></div></md-input-container><md-input-container \nclass=\"md-block padding-bottom-30\" flex-gt-sm><label>City</label><input required name=\"companyCity\" \nng-model=\"vm.company.city\" ng-disabled=\"vm.showCompany\"><div ng-messages=\"form.companyCity.$error\"><div \nng-message=\"required\">City is required.</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Zip Code</label><input name=\"companyZip\" ng-model=\"vm.company.zipcode\" required \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\" ng-disabled=\"vm.showCompany\" ui-mask=\"99999\" ui-mask-placeholder \nui-mask-placeholder-char=\"_\"><div ng-messages=\"vm.form.companyZip.$error\"><div ng-message=\"required\">Zip is required.\n</div></div></md-input-container></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/phase-type/dialog/color-picker-dialog.html","<md-dialog class=\"area-dialog\" flex=\"60\" aria-label=\"New Task\"><md-toolbar class=\"md-accent md-tall\" layout=\"column\">\n<div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Change color</span><md-button class=\"md-icon-button\" ng-click=\"vm.cancel()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"AREA.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><form name=\"colorForm\"><md-dialog-content ms-scroll><div layout=\"row\" layout-align=\"center center\" flex>\n<color-picker options=\"{inputClass:\'hide\',inline:true,alpha:false,format:\'hexString\'}\" ng-model=\"vm.phase.color\">\n</color-picker><div flex><md-input-container><label>Color Code:</label><input type=\"text\" ng-model=\"vm.phase.color\" \nng-pattern=\"/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i\" required></md-input-container></div></div></md-dialog-content></form>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button ng-disabled=\"colorForm.$invalid\" class=\"md-accent md-raised md-button\" ng-click=\"vm.saveDialog()\">\nChange Color</md-button><md-button ng-click=\"vm.cancel()\">Cancel</md-button></div></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/farm-admin/work-schedule-template/phase-type/dialog/phase-name-dialog.html","<md-dialog class=\"area-dialog\" flex=\"60\" aria-label=\"New Task\"><div ng-form=\"vm.phaseNameForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"AREA.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"PHASE.NAME\"></label><input ng-model=\"vm.phase.name\" unique-value=\"vm.getPhases(vm.phase)\" name=\"phaseName\" \ntype=\"text\" required md-autofocus md-maxlength=\"50\"><div ng-messages=\"vm.phaseNameForm.phaseName.$error\" role=\"alert\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\"><span translate=\"LANDS.ERRORS.FIELD_REQUIRED\">\n</span></div><div ng-message=\"uniqueValue\"><span translate=\"PHASE.UNIQUE_VALUE\"></span></div></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label>Description</label><input \nng-model=\"vm.phase.description\" name=\"phaseDescription\" type=\"text\" md-autofocus md-maxlength=\"250\"><div \nng-messages=\"vm.phaseTypeForm.phaseDescription.$error\" role=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\"><span translate=\"LANDS.ERRORS.FIELD_REQUIRED\"></span></div><div ng-message=\"uniqueValue\"><span \ntranslate=\"PHASE.UNIQUE_VALUE\"></span></div></div></md-input-container><div layout=\"collumn\" flex><div flex=\"40\">\n<label>Color:</label></div><div flex=\"60\"><div ng-click=\"vm.openColorPicker($event,vm.phase)\" \nclass=\"badge no-text clickeable\" ng-style=\"{\'background-color\':vm.phase.color}\"></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"vm.new_phase\" ng-click=\"vm.addNewPhase()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.phaseNameForm.$invalid || vm.phaseNameForm.$pristine\" aria-label=\"Add Phase\" \ntranslate=\"PHASE.ADD_PHASE\" translate-attr-aria-label=\"PHASE.ADD_PHASE\"></md-button></div></md-dialog-actions></div>\n</md-dialog>");
$templateCache.put("app/main/farm-admin/work-schedule-template/phase-type/dialog/phase-type-dialog.html","<md-dialog class=\"area-dialog\" flex=\"60\" aria-label=\"New Task\"><div ng-form=\"vm.phaseTypeForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"AREA.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"PHASE.NAME\"></label><input ng-model=\"vm.work_schedule_type.name\" name=\"phaseName\" \nunique-value=\"vm.getPhases(vm.work_schedule_type)\" type=\"text\" required md-autofocus md-maxlength=\"50\"><div \nng-messages=\"vm.phaseTypeForm.phaseName.$error\" role=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\"><span translate=\"LANDS.ERRORS.FIELD_REQUIRED\"></span></div><div ng-message=\"uniqueValue\"><span \ntranslate=\"PHASE.UNIQUE_VALUE\"></span></div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label>Description</label><input ng-model=\"vm.work_schedule_type.description\" \nname=\"phaseDescription\" type=\"text\" md-autofocus md-maxlength=\"250\"><div \nng-messages=\"vm.phaseTypeForm.phaseDescription.$error\" role=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\"><span translate=\"LANDS.ERRORS.FIELD_REQUIRED\"></span></div><div ng-message=\"uniqueValue\"><span \ntranslate=\"PHASE.UNIQUE_VALUE\"></span></div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"vm.new_work_schedule_type\" ng-click=\"vm.addNewWorkScheduleType()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"vm.phaseTypeForm.$invalid || vm.phaseTypeForm.$pristine\" \naria-label=\"Add Phase\" translate=\"PHASE.ADD_PHASE\" translate-attr-aria-label=\"PHASE.ADD_PHASE\"></md-button></div>\n</md-dialog-actions></div></md-dialog>");
$templateCache.put("app/main/farm-admin/work-schedule-template/phase-type/form/step1.html","<div id=\"work-step\" class=\"page-layout carded\" layout=\"row\"><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content datatable\" layout=\"column\" flex><table ng-show=\"!vm.loading\" class=\"dataTable row-border hover\"><thead>\n<tr><th class=\"w-10-p\"></th><th class=\"w-40-p\">Name</th><th class=\"w-50-p\">Description</th><th></th></tr></thead>\n<tbody><tr class=\"ng-scope odd\" ng-repeat=\"phase in vm.work_schedule_types\"><td class=\"radio-icon\"><md-radio-group \nrequired ng-model=\"vm.phaseSelectedId\"><md-radio-button aria-label=\"true\" ng-value=\"phase.id\"></md-radio-button>\n</md-radio-group></td><td><md-input-container class=\"md-block\" flex-gt-sm><input unique-value=\"vm.getWorkTypes(phase)\" \nname=\"phase-type-{{$index}}\" ng-model=\"phase.name\" aria-label=\"true\" required><div \nng-messages=\"vm.step1[\'phase-type-\'+$index].$error\" class=\"md-input-messages-animation\"><div ng-message=\"required\">\n<span translate=\"LANDS.ERRORS.FIELD_REQUIRED\"></span></div><div ng-message=\"uniqueValue\"><span \ntranslate=\"PHASE.UNIQUE_VALUE\"></span></div></div></md-input-container></td><td class=\"notes\"><textarea \nclass=\"form-control expandable\" type=\"text\" ng-click=\"$event.stopPropagation()\" \nng-change=\"$event.stopPropagation(); vm.broadcast(crop)\" ng-keydown=\"$event.stopPropagation()\" maxlength=\"250\" \nng-model=\"phase.description\" rows=\"1\"></textarea></td><td><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"More\" translate=\"\" translate-attr-aria-label=\"COMPANIES.MORE\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteWorkScheduleType($event,phase)\">Delete</md-button></md-menu-item></md-menu-content></md-menu></td>\n</tr></tbody></table><md-radio-group ng-if=\"vm.work_schedule_types.length === 0\" ng-hide=\"true\" required \nng-model=\"aux\"><md-radio-button aria-label=\"true\"></md-radio-button></md-radio-group><div ng-show=\"vm.loading\"><h2>\nLoading...</h2></div></div></div></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/phase-type/form/step2.html","<div id=\"work-step\" class=\"page-layout carded\" layout=\"row\"><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"content datatable\" layout=\"column\" flex><table ng-show=\"!vm.loading\" class=\"dataTable row-border hover\"><thead>\n<tr><th class=\"w-5-p\"></th><th class=\"w-5-p\"></th><th class=\"w-5-p\">Name</th><th class=\"w-5-p\">Description</th><th>\n</th></tr></thead><tbody><tr class=\"ng-scope odd\" ng-repeat=\"phase in vm.phasesByType\"><td class=\"w-1\"><b>{{$index+1}}\n</b></td><td class=\"w-1\"><div ng-click=\"vm.openColorPicker($event,phase,vm.saveColor)\" \nclass=\"badge no-text clickeable\" ng-style=\"{\'background-color\':phase.color}\"></div></td><td><md-input-container \nclass=\"md-block\" flex-gt-sm><input unique-value=\"vm.getPhases(phase)\" ng-model=\"phase.name\" \nname=\"phase-name-{{$index}}\" aria-label=\"true\" md-autofocus required><div \nng-messages=\"vm.step2[\'phase-name-\'+$index].$error\" class=\"md-input-messages-animation\"><div ng-message=\"required\">\n<span translate=\"LANDS.ERRORS.FIELD_REQUIRED\"></span></div><div ng-message=\"uniqueValue\"><span \ntranslate=\"PHASE.UNIQUE_VALUE\"></span></div></div></md-input-container></td><td class=\"notes\"><textarea \nclass=\"form-control expandable\" type=\"text\" ng-click=\"$event.stopPropagation()\" \nng-change=\"$event.stopPropagation(); vm.broadcast(crop)\" ng-keydown=\"$event.stopPropagation()\" maxlength=\"250\" \nng-model=\"phase.description\" rows=\"1\"></textarea></td><td class=\"radio-icon\"><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"More\" translate=\"\" \ntranslate-attr-aria-label=\"COMPANIES.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.deletePhase($event,phase)\">Delete</md-button>\n</md-menu-item></md-menu-content></md-menu></td></tr></tbody></table><div ng-show=\"vm.loading\"><h2>Loading...</h2>\n</div></div></div></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-schedule-tasks/task/task.html","<div id=\"tasks\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div flex-xs=\"45\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"USERS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"TASK.TITLE\">\n</span></div></div><div flex-xs=\"55\" class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input \nid=\"search\" placeholder=\"Search for task\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"TASK.SEARCH_FOR_TASK\"></md-input-container></div></div><div \nng-show=\"vm.selectedTasks.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedTasks =[]\"><md-button layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"USERS.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"selected-users-count\"><span>{{vm.selectedTasks.length}}</span> <span translate=\"USERS.SELECTED\">selected\n</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"USERS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllUsers()\" translate=\"USERS.SELECT_ALL\">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectUsers()\" \ntranslate=\"USERS.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedTasks($event)\" \naria-label=\"delete selected\" translate translate-attr-label=\"USERS.DELETE_SELECTED\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" \nlayout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/farm-admin/work-schedule-template/work-schedule-tasks/task/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><div class=\"main constrained\"><md-list class=\"users-list\"><md-subheader class=\"md-no-sticky md-white-bg\">\n<div class=\"row-header\" layout=\"row\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" translate=\"TASK.ALL_TASK\">All tasks</span> <span \nng-if=\"vm.listType === \'all\'\" class=\"secondary-text users-count\">({{vm.shownTasks.length}}) </span><span \nng-if=\"vm.listType === \'frequent\'\" translate=\"USERS.FREQUENTLY_USERED\">Frequnetly usered</span> <span \nng-if=\"vm.listType === \'starred\'\" translate=\"USERS.STARRED_USERS\">Starred tasks</span> <span ng-if=\"vm.listType.name\">\n{{vm.listType.name}}</span> <span ng-if=\"vm.listType !== \'all\' && vm.filterIds.length\" \nclass=\"secondary-text users-count\">({{vm.filterIds.length}})</span></div><div class=\"edit-group-form\" \nng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span ng-show=\"editGroupForm.$visible\" \neditable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup($event, vm.listType)\"></span></div>\n</div></md-subheader><div class=\"content white-bg md-whiteframe-4dp\"><div><table class=\"dataTable row-border hover\" \nms-responsive-table ms-infinite-scroll=\"vm.loadMore()\" ms-infinite-scroll-container=\'\".constrained\"\'><thead><tr><th \nclass=\"secondary-text w-130\"></th><th class=\"secondary-text name\"><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"TASK.NAME\"></span></div></th><th hide-xs class=\"secondary-text company\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TASK.TASK_FOREMAN\"></span></div></th><th hide-xs hide-sm class=\"secondary-text active\">\n<div class=\"table-header\"><span class=\"column-title\" translate=\"TASK.NOTIFY_START\"></span></div></th><th hide-xs \nhide-sm class=\"secondary-text active\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TASK.NOTIFY_END\">\n</span></div></th><th hide-xs hide-sm class=\"secondary-text active\"><div class=\"table-header\"><span \nclass=\"column-title\" translate=\"TASK.DAYLIGHT_ONLY\"></span></div></th><th hide-xs hide-sm \nclass=\"secondary-text active\"><div class=\"table-header\"><span class=\"column-title\" translate=\"TASK.AUTO_START\"></span>\n</div></th><th class=\"secondary-text fix-180\"><div class=\"table-header actions\"><span class=\"column-title\" \ntranslate=\"USERS.ACTIONS\"></span></div></th></tr></thead><tbody ng-style=\"setSize(318)\" resize \nclass=\"scrollable constrained\" ms-scroll ng-if=\"!loadingData && vm.filterIds.length>0\"><tr class=\"user-table-row\" \nng-repeat=\"task in vm.shownTasks | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredUsers track by task.id | limitTo:vm.offset\" \nng-click=\"vm.openTaskDialog($event, task)\"><td class=\"w-130\"><div layout=\"row\" flex><md-checkbox flex=\"50\" \nng-checked=\"vm.exists(task, vm.selectedTasks)\" ng-click=\"vm.toggleSelectTask(task, $event)\" \naria-label=\"{{vm.exists(task, vm.selectedTasks) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><div flex=\"30\" \nclass=\"badge no-text clickeable\" ng-style=\"{\'background-color\':task.color}\"></div></div></td><td class=\"name\">\n{{ task.name }}</td><td class=\"company\" hide-xs>{{vm.getForemanName(task)}}</td><td class=\"active\" hide-sm hide-xs>\n<md-button class=\"md-icon-button\" \nng-click=\"$event.stopPropagation(); task.notify_at_start = !task.notify_at_start; vm.patchActive(user)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_ACTIVE\"><md-icon \nng-if=\"task.notify_at_start\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon \nng-if=\"!task.notify_at_start\" md-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></td><td \nclass=\"active\" hide-sm hide-xs><md-button class=\"md-icon-button\" \nng-click=\"$event.stopPropagation(); task.notify_at_end = !task.notify_at_end; vm.patchActive(user)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_ACTIVE\"><md-icon \nng-if=\"task.notify_at_end\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon \nng-if=\"!task.notify_at_end\" md-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></td><td \nclass=\"active\" hide-sm hide-xs><md-button class=\"md-icon-button\" \nng-click=\"$event.stopPropagation(); task.daylight_only = !task.daylight_only; vm.patchActive(user)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_ACTIVE\"><md-icon \nng-if=\"task.daylight_only\" md-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon \nng-if=\"!task.daylight_only\" md-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></td><td \nclass=\"active\" hide-sm hide-xs><md-button class=\"md-icon-button\" \nng-click=\"$event.stopPropagation(); task.auto_start = !task.auto_start; vm.patchActive(user)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_ACTIVE\"><md-icon ng-if=\"task.auto_start\" \nmd-font-icon=\"icon-checkbox-marked-circle\" class=\"green-500-fg\"></md-icon><md-icon ng-if=\"!task.auto_start\" \nmd-font-icon=\"icon-close-circle\" class=\"red-500-fg\"></md-icon></md-button></td><td class=\"actions fix-180\"><md-button \nclass=\"md-icon-button hide show-gt-xs\" \nng-click=\"$event.stopPropagation();vm.toggleInArray(task.id, vm.starredTasks);vm.patchStarred(task)\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"USERS.TOGGLE_STARRED\"><md-icon ng-if=\"task.starred\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!task.starred\" md-font-icon=\"icon-star-outline\">\n</md-icon></md-button><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"USERS.MORE\" ng-click=\"$mdMenu.open($event)\"><md-icon ng-disable=\"finishUpdate\" \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content class=\"md-menu-min-height\" width=\"4\">\n<v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane ng-if=\"vm.allRolesGroups\"><v-pane-header \nclass=\"no-border\"><md-list-item>Foreman</md-list-item></v-pane-header><v-pane-content><md-list><md-list-item \nng-if=\"vm.allRolesGroups\" ng-repeat=\"group in vm.allRolesGroups\" ng-click=\"vm.patchRoleGroup(task, group)\" \nng-class=\"{\'header-color\':group.id == task.user_role_id ,\'fw-500\':group.id == task.user_role_id }\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item></md-list></v-pane-content></v-pane><v-pane ng-if=\"vm.allNotifyGroups\"><v-pane-header \nclass=\"no-border\"><md-list-item>Notify Groups</md-list-item></v-pane-header><v-pane-content><md-list><md-list-item \nng-if=\"vm.allNotifyGroups\" ng-repeat=\"group in vm.allNotifyGroups\" ng-click=\"vm.patchNotifyGroup(task, group)\" \nng-class=\"{\'header-color\':vm.exists(group.id, task.ng),\'fw-500\':vm.exists(group.id, task.ng)}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item></md-list></v-pane-content></v-pane></v-accordion></md-menu-content></md-menu></td>\n</tr></tbody></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\">\n<ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && filteredUsers.length === 0\"><p class=\"padding-left-8\" translate=\"USERS.NO_RESULTS\">\nNo results...</p></md-list-item></div></div></md-list></div></div><md-button show-xs show-sm hide-gt-sm \nclass=\"md-fab md-fab-bottom-right md-accent md-icon-button\" id=\"add-user-button-mobile\" \nng-click=\"vm.openTaskDialog($event,{})\" aria-label=\"add user\" translate translate-attr-aria-label=\"USERS.ADD_USER\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button hide-xs hide-sm show-gt-sm \nclass=\"md-fab md-accent md-icon-button add-icon-large\" id=\"add-user-button\" ng-click=\"vm.openTaskDialog($event,{})\" \naria-label=\"add user\" translate translate-attr-aria-label=\"USERS.ADD_USER\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-schedule-tasks/timeline-placeholders/timeline-placeholders.html","<div id=\"anchor-definition\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between center\"><div flex-xs=\"45\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"USERS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span hide-xs hide-sm class=\"logo-icon\"><md-icon\n md-font-icon=\"icon-account-multiple\" class=\"s24\"></md-icon></span><span class=\"logo-text\" \ntranslate=\"ANCHORTYPE.TITLE\"></span></div></div><div><md-button class=\"md-raised md-background\" id=\"save-land-button\" \nng-disabled=\"vm.invalidForm()\" ng-click=\"vm.save($event)\"><span aria-label translate=\"LANDS.SAVE\"></span></md-button>\n</div></div><div class=\"content\" md-background-bg layout=\"row\" layout-align=\"start start\"><div \nclass=\"main constrained\"><md-list layout-fill class=\"users-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div \nclass=\"row-header\" layout=\"row\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\"><span \ntranslate=\"ANCHORTYPE.TITLE\"></span></div></div></md-subheader><div><ul ng-show=\"vm.getWetDateAnchor().length!=1\" \nstyle=\"background-color: #ffe8a7\" class=\"margin-0 padding-left-15 clickeable animated drag-task-item\" layout=\"row\" \nflex layout-align=\"left center\"><p role=\"alert\" class=\"margin-left-20\">\nThe anchor definition must have one and only one wet date anchor</p></ul><ul \nng-show=\"vm.getHarvestDateAnchor().length!=1\" style=\"background-color: #ffe8a7\" \nclass=\"margin-0 padding-left-15 clickeable animated drag-task-item\" layout=\"row\" flex layout-align=\"left center\"><p \nrole=\"alert\" class=\"margin-left-20\">The anchor definition must have one and only one harvest date anchor</p></ul></div>\n<div class=\"content white-bg md-whiteframe-4dp\"><div style=\"padding-top: 40px\" layout-align=\"center center\" \nclass=\"headers\" flex layout=\"row\"><div flex=\"20\" layout=\"row\" layout-align=\"center center\">Name</div><div flex=\"10\" \nlayout=\"row\" layout-align=\"center center\">Short Code</div><div flex=\"50\" layout=\"row\" layout-align=\"center center\">Type\n</div><div flex=\"10\" layout=\"row\" layout-align=\"center center\">Repeats</div><div flex=\"10\" layout=\"row\" \nlayout-align=\"center center\">Actions</div></div><form name=\"anchorForm\"><div \nng-repeat=\"anchor in vm.anchorDefinitions\"><div layout-align=\"center center\" class=\"\" flex layout=\"row\"><div flex=\"20\" \nlayout=\"row\" layout-align=\"center center\"><md-input-container style=\"margin-bottom: 0px\"><input placeholder=\"Name\" \nng-model=\"anchor.name\"></md-input-container></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\">\n<md-input-container style=\"margin-bottom: 0px\"><input placeholder=\"Short Code\" ng-model=\"anchor.shortCode\">\n</md-input-container></div><div flex=\"50\" layout=\"row\" layout-align=\"center center\"><md-input-container flex=\"100\">\n<label>Anchor Type</label><md-select required ng-change=\"vm.checkAnchorType($event,anchor)\" \nng-model=\"anchor.typeSelection\" placeholder=\"Anchor Type\"><md-option value=\"wetDate\">Wet Date</md-option><md-option \nvalue=\"harvestDate\">Harvest Date</md-option><md-option value=\"assignAnchorDate\">Assign Anchor Date</md-option>\n<md-option value=\"preAnchor\">Pre Anchor</md-option><md-option value=\"postDate\">Post Anchor</md-option><md-option \nvalue=\"normal\">Normal</md-option></md-select></md-input-container></div><div flex=\"10\" layout=\"row\" \nlayout-align=\"center center\"><md-switch ng-disabled=\"anchor.preAnchor == false && anchor.postDate == false\" \nng-model=\"anchor.repeats\"></md-switch></div><div flex=\"10\" layout=\"row\" layout-align=\"center center\"><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"More\" translate=\"\" \ntranslate-attr-aria-label=\"COMPANIES.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.delete($event,anchor)\">Delete</md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div style=\"margin-left:40px\"><div class=\"danger\" role=\"alert\" \nng-if=\"vm.checkAttrAndOther(anchor,\'wetDate\',[\'harvestDate\',\'assignAnchorDate\',\'preAnchor\',\'postDate\',\'repeats\',\'display\'])\">\n<span>*The definition cannot have wet date and other type</span></div><div class=\"danger\" role=\"alert\" \nng-if=\"vm.checkAttrAndOther(anchor,\'harvestDate\',[\'wetDate\',\'assignAnchorDate\',\'preAnchor\',\'postDate\',\'repeats\',\'display\'])\">\n<span>*The definition cannot have harvest date and other type</span></div><div class=\"danger\" role=\"alert\" \nng-if=\"vm.checkAttrAndOther(anchor,\'assignAnchorDate\',[\'wetDate\',\'harvestDate\',\'preAnchor\',\'postDate\',\'repeats\'])\">\n<span>*The definition cannot have assign anchor date and other type (except display)</span></div><div class=\"danger\" \nrole=\"alert\" ng-if=\"anchor.assignAnchorDate && !anchor.display\"><span>\n*The definition for Assign anchor date must have display field too</span></div><div class=\"danger\" role=\"alert\" \nng-if=\"anchor.preAnchor && anchor.postAnchor\"><span>*The definition must be Pre anchor or Post Anchor, not both</span>\n</div></div></div></form></div><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" \nlayout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && filteredUsers.length === 0\"><p class=\"padding-left-8\" translate=\"USERS.NO_RESULTS\">\nNo results...</p></md-list-item></md-list></div></div><md-button hide-xs hide-sm show-gt-sm \nclass=\"md-fab md-accent md-icon-button add-icon-large\" id=\"add-user-button\" ng-click=\"vm.addNewAnchorDefinition()\" \naria-label=\"add user\" translate translate-attr-aria-label=\"USERS.ADD_USER\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-template/dialog/clone-task-dialog.html","<md-dialog aria-label=\"New Task\"><div ng-form=\"vm.CloneDialogForm\" class=\"md-inline-form\" novalidate><md-toolbar \nclass=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">Clone</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"AREA.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex>\n<md-input-container flex=\"50\"><label>Copy</label><input required ng-model=\"vm.work_template.name\" disabled=\"disabled\">\n</md-input-container><md-input-container flex=\"50\"><label>To</label><input name=\"cloneName\" \nunique-value=\"vm.getWorkTemplates()\" required ng-model=\"vm.new_work_template.name\"><div \nng-messages=\"vm.CloneDialogForm.cloneName.$error\" role=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\"><span translate=\"LANDS.ERRORS.FIELD_REQUIRED\"></span></div><div ng-message=\"uniqueValue\"><span \ntranslate=\"PHASE.UNIQUE_VALUE\"></span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-disabled=\"vm.CloneDialogForm.$invalid\" type=\"submit\" ng-click=\"vm.clone()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.CloneDialogForm.$invalid || vm.CloneDialogForm.$pristine\" aria-label=\"Add Task\">CLONE</md-button></div>\n</md-dialog-actions></div></md-dialog>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-template/dialog/task-dialog.html","<md-dialog flex=\"50\" aria-label=\"New Task\"><div ng-form=\"vm.TaskDialogForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.cancelDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"AREA.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" \nflex><md-input-container flex><label translate=\"WORK_TEMPLATE.DIALOG_NAME\"></label><input required \nng-model=\"vm.work_template.name\"></md-input-container></div><div layout=\"row\" flex><md-input-container flex><label>\nSelect a Season</label><md-select required ng-model=\"vm.work_template.season_id\"><md-option \nng-repeat=\"season in vm.seasons\" ng-value=\"season.id\">{{season.name}}</md-option></md-select></md-input-container>\n</div><div layout=\"row\" flex><md-input-container flex><label>Select a Phase Type</label><md-select required \nng-model=\"vm.work_template.phase_type_id\"><md-option ng-repeat=\"phase in vm.phase_types\" ng-value=\"phase.id\">\n{{phase.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex><md-input-container flex>\n<label>Select a Seed</label><md-select required ng-model=\"vm.work_template.seed_id\"><md-option \nng-repeat=\"seed in vm.seeds\" ng-value=\"seed.id\">{{seed.name}}</md-option></md-select></md-input-container></div><div \nlayout=\"collumn\" flex><div flex=\"40\"><label>Color:</label></div><div flex=\"60\"><div \nng-click=\"vm.openColorPicker($event,vm.work_template)\" class=\"badge no-text clickeable\" \nng-style=\"{\'background-color\':vm.work_template.color}\"></div></div></div><div layout=\"row\" flex><md-input-container \nflex><md-switch ng-model=\"vm.work_template.active\" aria-label=\"Switch 1\">Active</md-switch></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button ng-disabled=\"vm.TaskDialogForm.$invalid\" type=\"submit\" \nng-if=\"vm.new_work_template\" ng-click=\"vm.addNewWorkTemplate()\" class=\"send-button md-accent md-raised\" \naria-label=\"Add Phase\" translate=\"WORK_TEMPLATE.ADD\" translate-attr-aria-label=\"WORK_TEMPLATE.ADD\"></md-button>\n<md-button ng-disabled=\"vm.TaskDialogForm.$invalid\" type=\"submit\" ng-if=\"!vm.new_work_template\" ng-click=\"vm.editWT()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Add Phase\" translate=\"WORK_TEMPLATE.EDIT\" \ntranslate-attr-aria-label=\"WORK_TEMPLATE.EDIT\"></md-button></div></md-dialog-actions></div></md-dialog>");
$templateCache.put("app/main/pages/auth/login/dialogs/background_crop.html","<md-dialog layout-padding=\"\"><md-dialog-content><div layout=\"column\"><div flex><h3 class=\"text-center\">Crop the image\n</h3></div></div><div layout=\"column\" layout-align=\"center center\"><div class=\"crop-area\" flex><ui-cropper \narea-type=\"square\" style=\"width:300px;height:300px\" class=\"crop-image\" image=\"vm.picFile | ngfDataUrl\" \narea-min-size=\"250\" result-image-quality=\"1\" result-image=\"crop_image\"></ui-cropper></div></div><div flex \nlayout=\"column\"><div layout=\"row\" layout-align=\"center center\" flex><div flex><md-dialog-actions layout=\"row\">\n<md-button ng-click=\"confirm()\" md-autofocus>Confirm</md-button><md-button ng-click=\"cancel()\">Cancel</md-button>\n</md-dialog-actions></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/pages/auth/login/dialogs/background_dialog.html","<md-dialog class=\"background-dialog\" aria-label=\"New Task\"><form name=\"LoginForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\">Change Background</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex layout=\"column\" \nlayout-align=\"center center\"><div name=\"file\" class=\"clickeable\" ngf-select=\"vm.openBackDialog($event, $file);\" \nngf-max-size=\"10MB\" ng-model=\"vm.picFile\" accept=\"\'image/*\'\" \nngf-resize=\"{width: vm.sizeImg.width, height: vm.sizeImg.height}\" ngf-before-model-change=\"vm.invalidImage($files)\" \nngf-min-width=\"vm.sizeImg.width\" ngf-min-height=\"vm.sizeImg.height\" layout=\"column\" layout-align=\"center center\" \nngf-model-invalid=\"invalidFiles\"><md-tooltip md-direction=\"top\"><span>Click to search an image</span></md-tooltip>\n<span><b>Minimun required size:</b> {{vm.sizeImg.width}}x{{vm.sizeImg.height}} pixels</span><ms-loader \nng-if=\"!vm.background.loaded\" class=\"float-right\"></ms-loader><img ng-show=\"vm.background.loaded\" \nmsload=\"vm.background.loaded = true\" http-src=\"{{vm.background.image_url}}\" class=\"md-avatar\" alt=\"Background\"> <span \nng-if=\"invalidFiles.$error === \'minWidth\' || invalidFiles.$error === \'minHeight\'\" class=\"danger-image\"><b>\nInvalid image:</b></span> <span ng-if=\"invalidFiles.$errorMessages.minHeight\" class=\"danger-image-sub\">\nHeight: {{invalidFiles.$ngfHeight}}px</span> <span ng-if=\"invalidFiles.$errorMessages.minWidth\" \nclass=\"danger-image-sub\">Width: {{invalidFiles.$ngfWidth}}px</span> <span ng-if=\"invalidFiles.$error === \'maxSize\'\" \nclass=\"danger-image-sub\">Max file size 10MB</span></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveBackground()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\" translate=\"LOGIN.SAVE\" \ntranslate-attr-aria-label=\"LOGIN.SAVE\">SAVE</md-button></div><div class=\"pr-15\" layout=\"row\"><md-button \nng-click=\"vm.closeDialog()\" class=\"send-button md-raised\" aria-label=\"CANCEL\" translate=\"LOGIN.CANCEL\" \ntranslate-attr-aria-label=\"LOGIN.CANCEL\">CANCEL</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/contracts/dialogs/contract/contract-dialog.html","<md-dialog class=\"contract-dialog\" aria-label=\"New Task\"><form name=\"contractForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTRACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div ng-if=\"vm.contract.number\" \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"contract-name\">{{vm.contract.number}}</div></div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleStarred()\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"CONTRACTS.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.contract.starred\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.contract.starred\" \nmd-font-icon=\"icon-star-outline\"></md-icon></md-button></div></div></md-toolbar><md-dialog-content ms-scroll><div \nflex=\"95\" layout=\"column\" layout-align=\"start\"><md-input-container class=\"md-icon-float md-block\"><div \nclass=\"signature\"><label for=\"signature\" translate=\"CONTRACTS.CONTRACT_NUMBER\"></label></div><md-icon \nmd-font-icon=\"icon-numeric\" class=\"name\"></md-icon><input ng-model=\"vm.contract.number\" type=\"text\" required \nmd-autofocus><div ng-messages=\"vm.form.contract.number.$error\"><div ng-message=\"required\">Contract Number is required.\n</div></div></md-input-container><md-input-container class=\"padding-bottom-20\" class=\"md-block\" flex-gt-sm><div \nclass=\"signature\"><label for=\"signature\" translate=\"CONTRACTS.SHIPPER\"></label></div><md-icon md-font-icon=\"icon-city\" \nclass=\"name\"></md-icon><md-select required ng-model=\"vm.contract.company_id\"><md-option \nng-repeat=\"shipper in vm.shippers\" value=\"{{shipper.id}}\">{{shipper.name}}</md-option></md-select><div \nng-messages=\"vm.form.contract.company_id.$error\"><div ng-message=\"required\">Shipper is required.</div></div>\n</md-input-container><md-input-container class=\"md-block padding-top-5\"><div class=\"signature\"><label for=\"signature\" \ntranslate=\"CONTRACTS.ACRES\"></label></div><md-icon md-font-icon=\"icon-pine-tree\"></md-icon><input aria-label=\"acres\" \nng-model=\"vm.contract.acres\" currency-input=\"acres\" onfocus=\"placeholder=\'Max: 9,999.9\'\" onblur=\"placeholder=\'\'\" \ntype=\"text\"></md-input-container><md-input-container class=\"md-block dates\" flex-gt-sm><div class=\"signature\"><label \nfor=\"signature\">Enter Signature date</label></div><md-datepicker md-open-on-focus \nng-model=\"vm.contract.signature_date\" required></md-datepicker></md-input-container><md-input-container \nclass=\"md-block dates\" flex-gt-sm><div class=\"signature\"><label for=\"signature\">Enter Start date</label></div>\n<md-datepicker md-open-on-focus ng-model=\"vm.contract.start_date\" required></md-datepicker></md-input-container>\n<md-input-container class=\"md-block dates\" flex-gt-sm><div class=\"signature\"><label for=\"signature\">Enter End date\n</label></div><md-datepicker md-open-on-focus ng-model=\"vm.contract.end_date\" required></md-datepicker>\n</md-input-container><md-input-container class=\"padding-bottom-25\" class=\"md-block\" flex-gt-sm><div class=\"signature\">\n<label for=\"signature\">Payment Terms</label></div><md-icon md-font-icon=\"icon-document\" class=\"name\"></md-icon>\n<md-select required ng-model=\"vm.contract.payment_finance_terms\"><md-option \nng-repeat=\"payment in vm.payment_finance_terms\" value=\"{{payment}}\">{{payment}}</md-option></md-select><div \nng-messages=\"vm.form.contract.payment_finance_terms.$error\"><div ng-message=\"required\">Payment terms is required.</div>\n</div></md-input-container><md-input-container class=\"md-icon-float md-block\"><div class=\"signature\"><label \nfor=\"signature\" translate=\"CONTRACTS.CONTRACT_AMOUNT\"></label></div><md-icon md-font-icon=\"icon-square-inc-cash\" \nclass=\"name\"></md-icon><input aria-label=\"Contract Amount\" ng-model=\"vm.contract.amount\" required \ncurrency-input=\"money\" onfocus=\"placeholder=\'Max: 9,999,999.99\'\" onblur=\"placeholder=\'\'\" type=\"text\"><div \nng-messages=\"vm.form.contract.amount.$error\"><div ng-message=\"required\">Contract amount is required.</div></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><div class=\"signature\"><label for=\"signature\" \ntranslate=\"CONTRACTS.INCENTIVE_AMOUNT\"></label></div><md-icon md-font-icon=\"icon-square-inc-cash\" class=\"name\">\n</md-icon><input aria-label=\"Incentive Amount\" ng-model=\"vm.contract.incentive_amount\" required currency-input=\"money\" \nonfocus=\"placeholder=\'Max: 9,999,999.99\'\" onblur=\"placeholder=\'\'\" type=\"text\"><div \nng-messages=\"vm.form.contract.incentive_amount.$error\"><div ng-message=\"required\">Incentive amount is required.</div>\n</div></md-input-container><md-input-container class=\"md-icon-float md-block\"><div class=\"signature\"><label \ntranslate=\"CONTRACTS.DESCRIPTION\"></label></div><md-icon md-font-icon=\"icon-note\"></md-icon><textarea \naria-label=\"Description\" ng-model=\"vm.contract.description\" type=\"text\" max-rows=\"4\"></textarea></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.addNewContract()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contractForm.$invalid || contractForm.$pristine\" \naria-label=\"Add Contract\" translate=\"CONTRACTS.ADD_CONTRACT\" translate-attr-aria-label=\"CONTRACTS.ADD_CONTRACT\">\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/contracts/dialogs/crop/crop-dialog.html","<md-dialog class=\"contracted-crop-dialog\" aria-label=\"New Task\"><form name=\"cropForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"CONTRACTS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div flex layout=\"column\" layout-padding><section><md-input-container \nclass=\"md-icon-float md-block padding-top-0 margin-top-0 padding-bottom-25\" ng-if=\"!vm.crop.id\"><div class=\"signature\">\n<label for=\"signature\">Seed</label></div><md-icon md-font-icon=\"icon-barley\" class=\"name\"></md-icon><md-select \nname=\"seed\" required ng-model=\"vm.crop.seed_id\"><md-option ng-repeat=\"seed in vm.seeds\" ng-value=\"{{seed.id}}\">\n{{seed.name}}</md-option></md-select><div class=\"select-error\" ng-messages=\"cropForm.seed.$error\" role=\"alert\"><div \nclass=\"error-message\" ng-message=\"required\">Seed field is required.</div></div></md-input-container><md-input-container\n class=\"md-block padding-top-0 margin-top-0\" flex-gt-sm ng-if=\"vm.crop.id\"><label>Seed</label><md-icon \nmd-font-icon=\"icon-map-marker-radius\" class=\"name\"></md-icon><input aria-label=\"Seed\" ng-readonly=\"true\" \ndisabled=\"disabled\" name=\"seed\" ng-model=\"vm.crop.seed.name\" md-autofocus></md-input-container></section><section>\n<md-input-container class=\"md-icon-float md-block padding-top-0 margin-top-0\"><div class=\"signature\"><label \nfor=\"signature\" translate=\"CONTRACTS.CROPS.AMOUNT_PER_ACRE\"></label></div><md-icon md-font-icon=\"icon-square-inc-cash\" \nclass=\"name\"></md-icon><input name=\"amount_per_acre\" aria-label=\"Crop Amount Per Acre\" type=\"text\" \nng-model=\"vm.crop.amount_per_acre\" currency-input=\"money\" onfocus=\"placeholder=\'Max: 9,999,999.99\'\" \nonblur=\"placeholder=\'\'\"></md-input-container></section><section><md-input-container \nclass=\"md-icon-float md-block margin-top-0 padding-top-0\"><div class=\"signature\"><label for=\"signature\" \ntranslate=\"CONTRACTS.CROPS.INCENTIVE_PER_ACRE\"></label></div><md-icon md-font-icon=\"icon-square-inc-cash\" class=\"name\">\n</md-icon><input name=\"incentive_per_acre\" type=\"text\" aria-label=\"Crop Incentive Per Acre\" \nng-model=\"vm.crop.incentive_amount_per_acre\" currency-input=\"money\" onfocus=\"placeholder=\'Max: 9,999,999.99\'\" \nonblur=\"placeholder=\'\'\"></md-input-container></section><section><md-input-container \nclass=\"md-icon-float md-block margin-top-0 padding-top-0\"><div class=\"signature\"><label for=\"signature\" \ntranslate=\"CONTRACTS.CROPS.NOTES\"></label></div><md-icon md-font-icon=\"icon-note\"></md-icon><textarea \naria-label=\"Description\" ng-model=\"vm.crop.description\" type=\"text\" max-rows=\"4\" maxlength=\"250\" md-maxlength=\"250\">\n</textarea></md-input-container></section></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.saveCrop()\" class=\"send-button md-accent md-raised\" ng-disabled=\"cropForm.$invalid || cropForm.$pristine\" \naria-label=\"Save Crop\" translate=\"CONTRACTS.CROPS.SAVE_CROP\" translate-attr-aria-label=\"CONTRACTS.CROPS.SAVE_CROP\">\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/contracts/dialogs/grower-dates/grower-dates-dialog.html","<md-dialog class=\"grower-scheduled-date-dialog\" aria-label=\"New Task\"><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTRACTS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div \nclass=\"content white-bg md-whiteframe-4dp\"><div><table class=\"dataTable row-border hover\"><thead><tr><th class=\"block\">\n<div class=\"table-header text-center\"><span class=\"column-title\" translate=\"CONTRACTS.VARIETIES.BLOCK\"></span></div>\n</th><th class=\"acres\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"CONTRACTS.VARIETIES.SCHEDULED_ACRES\"></span></div></th><th class=\"wet-date\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"CONTRACTS.VARIETIES.SCHEDULED_WET_DATE\"></span>\n</div></th><th class=\"growing-days\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"CONTRACTS.VARIETIES.GROWING_DAYS\"></span></div></th><th class=\"harvest-date\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"CONTRACTS.VARIETIES.HARVEST_DATE\"></span></div>\n</th></tr></thead><tbody class=\"scrollable\" ms-scroll ng-if=\"!loadingDataCrop\" ng-style=\"setSize(630)\" resize><tr \nclass=\"md-white-bg\" ng-repeat=\"growerDate in vm.growerDates\"><td class=\"block-td text-center\">\n{{growerDate.grower_block.block.name}}</td><td class=\"acres text-center\">{{growerDate.scheduled_acres}}</td><td \nclass=\"wet-date text-center\">{{growerDate.scheduled_wet_date | date: \'mediumDate\' }}</td><td \nclass=\"growing-days-td text-left\">{{growerDate.original_growing_days}}</td><td class=\"harvest-date text-center\">\n{{growerDate.scheduled_harvest_date | date: \'mediumDate\' }}</td></tr></tbody></table></div></div></md-dialog-content>\n</md-dialog>");
$templateCache.put("app/main/pages/contracts/dialogs/variety/variety-dialog.html","<md-dialog class=\"variety-dialog\" aria-label=\"New Task\"><form name=\"varietyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTRACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex \nlayout=\"column\" layout-padding><section flex><md-input-container \nclass=\"md-block margin-top-0 padding-top-0 padding-bottom-15 margin-bottom-0\"><div class=\"signature\"><label \ntranslate=\"CONTRACTS.VARIETIES.SHIPPER_WET_DATE\"></label></div><md-datepicker md-open-on-focus \nng-model=\"vm.contract_schedule_variety.original_wet_date\" \nng-change=\"vm.setMinDate(\'original\');\n													 vm.calculateGrowingDays(\'wet_date\');\n													 vm.filterVarietiesByWetDate()\" \nmd-date-locale=\"customDateFormat\" name=\"original_wet_date\" md-open-on-focus required></md-datepicker><div \nng-messages=\"varietyForm.original_wet_date.$error\"><div class=\"error-message datepicker\" ng-message=\"required\">\nEstimated Wet Date field is required.</div></div></md-input-container></section><section><md-input-container \nclass=\"md-icon-float md-block margin-top-0 padding-top-0\" flex-gt-sm=\"95\"><label \ntranslate=\"CONTRACTS.VARIETIES.SHIPPER_GROWING_DAYS\"></label><md-icon md-font-icon=\"icon-leaf\"></md-icon><input \ntype=\"text\" name=\"original_growing_days\" aria-label=\"Growing Days\" currency-input=\"integerFourNum\" \nng-model=\"vm.contract_schedule_variety.original_growing_days\" ng-model-options=\"{ debounce: 500 }\" \nng-change=\"vm.calculateGrowingDays(\'growing_days\')\" onfocus=\"placeholder=\'Max: 9,999\'\" onblur=\"placeholder=\'\'\" \nlimit-to=\"4\" required><div ng-messages=\"varietyForm.original_growing_days.$error\" role=\"alert\"><div \nclass=\"error-message\" ng-message=\"required\">Growing Days field is required.</div><div class=\"error-message\" \nng-message=\"number\">Growing Days field must be a valid number.</div><div class=\"error-message\" ng-message=\"min\">\nGrowing Days field must be greater or equal than 0.</div></div></md-input-container></section><section>\n<md-input-container class=\"md-block margin-top-0 padding-top-0 margin-bottom-0\"><div class=\"signature\"><label \ntranslate=\"CONTRACTS.VARIETIES.SHIPPER_HARVEST_DATE\"></label></div><md-datepicker md-open-on-focus \nng-model=\"vm.contract_schedule_variety.original_harvest_date\" md-min-date=\"vm.min_original_harvest_date\" \nng-change=\"vm.calculateGrowingDays(\'harvest_date\')\" name=\"original_harvest_date\" md-date-locale=\"customDateFormat\" \nmd-open-on-focus required></md-datepicker><div ng-messages=\"varietyForm.original_harvest_date.$error\"><div \nclass=\"error-message datepicker\" ng-message=\"required\">Estimated Harvest Date field is required.</div></div>\n</md-input-container></section><section><md-input-container class=\"md-block padding-bottom-25 margin-bottom-15\" \nflex-gt-sm=\"95\"><label translate=\"CONTRACTS.VARIETIES.VARIETY\"></label><md-icon md-font-icon=\"icon-barley\" \nclass=\"name\"></md-icon><md-select name=\"variety_id\" ng-model=\"vm.contract_schedule_variety.variety_id\"><md-option \nng-if=\"vm.varieties.length === 0\" ng-click=\"vm.redirectToSeed()\"><span>There are no varieties to show<br>\nGo to Seed page</span></md-option><md-option ng-if=\"vm.varieties.length > 0\" ng-repeat=\"variety in vm.varieties\" \nng-value=\"{{variety.id}}\">{{variety.name}}</md-option></md-select></md-input-container></section><section>\n<md-input-container class=\"md-block margin-top-0 padding-top-0\" flex-gt-sm=\"95\"><label \ntranslate=\"CONTRACTS.VARIETIES.ACRES\"></label><md-icon md-font-icon=\"icon-pine-tree\"></md-icon><input required \nname=\"acres\" onfocus=\"placeholder=\'Max: 9,999.9\'\" onblur=\"placeholder=\'\'\" \nng-blur=\"aux=vm.contract_schedule_variety.acres\" aria-label=\"acres\" ng-model=\"vm.contract_schedule_variety.acres\" \ncurrency-input=\"acres\" type=\"text\"><div ng-messages=\"varietyForm.acres.$error\"><div class=\"error-message\" \nng-message=\"required\">Acres field is required.</div></div></md-input-container></section></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.saveVariety()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"varietyForm.$invalid || varietyForm.$pristine\" aria-label=\"Save Variety\" \ntranslate=\"CONTRACTS.VARIETIES.SAVE_VARIETY\" translate-attr-aria-label=\"CONTRACTS.VARIETIES.SAVE_VARIETY\"></md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/contracts/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">Contract Filter</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list-item aria-label=\"filter-all\" \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTRACTS.ALL_CONTRACTS\">\n</p></md-list-item><md-list-item aria-label=\"filter-starred\" ng-click=\"vm.filterChange(\'starred\')\" \nng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p translate=\"CONTRACTS.STARRED_CONTRACTS\"></p></md-list-item>\n<md-divider ng-if=\"vm.shippers.length\"></md-divider><v-accordion ng-if=\"vm.shippers.length\" \nclass=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header><md-list-item>Shipper</md-list-item>\n</v-pane-header><v-pane-content><md-list-item ng-if=\"vm.shippers.length\" ng-repeat=\"sh in vm.shippers\" \nng-click=\"vm.filterChange(\'shipper\', sh)\" ng-class=\"{\'selected\':vm.listType.name === sh.name}\"><p class=\"pl-8\">\n{{sh.name }}</p></md-list-item></v-pane-content></v-pane></v-accordion></div>");
$templateCache.put("app/main/pages/grower-schedule/dialogs/planting-report/planting-report-dialog.html","<md-dialog class=\"planting-report-dialog\" aria-label=\"New Task\"><form name=\"plantReportForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"BLOCKS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"GROWER_SCHEDULE.BED_SIZE\"></label><md-icon md-font-icon=\"icon-format-line-spacing\"></md-icon><input \ncurrency-input=\"integer\" aria-label=\"bed size\" name=\"bed_size\" ng-model=\"vm.planting_report.bed_size\" required \ntype=\"text\" val-min=\"1\" autofocus><div ng-messages=\"plantReportForm.bed_size.$error\" role=\"alert\"><div \nclass=\"error-message\" ng-message=\"required\">Bed Size field is required</div><div class=\"error-message\" \nng-message=\"bed_size\">Bed Size field must be greater than 0</div></div></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"GROWER_SCHEDULE.BLOCK_BED_COUNT\"></label><md-icon \nmd-font-icon=\"icon-numeric\"></md-icon><input currency-input=\"integer\" aria-label=\"block bed count\" name=\"bed_count\" \nng-model=\"vm.planting_report.block_bed_count\" required type=\"text\" val-min=\"1\"><div \nng-messages=\"plantReportForm.bed_count.$error\" role=\"alert\"><div class=\"error-message\" ng-message=\"required\">\nBlock Bed Count field is required</div><div class=\"error-message\" ng-message=\"bed_count\">\nBlock Bed Count field must be greater than 0</div></div></md-input-container><div ng-if=\"vm.showAllFields\">\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"GROWER_SCHEDULE.PLANT_LINES_PER_BED\"></label><md-icon\n md-font-icon=\"icon-numeric\"></md-icon><input currency-input=\"integer\" aria-label=\"planting lines\" name=\"plant_lines\" \nng-model=\"vm.planting_report.plant_lines\" required type=\"text\" val-min=\"1\"><div \nng-messages=\"plantReportForm.plant_lines.$error\" role=\"alert\"><div class=\"error-message\" ng-message=\"required\">\nPlant Lines Per Bed field is required</div><div class=\"error-message\" ng-message=\"plant_lines\">\nPlant Lines Per Bed field must be greater than 0</div></div></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"GROWER_SCHEDULE.ASSIGN_PCA\"></label><md-icon md-font-icon=\"icon-city\" class=\"name\">\n</md-icon><md-select name=\"pca_id\" required ng-model=\"vm.planting_report.pca_id\"><md-option \nng-repeat=\"user in vm.pca_users\" value=\"{{user.id}}\">{{user.name}}</md-option></md-select><div \nng-messages=\"plantReportForm.pca_id.$error\" role=\"alert\"><div class=\"error-message\" ng-message=\"required\">\nPCA field is required</div></div></md-input-container><md-divider \nng-class=\"{\'padding-bottom-15\': vm.planting_report.week_ending}\"></md-divider><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"GROWER_SCHEDULE.WEEK_ENDING\"></label><md-icon md-font-icon=\"icon-calendar-today\">\n</md-icon><input aria-label=\"planting lines\" name=\"plant_lines\" ng-model=\"vm.planting_report.week_ending\" type=\"text\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"GROWER_SCHEDULE.SEASON\"></label><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><input \naria-label=\"planting lines\" name=\"plant_lines\" ng-model=\"vm.planting_report.season\" type=\"text\" disabled=\"disabled\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"plantReportForm.$invalid || plantReportForm.$pristine\" \naria-label=\"SAVE\" translate=\"GROWER_SCHEDULE.SAVE\" translate-attr-aria-label=\"GROWER_SCHEDULE.SAVE\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/grower-schedule/dialogs/show-errors/show-errors-dialog.html","<md-dialog class=\"show-errors-dialog\" aria-label=\"New Task\" draggable><form name=\"showErrorsForm\" \nclass=\"md-inline-form\" novalidate><md-dialog-content ms-scroll><div ng-if=\"vm.gs\" class=\"errors-container\"><span \nclass=\"main-title\">There are some errors that need to be checked before Shipper Contract can be scheduled:</span><div \nng-if=\"vm.gs.wet_date_error || vm.gs.wet_date_variety_error || vm.gs.last_harvest_date_error || vm.gs.wet_date_fiscal_year_error || vm.gs.wet_date_period_error\">\n<span class=\"title\">Wet Date:</span><div ng-if=\"vm.gs.wet_date_error\"><span ng-if=\"vm.gs.leased\">\n- The Block is not Leased during <span class=\"inline title\">{{vm.formatDate(vm.gs.scheduled_wet_date)}}</span>\n, the selected Wet Date allotted tillage timeframe<div class=\"planting-dates\" \nng-if=\"vm.gs.block && vm.gs.block.lease_dates && vm.gs.block.lease_dates.length\"><span>Lease Dates:</span> <span \nng-repeat=\"date in vm.gs.block.lease_dates\"><span class=\"inline\">{{$index + 1}}) Start: <span class=\"inline title\">\n{{vm.formatDate(date.lease_start_date)}}</span> - End: <span class=\"inline title\">\n{{vm.formatDate(date.lease_end_date)}}</span></span></span></div></span><span ng-if=\"vm.gs.subleased\">\n- The Block is Subleased to another Grower during <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_wet_date)}}</span>, the selected Wet Date allotted timeframe<div \nclass=\"planting-dates\" ng-if=\"vm.gs.block && vm.gs.block.sublease_dates && vm.gs.block.sublease_dates.length\"><span>\nSublease Dates:</span> <span ng-repeat=\"date in vm.gs.block.sublease_dates\"><span class=\"inline\">\n{{$index + 1}}) Start: <span class=\"inline title\">{{vm.formatDate(date.sublease_start_date)}}</span> - End: <span \nclass=\"inline title\">{{vm.formatDate(date.sublease_end_date)}}</span></span></span></div></span></div><span \nng-if=\"vm.gs.wet_date_variety_error\">- Selected Wet Date <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_wet_date)}}</span> is not within Planting Dates from the Location <span \nclass=\"inline title\">{{vm.gs.location_name}}</span> for Seed <span class=\"inline title\">{{vm.gs.seed_name}}</span> \n<span ng-if=\"vm.gs.variety\" class=\"inline\">and Variety <span class=\"inline title\">{{vm.gs.variety.name}}</span></span>\n<div class=\"planting-dates\" ng-if=\"vm.aux_seed_varieties_location.length\">Existing Planting Dates: <span \nng-repeat=\"location in vm.aux_seed_varieties_location\"><span class=\"inline\">{{$index + 1}}) Start: <span \nclass=\"inline title\">{{vm.formatDateForVariety(location.begin_date)}}</span> - End: <span class=\"inline title\">\n{{vm.formatDateForVariety(location.end_date)}}</span></span></span></div><div class=\"planting-dates\" \nng-if=\"!vm.aux_seed_varieties_location.length\">There are no Planting Dates defined</div></span><span \nng-if=\"vm.gs.last_harvest_date_error\">- Selected Wet Date <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_wet_date)}}</span> needs to be greater than Last Harvest Date <span \nclass=\"inline title\">{{vm.formatDate(vm.gs.last_harvest_date)}}</span> <span class=\"inline\" \nng-if=\"vm.double_crop_bed_preparation_days === 1\">+ {{vm.double_crop_bed_preparation_days}} day</span> <span \nclass=\"inline\" ng-if=\"vm.double_crop_bed_preparation_days > 1\">+ {{vm.double_crop_bed_preparation_days}} days</span> \n</span><span ng-if=\"vm.gs.wet_date_fiscal_year_error\">- Selected Wet Date <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_wet_date)}}</span> is not within current Growing Year </span><span \nng-if=\"vm.gs.wet_date_period_error\"><span ng-if=\"vm.gs.leased\">- Selected Wet Date <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_wet_date)}}</span> must be on the same Lease period of the Block<div \nclass=\"planting-dates\" ng-if=\"vm.gs.block && vm.gs.block.lease_dates && vm.gs.block.lease_dates.length\"><span>\nLease Dates:</span> <span ng-repeat=\"date in vm.gs.block.lease_dates\"><span class=\"inline\">{{$index + 1}}) Start: <span\n class=\"inline title\">{{vm.formatDate(date.lease_start_date)}}</span> - End: <span class=\"inline title\">\n{{vm.formatDate(date.lease_end_date)}}</span></span></span></div></span><span ng-if=\"vm.gs.subleased\">\n- Allotted growing timeframe <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_wet_date)}} - {{vm.formatDate(vm.gs.scheduled_harvest_date)}}</span>\n is invalid, since the Block is Subleased to another Grower during it<div class=\"planting-dates\" \nng-if=\"vm.gs.block && vm.gs.block.sublease_dates && vm.gs.block.sublease_dates.length\"><span>Sublease Dates:</span> \n<span ng-repeat=\"date in vm.gs.block.sublease_dates\"><span class=\"inline\">{{$index + 1}}) Start: <span \nclass=\"inline title\">{{vm.formatDate(date.sublease_start_date)}}</span> - End: <span class=\"inline title\">\n{{vm.formatDate(date.sublease_end_date)}}</span></span></span></div></span></span></div><div \nclass=\"harvest-date-errors\" \nng-if=\"vm.gs.harvest_date_error || vm.gs.max_harvest_date_error || vm.gs.harvest_date_fiscal_year_error || vm.gs.harvest_date_period_error\">\n<span class=\"title\">Harvest Date:</span><span ng-if=\"vm.gs.harvest_date_error\"><span ng-if=\"vm.gs.leased\">\n- The Block is not Leased during <span class=\"inline title\">{{vm.formatDate(vm.gs.scheduled_harvest_date)}}</span>\n, the allotted growing timeframe of estimated Harvest Date<div class=\"planting-dates\" \nng-if=\"vm.gs.block && vm.gs.block.lease_dates && vm.gs.block.lease_dates.length\"><span>Lease Dates:</span> <span \nng-repeat=\"date in vm.gs.block.lease_dates\"><span class=\"inline\">{{$index + 1}}) Start: <span class=\"inline title\">\n{{vm.formatDate(date.lease_start_date)}}</span> - End: <span class=\"inline title\">\n{{vm.formatDate(date.lease_end_date)}}</span></span></span></div></span><span ng-if=\"vm.gs.subleased\">\n- The Block is Subleased to another Grower during <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_harvest_date)}}</span>, the allotted growing timeframe of estimated Harvest Date<div \nclass=\"planting-dates\" ng-if=\"vm.gs.block && vm.gs.block.sublease_dates && vm.gs.block.sublease_dates.length\"><span>\nSublease Dates:</span> <span ng-repeat=\"date in vm.gs.block.sublease_dates\"><span class=\"inline\">\n{{$index + 1}}) Start: <span class=\"inline title\">{{vm.formatDate(date.sublease_start_date)}}</span> - End: <span \nclass=\"inline title\">{{vm.formatDate(date.sublease_end_date)}}</span></span></span></div></span></span><span \nng-if=\"vm.gs.max_harvest_date_error && vm.gs.max_harvest_date\">- Selected Harvest Date can not be greater than <span \nclass=\"inline title\">{{vm.formatDate(vm.gs.max_harvest_date)}}</span> (next Scheduled Wet Date for the Block) <span \nclass=\"inline\" ng-if=\"vm.double_crop_bed_preparation_days === 1\">- {{vm.double_crop_bed_preparation_days}} day</span> \n<span class=\"inline\" ng-if=\"vm.double_crop_bed_preparation_days > 1\">- {{vm.double_crop_bed_preparation_days}} days\n</span> </span><span ng-if=\"vm.gs.harvest_date_fiscal_year_error\">- Selected Harvest Date <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_harvest_date)}}</span> is not within current Growing Year </span><span \nng-if=\"vm.gs.harvest_date_period_error\"><span ng-if=\"vm.gs.leased\">- Selected Harvest Date <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_harvest_date)}}</span> must be on the same Lease period of the Block<div \nclass=\"planting-dates\" ng-if=\"vm.gs.block && vm.gs.block.lease_dates && vm.gs.block.lease_dates.length\"><span>\nLease Dates:</span> <span ng-repeat=\"date in vm.gs.block.lease_dates\"><span class=\"inline\">{{$index + 1}}) Start: <span\n class=\"inline title\">{{vm.formatDate(date.lease_start_date)}}</span> - End: <span class=\"inline title\">\n{{vm.formatDate(date.lease_end_date)}}</span></span></span></div></span><span ng-if=\"vm.gs.subleased\">\n- Allotted growing timeframe <span class=\"inline title\">\n{{vm.formatDate(vm.gs.scheduled_wet_date)}} - {{vm.formatDate(vm.gs.scheduled_harvest_date)}}</span>\n is invalid, since the Block is Subleased to another Grower during it<div class=\"planting-dates\" \nng-if=\"vm.gs.block && vm.gs.block.sublease_dates && vm.gs.block.sublease_dates.length\"><span>Sublease Dates:</span> \n<span ng-repeat=\"date in vm.gs.block.sublease_dates\"><span class=\"inline\">{{$index + 1}}) Start: <span \nclass=\"inline title\">{{vm.formatDate(date.sublease_start_date)}}</span> - End: <span class=\"inline title\">\n{{vm.formatDate(date.sublease_end_date)}}</span></span></span></div></span></span></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"SAVE\" \ntranslate=\"GROWER_SCHEDULE.OK\" translate-attr-aria-label=\"GROWER_SCHEDULE.OK\"></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/pages/grower-schedule/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">Filters</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-subheader class=\"md-no-sticky\">\n<md-input-container class=\"md-block reset-btn-container\" flex-gt-sm><md-button class=\"reset-btn\" \nng-click=\"vm.resetFilters()\">Reset Filters</md-button></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Location Name</label><md-select ng-model=\"vm.location\" ng-click=\"vm.hideToast();\"><md-option \nng-if=\"vm.allLocations.length === 0\" ng-click=\"vm.goTo(\'/land\')\">No <b>Locations</b> to show<br>Go to Locations page\n</md-option><md-option ng-if=\"vm.allLocations.length > 0\" ng-repeat=\"location in vm.allLocations\" \nng-value=\"{{location.id}}\" \nng-click=\"\n                  vm.validateSharedFilterChange(\n                    growerSchedForm.$invalid, contractsForm.$invalid,\n                    \'location\', location.id,\n                    {\'id\': 1, \'type\': \'Location\', \'value\': location.name}\n                  );\">\n{{location.name}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.location\" \nclass=\"md-block\" flex-gt-sm><label>Ranch name</label><md-select ng-model=\"vm.ranch\" ng-click=\"vm.hideToast();\">\n<md-option ng-if=\"vm.allRanches.length === 0\" ng-click=\"vm.goToRanches()\">No <b>Ranches</b> in selected location<br>\nGo to Ranches page</md-option><md-option ng-if=\"vm.allRanches.length > 0\" ng-repeat=\"ranch in vm.allRanches\" \nng-value=\"{{ranch.id}}\" \nng-click=\"\n                  vm.validateSharedFilterChange(\n                    growerSchedForm.$invalid, contractsForm.$invalid,\n                    \'ranch\', ranch.id,\n                    {\'id\': 2, \'type\': \'Ranch\', \'value\': ranch.name }\n                  );\">\n{{ranch.name}}</md-option></md-select></md-input-container><md-input-container ng-show=\"vm.location && vm.ranch\" \nclass=\"md-block\" flex-gt-sm><label>Block name</label><md-select ng-model=\"vm.block\" ng-click=\"vm.hideToast();\">\n<md-option ng-if=\"vm.allBlocks.length === 0\" ng-click=\"vm.goToBlocks()\">No <b>Blocks</b> in selected Ranch<br>\nGo to Blocks page</md-option><md-option ng-if=\"vm.allBlocks.length > 0\" ng-repeat=\"block in vm.allBlocks\" \nng-value=\"{{block.id}}\" \nng-click=\"\n                  vm.validateSharedFilterChange(\n                    growerSchedForm.$invalid, contractsForm.$invalid,\n                    \'block\', block.id,\n                    {\'id\': 3, \'type\': \'Block\', \'value\': block.name }\n                  );\">\n{{block.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nSeason Name</label><md-select ng-model=\"vm.season\" ng-click=\"vm.hideToast();\"><md-option \nng-if=\"vm.allFiscalYearSeasons.length === 0\" ng-click=\"vm.goTo(\'/seasons\')\">No <b>Seasons</b> to show<br>\nGo to Seasons page</md-option><md-option ng-if=\"vm.allFiscalYearSeasons.length > 0\" \nng-repeat=\"fiscalYearSeason in vm.allFiscalYearSeasons\" ng-value=\"{{fiscalYearSeason.season_id}}\" \nng-click=\"\n                vm.validateSharedFilterChange(\n                  growerSchedForm.$invalid, contractsForm.$invalid,\n                  \'season\', fiscalYearSeason.season_id,\n                  {\'id\': 4, \'type\': \'Season\', \'value\': fiscalYearSeason.season.name }\n                );\">\n{{fiscalYearSeason.season.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label>Week Ending</label><md-select ng-model=\"vm.we\" ng-click=\"vm.hideToast();\"><md-option \nng-if=\"vm.allWeekEnding.length === 0\" ng-disabled=\"true\">No <b>Week Endings</b> to show<br></md-option><md-option \nng-if=\"vm.allWeekEnding.length > 0\" ng-repeat=\"we in vm.allWeekEnding\" ng-value=\"{{we.id}}\" \nng-click=\"\n                vm.validateSharedFilterChange(\n                  growerSchedForm.$invalid, contractsForm.$invalid,\n                  \'we\', we.id,\n                  {\'id\': 5, \'type\': \'Week\', \'value\': we.header_label }\n                );\">\n{{we.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nShipper Name</label><md-select ng-model=\"vm.shipper\" ng-click=\"vm.hideToast();\"><md-option \nng-if=\"vm.allShippers.length === 0\" ng-click=\"vm.goTo(\'/companies/\')\">No <b>Shippers</b> to show<br>\nGo to Companies page</md-option><md-option ng-if=\"vm.allShippers.length > 0\" ng-repeat=\"shipper in vm.allShippers\" \nng-value=\"{{shipper.id}}\" \nng-click=\"\n                vm.validateSharedFilterChange(\n                  growerSchedForm.$invalid, contractsForm.$invalid,\n                  \'shipper\', shipper.id,\n                  {\'id\': 6, \'type\': \'Shipper\', \'value\': shipper.name }\n                );\">\n{{shipper.name}}</md-option></md-select></md-input-container></md-subheader><md-subheader class=\"md-no-sticky\">\n<md-switch ng-if=\"!vm.isContractDisabled\" aria-label=\"Display Not Scheduled Contracts\" \nng-model=\"vm.displayNSContracts\" \nng-change=\"vm.schedulefilterChange(growerSchedForm.$invalid, contractsForm.$invalid, \'displayNSContracts\', \'contractListType\')\" \nng-click=\"vm.hideToast();\">Not Scheduled Contracts</md-switch><md-switch aria-label=\"Display Not Scheduled Blocks\" \nclass=\"custom-switch\" ng-model=\"vm.displayNSBlocks\" \nng-change=\"vm.schedulefilterChange(growerSchedForm.$invalid, contractsForm.$invalid, \'displayNSBlocks\', \'blockListType\')\" \nng-click=\"vm.hideToast();\">Not Scheduled Blocks</md-switch></md-subheader></div>");
$templateCache.put("app/main/pages/planting-schedule/dialogs/planting-schedule-information/planting-schedule-information-dialog.html","<md-dialog aria-label=\"New Task\"><form class=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-tall\" \nlayout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">Add Planting Schedule Information</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"PLANTING_SCHEDULE.TABS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex layout=\"column\" layout-padding><section>\n<md-input-container class=\"md-icon-float md-block margin-top-0 padding-top-0\"><div class=\"signature\"><label \nfor=\"signature\" translate=\"PLANTING_SCHEDULE.TABS.LOCATION\"></label></div><md-icon \nmd-font-icon=\"icon-map-marker-radius\"></md-icon><textarea aria-label=\"Location\" \nng-model=\"vm.newPlantingScheduleInformation.location\" type=\"text\"></textarea></md-input-container></section><section>\n<md-input-container class=\"md-icon-float md-block margin-top-0 padding-top-0\"><div class=\"signature\"><label \nfor=\"signature\" translate=\"PLANTING_SCHEDULE.TABS.SHIPPER\"></label></div><md-icon md-font-icon=\"icon-city\"></md-icon>\n<textarea aria-label=\"Shipper\" ng-model=\"vm.newPlantingScheduleInformation.shipper\" type=\"text\"></textarea>\n</md-input-container></section><section><md-input-container class=\"md-icon-float md-block margin-top-0 padding-top-0\">\n<div class=\"signature\"><label for=\"signature\" translate=\"PLANTING_SCHEDULE.TABS.WET_DATE\"></label></div><md-datepicker \nmd-open-on-focus name=\"wet_date\" ng-model=\"vm.newPlantingScheduleInformation.wet_date\"></md-datepicker>\n</md-input-container></section><section><md-input-container class=\"md-icon-float md-block margin-top-0 padding-top-0\">\n<div class=\"signature\"><label for=\"signature\" translate=\"PLANTING_SCHEDULE.TABS.SEED\"></label></div><md-icon \nmd-font-icon=\"icon-barley\"></md-icon><textarea aria-label=\"Seed\" ng-model=\"vm.newPlantingScheduleInformation.seed\" \ntype=\"text\"></textarea></md-input-container></section><section><md-input-container \nclass=\"md-icon-float md-block margin-top-0 padding-top-0\"><div class=\"signature\"><label for=\"signature\" \ntranslate=\"PLANTING_SCHEDULE.TABS.VARIETY\"></label></div><md-icon md-font-icon=\"icon-barley\"></md-icon><textarea \naria-label=\"Variety\" ng-model=\"vm.newPlantingScheduleInformation.variety\" type=\"text\"></textarea></md-input-container>\n</section></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.addPlantingScheduleInformation()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"Save Planting Schedule Information\" \ntranslate=\"PLANTING_SCHEDULE.TABS.SAVE\" translate-attr-aria-label=\"PLANTING_SCHEDULE.TABS.SAVE\"></md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/pages/planting-schedule/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">Filters</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list><md-subheader class=\"md-no-sticky\">\n<md-input-container class=\"md-block\" flex-gt-sm><label>All Seasons</label><md-select ng-model=\"vm.season_id\"><md-option\n ng-repeat=\"season in vm.allSeasons\" ng-value=\"{{season.id}}\" \nng-click=\"\n                            vm.filterChange(\'season\', season.id)\">{{season.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.season_id != null\"><label>Week Ending\n</label><md-select ng-model=\"vm.weekEnding_id\"><md-option ng-repeat=\"weekEnding in vm.allWeekEnding\" \nng-value=\"{{weekEnding.id}}\" ng-click=\"\n                                vm.filterChange(\'weekEnding\', weekEnding.id)\">\n{{weekEnding.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nAll Locations</label><md-select ng-model=\"vm.location_id\"><md-option ng-repeat=\"location in vm.allLocations\" \nng-value=\"{{location.id}}\" ng-click=\"\n                            vm.filterChange(\'location\', location.id)\">\n{{location.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm \nng-if=\"vm.location_id != null\"><label>All Ranches</label><md-select ng-model=\"vm.ranch_id\"><md-option \nng-repeat=\"ranch in vm.allRanches\" ng-value=\"{{ranch.id}}\" \nng-click=\"\n                            vm.filterChange(\'ranch\', ranch.id)\">{{ranch.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>All Shippers</label><md-select \nng-model=\"vm.shipper_id\"><md-option ng-repeat=\"shipper in vm.allShippers\" ng-value=\"{{shipper.id}}\" \nng-click=\"\n                                vm.filterChange(\'shipper\', shipper.id)\">{{shipper.name}}</md-option>\n</md-select></md-input-container><div ng-hide=\"vm.isContractDisabled || vm.contracts.length === 0\"><md-list-item \naria-label=\"filter-not-scheduled\" ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\': vm.starred_id === null}\"><p \ntranslate=\"PLANTING_SCHEDULE.ALL_BLOCKS\"></p></md-list-item><md-list-item aria-label=\"filter-all\" \nng-click=\"vm.filterChange(\'starred\', true)\" ng-class=\"{\'selected\':vm.starred_id === true}\"><p \ntranslate=\"PLANTING_SCHEDULE.STARRED_BLOCKS\"></p></md-list-item></div><md-input-container class=\"md-block\" flex-gt-sm>\n<label>Bed Status</label><md-select ng-model=\"vm.bedStatus_id\"><md-option ng-repeat=\"bedStatus in vm.allBedStatus\" \nng-value=\"{{bedStatus.id}}\" ng-click=\"\n                                vm.filterChange(\'bedStatus\', bedStatus.id)\">\n{{bedStatus.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nPlanting Status</label><md-select ng-model=\"vm.plantingStatus_id\"><md-option \nng-repeat=\"plantingStatus in vm.allPlantingStatus\" ng-value=\"{{plantingStatus.id}}\" \nng-click=\"\n                                vm.filterChange(\'plantingStatus\', plantingStatus.id)\">\n{{plantingStatus.name}}</md-option></md-select></md-input-container></md-subheader></md-list></div>");
$templateCache.put("app/main/pages/work-schedule/dialogs/add-edit/assign-teams-dialog.html","<md-dialog flex=\"60\" aria-label=\"Add Dialog\"><form name=\"dialogForm\"><md-toolbar class=\"md-accent height-64\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Work Schedule</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nstyle=\"background-color:#eaeaea\" ms-scroll><md-card><md-card-header><h3>Work Schedule Template Information</h3>\n</md-card-header><md-card-content layout=\"column\" flex><md-card flex=\"100\"><md-card-header><div layout=\"row\" flex>\n<label flex=\"70\">Work Schedule Template</label><div flex=\"10\" class=\"badge no-text clickeable\" \nng-style=\"{\'background-color\':vm.block.work_template.color}\"></div></div></md-card-header><md-card-content><md-select \nrequired disabled=\"disabled\" \nng-change=\"vm.changeWorkTemplate(vm.block);vm.generateRolesGroups(vm.block);vm.generateLaborGroups(vm.block);vm.generateDates();\" \nng-model=\"vm.block.work_template\" placeholder=\"Work Templates\" class=\"md-no-underline\"><md-option \nng-repeat=\"workTemplate in vm.workTemplates\" ng-value=\"workTemplate\">{{workTemplate.name}}</md-option></md-select>\n</md-card-content></md-card></md-card-content></md-card><md-card><md-card-header><h3>Assign Labor and Equipment</h3>\n</md-card-header><md-card-content><div flex layout=\"row\"><div flex=\"50\"><md-card><md-card-header layout=\"row\"><label>\nForeman</label></md-card-header><md-card-content><div flex layout=\"row\" layout-align=\"start center\" \nng-repeat=\"foremanGroup in vm.rolesGroups\"><div flex=\"50\"><label>{{foremanGroup.name}}</label></div><div flex=\"30\">\n<md-select required ng-model=\"foremanGroup.foreman\" placeholder=\"Foreman\" class=\"md-no-underline\"><md-option \nng-repeat=\"foremanOption in foremanGroup.subgroups\" ng-value=\"foremanOption.id\">{{foremanOption.name}}</md-option>\n</md-select></div><div flex=\"20\"><div ng-click=\"vm.openColorPicker($event,foremanGroup)\" \nclass=\"badge no-text clickeable\" ng-style=\"{\'background-color\':foremanGroup.color}\"></div></div></div>\n</md-card-content></md-card><md-card><md-card-header layout=\"row\"><label>Equipment Team</label></md-card-header>\n<md-card-content><div flex layout=\"row\" layout-align=\"start center\" ng-repeat=\"equipmentGroup in vm.equipmentGroups\">\n<div flex=\"50\"><label>{{equipmentGroup.name}}</label></div><div flex=\"30\"><md-select required \nng-model=\"equipmentGroup.equipment\" placeholder=\"Equipment\" class=\"md-no-underline\"><md-option \nng-repeat=\"equipmentOption in equipmentGroup.subgroups\" ng-value=\"equipmentOption.id\">{{equipmentOption.name}}\n</md-option></md-select></div><div flex=\"20\"><div ng-click=\"vm.openColorPicker($event,equipmentGroup)\" \nclass=\"badge no-text clickeable\" ng-style=\"{\'background-color\':equipmentGroup.color}\"></div></div></div>\n</md-card-content></md-card></div><div flex=\"50\"><md-card><md-card-header><label>Labor Team</label></md-card-header>\n<md-card-content><div flex layout=\"row\" layout-align=\"start center\" ng-repeat=\"laborGroup in vm.laborGroups\"><div \nflex=\"50\"><label>{{laborGroup.name}}</label></div><div flex=\"30\"><md-select required ng-model=\"laborGroup.labor\" \nplaceholder=\"Labor\" class=\"md-no-underline\"><md-option ng-repeat=\"laborOption in laborGroup.subgroups\" \nng-value=\"laborOption.id\">{{laborOption.name}}</md-option></md-select></div><div flex=\"20\"><div \nng-click=\"vm.openColorPicker($event,laborGroup)\" class=\"badge no-text clickeable\" \nng-style=\"{\'background-color\':laborGroup.color}\"></div></div></div></md-card-content></md-card></div></div>\n</md-card-content></md-card><div flex layout=\"row\"><div flex=\"30\"><md-button ng-disabled=\"dialogForm.$invalid\" \nng-click=\"vm.save()\" class=\"md-raised\">Save</md-button></div><div flex=\"30\"><md-checkbox class=\"margin-bottom-0\" \naria-label=\"Checkbox 1\">Save Changes to Template:</md-checkbox><md-checkbox ng-model=\"vm.copy\" class=\"margin-bottom-0\" \naria-label=\"Checkbox 1\">Copy to New Template:</md-checkbox></div><div flex=\"40\"><md-input-container ng-show=\"vm.copy\" \nng-required=\"vm.copy\"><label>Template Name</label><input ng-model=\"user.title\"></md-input-container></div></div>\n</md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pages/work-schedule/dialogs/add-edit/block-work-template-dialog.html","<md-dialog flex=\"60\" aria-label=\"Add Dialog\"><form name=\"dialogForm\"><md-toolbar class=\"md-accent height-64\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">Work Schedule</h2><span \nflex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nclass=\"bk-color-ea\" ms-scroll><md-card><md-card-header><h2><b>Work Schedule Template Information</b></h2>\n</md-card-header><md-card-content layout=\"column\" flex><md-card flex=\"100\"><md-card-header><div layout=\"row\" flex>\n<label flex=\"70\">Work Schedule Template</label><div flex=\"5\" class=\"badge no-text clickeable\" \nng-style=\"{\'background-color\':vm.block.work_template.color}\"></div></div></md-card-header><md-card-content><md-select \nrequired \nng-change=\"vm.changeWorkTemplate(vm.block);vm.generateRolesGroups(vm.block);vm.generateLaborGroups(vm.block);vm.generateDates();\" \nng-model=\"vm.block.work_template\" placeholder=\"Work Templates\" class=\"md-no-underline\"><md-option \nng-repeat=\"workTemplate in vm.workTemplates\" ng-value=\"workTemplate\">{{workTemplate.name}}</md-option></md-select>\n</md-card-content></md-card><md-card flex=\"100\"><md-card-content><div flex layout=\"row\"><div flex=\"50\"><label>Season\n</label></div><div flex=\"50\"><label>Seed</label></div></div><br><div flex layout=\"row\" ng-if=\"vm.seasons && vm.seeds\">\n<div flex=\"50\"><b>{{vm.getSeasonName()}}</b></div><div flex=\"50\"><b>{{vm.getSeedName()}}</b></div></div>\n</md-card-content></md-card></md-card-content></md-card><md-card><md-card-header><h2><b>Timeline anchor definition</b>\n</h2></md-card-header><md-card-content><md-card ng-if=\"vm.canConfigureRepeats(phase)\" \nng-repeat=\"phase in vm.block.work_template.phases\"><div class=\"padding-20\" flex layout=\"row\"><h2>\n{{phase.name}} Repeat Definition</h2></div><div flex layout=\"row\" layout-align=\"center center\"><div flex=\"100\">\n<md-input-container class=\"md-block\" flex=\"100\"><label>Number of days between tasks</label><input flex=\"100\" \ntype=\"number\" min=\"0\" max=\"100\" required ng-model=\"phase.repeatGap\"></md-input-container></div></div></md-card><md-card\n ng-repeat=\"date in vm.dates\"><div class=\"padding-20\" flex=\"100\" layout=\"row\"><h2>\n{{date.anchor.name}} Assign to {{vm.getAnchorTask(date.anchor.id).name}}</h2></div><div flex=\"100\" \nng-if=\"date.type==\'picker\'\" layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\" flex=\"100\"><md-datepicker \nng-model=\"date.date.date\" class=\"shipper-wet-date\" required md-placeholder=\"\"></md-datepicker></md-input-container>\n</div></div><div flex=\"100\" ng-if=\"date.type==\'before\'\" layout=\"row\"><div flex=\"50\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label>Days before wet date (0 - 100)</label><input ng-init=\"vm.addDays(date.date,1)\" \nflex=\"100\" type=\"number\" min=\"0\" max=\"100\" ng-change=\"vm.addDays(date.date,-1)\" required ng-model=\"date.date.model\">\n</md-input-container></div><div flex=\"50\" layout=\"column\" layout-align=\"start center\"><div flex><p>{{date.anchor.name}}\n</p></div><div flex><p>{{vm.formatDate(date.date.date)}}</p></div></div></div><div flex=\"100\" \nng-if=\"date.type==\'after\'\" layout=\"row\"><div flex=\"50\"><md-input-container class=\"md-block\" flex=\"100\"><label>\nDays after wet date (0 - 100)</label><input ng-init=\"vm.addDays(date.date,1)\" flex=\"100\" type=\"number\" min=\"0\" \nmax=\"100\" ng-change=\"vm.addDays(date.date,1)\" required ng-model=\"date.date.model\"></md-input-container></div><div \nflex=\"50\" layout=\"column\" layout-align=\"start center\"><div flex><p>{{date.anchor.name}}</p></div><div flex><p>\n{{vm.formatDate(date.date.date)}}</p></div></div></div></md-card></md-card-content></md-card><div flex layout=\"row\">\n<div flex=\"30\"><md-button ng-disabled=\"dialogForm.$invalid\" ng-click=\"vm.save()\" class=\"md-raised\">Save</md-button>\n</div><div flex=\"30\"><md-checkbox class=\"margin-bottom-0\" aria-label=\"Checkbox 1\">Save Changes to Template:\n</md-checkbox><md-checkbox ng-model=\"vm.copy\" class=\"margin-bottom-0\" aria-label=\"Checkbox 1\">Copy to New Template:\n</md-checkbox></div><div flex=\"40\"><md-input-container ng-show=\"vm.copy\" ng-required=\"vm.copy\"><label>Template Name\n</label><input ng-model=\"user.title\"></md-input-container></div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pages/work-schedule/dialogs/add-edit/edit-dialog.html","<md-dialog flex=\"50\" aria-label=\"Edit Dialog\"><md-toolbar class=\"md-accent height-64\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\nBlock Preparation Calculation</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><form name=\"calculatorForm\"><md-dialog-content ms-scroll style=\"padding:20px\"><div \nng-if=\"!vm.hasGrowingTask() && !vm.hasTillageTask() && !vm.hasPreWaterTask()  \"></div><div ng-if=\"vm.hasTillageTask()\">\n<div flex layout=\"row\"><h2>Tillage Start Date</h2></div><div flex layout=\"row\" layout-align=\"center center\"><div \nflex=\"50\"><md-input-container class=\"md-block\" flex=\"100\"><label>Days before wet date (0 - 100)</label><input \nflex=\"100\" type=\"number\" min=\"0\" max=\"100\" ng-change=\"vm.changeTillageDays()\" required ng-model=\"vm.block.tillageDays\">\n</md-input-container></div><div flex=\"50\"><p>Tillage Start Date</p><p>\n{{vm.ahowDateFormatted(vm.block.scheduled_tillage_date)}}</p></div></div></div><div ng-if=\"vm.hasPreWaterTask()\"><div \nflex layout=\"row\"><h2>Pre-Water Date</h2></div><div flex layout=\"row\" layout-align=\"center center\"><div flex=\"50\">\n<md-input-container class=\"md-block\" flex=\"100\"><label>Days before wet date (0 - 100)</label><input flex=\"100\" \ntype=\"number\" min=\"0\" max=\"100\" ng-change=\"vm.changePreWaterDays()\" required ng-model=\"vm.block.preWaterDays\">\n</md-input-container></div><div flex=\"50\"><p>Pre-Water Date</p><p>\n{{vm.ahowDateFormatted(vm.block.scheduled_pre_water_date)}}</p></div></div></div><div ng-if=\"vm.hasGrowingTask()\"><div \nflex layout=\"row\"><h2>Growing Start Date</h2></div><div flex layout=\"row\" layout-align=\"center center\"><div flex=\"50\">\n<md-input-container class=\"md-block\" flex=\"100\"><label>Days After Wet Date (0 - 100)</label><input flex=\"100\" \ntype=\"number\" min=\"0\" max=\"100\" ng-change=\"vm.changeGrowingDays()\" required ng-model=\"vm.block.growingDays\">\n</md-input-container></div><div flex=\"50\"><p>Growing Start Date</p><p>\n{{vm.ahowDateFormatted(vm.block.scheduled_growing_date)}}</p></div></div></div><div ng-if=\"vm.hasIrrigationTask()\"><div\n flex layout=\"row\"><h2>Irrigation Date</h2></div><div flex layout=\"row\" layout-align=\"center center\"><div flex=\"50\">\n<md-input-container class=\"md-block\" flex=\"100\"><label>Days After Wet Date (0 - 100)</label><input flex=\"100\" \ntype=\"number\" min=\"0\" max=\"100\" ng-change=\"vm.changeIrrigationDays()\" required ng-model=\"vm.block.irrigationDays\">\n</md-input-container></div><div flex=\"50\"><p>Irrigation Date</p><p>\n{{vm.ahowDateFormatted(vm.block.scheduled_irrigation_date)}}</p></div></div></div><div flex layout=\"row\"><div \nflex=\"30\"><md-button ng-disabled=\"calculatorForm.$invalid\" ng-click=\"vm.save()\" class=\"md-raised\">Save</md-button>\n</div></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/pages/work-schedule/sidenavs/settings/settings-sidenav.html","<md-toolbar class=\"toolbar md-accent\"><div class=\"md-toolbar-tools\"><md-button class=\"md-icon-button\" \naria-label=\"Settings\"><md-icon md-font-icon=\"icon-cog\"></md-icon></md-button><h2><span>Settings</span></h2></div>\n</md-toolbar><md-content class=\"content\" layout-padding><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"GANTT.EDIT\">Edit</span></md-subheader><md-list-item><md-icon md-font-icon=\"icon-pencil\"></md-icon><p \ntranslate=\"GANTT.DRAW\">Draw</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.draw\"></md-checkbox>\n</md-list-item><md-list-item><md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.READ_ONLY\">Read only</p>\n<md-checkbox class=\"md-secondary\" ng-model=\"vm.options.readOnly\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SNAP\">Snap</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-magnet\"></md-icon><p translate=\"GANTT.SNAP_AREA\">Snap area</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.columnMagnet\" placeholder=\"Snap area\"><md-option value=\"column\" \ntranslate=\"GANTT.COLUMN\">Column</md-option><md-option value=\"1 second\" translate=\"GANTT.1_SECOND\">1 second</md-option>\n<md-option value=\"1 minute\" translate=\"GANTT.1_MINUTE\">1 minute</md-option><md-option value=\"5 minutes\" \ntranslate=\"GANTT.5_MINUTES\">5 minutes</md-option><md-option value=\"15 minutes\" translate=\"GANTT.15_MINUTES\">15 minutes\n</md-option><md-option value=\"1 hour\" translate=\"GANTT.1_HOUR\">1 hour</md-option><md-option value=\"1 day\" \ntranslate=\"GANTT.1_DAY\">1 day</md-option><md-option value=\"5 days\" translate=\"GANTT.5_DAYS\">5 days</md-option>\n</md-select></md-list-item><md-list-item><md-icon md-font-icon=\"icon-view-day\"></md-icon><p translate=\"GANTT.DAILY\">\nDaily</p><md-checkbox class=\"md-secondary\" ng-model=\"vm.options.daily\"></md-checkbox></md-list-item><md-list-item>\n<md-icon md-font-icon=\"icon-lock\"></md-icon><p translate=\"GANTT.TIME_FRAMES\">Time frames</p><md-checkbox \nclass=\"md-secondary\" ng-model=\"vm.options.timeFramesMagnet\"></md-checkbox></md-list-item><md-divider></md-divider>\n<md-subheader class=\"md-no-sticky\"><span translate=\"GANTT.SIDEBAR\">Sidebar</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-eye\"></md-icon><p translate=\"GANTT.SHOW_SIDEBAR\">Show Sidebar</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.labelsEnabled\"></md-checkbox></md-list-item><md-list-item><md-icon md-font-icon=\"icon-code-tags\">\n</md-icon><p translate=\"GANTT.RESIZABLE\">Resizable</p><md-checkbox class=\"md-secondary\" \nng-model=\"vm.options.allowSideResizing\"></md-checkbox></md-list-item><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.LIST_MODE\">List Mode</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.sideMode\" placeholder=\"List\"><md-option value=\"Tree\" \ntranslate=\"GANTT.TREE\">Tree</md-option><md-option value=\"Table\" translate=\"GANTT.TABLE\">Table</md-option><md-option \nvalue=\"TreeTable\" translate=\"GANTT.TREE_TABLE\">TreeTable</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"GANTT.TIMELINE\">Timeline</span></md-subheader><md-list-item><md-icon \nmd-font-icon=\"icon-view-headline\"></md-icon><p translate=\"GANTT.GROUPS\">Groups</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.groupDisplayMode\" placeholder=\"Groups\"><md-option value=\"group\" \ntranslate=\"GANTT.GROUP\">Group</md-option><md-option value=\"overview\" translate=\"GANTT.OVERVIEW\">Overview</md-option>\n<md-option value=\"promote\" translate=\"GANTT.PROMOTE\">Promote</md-option><md-option value=\"Disabled\" \ntranslate=\"GANTT.DISABLED\">Disabled</md-option></md-select></md-list-item><md-divider></md-divider><md-list-item>\n<md-icon md-font-icon=\"icon-calendar-today\"></md-icon><p translate=\"GANTT.TODAY\">Today</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.currentDate\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"line\" translate=\"GANTT.LINE\">Line</md-option><md-option \nvalue=\"column\" translate=\"GANTT.COLUMN\">Column</md-option></md-select></md-list-item><md-divider></md-divider>\n<md-list-item><md-icon md-font-icon=\"icon-arrow-expand\"></md-icon><p translate=\"GANTT.EXPAND\">Expand</p><md-select \nclass=\"simplified md-secondary\" ng-model=\"vm.options.autoExpand\" placeholder=\"Today\"><md-option value=\"none\" \ntranslate=\"GANTT.NONE\">None</md-option><md-option value=\"both\" translate=\"GANTT.BOTH\">Both</md-option><md-option \nvalue=\"left\" translate=\"GANTT.LEFT\">Left</md-option><md-option value=\"right\" translate=\"GANTT.RIGHT\">Right</md-option>\n</md-select></md-list-item><md-divider></md-divider><md-list-item><md-icon md-font-icon=\"icon-content-cut\"></md-icon><p\n translate=\"GANTT.OUT_OF_RANGE\">Out of range</p><md-select class=\"simplified md-secondary\" \nng-model=\"vm.options.taskOutOfRange\" placeholder=\"Out of range\"><md-option value=\"expand\" translate=\"GANTT.EXPAND\">\nEXPAND</md-option><md-option value=\"truncate\" translate=\"GANTT.TRUNCATE\">Truncate</md-option></md-select>\n</md-list-item><md-divider></md-divider></md-list></md-content>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/directives/ms-custom-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-custom-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-custom-stepper-step-content\" ng-transclude></div><div class=\"ms-custom-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" \nng-if=\"MsStepper.isLastStep() && MsStepper.hasSave()\" ng-disabled=\"!MsStepper.isFormValid()\">Save</md-button></div>");
$templateCache.put("app/main/farm-admin/farm-resources/seed/dialogs/seed/seed-dialog.html","<md-dialog class=\"seed-dialog\" aria-label=\"New Task\"><form name=\"seedForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titleSeed}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"SEEDS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"SEEDS.SEED_NAME\"></label><md-icon md-font-icon=\"icon-barley\" \nclass=\"name\"></md-icon><input ng-model=\"vm.seed.name\" type=\"text\" letters-only md-maxlength=\"20\" maxlength=\"20\" \nrequired md-autofocus><div ng-messages=\"vm.seed.name.$error\" role=\"alert\" multiple=\"multiple\" md-auto-hide=\"true\"><div \nng-message=\"required\"><span translate=\"SEEDS.FIELD_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"SEEDS.ONLY_LETTERS\"></span></div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block padding-bottom-0\"><label translate=\"SEEDS.DESCRIPTION\"></label><md-icon \nmd-font-icon=\"icon-note\"></md-icon><input ng-model=\"vm.seed.description\" type=\"text\" md-maxlength=\"250\" \nmaxlength=\"250\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"vm.newSeed\" ng-click=\"vm.addNewSeed()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"seedForm.$invalid || companyForm.$pristine\" translate=\"SEEDS.ADD_SEED\" \ntranslate-attr-aria-label=\"SEEDS.ADD_SEED\">ADD</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/farm-admin/farm-resources/seed/dialogs/location/location-dialog.html","<md-dialog class=\"location-seed-dialog\" aria-label=\"New Task\"><form name=\"seedForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titleVarietyLocation}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" translate translate-attr-aria-label=\"SEEDS.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div flex=\"95\" \nlayout=\"column\" layout-align=\"start\"><md-input-container class=\"md-block padding-bottom-20\"><div class=\"signature\">\n<label for=\"signature\">Location</label></div><md-icon md-font-icon=\"icon-map-marker-radius\" class=\"location\"></md-icon>\n<md-select name=\"location_id\" class=\"selection\" ng-model=\"vm.varietyLocation.location_id\" md-on-open=\"loadLocation()\" \nrequired><md-option ng-if=\"vm.locations.length===0\" ng-click=\"vm.redirectLand()\">There are no locations to display\n</md-option><md-option required ng-if=\"vm.locations.length!==0\" ng-repeat=\"location in vm.locations\" class=\"option\" \nng-value=\"location.id\">{{location.name}}</md-option></md-select><div class=\"select-error\" \nng-messages=\"seedForm.location_id.$error\"><div class=\"error-message\" ng-message=\"required\">Location field is required.\n</div></div></md-input-container><md-input-container class=\"md-block dates\" flex-gt-sm><div class=\"signature\"><label \nfor=\"signature\">Planting Start Date</label></div><md-datepicker md-open-on-focus name=\"start_date\" \nng-model=\"vm.varietyLocation.begin_date\" md-date-locale=\"customDateFormat\" \nng-change=\"vm.dateChanged(vm.varietyLocation)\" required></md-datepicker><div ng-messages=\"seedForm.start_date.$error\">\n<div class=\"error-message datepicker\" ng-message=\"required\">Planting Start Date field is required.</div></div>\n</md-input-container><md-input-container class=\"md-block dates padding-bottom-0 margin-bottom-0\" flex-gt-sm><div \nclass=\"signature\"><label for=\"signature\">Planting End Date</label></div><md-datepicker md-open-on-focus \nname=\"end_date\" ng-model=\"vm.varietyLocation.end_date\" md-date-locale=\"customDateFormat\" \nng-change=\"vm.dateChanged(vm.varietyLocation)\" md-min-date=\"vm.varietyLocation.min_date\" required></md-datepicker><div \nng-messages=\"seedForm.end_date.$error\"><div class=\"error-message datepicker\" ng-message=\"required\">\nPlanting End Date field is required.</div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"vm.addNewLocation\" ng-click=\"vm.addNewLocation()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"seedForm.$invalid || companyForm.$pristine\" translate-attr-aria-label=\"SEEDS.ADD_SEED\">ADD</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/farm-admin/farm-resources/seed/dialogs/variety/variety-dialog.html","<md-dialog class=\"new-variety-dialog\" aria-label=\"New Task\"><form name=\"seedForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.titleVariety}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"SEEDS.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-checkbox \nng-checked=\"vm.variety.public_domain\" ng-model=\"vm.variety.public_domain\">Public Domain</md-checkbox>\n<md-input-container class=\"md-icon-float md-block margin-top-30\"><label translate=\"SEEDS.VARIETY_NAME\"></label><md-icon\n md-font-icon=\"icon-barley\" class=\"name\"></md-icon><input ng-model=\"vm.variety.name\" md-maxlength=\"20\" maxlength=\"20\" \nletters-only type=\"text\" required md-autofocus></md-input-container><md-input-container required \nclass=\"md-icon-float md-block margin-top-40\"><label translate=\"SEEDS.DESCRIPTION\"></label><md-icon \nmd-font-icon=\"icon-note\"></md-icon><input ng-model=\"vm.variety.description\" type=\"text\" md-maxlength=\"250\" \nmaxlength=\"250\"></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"vm.newVariety\" ng-click=\"vm.addNewVariety()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"seedForm.$invalid || companyForm.$pristine\" translate=\"SEEDS.ADD_SEED\" \ntranslate-attr-aria-label=\"SEEDS.ADD_SEED\">ADD</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/farm-admin/land/blocks/dialogs/block-bed-sizes/block-bed-sizes-dialog.html","<md-dialog class=\"block-dialog\" aria-label=\"New Task\"><form name=\"blockForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"BLOCKS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"BLOCK_TABS.SECTION_INFO.BED_SIZE\"></label><md-icon \nmd-font-icon=\"icon-tree\" class=\"name\"></md-icon><md-select required ng-model=\"vm.block_bed_size.bed_size_id\"><md-option\n ng-if=\"vm.bedSizes.length\" ng-repeat=\"bed_size in vm.bedSizes\" value=\"{{bed_size.id}}\">{{bed_size.bed_size}}\n</md-option><md-option ng-if=\"!vm.bedSizes.length\">No more bed sizes available for this block</md-option></md-select>\n<div ng-messages=\"vm.form.bedSizes.id.$error\"><div ng-message=\"required\">Bed Direction is required.</div></div>\n</md-input-container><md-input-container class=\"md-block margin-top-40\"><label \ntranslate=\"BLOCK_TABS.SECTION_INFO.NUMBER_OF_BEDS\"></label><md-icon md-font-icon=\"icon-numeric\" class=\"name\"></md-icon>\n<input required name=\"bed_count\" ng-model=\"vm.block_bed_size.bed_count\" currency-input=\"integer\" \nonfocus=\"placeholder=\'Max: 9,999\'\" onblur=\"placeholder=\'\'\" type=\"text\"><div \nng-messages=\"vm.form.bblock_bed_size.bed_count.$error\"><div ng-message=\"required\">Number of beds is required.</div>\n</div></md-input-container><md-input-container class=\"md-block margin-top-20\" flex-gt-sm><label translate \ntranslate-attr-placeholder=\"BLOCK_TABS.SECTION_INFO.NOTES\">Notes</label><md-icon md-font-icon=\"icon-note\"></md-icon>\n<textarea ng-model=\"vm.block_bed_size.description\" type=\"text\" md-maxlength=\"100\" maxlength=\"100\"></textarea>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.addNewBlockBedSize()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"blockForm.$invalid || blockForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"BLOCKS.SAVE\" translate-attr-aria-label=\"BLOCKS.SAVE\"></md-button></div></md-dialog-actions></form>\n</md-dialog>");
$templateCache.put("app/main/farm-admin/land/blocks/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">Blocks Filter</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\"><div class=\"custom-padding\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label>Location name</label><md-select ng-model=\"vm.location_id\" \nng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.location_id ? vm.filterChange(\'location\',vm.location_id,vm.location_name,1000) : \'\'\"><md-option \nng-if=\"vm.locations.length>0\" ng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" \nng-click=\"vm.filterChange(\'location\',location.id,location.name)\">{{location.name}}</md-option><md-option \nng-if=\"vm.locations.length===0\" ng-click=\"vm.goToLandPage()\">No <b>Locations</b> in the current area<br>Go to Land page\n</md-option></md-select></md-input-container><md-input-container \nng-show=\"vm.location_id && (vm.ranches.length > 0 || vm.filterData.ranch_id )\" class=\"md-block\" flex-gt-sm><label>\nRanch name</label><md-select ng-model=\"vm.ranch_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.filterData.ranch_id ? vm.filterChange(\'ranch\',vm.filterData.ranch_id,vm.filterData.ranch_name,1500) : \'\'\">\n<md-option ng-if=\"vm.ranches.length>0\" ng-repeat=\"ranch in vm.ranches\" value=\"{{ranch.id}}\" \nng-click=\"vm.filterChange(\'ranch\',ranch.id,ranch.name)\">{{ranch.name}}</md-option><md-option ng-if=\"!vm.location_id\">\nNo Ranches. First select a location</md-option><md-option ng-if=\"vm.location_id && vm.ranches.length===0\" \nng-click=\"vm.goToRanchesPage()\">No <b>Ranches</b> in the selected location<br>Go to Ranches page</md-option>\n</md-select></md-input-container></div><md-divider></md-divider><md-list-item aria-label=\"filter-all\" \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType.name ===\'all\'}\" ng-disabled=\"vm.loadListFiltered\">\n<p translate=\"BLOCKS.ALL_BLOCKS\"></p></md-list-item><md-divider></md-divider><v-accordion class=\"vAccordion--default\" \nmultiple=\"multiple\"><v-pane><v-pane-header><md-list-item>Filter by</md-list-item></v-pane-header><v-pane-content>\n<md-list-item aria-label=\"filter-active\" ng-click=\"vm.filterChange(\'active\')\" \nng-class=\"{\'selected\':  vm.filteredActive }\" ng-disabled=\"vm.loadListFiltered\"><p translate=\"BLOCKS.ACTIVE\"></p>\n</md-list-item><md-list-item aria-label=\"filter-starred\" ng-click=\"vm.filterChange(\'starred\')\" \nng-class=\"{\'selected\': vm.filteredStarred }\" ng-disabled=\"vm.loadListFiltered\"><p translate=\"BLOCKS.STARRED_BLOCKS\">\n</p></md-list-item></v-pane-content></v-pane></v-accordion><v-accordion class=\"vAccordion--default\" \nmultiple=\"multiple\"><v-pane><v-pane-header><md-list-item>Land Owner Company</md-list-item></v-pane-header>\n<v-pane-content><md-list-item ng-if=\"vm.landOwnerCompanies\" ng-repeat=\"landOwner in vm.landOwnerCompanies\" \nng-click=\"vm.filterChange(\'landOwner\',landOwner.id,landOwner.name)\" \nng-class=\"{\'selected\':  vm.landOwner_name === landOwner.name}\" ng-disabled=\"vm.loadListFiltered\"><p class=\"pl-8\">\n{{landOwner.name}}</p></md-list-item></v-pane-content></v-pane></v-accordion><md-subheader class=\"md-no-sticky\">\n</md-subheader></div>");
$templateCache.put("app/main/farm-admin/land/blocks/sidenavs/location-select/location-select-sidenav.html","<md-subheader class=\"md-no-sticky\"><md-select ng-model=\"vm.location\" placeholder=\"Location name\"><md-option \nng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" ng-click=\"vm.filterChange(\'location\',location.id)\">\n{{location.name}}</md-option></md-select></md-subheader>");
$templateCache.put("app/main/farm-admin/land/land/dialogs/location/land-dialog-location.html","<md-dialog class=\"location-dialog\" aria-label=\"New Task\"><form name=\"locationForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"AREA.LOCATIONS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"LANDS.LOCATION_NAME\"></label><input ng-model=\"vm.location.name\" type=\"text\" required md-autofocus \nng-pattern=\"/^[a-zA-Z\\s]*$/\" md-maxlength=\"30\"><div ng-messages=\"vm.location.name.$error\" role=\"alert\" \nmultiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\"><span translate=\"LANDS.ERRORS.FIELD_REQUIRED\">\n</span></div><div ng-message=\"pattern\"><span translate=\"LANDS.ERRORS.ONLY_LETTERS\"></span></div></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"LANDS.LOCATION_SHORT_CODE\">\n</label><input ng-model=\"vm.location.location_short_code\" type=\"text\" required ng-pattern=\"/^[a-zA-Z]*$/\" \nmd-maxlength=\"2\"><div ng-messages=\"vm.location.location_short_code.$error\" role=\"alert\" multiple=\"multiple\" \nmd-auto-hide=\"false\"><div ng-message=\"required\"><span translate=\"LANDS.ERRORS.FIELD_REQUIRED\"></span></div><div \nng-message=\"pattern\"><span translate=\"LANDS.ERRORS.ONLY_LETTERS\"></span></div></div></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"vm.newLocation\" ng-click=\"vm.addNewLocation()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"locationForm.$invalid || companyForm.$pristine\" \naria-label=\"Add Task\" translate=\"LANDS.ADD_LOCATION\" translate-attr-aria-label=\"LANDS.ADD_LOCATION\">Location\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/farm-admin/land/land/dialogs/land/land-dialog.html","<md-dialog class=\"area-dialog\" aria-label=\"New Task\"><form name=\"areaForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"AREA.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"LANDS.AREA_NAME\"></label><input ng-model=\"vm.area.name\" type=\"text\" \nrequired md-autofocus ng-pattern=\"/^[a-zA-Z\\s]*$/\" md-maxlength=\"50\"><div ng-messages=\"vm.area.name.$error\" \nrole=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\"><span \ntranslate=\"LANDS.ERRORS.FIELD_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"LANDS.ERRORS.ONLY_LETTERS\"></span></div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"vm.newArea\" ng-click=\"vm.addNewArea()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"areaForm.$invalid || companyForm.$pristine\" aria-label=\"Add Task\" translate=\"LANDS.ADD_AREA\" \ntranslate-attr-aria-label=\"LANDS.ADD_AREA\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/farm-admin/land/leases/dialogs/lease-list-blocks/lease-list-blocks-dialog.html","<md-dialog class=\"list-blocks-dialog\" aria-label=\"List Blocks\"><ms-lease-list-blocks data-lease=\"vm.lease\" \naria-label=\"List Blocks\"></ms-lease-list-blocks></md-dialog>");
$templateCache.put("app/main/farm-admin/land/leases/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">Lease Filter</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\"><div class=\"custom-padding\"><md-input-container \nclass=\"md-block\" flex-gt-sm ng-if=\"vm.locations.length>0\"><label>Location name</label><md-select \nng-model=\"vm.location_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.location_id ? vm.filterChange(\'location\',vm.location_id,vm.location_name,true) : \'\'\"><md-option \nng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" \nng-click=\"vm.filterChange(\'location\',location.id,location.name) \">{{location.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.ranches.length>0\"><label>Ranch name\n</label><md-select ng-model=\"vm.ranch_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.filterData.ranch_id ? vm.filterChange(\'ranch\',vm.filterData.ranch_id,vm.filterData.ranch_name,true) : \'\'\">\n<md-option ng-repeat=\"ranch in vm.ranches\" value=\"{{ranch.id}}\" \nng-click=\"vm.filterChange(\'ranch\',ranch.id,ranch.name)\">{{ranch.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.blocks.length>0\"><label>Block name</label><md-select \nng-model=\"vm.block_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.filterData.block_id ? vm.filterChange(\'block\',vm.filterData.block_id,vm.filterData.block_name,true) : \'\'\">\n<md-option ng-repeat=\"block in vm.blocks\" value=\"{{block.id}}\" ng-click=\"vm.filterChange(\'block\',block.id,block.name)\">\n{{block.name}}</md-option></md-select></md-input-container></div><md-divider></md-divider><md-list-item \naria-label=\"filter-all\" ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType.name ===\'all\'}\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"LEASES.ALL_LEASES\"></p></md-list-item><md-divider></md-divider>\n<v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header><md-list-item>Filter by\n</md-list-item></v-pane-header><v-pane-content><md-list-item aria-label=\"filter-active\" \nng-click=\"vm.filterChange(\'active\');\" ng-class=\"{\'selected\':  vm.filteredState === \'active\' }\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"LEASES.ACTIVE\"></p></md-list-item><md-list-item \naria-label=\"filter-future\" ng-click=\"vm.filterChange(\'future\');\" \nng-class=\"{\'selected\':  vm.filteredState === \'future\' }\" ng-disabled=\"vm.loadListFiltered\"><p \ntranslate=\"LEASES.FUTURE\"></p></md-list-item><md-list-item aria-label=\"filter-expiring\" \nng-click=\"vm.filterChange(\'expiring\');\" ng-class=\"{\'selected\':  vm.filteredState === \'expiring\' }\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"LEASES.EXPIRING\"></p></md-list-item><md-list-item \naria-label=\"filter-expired\" ng-click=\"vm.filterChange(\'expired\');\" \nng-class=\"{\'selected\':  vm.filteredState === \'expired\' }\" ng-disabled=\"vm.loadListFiltered\"><p \ntranslate=\"LEASES.EXPIRED\"></p></md-list-item><md-list-item aria-label=\"filter-subleased\" \nng-click=\"vm.filterChange(\'subleased\');\" ng-class=\"{\'selected\':  vm.filteredSubleased }\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"LEASES.SUBLEASED\"></p></md-list-item><md-list-item \naria-label=\"filter-starred\" ng-click=\"vm.filterChange(\'starred\');\" ng-class=\"{\'selected\':  vm.filteredStarred }\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"LEASES.STARRED_LEASES\"></p></md-list-item></v-pane-content></v-pane>\n</v-accordion><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header><md-list-item>\nLand Lord Company</md-list-item></v-pane-header><v-pane-content><md-list-item ng-if=\"vm.landlordCompanies.length>0\" \nng-repeat=\"landlord in vm.landlordCompanies\" ng-click=\"vm.filterChange(\'landlord\',landlord.id, landlord.name)\" \nng-class=\"{\'selected\':  landlord.id === vm.landlord_id}\" ng-disabled=\"vm.loadListFiltered\"><p class=\"pl-8\">\n{{landlord.name}}</p></md-list-item></v-pane-content></v-pane></v-accordion></div>");
$templateCache.put("app/main/farm-admin/land/ranches/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><div><md-icon \nmd-font-icon=\"icon-view-dashboard\"></md-icon></div><div class=\"custom-flex\" flex=\"10\" hide-xs hide-sm></div><span \nclass=\"font-weight-500 font-size-14\">{{vm.company.name}}Ranch Filter</span></div><md-divider></md-divider><div \nms-scroll class=\"content scrollable\"><div class=\"custom-padding\"><md-input-container class=\"md-block\" flex-gt-sm>\n<label>Location</label><md-select ng-model=\"vm.location_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.location_id ? vm.filterChange(\'location\',vm.location_id,vm.location_name,500) : \'\'\"><md-option \nng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" \nng-click=\"vm.filterChange(\'location\',location.id, location.name); vm.listType.name = location.name \">{{location.name}}\n</md-option></md-select></md-input-container></div><md-divider></md-divider><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType.name ===\'all\'}\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"RANCHES.ALL_RANCHES\">All Ranches</p></md-list-item><md-list-item \naria-label=\"filter-starred\" ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\': vm.filteredStarred }\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"RANCHES.STARRED_RANCHES\">Starred Ranches</p></md-list-item>\n<md-list-item aria-label=\"filter-starred\" ng-click=\"vm.filterChange(\'active\')\" \nng-class=\"{\'selected\': vm.filteredActive }\" ng-disabled=\"vm.loadListFiltered\"><p translate=\"RANCHES.ACTIVE_RANCHES\">\nActive Ranches</p></md-list-item></div>");
$templateCache.put("app/main/farm-admin/land/subleases/dialogs/sublease-list-blocks/sublease-list-blocks-dialog.html","<md-dialog class=\"list-blocks-dialog\" aria-label=\"List Blocks\"><ms-lease-list-blocks data-lease=\"vm.sublease\" \naria-label=\"List Blocks\"></ms-lease-list-blocks></md-dialog>");
$templateCache.put("app/main/farm-admin/land/subleases/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">Sublease Filter</span></div>\n<md-divider></md-divider><div ms-scroll class=\"content scrollable\"><div class=\"custom-padding\"><md-input-container \nclass=\"md-block\" flex-gt-sm ng-if=\"vm.locations.length>0\"><label>Location name</label><md-select \nng-model=\"vm.location_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.location_id ? vm.filterChange(\'location\',vm.location_id,vm.location_name,true) : \'\'\"><md-option \nng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" \nng-click=\"vm.filterChange(\'location\',location.id,location.name)\">{{location.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.ranches.length>0\"><label>Ranch name\n</label><md-select ng-model=\"vm.ranch_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.filterData.ranch_id ? vm.filterChange(\'ranch\',vm.filterData.ranch_id,vm.filterData.ranch_name,true) : \'\'\">\n<md-option ng-repeat=\"ranch in vm.ranches\" value=\"{{ranch.id}}\" \nng-click=\"vm.filterChange(\'ranch\',ranch.id,ranch.name)\">{{ranch.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.blocks.length>0\"><label>Block name</label><md-select \nng-model=\"vm.block_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.filterData.block_id ? vm.filterChange(\'block\',vm.filterData.block_id,vm.filterData.block_name,true) : \'\'\">\n<md-option ng-repeat=\"block in vm.blocks\" value=\"{{block.id}}\" \nng-click=\"vm.filterChange(\'block\',block.id, block.name)\">{{block.name}}</md-option></md-select></md-input-container>\n</div><md-divider></md-divider><md-list-item aria-label=\"filter-all\" ng-click=\"vm.filterChange(\'all\')\" \nng-class=\"{\'selected\':vm.listType.name ===\'all\'}\" ng-disabled=\"vm.loadListFiltered\"><p \ntranslate=\"SUBLEASES.ALL_SUBLEASES\"></p></md-list-item><md-divider></md-divider><v-accordion \nclass=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header><md-list-item>Filter by</md-list-item>\n</v-pane-header><v-pane-content><md-list-item aria-label=\"filter-active\" ng-click=\"vm.filterChange(\'active\');\" \nng-class=\"{\'selected\':  vm.filteredState === \'active\' }\" ng-disabled=\"vm.loadListFiltered\"><p \ntranslate=\"SUBLEASES.ACTIVE\"></p></md-list-item><md-list-item aria-label=\"filter-future\" \nng-click=\"vm.filterChange(\'future\');\" ng-class=\"{\'selected\':  vm.filteredState === \'future\' }\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"LEASES.FUTURE\"></p></md-list-item><md-list-item \naria-label=\"filter-expiring\" ng-click=\"vm.filterChange(\'expiring\');\" \nng-class=\"{\'selected\':  vm.filteredState === \'expiring\' }\" ng-disabled=\"vm.loadListFiltered\"><p \ntranslate=\"SUBLEASES.EXPIRING\"></p></md-list-item><md-list-item aria-label=\"filter-expired\" \nng-click=\"vm.filterChange(\'expired\');\" ng-class=\"{\'selected\':  vm.filteredState === \'expired\' }\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"SUBLEASES.EXPIRED\"></p></md-list-item><md-list-item \naria-label=\"filter-starred\" ng-click=\"vm.filterChange(\'starred\');\" ng-class=\"{\'selected\':  vm.filteredStarred }\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"SUBLEASES.STARRED_SUBLEASES\"></p></md-list-item></v-pane-content>\n</v-pane></v-accordion><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header>\n<md-list-item>Tenant Company</md-list-item></v-pane-header><v-pane-content><md-list-item \nng-if=\"vm.tenantCompanies.length>0\" ng-repeat=\"tenant in vm.tenantCompanies\" \nng-click=\"vm.filterChange(\'tenant\',tenant.id, tenant.name)\" ng-class=\"{\'selected\':  tenant.id === vm.tenant_id}\" \nng-disabled=\"vm.loadListFiltered\"><p class=\"pl-8\">{{tenant.name}}</p></md-list-item></v-pane-content></v-pane>\n</v-accordion></div>");
$templateCache.put("app/main/farm-admin/users/companies/dialogs/company/company-dialog.html","<md-dialog class=\"company-dialog\" aria-label=\"New Task\"><form name=\"companyForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog(true)\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"COMPANIES.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div class=\"clickeable\" name=\"file\" \nngf-select=\"vm.openImgCropDialog(event,$file)\" ngf-max-size=\"1MB\" ng-model=\"vm.picFile\" accept=\"image/*\" \nngf-resize=\"{width: 250, height: 250}\" ngf-before-model-change=\"vm.invalidImage($files)\" layout=\"column\" \nlayout-align=\"center center\"><md-tooltip md-direction=\"top\"><span>Logo</span></md-tooltip><span \nng-if=\"companyForm.$dirty && companyForm.file.$error.maxSize\" class=\"danger\">Max file size 1MB</span> <img \nhttp-src=\"{{vm.company.image_url  || \'assets/images/avatars/office.png\'}}\" class=\"company-avatar\" \nalt=\"{{vm.company.name}}\"><div class=\"company-name\">{{vm.company.name}}</div></div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleInArray(vm.company.id, vm.starredCompanies);vm.starredCompany(vm.company);\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"COMPANIES.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.company.starred\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.company.starred\" \nmd-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu><md-button ng-show=\"vm.company.br \" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" ng-mouseup=\"vm.setMenuWidth()\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"TODO.MORE\"><md-tooltip><span translate=\"COMPANIES.BUSINESS_ROLES\"></span></md-tooltip>\n<md-icon md-font-icon=\"icon-account-multiple-plus\"></md-icon></md-button><md-menu-content width=\"3\"><md-subheader \nclass=\"md-no-sticky\" ng-if=\"vm.allBusinessGroups\">Business Roles</md-subheader><md-menu-item class=\"md-menu-item\">\n<md-button class=\"md-button-br\" ng-if=\"vm.company.br\" ng-repeat=\"group in vm.allBusinessGroups\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" ng-click=\"vm.addToCompanyBusinessRoles(vm.company, group)\"><p \nclass=\"pl-8\" \nng-class=\"{\'header-color\':vm.exists(group.id, vm.company.br),\'fw-500\':vm.exists(group.id, vm.company.br)}\">\n{{ group.name }}</p></md-button></md-menu-item></md-menu-content></md-menu></div></div></md-toolbar><md-dialog-content \nms-scroll><md-input-container class=\"md-icon-float md-block\"><label translate=\"COMPANIES.COMPANY_NAME\"></label><md-icon\n md-font-icon=\"icon-domain\" class=\"name\"></md-icon><input ng-model=\"vm.company.name\" type=\"text\" required md-autofocus \nmd-maxlength=\"50\"><div ng-messages=\"vm.company.name.$error\" role=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"required\"><span translate=\"COMPANIES.FIELD_REQUIRED\"></span></div><div ng-message=\"pattern\"><span \ntranslate=\"COMPANIES.ONLY_LETTERS\"></span></div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"COMPANIES.PERSON_CONTACT\"></label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.company.contact_person\" type=\"text\" required \nmd-maxlength=\"50\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"COMPANIES.EMAIL\"></label><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon><input \nng-model=\"vm.company.email_address\" type=\"email\" required md-maxlength=\"50\"></md-input-container><md-autocomplete \nclass=\"black-text\" required md-selected-item=\"vm.company.country\" md-no-cache=\"false\" \nmd-search-text-change=\"vm.searchTextChange(vm.countrySearchText)\" md-search-text=\"vm.countrySearchText\" \nmd-selected-item-change=\"vm.selectedCountryChange(item)\" md-items=\"item in vm.queryCountry(vm.countrySearchText)\" \nmd-item-text=\"item\" md-min-length=\"0\" md-require-match md-floating-label=\"Country\"><md-item-template><span \nmd-highlight-text=\"vm.countrySearchText\" md-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>\nNo results matching \"{{vm.countrySearchText}}\" were found.</md-not-found></md-autocomplete><md-autocomplete \nstyle=\"margin-bottom: -18px\" ng-if=\"vm.company.country==\'United States\'\" class=\"black-text\" required \nmd-selected-item=\"vm.company.state\" md-no-cache=\"false\" \nmd-search-text-change=\"vm.searchTextChangeState(vm.stateSearchText)\" md-search-text=\"vm.stateSearchText\" \nmd-selected-item-change=\"vm.selectedStateChange(item)\" md-items=\"item in vm.queryState(vm.stateSearchText)\" \nmd-item-text=\"item\" md-min-length=\"0\" md-require-match md-floating-label=\"State\"><md-item-template><span \nmd-highlight-text=\"vm.stateSearchText\" md-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>\nNo results matching \"{{vm.stateSearchText}}\" were found.</md-not-found></md-autocomplete><md-input-container \nclass=\"md-block\" flex-gt-sm><md-icon></md-icon><label translate=\"COMPANIES.CITY\"></label><input \nng-change=\"changeCity()\" ng-model=\"vm.company.city\" type=\"text\" required md-maxlength=\"30\"></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"COMPANIES.ADDRESS1\"></label><md-icon \nmd-font-icon=\"icon-home\"></md-icon><input ng-change=\"changeAddress1()\" ng-model=\"vm.company.address1\" type=\"text\" \nrequired md-maxlength=\"50\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"COMPANIES.ADDRESS2\"></label><md-icon md-font-icon=\"icon-home\"></md-icon><input ng-change=\"changeAddress2()\" \nng-model=\"vm.company.address2\" type=\"text\" md-maxlength=\"50\"></md-input-container><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"COMPANIES.ZIPCODE\"></label><md-icon></md-icon><input ng-change=\"changeZipcode()\" \nng-model=\"vm.company.zipcode\" type=\"text\" required md-maxlength=\"12\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm><label translate=\"COMPANIES.OFFICE_PHONE\"></label><md-icon md-font-icon=\"icon-phone\">\n</md-icon><input ng-model=\"vm.company.office_phone\" ui-mask=\"{{vm.phoneMask}}\" ng-pattern=\"/^[0-9\\+\\-\\\\)\\\\(\\\\ \\/]*$/\" \nrequired></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"COMPANIES.MOBILE_PHONE\"></label><md-icon md-font-icon=\"icon-phone\"></md-icon><input \nng-model=\"vm.company.cell_phone\" ui-mask=\"{{vm.phoneMask}}\" ng-pattern=\"/^[0-9\\+\\-\\\\)\\\\(\\\\ \\/]*$/\" required>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"COMPANIES.FAX_PHONE\"></label>\n<md-icon md-font-icon=\"icon-phone\"></md-icon><input ng-model=\"vm.company.fax\" ui-mask=\"{{vm.phoneMask}}\" \nng-pattern=\"/^[0-9\\+\\-\\\\)\\\\(\\\\ \\/]*$/\" required></md-input-container><md-input-container class=\"md-block\" flex-gt-sm>\n<md-switch ng-model=\"vm.sameShippingAddress\" aria-label=\"\">{{\"COMPANIES.SHIPPING_SWITCH\"|translate}}</md-switch>\n</md-input-container><div ng-if=\"!vm.sameShippingAddress\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"COMPANIES.SHIPPING_ADDRESS1\"></label><md-icon md-font-icon=\"icon-home\"></md-icon><input \nng-model=\"vm.company.shipping_address1\" type=\"text\" required md-maxlength=\"50\"></md-input-container><md-input-container\n class=\"md-block\" flex-gt-sm><label translate=\"COMPANIES.SHIPPING_ADDRESS2\"></label><md-icon md-font-icon=\"icon-home\">\n</md-icon><input ng-model=\"vm.company.shipping_address2\" type=\"text\" md-maxlength=\"50\"></md-input-container>\n<md-autocomplete style=\"margin-bottom: -18px\" ng-if=\"vm.company.country==\'United States\'\" flex-gt-sm \nclass=\"black-text\" required md-selected-item=\"vm.company.shipping_state\" md-no-cache=\"false\" \nmd-search-text-change=\"vm.searchTextChangeState(vm.shippingStateSearchText)\" \nmd-search-text=\"vm.shippingStateSearchText\" md-items=\"item in vm.queryState(vm.shippingStateSearchText)\" \nmd-item-text=\"item\" md-min-length=\"0\" md-require-match md-floating-label=\"Shipping State\"><md-item-template><span \nmd-highlight-text=\"vm.stateSearchText\" md-highlight-flags=\"^i\">{{item}}</span></md-item-template><md-not-found>\nNo results matching \"{{vm.stateSearchText}}\" were found.</md-not-found></md-autocomplete><md-input-container \nclass=\"md-block\" flex-gt-sm><md-icon></md-icon><label translate=\"COMPANIES.SHIPPING_CITY\"></label><input \nng-change=\"radioShippingChange()\" ng-model=\"vm.company.shipping_city\" type=\"text\" required md-maxlength=\"30\">\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"COMPANIES.SHIPPING_ZIPCODE\">\n</label><md-icon></md-icon><input ng-model=\"vm.company.shipping_zipcode\" type=\"text\" required md-maxlength=\"12\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newCompany\" ng-click=\"vm.saveCompany()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"companyForm.$invalid \" aria-label=\"SAVE\" \ntranslate=\"COMPANIES.SAVE\" translate-attr-aria-label=\"COMPANIES.SAVE\">SAVE</md-button><md-button type=\"submit\" \nng-if=\"vm.newCompany\" ng-click=\"vm.addNewCompany()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"companyForm.$invalid || companyForm.$pristine\" aria-label=\"Add Task\" translate=\"COMPANIES.ADD_COMPANY\" \ntranslate-attr-aria-label=\"COMPANIES.ADD_COMPANY\">ADD COMPANY</md-button></div><div layout=\"row\"><md-button \nng-if=\"vm.company.id\" class=\"md-icon-button\" ng-click=\"vm.deleteCompanyConfirm(event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"COMPANIES.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"COMPANIES.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/farm-admin/users/companies/dialogs/company/crop_dialog.html","<md-dialog layout-padding=\"\"><md-dialog-content><div layout=\"column\"><div flex><h3 class=\"text-center\">Crop the image\n</h3></div></div><div layout=\"column\" layout-align=\"center center\"><div class=\"crop-area\" flex><ui-cropper \narea-type=\"rectangle\" change-on-fly=\"false\" style=\"width:350px;height:350px\" class=\"crop-image\" \nimage=\"vm.picFile | ngfDataUrl\" result-image=\"crop_image\"></ui-cropper></div></div><div flex layout=\"column\"><div \nlayout=\"row\" layout-align=\"center center\" flex><div flex><md-dialog-actions layout=\"row\"><md-button \nng-click=\"confirm()\" md-autofocus>Confirm</md-button><md-button ng-click=\"cancel()\">Cancel</md-button>\n</md-dialog-actions></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/farm-admin/users/companies/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">\n{{vm.company.name}}Company Filter</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\">\n<md-list><md-list-item ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p \ntranslate=\"COMPANIES.ALL_COMPANIES\">All Companies</p></md-list-item><md-list-item \nng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"COMPANIES.STARRED_COMPANIES\">Starred Companies</p></md-list-item><md-divider></md-divider><v-accordion \nclass=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header><md-list-item>Business Roles</md-list-item>\n</v-pane-header><v-pane-content><md-list><md-list-item ng-if=\"vm.allBusinessGroups\" \nng-repeat=\"group in vm.allBusinessGroups\" ng-click=\"vm.filterChange(group)\" \nng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">{{group.name}}</p></md-list-item></md-list>\n</v-pane-content></v-pane></v-accordion><div ng-show=\"admin === true\"><md-list-item class=\"new-group-form\" \nng-show=\"newListForm.$visible\"><p class=\"pl-8\" editable-text=\"vm.newGroupName\" e-form=\"newListForm\" \nonaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item class=\"\" ng-click=\"newListForm.$show()\" \nng-hide=\"newListForm.$visible\" aria-label=\"New Business Role\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"COMPANIES.NEW_BUSINESS_ROLE\"></p></md-list-item><md-button type=\"submit\" \nclass=\"form-button md-accent md-raised\" ng-show=\"newListForm.$visible\" ng-click=\"newListForm.$save()\">Create\n</md-button><md-button type=\"button\" class=\"form-button md-accent md-raised\" ng-show=\"newListForm.$visible\" \nng-click=\"newListForm.$cancel();\">Cancel</md-button></div></md-list></div>");
$templateCache.put("app/main/farm-admin/users/users/dialogs/notify-group/add-edit-notify-group.html","<md-dialog class=\"notify-group-dialog\" aria-label=\"New Task\"><form name=\"notifyGroupForm\" class=\"md-inline-form\" \nnovalidate><md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"USERS.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-middle\" flex layout=\"column\" layout-align=\"center center\"><div \nlayout=\"column\" layout-align=\"center center\"><div class=\"user-name\">{{vm.user.name}}</div></div></div></md-toolbar>\n<md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"USERS.NOTIFY_GROUP_NAME\"></label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nng-model=\"vm.notifyGroup.name\" type=\"text\" required md-autofocus><div ng-messages=\"vm.notifyGroup.name.$error\" \nrole=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\"><span \ntranslate=\"USERS.FIELD_REQUIRED\"></span></div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"!vm.newNotifyGroup\" ng-click=\"vm.saveNotifyGroup()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"notifyGroupForm.$invalid || notifyGroupForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"USERS.NOTIFY_GROUP_SAVE\" translate-attr-aria-label=\"USERS.NOTIFY_GROUP_SAVE\"></md-button><md-button \ntype=\"submit\" ng-if=\"vm.newNotifyGroup\" ng-click=\"vm.addNewNotifyGroup()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"notifyGroupForm.$invalid || notifyGroupForm.$pristine\" aria-label=\"Add Task\" \ntranslate=\"USERS.ADD_NOTIFY_GROUP\" translate-attr-aria-label=\"USERS.ADD_NOTIFY_GROUP\"></md-button></div><div \nlayout=\"row\"><md-button ng-if=\"!vm.newNotifyGroup\" class=\"md-icon-button\" \nng-click=\"vm.deleteNotifyGroupConfirm($event)\" aria-label=\"Delete\" translate translate-attr-aria-label=\"USERS.DELETE\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"USERS.DELETE\">DELETE</span></md-tooltip>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/farm-admin/users/users/dialogs/user/add-edit-dialog.html","<md-dialog class=\"user-dialog\" aria-label=\"New Task\"><form name=\"userForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"USERS.CLOSE_DIALOG\"><md-icon\n md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" flex \nlayout=\"column\" layout-align=\"center center\"><div name=\"file\" class=\"clickeable\" \nngf-select=\"vm.openImgCropDialog(event,$file)\" ngf-max-size=\"1MB\" ng-model=\"vm.picFile\" accept=\"image/*\" \nngf-resize=\"{width: 250, height: 250}\" ngf-before-model-change=\"vm.invalidImage($files)\" layout=\"column\" \nlayout-align=\"center center\"><md-tooltip md-direction=\"top\"><span>Avatar</span></md-tooltip><span \nng-if=\"userForm.$dirty && userForm.file.$error.maxSize\" class=\"danger\">Max file size 1MB</span> <img \nhttp-src=\"{{vm.user.image_url || \'assets/images/avatars/profile.jpg\'}}\" class=\"md-avatar avatar user-avatar huge\" \nalt=\"{{vm.user.name}}\"><div class=\"user-name\">{{vm.user.name}}</div></div></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\" layout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button\" \nng-click=\"event.stopPropagation();vm.toggleInArray(vm.user.id, vm.starredUsers);vm.starredUser(vm.user);\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.user.starred\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.user.starred\" \nmd-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu><md-button ng-show=\"vm.user.r\" class=\"md-icon-button\" \nng-click=\"$mdMenu.open($event)\" ng-mouseup=\"vm.setMenuWidth()\" aria-label=\"Roles\"><md-tooltip><span \ntranslate=\"USERS.ROLES\"></span></md-tooltip><md-icon md-font-icon=\"icon-account-alert\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-subheader class=\"md-no-sticky\" ng-if=\"vm.allRolesGroups\">Users Roles</md-subheader>\n<md-menu-item class=\"md-menu-item\"><md-button class=\"md-button-br\" ng-if=\"vm.user.r\" \nng-repeat=\"group in vm.allRolesGroups\" md-prevent-menu-close=\"md-prevent-menu-close\" \nng-click=\"vm.addToUserUserRole(vm.user, group)\"><p class=\"pl-8\" \nng-class=\"{\'header-color\':vm.exists(group.id, vm.user.r) ,\'fw-500\':vm.exists(group.id, vm.user.r) }\">{{group.name }}\n</p></md-button></md-menu-item></md-menu-content></md-menu><md-menu><md-button ng-show=\"vm.user.ng\" \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" ng-mouseup=\"vm.setMenuWidth()\" aria-label=\"Notify Group\">\n<md-tooltip><span translate=\"USERS.NOTIFY_GROUP\"></span></md-tooltip><md-icon \nmd-font-icon=\"icon-account-multiple-plus\"></md-icon></md-button><md-menu-content width=\"3\"><md-subheader \nclass=\"md-no-sticky\" ng-if=\"vm.allNotifyGroups\">Notify Groups</md-subheader><md-menu-item class=\"md-menu-item\">\n<md-button class=\"md-button-br\" ng-if=\"vm.allNotifyGroups\" ng-repeat=\"group in vm.allNotifyGroups\" \nmd-prevent-menu-close=\"md-prevent-menu-close\" ng-click=\"vm.addToUserNotifyGroup(vm.user, group)\"><p class=\"pl-8\" \nng-class=\"{\'header-color\':vm.exists(group.id, vm.user.ng)  ,\'fw-500\':vm.exists(group.id, vm.user.ng)}\">{{ group.name }}\n</p></md-button></md-menu-item></md-menu-content></md-menu></div></div></md-toolbar><md-dialog-content ms-scroll>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"USERS.NAME_REQUIRED\"></label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.user.name\" type=\"text\" \nng-pattern=\"/^[a-zA-Z\\s]*$/\" md-maxlength=\"50\" required md-autofocus><div ng-messages=\"vm.user.name.$error\" \nrole=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div ng-message=\"required\"><span \ntranslate=\"USERS.FIELD_REQUIRED\"></span></div><div ng-message=\"pattern\"><span translate=\"USERS.ONLY_LETTERS\"></span>\n</div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"USERS.NICKNAME\">\n</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.user.login_name\" type=\"text\" \nmd-maxlength=\"30\" required></md-input-container><md-autocomplete style=\"margin-bottom: -18px\" class=\"black-text\" \nrequired md-selected-item=\"vm.user.company\" md-no-cache=\"false\" \nmd-search-text-change=\"vm.searchTextChange(vm.companySearchText)\" md-search-text=\"vm.companySearchText\" \nmd-selected-item-change=\"vm.selectedCompanyChange(item)\" md-items=\"item in vm.queryCompany(vm.companySearchText)\" \nmd-item-text=\"item.name\" md-min-length=\"0\" md-require-match md-floating-label=\"Company\"><md-item-template><span \nmd-highlight-text=\"vm.companySearchText\" md-highlight-flags=\"^i\">{{item.name}}</span></md-item-template><md-not-found>\nNo results matching \"{{vm.companySearchText}}\" were found.</md-not-found></md-autocomplete><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"USERS.EMAIL\"></label><md-icon md-font-icon=\"icon-email\" class=\"email\">\n</md-icon><input ng-model=\"vm.user.email_address\" type=\"email\" md-maxlength=\"30\" required></md-input-container>\n<md-input-container class=\"md-icon-float md-block\"><label translate=\"USERS.PASSWORD\"></label><md-icon \nmd-font-icon=\"icon-lock\" class=\"password\"></md-icon><input ng-model=\"vm.user.password\" id=\"password\" name=\"password\" \ntype=\"password\" md-maxlength=\"50\" ng-required=\"vm.newUser\"></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"USERS.PASSWORD_CONFIRM\"></label><md-icon md-font-icon=\"icon-lock\" \nclass=\"password\"></md-icon><input ng-keydown=\"vm.checkTabKey($event);\" pw-check=\"password\" name=\"password_confirm\" \nng-model=\"vm.user.password_confirm\" type=\"password\" ng-pattern=\"/^.{6,}$/\" md-maxlength=\"50\" ng-required=\"vm.newUser\">\n<div ng-messages=\"userForm.password_confirm.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"USERS.PASSWORD_REQUIRED\"></span></div><div ng-message=\"pattern\"><span translate=\"USERS.PASSWORD_LENGTH\">\n</span></div><div ng-message=\"pwmatch\"><span translate=\"USERS.PASSWORD_NOT_MATCH\"></span></div></div>\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon>\n<label translate=\"USERS.CELL_PHONE\"></label><input ng-model=\"vm.user.cell_phone\" ui-mask=\"{{vm.phoneMask}}\" \nng-pattern=\"/^[0-9\\+\\-\\\\)\\\\(\\\\ \\/]*$/\" required></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-domain\"></md-icon><label translate=\"USERS.OFFICE_PHONE\"></label><input \nng-model=\"vm.user.office_phone\" ui-mask=\"{{vm.phoneMask}}\" ng-pattern=\"/^[0-9\\+\\-\\\\)\\\\(\\\\ \\/]*$/\"></md-input-container>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-domain\"></md-icon><label translate=\"USERS.FAX\">\n</label><input ng-model=\"vm.user.fax\" ui-mask=\"{{vm.phoneMask}}\" ng-pattern=\"/^[0-9\\+\\-\\\\)\\\\(\\\\ \\/]*$/\">\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newUser\" ng-click=\"vm.saveUser()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"userForm.$invalid\" aria-label=\"SAVE\" translate=\"USERS.SAVE\" \ntranslate-attr-aria-label=\"USERS.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newUser\" \nng-click=\"vm.addNewUser()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"userForm.$invalid || userForm.$pristine\" aria-label=\"Add Task\" translate=\"USERS.ADD_USER\" \ntranslate-attr-aria-label=\"USERS.ADD_USER\">ADD USER</md-button></div><div layout=\"row\"><md-button ng-if=\"vm.user.id\" \nclass=\"md-icon-button\" ng-click=\"vm.deleteUserConfirm(event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"USERS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"USERS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/farm-admin/users/users/dialogs/user/crop_dialog.html","<md-dialog layout-padding=\"\"><md-dialog-content><div layout=\"column\"><div flex><h3 class=\"text-center\">Crop the image\n</h3></div></div><div layout=\"column\" layout-align=\"center center\"><div class=\"crop-area\" flex><ui-cropper \narea-type=\"circle\" style=\"width:350px;height:350px\" class=\"crop-image\" image=\"vm.picFile | ngfDataUrl\" \nresult-image=\"crop_image\"></ui-cropper></div></div><div flex layout=\"column\"><div layout=\"row\" \nlayout-align=\"center center\" flex><div flex><md-dialog-actions layout=\"row\"><md-button ng-click=\"confirm()\" \nmd-autofocus>Confirm</md-button><md-button ng-click=\"cancel()\">Cancel</md-button></md-dialog-actions></div></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/farm-admin/users/users/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\" style=\"height: 40px\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"title font-weight-500 font-size-14\" \ntranslate=\"USERS.USER_FILTER\"></span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list>\n<md-list-item ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p \ntranslate=\"USERS.ALL_USERS\">All Contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" \nng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p translate=\"USERS.STARRED_USERS\">Starred Contacts</p></md-list-item>\n<md-divider></md-divider><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header>\n<md-list-item>User Roles</md-list-item></v-pane-header><v-pane-content><md-list><md-list-item \nng-if=\"vm.allRolesGroups\" ng-repeat=\"group in vm.allRolesGroups\" ng-click=\"vm.filterChange(group, \'roles\')\" \nng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">{{ group.name }}</p></md-list-item></md-list>\n</v-pane-content></v-pane></v-accordion><v-accordion class=\"vAccordion--default\" multiple=\"multiple\" \nng-if=\"vm.allNotifyGroups.length > 0\"><v-pane><v-pane-header md-ink-ripple><md-list-item>Notify Groups</md-list-item>\n</v-pane-header><v-pane-content><md-list><md-list-item ng-if=\"vm.allNotifyGroups\" \nng-repeat=\"group in vm.allNotifyGroups\" ng-click=\"vm.filterChange(group, \'notify_groups\')\" \nng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">{{ group.name}}</p></md-list-item></md-list>\n</v-pane-content></v-pane></v-accordion><div ng-show=\"admin === true\"><md-list-item class=\"new-group-form\" \nng-show=\"newListForm.$visible\"><p class=\"pl-8\" editable-text=\"vm.newGroupName\" e-form=\"newListForm\" \nonaftersave=\"vm.addNewRoleGroup()\"></p></md-list-item><md-list-item class=\"\" ng-click=\"newListForm.$show()\" \nng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" translate=\"USERS.NEW_ROLE_GROUP\">New Role</p>\n</md-list-item><md-button type=\"submit\" class=\"form-button md-accent md-raised\" ng-show=\"newListForm.$visible\" \nng-click=\"newListForm.$save()\">Create</md-button><md-button type=\"button\" class=\"form-button md-accent md-raised\" \nng-show=\"newListForm.$visible\" ng-click=\"newListForm.$cancel();\">Cancel</md-button></div><div><md-list-item \nclass=\"new-group-form\" ng-show=\"newListForm2.$visible\"><p class=\"pl-8\" editable-text=\"vm.newGroupName2\" \ne-form=\"newListForm2\" onaftersave=\"vm.addNewNotifyGroup()\"></p></md-list-item><md-list-item class=\"\" \nng-click=\"newListForm2.$show()\" ng-hide=\"newListForm2.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"USERS.NEW_NOTIFY_GROUP\">New Notify Group</p></md-list-item><md-button type=\"submit\" \nclass=\"form-button md-accent md-raised\" ng-show=\"newListForm2.$visible\" ng-click=\"newListForm2.$save()\">Create\n</md-button><md-button type=\"button\" class=\"form-button md-accent md-raised\" ng-show=\"newListForm2.$visible\" \nng-click=\"newListForm2.$cancel();\">Cancel</md-button></div></md-list></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-schedule-tasks/task/dialog/task-dialog.html","<md-dialog flex=\"80\" aria-label=\"New Task\"><div ng-form=\"vm.TaskDialogForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall height-64\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button \nclass=\"md-icon-button\" ng-click=\"vm.cancelDialog()\" aria-label=\"Close dialog\" translate \ntranslate-attr-aria-label=\"AREA.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div layout=\"row\" flex><md-input-container ng-if=\"!vm.isGanttTaskDialog\" \nflex=\"50\"><label translate=\"TASK.DIALOG_NAME\"></label><input type=\"text\" required ng-model=\"vm.task.name\">\n</md-input-container><md-input-container ng-if=\"vm.isGanttTaskDialog\" flex=\"50\"><label>Task</label><md-select \nng-change=\"vm.changeSelectedTask();\" required ng-model=\"vm.selectedTask\"><md-option ng-repeat=\"task in vm.tasks\" \nng-value=\"task\">{{task.name}}</md-option></md-select></md-input-container><md-input-container flex=\"50\"><label \ntranslate=\"TASK.DIALOG_FOREMAN\"></label><md-select required ng-model=\"vm.task.user_role_id\"><md-option \nng-repeat=\"role in vm.roles\" ng-value=\"role.id\">{{role.name}}</md-option></md-select></md-input-container></div><div \nlayout=\"row\" flex ng-if=\"vm.isGanttTaskDialog && vm.ganttBlockMode != false\"><md-input-container layout-wrap flex=\"50\">\n<md-datepicker flex layout-wrap class=\"no-margin\" required md-open-on-focus ng-model=\"vm.task.date\" \nmd-placeholder=\"Date\"></md-datepicker></md-input-container><md-input-container flex=\"50\" class=\"padding-left-5\"><label>\nPhase</label><md-select required ng-model=\"vm.task.phase\"><md-option \nng-repeat=\"phase in vm.block.work_template.phases\" ng-value=\"phase\">{{phase.name}}</md-option></md-select>\n</md-input-container></div><div layout=\"row\" flex><md-input-container flex=\"50\"><label \ntranslate=\"TASK.EQUIPMENT_GROUP\"></label><md-select required ng-model=\"vm.task.equipment_task_group_id\"><md-option \nng-repeat=\"notify in vm.notifyGroups\" ng-value=\"notify.id\">{{notify.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"50\"><label translate=\"TASK.LABOR_GROUP\"></label><md-select required \nng-model=\"vm.task.labor_task_group_id\"><md-option ng-repeat=\"notify in vm.notifyGroups\" ng-value=\"notify.id\">\n{{notify.name}}</md-option></md-select></md-input-container></div><div layout=\"row\" flex><md-input-container flex=\"25\">\n<md-switch ng-model=\"vm.task.notify_at_start\" aria-label=\"Switch 1\">Notify at Start</md-switch></md-input-container>\n<md-input-container flex=\"25\"><md-switch ng-model=\"vm.task.notify_at_end\" aria-label=\"Switch 1\">Notify at End\n</md-switch></md-input-container><md-input-container flex=\"25\"><md-switch ng-model=\"vm.task.auto_start\" \naria-label=\"Switch 1\">Auto Start</md-switch></md-input-container><md-input-container flex=\"25\"><md-switch \nng-model=\"vm.task.daylight_only\" aria-label=\"Switch 1\">Daylight Only</md-switch></md-input-container></div><div \nlayout=\"row\" flex><md-input-container flex=\"50\"><label>Task anchor type</label><md-select required \nng-model=\"vm.task.anchor_id\"><md-option ng-repeat=\"anchorType in vm.anchorDefinitions\" \nng-value=\"vm.getAnchorValue(anchorType)\">{{anchorType.name}}</md-option></md-select></md-input-container><div \nflex=\"50\"><md-button class=\"no-padding no-margin margin-top-16\"><div flex layout=\"row\" layout-align=\"center center\">\n<label>Color:</label><div ng-click=\"vm.openColorPicker($event,vm.task)\" class=\"badge no-text clickeable\" \nng-style=\"{\'background-color\':vm.task.color,\'margin-left\':\'20px\'}\"></div></div></md-button></div></div><div \nlayout=\"row\" flex><md-input-container flex=\"50\"><md-switch class=\"margin-top-0\" \nng-model=\"vm.task.time_to_complete_mesured_by_acre\" aria-label=\"Switch 1\">Time Measured by Acre</md-switch>\n</md-input-container><md-input-container ng-if=\"vm.task.time_to_complete_mesured_by_acre\" flex=\"50\"><label \ntranslate=\"TASK.ESTIMATED_MINUTES\"></label><input min=\"1\" name=\"estimated01\" type=\"number\" \nng-required=\"vm.task.time_to_complete_mesured_by_acre\" ng-model=\"vm.task.estimated_minutes\"><div \nng-messages=\"vm.TaskDialogForm.estimated01.$error\" role=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"min\"><span>The estimated minutes must be greater than 0</span></div></div></md-input-container>\n<md-input-container ng-if=\"!vm.task.time_to_complete_mesured_by_acre\" flex=\"50\"><label \ntranslate=\"TASK.ESTIMATED_MINUTES2\"></label><input min=\"1\" name=\"estimated02\" type=\"number\" \nng-required=\"!vm.task.time_to_complete_mesured_by_acre\" ng-model=\"vm.task.estimated_minutes2\"><div \nng-messages=\"vm.TaskDialogForm.estimated02.$error\" role=\"alert\" multiple=\"multiple\" md-auto-hide=\"false\"><div \nng-message=\"min\"><span>The estimated minutes must be greater than 0</span></div></div></md-input-container></div><div \nlayout=\"row\" flex><label translate=\"TASK.NOTIFY_GROUP\"></label></div><div layout=\"row\" flex><md-input-container \nng-repeat=\"notify in vm.notifyGroups\" flex=\"20\"><md-checkbox ng-click=\"vm.updateTaskModel(vm.task,notify)\" \nng-checked=\"vm.exists(notify.id, vm.task.ng)\" ng-value=\"notify.id\">{{notify.name}}</md-checkbox></md-input-container>\n</div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"!vm.isGanttTaskDialog\"><md-button ng-disabled=\"vm.TaskDialogForm.$invalid\" \ntype=\"submit\" ng-if=\"vm.new_task\" ng-click=\"vm.addNewTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.phaseTypeForm.$invalid || vm.phaseTypeForm.$pristine\" aria-label=\"Add Task\" translate=\"TASK.ADD_TASK\" \ntranslate-attr-aria-label=\"TASK.ADD_TASK\"></md-button><md-button ng-disabled=\"vm.TaskDialogForm.$invalid\" \ntype=\"submit\" ng-if=\"!vm.new_task\" ng-click=\"vm.editTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.phaseTypeForm.$invalid || vm.phaseTypeForm.$pristine\" aria-label=\"Edit Task\" \ntranslate=\"TASK.EDIT_TASK\" translate-attr-aria-label=\"TASK.EDIT_TASK\"></md-button></div><div layout=\"row\" \nlayout-align=\"start center\" ng-if=\"vm.isGanttTaskDialog\"><md-button ng-disabled=\"vm.TaskDialogForm.$invalid\" \ntype=\"submit\" ng-if=\"vm.new_task\" ng-click=\"vm.addNewTaskGantt()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"vm.phaseTypeForm.$invalid || vm.phaseTypeForm.$pristine\" aria-label=\"Add Task\" translate=\"TASK.ADD_TASK\" \ntranslate-attr-aria-label=\"TASK.ADD_TASK\"></md-button></div></md-dialog-actions></div></md-dialog>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-template/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\" style=\"height: 40px\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"title font-weight-500 font-size-14\" \ntranslate=\"WORK_TEMPLATE.WORK_FILTER\"></span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\">\n<md-list><md-list-item ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p \ntranslate=\"WORK_TEMPLATE.ALL_TEMPLATE\">All Contacts</p></md-list-item><md-list-item \nng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"WORK_TEMPLATE.STARRED_TEMPLATE\">Starred Contacts</p></md-list-item><md-divider></md-divider><v-accordion \nclass=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header><md-list-item>Seasons</md-list-item>\n</v-pane-header><v-pane-content><md-list><md-list-item ng-if=\"vm.seasons\" ng-repeat=\"group in vm.seasons\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{ group.name }}</p></md-list-item></md-list></v-pane-content></v-pane></v-accordion><v-accordion \nclass=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header md-ink-ripple><md-list-item>Seeds</md-list-item>\n</v-pane-header><v-pane-content><md-list><md-list-item ng-if=\"vm.seeds\" ng-repeat=\"group in vm.seeds\" \nng-click=\"vm.filterChange(group, \'notify_groups\')\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p \nclass=\"pl-8\">{{ group.name }}</p></md-list-item></md-list></v-pane-content></v-pane></v-accordion></md-list></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-template-2/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\" style=\"height: 40px\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"title font-weight-500 font-size-14\" \ntranslate=\"TASK.TASK_FILTER\"></span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list>\n<md-list-item ng-click=\"vm.filterChange(null)\" ng-class=\"{\'selected\':vm.currentFilter == null}\"><p \ntranslate=\"TASK.ALL_TASK\">All Tasks</p></md-list-item><md-divider></md-divider><v-accordion \nclass=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header><md-list-item>Foreman</md-list-item>\n</v-pane-header><v-pane-content><md-list><md-list-item ng-if=\"vm.allRolesGroups\" \nng-repeat=\"group in vm.allRolesGroups\" ng-click=\"vm.filterChange(group.id)\" \nng-class=\"{\'selected\':vm.currentFilter === group.id}\"><p class=\"pl-8\">{{ group.name }}</p></md-list-item></md-list>\n</v-pane-content></v-pane></v-accordion><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane>\n<v-pane-header md-ink-ripple><md-list-item>Tasks</md-list-item></v-pane-header><v-pane-content><md-list><md-list-item \nng-repeat=\"task in vm.getFilteredTasks()\"><div dnd-draggable=\"task\" dnd-effect-allowed=\"link\" layout=\"row\" \nclass=\"clickeable\" flex><i flex=\"10\" class=\"fa fa-bars fs-16\" aria-hidden=\"true\"></i> <i flex=\"10\" \nclass=\"fa fa-edit fs-16\" ng-click=\"vm.openTaskDialog($event,task)\" aria-hidden=\"true\"></i><div flex=\"20\" \nclass=\"badge no-text clickeable\" ng-style=\"{\'background-color\':task.color}\"></div><p flex=\"60\" \nclass=\"pl-8 margin-top-0\">{{ task.name | capitalize }} <b>{{vm.getAnchorShortCode(task.anchor_id)}}</b></p></div>\n</md-list-item></md-list></v-pane-content></v-pane></v-accordion></md-list></div>");
$templateCache.put("app/main/pages/contracts/tabs/sections/documents/documents.html","<ms-file-upload file-entity=\"vm.entity\" file-entity-id=\"vm.contract.id\"></ms-file-upload>");
$templateCache.put("app/main/pages/contracts/tabs/sections/crops/crops.html","<div classs=\"padding-bottom-25\" id=\"crops\"><form name=\"crops-stepper\" hide-save=\"true\" ms-vertical-custom-stepper \nng-submit=\"vm.saveCrops()\" ng-model=\"vm.stepper\" novalidate><ms-vertical-custom-stepper-step ng-form=\"step1\" step=\"1\" \nstep-title=\"\'Contracted Crops\'\"><div \nng-include=\"\'app/main/pages/contracts/tabs/sections/crops/form/scheduled_crops.html\'\"></div>\n</ms-vertical-custom-stepper-step><ms-vertical-custom-stepper-step ng-form=\"step2\" step=\"2\" \nstep-title=\"\'Variety	Wet	Dates\'\"><div \nng-include=\"\'app/main/pages/contracts/tabs/sections/crops/form/variety_wet_dates.html\'\"></div>\n</ms-vertical-custom-stepper-step></form></div>");
$templateCache.put("app/main/pages/contracts/tabs/sections/information/information.html","<form id=\"informationForm\" name=\"vm.informationForm\"><md-card md-theme-watch><md-card-content \nclass=\"contract-information-title\" layout=\"row\"><div flex-gt-xs=\"100\"><div layout-gt-sm=\"row\"><md-card-title \nclass=\"padding-bottom-10\"><md-card-title-text><span class=\"md-headline\">Contract Information</span>\n</md-card-title-text></md-card-title><md-card-actions class=\"no-padding\"><md-button class=\"md-icon-button\" \nng-click=\"vm.setStarred()\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"CONTRACT.TABS.TOGGLE_STARRED\"><md-icon ng-if=\"vm.contract.starred\" md-font-icon=\"icon-star\" \nclass=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.contract.starred\" md-font-icon=\"icon-star-outline\"></md-icon><input \nng-model=\"vm.contract.starred\" type=\"hidden\"></md-button></md-card-actions></div></div></md-card-content>\n<md-card-content flex layout=\"row\"><div class=\"margin-left-20\" flex layout-xs=\"column\" layout-sm=\"column\"><div \nlayout-gt-sm=\"row\" class=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm=\"45\"><md-input-container \nclass=\"md-block padding-bottom-20 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"CONTRACTS.SECTION_INFO.CONTRACT_NUMBER\"></label><md-icon md-font-icon=\"icon-numeric\" class=\"name\"></md-icon>\n<input required name=\"contractNumber\" ng-model=\"vm.contract.number\" maxlength=\"10\" md-maxlength=\"10\" md-autofocus><div \nng-messages=\"vm.informationForm.contractNumber.$error\"><div class=\"error-message\" ng-message=\"required\">\nContract number field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><div \nflex-gt-sm=\"50\" class=\"padding-top-15 padding-bottom-0 margin-bottom-0\"><md-input-container \nclass=\"md-block padding-top-0 margin-top-5 padding-bottom-8 padding-top-0\" flex-gt-sm><label \ntranslate=\"CONTRACTS.SECTION_INFO.SHIPPER\"></label><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><md-select \nname=\"company_id\" required ng-model=\"vm.contract.company_id\"><md-option ng-repeat=\"company in vm.shippers\" \nng-value=\"{{company.id}}\">{{company.name}}</md-option></md-select><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nShipper field is required.</div></div></md-input-container></div></div><div class=\"height-20\" flex=\"5\" hide show-xs \nshow-sm></div><div layout-gt-sm=\"row\" class=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm=\"45\" \nclass=\"padding-left-0 padding-bottom-15 margin-bottom-0\"><md-input-container ng-if=\"vm.contract.id\" \nclass=\"md-block padding-bottom-0 margin-bottom-0 padding-top-0 margin-top-0\" flex-gt-sm><div class=\"signature\"><label \ntranslate=\"CONTRACTS.SECTION_INFO.ACRES\"></label></div><md-icon md-font-icon=\"icon-pine-tree\" class=\"name\"></md-icon>\n<input disabled=\"disabled\" name=\"acres\" ng-model=\"vm.contract.acres\" currency-input=\"acres\" type=\"text\">\n</md-input-container><md-input-container ng-if=\"!vm.contract.id\" \nclass=\"md-block padding-bottom-0 margin-bottom-0 padding-top-0 margin-top-0\" flex-gt-sm><div class=\"signature\"><label \ntranslate=\"CONTRACTS.SECTION_INFO.ACRES\"></label></div><md-icon md-font-icon=\"icon-pine-tree\" class=\"name\"></md-icon>\n<input disabled=\"disabled\" name=\"acres\" ng-model=\"vm.contract.acres\"></md-input-container></div><div flex=\"5\" hide-xs \nhide-sm></div><div class=\"height-25\" flex=\"5\" hide show-xs show-sm></div><div flex-gt-sm=\"50\" \nclass=\"margin-top-0 padding-top-0 padding-left-0 padding-bottom-0 margin-bottom-0\"><md-input-container \nclass=\"md-block padding-top-0 margin-top-5 padding-bottom-8 padding-top-0\" flex><div class=\"signature\"><label \nfor=\"signature\" translate=\"CONTRACTS.SECTION_INFO.SIGNATURE_DATE\"></label></div><md-datepicker md-open-on-focus \nname=\"signature_date\" ng-model=\"vm.contract.signature_date\" required md-date-locale=\"customDateFormat\"></md-datepicker>\n<div ng-messages=\"vm.informationForm.signature_date.$error\"><div class=\"error-message datepicker\" \nng-message=\"required\">Signature Date field is required.</div></div></md-input-container></div></div><div \nclass=\"height-5\" flex=\"5\" hide show-xs show-sm></div><div class=\"padding-bottom-0 margin-bottom-0\" layout-gt-sm=\"row\">\n<div flex-gt-sm=\"45\" class=\"padding-left-0 padding-bottom-15 margin-bottom-0\"><md-input-container \nclass=\"md-block padding-top-0 margin-top-5 padding-bottom-8 padding-top-0\" flex><div class=\"signature\"><label \nfor=\"signature\" translate=\"CONTRACTS.SECTION_INFO.START_DATE\"></label></div><md-datepicker md-open-on-focus \nname=\"start_date\" ng-model=\"vm.contract.start_date\" required md-date-locale=\"customDateFormat\"></md-datepicker><div \nng-messages=\"vm.informationForm.start_date.$error\"><div class=\"error-message datepicker\" ng-message=\"required\">\nStart Date field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><div \nclass=\"height-15\" flex=\"5\" hide show-xs show-sm></div><div flex-gt-sm=\"50\" flex-gt-sm \nclass=\"margin-top-0 padding-top-0 padding-left-0 padding-bottom-0 margin-bottom-0\"><md-input-container \nclass=\"md-block padding-top-0 margin-top-5 padding-bottom-8 padding-top-0\" flex><div class=\"signature\"><label \nfor=\"signature\" translate=\"CONTRACTS.SECTION_INFO.END_DATE\"></label></div><md-datepicker md-open-on-focus \nname=\"end_date\" ng-model=\"vm.contract.end_date\" md-min-date=\"vm.min_start_date || vm.currentDay\" required \nmd-date-locale=\"customDateFormat\"></md-datepicker><div ng-messages=\"vm.informationForm.end_date.$error\"><div \nclass=\"error-message datepicker\" ng-message=\"required\">End Date field is required.</div></div></md-input-container>\n</div></div></div><md-card-actions layout=\"column\"><md-button class=\"md-icon-button\" aria-label=\"Favorite\"></md-button>\n</md-card-actions></md-card-content></md-card><md-card md-theme-watch><md-card-title><md-card-title-text><span \nclass=\"md-headline\">Contract Amount Information</span></md-card-title-text></md-card-title><md-card-content flex \nlayout=\"row\"><div class=\"margin-left-20\" flex layout-xs=\"column\" layout-sm=\"column\"><div layout-gt-sm=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm><md-input-container \nclass=\"md-block padding-bottom-20 margin-bottom-5 padding-top-0\" flex-gt-sm><div class=\"signature\"><label \nfor=\"signature\" translate=\"CONTRACTS.SECTION_INFO.PAYMENT_TERMS\"></label></div><md-icon md-font-icon=\"icon-document\" \nclass=\"name\"></md-icon><md-select name=\"payment_finance_terms\" required ng-model=\"vm.contract.payment_finance_terms\">\n<md-option ng-repeat=\"payment in vm.payment_finance_terms\" value=\"{{payment}}\">{{payment}}</md-option></md-select><div \nclass=\"select-error\" ng-messages=\"vm.informationForm.payment_finance_terms.$error\"><div class=\"error-message\" \nng-message=\"required\">Payment Terms field is required.</div></div></md-input-container></div></div><div \nclass=\"height-20\" flex=\"5\" hide show-xs show-sm></div><div layout-gt-sm=\"row\" \nclass=\"padding-top-20 margin-top-20 padding-bottom-10 margin-bottom-10\"><div flex-gt-sm \nclass=\"padding-left-0 padding-bottom-15 margin-bottom-0\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-0 padding-top-0 margin-top-0\" flex-gt-sm><div class=\"signature\"><label \nfor=\"signature\" translate=\"CONTRACTS.SECTION_INFO.CONTRACT_AMOUNT\"></label></div><md-icon \nmd-font-icon=\"icon-square-inc-cash\"></md-icon><input disabled=\"disabled\" name=\"paymentAmount\" \nng-model=\"vm.contract.total_amount_per_acre\" currency-input=\"money\" type=\"text\"></md-input-container></div></div><div \nclass=\"height-20\" flex=\"5\" hide show-xs show-sm></div><div layout-gt-sm=\"row\" \nclass=\"padding-top-15 margin-top-5 padding-bottom-20 margin-bottom-10\"><div flex-gt-sm \nclass=\"padding-left-0 margin-top-0 padding-top-0\"><md-input-container \nclass=\"md-block margin-bottom-0 padding-top-0 margin-top-0 padding-bottom-0\" flex><div class=\"signature\"><label \nfor=\"signature\" translate=\"CONTRACTS.SECTION_INFO.INCENTIVE_AMOUNT\"></label></div><md-icon \nmd-font-icon=\"icon-square-inc-cash\"></md-icon><input name=\"incentiveAmount\" \nng-model=\"vm.contract.total_incentive_amount_per_acre\" currency-input=\"money\" type=\"text\" disabled=\"disabled\">\n</md-input-container></div></div></div><md-card-actions layout=\"column\"><md-button class=\"md-icon-button\" \naria-label=\"Favorite\"></md-button></md-card-actions></md-card-content></md-card><md-card md-theme-watch><md-card-title>\n<md-card-title-text><span class=\"md-headline\">Notes</span></md-card-title-text></md-card-title><md-card-content flex \nlayout=\"row\"><div class=\"margin-left-20\" flex layout-xs=\"column\" layout-sm=\"column\"><div layout-gt-sm=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0 padding-right-60\"><div flex-gt-sm><md-input-container \nclass=\"md-block padding-bottom-20 margin-bottom-5 padding-top-0\" flex-gt-sm><div class=\"signature\"><label \nfor=\"signature\" translate=\"CONTRACTS.SECTION_INFO.NOTES\"></label></div><md-icon md-font-icon=\"icon-note\"></md-icon>\n<input name=\"description\" ng-model=\"vm.contract.description\" md-maxlength=\"100\" maxlength=\"100\"></md-input-container>\n</div></div></div></md-card-content></md-card></form>");
$templateCache.put("app/main/pages/contracts/tabs/sections/payment-schedule/payment-schedule.html","<ms-payment-schedule data-related-id=\"vm.contract.id\" data-entity=\"vm.entity\" data-service=\"vm.service\">\n</ms-payment-schedule>");
$templateCache.put("app/main/pages/planting-schedule/tabs/sections/add-new/add-new.html","<form id=\"tabs-planting-schedule\"><md-card md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">\nInformation</span></md-card-title-text></md-card-title><md-card-content flex layout=\"row\"><div class=\"margin-left-20\" \nflex layout-xs=\"column\" layout-sm=\"column\"><div layout-gt-sm=\"row\" class=\"padding-bottom-0 margin-bottom-0\"><div \nflex-gt-sm=\"45\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.SHIPPERS\"></label><md-icon md-font-icon=\"icon-city\" class=\"name\"></md-icon><input \nrequired name=\"block_bed_count\" ng-model=\"vm.newPlantingSchedule.shipper\" md-autofocus><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nShipper field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><div \nflex-gt-sm=\"45\" class=\"datepicker-div\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0 datepicker\" flex-gt-sm><label class=\"datepicker-label\" \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_DATE\"></label><md-datepicker md-open-on-focus \nname=\"block_confirmed_date\" ng-model=\"vm.newPlantingSchedule.wet_date\" ng-change=\"vm.setMinDate(\'signature\')\" required>\n</md-datepicker><div ng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" \nng-message=\"required\">Wet Date field is required.</div></div></md-input-container></div></div><div class=\"height-20\" \nflex=\"5\" hide show-xs show-sm></div><div layout-gt-sm=\"row\" class=\"padding-bottom-0 margin-bottom-0\"><div \nflex-gt-sm=\"45\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.BLOCK\"></label><md-icon md-font-icon=\"icon-view-dashboard\" class=\"name\"></md-icon><input \nrequired name=\"block_bed_count\" ng-model=\"vm.newPlantingSchedule.block\" md-autofocus><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nBlock field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><div \nflex-gt-sm=\"45\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.SEED\"></label><md-icon md-font-icon=\"icon-leaf\" class=\"name\"></md-icon><input required \nname=\"block_bed_count\" ng-model=\"vm.newPlantingSchedule.seed\" md-autofocus><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nSeed field is required.</div></div></md-input-container></div></div><div class=\"height-20\" flex=\"5\" hide show-xs \nshow-sm></div><div layout-gt-sm=\"row\" class=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm=\"45\"><md-input-container\n class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.VARIETY\"></label><md-icon md-font-icon=\"icon-leaf\" class=\"name\"></md-icon><input required \nname=\"block_bed_count\" ng-model=\"vm.newPlantingSchedule.variety\" md-autofocus><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nVariety field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><div \nflex-gt-sm=\"45\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.ACRES\"></label><md-icon md-font-icon=\"icon-pine-tree\" class=\"name\"></md-icon><input \nrequired name=\"block_bed_count\" ng-model=\"vm.newPlantingSchedule.acres\" md-autofocus type=\"number\"><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nAcres field is required.</div></div></md-input-container></div></div><div class=\"height-20\" flex=\"5\" hide show-xs \nshow-sm></div><div layout-gt-sm=\"row\" class=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm=\"45\" \nclass=\"datepicker-div\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0 datepicker\" \nflex-gt-sm><label class=\"datepicker-label\" translate=\"PLANTING_SCHEDULE.PLANTING_DATE\"></label><md-datepicker \nmd-open-on-focus name=\"block_confirmed_date\" ng-model=\"vm.newPlantingSchedule.planting_date\" \nng-change=\"vm.setMinDate(\'signature\')\" required></md-datepicker><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nPlanting Date field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><div \nflex-gt-sm=\"45\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_BED_COUNT\"></label><md-icon md-font-icon=\"icon-numeric\" class=\"name\"></md-icon>\n<input required name=\"block_bed_count\" ng-model=\"vm.newPlantingSchedule.bed_count\" md-autofocus type=\"number\"><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nBlock Bed Count number field is required.</div></div></md-input-container></div></div><div class=\"height-20\" flex=\"5\" \nhide show-xs show-sm></div><div layout-gt-sm=\"row\" class=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm=\"45\">\n<md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.BED_STATUS\"></label><md-icon md-font-icon=\"icon-tree\" class=\"name\"></md-icon><input \nrequired name=\"block_bed_count\" ng-model=\"vm.newPlantingSchedule.bed_status\" md-autofocus><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nBed Status field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><div \nflex-gt-sm=\"45\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.PLANTING_STATUS\"></label><md-icon md-font-icon=\"icon-tree\" class=\"name\"></md-icon><input \nrequired name=\"block_bed_count\" ng-model=\"vm.newPlantingSchedule.planting_status\" md-autofocus><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nPlanting Status field is required.</div></div></md-input-container></div></div></div></md-card-content></md-card>\n</form>");
$templateCache.put("app/main/pages/planting-schedule/tabs/sections/block-information/block-information.html","<form id=\"tabs-planting-schedule\"><md-card md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">\nBed Shaped Data</span></md-card-title-text></md-card-title><md-card-content flex layout=\"row\"><div \nclass=\"margin-left-20\" flex layout-xs=\"column\" layout-sm=\"column\"><div layout-gt-sm=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm=\"45\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_BED_COUNT\"></label><md-icon md-font-icon=\"icon-numeric\" class=\"name\"></md-icon>\n<input required name=\"block_bed_count\" ng-model=\"vm.blockInformation.block_bed_count\" md-autofocus type=\"number\"><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nBlock Bed Count number field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div>\n<div flex-gt-sm=\"45\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm>\n<label translate=\"PLANTING_SCHEDULE.TABS.BED_SIZE\"></label><md-icon md-font-icon=\"icon-map\" class=\"name\"></md-icon>\n<md-select name=\"bed_size\" required ng-model=\"vm.blockInformation.bed_size\"><md-option value=\"42\">42</md-option>\n<md-option value=\"Multiple\">Multiple</md-option></md-select><div ng-messages><div class=\"error-message\" \nng-message=\"required\">Bed Size field is required.</div></div></md-input-container></div></div><div class=\"height-20\" \nflex=\"5\" hide show-xs show-sm></div><div layout-gt-sm=\"row\" class=\"padding-bottom-0 margin-bottom-0\"><div \nflex-gt-sm=\"45\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.BED_DIRECTION\"></label><md-icon md-font-icon=\"icon-map\" class=\"name\"></md-icon>\n<md-select name=\"bed_direction\" required ng-model=\"vm.blockInformation.bed_direction\"><md-option value=\"N-S\">N-S\n</md-option><md-option value=\"W-E\">W-E</md-option></md-select><div ng-messages=\"vm.informationForm.company_id.$error\">\n<div class=\"error-message\" ng-message=\"required\">Bed Direction field is required.</div></div></md-input-container>\n</div><div flex=\"5\" hide-xs hide-sm></div><div flex-gt-sm=\"45\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_BY\"></label><md-icon md-font-icon=\"icon-check\" class=\"name\">\n</md-icon><md-select name=\"block_confirmed_by\" required ng-model=\"vm.blockInformation.block_confirmed_by\"><md-option \nvalue=\"John Thompson\">John Thompson</md-option><md-option value=\"name2\">name2</md-option><md-option value=\"name3\">name3\n</md-option></md-select><div ng-messages><div class=\"error-message\" ng-message=\"required\">\nBlock Confirmed By field is required.</div></div></md-input-container></div></div><div class=\"height-20\" flex=\"5\" hide \nshow-xs show-sm></div><div class=\"padding-left-0 padding-top-0 margin-top-0\" layout-gt-sm=\"row\"><div class=\"notes\" \nflex-gt-sm=\"95\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.NOTES\"></label><md-icon md-font-icon=\"icon-numeric\" class=\"name\"></md-icon><input \nng-model=\"vm.blockInformation.bed_notes\" md-autofocus></md-input-container></div></div></div></md-card-content>\n</md-card><md-card md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">\nPlanting Foreman Confirmation</span></md-card-title-text></md-card-title><md-card-content flex layout=\"row\"><div \nclass=\"margin-left-20\" flex layout-xs=\"column\" layout-sm=\"column\"><div layout-gt-sm=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm=\"45\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_BY\"></label><md-icon md-font-icon=\"icon-check\" class=\"name\">\n</md-icon><md-select name=\"planting_block_confirmed_by\" required \nng-model=\"vm.blockInformation.planting_block_confirmed_by\"><md-option value=\"John Thompson\">John Thompson</md-option>\n<md-option value=\"name2\">name2</md-option><md-option value=\"name3\">name3</md-option></md-select><div ng-messages><div \nclass=\"error-message\" ng-message=\"required\">Block Confirmed By field is required.</div></div></md-input-container>\n</div><div flex=\"5\" hide-xs hide-sm></div><div flex-gt-sm=\"45\" class=\"datepicker-div\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0 datepicker\" flex-gt-sm><label class=\"datepicker-label\" \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_DATE\"></label><md-datepicker md-open-on-focus \nname=\"block_confirmed_date\" ng-model=\"vm.blockInformation.planting_block_confirmed_date\" \nng-change=\"vm.setMinDate(\'signature\')\" required></md-datepicker><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nBlock Confirmed Date field is required.</div></div></md-input-container></div></div><div class=\"height-20\" flex=\"5\" \nhide show-xs show-sm></div><div class=\"padding-left-0 padding-top-0 margin-top-0\" layout-gt-sm=\"row\"><div \nclass=\"notes\" flex-gt-sm=\"95\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" \nflex-gt-sm><label translate=\"PLANTING_SCHEDULE.TABS.NOTES\"></label><md-icon md-font-icon=\"icon-numeric\" class=\"name\">\n</md-icon><input ng-model=\"vm.blockInformation.planting_notes\" md-autofocus></md-input-container></div></div></div>\n</md-card-content></md-card><md-card md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">\nFarm Manager Confirmation</span></md-card-title-text></md-card-title><md-card-content flex layout=\"row\"><div \nclass=\"margin-left-20\" flex layout-xs=\"column\" layout-sm=\"column\"><div layout-gt-sm=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm=\"45\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_BY\"></label><md-icon md-font-icon=\"icon-check\" class=\"name\">\n</md-icon><md-select name=\"farm_block_confirmed_by\" required ng-model=\"vm.blockInformation.farm_block_confirmed_by\">\n<md-option value=\"John Thompson\">John Thompson</md-option><md-option value=\"name2\">name2</md-option><md-option \nvalue=\"name3\">name3</md-option></md-select><div ng-messages><div class=\"error-message\" ng-message=\"required\">\nBlock Confirmed By field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><div \nflex-gt-sm=\"45\" class=\"datepicker-div\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0 datepicker\" flex-gt-sm><label class=\"datepicker-label\" \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_DATE\"></label><md-datepicker md-open-on-focus \nname=\"block_confirmed_date\" ng-model=\"vm.blockInformation.farm_block_confirmed_date\" \nng-change=\"vm.setMinDate(\'signature\')\"></md-datepicker><div ng-messages=\"vm.informationForm.company_id.$error\"><div \nclass=\"error-message\" ng-message=\"required\">Block Confirmed Date field is required.</div></div></md-input-container>\n</div></div><div class=\"height-20\" flex=\"5\" hide show-xs show-sm></div><div \nclass=\"padding-left-0 padding-top-0 margin-top-0\" layout-gt-sm=\"row\"><div class=\"notes\" flex-gt-sm=\"95\">\n<md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.NOTES\"></label><md-icon md-font-icon=\"icon-numeric\" class=\"name\"></md-icon><input \nng-model=\"vm.blockInformation.farm_notes\" md-autofocus></md-input-container></div></div></div></md-card-content>\n</md-card></form>");
$templateCache.put("app/main/pages/planting-schedule/tabs/sections/planting-schedule-information/planting-schedule-information.html","<div id=\"tabs-planting-schedule\"><div class=\"main\" fxlayout=\"row\" fxlayoutalign=\"space-between center\"><md-button \nhide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" id=\"add-planting-schedule-information-button\" \nng-click=\"vm.showDialogPlantingScheduleInformation($event)\" aria-label=\"add planting schedule information\" translate \ntranslate-attr-aria-label=\"PLANTING_SCHEDULE.TABS.PLANTING_SCHEDULE_INFORMATION\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button><md-button show-xs show-sm hide-gt-sm id=\"add-planting-schedule-information-button-mobile\" \nclass=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nng-click=\"vm.showDialogPlantingScheduleInformation($event)\" aria-label=\"add planting schedule information\" translate \ntranslate-attr-aria-label=\"PLANTING_SCHEDULE.TABS.PLANTING_SCHEDULE_INFORMATION\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button><md-list><md-card md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">\nPlanting Schedule Confirmation</span></md-card-title-text></md-card-title><md-card-content flex layout=\"row\"><table \nclass=\"dataTable row-border\"><thead><tr><th><div class=\"table-header w-8-p\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE.TABS.LOCATION\"></span></div></th><th><div class=\"table-header w-8-p\"><span \nclass=\"column-title\" translate=\"PLANTING_SCHEDULE.TABS.SHIPPER\"></span></div></th><th><div class=\"table-header w-8-p\">\n<span class=\"column-title\" translate=\"PLANTING_SCHEDULE.TABS.WET_DATE\"></span></div></th><th><div \nclass=\"table-header w-8-p\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.TABS.SEED\"></span></div></th><th>\n<div class=\"table-header w-8-p\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.TABS.VARIETY\"></span></div>\n</th><th><div class=\"table-header w-8-p\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.TABS.ACRES\"></span>\n</div></th><th><div class=\"table-header w-8-p\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.TABS.BED_COUNT\">\n</span></div></th><th><div class=\"table-header w-8-p\"><span class=\"column-title\" \ntranslate=\"PLANTING_SCHEDULE.TABS.BED_SIZE\"></span></div></th><th><div class=\"table-header w-8-p\"><span \nclass=\"column-title\" translate=\"PLANTING_SCHEDULE.TABS.SEED_SPACING\"></span></div></th><th><div \nclass=\"table-header w-8-p\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.TABS.NUMBER_OF_LINES\"></span></div>\n</th><th><div class=\"table-header w-8-p\"><span class=\"column-title\" translate=\"PLANTING_SCHEDULE.TABS.PLANTING_DATE\">\n</span></div></th><th><div class=\"table-header w-8-p\"><span class=\"column-title\"></span></div></th></tr></thead><tbody>\n<tr class=\"payment-row\" ng-repeat=\"plantingInformation in vm.plantingInformation\"><td class=\"w-8-p location\">\n{{ plantingInformation.location }}</td><td class=\"w-8-p\">{{ plantingInformation.shipper }}</td><td class=\"w-8-p\">\n{{ plantingInformation.wet_date }}</td><td class=\"w-8-p\">{{ plantingInformation.seed }}</td><td class=\"w-8-p\">\n{{ plantingInformation.variety }}</td><td class=\"w-8-p\"><md-input-container><input \nclass=\"planting-schedule-information\" aria-label=\"lot\" ng-model=\"plantingInformation.acres\" type=\"text\" \nng-click=\"$event.stopPropagation()\" ng-keydown=\"$event.stopPropagation()\" \nng-change=\"payment.changed = true; vm.broadcast(payment)\"></md-input-container></td><td class=\"w-8-p\">\n<md-input-container><input class=\"planting-schedule-information\" aria-label=\"lot\" \nng-model=\"plantingInformation.bed_count\" type=\"text\" ng-click=\"$event.stopPropagation()\" \nng-keydown=\"$event.stopPropagation()\" ng-change=\"payment.changed = true; vm.broadcast(payment)\"></md-input-container>\n</td><td class=\"w-8-p\"><md-input-container><md-select name=\"bed_size\" ng-model=\"plantingInformation.bed_size\">\n<md-option value=\"bed size 1\">bed size 1</md-option><md-option value=\"bed size 2\">bed size 2</md-option><md-option \nvalue=\"bed size 3\">bed size 3</md-option></md-select></md-input-container></td><td class=\"w-8-p\"><md-input-container>\n<md-select name=\"seed_spacing\" ng-model=\"plantingInformation.seed_spacing\"><md-option value=\"seed spacing 1\">\nseed spacing 1</md-option><md-option value=\"seed spacing 2\">seed spacing 2</md-option><md-option \nvalue=\"seed spacing 3\">seed spacing 3</md-option></md-select></md-input-container></td><td class=\"w-8-p\">\n<md-input-container><md-select name=\"number_of_lines\" ng-model=\"plantingInformation.number_of_lines\"><md-option \nvalue=\"10\">10</md-option><md-option value=\"30\">30</md-option><md-option value=\"50\">50</md-option></md-select>\n</md-input-container></td><td class=\"w-8-p\"><md-input-container class=\"datepicker\"><md-datepicker md-open-on-focus \nname=\"planting_date\" ng-model=\"plantingInformation.planting_date\"></md-datepicker></md-input-container></td><td \nclass=\"w-8-p\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"clear-information\" translate \ntranslate-attr-aria-label=\"PLANTING_SCHEDULE.TABS.CLEAR\" ng-click=\"$mdMenu.open($event); event.stopPropagation()\">\n<md-icon md-font-icon=\"icon-dots-vertical\" id=\"icon-dot\"></md-icon></md-button><md-menu-content width=\"3\">\n<md-menu-item><md-button aria-label=\"clear-information\" translate=\"PLANTING_SCHEDULE.TABS.CLEAR\" \nng-click=\"vm.clearInformation(plantingInformation.id)\"></md-button></md-menu-item></md-menu-content></md-menu></td>\n</tr></tbody></table><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\">\n<ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && vm.payments.length === 0\"><p translate=\"LABOR_GROUP.NO_RESULTS\">No results..</p>\n</md-list-item></md-card-content></md-card></md-list></div></div><form id=\"tabs-planting-schedule\"><md-card \nmd-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">Planting Foreman Confirmation</span>\n</md-card-title-text></md-card-title><md-card-content flex layout=\"row\"><div class=\"margin-left-20\" flex \nlayout-xs=\"column\" layout-sm=\"column\"><div layout-gt-sm=\"row\" class=\"padding-bottom-0 margin-bottom-0\"><div \nflex-gt-sm=\"45\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_BY\"></label><md-icon md-font-icon=\"icon-check\" class=\"name\">\n</md-icon><md-select name=\"planting_block_confirmed_by\" required \nng-model=\"vm.blockInformation.planting_block_confirmed_by\"><md-option value=\"John Thompson\">John Thompson</md-option>\n<md-option value=\"name2\">name2</md-option><md-option value=\"name3\">name3</md-option></md-select><div ng-messages><div \nclass=\"error-message\" ng-message=\"required\">Block Confirmed By field is required.</div></div></md-input-container>\n</div><div flex=\"5\" hide-xs hide-sm></div><div flex-gt-sm=\"45\" class=\"datepicker-div\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0 datepicker\" flex-gt-sm><label class=\"datepicker-label\" \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_DATE\"></label><md-datepicker md-open-on-focus \nname=\"block_confirmed_date\" ng-model=\"vm.blockInformation.planting_block_confirmed_date\" \nng-change=\"vm.setMinDate(\'signature\')\" required></md-datepicker><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nBlock Confirmed Date field is required.</div></div></md-input-container></div></div><div class=\"height-20\" flex=\"5\" \nhide show-xs show-sm></div><div class=\"padding-left-0 padding-top-0 margin-top-0\" layout-gt-sm=\"row\"><div \nclass=\"notes\" flex-gt-sm=\"95\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" \nflex-gt-sm><label translate=\"PLANTING_SCHEDULE.TABS.NOTES\"></label><md-icon md-font-icon=\"icon-numeric\" class=\"name\">\n</md-icon><input ng-model=\"vm.blockInformation.planting_notes\" md-autofocus></md-input-container></div></div></div>\n</md-card-content></md-card><md-card md-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">\nFarm Manager Confirmation</span></md-card-title-text></md-card-title><md-card-content flex layout=\"row\"><div \nclass=\"margin-left-20\" flex layout-xs=\"column\" layout-sm=\"column\"><div layout-gt-sm=\"row\" \nclass=\"padding-bottom-0 margin-bottom-0\"><div flex-gt-sm=\"45\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" flex-gt-sm><label \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_BY\"></label><md-icon md-font-icon=\"icon-check\" class=\"name\">\n</md-icon><md-select name=\"farm_block_confirmed_by\" required ng-model=\"vm.blockInformation.farm_block_confirmed_by\">\n<md-option value=\"John Thompson\">John Thompson</md-option><md-option value=\"name2\">name2</md-option><md-option \nvalue=\"name3\">name3</md-option></md-select><div ng-messages><div class=\"error-message\" ng-message=\"required\">\nBlock Confirmed By field is required.</div></div></md-input-container></div><div flex=\"5\" hide-xs hide-sm></div><div \nflex-gt-sm=\"45\" class=\"datepicker-div\"><md-input-container \nclass=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0 datepicker\" flex-gt-sm><label class=\"datepicker-label\" \ntranslate=\"PLANTING_SCHEDULE.TABS.BLOCK_CONFIRMED_DATE\"></label><md-datepicker md-open-on-focus \nname=\"block_confirmed_date\" ng-model=\"vm.blockInformation.farm_block_confirmed_date\" \nng-change=\"vm.setMinDate(\'signature\')\" required></md-datepicker><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nBlock Confirmed Date field is required.</div></div></md-input-container></div></div><div class=\"height-20\" flex=\"5\" \nhide show-xs show-sm></div><div class=\"padding-left-0 padding-top-0 margin-top-0\" layout-gt-sm=\"row\"><div \nclass=\"notes\" flex-gt-sm=\"95\"><md-input-container class=\"md-block padding-bottom-0 margin-bottom-5 padding-top-0\" \nflex-gt-sm><label translate=\"PLANTING_SCHEDULE.TABS.NOTES\"></label><md-icon md-font-icon=\"icon-numeric\" class=\"name\">\n</md-icon><input ng-model=\"vm.blockInformation.farm_notes\" md-autofocus></md-input-container></div></div></div>\n</md-card-content></md-card></form>");
$templateCache.put("app/main/pages/reports/contract-schedule-report/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">\nContract Schedule Report Filter</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\">\n<md-list-item aria-label=\"filter-all\" ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"GROWER_SCHEDULE_REPORT.ALL_WET_DATES\"></p></md-list-item><md-divider>\n</md-divider><div class=\"custom-padding\"><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.isFarmOwner\"><label>\nShipper</label><md-select ng-model=\"vm.shipper_id\" ng-disabled=\"vm.loadListFiltered\"><md-option \nng-if=\"vm.shippers.length\" ng-repeat=\"shipper in vm.shippers\" ng-value=\"{{shipper.id}}\" \nng-click=\"vm.filterChange(\'shipper\',shipper.id,shipper.name)\">{{shipper.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Season</label><md-select \nng-model=\"vm.season_id\" ng-disabled=\"vm.loadListFiltered\"><md-option ng-repeat=\"season in vm.seasons\" \nng-value=\"{{season.id}}\" \nng-click=\"\n              vm.season.id = season.id;\n              vm.filterChange(\'season\',season.id,season.name);\n              vm.checkFilterLabels({\'id\': 2, \'type\': \'Season\', \'value\': season.name })\">\n{{season.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm \nng-if=\"vm.season_id\"><label>Week Ending</label><md-select ng-model=\"vm.week_ending_id\" \nng-disabled=\"vm.loadListFiltered\"><md-option ng-repeat=\"we in vm.allWeekEnding\" ng-value=\"{{we.id}}\" \nng-click=\"vm.filterChange(\'week_ending\',we.id, we.name)\">{{we.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.locations.length>0\"><label>Location</label><md-select \nng-model=\"vm.location_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.location_id ? vm.filterChange(\'location\',vm.location_id,vm.location_name,true) : \'\'\"><md-option \nng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" \nng-click=\"vm.filterChange(\'location\',location.id,location.name) \">{{location.name}}</md-option></md-select>\n</md-input-container></div></div>");
$templateCache.put("app/main/pages/reports/grower-schedule-report/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">Grower Schedule Report Filter\n</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list-item aria-label=\"filter-all\" \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\" ng-disabled=\"vm.loadListFiltered\"><p \ntranslate=\"GROWER_SCHEDULE_REPORT.ALL_WET_DATES\"></p></md-list-item><md-divider></md-divider><div \nclass=\"custom-padding\"><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.isFarmOwner\"><label>Shipper</label>\n<md-select ng-model=\"vm.shipper_id\" ng-disabled=\"vm.loadListFiltered\"><md-option ng-if=\"vm.shippers.length\" \nng-repeat=\"shipper in vm.shippers\" ng-value=\"{{shipper.id}}\" \nng-click=\"vm.filterChange(\'shipper\',shipper.id,shipper.name)\">{{shipper.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.isFarmOwner\"><label>PCA</label>\n<md-select ng-model=\"vm.pca_id\" ng-disabled=\"vm.loadListFiltered\"><md-option ng-if=\"vm.pcaUsers.length\" \nng-repeat=\"pca in vm.pcaUsers\" ng-value=\"{{pca.id}}\" ng-click=\"vm.filterChange(\'pca\',pca.id,pca.name)\">{{pca.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Season</label>\n<md-select ng-model=\"vm.season_id\" ng-disabled=\"vm.loadListFiltered\"><md-option ng-repeat=\"season in vm.seasons\" \nng-value=\"{{season.id}}\" \nng-click=\"\n    vm.season.id = season.id;\n    vm.filterChange(\'season\',season.id,season.name);\n    vm.checkFilterLabels({\'id\': 2, \'type\': \'Season\', \'value\': season.name })\">\n{{season.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm \nng-if=\"vm.season_id\"><label>Week Ending</label><md-select ng-model=\"vm.week_ending_id\" \nng-disabled=\"vm.loadListFiltered\"><md-option ng-repeat=\"we in vm.allWeekEnding\" ng-value=\"{{we.id}}\" \nng-click=\"vm.filterChange(\'week_ending\',we.id, we.name)\">{{we.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.locations.length>0\"><label>Location name</label><md-select \nng-model=\"vm.location_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.location_id ? vm.filterChange(\'location\',vm.location_id,vm.location_name,true) : \'\'\"><md-option \nng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" \nng-click=\"vm.filterChange(\'location\',location.id,location.name) \">{{location.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.ranches.length>0\"><label>Ranch name\n</label><md-select ng-model=\"vm.ranch_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.filterData.ranch_id ? vm.filterChange(\'ranch\',vm.filterData.ranch_id,vm.filterData.ranch_name,true) : \'\'\">\n<md-option ng-repeat=\"ranch in vm.ranches\" value=\"{{ranch.id}}\" \nng-click=\"vm.filterChange(\'ranch\',ranch.id,ranch.name)\">{{ranch.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.blocks.length>0\"><label>Block name</label><md-select \nng-model=\"vm.block_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.filterData.block_id ? vm.filterChange(\'block\',vm.filterData.block_id,vm.filterData.block_name,true) : \'\'\">\n<md-option ng-repeat=\"block in vm.blocks\" value=\"{{block.id}}\" ng-click=\"vm.filterChange(\'block\',block.id,block.name)\">\n{{block.name}}</md-option></md-select></md-input-container></div></div>");
$templateCache.put("app/main/pages/reports/planting-schedule-report/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\">\nPlanting Schedule Report Filter</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\">\n<md-list-item aria-label=\"filter-all\" ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\" \nng-disabled=\"vm.loadListFiltered\"><p translate=\"GROWER_SCHEDULE_REPORT.ALL_WET_DATES\"></p></md-list-item><md-divider>\n</md-divider><div class=\"custom-padding\"><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.isFarmOwner\"><label>\nShipper</label><md-select ng-model=\"vm.shipper_id\" ng-disabled=\"vm.loadListFiltered\"><md-option \nng-if=\"vm.shippers.length\" ng-repeat=\"shipper in vm.shippers\" ng-value=\"{{shipper.id}}\" \nng-click=\"vm.filterChange(\'shipper\',shipper.id,shipper.name)\">{{shipper.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Season</label><md-select \nng-model=\"vm.season_id\" ng-disabled=\"vm.loadListFiltered\"><md-option ng-repeat=\"season in vm.seasons\" \nng-value=\"{{season.id}}\" \nng-click=\"\n    vm.season.id = season.id;\n    vm.filterChange(\'season\',season.id,season.name);\n    vm.checkFilterLabels({\'id\': 2, \'type\': \'Season\', \'value\': season.name })\">\n{{season.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm \nng-if=\"vm.season_id\"><label>Week Ending</label><md-select ng-model=\"vm.week_ending_id\" \nng-disabled=\"vm.loadListFiltered\"><md-option ng-repeat=\"we in vm.allWeekEnding\" ng-value=\"{{we.id}}\" \nng-click=\"vm.filterChange(\'week_ending\',we.id, we.name)\">{{we.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.locations.length>0\"><label>Location name</label><md-select \nng-model=\"vm.location_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.location_id ? vm.filterChange(\'location\',vm.location_id,vm.location_name,true) : \'\'\"><md-option \nng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" \nng-click=\"vm.filterChange(\'location\',location.id,location.name) \">{{location.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.ranches.length>0\"><label>Ranch name\n</label><md-select ng-model=\"vm.ranch_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.filterData.ranch_id ? vm.filterChange(\'ranch\',vm.filterData.ranch_id,vm.filterData.ranch_name,true) : \'\'\">\n<md-option ng-repeat=\"ranch in vm.ranches\" value=\"{{ranch.id}}\" \nng-click=\"vm.filterChange(\'ranch\',ranch.id,ranch.name)\">{{ranch.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.blocks.length>0\"><label>Block name</label><md-select \nng-model=\"vm.block_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.filterData.block_id ? vm.filterChange(\'block\',vm.filterData.block_id,vm.filterData.block_name,true) : \'\'\">\n<md-option ng-repeat=\"block in vm.blocks\" value=\"{{block.id}}\" ng-click=\"vm.filterChange(\'block\',block.id,block.name)\">\n{{block.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>\nPlanting Foreman</label><md-select ng-model=\"vm.foreman_id\" ng-disabled=\"vm.loadListFiltered\"><md-option \nng-if=\"vm.foremans.length\" ng-repeat=\"foreman in vm.foremans\" ng-value=\"{{foreman.id}}\" \nng-click=\"vm.filterChange(\'foreman\',foreman.id,foreman.name)\">{{foreman.name}}</md-option></md-select>\n</md-input-container></div></div>");
$templateCache.put("app/main/pages/reports/resource-requirements-report/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"font-weight-500 font-size-14\" \ntranslate=\"RESOURCE_REQUIREMENTS_REPORT.RESOURCE_REQUIREMENTS_REPORT_FILTER\"></span></div><md-divider></md-divider><div\n ms-scroll class=\"content scrollable\"><md-list-item aria-label=\"filter-all\" ng-click=\"vm.filterChange(\'all\')\" \nng-class=\"{\'selected\':vm.listType ===\'all\'}\" ng-disabled=\"vm.loadListFiltered\"><p \ntranslate=\"GROWER_SCHEDULE_REPORT.ALL_WET_DATES\"></p></md-list-item><md-divider></md-divider><div \nclass=\"custom-padding\"><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.isFarmOwner\"><label>Shipper</label>\n<md-select ng-model=\"vm.shipper_id\" ng-disabled=\"vm.loadListFiltered\"><md-option ng-if=\"vm.shippers.length\" \nng-repeat=\"shipper in vm.shippers\" ng-value=\"{{shipper.id}}\" \nng-click=\"vm.filterChange(\'shipper\',shipper.id,shipper.name)\">{{shipper.name}}</md-option></md-select>\n</md-input-container><md-input-container class=\"md-block\" flex-gt-sm><label>Season</label><md-select \nng-model=\"vm.season_id\" ng-disabled=\"vm.loadListFiltered\"><md-option ng-repeat=\"season in vm.seasons\" \nng-value=\"{{season.id}}\" \nng-click=\"\n              vm.season.id = season.id;\n              vm.filterChange(\'season\',season.id,season.name);\n              vm.checkFilterLabels({\'id\': 2, \'type\': \'Season\', \'value\': season.name })\">\n{{season.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex-gt-sm \nng-if=\"vm.season_id\"><label>Week Ending</label><md-select ng-model=\"vm.week_ending_id\" \nng-disabled=\"vm.loadListFiltered\"><md-option ng-repeat=\"we in vm.allWeekEnding\" ng-value=\"{{we.id}}\" \nng-click=\"vm.filterChange(\'week_ending\',we.id, we.name)\">{{we.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.locations.length>0\"><label>Location</label><md-select \nng-model=\"vm.location_id\" ng-disabled=\"vm.loadListFiltered\" \nng-init=\"vm.location_id ? vm.filterChange(\'location\',vm.location_id,vm.location_name,true) : \'\'\"><md-option \nng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" \nng-click=\"vm.filterChange(\'location\',location.id,location.name) \">{{location.name}}</md-option></md-select>\n</md-input-container></div></div>");
$templateCache.put("app/main/pages/work-schedule/dialogs/add-edit/views/schedule-form-view.html","<div class=\"row\" layout=\"column\"><form name=\"rowForm\" ng-submit=\"vm.dialogType === \'add\'?vm.addNewRow():vm.saveRow();\">\n<div class=\"form-content\"><div layout=\"row\"><div class=\"input-block\" flex layout=\"row\" \nlayout-align=\"space-between center\"><label>Create from template:</label><md-switch ng-model=\"rowForm.fromTemplate\" \naria-label=\"Create from template\"></md-switch></div></div><div layout=\"row\"><div flex class=\"input-block\" \nng-if=\"rowForm.fromTemplate\"><md-input-container><label>Schedule to copy:</label><md-select name=\"rowId\" \nng-model=\"vm.row.scheduleTemplate\" required><md-option ng-repeat=\"row in vm.scheduleTemplates\" ng-value=\"row\">\n{{row.name}}</md-option></md-select></md-input-container></div></div><div layout=\"row\"><div flex class=\"input-block\">\n<md-input-container flex class=\"row-name\"><label>Schedule Name</label><input name=\"name\" ng-model=\"vm.row.name\" \nrequired md-autofocus></md-input-container></div></div><div layout=\"column\" layout-gt-sm=\"row\" \nlayout-align=\"start start\"><div class=\"input-block\" flex><md-input-container flex><label>Season:</label><md-select \nng-model=\"vm.row.season\" required ng-model-options=\"{trackBy: \'$value.season_id\'}\"><md-option \nng-repeat=\"season in vm.seasons\" ng-value=\"season\">{{season.season_name}}</md-option></md-select></md-input-container>\n</div><div class=\"input-block\" flex><md-input-container flex><label>Seed Type:</label><md-select \nng-model=\"vm.row.seed\" required ng-model-options=\"{trackBy: \'$value.seed_id\'}\"><md-option ng-repeat=\"seed in vm.seed\" \nng-value=\"seed\">{{seed.seed_kind}}</md-option></md-select></md-input-container></div></div></div><md-dialog-actions>\n<md-button ng-if=\"vm.dialogType === \'edit\'\" class=\"md-icon-button\" ng-click=\"vm.removeRow()\" aria-label=\"Remove\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon></md-button><md-button type=\"submit\" class=\"md-accent md-raised\" \nng-disabled=\"rowForm.$invalid || rowForm.$pristine\" aria-label=\"Save\"><span ng-if=\"vm.dialogType === \'add\'\">Add</span> \n<span ng-if=\"vm.dialogType === \'edit\'\">Save</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/pages/work-schedule/dialogs/add-edit/views/task-form-view.html","<div class=\"task\" layout=\"column\"><form name=\"taskForm\" \nng-submit=\"vm.dialogType === \'add\'?vm.addNewTask():vm.saveTask();\"><div class=\"form-content\"><div layout=\"row\" \nng-if=\"vm.dialogType !== \'edit\'\"><div class=\"input-block\" flex layout=\"row\" layout-align=\"space-between center\"><label>\nFrom existing:</label><md-switch ng-model=\"taskForm.fromExisting\" aria-label=\"Task from existing\"></md-switch></div>\n</div><div layout=\"row\"><div flex class=\"input-block\" ng-if=\"!taskForm.fromExisting\"><md-input-container flex \nclass=\"task-name\"><label>Task Name</label><input name=\"name\" ng-model=\"vm.task.name\" required md-autofocus>\n</md-input-container></div><div flex class=\"input-block\" ng-if=\"taskForm.fromExisting\"><md-input-container><label>\nTask Name</label><md-select name=\"task\" ng-model=\"vm.task\" required><md-option ng-repeat=\"task in vm.taskTemplates\" \nng-value=\"task\">{{task.name}}</md-option></md-select></md-input-container></div></div><div layout=\"column\" \nlayout-gt-sm=\"row\" layout-align=\"start start\"><div class=\"input-block\" flex layout=\"row\" \nlayout-align=\"space-between center\"><label>From:</label><input mdc-datetime-picker date=\"true\" short-time=\"true\" \ntime=\"true\" type=\"text\" ng-required placeholder=\"Start Date and Time\" max-date=\"vm.task.to\" ng-model=\"vm.task.from\">\n<div class=\"md-errors-spacer\"></div></div><div class=\"input-block\" flex layout=\"row\" \nlayout-align=\"space-between center\"><label>To:</label><input mdc-datetime-picker date=\"true\" short-time=\"true\" \ntime=\"true\" type=\"text\" ng-required placeholder=\"End Date and Time\" min-date=\"vm.task.from\" ng-model=\"vm.task.to\"><div \nclass=\"md-errors-spacer\"></div></div></div><div ng-if=\"vm.dialogType === \'add\'\" layout=\"row\" \nlayout-align=\"start start\"><div flex class=\"input-block\"><md-input-container><label>Add to Schedule:</label><md-select \nname=\"rowId\" ng-model=\"vm.scheduleRowId\" required><md-option ng-repeat=\"row in vm.chartData\" ng-value=\"row.id\">\n{{row.name}}</md-option></md-select></md-input-container></div></div></div><md-dialog-actions><md-button \nng-if=\"vm.dialogType === \'edit\'\" class=\"md-icon-button\" ng-click=\"vm.removeTask()\" aria-label=\"Remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button><md-button class=\"md-accent md-raised\" type=\"submit\" \nng-disabled=\"taskForm.$invalid\" aria-label=\"Save\"><span ng-if=\"vm.dialogType === \'add\'\">Add</span> <span \nng-if=\"vm.dialogType === \'edit\'\">Save</span></md-button></md-dialog-actions></form></div>");
$templateCache.put("app/main/admin/modules/sidenavs/settings/menus/color/color-menu.html","<div class=\"header md-whiteframe-2dp\"><md-list><md-list-item class=\"selected-color\"><p class=\"title\" flex>\nSelected Color:</p><div ng-if=\"!vm.board.settings.color\" class=\"preview md-background-bg md-hue-1\"></div><div \nng-if=\"vm.board.settings.color\" class=\"preview\" ng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\">\n{{vm.board.settings.color}}</div><md-button class=\"md-icon-button\" ng-click=\"vm.board.settings.color = \'\'\" \naria-label=\"Default Color\"><md-icon md-font-icon=\"icon-close-circle\"></md-icon></md-button></md-list-item></md-list>\n</div><div flex class=\"content\" ms-scroll ms-sidenav-helper><md-list><md-list-item class=\"color\" \nng-repeat=\"(paletteName, palette) in vm.palettes\" ng-click=\"vm.board.settings.color = paletteName\" \nng-class=\"\'md-\'+paletteName+\'-bg\'\" aria-label=\"color select\"><p flex>{{paletteName}}</p><i class=\"icon-check s16\" \nng-if=\"paletteName === vm.board.settings.color\"></i></md-list-item></md-list></div>");
$templateCache.put("app/main/admin/modules/sidenavs/settings/menus/labels/labels-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Label</md-subheader><md-list-item class=\"label\"><div layout=\"row\" \nlayout-align=\"start center\"><md-menu md-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" \nng-class=\"vm.newLabelColor+\'-fg\'\" class=\"label-icon\"></md-icon></md-button><md-menu-content \nclass=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" layout=\"row\" layout-wrap><label \nclass=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"vm.newLabelColor\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><span editable-text=\"vm.newLabelName\" e-form=\"newLabelForm\" \nonaftersave=\"vm.addNewLabel()\"></span><p flex class=\"title new-label-form-button\" ng-click=\"newLabelForm.$show()\" \nng-hide=\"newLabelForm.$visible\">Enter New Label Name</p></div></md-list-item><md-divider></md-divider><md-list-item \nclass=\"label\" ng-repeat=\"label in vm.board.labels\"><div layout=\"row\" layout-align=\"start center\" flex><md-menu \nmd-offset=\"0 52px\"><md-button class=\"md-icon-button label-color-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"label color\"><md-icon md-font-icon=\"icon-label\" ng-class=\"label.color+\'-fg\'\" class=\"label-icon\"></md-icon>\n</md-button><md-menu-content class=\"labels-settings-menu-content\" width=\"3\"><div class=\"new-label-color-pick\" \nlayout=\"row\" layout-wrap><label class=\"color\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\" layout=\"column\" \nlayout-align=\"center center\"><input class=\"ng-hide\" type=\"radio\" ng-model=\"label.color\" ng-value=\"palette\" \naria-label=\"{{palette}}\" ng-click=\"$mdMenu.hide()\"> <i class=\"icon-check s18\" ng-if=\"label.color === palette\"></i>\n</label></div></md-menu-content></md-menu><p flex class=\"title\" editable-text=\"label.name\">{{label.name}}</p><md-button\n ng-click=\"vm.removeLabel($event, label.id);\" class=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></md-list-item></md-list>");
$templateCache.put("app/main/admin/modules/sidenavs/settings/menus/members/members-menu.html","<md-list><md-subheader class=\"md-no-sticky\">Add New Member</md-subheader><md-list-item class=\"add-new-member\"><form \nng-submit=\"vm.newMember()\" layout=\"row\" layout-align=\"start center\"><input flex placeholder=\"Type Member Name\" \ntype=\"text\" ng-model=\"vm.newMemberSearchInput\"><md-button type=\"submit\" class=\"md-accent md-raised\" \naria-label=\"Add New Member\">Add</md-button></form></md-list-item><md-divider></md-divider><md-list-item class=\"member\" \nng-repeat=\"member in vm.board.members\"><img alt=\"{{ member.name }}\" ng-src=\"{{ member.avatar }}\" class=\"md-avatar\"><p \nclass=\"member-name\">{{ member.name }}</p><md-button ng-click=\"vm.removeMember($event, member.id);\" \nclass=\"remove-button md-icon-button\" aria-label=\"remove\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button>\n</md-list-item></md-list>");
$templateCache.put("app/main/admin/modules/views/calendar/sidenavs/scheduled-tasks/scheduled-tasks-sidenav.html","<div class=\"md-title sidenav-title\">Scheduled Cards</div><div class=\"cards\"><div ng-if=\"vm.cards.length <= 0\"><span \ntranslate=\"SB.NO_SCHEDULED_CARD\">There is no scheduled card.</span></div><div class=\"card\" layout=\"row\" \nng-repeat=\"card in vm.cards\"><md-button class=\"md-raised card-date\" ng-click=\"vm.goToDate(card.start)\"><div \nclass=\"day-in-week\">{{card.due | date:\'EEEE\'}}</div><div class=\"day\">{{card.due | date:\'d\' }}</div><div \nclass=\"month-year\">{{card.due | date:\'MMM yyyy\'}}</div></md-button><div class=\"card-title\" flex layout=\"column\" \nlayout-align=\"center start\" ng-click=\"vm.openCardDialog($event, card.idCard)\"><span>{{card.title}}</span></div></div>\n</div>");
$templateCache.put("app/main/admin/modules/views/calendar/dialogs/event/event-dialog.html","<md-dialog class=\"event-calendar-dialog\" aria-label=\"Event Dialog\" ng-cloak><md-toolbar class=\"md-accent\" \nng-class=\"\'md-\'+vm.board.settings.color+\'-bg\'\"><div class=\"md-toolbar-tools\"><h2 class=\"title\">\n{{vm.dueDate | date:\'mediumDate\':\'UTC\'}}</h2><span flex></span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"close dialog\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-tabs md-dynamic-height><md-tab><md-tab-label>\n<span translate=\"SB.ADD_A_PAGE\">Add a page</span></md-tab-label><md-tab-body><div class=\"new-card\" layout=\"column\">\n<form name=\"newCardForm\" novalidate><md-input-container class=\"new-card-name md-block\" md-no-float><input name=\"name\" \nng-model=\"vm.newCard.name\" placeholder=\"Page name\" required><div ng-messages=\"newCardForm.name.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"SB.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><div class=\"lists\"><p>Select a list:</p><md-radio-group ng-model=\"vm.newCard.listId\" required>\n<md-radio-button ng-repeat=\"list in vm.board.lists\" ng-value=\"list.id\">{{list.name}}</md-radio-button></md-radio-group>\n</div><md-dialog-actions><md-button class=\"md-accent md-raised\" ng-click=\"vm.addNewCard()\" \nng-disabled=\"newCardForm.$invalid || newCardForm.$pristine\">Add</md-button></md-dialog-actions></form></div>\n</md-tab-body></md-tab><md-tab><md-tab-label><span translate=\"SB.ASSIGN_THE_DATE_TO_CARDS\">Assign the date to cards\n</span></md-tab-label><md-tab-body><div class=\"assign-due-date\"><md-list class=\"cards\"><md-content \nclass=\"cards-content\" flex ms-scroll><md-list-item class=\"card\" ng-repeat=\"card in vm.board.cards\" \nng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" aria-label=\"card\"><p layout=\"column\" layout-align=\"start start\">\n<span class=\"card-name\">{{card.name}}</span> <span ng-if=\"card.due\" class=\"card-date\">{{card.due | date}}</span></p>\n<md-checkbox ng-checked=\"vm.exists(card.id, vm.selectedCards)\" ng-click=\"vm.toggleInArray(card.id, vm.selectedCards)\" \nclass=\"md-secondary\" aria-label=\"card\"></md-checkbox></md-list-item></md-content></md-list><md-dialog-actions>\n<md-button ng-disabled=\"!vm.selectedCards[0]\" ng-click=\"vm.assignDueDate()\" class=\"md-accent md-raised\">Assign\n</md-button></md-dialog-actions></div></md-tab-body></md-tab></md-tabs></md-dialog-content></md-dialog>");
$templateCache.put("app/main/farm-admin/land/blocks/tabs/sections/bed-sizes/block-bed-sizes.html","<div id=\"block-bed-sizes\" ng-style=\"setSizeMedium(221)\" resize \nclass=\"page-layout simple left-sidenav inner-sidenav padding-bottom-10\"><div \nclass=\"pl-8 main margin-top-0 padding-top-0\" layout=\"row\" layout-align=\"center center\"><md-list class=\"bed-sizes-list\">\n<md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\"><div class=\"list-title\" \nlayout=\"row\" layout-align=\"start center\" ng-hide=\"editGroupForm.$visible\"><span \ntranslate=\"BLOCK_TABS.SECTION_INFO.ALL_BED_SIZES\"></span> <span class=\"secondary-text bed-sizes-count\">\n({{vm.block.block_bed_sizes.length}})</span></div></div></md-subheader><div class=\"content white-bg md-whiteframe-4dp\">\n<form id=\"bedSizesForm\" name=\"vm.bedSizesForm\"><table class=\"dataTable row-border\"><thead><tr><th class=\"w-350\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"BLOCK_TABS.SECTION_INFO.BED_SIZE\"></span></div></th><th \nclass=\"w-350\"><div class=\"table-header\"><span class=\"column-title\" translate=\"BLOCK_TABS.SECTION_INFO.NUMBER_OF_BEDS\">\n</span></div></th><th class=\"w-450\" hide-xs><div class=\"table-header\"><span class=\"column-title\" \ntranslate=\"BLOCK_TABS.SECTION_INFO.NOTES\"></span></div></th><th class=\"w-100\"><div class=\"table-header text-center\">\n<span class=\"column-title\">Actions</span></div></th></tr></thead><tbody class=\"scrollable\" ms-scroll \nng-style=\"setSize(350)\" resize ng-if=\"!loadingData\"><tr class=\"bed-size-row\" \nng-repeat=\"block_bed_size in vm.block.block_bed_sizes\"><td class=\"w-350 text-center\"><md-input-container \nclass=\"no-margin md-block editable-row\"><input required class=\"text-center\" \nng-model=\"block_bed_size.bed_size.bed_size\" name=\"bed_size\" disabled=\"disabled\" aria-label=\"Bed size\" \ncurrency-input=\"integer\" onfocus=\"placeholder=\'Max: 9,999\'\" onblur=\"placeholder=\'\'\" type=\"text\"></md-input-container>\n</td><td class=\"w-350 text-center\"><md-input-container class=\"no-margin md-block editable-row\"><input required \nng-model=\"block_bed_size.bed_count\" class=\"text-center\" name=\"bed_count\" aria-label=\"Number of beds\" \ncurrency-input=\"integerFourNum\" onblur=\"placeholder=\'\'\" type=\"text\"></md-input-container></td><td class=\"w-450\" \nhide-xs><textarea class=\"form-control expandable\" type=\"text\" ng-click=\"$event.stopPropagation()\" \nng-change=\"$event.stopPropagation(); vm.broadcast(payment)\" ng-keydown=\"$event.stopPropagation()\" maxlength=\"250\" \nng-model=\"block_bed_size.description\" rows=\"1\"></textarea></td><td class=\"w-100 text-center\"><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"BLOCKS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button style=\"color: black\" \nng-click=\"vm.deleteBlockBedSizeConfirm(block_bed_size, ev)\" aria-label=\"delete-bed-size\" \ntranslate=\"BLOCK_TABS.SECTION_INFO.DELETE_BED_SIZE\"></md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table></form><md-list-item ng-if=\"loadingData\" class=\"loader\" layout=\"row\" layout-align=\"center center\">\n<ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingData && vm.payments.length === 0\"><p translate=\"CONTRACTS.NO_RESULTS\">No results..</p></md-list-item>\n</div></md-list><md-button show-xs show-sm hide-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nid=\"add-bed-size-button-button-mobile\" ng-click=\"vm.addBlockBedSizeDialog($event)\" aria-label=\"add block\" translate \ntranslate-attr-aria-label=\"BLOCK_TABS.SECTION_INFO.ADD_BED_SIZE\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button><md-button hide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" id=\"add-bed-size-button\" \nng-click=\"vm.addBlockBedSizeDialog($event)\" aria-label=\"add block\" translate \ntranslate-attr-aria-label=\"BLOCK_TABS.SECTION_INFO.ADD_BED_SIZE\"><md-icon md-font-icon=\"icon-plus\"></md-icon>\n</md-button></div></div>");
$templateCache.put("app/main/farm-admin/land/blocks/tabs/sections/documents/documents.html","<div ng-if=\"vm.block.id\"><ms-file-upload file-entity=\"vm.entity\" file-entity-id=\"vm.block.id\"></ms-file-upload></div>");
$templateCache.put("app/main/farm-admin/land/blocks/tabs/sections/information/block-info.html","<form id=\"information-form\" name=\"vm.informationForm\"><md-card md-theme-watch><md-card-content \nclass=\"block-information-title\" layout=\"row\"><div flex-gt-xs=\"100\"><div layout-gt-sm=\"row\"><md-card-title \nclass=\"padding-bottom-0\"><md-card-title-text><span class=\"md-headline\">Block Information</span></md-card-title-text>\n</md-card-title><div flex layout=\"row\" class=\"custom-labels\" layout-align-xs=\"start center\" \nlayout-align-sm=\"start center\" layout-align-gt-sm=\"end center\"><md-card-actions class=\"no-padding\"><md-input-container \nclass=\"md-block\" flex-gt-sm><md-checkbox aria-label=\"Toggle uniform\" ng-checked=\"vm.block.nonuniform_block_size\" \nng-click=\"vm.setNonUniform()\" ng-value=\"vm.block.nonuniform_block_size\"></md-checkbox><span \nclass=\"label-uniform md-label\" translate=\"BLOCKS.NO_UNIFORM\"></span><md-checkbox aria-label=\"Toggle active\" \nng-checked=\"vm.block.active\" ng-click=\"vm.setActive()\" ng-value=\"vm.block.active\"></md-checkbox><span \nclass=\"label-active md-label\" translate=\"BLOCKS.ACTIVE\"></span><md-button class=\"md-icon-button\" \nng-click=\"vm.setStarred()\" aria-label=\"Toggle starred\" translate translate-attr-aria-label=\"BLOCKS.TOGGLE_STARRED\">\n<md-icon ng-if=\"vm.block.starred\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.block.starred\" md-font-icon=\"icon-star-outline\"></md-icon><input ng-value=\"vm.block.starred\" type=\"hidden\">\n</md-button></md-input-container></md-card-actions></div></div></div></md-card-content><md-card-content layout=\"row\" \nclass=\"block-information\"><div flex-gt-xs=\"100\"><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" \nflex-gt-sm><label translate=\"BLOCKS.BLOCK_NAME\"></label><md-icon md-font-icon=\"icon-view-dashboard\"></md-icon><input \ndisabled=\"disabled\" aria-label=\"block code\" ng-model=\"vm.block.name\" required type=\"text\"></md-input-container><div \nflex=\"5\" hide-xs hide-sm></div><md-input-container class=\"md-block\" flex-gt-sm><label translate=\"BLOCKS.BLOCK_CODE\">\n</label><md-icon md-font-icon=\"icon-code-tags\"></md-icon><input aria-label=\"block code\" ng-model=\"vm.block.code\" \nrequired name=\"blockCode\" type=\"text\" ng-change=\"vm.generateBlockName(vm.ranch_name)\" md-maxlength=\"10\" maxlength=\"10\">\n<div ng-messages=\"vm.informationForm.blockCode.$error\"><div class=\"error-message\" ng-message=\"required\">\nBlock Code field is required.</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block\" ng-if=\"!vm.newBlock\" flex-gt-sm><label translate=\"BLOCK_TABS.SECTION_INFO.LOCATION\"></label><md-icon \nmd-font-icon=\"icon-map-marker-radius\" class=\"location\"></md-icon><input ng-readonly=\"true\" disabled=\"disabled\" \nng-model=\"vm.location.name\" name=\"location\" value=\"{{vm.location.name }}\"></md-input-container><md-input-container \nclass=\"md-block\" flex-gt-sm ng-if=\"vm.newBlock\"><label>Location</label><md-icon md-font-icon=\"icon-map-marker-radius\" \nclass=\"location\"></md-icon><md-select ng-required=\"!vm.location_id\" ng-model=\"vm.location_id\" name=\"location\">\n<md-option ng-repeat=\"location in vm.locations\" value=\"{{location.id}}\" ng-click=\"vm.loadRanches(location.id)\">\n{{location.name}}</md-option><md-option ng-if=\"vm.allLocations.length===0\" ng-click=\"vm.goToLand()\">No <b>Locations</b>\n exist<br>Go to Land page</md-option></md-select><div ng-messages=\"vm.informationForm.location.$error\"><div \nclass=\"error-message\" ng-message=\"required\">Location field is required.</div></div></md-input-container><div flex=\"5\" \nhide-xs hide-sm></div><md-input-container class=\"md-block\" ng-if=\"!vm.newBlock\" flex-gt-sm><label \ntranslate=\"BLOCK_TABS.SECTION_INFO.RANCH\"></label><md-icon md-font-icon=\"icon-map-marker-radius\" class=\"ranch\">\n</md-icon><input ng-readonly=\"true\" disabled=\"disabled\" ng-model=\"vm.ranch_name\" name=\"ranch\" \nvalue=\"{{vm.ranch_name}}\"></md-input-container><md-input-container class=\"md-block\" flex-gt-sm ng-if=\"vm.newBlock\">\n<label>Ranch</label><md-icon md-font-icon=\"icon-view-dashboard\" class=\"name\"></md-icon><md-select \nng-required=\"!vm.block.ranch_id\" ng-model=\"vm.block.ranch_id\" name=\"ranch\"><md-option \nng-repeat=\"ranch in vm.ranches track by ranch.id\" value=\"{{ranch.id}}\" ng-click=\"vm.generateBlockName(ranch.name)\">\n{{ranch.name}}</md-option><md-option ng-if=\"!vm.location_id\">First select a Location<br></md-option><md-option \nng-if=\"vm.location_id && vm.ranches.length===0\" ng-click=\"vm.goToRanches()\">No <b>Ranches</b> in Location<br>\nGo to Ranches page</md-option></md-select><div ng-messages=\"vm.informationForm.ranch.$error\"><div \nclass=\"error-message\" ng-message=\"required\">Ranch field is required.</div></div></md-input-container></div><div \nlayout-gt-sm=\"row margin-top-25\"><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"BLOCK_TABS.SECTION_INFO.ACRES\"></label><md-icon md-font-icon=\"icon-pine-tree\"></md-icon><input required \nname=\"acres\" ng-model=\"vm.block.acres\" currency-input=\"acres\" onfocus=\"placeholder=\'Max: 9,999.9\'\" \nonblur=\"placeholder=\'\'\" type=\"text\"><div ng-messages=\"vm.informationForm.acres.$error\"><div class=\"error-message\" \nng-message=\"required\">Acres field is required.</div></div></md-input-container><div flex=\"5\" hide-xs hide-sm></div>\n<md-input-container class=\"md-block\" flex-gt-sm><label translate=\"BLOCKS.LAND_OWNER\"></label><md-icon \nmd-font-icon=\"icon-city\" class=\"name\"></md-icon><md-select required name=\"company_id\" ng-model=\"vm.block.company_id\">\n<md-option ng-if=\"vm.landOwnerCompanies\" ng-repeat=\"landOwner in vm.landOwnerCompanies\" ng-value=\"landOwner.id\">\n{{landOwner.name}}</md-option><md-option ng-if=\"vm.landOwnerCompanies.length===0\" ng-click=\"vm.goToCompanies()\">No <b>\nCompanies</b> exist<br>Go to Companies page</md-option></md-select><div \nng-messages=\"vm.informationForm.company_id.$error\"><div class=\"error-message\" ng-message=\"required\">\nCompany field is required.</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container \nclass=\"md-block mt-20\" ng-if=\"vm.blockBedDirections\" flex-gt-sm><label>Bed Directions</label><md-icon \nmd-font-icon=\"icon-tree\" class=\"name\"></md-icon><md-select required ng-model=\"vm.block.bed_direction_id\" \nname=\"bed_direction\"><md-option ng-repeat=\"direction in vm.blockBedDirections\" value=\"{{direction.id}}\">\n{{direction.bed_direction}}</md-option></md-select><div ng-messages=\"vm.informationForm.bed_direction.$error\"><div \nclass=\"error-message\" ng-message=\"required\">Bed direction field is required.</div></div></md-input-container><div \nflex=\"5\" hide-xs hide-sm></div><div show-xs show-sm hide-gt-sm class=\"height-10\"></div><md-input-container \nclass=\"md-block mt-20\" flex-gt-sm><label translate=\"BLOCKS.SOIL_TYPES\"></label><md-icon md-font-icon=\"icon-tree\" \nclass=\"name\"></md-icon><md-select required name=\"soil_type_id\" ng-model=\"vm.block.soil_type_id\" name=\"soil_type\">\n<md-option ng-if=\"vm.soilTypes\" ng-repeat=\"soilType in vm.soilTypes\" ng-value=\"soilType.id\">{{soilType.soil_type}}\n</md-option><md-option ng-if=\"vm.soilTypes.length===0\">No <b>Soil Types</b> exist</md-option></md-select><div \nng-messages=\"vm.informationForm.soil_type.$error\"><div class=\"error-message\" ng-message=\"required\">\nSoil Type field is required.</div></div></md-input-container></div></div></md-card-content></md-card><md-card \nmd-theme-watch><md-card-title><md-card-title-text><span class=\"md-headline\">Notes</span></md-card-title-text>\n</md-card-title><md-card-content class=\"block-information\" layout=\"row\"><div flex-gt-xs=\"100\"><md-input-container \nclass=\"md-block\" flex-gt-sm><label class=\"custom-label\" translate=\"BLOCK_TABS.SECTION_INFO.NOTES\"></label><md-icon \nmd-font-icon=\"icon-note\"></md-icon><textarea class=\"form-control expandable\" type=\"text\" \nng-click=\"$event.stopPropagation()\" ng-change=\"$event.stopPropagation(); vm.broadcast(payment)\" \nng-keydown=\"$event.stopPropagation()\" md-maxlength=\"250\" maxlength=\"250\" ng-model=\"vm.block.description\" rows=\"1\">\n</textarea></md-input-container></div></md-card-content></md-card><md-card md-theme-watch><md-card-content \nclass=\"block-title margin-bottom-0 margin-left-0 padding-left-0\" layout=\"row\"><div flex-gt-xs=\"100\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-card-title class=\"padding-bottom-0\"><md-card-title-text><span \nclass=\"md-headline\">Geolocation</span></md-card-title-text></md-card-title></div></div></md-card-content>\n<md-card-content layout=\"row\" class=\"block-information\"><div flex-gt-xs=\"100\"><div show-xs show-sm hide-gt-sm \nclass=\"height-65\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><label translate=\"BLOCK_TABS.MAP.LATITUDE\"></label><input \nng-model=\"vm.block.latitude\" type=\"number\" name=\"latitude\" min=\"-85\" max=\"85\"><div \nng-messages=\"vm.informationForm.latitude.$error\" ng-if=\"vm.informationForm.latitude.$dirty\"><div ng-message=\"min\">\nThis field must be greater than -85.</div><div ng-message=\"max\">This field must be less than 85.</div></div>\n</md-input-container><div flex=\"5\" hide-xs hide-sm></div><md-input-container class=\"md-block\" flex-gt-sm><label \ntranslate=\"BLOCK_TABS.MAP.LONGITUDE\"></label><md-icon md-font-icon=\"icon-map-marker\"></md-icon><input \nng-model=\"vm.block.longitude\" type=\"number\" name=\"longitude\" min=\"-180\" max=\"180\"><div \nng-messages=\"vm.informationForm.longitude.$error\" ng-if=\"vm.informationForm.longitude.$dirty\"><div ng-message=\"min\">\nThis field must be greater than -180.</div><div ng-message=\"max\">This field must be less than 180.</div></div>\n</md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-icon-float md-block\" flex-gt-sm>\n<md-icon md-font-icon=\"icon-magnify\"></md-icon><label translate=\"BLOCK_TABS.MAP.ZOOM\"></label><input \nng-model=\"vm.block.zoom\" name=\"zoom\" id=\"zoom\" type=\"number\" min=\"3\" max=\"18\" step=\"1\"><div \nng-messages=\"vm.informationForm.zoom.$error\" ng-if=\"vm.informationForm.zoom.$dirty\"><div ng-message=\"min\">\nThis field must be greater than 3.</div><div ng-message=\"max\">This field must be less than 18.</div></div>\n</md-input-container></div></div></md-card-content></md-card></form><div ng-if=\"!vm.newBlock\"><md-button show-xs \nshow-sm hide-gt-sm class=\"md-fab md-fab-top-right md-accent md-icon-button\" id=\"add-block-button-mobile\" \nng-click=\"vm.addBlock()\" aria-label=\"add block\" translate translate-attr-aria-label=\"BLOCKS.ADD_BLOCK\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button><md-button hide-xs hide-sm show-gt-sm \nclass=\"md-fab md-fab-top-right md-accent md-icon-button\" id=\"add-block-button\" ng-click=\"vm.addBlock()\" \naria-label=\"add block\" translate translate-attr-aria-label=\"BLOCKS.ADD_BLOCK\"><md-icon md-font-icon=\"icon-plus\">\n</md-icon></md-button></div>");
$templateCache.put("app/main/farm-admin/land/blocks/tabs/sections/map/index.html","<div id=\"block-map\"><md-card md-theme-watch><md-card-content><h3><md-icon md-font-icon=\"icon-map-marker-circle\">\n</md-icon><span translate=\"BLOCKS.GEOLOCATION\"></span></h3><p translate=\"BLOCKS.GEOLOCATION_MSG\"></p><p><span \ntranslate=\"BLOCK_TABS.MAP.LATITUDE\"></span>:&nbsp;<b>{{vm.block.latitude | number:6}}</b><br><span \ntranslate=\"BLOCK_TABS.MAP.LONGITUDE\"></span>:&nbsp;<b>{{vm.block.longitude | number:6}}</b></p><ui-gmap-google-map \ncenter=\"vm.simpleMarkerMap.center\" draggable=\"vm.simpleMarkerMap.dragging\" zoom=\"vm.simpleMarkerMap.zoom\" \noptions=\"vm.simpleMarkerMap.options\" events=\"vm.simpleMarkerMap.events\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\" icon=\"vm.simpleMarkerMap.marker.icon\">\n<ui-gmap-window show=\"\'true\'\"><div><div id=\"siteNotice\"></div><h1 id=\"firstHeading\" class=\"firstHeading\">\n{{vm.block.name}}</h1><div id=\"bodyContent\"><p><span translate=\"BLOCKS.SECTION_NAME\"></span>: <b>\n{{vm.block.section_name}}</b><br><span translate=\"BLOCKS.LOCATION\"></span>\n: {{vm.block.location_short_code}} (lat:{{vm.simpleMarkerMap.marker.coords.latitude}},long:{{vm.simpleMarkerMap.marker.coords.longitude}})\n</p></div></div></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></md-card-content></md-card></div>");
$templateCache.put("app/main/farm-admin/land/leases/tabs/sections/block/block.html","<div ng-if=\"vm.lease\"><ms-lease-block data-lease=\"vm.lease\" data-service=\"vm.service\" data-is-lease=\"vm.isLease\">\n</ms-lease-block></div>");
$templateCache.put("app/main/farm-admin/land/leases/tabs/sections/documents/documents.html","<ms-file-upload file-entity=\"vm.entity\" file-entity-id=\"vm.lease.id\"></ms-file-upload>");
$templateCache.put("app/main/farm-admin/land/leases/tabs/sections/information/information.html","<div ng-if=\"vm.lease\"><ms-lease-information data-lease=\"vm.lease\" data-is-lease=\"vm.isLease\" data-service=\"vm.service\">\n</ms-lease-information></div>");
$templateCache.put("app/main/farm-admin/land/leases/tabs/sections/payment-schedule/payment-schedule.html","<div ng-if=\"vm.lease\"><ms-payment-schedule data-related-id=\"vm.lease.id\" data-entity=\"vm.entity\" \ndata-service=\"vm.paymentService\" data-new-lease=\"vm.lease.newLease\"></ms-payment-schedule></div>");
$templateCache.put("app/main/farm-admin/land/ranches/tabs/sections/documents/documents.html","<div ng-if=\"vm.ranch.id\"><ms-file-upload file-entity=\"vm.entity\" file-entity-id=\"vm.ranch.id\"></ms-file-upload></div>");
$templateCache.put("app/main/farm-admin/land/ranches/tabs/sections/map/index.html","<div id=\"ranch-map\"><md-card md-theme-watch><md-card-content><h3><md-icon md-font-icon=\"icon-map-marker-circle\">\n</md-icon><span translate=\"RANCHES.GEOLOCATION\"></span></h3><p translate=\"RANCHES.GEOLOCATION_MSG\"></p><p><span \ntranslate=\"RANCH_TABS.MAP.LATITUDE\"></span>:&nbsp;<b>{{vm.ranch.latitude | number:6}}</b><br><span \ntranslate=\"RANCH_TABS.MAP.LONGITUDE\"></span>:&nbsp;<b>{{vm.ranch.longitude | number:6}}</b></p><ui-gmap-google-map \ncenter=\"vm.simpleMarkerMap.center\" draggable=\"vm.simpleMarkerMap.dragging\" zoom=\"vm.simpleMarkerMap.zoom\" \noptions=\"vm.simpleMarkerMap.options\" events=\"vm.simpleMarkerMap.events\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\" icon=\"vm.simpleMarkerMap.marker.icon\">\n<ui-gmap-window ng-cloak show=\"true\"><div><div id=\"siteNotice\"></div><h1 id=\"firstHeading\" class=\"firstHeading\">\n{{vm.ranch.name }}</h1><div id=\"bodyContent\"><p><span translate=\"RANCHES.SECTION_NAME\"></span>: <b>\n{{vm.ranch.section_name}}</b><br><span translate=\"RANCHES.LOCATION\"></span>\n: {{vm.ranch.location_short_code}} (lat:{{vm.simpleMarkerMap.marker.coords.latitude}},long:{{vm.simpleMarkerMap.marker.coords.longitude}})\n</p></div></div></ui-gmap-window></ui-gmap-marker></ui-gmap-google-map></md-card-content></md-card></div>");
$templateCache.put("app/main/farm-admin/land/ranches/tabs/sections/information/ranch.html","<form id=\"information-form\" name=\"vm.informationForm\"><md-card md-theme-watch><md-card-content \nclass=\"ranch-title margin-bottom-0 margin-left-0 padding-left-0\" layout=\"row\"><div flex-gt-xs=\"100\"><div \nlayout=\"column\" layout-gt-sm=\"row\"><md-card-title class=\"padding-bottom-0\"><md-card-title-text><span \nclass=\"md-headline\">Ranch Information</span></md-card-title-text></md-card-title><div flex layout=\"row\" \nlayout-align-xs=\"start center\" layout-align-sm=\"start center\" layout-align-gt-sm=\"end center\"><md-card-actions \nclass=\"no-padding\"><md-input-container class=\"md-block\" flex-gt-sm><md-checkbox aria-label=\"Toggle active\" \nng-checked=\"vm.ranch.active\" ng-click=\"vm.setActive()\" ng-value=\"vm.ranch.active\"></md-checkbox><span class=\"md-label\" \ntranslate=\"RANCHES.ACTIVE\"></span><md-button class=\"md-icon-button\" ng-click=\"vm.setStarred()\" \naria-label=\"Toggle starred\" translate translate-attr-aria-label=\"RANCHES.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.ranch.starred\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.ranch.starred\" \nmd-font-icon=\"icon-star-outline\"></md-icon><input ng-model=\"vm.ranch.starred\" type=\"hidden\"></md-button>\n</md-input-container></md-card-actions></div></div></div></md-card-content><md-card-content layout=\"row\" \nclass=\"ranch-information\"><div flex-gt-xs=\"100\"><div show-xs show-sm hide-gt-sm class=\"height-65\"></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><md-icon md-font-icon=\"icon-view-dashboard\">\n</md-icon><label translate=\"RANCHES.NAME\"></label><input ng-readonly=\"true\" disabled=\"disabled\" name=\"ranch_name\" \nng-model=\"vm.ranch.name\"></md-input-container><div flex=\"5\" hide-xs hide-sm></div><md-input-container class=\"md-block\" \nflex-gt-sm><md-icon md-font-icon=\"icon-view-dashboard\"></md-icon><label translate=\"RANCHES.SECTION_NAME\"></label><input\n required name=\"section_name\" ng-model=\"vm.ranch.section_name\" ng-change=\"vm.updateName()\" md-maxlength=\"10\" \nmaxlength=\"10\"><div ng-messages=\"vm.informationForm.section_name.$error\"><div class=\"custom-message\" \nng-message=\"required\">Section name is required.</div></div></md-input-container></div><div layout-gt-sm=\"row\">\n<md-input-container ng-if=\"vm.ranch.id\" class=\"md-block\" flex-gt-sm><md-icon md-font-icon=\"icon-map-marker-radius\">\n</md-icon><label translate=\"RANCHES.LOCATION\"></label><input ng-readonly=\"true\" disabled=\"disabled\" \nname=\"location_name\" placeholder=\"{{vm.location_name }}\"></md-input-container><md-input-container ng-if=\"!vm.ranch.id\" \nclass=\"md-block\" flex-gt-sm><md-icon md-font-icon=\"icon-map-marker-radius\"></md-icon><label \ntranslate=\"RANCHES.LOCATION\"></label><md-select name=\"location\" required ng-model=\"vm.ranch.location_id\"><md-option \nng-repeat=\"location in vm.locations\" ng-value=\"{{location.id}}\" \nng-click=\"vm.setShortCode(location.location_short_code); vm.setRanchName(location.location_short_code)\">\n{{location.name }}</md-option></md-select><div ng-messages=\"vm.informationForm.location.$error\"><div \nclass=\"custom-message\" ng-message=\"required\">Location is required.</div></div></md-input-container><div flex=\"5\" \nhide-xs hide-sm></div><md-input-container class=\"md-block\" flex-gt-sm><md-icon md-font-icon=\"icon-document\"></md-icon>\n<label translate=\"RANCHES.LOCATION_CODE\"></label><input ng-readonly=\"true\" disabled=\"disabled\" \nname=\"location_short_code\" ng-model=\"vm.ranch.location_short_code\"></md-input-container></div></div></md-card-content>\n</md-card><md-card md-theme-watch><md-card-content class=\"ranch-title margin-bottom-0 margin-left-0 padding-left-0\" \nlayout=\"row\"><div flex-gt-xs=\"100\"><div layout=\"column\" layout-gt-sm=\"row\"><md-card-title class=\"padding-bottom-0\">\n<md-card-title-text><span class=\"md-headline\">Shipping Address</span></md-card-title-text></md-card-title></div></div>\n</md-card-content><md-card-content layout=\"row\" class=\"ranch-information\"><div flex-gt-xs=\"100\"><div show-xs show-sm \nhide-gt-sm class=\"height-65\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><md-icon \nmd-font-icon=\"icon-home\"></md-icon><label translate=\"RANCHES.ADDRESS\"></label><input required name=\"address1\" \nng-model=\"vm.ranch.address1\"><div ng-messages=\"vm.informationForm.address1.$error\"><div class=\"custom-message\" \nng-message=\"required\">Address is required.</div></div></md-input-container><div flex=\"5\" hide-xs hide-sm></div>\n<md-input-container class=\"md-block\" flex-gt-sm><md-icon md-font-icon=\"icon-city\"></md-icon><label \ntranslate=\"RANCHES.CITY\"></label><input required name=\"city\" ng-model=\"vm.ranch.city\"><div \nng-messages=\"vm.informationForm.city.$error\"><div class=\"custom-message\" ng-message=\"required\">City is required.</div>\n</div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block custom-autocomplete\" \nflex-gt-sm><md-icon class=\"custom-icon\" md-font-icon=\"icon-domain\"></md-icon><md-autocomplete \nstyle=\"margin-bottom: -42px\" class=\"black-text\" required md-input-name=\"state\" md-selected-item=\"vm.ranch.state\" \nmd-no-cache=\"false\" md-search-text-change=\"vm.searchTextChangeState(vm.stateSearchText)\" \nmd-search-text=\"vm.stateSearchText\" md-selected-item-change=\"vm.selectedStateChange(item)\" \nmd-items=\"item in vm.queryState(vm.stateSearchText)\" md-item-text=\"item\" md-min-length=\"0\" md-required-match=\"false\" \nmd-floating-label=\"State\"><md-item-template><span md-highlight-text=\"vm.stateSearchText\" md-highlight-flags=\"^i\">\n{{item}}</span></md-item-template><md-not-found>No results matching \"{{vm.stateSearchText}}\" were found.</md-not-found>\n</md-autocomplete><div ng-messages=\"vm.informationForm.state.$error\" ng-if=\"vm.informationForm.state.$touched\"><div \nclass=\"custom-message\" ng-message=\"required\">State name is required.</div></div></md-input-container><div show-xs \nshow-sm hide-gt-sm class=\"height-45\"></div><div flex=\"5\" hide-xs hide-sm></div><md-input-container class=\"md-block\" \nflex-gt-sm><md-icon md-font-icon=\"icon-document\"></md-icon><label translate=\"RANCHES.ZIPCODE\"></label><input required \nname=\"zipcode\" ng-model=\"vm.ranch.zipcode\"><div ng-messages=\"vm.informationForm.zipcode.$error\"><div \nclass=\"custom-message\" ng-message=\"required\">Zipcode name is required.</div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><md-icon md-font-icon=\"icon-city\"></md-icon><label \ntranslate=\"RANCHES.TOWNSHIP\"></label><input required name=\"township\" ng-model=\"vm.ranch.township\"><div \nng-messages=\"vm.informationForm.township.$error\"><div class=\"custom-message\" ng-message=\"required\">\nTownship is required.</div></div></md-input-container><div flex=\"5\" hide-xs hide-sm></div><md-input-container \nclass=\"md-block\" flex-gt-sm><md-icon md-font-icon=\"icon-code-tags\"></md-icon><label translate=\"RANCHES.RANGE\"></label>\n<input required name=\"range\" ng-model=\"vm.ranch.range\"><div ng-messages=\"vm.informationForm.range.$error\"><div \nclass=\"custom-message\" ng-message=\"required\">Township is required.</div></div></md-input-container></div><div \nlayout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><md-icon md-font-icon=\"icon-water\"></md-icon><label \ntranslate=\"RANCHES.WATER_DISTRICT\"></label><md-select required name=\"water_district_id\" \nng-model=\"vm.ranch.water_district_id\"><md-option ng-if=\"vm.water_districts.length>0\" \nng-repeat=\"wd in vm.water_districts\" ng-value=\"wd.id\">{{wd.name}}</md-option><md-option \nng-if=\"vm.water_districts.length===0\">No <b>Water districts</b> exist<br></md-option></md-select><div \nng-messages=\"vm.informationForm.water_district_id.$error\"><div class=\"custom-message\" ng-message=\"required\">\nWater district is required.</div></div></md-input-container></div></div></md-card-content></md-card><md-card \nmd-theme-watch><md-card-content class=\"ranch-title margin-bottom-0 margin-left-0 padding-left-0\" layout=\"row\"><div \nflex-gt-xs=\"100\"><div layout=\"column\" layout-gt-sm=\"row\"><md-card-title class=\"padding-bottom-0\"><md-card-title-text>\n<span class=\"md-headline\">Geolocation</span></md-card-title-text></md-card-title></div></div></md-card-content>\n<md-card-content layout=\"row\" class=\"ranch-information\"><div flex-gt-xs=\"100\"><div show-xs show-sm hide-gt-sm \nclass=\"height-65\"></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-block\" flex-gt-sm><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><label translate=\"RANCH_TABS.MAP.LATITUDE\"></label><input \nng-model=\"vm.ranch.latitude\" type=\"number\" name=\"latitude\" min=\"-85\" max=\"85\"><div \nng-messages=\"vm.informationForm.latitude.$error\" ng-if=\"vm.informationForm.latitude.$dirty\"><div ng-message=\"min\">\nLatitude must be greater than -85.</div><div class=\"custom-message\" ng-message=\"max\">Latitude must be less than 85.\n</div></div></md-input-container><div flex=\"5\" hide-xs hide-sm></div><md-input-container class=\"md-block\" flex-gt-sm>\n<label translate=\"RANCH_TABS.MAP.LONGITUDE\"></label><md-icon md-font-icon=\"icon-map-marker\"></md-icon><input \nng-model=\"vm.ranch.longitude\" type=\"number\" name=\"longitude\" min=\"-180\" max=\"180\"><div \nng-messages=\"vm.informationForm.longitude.$error\" ng-if=\"vm.informationForm.longitude.$dirty\"><div ng-message=\"min\">\nLongitude must be greater than -180.</div><div class=\"custom-message\" ng-message=\"max\">Longitude must be less than 180.\n</div></div></md-input-container></div><div layout-gt-sm=\"row\"><md-input-container class=\"md-icon-float md-block\" \nflex-gt-sm><md-icon md-font-icon=\"icon-magnify\"></md-icon><label translate=\"RANCH_TABS.MAP.ZOOM\"></label><input \nng-model=\"vm.ranch.zoom\" name=\"zoom\" id=\"zoom\" type=\"number\" min=\"3\" max=\"18\" step=\"1\"><div \nng-messages=\"vm.informationForm.zoom.$error\" ng-if=\"vm.informationForm.zoom.$dirty\"><div class=\"custom-message\" \nng-message=\"min\">Zoom must be greater than 3.</div><div class=\"custom-message\" ng-message=\"max\">\nZoom must be less than 18.</div></div></md-input-container></div></div></md-card-content></md-card></form><div \nng-if=\"vm.ranch.id\"><md-button show-xs show-sm hide-gt-sm class=\"md-fab md-fab-top-right md-accent md-icon-button\" \nid=\"add-ranch-button-mobile\" ng-click=\"vm.addRanch($event)\" aria-label=\"add ranch\" translate \ntranslate-attr-aria-label=\"RANCHS.ADD_RANCH\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button \nhide-xs hide-sm show-gt-sm class=\"md-fab md-fab-top-right md-accent md-icon-button\" id=\"add-ranch-button\" \nng-click=\"vm.addRanch($event)\" aria-label=\"add contract\" translate translate-attr-aria-label=\"RANCHS.ADD_RANCH\">\n<md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/farm-admin/land/subleases/tabs/sections/block/block.html","<div ng-if=\"vm.sublease\"><ms-lease-block data-lease=\"vm.sublease\" data-service=\"vm.service\" data-is-lease=\"vm.isLease\">\n</ms-lease-block></div>");
$templateCache.put("app/main/farm-admin/land/subleases/tabs/sections/documents/documents.html","<ms-file-upload file-entity=\"vm.entity\" file-entity-id=\"vm.sublease.id\"></ms-file-upload>");
$templateCache.put("app/main/farm-admin/land/subleases/tabs/sections/information/information.html","<div ng-if=\"vm.sublease\"><ms-lease-information data-lease=\"vm.sublease\" data-is-lease=\"vm.isLease\" \ndata-service=\"vm.service\"></ms-lease-information></div>");
$templateCache.put("app/main/farm-admin/land/subleases/tabs/sections/payment-schedule/payment-schedule.html","<div ng-if=\"vm.sublease\"><ms-payment-schedule data-related-id=\"vm.sublease.id\" data-entity=\"vm.entity\" \ndata-service=\"vm.paymentService\"></ms-payment-schedule></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-schedule-tasks/task/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\" style=\"height: 40px\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"title font-weight-500 font-size-14\" \ntranslate=\"TASK.TASK_FILTER\"></span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list>\n<md-list-item ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p \ntranslate=\"TASK.ALL_TASK\">All Contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" \nng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p translate=\"TASK.STARRED_TASKS\">Starred Contacts</p></md-list-item>\n<md-divider></md-divider><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header>\n<md-list-item>Foreman</md-list-item></v-pane-header><v-pane-content><md-list><md-list-item ng-if=\"vm.allRolesGroups\" \nng-repeat=\"group in vm.getFilteredRoles()\" ng-click=\"vm.filterChange(group)\" \nng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">{{ group.name }}</p></md-list-item></md-list>\n</v-pane-content></v-pane></v-accordion><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane>\n<v-pane-header md-ink-ripple><md-list-item>Notify Groups</md-list-item></v-pane-header><v-pane-content><md-list>\n<md-list-item ng-if=\"vm.allNotifyGroups\" ng-repeat=\"group in vm.allNotifyGroups\" \nng-click=\"vm.filterChange(group, \'notify_groups\')\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p \nclass=\"pl-8\">{{ group.name }}</p></md-list-item></md-list></v-pane-content></v-pane></v-accordion></md-list></div>");
$templateCache.put("app/main/farm-admin/work-schedule-template/work-schedule-tasks/timeline-placeholders/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\" style=\"height: 40px\"><img \nng-src=\"assets/images/avatars/binocoluars.png\" class=\"md-avatar avatar mr-16\" \nsrc=\"assets/images/avatars/binocoluarss.png\"> <span class=\"title font-weight-500 font-size-14\" \ntranslate=\"TASK.TASK_FILTER\"></span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list>\n<md-list-item ng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p \ntranslate=\"TASK.ALL_TASK\">All Contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" \nng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p translate=\"TASK.STARRED_TASKS\">Starred Contacts</p></md-list-item>\n<md-divider></md-divider><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane><v-pane-header>\n<md-list-item>Foreman</md-list-item></v-pane-header><v-pane-content><md-list><md-list-item ng-if=\"vm.allRolesGroups\" \nng-repeat=\"group in vm.getFilteredRoles()\" ng-click=\"vm.filterChange(group)\" \nng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">{{ group.name }}</p></md-list-item></md-list>\n</v-pane-content></v-pane></v-accordion><v-accordion class=\"vAccordion--default\" multiple=\"multiple\"><v-pane>\n<v-pane-header md-ink-ripple><md-list-item>Notify Groups</md-list-item></v-pane-header><v-pane-content><md-list>\n<md-list-item ng-if=\"vm.allNotifyGroups\" ng-repeat=\"group in vm.allNotifyGroups\" \nng-click=\"vm.filterChange(group, \'notify_groups\')\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p \nclass=\"pl-8\">{{ group.name }}</p></md-list-item></md-list></v-pane-content></v-pane></v-accordion></md-list></div>");
$templateCache.put("app/main/pages/contracts/tabs/sections/crops/form/scheduled_crops.html","<md-list class=\"crops-list\"><div class=\"content white-bg md-whiteframe-4dp\"><div><form name=\"vm.cropsForm\"><table \nclass=\"dataTable row-border hover\"><thead><tr><th class=\"checkbox-header\"></th><th class=\"seed\"><div \nclass=\"table-header\"><span class=\"column-title\" translate=\"CONTRACTS.CROPS.SEED\"></span></div></th><th class=\"acres\">\n<div class=\"table-header text-center\"><span class=\"column-title\" translate=\"CONTRACTS.CROPS.ACRES\"></span></div></th>\n<th class=\"amount\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"CONTRACTS.CROPS.AMOUNT_PER_ACRE\"></span></div></th><th class=\"incentive\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"CONTRACTS.CROPS.INCENTIVE_PER_ACRE\"></span>\n</div></th><th class=\"notes\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACTS.CROPS.NOTES\">\n</span></div></th><th class=\"actions\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"CONTRACTS.ACTIONS\"></span></div></th></tr></thead><tbody class=\"scrollable\" ms-scroll \nng-if=\"!loadingDataCrop\" ng-style=\"setSize(566)\" resize><tr class=\"crop-item md-white-bg\" ng-repeat=\"crop in vm.crops\" \nng-click=\"vm.addCropDialog($event, crop);\"><td class=\"checkbox radio-icon\"><md-radio-group required \nng-model=\"vm.selected_crop_id\"><md-radio-button aria-label=\"true\" ng-value=\"crop.id\" ng-click=\"vm.showVarieties(crop)\">\n</md-radio-button></md-radio-group></td><td class=\"seed\">{{ crop.seed.name }}</td><td class=\"acres text-center\">\n{{ crop.acres || 0 | numberFilter:1 }}</td><td class=\"amount text-center\">{{ crop.amount_per_acre }}</td><td \nclass=\"incentive text-center\">{{ crop.incentive_amount_per_acre }}</td><td class=\"notes\"><textarea \nclass=\"form-control expandable\" type=\"text\" ng-click=\"$event.stopPropagation()\" \nng-change=\"$event.stopPropagation(); vm.broadcast(crop)\" ng-keydown=\"$event.stopPropagation()\" maxlength=\"250\" \nng-model=\"crop.description\" rows=\"1\"></textarea></td><td class=\"text-center actions\"><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdMenu.open($event)\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"CONTRACTS.CROPS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" id=\"icon-dot\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"edit-crop\" \ntranslate=\"CONTRACTS.CROPS.EDIT_CROP\" ng-click=\"vm.addCropDialog($event, crop)\"></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"delete-crop\" translate=\"CONTRACTS.CROPS.DELETE\" \nng-click=\"vm.deleteCrop(ev, crop)\"></md-button></md-menu-item></md-menu-content></md-menu></td></tr></tbody></table>\n</form><md-radio-group ng-if=\"vm.crops.length === 0\" ng-hide=\"true\" required ng-model=\"aux\"><md-radio-button \naria-label=\"true\"></md-radio-button></md-radio-group><md-list-item ng-if=\"loadingDataCrop\" class=\"loader\" layout=\"row\" \nlayout-align=\"center center\"><ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingDataCrop && vm.crops.length === 0\"><p translate=\"CONTRACTS.NO_RESULTS\">No results..</p></md-list-item>\n</div></div></md-list><md-button hide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" \nid=\"add-crop-button\" ng-click=\"vm.addCropDialog($event)\" aria-label=\"add crop\" translate \ntranslate-attr-aria-label=\"CONTRACTS.CROPS.ADD_CROP\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button><md-button\n show-xs show-sm hide-gt-sm id=\"add-crop-button-mobile\" class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nng-click=\"vm.addCropDialog($event)\" aria-label=\"add crop\" translate \ntranslate-attr-aria-label=\"CONTRACTS.CROPS.ADD_CROP\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/pages/contracts/tabs/sections/crops/form/variety_wet_dates.html","<md-list class=\"varieties-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div class=\"row-header\" layout=\"row\">\n<div class=\"list-title\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"vm.variety_title\"><span \nng-if=\"vm.variety_title.seed\">Seed: </span><span ng-if=\"vm.variety_title.seed\" class=\"fw-400\">\n{{vm.variety_title.seed }} </span><span ng-if=\"vm.variety_title.acres\">- Acres: </span><span \nng-if=\"vm.variety_title.acres\" class=\"fw-400\">{{vm.variety_title.acres | numberFilter:1 }}</span></div></div></div>\n</md-subheader><div class=\"content white-bg md-whiteframe-4dp\"><div><table class=\"dataTable row-border hover\"><thead>\n<tr><th class=\"variety\"><div class=\"table-header\"><span class=\"column-title\" translate=\"CONTRACTS.VARIETIES.VARIETY\">\n</span></div></th><th class=\"variety-acres\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"CONTRACTS.VARIETIES.ACRES\"></span></div></th><th class=\"wet-date\"><div class=\"table-header text-center\">\n<span class=\"column-title\" translate=\"CONTRACTS.VARIETIES.SHIPPER_WET_DATE\"></span></div></th><th class=\"growing-days\">\n<div class=\"table-header text-center\"><span class=\"column-title\" translate=\"CONTRACTS.VARIETIES.SHIPPER_GROWING_DAYS\">\n</span></div></th><th class=\"harvest-date\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"CONTRACTS.VARIETIES.SHIPPER_HARVEST_DATE\"></span></div></th><th class=\"view-dates\"><div \nclass=\"table-header text-center\"><span class=\"column-title\" translate=\"CONTRACTS.VARIETIES.GROWER_DATES\"></span></div>\n</th><th class=\"actions-variety\"><div class=\"table-header text-center\"><span class=\"column-title\" \ntranslate=\"CONTRACTS.ACTIONS\"></span></div></th></tr></thead><tbody class=\"scrollable\" ms-scroll \nng-if=\"!loadingDataCrop\" ng-style=\"setSize(630)\" resize><tr class=\"md-white-bg\" \nng-class=\"{true: \'variety-item\', false: \'\'}[!variety.growerScheduleData.length]\" ng-repeat=\"variety in vm.varieties\" \nng-click=\"!variety.growerScheduleData.length ? vm.addVarietyDialog($event, variety) : \'\'\"><td class=\"variety\">\n{{ variety.variety.name }}</td><td class=\"variety-acres text-center\">{{ variety.acres | numberFilter:1 }}</td><td \nclass=\"wet-date text-center\">{{ variety.original_wet_date | date: \'mediumDate\' }}</td><td \nclass=\"growing-days text-center\">{{ variety.original_growing_days }}</td><td class=\"harvest-date text-center\">\n{{ variety.original_harvest_date | date: \'mediumDate\' }}</td><td class=\"view-dates\" align=\"center\" hide-xs \nng-if=\"variety.growerScheduleData.length\"><md-button class=\"md-icon-button\" \nng-click=\"$event.stopPropagation(); vm.viewGrowerDatesDialog($event, variety)\" aria-label=\"View Grower Dates\" \ntranslate translate-attr-aria-label=\"CONTRACTS.VARIETIES.GROWER_DATES\"><md-icon md-font-icon=\"icon-magnify-plus\">\n</md-icon></md-button></td><td class=\"view-dates\" align=\"center\" hide-xs ng-if=\"!variety.growerScheduleData.length\">\nNot scheduled</td><td class=\"actions-variety text-center\"><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"CONTRACTS.MORE\" ng-click=\"$mdMenu.open($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\" id=\"icon-dot\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button aria-label=\"edit-variety-wet-date\" translate=\"CONTRACTS.VARIETIES.EDIT_VARIETY_WET_DATE\" \nng-disabled=\"variety.growerScheduleData.length\" ng-click=\"vm.addVarietyDialog($event, variety)\"></md-button>\n</md-menu-item><md-menu-item><md-button aria-label=\"delete-variety-wet-date\" \ntranslate=\"CONTRACTS.VARIETIES.DELETE_VARIETY_WET_DATE\" ng-disabled=\"variety.growerScheduleData.length\" \nng-click=\"vm.deleteVariety(ev, variety)\"></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"view-grower-dates\" translate=\"CONTRACTS.VARIETIES.GROWER_DATES\" \nng-click=\"vm.viewGrowerDatesDialog(ev, variety.id)\"></md-button></md-menu-item></md-menu-content></md-menu></td></tr>\n</tbody></table><md-list-item ng-if=\"loadingDataCrop\" class=\"loader\" layout=\"row\" layout-align=\"center center\">\n<ms-loader></ms-loader></md-list-item><md-list-item class=\"md-white-bg\" \nng-show=\"!loadingDataCrop && vm.varieties.length === 0\"><p translate=\"CONTRACTS.NO_RESULTS\">No results..</p>\n</md-list-item></div></div></md-list><md-button hide-xs hide-sm show-gt-sm class=\"md-fab md-accent md-icon-button\" \nid=\"add-variety-button\" ng-click=\"vm.addVarietyDialog($event)\" aria-label=\"add variety\" translate \ntranslate-attr-aria-label=\"CONTRACTS.VARIETIES.ADD_VARIETY\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>\n<md-button show-xs show-sm hide-gt-sm class=\"md-fab md-fab-bottom-right md-accent md-icon-button\" \nng-click=\"vm.addVarietyDialog($event)\" aria-label=\"add variety\" translate \ntranslate-attr-aria-label=\"CONTRACTS.VARIETIES.ADD_VARIETY\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button>");}]);